function ow(m) {
  return m && m.__esModule && Object.prototype.hasOwnProperty.call(m, "default") ? m.default : m;
}
var _k, Ok = { exports: {} }, og = {}, Lk, ag = {}, dv = { exports: {} }, cn = {};
function I1() {
  if (Lk) return cn;
  Lk = 1;
  var m = Symbol.for("react.transitional.element"), k = Symbol.for("react.portal"), C = Symbol.for("react.fragment"), b = Symbol.for("react.strict_mode"), A = Symbol.for("react.profiler"), W = Symbol.for("react.consumer"), Z = Symbol.for("react.context"), H = Symbol.for("react.forward_ref"), R = Symbol.for("react.suspense"), L = Symbol.for("react.memo"), U = Symbol.for("react.lazy"), O = Symbol.iterator, Y = { isMounted: function() {
    return !1;
  }, enqueueForceUpdate: function() {
  }, enqueueReplaceState: function() {
  }, enqueueSetState: function() {
  } }, K = Object.assign, ye = {};
  function G(S, N, $) {
    this.props = S, this.context = N, this.refs = ye, this.updater = $ || Y;
  }
  function re() {
  }
  function oe(S, N, $) {
    this.props = S, this.context = N, this.refs = ye, this.updater = $ || Y;
  }
  G.prototype.isReactComponent = {}, G.prototype.setState = function(S, N) {
    if (typeof S != "object" && typeof S != "function" && S != null) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, S, N, "setState");
  }, G.prototype.forceUpdate = function(S) {
    this.updater.enqueueForceUpdate(this, S, "forceUpdate");
  }, re.prototype = G.prototype;
  var ue = oe.prototype = new re();
  ue.constructor = oe, K(ue, G.prototype), ue.isPureReactComponent = !0;
  var pe = Array.isArray, se = { H: null, A: null, T: null, S: null, V: null }, ke = Object.prototype.hasOwnProperty;
  function Se(S, N, $, ae, me, ce) {
    return $ = ce.ref, { $$typeof: m, type: S, key: N, ref: $ !== void 0 ? $ : null, props: ce };
  }
  function Ge(S) {
    return typeof S == "object" && S !== null && S.$$typeof === m;
  }
  var Ee = /\/+/g;
  function Me(S, N) {
    return typeof S == "object" && S !== null && S.key != null ? ($ = "" + S.key, ae = { "=": "=0", ":": "=2" }, "$" + $.replace(/[=:]/g, function(me) {
      return ae[me];
    })) : N.toString(36);
    var $, ae;
  }
  function Ue() {
  }
  function Oe(S, N, $, ae, me) {
    var ce = typeof S;
    ce !== "undefined" && ce !== "boolean" || (S = null);
    var Te, He, Ce = !1;
    if (S === null) Ce = !0;
    else switch (ce) {
      case "bigint":
      case "string":
      case "number":
        Ce = !0;
        break;
      case "object":
        switch (S.$$typeof) {
          case m:
          case k:
            Ce = !0;
            break;
          case U:
            return Oe((Ce = S._init)(S._payload), N, $, ae, me);
        }
    }
    if (Ce) return me = me(S), Ce = ae === "" ? "." + Me(S, 0) : ae, pe(me) ? ($ = "", Ce != null && ($ = Ce.replace(Ee, "$&/") + "/"), Oe(me, N, $, "", function(_e) {
      return _e;
    })) : me != null && (Ge(me) && (Te = me, He = $ + (me.key == null || S && S.key === me.key ? "" : ("" + me.key).replace(Ee, "$&/") + "/") + Ce, me = Se(Te.type, He, void 0, 0, 0, Te.props)), N.push(me)), 1;
    Ce = 0;
    var Ie, Be = ae === "" ? "." : ae + ":";
    if (pe(S)) for (var Qe = 0; Qe < S.length; Qe++) Ce += Oe(ae = S[Qe], N, $, ce = Be + Me(ae, Qe), me);
    else if (typeof (Qe = (Ie = S) === null || typeof Ie != "object" ? null : typeof (Ie = O && Ie[O] || Ie["@@iterator"]) == "function" ? Ie : null) == "function") for (S = Qe.call(S), Qe = 0; !(ae = S.next()).done; ) Ce += Oe(ae = ae.value, N, $, ce = Be + Me(ae, Qe++), me);
    else if (ce === "object") {
      if (typeof S.then == "function") return Oe(function(_e) {
        switch (_e.status) {
          case "fulfilled":
            return _e.value;
          case "rejected":
            throw _e.reason;
          default:
            switch (typeof _e.status == "string" ? _e.then(Ue, Ue) : (_e.status = "pending", _e.then(function(Vn) {
              _e.status === "pending" && (_e.status = "fulfilled", _e.value = Vn);
            }, function(Vn) {
              _e.status === "pending" && (_e.status = "rejected", _e.reason = Vn);
            })), _e.status) {
              case "fulfilled":
                return _e.value;
              case "rejected":
                throw _e.reason;
            }
        }
        throw _e;
      }(S), N, $, ae, me);
      throw N = String(S), Error("Objects are not valid as a React child (found: " + (N === "[object Object]" ? "object with keys {" + Object.keys(S).join(", ") + "}" : N) + "). If you meant to render a collection of children, use an array instead.");
    }
    return Ce;
  }
  function mn(S, N, $) {
    if (S == null) return S;
    var ae = [], me = 0;
    return Oe(S, ae, "", "", function(ce) {
      return N.call($, ce, me++);
    }), ae;
  }
  function yn(S) {
    if (S._status === -1) {
      var N = S._result;
      (N = N()).then(function($) {
        S._status !== 0 && S._status !== -1 || (S._status = 1, S._result = $);
      }, function($) {
        S._status !== 0 && S._status !== -1 || (S._status = 2, S._result = $);
      }), S._status === -1 && (S._status = 0, S._result = N);
    }
    if (S._status === 1) return S._result.default;
    throw S._result;
  }
  var jn = typeof reportError == "function" ? reportError : function(S) {
    if (typeof window == "object" && typeof window.ErrorEvent == "function") {
      var N = new window.ErrorEvent("error", { bubbles: !0, cancelable: !0, message: typeof S == "object" && S !== null && typeof S.message == "string" ? String(S.message) : String(S), error: S });
      if (!window.dispatchEvent(N)) return;
    } else if (typeof process == "object" && typeof process.emit == "function") return void process.emit("uncaughtException", S);
    console.error(S);
  };
  function Ae() {
  }
  return cn.Children = { map: mn, forEach: function(S, N, $) {
    mn(S, function() {
      N.apply(this, arguments);
    }, $);
  }, count: function(S) {
    var N = 0;
    return mn(S, function() {
      N++;
    }), N;
  }, toArray: function(S) {
    return mn(S, function(N) {
      return N;
    }) || [];
  }, only: function(S) {
    if (!Ge(S)) throw Error("React.Children.only expected to receive a single React element child.");
    return S;
  } }, cn.Component = G, cn.Fragment = C, cn.Profiler = A, cn.PureComponent = oe, cn.StrictMode = b, cn.Suspense = R, cn.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = se, cn.__COMPILER_RUNTIME = { __proto__: null, c: function(S) {
    return se.H.useMemoCache(S);
  } }, cn.cache = function(S) {
    return function() {
      return S.apply(null, arguments);
    };
  }, cn.cloneElement = function(S, N, $) {
    if (S == null) throw Error("The argument must be a React element, but you passed " + S + ".");
    var ae = K({}, S.props), me = S.key;
    if (N != null) for (ce in N.ref, N.key !== void 0 && (me = "" + N.key), N) !ke.call(N, ce) || ce === "key" || ce === "__self" || ce === "__source" || ce === "ref" && N.ref === void 0 || (ae[ce] = N[ce]);
    var ce = arguments.length - 2;
    if (ce === 1) ae.children = $;
    else if (1 < ce) {
      for (var Te = Array(ce), He = 0; He < ce; He++) Te[He] = arguments[He + 2];
      ae.children = Te;
    }
    return Se(S.type, me, void 0, 0, 0, ae);
  }, cn.createContext = function(S) {
    return (S = { $$typeof: Z, _currentValue: S, _currentValue2: S, _threadCount: 0, Provider: null, Consumer: null }).Provider = S, S.Consumer = { $$typeof: W, _context: S }, S;
  }, cn.createElement = function(S, N, $) {
    var ae, me = {}, ce = null;
    if (N != null) for (ae in N.key !== void 0 && (ce = "" + N.key), N) ke.call(N, ae) && ae !== "key" && ae !== "__self" && ae !== "__source" && (me[ae] = N[ae]);
    var Te = arguments.length - 2;
    if (Te === 1) me.children = $;
    else if (1 < Te) {
      for (var He = Array(Te), Ce = 0; Ce < Te; Ce++) He[Ce] = arguments[Ce + 2];
      me.children = He;
    }
    if (S && S.defaultProps) for (ae in Te = S.defaultProps) me[ae] === void 0 && (me[ae] = Te[ae]);
    return Se(S, ce, void 0, 0, 0, me);
  }, cn.createRef = function() {
    return { current: null };
  }, cn.forwardRef = function(S) {
    return { $$typeof: H, render: S };
  }, cn.isValidElement = Ge, cn.lazy = function(S) {
    return { $$typeof: U, _payload: { _status: -1, _result: S }, _init: yn };
  }, cn.memo = function(S, N) {
    return { $$typeof: L, type: S, compare: N === void 0 ? null : N };
  }, cn.startTransition = function(S) {
    var N = se.T, $ = {};
    se.T = $;
    try {
      var ae = S(), me = se.S;
      me !== null && me($, ae), typeof ae == "object" && ae !== null && typeof ae.then == "function" && ae.then(Ae, jn);
    } catch (ce) {
      jn(ce);
    } finally {
      se.T = N;
    }
  }, cn.unstable_useCacheRefresh = function() {
    return se.H.useCacheRefresh();
  }, cn.use = function(S) {
    return se.H.use(S);
  }, cn.useActionState = function(S, N, $) {
    return se.H.useActionState(S, N, $);
  }, cn.useCallback = function(S, N) {
    return se.H.useCallback(S, N);
  }, cn.useContext = function(S) {
    return se.H.useContext(S);
  }, cn.useDebugValue = function() {
  }, cn.useDeferredValue = function(S, N) {
    return se.H.useDeferredValue(S, N);
  }, cn.useEffect = function(S, N, $) {
    var ae = se.H;
    if (typeof $ == "function") throw Error("useEffect CRUD overload is not enabled in this build of React.");
    return ae.useEffect(S, N);
  }, cn.useId = function() {
    return se.H.useId();
  }, cn.useImperativeHandle = function(S, N, $) {
    return se.H.useImperativeHandle(S, N, $);
  }, cn.useInsertionEffect = function(S, N) {
    return se.H.useInsertionEffect(S, N);
  }, cn.useLayoutEffect = function(S, N) {
    return se.H.useLayoutEffect(S, N);
  }, cn.useMemo = function(S, N) {
    return se.H.useMemo(S, N);
  }, cn.useOptimistic = function(S, N) {
    return se.H.useOptimistic(S, N);
  }, cn.useReducer = function(S, N, $) {
    return se.H.useReducer(S, N, $);
  }, cn.useRef = function(S) {
    return se.H.useRef(S);
  }, cn.useState = function(S) {
    return se.H.useState(S);
  }, cn.useSyncExternalStore = function(S, N, $) {
    return se.H.useSyncExternalStore(S, N, $);
  }, cn.useTransition = function() {
    return se.H.useTransition();
  }, cn.version = "19.1.0", cn;
}
var zk, Dk, Fk, Ik, fv = { exports: {} };
function M1() {
  return zk || (zk = 1, m = fv, k = fv.exports, /**
  		 * @license React
  		 * react.development.js
  		 *
  		 * Copyright (c) Meta Platforms, Inc. and affiliates.
  		 *
  		 * This source code is licensed under the MIT license found in the
  		 * LICENSE file in the root directory of this source tree.
  		 */
  {}.NODE_ENV !== "production" && function() {
    function C(E, V) {
      Object.defineProperty(A.prototype, E, { get: function() {
        console.warn("%s(...) is deprecated in plain JavaScript React classes. %s", V[0], V[1]);
      } });
    }
    function b(E, V) {
      var be = (E = (E = E.constructor) && (E.displayName || E.name) || "ReactClass") + "." + V;
      Qe[be] || (console.error("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", V, E), Qe[be] = !0);
    }
    function A(E, V, be) {
      this.props = E, this.context = V, this.refs = Fn, this.updater = be || _e;
    }
    function W() {
    }
    function Z(E, V, be) {
      this.props = E, this.context = V, this.refs = Fn, this.updater = be || _e;
    }
    function H(E) {
      return "" + E;
    }
    function R(E) {
      try {
        H(E);
        var V = !1;
      } catch {
        V = !0;
      }
      if (V) {
        var be = (V = console).error, we = typeof Symbol == "function" && Symbol.toStringTag && E[Symbol.toStringTag] || E.constructor.name || "Object";
        return be.call(V, "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.", we), H(E);
      }
    }
    function L(E) {
      if (E == null) return null;
      if (typeof E == "function") return E.$$typeof === oo ? null : E.displayName || E.name || null;
      if (typeof E == "string") return E;
      switch (E) {
        case Ae:
          return "Fragment";
        case N:
          return "Profiler";
        case S:
          return "StrictMode";
        case ce:
          return "Suspense";
        case Te:
          return "SuspenseList";
        case Ie:
          return "Activity";
      }
      if (typeof E == "object") switch (typeof E.tag == "number" && console.error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), E.$$typeof) {
        case jn:
          return "Portal";
        case ae:
          return (E.displayName || "Context") + ".Provider";
        case $:
          return (E._context.displayName || "Context") + ".Consumer";
        case me:
          var V = E.render;
          return (E = E.displayName) || (E = (E = V.displayName || V.name || "") !== "" ? "ForwardRef(" + E + ")" : "ForwardRef"), E;
        case He:
          return (V = E.displayName || null) !== null ? V : L(E.type) || "Memo";
        case Ce:
          V = E._payload, E = E._init;
          try {
            return L(E(V));
          } catch {
          }
      }
      return null;
    }
    function U(E) {
      if (E === Ae) return "<>";
      if (typeof E == "object" && E !== null && E.$$typeof === Ce) return "<...>";
      try {
        var V = L(E);
        return V ? "<" + V + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function O() {
      var E = rn.A;
      return E === null ? null : E.getOwner();
    }
    function Y() {
      return Error("react-stack-top-frame");
    }
    function K(E) {
      if (yl.call(E, "key")) {
        var V = Object.getOwnPropertyDescriptor(E, "key").get;
        if (V && V.isReactWarning) return !1;
      }
      return E.key !== void 0;
    }
    function ye() {
      var E = L(this.type);
      return Bo[E] || (Bo[E] = !0, console.error("Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release.")), (E = this.props.ref) !== void 0 ? E : null;
    }
    function G(E, V, be, we, Le, dn, Wn, wn) {
      return be = dn.ref, E = { $$typeof: yn, type: E, key: V, props: dn, _owner: Le }, (be !== void 0 ? be : null) !== null ? Object.defineProperty(E, "ref", { enumerable: !1, get: ye }) : Object.defineProperty(E, "ref", { enumerable: !1, value: null }), E._store = {}, Object.defineProperty(E._store, "validated", { configurable: !1, enumerable: !1, writable: !0, value: 0 }), Object.defineProperty(E, "_debugInfo", { configurable: !1, enumerable: !1, writable: !0, value: null }), Object.defineProperty(E, "_debugStack", { configurable: !1, enumerable: !1, writable: !0, value: Wn }), Object.defineProperty(E, "_debugTask", { configurable: !1, enumerable: !1, writable: !0, value: wn }), Object.freeze && (Object.freeze(E.props), Object.freeze(E)), E;
    }
    function re(E) {
      return typeof E == "object" && E !== null && E.$$typeof === yn;
    }
    function oe(E, V) {
      return typeof E == "object" && E !== null && E.key != null ? (R(E.key), be = "" + E.key, we = { "=": "=0", ":": "=2" }, "$" + be.replace(/[=:]/g, function(Le) {
        return we[Le];
      })) : V.toString(36);
      var be, we;
    }
    function ue() {
    }
    function pe(E, V, be, we, Le) {
      var dn = typeof E;
      dn !== "undefined" && dn !== "boolean" || (E = null);
      var Wn, wn, Ze, tn = !1;
      if (E === null) tn = !0;
      else switch (dn) {
        case "bigint":
        case "string":
        case "number":
          tn = !0;
          break;
        case "object":
          switch (E.$$typeof) {
            case yn:
            case jn:
              tn = !0;
              break;
            case Ce:
              return pe((tn = E._init)(E._payload), V, be, we, Le);
          }
      }
      if (tn) {
        Le = Le(tn = E);
        var Ct = we === "" ? "." + oe(tn, 0) : we;
        return Uo(Le) ? (be = "", Ct != null && (be = Ct.replace(ks, "$&/") + "/"), pe(Le, V, be, "", function(Hn) {
          return Hn;
        })) : Le != null && (re(Le) && (Le.key != null && (tn && tn.key === Le.key || R(Le.key)), Wn = Le, wn = be + (Le.key == null || tn && tn.key === Le.key ? "" : ("" + Le.key).replace(ks, "$&/") + "/") + Ct, wn = G(Wn.type, wn, void 0, 0, Wn._owner, Wn.props, Wn._debugStack, Wn._debugTask), Wn._store && (wn._store.validated = Wn._store.validated), be = wn, we !== "" && tn != null && re(tn) && tn.key == null && tn._store && !tn._store.validated && (be._store.validated = 2), Le = be), V.push(Le)), 1;
      }
      if (tn = 0, Ct = we === "" ? "." : we + ":", Uo(E)) for (var Ln = 0; Ln < E.length; Ln++) tn += pe(we = E[Ln], V, be, dn = Ct + oe(we, Ln), Le);
      else if (typeof (Ln = (Ze = E) === null || typeof Ze != "object" ? null : typeof (Ze = Be && Ze[Be] || Ze["@@iterator"]) == "function" ? Ze : null) == "function") for (Ln === E.entries && (du || console.warn("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), du = !0), E = Ln.call(E), Ln = 0; !(we = E.next()).done; ) tn += pe(we = we.value, V, be, dn = Ct + oe(we, Ln++), Le);
      else if (dn === "object") {
        if (typeof E.then == "function") return pe(function(Hn) {
          switch (Hn.status) {
            case "fulfilled":
              return Hn.value;
            case "rejected":
              throw Hn.reason;
            default:
              switch (typeof Hn.status == "string" ? Hn.then(ue, ue) : (Hn.status = "pending", Hn.then(function(ri) {
                Hn.status === "pending" && (Hn.status = "fulfilled", Hn.value = ri);
              }, function(ri) {
                Hn.status === "pending" && (Hn.status = "rejected", Hn.reason = ri);
              })), Hn.status) {
                case "fulfilled":
                  return Hn.value;
                case "rejected":
                  throw Hn.reason;
              }
          }
          throw Hn;
        }(E), V, be, we, Le);
        throw V = String(E), Error("Objects are not valid as a React child (found: " + (V === "[object Object]" ? "object with keys {" + Object.keys(E).join(", ") + "}" : V) + "). If you meant to render a collection of children, use an array instead.");
      }
      return tn;
    }
    function se(E, V, be) {
      if (E == null) return E;
      var we = [], Le = 0;
      return pe(E, we, "", "", function(dn) {
        return V.call(be, dn, Le++);
      }), we;
    }
    function ke(E) {
      if (E._status === -1) {
        var V = E._result;
        (V = V()).then(function(be) {
          E._status !== 0 && E._status !== -1 || (E._status = 1, E._result = be);
        }, function(be) {
          E._status !== 0 && E._status !== -1 || (E._status = 2, E._result = be);
        }), E._status === -1 && (E._status = 0, E._result = V);
      }
      if (E._status === 1) return (V = E._result) === void 0 && console.error(`lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))

Did you accidentally put curly braces around the import?`, V), "default" in V || console.error(`lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))`, V), V.default;
      throw E._result;
    }
    function Se() {
      var E = rn.H;
      return E === null && console.error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.`), E;
    }
    function Ge() {
    }
    function Ee(E) {
      if (Er === null) try {
        var V = ("require" + Math.random()).slice(0, 7);
        Er = (m && m[V]).call(m, "timers").setImmediate;
      } catch {
        Er = function(we) {
          _t === !1 && (_t = !0, typeof MessageChannel > "u" && console.error("This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning."));
          var Le = new MessageChannel();
          Le.port1.onmessage = we, Le.port2.postMessage(void 0);
        };
      }
      return Er(E);
    }
    function Me(E) {
      return 1 < E.length && typeof AggregateError == "function" ? new AggregateError(E) : E[0];
    }
    function Ue(E, V) {
      V !== vt - 1 && console.error("You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. "), vt = V;
    }
    function Oe(E, V, be) {
      var we = rn.actQueue;
      if (we !== null) if (we.length !== 0) try {
        return mn(we), void Ee(function() {
          return Oe(E, V, be);
        });
      } catch (Le) {
        rn.thrownErrors.push(Le);
      }
      else rn.actQueue = null;
      0 < rn.thrownErrors.length ? (we = Me(rn.thrownErrors), rn.thrownErrors.length = 0, be(we)) : V(E);
    }
    function mn(E) {
      if (!vo) {
        vo = !0;
        var V = 0;
        try {
          for (; V < E.length; V++) for (var be = E[V]; ; ) {
            rn.didUsePromise = !1;
            var we = be(!1);
            if (we === null) break;
            if (rn.didUsePromise) return E[V] = be, void E.splice(0, V);
            be = we;
          }
          E.length = 0;
        } catch (Le) {
          E.splice(0, V + 1), rn.thrownErrors.push(Le);
        } finally {
          vo = !1;
        }
      }
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var yn = Symbol.for("react.transitional.element"), jn = Symbol.for("react.portal"), Ae = Symbol.for("react.fragment"), S = Symbol.for("react.strict_mode"), N = Symbol.for("react.profiler"), $ = Symbol.for("react.consumer"), ae = Symbol.for("react.context"), me = Symbol.for("react.forward_ref"), ce = Symbol.for("react.suspense"), Te = Symbol.for("react.suspense_list"), He = Symbol.for("react.memo"), Ce = Symbol.for("react.lazy"), Ie = Symbol.for("react.activity"), Be = Symbol.iterator, Qe = {}, _e = { isMounted: function() {
      return !1;
    }, enqueueForceUpdate: function(E) {
      b(E, "forceUpdate");
    }, enqueueReplaceState: function(E) {
      b(E, "replaceState");
    }, enqueueSetState: function(E) {
      b(E, "setState");
    } }, Vn = Object.assign, Fn = {};
    Object.freeze(Fn), A.prototype.isReactComponent = {}, A.prototype.setState = function(E, V) {
      if (typeof E != "object" && typeof E != "function" && E != null) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
      this.updater.enqueueSetState(this, E, V, "setState");
    }, A.prototype.forceUpdate = function(E) {
      this.updater.enqueueForceUpdate(this, E, "forceUpdate");
    };
    var Xt, $t = { isMounted: ["isMounted", "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."], replaceState: ["replaceState", "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."] };
    for (Xt in $t) $t.hasOwnProperty(Xt) && C(Xt, $t[Xt]);
    W.prototype = A.prototype, ($t = Z.prototype = new W()).constructor = Z, Vn($t, A.prototype), $t.isPureReactComponent = !0;
    var fr, Ua, Uo = Array.isArray, oo = Symbol.for("react.client.reference"), rn = { H: null, A: null, T: null, S: null, V: null, actQueue: null, isBatchingLegacy: !1, didScheduleLegacyUpdate: !1, didUsePromise: !1, thrownErrors: [], getCurrentStack: null, recentlyCreatedOwnerStacks: 0 }, yl = Object.prototype.hasOwnProperty, ti = console.createTask ? console.createTask : function() {
      return null;
    }, Bo = {}, pd = ($t = { "react-stack-bottom-frame": function(E) {
      return E();
    } })["react-stack-bottom-frame"].bind($t, Y)(), vs = ti(U(Y)), du = !1, ks = /\/+/g, Ba = typeof reportError == "function" ? reportError : function(E) {
      if (typeof window == "object" && typeof window.ErrorEvent == "function") {
        var V = new window.ErrorEvent("error", { bubbles: !0, cancelable: !0, message: typeof E == "object" && E !== null && typeof E.message == "string" ? String(E.message) : String(E), error: E });
        if (!window.dispatchEvent(V)) return;
      } else if (typeof process == "object" && typeof process.emit == "function") return void process.emit("uncaughtException", E);
      console.error(E);
    }, _t = !1, Er = null, vt = 0, bo = !1, vo = !1, Vo = typeof queueMicrotask == "function" ? function(E) {
      queueMicrotask(function() {
        return queueMicrotask(E);
      });
    } : Ee;
    $t = Object.freeze({ __proto__: null, c: function(E) {
      return Se().useMemoCache(E);
    } }), k.Children = { map: se, forEach: function(E, V, be) {
      se(E, function() {
        V.apply(this, arguments);
      }, be);
    }, count: function(E) {
      var V = 0;
      return se(E, function() {
        V++;
      }), V;
    }, toArray: function(E) {
      return se(E, function(V) {
        return V;
      }) || [];
    }, only: function(E) {
      if (!re(E)) throw Error("React.Children.only expected to receive a single React element child.");
      return E;
    } }, k.Component = A, k.Fragment = Ae, k.Profiler = N, k.PureComponent = Z, k.StrictMode = S, k.Suspense = ce, k.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = rn, k.__COMPILER_RUNTIME = $t, k.act = function(E) {
      var V = rn.actQueue, be = vt;
      vt++;
      var we = rn.actQueue = V !== null ? V : [], Le = !1;
      try {
        var dn = E();
      } catch (Ze) {
        rn.thrownErrors.push(Ze);
      }
      if (0 < rn.thrownErrors.length) throw Ue(0, be), E = Me(rn.thrownErrors), rn.thrownErrors.length = 0, E;
      if (dn !== null && typeof dn == "object" && typeof dn.then == "function") {
        var Wn = dn;
        return Vo(function() {
          Le || bo || (bo = !0, console.error("You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);"));
        }), { then: function(Ze, tn) {
          Le = !0, Wn.then(function(Ct) {
            if (Ue(0, be), be === 0) {
              try {
                mn(we), Ee(function() {
                  return Oe(Ct, Ze, tn);
                });
              } catch (Hn) {
                rn.thrownErrors.push(Hn);
              }
              if (0 < rn.thrownErrors.length) {
                var Ln = Me(rn.thrownErrors);
                rn.thrownErrors.length = 0, tn(Ln);
              }
            } else Ze(Ct);
          }, function(Ct) {
            Ue(0, be), 0 < rn.thrownErrors.length && (Ct = Me(rn.thrownErrors), rn.thrownErrors.length = 0), tn(Ct);
          });
        } };
      }
      var wn = dn;
      if (Ue(0, be), be === 0 && (mn(we), we.length !== 0 && Vo(function() {
        Le || bo || (bo = !0, console.error("A component suspended inside an `act` scope, but the `act` call was not awaited. When testing React components that depend on asynchronous data, you must await the result:\n\nawait act(() => ...)"));
      }), rn.actQueue = null), 0 < rn.thrownErrors.length) throw E = Me(rn.thrownErrors), rn.thrownErrors.length = 0, E;
      return { then: function(Ze, tn) {
        Le = !0, be === 0 ? (rn.actQueue = we, Ee(function() {
          return Oe(wn, Ze, tn);
        })) : Ze(wn);
      } };
    }, k.cache = function(E) {
      return function() {
        return E.apply(null, arguments);
      };
    }, k.captureOwnerStack = function() {
      var E = rn.getCurrentStack;
      return E === null ? null : E();
    }, k.cloneElement = function(E, V, be) {
      if (E == null) throw Error("The argument must be a React element, but you passed " + E + ".");
      var we, Le = Vn({}, E.props), dn = E.key, Wn = E._owner;
      if (V != null) for (wn in (we = !(yl.call(V, "ref") && (we = Object.getOwnPropertyDescriptor(V, "ref").get) && we.isReactWarning) && V.ref !== void 0) && (Wn = O()), K(V) && (R(V.key), dn = "" + V.key), V) !yl.call(V, wn) || wn === "key" || wn === "__self" || wn === "__source" || wn === "ref" && V.ref === void 0 || (Le[wn] = V[wn]);
      var wn = arguments.length - 2;
      if (wn === 1) Le.children = be;
      else if (1 < wn) {
        we = Array(wn);
        for (var Ze = 0; Ze < wn; Ze++) we[Ze] = arguments[Ze + 2];
        Le.children = we;
      }
      for (Le = G(E.type, dn, void 0, 0, Wn, Le, E._debugStack, E._debugTask), dn = 2; dn < arguments.length; dn++) re(Wn = arguments[dn]) && Wn._store && (Wn._store.validated = 1);
      return Le;
    }, k.createContext = function(E) {
      return (E = { $$typeof: ae, _currentValue: E, _currentValue2: E, _threadCount: 0, Provider: null, Consumer: null }).Provider = E, E.Consumer = { $$typeof: $, _context: E }, E._currentRenderer = null, E._currentRenderer2 = null, E;
    }, k.createElement = function(E, V, be) {
      for (var we = 2; we < arguments.length; we++) {
        var Le = arguments[we];
        re(Le) && Le._store && (Le._store.validated = 1);
      }
      if (we = {}, Le = null, V != null) for (Ze in Ua || !("__self" in V) || "key" in V || (Ua = !0, console.warn("Your app (or one of its dependencies) is using an outdated JSX transform. Update to the modern JSX transform for faster performance: https://react.dev/link/new-jsx-transform")), K(V) && (R(V.key), Le = "" + V.key), V) yl.call(V, Ze) && Ze !== "key" && Ze !== "__self" && Ze !== "__source" && (we[Ze] = V[Ze]);
      var dn = arguments.length - 2;
      if (dn === 1) we.children = be;
      else if (1 < dn) {
        for (var Wn = Array(dn), wn = 0; wn < dn; wn++) Wn[wn] = arguments[wn + 2];
        Object.freeze && Object.freeze(Wn), we.children = Wn;
      }
      if (E && E.defaultProps) for (Ze in dn = E.defaultProps) we[Ze] === void 0 && (we[Ze] = dn[Ze]);
      Le && function(tn, Ct) {
        function Ln() {
          fr || (fr = !0, console.error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)", Ct));
        }
        Ln.isReactWarning = !0, Object.defineProperty(tn, "key", { get: Ln, configurable: !0 });
      }(we, typeof E == "function" ? E.displayName || E.name || "Unknown" : E);
      var Ze = 1e4 > rn.recentlyCreatedOwnerStacks++;
      return G(E, Le, void 0, 0, O(), we, Ze ? Error("react-stack-top-frame") : pd, Ze ? ti(U(E)) : vs);
    }, k.createRef = function() {
      var E = { current: null };
      return Object.seal(E), E;
    }, k.forwardRef = function(E) {
      E != null && E.$$typeof === He ? console.error("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).") : typeof E != "function" ? console.error("forwardRef requires a render function but was given %s.", E === null ? "null" : typeof E) : E.length !== 0 && E.length !== 2 && console.error("forwardRef render functions accept exactly two parameters: props and ref. %s", E.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined."), E != null && E.defaultProps != null && console.error("forwardRef render functions do not support defaultProps. Did you accidentally pass a React component?");
      var V, be = { $$typeof: me, render: E };
      return Object.defineProperty(be, "displayName", { enumerable: !1, configurable: !0, get: function() {
        return V;
      }, set: function(we) {
        V = we, E.name || E.displayName || (Object.defineProperty(E, "name", { value: we }), E.displayName = we);
      } }), be;
    }, k.isValidElement = re, k.lazy = function(E) {
      return { $$typeof: Ce, _payload: { _status: -1, _result: E }, _init: ke };
    }, k.memo = function(E, V) {
      var be;
      return E == null && console.error("memo: The first argument must be a component. Instead received: %s", E === null ? "null" : typeof E), V = { $$typeof: He, type: E, compare: V === void 0 ? null : V }, Object.defineProperty(V, "displayName", { enumerable: !1, configurable: !0, get: function() {
        return be;
      }, set: function(we) {
        be = we, E.name || E.displayName || (Object.defineProperty(E, "name", { value: we }), E.displayName = we);
      } }), V;
    }, k.startTransition = function(E) {
      var V = rn.T, be = {};
      rn.T = be, be._updatedFibers = /* @__PURE__ */ new Set();
      try {
        var we = E(), Le = rn.S;
        Le !== null && Le(be, we), typeof we == "object" && we !== null && typeof we.then == "function" && we.then(Ge, Ba);
      } catch (dn) {
        Ba(dn);
      } finally {
        V === null && be._updatedFibers && (E = be._updatedFibers.size, be._updatedFibers.clear(), 10 < E && console.warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table.")), rn.T = V;
      }
    }, k.unstable_useCacheRefresh = function() {
      return Se().useCacheRefresh();
    }, k.use = function(E) {
      return Se().use(E);
    }, k.useActionState = function(E, V, be) {
      return Se().useActionState(E, V, be);
    }, k.useCallback = function(E, V) {
      return Se().useCallback(E, V);
    }, k.useContext = function(E) {
      var V = Se();
      return E.$$typeof === $ && console.error("Calling useContext(Context.Consumer) is not supported and will cause bugs. Did you mean to call useContext(Context) instead?"), V.useContext(E);
    }, k.useDebugValue = function(E, V) {
      return Se().useDebugValue(E, V);
    }, k.useDeferredValue = function(E, V) {
      return Se().useDeferredValue(E, V);
    }, k.useEffect = function(E, V, be) {
      E == null && console.warn("React Hook useEffect requires an effect callback. Did you forget to pass a callback to the hook?");
      var we = Se();
      if (typeof be == "function") throw Error("useEffect CRUD overload is not enabled in this build of React.");
      return we.useEffect(E, V);
    }, k.useId = function() {
      return Se().useId();
    }, k.useImperativeHandle = function(E, V, be) {
      return Se().useImperativeHandle(E, V, be);
    }, k.useInsertionEffect = function(E, V) {
      return E == null && console.warn("React Hook useInsertionEffect requires an effect callback. Did you forget to pass a callback to the hook?"), Se().useInsertionEffect(E, V);
    }, k.useLayoutEffect = function(E, V) {
      return E == null && console.warn("React Hook useLayoutEffect requires an effect callback. Did you forget to pass a callback to the hook?"), Se().useLayoutEffect(E, V);
    }, k.useMemo = function(E, V) {
      return Se().useMemo(E, V);
    }, k.useOptimistic = function(E, V) {
      return Se().useOptimistic(E, V);
    }, k.useReducer = function(E, V, be) {
      return Se().useReducer(E, V, be);
    }, k.useRef = function(E) {
      return Se().useRef(E);
    }, k.useState = function(E) {
      return Se().useState(E);
    }, k.useSyncExternalStore = function(E, V, be) {
      return Se().useSyncExternalStore(E, V, be);
    }, k.useTransition = function() {
      return Se().useTransition();
    }, k.version = "19.1.0", typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), fv.exports;
  var m, k;
}
function Lp() {
  return Dk ? dv.exports : (Dk = 1, dv.exports = {}.NODE_ENV === "production" ? I1() : M1(), dv.exports);
}
function j1() {
  if (Fk) return ag;
  Fk = 1;
  /**
  	 * @license React
  	 * react-jsx-runtime.development.js
  	 *
  	 * Copyright (c) Meta Platforms, Inc. and affiliates.
  	 *
  	 * This source code is licensed under the MIT license found in the
  	 * LICENSE file in the root directory of this source tree.
  	 */
  return {}.NODE_ENV !== "production" && function() {
    function m(S) {
      if (S == null) return null;
      if (typeof S == "function") return S.$$typeof === Ge ? null : S.displayName || S.name || null;
      if (typeof S == "string") return S;
      switch (S) {
        case Y:
          return "Fragment";
        case ye:
          return "Profiler";
        case K:
          return "StrictMode";
        case ue:
          return "Suspense";
        case pe:
          return "SuspenseList";
        case Se:
          return "Activity";
      }
      if (typeof S == "object") switch (typeof S.tag == "number" && console.error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), S.$$typeof) {
        case O:
          return "Portal";
        case re:
          return (S.displayName || "Context") + ".Provider";
        case G:
          return (S._context.displayName || "Context") + ".Consumer";
        case oe:
          var N = S.render;
          return (S = S.displayName) || (S = (S = N.displayName || N.name || "") !== "" ? "ForwardRef(" + S + ")" : "ForwardRef"), S;
        case se:
          return (N = S.displayName || null) !== null ? N : m(S.type) || "Memo";
        case ke:
          N = S._payload, S = S._init;
          try {
            return m(S(N));
          } catch {
          }
      }
      return null;
    }
    function k(S) {
      return "" + S;
    }
    function C(S) {
      try {
        k(S);
        var N = !1;
      } catch {
        N = !0;
      }
      if (N) {
        var $ = (N = console).error, ae = typeof Symbol == "function" && Symbol.toStringTag && S[Symbol.toStringTag] || S.constructor.name || "Object";
        return $.call(N, "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.", ae), k(S);
      }
    }
    function b(S) {
      if (S === Y) return "<>";
      if (typeof S == "object" && S !== null && S.$$typeof === ke) return "<...>";
      try {
        var N = m(S);
        return N ? "<" + N + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function A() {
      return Error("react-stack-top-frame");
    }
    function W() {
      var S = m(this.type);
      return mn[S] || (mn[S] = !0, console.error("Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release.")), (S = this.props.ref) !== void 0 ? S : null;
    }
    function Z(S, N, $, ae, me, ce, Te, He) {
      var Ce, Ie = N.children;
      if (Ie !== void 0) if (ae) if (Ue(Ie)) {
        for (ae = 0; ae < Ie.length; ae++) H(Ie[ae]);
        Object.freeze && Object.freeze(Ie);
      } else console.error("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
      else H(Ie);
      if (Me.call(N, "key")) {
        Ie = m(S);
        var Be = Object.keys(N).filter(function(_e) {
          return _e !== "key";
        });
        ae = 0 < Be.length ? "{key: someKey, " + Be.join(": ..., ") + ": ...}" : "{key: someKey}", Ae[Ie + ae] || (Be = 0 < Be.length ? "{" + Be.join(": ..., ") + ": ...}" : "{}", console.error(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, ae, Ie, Be, Ie), Ae[Ie + ae] = !0);
      }
      if (Ie = null, $ !== void 0 && (C($), Ie = "" + $), function(_e) {
        if (Me.call(_e, "key")) {
          var Vn = Object.getOwnPropertyDescriptor(_e, "key").get;
          if (Vn && Vn.isReactWarning) return !1;
        }
        return _e.key !== void 0;
      }(N) && (C(N.key), Ie = "" + N.key), "key" in N) for (var Qe in $ = {}, N) Qe !== "key" && ($[Qe] = N[Qe]);
      else $ = N;
      return Ie && function(_e, Vn) {
        function Fn() {
          R || (R = !0, console.error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)", Vn));
        }
        Fn.isReactWarning = !0, Object.defineProperty(_e, "key", { get: Fn, configurable: !0 });
      }($, typeof S == "function" ? S.displayName || S.name || "Unknown" : S), function(_e, Vn, Fn, Xt, $t, fr, Ua, Uo) {
        return Fn = fr.ref, _e = { $$typeof: U, type: _e, key: Vn, props: fr, _owner: $t }, (Fn !== void 0 ? Fn : null) !== null ? Object.defineProperty(_e, "ref", { enumerable: !1, get: W }) : Object.defineProperty(_e, "ref", { enumerable: !1, value: null }), _e._store = {}, Object.defineProperty(_e._store, "validated", { configurable: !1, enumerable: !1, writable: !0, value: 0 }), Object.defineProperty(_e, "_debugInfo", { configurable: !1, enumerable: !1, writable: !0, value: null }), Object.defineProperty(_e, "_debugStack", { configurable: !1, enumerable: !1, writable: !0, value: Ua }), Object.defineProperty(_e, "_debugTask", { configurable: !1, enumerable: !1, writable: !0, value: Uo }), Object.freeze && (Object.freeze(_e.props), Object.freeze(_e)), _e;
      }(S, Ie, ce, 0, (Ce = Ee.A) === null ? null : Ce.getOwner(), $, Te, He);
    }
    function H(S) {
      typeof S == "object" && S !== null && S.$$typeof === U && S._store && (S._store.validated = 1);
    }
    var R, L = Lp(), U = Symbol.for("react.transitional.element"), O = Symbol.for("react.portal"), Y = Symbol.for("react.fragment"), K = Symbol.for("react.strict_mode"), ye = Symbol.for("react.profiler"), G = Symbol.for("react.consumer"), re = Symbol.for("react.context"), oe = Symbol.for("react.forward_ref"), ue = Symbol.for("react.suspense"), pe = Symbol.for("react.suspense_list"), se = Symbol.for("react.memo"), ke = Symbol.for("react.lazy"), Se = Symbol.for("react.activity"), Ge = Symbol.for("react.client.reference"), Ee = L.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, Me = Object.prototype.hasOwnProperty, Ue = Array.isArray, Oe = console.createTask ? console.createTask : function() {
      return null;
    }, mn = {}, yn = (L = { "react-stack-bottom-frame": function(S) {
      return S();
    } })["react-stack-bottom-frame"].bind(L, A)(), jn = Oe(b(A)), Ae = {};
    ag.Fragment = Y, ag.jsx = function(S, N, $, ae, me) {
      var ce = 1e4 > Ee.recentlyCreatedOwnerStacks++;
      return Z(S, N, $, !1, 0, me, ce ? Error("react-stack-top-frame") : yn, ce ? Oe(b(S)) : jn);
    }, ag.jsxs = function(S, N, $, ae, me) {
      var ce = 1e4 > Ee.recentlyCreatedOwnerStacks++;
      return Z(S, N, $, !0, 0, me, ce ? Error("react-stack-top-frame") : yn, ce ? Oe(b(S)) : jn);
    };
  }(), ag;
}
var Mk, ze = (Ik || (Ik = 1, Ok.exports = {}.NODE_ENV === "production" ? function() {
  if (_k) return og;
  _k = 1;
  var m = Symbol.for("react.transitional.element"), k = Symbol.for("react.fragment");
  function C(b, A, W) {
    var Z = null;
    if (W !== void 0 && (Z = "" + W), A.key !== void 0 && (Z = "" + A.key), "key" in A) for (var H in W = {}, A) H !== "key" && (W[H] = A[H]);
    else W = A;
    return A = W.ref, { $$typeof: m, type: b, key: Z, ref: A !== void 0 ? A : null, props: W };
  }
  return og.Fragment = k, og.jsx = C, og.jsxs = C, og;
}() : j1()), Ok.exports), Wy = { exports: {} }, lg = {}, pv = { exports: {} }, jk = {}, Hk, Uk, Bk = {};
function aw() {
  if (Uk) return pv.exports;
  Uk = 1;
  var m;
  return pv.exports = {}.NODE_ENV === "production" ? (Mk || (Mk = 1, function(k) {
    function C(N, $) {
      var ae = N.length;
      N.push($);
      e: for (; 0 < ae; ) {
        var me = ae - 1 >>> 1, ce = N[me];
        if (!(0 < W(ce, $))) break e;
        N[me] = $, N[ae] = ce, ae = me;
      }
    }
    function b(N) {
      return N.length === 0 ? null : N[0];
    }
    function A(N) {
      if (N.length === 0) return null;
      var $ = N[0], ae = N.pop();
      if (ae !== $) {
        N[0] = ae;
        e: for (var me = 0, ce = N.length, Te = ce >>> 1; me < Te; ) {
          var He = 2 * (me + 1) - 1, Ce = N[He], Ie = He + 1, Be = N[Ie];
          if (0 > W(Ce, ae)) Ie < ce && 0 > W(Be, Ce) ? (N[me] = Be, N[Ie] = ae, me = Ie) : (N[me] = Ce, N[He] = ae, me = He);
          else {
            if (!(Ie < ce && 0 > W(Be, ae))) break e;
            N[me] = Be, N[Ie] = ae, me = Ie;
          }
        }
      }
      return $;
    }
    function W(N, $) {
      var ae = N.sortIndex - $.sortIndex;
      return ae !== 0 ? ae : N.id - $.id;
    }
    if (k.unstable_now = void 0, typeof performance == "object" && typeof performance.now == "function") {
      var Z = performance;
      k.unstable_now = function() {
        return Z.now();
      };
    } else {
      var H = Date, R = H.now();
      k.unstable_now = function() {
        return H.now() - R;
      };
    }
    var L = [], U = [], O = 1, Y = null, K = 3, ye = !1, G = !1, re = !1, oe = !1, ue = typeof setTimeout == "function" ? setTimeout : null, pe = typeof clearTimeout == "function" ? clearTimeout : null, se = typeof setImmediate < "u" ? setImmediate : null;
    function ke(N) {
      for (var $ = b(U); $ !== null; ) {
        if ($.callback === null) A(U);
        else {
          if (!($.startTime <= N)) break;
          A(U), $.sortIndex = $.expirationTime, C(L, $);
        }
        $ = b(U);
      }
    }
    function Se(N) {
      if (re = !1, ke(N), !G) if (b(L) !== null) G = !0, Ee || (Ee = !0, Ge());
      else {
        var $ = b(U);
        $ !== null && S(Se, $.startTime - N);
      }
    }
    var Ge, Ee = !1, Me = -1, Ue = 5, Oe = -1;
    function mn() {
      return !(!oe && k.unstable_now() - Oe < Ue);
    }
    function yn() {
      if (oe = !1, Ee) {
        var N = k.unstable_now();
        Oe = N;
        var $ = !0;
        try {
          e: {
            G = !1, re && (re = !1, pe(Me), Me = -1), ye = !0;
            var ae = K;
            try {
              n: {
                for (ke(N), Y = b(L); Y !== null && !(Y.expirationTime > N && mn()); ) {
                  var me = Y.callback;
                  if (typeof me == "function") {
                    Y.callback = null, K = Y.priorityLevel;
                    var ce = me(Y.expirationTime <= N);
                    if (N = k.unstable_now(), typeof ce == "function") {
                      Y.callback = ce, ke(N), $ = !0;
                      break n;
                    }
                    Y === b(L) && A(L), ke(N);
                  } else A(L);
                  Y = b(L);
                }
                if (Y !== null) $ = !0;
                else {
                  var Te = b(U);
                  Te !== null && S(Se, Te.startTime - N), $ = !1;
                }
              }
              break e;
            } finally {
              Y = null, K = ae, ye = !1;
            }
            $ = void 0;
          }
        } finally {
          $ ? Ge() : Ee = !1;
        }
      }
    }
    if (typeof se == "function") Ge = function() {
      se(yn);
    };
    else if (typeof MessageChannel < "u") {
      var jn = new MessageChannel(), Ae = jn.port2;
      jn.port1.onmessage = yn, Ge = function() {
        Ae.postMessage(null);
      };
    } else Ge = function() {
      ue(yn, 0);
    };
    function S(N, $) {
      Me = ue(function() {
        N(k.unstable_now());
      }, $);
    }
    k.unstable_IdlePriority = 5, k.unstable_ImmediatePriority = 1, k.unstable_LowPriority = 4, k.unstable_NormalPriority = 3, k.unstable_Profiling = null, k.unstable_UserBlockingPriority = 2, k.unstable_cancelCallback = function(N) {
      N.callback = null;
    }, k.unstable_forceFrameRate = function(N) {
      0 > N || 125 < N ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : Ue = 0 < N ? Math.floor(1e3 / N) : 5;
    }, k.unstable_getCurrentPriorityLevel = function() {
      return K;
    }, k.unstable_next = function(N) {
      switch (K) {
        case 1:
        case 2:
        case 3:
          var $ = 3;
          break;
        default:
          $ = K;
      }
      var ae = K;
      K = $;
      try {
        return N();
      } finally {
        K = ae;
      }
    }, k.unstable_requestPaint = function() {
      oe = !0;
    }, k.unstable_runWithPriority = function(N, $) {
      switch (N) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          N = 3;
      }
      var ae = K;
      K = N;
      try {
        return $();
      } finally {
        K = ae;
      }
    }, k.unstable_scheduleCallback = function(N, $, ae) {
      var me = k.unstable_now();
      switch (ae = typeof ae == "object" && ae !== null && typeof (ae = ae.delay) == "number" && 0 < ae ? me + ae : me, N) {
        case 1:
          var ce = -1;
          break;
        case 2:
          ce = 250;
          break;
        case 5:
          ce = 1073741823;
          break;
        case 4:
          ce = 1e4;
          break;
        default:
          ce = 5e3;
      }
      return N = { id: O++, callback: $, priorityLevel: N, startTime: ae, expirationTime: ce = ae + ce, sortIndex: -1 }, ae > me ? (N.sortIndex = ae, C(U, N), b(L) === null && N === b(U) && (re ? (pe(Me), Me = -1) : re = !0, S(Se, ae - me))) : (N.sortIndex = ce, C(L, N), G || ye || (G = !0, Ee || (Ee = !0, Ge()))), N;
    }, k.unstable_shouldYield = mn, k.unstable_wrapCallback = function(N) {
      var $ = K;
      return function() {
        var ae = K;
        K = $;
        try {
          return N.apply(this, arguments);
        } finally {
          K = ae;
        }
      };
    };
  }(jk)), jk) : (Hk || (Hk = 1, m = Bk, /**
  		 * @license React
  		 * scheduler.development.js
  		 *
  		 * Copyright (c) Meta Platforms, Inc. and affiliates.
  		 *
  		 * This source code is licensed under the MIT license found in the
  		 * LICENSE file in the root directory of this source tree.
  		 */
  {}.NODE_ENV !== "production" && function() {
    function k() {
      if (ke = !1, Me) {
        var S = m.unstable_now();
        mn = S;
        var N = !0;
        try {
          e: {
            pe = !1, se && (se = !1, Ge(Ue), Ue = -1), ue = !0;
            var $ = oe;
            try {
              n: {
                for (Z(S), re = b(K); re !== null && !(re.expirationTime > S && R()); ) {
                  var ae = re.callback;
                  if (typeof ae == "function") {
                    re.callback = null, oe = re.priorityLevel;
                    var me = ae(re.expirationTime <= S);
                    if (S = m.unstable_now(), typeof me == "function") {
                      re.callback = me, Z(S), N = !0;
                      break n;
                    }
                    re === b(K) && A(K), Z(S);
                  } else A(K);
                  re = b(K);
                }
                if (re !== null) N = !0;
                else {
                  var ce = b(ye);
                  ce !== null && L(H, ce.startTime - S), N = !1;
                }
              }
              break e;
            } finally {
              re = null, oe = $, ue = !1;
            }
            N = void 0;
          }
        } finally {
          N ? yn() : Me = !1;
        }
      }
    }
    function C(S, N) {
      var $ = S.length;
      S.push(N);
      e: for (; 0 < $; ) {
        var ae = $ - 1 >>> 1, me = S[ae];
        if (!(0 < W(me, N))) break e;
        S[ae] = N, S[$] = me, $ = ae;
      }
    }
    function b(S) {
      return S.length === 0 ? null : S[0];
    }
    function A(S) {
      if (S.length === 0) return null;
      var N = S[0], $ = S.pop();
      if ($ !== N) {
        S[0] = $;
        e: for (var ae = 0, me = S.length, ce = me >>> 1; ae < ce; ) {
          var Te = 2 * (ae + 1) - 1, He = S[Te], Ce = Te + 1, Ie = S[Ce];
          if (0 > W(He, $)) Ce < me && 0 > W(Ie, He) ? (S[ae] = Ie, S[Ce] = $, ae = Ce) : (S[ae] = He, S[Te] = $, ae = Te);
          else {
            if (!(Ce < me && 0 > W(Ie, $))) break e;
            S[ae] = Ie, S[Ce] = $, ae = Ce;
          }
        }
      }
      return N;
    }
    function W(S, N) {
      var $ = S.sortIndex - N.sortIndex;
      return $ !== 0 ? $ : S.id - N.id;
    }
    function Z(S) {
      for (var N = b(ye); N !== null; ) {
        if (N.callback === null) A(ye);
        else {
          if (!(N.startTime <= S)) break;
          A(ye), N.sortIndex = N.expirationTime, C(K, N);
        }
        N = b(ye);
      }
    }
    function H(S) {
      if (se = !1, Z(S), !pe) if (b(K) !== null) pe = !0, Me || (Me = !0, yn());
      else {
        var N = b(ye);
        N !== null && L(H, N.startTime - S);
      }
    }
    function R() {
      return !(!ke && m.unstable_now() - mn < Oe);
    }
    function L(S, N) {
      Ue = Se(function() {
        S(m.unstable_now());
      }, N);
    }
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error()), m.unstable_now = void 0, typeof performance == "object" && typeof performance.now == "function") {
      var U = performance;
      m.unstable_now = function() {
        return U.now();
      };
    } else {
      var O = Date, Y = O.now();
      m.unstable_now = function() {
        return O.now() - Y;
      };
    }
    var K = [], ye = [], G = 1, re = null, oe = 3, ue = !1, pe = !1, se = !1, ke = !1, Se = typeof setTimeout == "function" ? setTimeout : null, Ge = typeof clearTimeout == "function" ? clearTimeout : null, Ee = typeof setImmediate < "u" ? setImmediate : null, Me = !1, Ue = -1, Oe = 5, mn = -1;
    if (typeof Ee == "function") var yn = function() {
      Ee(k);
    };
    else if (typeof MessageChannel < "u") {
      var jn = new MessageChannel(), Ae = jn.port2;
      jn.port1.onmessage = k, yn = function() {
        Ae.postMessage(null);
      };
    } else yn = function() {
      Se(k, 0);
    };
    m.unstable_IdlePriority = 5, m.unstable_ImmediatePriority = 1, m.unstable_LowPriority = 4, m.unstable_NormalPriority = 3, m.unstable_Profiling = null, m.unstable_UserBlockingPriority = 2, m.unstable_cancelCallback = function(S) {
      S.callback = null;
    }, m.unstable_forceFrameRate = function(S) {
      0 > S || 125 < S ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : Oe = 0 < S ? Math.floor(1e3 / S) : 5;
    }, m.unstable_getCurrentPriorityLevel = function() {
      return oe;
    }, m.unstable_next = function(S) {
      switch (oe) {
        case 1:
        case 2:
        case 3:
          var N = 3;
          break;
        default:
          N = oe;
      }
      var $ = oe;
      oe = N;
      try {
        return S();
      } finally {
        oe = $;
      }
    }, m.unstable_requestPaint = function() {
      ke = !0;
    }, m.unstable_runWithPriority = function(S, N) {
      switch (S) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          S = 3;
      }
      var $ = oe;
      oe = S;
      try {
        return N();
      } finally {
        oe = $;
      }
    }, m.unstable_scheduleCallback = function(S, N, $) {
      var ae = m.unstable_now();
      switch ($ = typeof $ == "object" && $ !== null && typeof ($ = $.delay) == "number" && 0 < $ ? ae + $ : ae, S) {
        case 1:
          var me = -1;
          break;
        case 2:
          me = 250;
          break;
        case 5:
          me = 1073741823;
          break;
        case 4:
          me = 1e4;
          break;
        default:
          me = 5e3;
      }
      return S = { id: G++, callback: N, priorityLevel: S, startTime: $, expirationTime: me = $ + me, sortIndex: -1 }, $ > ae ? (S.sortIndex = $, C(ye, S), b(K) === null && S === b(ye) && (se ? (Ge(Ue), Ue = -1) : se = !0, L(H, $ - ae))) : (S.sortIndex = me, C(K, S), pe || ue || (pe = !0, Me || (Me = !0, yn()))), S;
    }, m.unstable_shouldYield = R, m.unstable_wrapCallback = function(S) {
      var N = oe;
      return function() {
        var $ = oe;
        oe = N;
        try {
          return S.apply(this, arguments);
        } finally {
          oe = $;
        }
      };
    }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), Bk), pv.exports;
}
var Vk, qy = { exports: {} }, Ir = {};
function H1() {
  if (Vk) return Ir;
  Vk = 1;
  var m = Lp();
  function k(H) {
    var R = "https://react.dev/errors/" + H;
    if (1 < arguments.length) {
      R += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var L = 2; L < arguments.length; L++) R += "&args[]=" + encodeURIComponent(arguments[L]);
    }
    return "Minified React error #" + H + "; visit " + R + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  function C() {
  }
  var b = { d: { f: C, r: function() {
    throw Error(k(522));
  }, D: C, C, L: C, m: C, X: C, S: C, M: C }, p: 0, findDOMNode: null }, A = Symbol.for("react.portal"), W = m.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
  function Z(H, R) {
    return H === "font" ? "" : typeof R == "string" ? R === "use-credentials" ? R : "" : void 0;
  }
  return Ir.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = b, Ir.createPortal = function(H, R) {
    var L = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!R || R.nodeType !== 1 && R.nodeType !== 9 && R.nodeType !== 11) throw Error(k(299));
    return function(U, O, Y) {
      var K = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
      return { $$typeof: A, key: K == null ? null : "" + K, children: U, containerInfo: O, implementation: Y };
    }(H, R, null, L);
  }, Ir.flushSync = function(H) {
    var R = W.T, L = b.p;
    try {
      if (W.T = null, b.p = 2, H) return H();
    } finally {
      W.T = R, b.p = L, b.d.f();
    }
  }, Ir.preconnect = function(H, R) {
    typeof H == "string" && (R ? R = typeof (R = R.crossOrigin) == "string" ? R === "use-credentials" ? R : "" : void 0 : R = null, b.d.C(H, R));
  }, Ir.prefetchDNS = function(H) {
    typeof H == "string" && b.d.D(H);
  }, Ir.preinit = function(H, R) {
    if (typeof H == "string" && R && typeof R.as == "string") {
      var L = R.as, U = Z(L, R.crossOrigin), O = typeof R.integrity == "string" ? R.integrity : void 0, Y = typeof R.fetchPriority == "string" ? R.fetchPriority : void 0;
      L === "style" ? b.d.S(H, typeof R.precedence == "string" ? R.precedence : void 0, { crossOrigin: U, integrity: O, fetchPriority: Y }) : L === "script" && b.d.X(H, { crossOrigin: U, integrity: O, fetchPriority: Y, nonce: typeof R.nonce == "string" ? R.nonce : void 0 });
    }
  }, Ir.preinitModule = function(H, R) {
    if (typeof H == "string") if (typeof R == "object" && R !== null) {
      if (R.as == null || R.as === "script") {
        var L = Z(R.as, R.crossOrigin);
        b.d.M(H, { crossOrigin: L, integrity: typeof R.integrity == "string" ? R.integrity : void 0, nonce: typeof R.nonce == "string" ? R.nonce : void 0 });
      }
    } else R == null && b.d.M(H);
  }, Ir.preload = function(H, R) {
    if (typeof H == "string" && typeof R == "object" && R !== null && typeof R.as == "string") {
      var L = R.as, U = Z(L, R.crossOrigin);
      b.d.L(H, L, { crossOrigin: U, integrity: typeof R.integrity == "string" ? R.integrity : void 0, nonce: typeof R.nonce == "string" ? R.nonce : void 0, type: typeof R.type == "string" ? R.type : void 0, fetchPriority: typeof R.fetchPriority == "string" ? R.fetchPriority : void 0, referrerPolicy: typeof R.referrerPolicy == "string" ? R.referrerPolicy : void 0, imageSrcSet: typeof R.imageSrcSet == "string" ? R.imageSrcSet : void 0, imageSizes: typeof R.imageSizes == "string" ? R.imageSizes : void 0, media: typeof R.media == "string" ? R.media : void 0 });
    }
  }, Ir.preloadModule = function(H, R) {
    if (typeof H == "string") if (R) {
      var L = Z(R.as, R.crossOrigin);
      b.d.m(H, { as: typeof R.as == "string" && R.as !== "script" ? R.as : void 0, crossOrigin: L, integrity: typeof R.integrity == "string" ? R.integrity : void 0 });
    } else b.d.m(H);
  }, Ir.requestFormReset = function(H) {
    b.d.r(H);
  }, Ir.unstable_batchedUpdates = function(H, R) {
    return H(R);
  }, Ir.useFormState = function(H, R, L) {
    return W.H.useFormState(H, R, L);
  }, Ir.useFormStatus = function() {
    return W.H.useHostTransitionStatus();
  }, Ir.version = "19.1.0", Ir;
}
var Wk, qk, Qk, Mr = {};
function U1() {
  if (Wk) return Mr;
  Wk = 1;
  /**
  	 * @license React
  	 * react-dom.development.js
  	 *
  	 * Copyright (c) Meta Platforms, Inc. and affiliates.
  	 *
  	 * This source code is licensed under the MIT license found in the
  	 * LICENSE file in the root directory of this source tree.
  	 */
  return {}.NODE_ENV !== "production" && function() {
    function m() {
    }
    function k(U) {
      return "" + U;
    }
    function C(U, O) {
      return U === "font" ? "" : typeof O == "string" ? O === "use-credentials" ? O : "" : void 0;
    }
    function b(U) {
      return U === null ? "`null`" : U === void 0 ? "`undefined`" : U === "" ? "an empty string" : 'something with type "' + typeof U + '"';
    }
    function A(U) {
      return U === null ? "`null`" : U === void 0 ? "`undefined`" : U === "" ? "an empty string" : typeof U == "string" ? JSON.stringify(U) : typeof U == "number" ? "`" + U + "`" : 'something with type "' + typeof U + '"';
    }
    function W() {
      var U = L.H;
      return U === null && console.error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.`), U;
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var Z = Lp(), H = { d: { f: m, r: function() {
      throw Error("Invalid form element. requestFormReset must be passed a form that was rendered by React.");
    }, D: m, C: m, L: m, m, X: m, S: m, M: m }, p: 0, findDOMNode: null }, R = Symbol.for("react.portal"), L = Z.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
    typeof Map == "function" && Map.prototype != null && typeof Map.prototype.forEach == "function" && typeof Set == "function" && Set.prototype != null && typeof Set.prototype.clear == "function" && typeof Set.prototype.forEach == "function" || console.error("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"), Mr.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = H, Mr.createPortal = function(U, O) {
      var Y = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
      if (!O || O.nodeType !== 1 && O.nodeType !== 9 && O.nodeType !== 11) throw Error("Target container is not a DOM element.");
      return function(K, ye, G) {
        var re = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
        try {
          k(re);
          var oe = !1;
        } catch {
          oe = !0;
        }
        return oe && (console.error("The provided key is an unsupported type %s. This value must be coerced to a string before using it here.", typeof Symbol == "function" && Symbol.toStringTag && re[Symbol.toStringTag] || re.constructor.name || "Object"), k(re)), { $$typeof: R, key: re == null ? null : "" + re, children: K, containerInfo: ye, implementation: G };
      }(U, O, null, Y);
    }, Mr.flushSync = function(U) {
      var O = L.T, Y = H.p;
      try {
        if (L.T = null, H.p = 2, U) return U();
      } finally {
        L.T = O, H.p = Y, H.d.f() && console.error("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task.");
      }
    }, Mr.preconnect = function(U, O) {
      typeof U == "string" && U ? O != null && typeof O != "object" ? console.error("ReactDOM.preconnect(): Expected the `options` argument (second) to be an object but encountered %s instead. The only supported option at this time is `crossOrigin` which accepts a string.", A(O)) : O != null && typeof O.crossOrigin != "string" && console.error("ReactDOM.preconnect(): Expected the `crossOrigin` option (second argument) to be a string but encountered %s instead. Try removing this option or passing a string value instead.", b(O.crossOrigin)) : console.error("ReactDOM.preconnect(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.", b(U)), typeof U == "string" && (O ? O = typeof (O = O.crossOrigin) == "string" ? O === "use-credentials" ? O : "" : void 0 : O = null, H.d.C(U, O));
    }, Mr.prefetchDNS = function(U) {
      if (typeof U == "string" && U) {
        if (1 < arguments.length) {
          var O = arguments[1];
          typeof O == "object" && O.hasOwnProperty("crossOrigin") ? console.error("ReactDOM.prefetchDNS(): Expected only one argument, `href`, but encountered %s as a second argument instead. This argument is reserved for future options and is currently disallowed. It looks like the you are attempting to set a crossOrigin property for this DNS lookup hint. Browsers do not perform DNS queries using CORS and setting this attribute on the resource hint has no effect. Try calling ReactDOM.prefetchDNS() with just a single string argument, `href`.", A(O)) : console.error("ReactDOM.prefetchDNS(): Expected only one argument, `href`, but encountered %s as a second argument instead. This argument is reserved for future options and is currently disallowed. Try calling ReactDOM.prefetchDNS() with just a single string argument, `href`.", A(O));
        }
      } else console.error("ReactDOM.prefetchDNS(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.", b(U));
      typeof U == "string" && H.d.D(U);
    }, Mr.preinit = function(U, O) {
      if (typeof U == "string" && U ? O == null || typeof O != "object" ? console.error("ReactDOM.preinit(): Expected the `options` argument (second) to be an object with an `as` property describing the type of resource to be preinitialized but encountered %s instead.", A(O)) : O.as !== "style" && O.as !== "script" && console.error('ReactDOM.preinit(): Expected the `as` property in the `options` argument (second) to contain a valid value describing the type of resource to be preinitialized but encountered %s instead. Valid values for `as` are "style" and "script".', A(O.as)) : console.error("ReactDOM.preinit(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.", b(U)), typeof U == "string" && O && typeof O.as == "string") {
        var Y = O.as, K = C(Y, O.crossOrigin), ye = typeof O.integrity == "string" ? O.integrity : void 0, G = typeof O.fetchPriority == "string" ? O.fetchPriority : void 0;
        Y === "style" ? H.d.S(U, typeof O.precedence == "string" ? O.precedence : void 0, { crossOrigin: K, integrity: ye, fetchPriority: G }) : Y === "script" && H.d.X(U, { crossOrigin: K, integrity: ye, fetchPriority: G, nonce: typeof O.nonce == "string" ? O.nonce : void 0 });
      }
    }, Mr.preinitModule = function(U, O) {
      var Y = "";
      typeof U == "string" && U || (Y += " The `href` argument encountered was " + b(U) + "."), O !== void 0 && typeof O != "object" ? Y += " The `options` argument encountered was " + b(O) + "." : O && "as" in O && O.as !== "script" && (Y += " The `as` option encountered was " + A(O.as) + "."), Y ? console.error("ReactDOM.preinitModule(): Expected up to two arguments, a non-empty `href` string and, optionally, an `options` object with a valid `as` property.%s", Y) : (Y = O && typeof O.as == "string" ? O.as : "script") === "script" || (Y = A(Y), console.error('ReactDOM.preinitModule(): Currently the only supported "as" type for this function is "script" but received "%s" instead. This warning was generated for `href` "%s". In the future other module types will be supported, aligning with the import-attributes proposal. Learn more here: (https://github.com/tc39/proposal-import-attributes)', Y, U)), typeof U == "string" && (typeof O == "object" && O !== null ? O.as != null && O.as !== "script" || (Y = C(O.as, O.crossOrigin), H.d.M(U, { crossOrigin: Y, integrity: typeof O.integrity == "string" ? O.integrity : void 0, nonce: typeof O.nonce == "string" ? O.nonce : void 0 })) : O == null && H.d.M(U));
    }, Mr.preload = function(U, O) {
      var Y = "";
      if (typeof U == "string" && U || (Y += " The `href` argument encountered was " + b(U) + "."), O == null || typeof O != "object" ? Y += " The `options` argument encountered was " + b(O) + "." : typeof O.as == "string" && O.as || (Y += " The `as` option encountered was " + b(O.as) + "."), Y && console.error('ReactDOM.preload(): Expected two arguments, a non-empty `href` string and an `options` object with an `as` property valid for a `<link rel="preload" as="..." />` tag.%s', Y), typeof U == "string" && typeof O == "object" && O !== null && typeof O.as == "string") {
        var K = C(Y = O.as, O.crossOrigin);
        H.d.L(U, Y, { crossOrigin: K, integrity: typeof O.integrity == "string" ? O.integrity : void 0, nonce: typeof O.nonce == "string" ? O.nonce : void 0, type: typeof O.type == "string" ? O.type : void 0, fetchPriority: typeof O.fetchPriority == "string" ? O.fetchPriority : void 0, referrerPolicy: typeof O.referrerPolicy == "string" ? O.referrerPolicy : void 0, imageSrcSet: typeof O.imageSrcSet == "string" ? O.imageSrcSet : void 0, imageSizes: typeof O.imageSizes == "string" ? O.imageSizes : void 0, media: typeof O.media == "string" ? O.media : void 0 });
      }
    }, Mr.preloadModule = function(U, O) {
      var Y = "";
      typeof U == "string" && U || (Y += " The `href` argument encountered was " + b(U) + "."), O !== void 0 && typeof O != "object" ? Y += " The `options` argument encountered was " + b(O) + "." : O && "as" in O && typeof O.as != "string" && (Y += " The `as` option encountered was " + b(O.as) + "."), Y && console.error('ReactDOM.preloadModule(): Expected two arguments, a non-empty `href` string and, optionally, an `options` object with an `as` property valid for a `<link rel="modulepreload" as="..." />` tag.%s', Y), typeof U == "string" && (O ? (Y = C(O.as, O.crossOrigin), H.d.m(U, { as: typeof O.as == "string" && O.as !== "script" ? O.as : void 0, crossOrigin: Y, integrity: typeof O.integrity == "string" ? O.integrity : void 0 })) : H.d.m(U));
    }, Mr.requestFormReset = function(U) {
      H.d.r(U);
    }, Mr.unstable_batchedUpdates = function(U, O) {
      return U(O);
    }, Mr.useFormState = function(U, O, Y) {
      return W().useFormState(U, O, Y);
    }, Mr.useFormStatus = function() {
      return W().useHostTransitionStatus();
    }, Mr.version = "19.1.0", typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }(), Mr;
}
function Cv() {
  if (qk) return qy.exports;
  qk = 1;
  var m = {};
  return m.NODE_ENV === "production" ? (function k() {
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE == "function") {
      if (m.NODE_ENV !== "production") throw new Error("^_^");
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(k);
      } catch (C) {
        console.error(C);
      }
    }
  }(), qy.exports = H1()) : qy.exports = U1(), qy.exports;
}
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function B1() {
  if (Qk) return lg;
  Qk = 1;
  var m = aw(), k = Lp(), C = Cv();
  function b(t) {
    var o = "https://react.dev/errors/" + t;
    if (1 < arguments.length) {
      o += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var a = 2; a < arguments.length; a++) o += "&args[]=" + encodeURIComponent(arguments[a]);
    }
    return "Minified React error #" + t + "; visit " + o + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  function A(t) {
    return !(!t || t.nodeType !== 1 && t.nodeType !== 9 && t.nodeType !== 11);
  }
  function W(t) {
    var o = t, a = t;
    if (t.alternate) for (; o.return; ) o = o.return;
    else {
      t = o;
      do
        4098 & (o = t).flags && (a = o.return), t = o.return;
      while (t);
    }
    return o.tag === 3 ? a : null;
  }
  function Z(t) {
    if (t.tag === 13) {
      var o = t.memoizedState;
      if (o === null && (t = t.alternate) !== null && (o = t.memoizedState), o !== null) return o.dehydrated;
    }
    return null;
  }
  function H(t) {
    if (W(t) !== t) throw Error(b(188));
  }
  function R(t) {
    var o = t.tag;
    if (o === 5 || o === 26 || o === 27 || o === 6) return t;
    for (t = t.child; t !== null; ) {
      if ((o = R(t)) !== null) return o;
      t = t.sibling;
    }
    return null;
  }
  var L = Object.assign, U = Symbol.for("react.element"), O = Symbol.for("react.transitional.element"), Y = Symbol.for("react.portal"), K = Symbol.for("react.fragment"), ye = Symbol.for("react.strict_mode"), G = Symbol.for("react.profiler"), re = Symbol.for("react.provider"), oe = Symbol.for("react.consumer"), ue = Symbol.for("react.context"), pe = Symbol.for("react.forward_ref"), se = Symbol.for("react.suspense"), ke = Symbol.for("react.suspense_list"), Se = Symbol.for("react.memo"), Ge = Symbol.for("react.lazy"), Ee = Symbol.for("react.activity"), Me = Symbol.for("react.memo_cache_sentinel"), Ue = Symbol.iterator;
  function Oe(t) {
    return t === null || typeof t != "object" ? null : typeof (t = Ue && t[Ue] || t["@@iterator"]) == "function" ? t : null;
  }
  var mn = Symbol.for("react.client.reference");
  function yn(t) {
    if (t == null) return null;
    if (typeof t == "function") return t.$$typeof === mn ? null : t.displayName || t.name || null;
    if (typeof t == "string") return t;
    switch (t) {
      case K:
        return "Fragment";
      case G:
        return "Profiler";
      case ye:
        return "StrictMode";
      case se:
        return "Suspense";
      case ke:
        return "SuspenseList";
      case Ee:
        return "Activity";
    }
    if (typeof t == "object") switch (t.$$typeof) {
      case Y:
        return "Portal";
      case ue:
        return (t.displayName || "Context") + ".Provider";
      case oe:
        return (t._context.displayName || "Context") + ".Consumer";
      case pe:
        var o = t.render;
        return (t = t.displayName) || (t = (t = o.displayName || o.name || "") !== "" ? "ForwardRef(" + t + ")" : "ForwardRef"), t;
      case Se:
        return (o = t.displayName || null) !== null ? o : yn(t.type) || "Memo";
      case Ge:
        o = t._payload, t = t._init;
        try {
          return yn(t(o));
        } catch {
        }
    }
    return null;
  }
  var jn = Array.isArray, Ae = k.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, S = C.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, N = { pending: !1, data: null, method: null, action: null }, $ = [], ae = -1;
  function me(t) {
    return { current: t };
  }
  function ce(t) {
    0 > ae || (t.current = $[ae], $[ae] = null, ae--);
  }
  function Te(t, o) {
    ae++, $[ae] = t.current, t.current = o;
  }
  var He = me(null), Ce = me(null), Ie = me(null), Be = me(null);
  function Qe(t, o) {
    switch (Te(Ie, o), Te(Ce, t), Te(He, null), o.nodeType) {
      case 9:
      case 11:
        t = (t = o.documentElement) && (t = t.namespaceURI) ? Zu(t) : 0;
        break;
      default:
        if (t = o.tagName, o = o.namespaceURI) t = ul(o = Zu(o), t);
        else switch (t) {
          case "svg":
            t = 1;
            break;
          case "math":
            t = 2;
            break;
          default:
            t = 0;
        }
    }
    ce(He), Te(He, t);
  }
  function _e() {
    ce(He), ce(Ce), ce(Ie);
  }
  function Vn(t) {
    t.memoizedState !== null && Te(Be, t);
    var o = He.current, a = ul(o, t.type);
    o !== a && (Te(Ce, t), Te(He, a));
  }
  function Fn(t) {
    Ce.current === t && (ce(He), ce(Ce)), Be.current === t && (ce(Be), Dc._currentValue = N);
  }
  var Xt = Object.prototype.hasOwnProperty, $t = m.unstable_scheduleCallback, fr = m.unstable_cancelCallback, Ua = m.unstable_shouldYield, Uo = m.unstable_requestPaint, oo = m.unstable_now, rn = m.unstable_getCurrentPriorityLevel, yl = m.unstable_ImmediatePriority, ti = m.unstable_UserBlockingPriority, Bo = m.unstable_NormalPriority, pd = m.unstable_LowPriority, vs = m.unstable_IdlePriority, du = m.log, ks = m.unstable_setDisableYieldValue, Ba = null, _t = null;
  function Er(t) {
    if (typeof du == "function" && ks(t), _t && typeof _t.setStrictMode == "function") try {
      _t.setStrictMode(Ba, t);
    } catch {
    }
  }
  var vt = Math.clz32 ? Math.clz32 : function(t) {
    return (t >>>= 0) === 0 ? 32 : 31 - (bo(t) / vo | 0) | 0;
  }, bo = Math.log, vo = Math.LN2, Vo = 256, E = 4194304;
  function V(t) {
    var o = 42 & t;
    if (o !== 0) return o;
    switch (t & -t) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
        return 64;
      case 128:
        return 128;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return 4194048 & t;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return 62914560 & t;
      case 67108864:
        return 67108864;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 0;
      default:
        return t;
    }
  }
  function be(t, o, a) {
    var u = t.pendingLanes;
    if (u === 0) return 0;
    var c = 0, d = t.suspendedLanes, g = t.pingedLanes;
    t = t.warmLanes;
    var h = 134217727 & u;
    return h !== 0 ? (u = h & ~d) !== 0 ? c = V(u) : (g &= h) !== 0 ? c = V(g) : a || (a = h & ~t) !== 0 && (c = V(a)) : (h = u & ~d) !== 0 ? c = V(h) : g !== 0 ? c = V(g) : a || (a = u & ~t) !== 0 && (c = V(a)), c === 0 ? 0 : o !== 0 && o !== c && (o & d) === 0 && ((d = c & -c) >= (a = o & -o) || d === 32 && 4194048 & a) ? o : c;
  }
  function we(t, o) {
    return (t.pendingLanes & ~(t.suspendedLanes & ~t.pingedLanes) & o) === 0;
  }
  function Le(t, o) {
    switch (t) {
      case 1:
      case 2:
      case 4:
      case 8:
      case 64:
        return o + 250;
      case 16:
      case 32:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return o + 5e3;
      default:
        return -1;
    }
  }
  function dn() {
    var t = Vo;
    return !(4194048 & (Vo <<= 1)) && (Vo = 256), t;
  }
  function Wn() {
    var t = E;
    return !(62914560 & (E <<= 1)) && (E = 4194304), t;
  }
  function wn(t) {
    for (var o = [], a = 0; 31 > a; a++) o.push(t);
    return o;
  }
  function Ze(t, o) {
    t.pendingLanes |= o, o !== 268435456 && (t.suspendedLanes = 0, t.pingedLanes = 0, t.warmLanes = 0);
  }
  function tn(t, o, a) {
    t.pendingLanes |= o, t.suspendedLanes &= ~o;
    var u = 31 - vt(o);
    t.entangledLanes |= o, t.entanglements[u] = 1073741824 | t.entanglements[u] | 4194090 & a;
  }
  function Ct(t, o) {
    var a = t.entangledLanes |= o;
    for (t = t.entanglements; a; ) {
      var u = 31 - vt(a), c = 1 << u;
      c & o | t[u] & o && (t[u] |= o), a &= ~c;
    }
  }
  function Ln(t) {
    switch (t) {
      case 2:
        t = 1;
        break;
      case 8:
        t = 4;
        break;
      case 32:
        t = 16;
        break;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        t = 128;
        break;
      case 268435456:
        t = 134217728;
        break;
      default:
        t = 0;
    }
    return t;
  }
  function Hn(t) {
    return 2 < (t &= -t) ? 8 < t ? 134217727 & t ? 32 : 268435456 : 8 : 2;
  }
  function ri() {
    var t = S.p;
    return t !== 0 ? t : (t = window.event) === void 0 ? 32 : vh(t.type);
  }
  var bl = Math.random().toString(36).slice(2), Ut = "__reactFiber$" + bl, pr = "__reactProps$" + bl, Va = "__reactContainer$" + bl, Fp = "__reactEvents$" + bl, De = "__reactListeners$" + bl, Ip = "__reactHandles$" + bl, jr = "__reactResources$" + bl, fu = "__reactMarker$" + bl;
  function pu(t) {
    delete t[Ut], delete t[pr], delete t[Fp], delete t[De], delete t[Ip];
  }
  function oi(t) {
    var o = t[Ut];
    if (o) return o;
    for (var a = t.parentNode; a; ) {
      if (o = a[Va] || a[Ut]) {
        if (a = o.alternate, o.child !== null || a !== null && a.child !== null) for (t = Jg(t); t !== null; ) {
          if (a = t[Ut]) return a;
          t = Jg(t);
        }
        return o;
      }
      a = (t = a).parentNode;
    }
    return null;
  }
  function Wa(t) {
    if (t = t[Ut] || t[Va]) {
      var o = t.tag;
      if (o === 5 || o === 6 || o === 13 || o === 26 || o === 27 || o === 3) return t;
    }
    return null;
  }
  function mr(t) {
    var o = t.tag;
    if (o === 5 || o === 26 || o === 27 || o === 6) return t.stateNode;
    throw Error(b(33));
  }
  function ai(t) {
    var o = t[jr];
    return o || (o = t[jr] = { hoistableStyles: /* @__PURE__ */ new Map(), hoistableScripts: /* @__PURE__ */ new Map() }), o;
  }
  function kt(t) {
    t[fu] = !0;
  }
  var Mp = /* @__PURE__ */ new Set(), md = {};
  function vl(t, o) {
    li(t, o), li(t + "Capture", o);
  }
  function li(t, o) {
    for (md[t] = o, t = 0; t < o.length; t++) Mp.add(o[t]);
  }
  var kl, jp, mg = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), Hp = {}, Up = {};
  function ws(t, o, a) {
    if (c = o, Xt.call(Up, c) || !Xt.call(Hp, c) && (mg.test(c) ? Up[c] = !0 : (Hp[c] = !0, 0))) if (a === null) t.removeAttribute(o);
    else {
      switch (typeof a) {
        case "undefined":
        case "function":
        case "symbol":
          return void t.removeAttribute(o);
        case "boolean":
          var u = o.toLowerCase().slice(0, 5);
          if (u !== "data-" && u !== "aria-") return void t.removeAttribute(o);
      }
      t.setAttribute(o, "" + a);
    }
    var c;
  }
  function Zt(t, o, a) {
    if (a === null) t.removeAttribute(o);
    else {
      switch (typeof a) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          return void t.removeAttribute(o);
      }
      t.setAttribute(o, "" + a);
    }
  }
  function xr(t, o, a, u) {
    if (u === null) t.removeAttribute(a);
    else {
      switch (typeof u) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          return void t.removeAttribute(a);
      }
      t.setAttributeNS(o, a, "" + u);
    }
  }
  function ao(t) {
    if (kl === void 0) try {
      throw Error();
    } catch (a) {
      var o = a.stack.trim().match(/\n( *(at )?)/);
      kl = o && o[1] || "", jp = -1 < a.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < a.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return `
` + kl + t + jp;
  }
  var hd = !1;
  function ii(t, o) {
    if (!t || hd) return "";
    hd = !0;
    var a = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      var u = { DetermineComponentFrameRoot: function() {
        try {
          if (o) {
            var q = function() {
              throw Error();
            };
            if (Object.defineProperty(q.prototype, "props", { set: function() {
              throw Error();
            } }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(q, []);
              } catch (le) {
                var ee = le;
              }
              Reflect.construct(t, [], q);
            } else {
              try {
                q.call();
              } catch (le) {
                ee = le;
              }
              t.call(q.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (le) {
              ee = le;
            }
            (q = t()) && typeof q.catch == "function" && q.catch(function() {
            });
          }
        } catch (le) {
          if (le && ee && typeof le.stack == "string") return [le.stack, ee.stack];
        }
        return [null, null];
      } };
      u.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
      var c = Object.getOwnPropertyDescriptor(u.DetermineComponentFrameRoot, "name");
      c && c.configurable && Object.defineProperty(u.DetermineComponentFrameRoot, "name", { value: "DetermineComponentFrameRoot" });
      var d = u.DetermineComponentFrameRoot(), g = d[0], h = d[1];
      if (g && h) {
        var w = g.split(`
`), x = h.split(`
`);
        for (c = u = 0; u < w.length && !w[u].includes("DetermineComponentFrameRoot"); ) u++;
        for (; c < x.length && !x[c].includes("DetermineComponentFrameRoot"); ) c++;
        if (u === w.length || c === x.length) for (u = w.length - 1, c = x.length - 1; 1 <= u && 0 <= c && w[u] !== x[c]; ) c--;
        for (; 1 <= u && 0 <= c; u--, c--) if (w[u] !== x[c]) {
          if (u !== 1 || c !== 1) do
            if (u--, 0 > --c || w[u] !== x[c]) {
              var B = `
` + w[u].replace(" at new ", " at ");
              return t.displayName && B.includes("<anonymous>") && (B = B.replace("<anonymous>", t.displayName)), B;
            }
          while (1 <= u && 0 <= c);
          break;
        }
      }
    } finally {
      hd = !1, Error.prepareStackTrace = a;
    }
    return (a = t ? t.displayName || t.name : "") ? ao(a) : "";
  }
  function gd(t) {
    switch (t.tag) {
      case 26:
      case 27:
      case 5:
        return ao(t.type);
      case 16:
        return ao("Lazy");
      case 13:
        return ao("Suspense");
      case 19:
        return ao("SuspenseList");
      case 0:
      case 15:
        return ii(t.type, !1);
      case 11:
        return ii(t.type.render, !1);
      case 1:
        return ii(t.type, !0);
      case 31:
        return ao("Activity");
      default:
        return "";
    }
  }
  function yd(t) {
    try {
      var o = "";
      do
        o += gd(t), t = t.return;
      while (t);
      return o;
    } catch (a) {
      return `
Error generating stack: ` + a.message + `
` + a.stack;
    }
  }
  function Jt(t) {
    switch (typeof t) {
      case "bigint":
      case "boolean":
      case "number":
      case "string":
      case "undefined":
      case "object":
        return t;
      default:
        return "";
    }
  }
  function ui(t) {
    var o = t.type;
    return (t = t.nodeName) && t.toLowerCase() === "input" && (o === "checkbox" || o === "radio");
  }
  function mu(t) {
    t._valueTracker || (t._valueTracker = function(o) {
      var a = ui(o) ? "checked" : "value", u = Object.getOwnPropertyDescriptor(o.constructor.prototype, a), c = "" + o[a];
      if (!o.hasOwnProperty(a) && u !== void 0 && typeof u.get == "function" && typeof u.set == "function") {
        var d = u.get, g = u.set;
        return Object.defineProperty(o, a, { configurable: !0, get: function() {
          return d.call(this);
        }, set: function(h) {
          c = "" + h, g.call(this, h);
        } }), Object.defineProperty(o, a, { enumerable: u.enumerable }), { getValue: function() {
          return c;
        }, setValue: function(h) {
          c = "" + h;
        }, stopTracking: function() {
          o._valueTracker = null, delete o[a];
        } };
      }
    }(t));
  }
  function hg(t) {
    if (!t) return !1;
    var o = t._valueTracker;
    if (!o) return !0;
    var a = o.getValue(), u = "";
    return t && (u = ui(t) ? t.checked ? "true" : "false" : t.value), (t = u) !== a && (o.setValue(t), !0);
  }
  function Ss(t) {
    if ((t = t || (typeof document < "u" ? document : void 0)) === void 0) return null;
    try {
      return t.activeElement || t.body;
    } catch {
      return t.body;
    }
  }
  var Bp = /[\n"\\]/g;
  function Hr(t) {
    return t.replace(Bp, function(o) {
      return "\\" + o.charCodeAt(0).toString(16) + " ";
    });
  }
  function bd(t, o, a, u, c, d, g, h) {
    t.name = "", g != null && typeof g != "function" && typeof g != "symbol" && typeof g != "boolean" ? t.type = g : t.removeAttribute("type"), o != null ? g === "number" ? (o === 0 && t.value === "" || t.value != o) && (t.value = "" + Jt(o)) : t.value !== "" + Jt(o) && (t.value = "" + Jt(o)) : g !== "submit" && g !== "reset" || t.removeAttribute("value"), o != null ? vd(t, g, Jt(o)) : a != null ? vd(t, g, Jt(a)) : u != null && t.removeAttribute("value"), c == null && d != null && (t.defaultChecked = !!d), c != null && (t.checked = c && typeof c != "function" && typeof c != "symbol"), h != null && typeof h != "function" && typeof h != "symbol" && typeof h != "boolean" ? t.name = "" + Jt(h) : t.removeAttribute("name");
  }
  function Vp(t, o, a, u, c, d, g, h) {
    if (d != null && typeof d != "function" && typeof d != "symbol" && typeof d != "boolean" && (t.type = d), o != null || a != null) {
      if ((d === "submit" || d === "reset") && o == null) return;
      a = a != null ? "" + Jt(a) : "", o = o != null ? "" + Jt(o) : a, h || o === t.value || (t.value = o), t.defaultValue = o;
    }
    u = typeof (u = u ?? c) != "function" && typeof u != "symbol" && !!u, t.checked = h ? t.checked : !!u, t.defaultChecked = !!u, g != null && typeof g != "function" && typeof g != "symbol" && typeof g != "boolean" && (t.name = g);
  }
  function vd(t, o, a) {
    o === "number" && Ss(t.ownerDocument) === t || t.defaultValue === "" + a || (t.defaultValue = "" + a);
  }
  function si(t, o, a, u) {
    if (t = t.options, o) {
      o = {};
      for (var c = 0; c < a.length; c++) o["$" + a[c]] = !0;
      for (a = 0; a < t.length; a++) c = o.hasOwnProperty("$" + t[a].value), t[a].selected !== c && (t[a].selected = c), c && u && (t[a].defaultSelected = !0);
    } else {
      for (a = "" + Jt(a), o = null, c = 0; c < t.length; c++) {
        if (t[c].value === a) return t[c].selected = !0, void (u && (t[c].defaultSelected = !0));
        o !== null || t[c].disabled || (o = t[c]);
      }
      o !== null && (o.selected = !0);
    }
  }
  function kd(t, o, a) {
    o == null || ((o = "" + Jt(o)) !== t.value && (t.value = o), a != null) ? t.defaultValue = a != null ? "" + Jt(a) : "" : t.defaultValue !== o && (t.defaultValue = o);
  }
  function Es(t, o, a, u) {
    if (o == null) {
      if (u != null) {
        if (a != null) throw Error(b(92));
        if (jn(u)) {
          if (1 < u.length) throw Error(b(93));
          u = u[0];
        }
        a = u;
      }
      a == null && (a = ""), o = a;
    }
    a = Jt(o), t.defaultValue = a, (u = t.textContent) === a && u !== "" && u !== null && (t.value = u);
  }
  function Wo(t, o) {
    if (o) {
      var a = t.firstChild;
      if (a && a === t.lastChild && a.nodeType === 3) return void (a.nodeValue = o);
    }
    t.textContent = o;
  }
  var gg = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
  function Wp(t, o, a) {
    var u = o.indexOf("--") === 0;
    a == null || typeof a == "boolean" || a === "" ? u ? t.setProperty(o, "") : o === "float" ? t.cssFloat = "" : t[o] = "" : u ? t.setProperty(o, a) : typeof a != "number" || a === 0 || gg.has(o) ? o === "float" ? t.cssFloat = a : t[o] = ("" + a).trim() : t[o] = a + "px";
  }
  function hu(t, o, a) {
    if (o != null && typeof o != "object") throw Error(b(62));
    if (t = t.style, a != null) {
      for (var u in a) !a.hasOwnProperty(u) || o != null && o.hasOwnProperty(u) || (u.indexOf("--") === 0 ? t.setProperty(u, "") : u === "float" ? t.cssFloat = "" : t[u] = "");
      for (var c in o) u = o[c], o.hasOwnProperty(c) && a[c] !== u && Wp(t, c, u);
    } else for (var d in o) o.hasOwnProperty(d) && Wp(t, d, o[d]);
  }
  function wd(t) {
    if (t.indexOf("-") === -1) return !1;
    switch (t) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var eb = /* @__PURE__ */ new Map([["acceptCharset", "accept-charset"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"], ["crossOrigin", "crossorigin"], ["accentHeight", "accent-height"], ["alignmentBaseline", "alignment-baseline"], ["arabicForm", "arabic-form"], ["baselineShift", "baseline-shift"], ["capHeight", "cap-height"], ["clipPath", "clip-path"], ["clipRule", "clip-rule"], ["colorInterpolation", "color-interpolation"], ["colorInterpolationFilters", "color-interpolation-filters"], ["colorProfile", "color-profile"], ["colorRendering", "color-rendering"], ["dominantBaseline", "dominant-baseline"], ["enableBackground", "enable-background"], ["fillOpacity", "fill-opacity"], ["fillRule", "fill-rule"], ["floodColor", "flood-color"], ["floodOpacity", "flood-opacity"], ["fontFamily", "font-family"], ["fontSize", "font-size"], ["fontSizeAdjust", "font-size-adjust"], ["fontStretch", "font-stretch"], ["fontStyle", "font-style"], ["fontVariant", "font-variant"], ["fontWeight", "font-weight"], ["glyphName", "glyph-name"], ["glyphOrientationHorizontal", "glyph-orientation-horizontal"], ["glyphOrientationVertical", "glyph-orientation-vertical"], ["horizAdvX", "horiz-adv-x"], ["horizOriginX", "horiz-origin-x"], ["imageRendering", "image-rendering"], ["letterSpacing", "letter-spacing"], ["lightingColor", "lighting-color"], ["markerEnd", "marker-end"], ["markerMid", "marker-mid"], ["markerStart", "marker-start"], ["overlinePosition", "overline-position"], ["overlineThickness", "overline-thickness"], ["paintOrder", "paint-order"], ["panose-1", "panose-1"], ["pointerEvents", "pointer-events"], ["renderingIntent", "rendering-intent"], ["shapeRendering", "shape-rendering"], ["stopColor", "stop-color"], ["stopOpacity", "stop-opacity"], ["strikethroughPosition", "strikethrough-position"], ["strikethroughThickness", "strikethrough-thickness"], ["strokeDasharray", "stroke-dasharray"], ["strokeDashoffset", "stroke-dashoffset"], ["strokeLinecap", "stroke-linecap"], ["strokeLinejoin", "stroke-linejoin"], ["strokeMiterlimit", "stroke-miterlimit"], ["strokeOpacity", "stroke-opacity"], ["strokeWidth", "stroke-width"], ["textAnchor", "text-anchor"], ["textDecoration", "text-decoration"], ["textRendering", "text-rendering"], ["transformOrigin", "transform-origin"], ["underlinePosition", "underline-position"], ["underlineThickness", "underline-thickness"], ["unicodeBidi", "unicode-bidi"], ["unicodeRange", "unicode-range"], ["unitsPerEm", "units-per-em"], ["vAlphabetic", "v-alphabetic"], ["vHanging", "v-hanging"], ["vIdeographic", "v-ideographic"], ["vMathematical", "v-mathematical"], ["vectorEffect", "vector-effect"], ["vertAdvY", "vert-adv-y"], ["vertOriginX", "vert-origin-x"], ["vertOriginY", "vert-origin-y"], ["wordSpacing", "word-spacing"], ["writingMode", "writing-mode"], ["xmlnsXlink", "xmlns:xlink"], ["xHeight", "x-height"]]), nb = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
  function wl(t) {
    return nb.test("" + t) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : t;
  }
  var xs = null;
  function Sd(t) {
    return (t = t.target || t.srcElement || window).correspondingUseElement && (t = t.correspondingUseElement), t.nodeType === 3 ? t.parentNode : t;
  }
  var ci = null, qo = null;
  function qp(t) {
    var o = Wa(t);
    if (o && (t = o.stateNode)) {
      var a = t[pr] || null;
      e: switch (t = o.stateNode, o.type) {
        case "input":
          if (bd(t, a.value, a.defaultValue, a.defaultValue, a.checked, a.defaultChecked, a.type, a.name), o = a.name, a.type === "radio" && o != null) {
            for (a = t; a.parentNode; ) a = a.parentNode;
            for (a = a.querySelectorAll('input[name="' + Hr("" + o) + '"][type="radio"]'), o = 0; o < a.length; o++) {
              var u = a[o];
              if (u !== t && u.form === t.form) {
                var c = u[pr] || null;
                if (!c) throw Error(b(90));
                bd(u, c.value, c.defaultValue, c.defaultValue, c.checked, c.defaultChecked, c.type, c.name);
              }
            }
            for (o = 0; o < a.length; o++) (u = a[o]).form === t.form && hg(u);
          }
          break e;
        case "textarea":
          kd(t, a.value, a.defaultValue);
          break e;
        case "select":
          (o = a.value) != null && si(t, !!a.multiple, o, !1);
      }
    }
  }
  var gu = !1;
  function Cs(t, o, a) {
    if (gu) return t(o, a);
    gu = !0;
    try {
      return t(o);
    } finally {
      if (gu = !1, (ci !== null || qo !== null) && (kc(), ci && (o = ci, t = qo, qo = ci = null, qp(o), t))) for (o = 0; o < t.length; o++) qp(t[o]);
    }
  }
  function yu(t, o) {
    var a = t.stateNode;
    if (a === null) return null;
    var u = a[pr] || null;
    if (u === null) return null;
    a = u[o];
    e: switch (o) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (u = !u.disabled) || (u = !((t = t.type) === "button" || t === "input" || t === "select" || t === "textarea")), t = !u;
        break e;
      default:
        t = !1;
    }
    if (t) return null;
    if (a && typeof a != "function") throw Error(b(231, o, typeof a));
    return a;
  }
  var it = !(typeof window > "u" || window.document === void 0 || window.document.createElement === void 0), Qp = !1;
  if (it) try {
    var di = {};
    Object.defineProperty(di, "passive", { get: function() {
      Qp = !0;
    } }), window.addEventListener("test", di, di), window.removeEventListener("test", di, di);
  } catch {
    Qp = !1;
  }
  var Sl = null, Ed = null, Ts = null;
  function Yp() {
    if (Ts) return Ts;
    var t, o, a = Ed, u = a.length, c = "value" in Sl ? Sl.value : Sl.textContent, d = c.length;
    for (t = 0; t < u && a[t] === c[t]; t++) ;
    var g = u - t;
    for (o = 1; o <= g && a[u - o] === c[d - o]; o++) ;
    return Ts = c.slice(t, 1 < o ? 1 - o : void 0);
  }
  function xd(t) {
    var o = t.keyCode;
    return "charCode" in t ? (t = t.charCode) === 0 && o === 13 && (t = 13) : t = o, t === 10 && (t = 13), 32 <= t || t === 13 ? t : 0;
  }
  function fi() {
    return !0;
  }
  function Gp() {
    return !1;
  }
  function hr(t) {
    function o(a, u, c, d, g) {
      for (var h in this._reactName = a, this._targetInst = c, this.type = u, this.nativeEvent = d, this.target = g, this.currentTarget = null, t) t.hasOwnProperty(h) && (a = t[h], this[h] = a ? a(d) : d[h]);
      return this.isDefaultPrevented = (d.defaultPrevented != null ? d.defaultPrevented : d.returnValue === !1) ? fi : Gp, this.isPropagationStopped = Gp, this;
    }
    return L(o.prototype, { preventDefault: function() {
      this.defaultPrevented = !0;
      var a = this.nativeEvent;
      a && (a.preventDefault ? a.preventDefault() : typeof a.returnValue != "unknown" && (a.returnValue = !1), this.isDefaultPrevented = fi);
    }, stopPropagation: function() {
      var a = this.nativeEvent;
      a && (a.stopPropagation ? a.stopPropagation() : typeof a.cancelBubble != "unknown" && (a.cancelBubble = !0), this.isPropagationStopped = fi);
    }, persist: function() {
    }, isPersistent: fi }), o;
  }
  var Cd, Kp, Ps, pi = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(t) {
    return t.timeStamp || Date.now();
  }, defaultPrevented: 0, isTrusted: 0 }, Td = hr(pi), qa = L({}, pi, { view: 0, detail: 0 }), yg = hr(qa), Rs = L({}, qa, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: Ns, button: 0, buttons: 0, relatedTarget: function(t) {
    return t.relatedTarget === void 0 ? t.fromElement === t.srcElement ? t.toElement : t.fromElement : t.relatedTarget;
  }, movementX: function(t) {
    return "movementX" in t ? t.movementX : (t !== Ps && (Ps && t.type === "mousemove" ? (Cd = t.screenX - Ps.screenX, Kp = t.screenY - Ps.screenY) : Kp = Cd = 0, Ps = t), Cd);
  }, movementY: function(t) {
    return "movementY" in t ? t.movementY : Kp;
  } }), Xp = hr(Rs), bg = hr(L({}, Rs, { dataTransfer: 0 })), As = hr(L({}, qa, { relatedTarget: 0 })), vg = hr(L({}, pi, { animationName: 0, elapsedTime: 0, pseudoElement: 0 })), mi = hr(L({}, pi, { clipboardData: function(t) {
    return "clipboardData" in t ? t.clipboardData : window.clipboardData;
  } })), El = hr(L({}, pi, { data: 0 })), ko = { Esc: "Escape", Spacebar: " ", Left: "ArrowLeft", Up: "ArrowUp", Right: "ArrowRight", Down: "ArrowDown", Del: "Delete", Win: "OS", Menu: "ContextMenu", Apps: "ContextMenu", Scroll: "ScrollLock", MozPrintableKey: "Unidentified" }, Ur = { 8: "Backspace", 9: "Tab", 12: "Clear", 13: "Enter", 16: "Shift", 17: "Control", 18: "Alt", 19: "Pause", 20: "CapsLock", 27: "Escape", 32: " ", 33: "PageUp", 34: "PageDown", 35: "End", 36: "Home", 37: "ArrowLeft", 38: "ArrowUp", 39: "ArrowRight", 40: "ArrowDown", 45: "Insert", 46: "Delete", 112: "F1", 113: "F2", 114: "F3", 115: "F4", 116: "F5", 117: "F6", 118: "F7", 119: "F8", 120: "F9", 121: "F10", 122: "F11", 123: "F12", 144: "NumLock", 145: "ScrollLock", 224: "Meta" }, Pd = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
  function Rd(t) {
    var o = this.nativeEvent;
    return o.getModifierState ? o.getModifierState(t) : !!(t = Pd[t]) && !!o[t];
  }
  function Ns() {
    return Rd;
  }
  var Cr = hr(L({}, qa, { key: function(t) {
    if (t.key) {
      var o = ko[t.key] || t.key;
      if (o !== "Unidentified") return o;
    }
    return t.type === "keypress" ? (t = xd(t)) === 13 ? "Enter" : String.fromCharCode(t) : t.type === "keydown" || t.type === "keyup" ? Ur[t.keyCode] || "Unidentified" : "";
  }, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: Ns, charCode: function(t) {
    return t.type === "keypress" ? xd(t) : 0;
  }, keyCode: function(t) {
    return t.type === "keydown" || t.type === "keyup" ? t.keyCode : 0;
  }, which: function(t) {
    return t.type === "keypress" ? xd(t) : t.type === "keydown" || t.type === "keyup" ? t.keyCode : 0;
  } })), $p = hr(L({}, Rs, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 })), Ad = hr(L({}, qa, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: Ns })), bu = hr(L({}, pi, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 })), Zp = hr(L({}, Rs, { deltaX: function(t) {
    return "deltaX" in t ? t.deltaX : "wheelDeltaX" in t ? -t.wheelDeltaX : 0;
  }, deltaY: function(t) {
    return "deltaY" in t ? t.deltaY : "wheelDeltaY" in t ? -t.wheelDeltaY : "wheelDelta" in t ? -t.wheelDelta : 0;
  }, deltaZ: 0, deltaMode: 0 })), kg = hr(L({}, pi, { newState: 0, oldState: 0 })), wg = [9, 13, 27, 32], _s = it && "CompositionEvent" in window, Os = null;
  it && "documentMode" in document && (Os = document.documentMode);
  var Jp = it && "TextEvent" in window && !Os, Qo = it && (!_s || Os && 8 < Os && 11 >= Os), em = " ", Nd = !1;
  function Ls(t, o) {
    switch (t) {
      case "keyup":
        return wg.indexOf(o.keyCode) !== -1;
      case "keydown":
        return o.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function xl(t) {
    return typeof (t = t.detail) == "object" && "data" in t ? t.data : null;
  }
  var Cl = !1, nm = { color: !0, date: !0, datetime: !0, "datetime-local": !0, email: !0, month: !0, number: !0, password: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0 };
  function Tl(t) {
    var o = t && t.nodeName && t.nodeName.toLowerCase();
    return o === "input" ? !!nm[t.type] : o === "textarea";
  }
  function tm(t, o, a, u) {
    ci ? qo ? qo.push(u) : qo = [u] : ci = u, 0 < (o = Zi(o, "onChange")).length && (a = new Td("onChange", "change", null, a, u), t.push({ event: a, listeners: o }));
  }
  var vu = null, hi = null;
  function gi(t) {
    Tc(t, 0);
  }
  function Yo(t) {
    if (hg(mr(t))) return t;
  }
  function _d(t, o) {
    if (t === "change") return o;
  }
  var Pl = !1;
  if (it) {
    var Od;
    if (it) {
      var Ld = "oninput" in document;
      if (!Ld) {
        var ku = document.createElement("div");
        ku.setAttribute("oninput", "return;"), Ld = typeof ku.oninput == "function";
      }
      Od = Ld;
    } else Od = !1;
    Pl = Od && (!document.documentMode || 9 < document.documentMode);
  }
  function wu() {
    vu && (vu.detachEvent("onpropertychange", rm), hi = vu = null);
  }
  function rm(t) {
    if (t.propertyName === "value" && Yo(hi)) {
      var o = [];
      tm(o, hi, t, Sd(t)), Cs(gi, o);
    }
  }
  function zs(t, o, a) {
    t === "focusin" ? (wu(), hi = a, (vu = o).attachEvent("onpropertychange", rm)) : t === "focusout" && wu();
  }
  function Sg(t) {
    if (t === "selectionchange" || t === "keyup" || t === "keydown") return Yo(hi);
  }
  function zd(t, o) {
    if (t === "click") return Yo(o);
  }
  function Rl(t, o) {
    if (t === "input" || t === "change") return Yo(o);
  }
  var mt = typeof Object.is == "function" ? Object.is : function(t, o) {
    return t === o && (t !== 0 || 1 / t == 1 / o) || t != t && o != o;
  };
  function yi(t, o) {
    if (mt(t, o)) return !0;
    if (typeof t != "object" || t === null || typeof o != "object" || o === null) return !1;
    var a = Object.keys(t), u = Object.keys(o);
    if (a.length !== u.length) return !1;
    for (u = 0; u < a.length; u++) {
      var c = a[u];
      if (!Xt.call(o, c) || !mt(t[c], o[c])) return !1;
    }
    return !0;
  }
  function Dd(t) {
    for (; t && t.firstChild; ) t = t.firstChild;
    return t;
  }
  function Su(t, o) {
    var a, u = Dd(t);
    for (t = 0; u; ) {
      if (u.nodeType === 3) {
        if (a = t + u.textContent.length, t <= o && a >= o) return { node: u, offset: o - t };
        t = a;
      }
      e: {
        for (; u; ) {
          if (u.nextSibling) {
            u = u.nextSibling;
            break e;
          }
          u = u.parentNode;
        }
        u = void 0;
      }
      u = Dd(u);
    }
  }
  function Ds(t, o) {
    return !(!t || !o) && (t === o || (!t || t.nodeType !== 3) && (o && o.nodeType === 3 ? Ds(t, o.parentNode) : "contains" in t ? t.contains(o) : !!t.compareDocumentPosition && !!(16 & t.compareDocumentPosition(o))));
  }
  function Al(t) {
    for (var o = Ss((t = t != null && t.ownerDocument != null && t.ownerDocument.defaultView != null ? t.ownerDocument.defaultView : window).document); o instanceof t.HTMLIFrameElement; ) {
      try {
        var a = typeof o.contentWindow.location.href == "string";
      } catch {
        a = !1;
      }
      if (!a) break;
      o = Ss((t = o.contentWindow).document);
    }
    return o;
  }
  function qn(t) {
    var o = t && t.nodeName && t.nodeName.toLowerCase();
    return o && (o === "input" && (t.type === "text" || t.type === "search" || t.type === "tel" || t.type === "url" || t.type === "password") || o === "textarea" || t.contentEditable === "true");
  }
  var Fd = it && "documentMode" in document && 11 >= document.documentMode, bi = null, Fs = null, wo = null, vi = !1;
  function Go(t, o, a) {
    var u = a.window === a ? a.document : a.nodeType === 9 ? a : a.ownerDocument;
    vi || bi == null || bi !== Ss(u) || ("selectionStart" in (u = bi) && qn(u) ? u = { start: u.selectionStart, end: u.selectionEnd } : u = { anchorNode: (u = (u.ownerDocument && u.ownerDocument.defaultView || window).getSelection()).anchorNode, anchorOffset: u.anchorOffset, focusNode: u.focusNode, focusOffset: u.focusOffset }, wo && yi(wo, u) || (wo = u, 0 < (u = Zi(Fs, "onSelect")).length && (o = new Td("onSelect", "select", null, o, a), t.push({ event: o, listeners: u }), o.target = bi)));
  }
  function Ko(t, o) {
    var a = {};
    return a[t.toLowerCase()] = o.toLowerCase(), a["Webkit" + t] = "webkit" + o, a["Moz" + t] = "moz" + o, a;
  }
  var Xo = { animationend: Ko("Animation", "AnimationEnd"), animationiteration: Ko("Animation", "AnimationIteration"), animationstart: Ko("Animation", "AnimationStart"), transitionrun: Ko("Transition", "TransitionRun"), transitionstart: Ko("Transition", "TransitionStart"), transitioncancel: Ko("Transition", "TransitionCancel"), transitionend: Ko("Transition", "TransitionEnd") }, Is = {}, Id = {};
  function Nl(t) {
    if (Is[t]) return Is[t];
    if (!Xo[t]) return t;
    var o, a = Xo[t];
    for (o in a) if (a.hasOwnProperty(o) && o in Id) return Is[t] = a[o];
    return t;
  }
  it && (Id = document.createElement("div").style, "AnimationEvent" in window || (delete Xo.animationend.animation, delete Xo.animationiteration.animation, delete Xo.animationstart.animation), "TransitionEvent" in window || delete Xo.transitionend.transition);
  var So = Nl("animationend"), Eo = Nl("animationiteration"), Ms = Nl("animationstart"), Eg = Nl("transitionrun"), om = Nl("transitionstart"), Md = Nl("transitioncancel"), am = Nl("transitionend"), lm = /* @__PURE__ */ new Map(), Eu = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
  function lo(t, o) {
    lm.set(t, o), vl(o, [t]);
  }
  Eu.push("scrollEnd");
  var im = /* @__PURE__ */ new WeakMap();
  function Br(t, o) {
    if (typeof t == "object" && t !== null) {
      var a = im.get(t);
      return a !== void 0 ? a : (o = { value: t, source: o, stack: yd(o) }, im.set(t, o), o);
    }
    return { value: t, source: o, stack: yd(o) };
  }
  var Tr = [], _l = 0, $o = 0;
  function xo() {
    for (var t = _l, o = $o = _l = 0; o < t; ) {
      var a = Tr[o];
      Tr[o++] = null;
      var u = Tr[o];
      Tr[o++] = null;
      var c = Tr[o];
      Tr[o++] = null;
      var d = Tr[o];
      if (Tr[o++] = null, u !== null && c !== null) {
        var g = u.pending;
        g === null ? c.next = c : (c.next = g.next, g.next = c), u.pending = c;
      }
      d !== 0 && Cu(a, c, d);
    }
  }
  function Ol(t, o, a, u) {
    Tr[_l++] = t, Tr[_l++] = o, Tr[_l++] = a, Tr[_l++] = u, $o |= u, t.lanes |= u, (t = t.alternate) !== null && (t.lanes |= u);
  }
  function xu(t, o, a, u) {
    return Ol(t, o, a, u), js(t);
  }
  function Zo(t, o) {
    return Ol(t, null, null, o), js(t);
  }
  function Cu(t, o, a) {
    t.lanes |= a;
    var u = t.alternate;
    u !== null && (u.lanes |= a);
    for (var c = !1, d = t.return; d !== null; ) d.childLanes |= a, (u = d.alternate) !== null && (u.childLanes |= a), d.tag === 22 && ((t = d.stateNode) === null || 1 & t._visibility || (c = !0)), t = d, d = d.return;
    return t.tag === 3 ? (d = t.stateNode, c && o !== null && (c = 31 - vt(a), (u = (t = d.hiddenUpdates)[c]) === null ? t[c] = [o] : u.push(o), o.lane = 536870912 | a), d) : null;
  }
  function js(t) {
    if (50 < va) throw va = 0, Yi = null, Error(b(185));
    for (var o = t.return; o !== null; ) o = (t = o).return;
    return t.tag === 3 ? t.stateNode : null;
  }
  var Tu = {};
  function xg(t, o, a, u) {
    this.tag = t, this.key = a, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.refCleanup = this.ref = null, this.pendingProps = o, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = u, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function Pr(t, o, a, u) {
    return new xg(t, o, a, u);
  }
  function Hs(t) {
    return !(!(t = t.prototype) || !t.isReactComponent);
  }
  function Co(t, o) {
    var a = t.alternate;
    return a === null ? ((a = Pr(t.tag, o, t.key, t.mode)).elementType = t.elementType, a.type = t.type, a.stateNode = t.stateNode, a.alternate = t, t.alternate = a) : (a.pendingProps = o, a.type = t.type, a.flags = 0, a.subtreeFlags = 0, a.deletions = null), a.flags = 65011712 & t.flags, a.childLanes = t.childLanes, a.lanes = t.lanes, a.child = t.child, a.memoizedProps = t.memoizedProps, a.memoizedState = t.memoizedState, a.updateQueue = t.updateQueue, o = t.dependencies, a.dependencies = o === null ? null : { lanes: o.lanes, firstContext: o.firstContext }, a.sibling = t.sibling, a.index = t.index, a.ref = t.ref, a.refCleanup = t.refCleanup, a;
  }
  function on(t, o) {
    t.flags &= 65011714;
    var a = t.alternate;
    return a === null ? (t.childLanes = 0, t.lanes = o, t.child = null, t.subtreeFlags = 0, t.memoizedProps = null, t.memoizedState = null, t.updateQueue = null, t.dependencies = null, t.stateNode = null) : (t.childLanes = a.childLanes, t.lanes = a.lanes, t.child = a.child, t.subtreeFlags = 0, t.deletions = null, t.memoizedProps = a.memoizedProps, t.memoizedState = a.memoizedState, t.updateQueue = a.updateQueue, t.type = a.type, o = a.dependencies, t.dependencies = o === null ? null : { lanes: o.lanes, firstContext: o.firstContext }), t;
  }
  function he(t, o, a, u, c, d) {
    var g = 0;
    if (u = t, typeof t == "function") Hs(t) && (g = 1);
    else if (typeof t == "string") g = function(h, w, x) {
      if (x === 1 || w.itemProp != null) return !1;
      switch (h) {
        case "meta":
        case "title":
          return !0;
        case "style":
          if (typeof w.precedence != "string" || typeof w.href != "string" || w.href === "") break;
          return !0;
        case "link":
          if (typeof w.rel != "string" || typeof w.href != "string" || w.href === "" || w.onLoad || w.onError) break;
          return w.rel !== "stylesheet" || (h = w.disabled, typeof w.precedence == "string" && h == null);
        case "script":
          if (w.async && typeof w.async != "function" && typeof w.async != "symbol" && !w.onLoad && !w.onError && w.src && typeof w.src == "string") return !0;
      }
      return !1;
    }(t, a, He.current) ? 26 : t === "html" || t === "head" || t === "body" ? 27 : 5;
    else e: switch (t) {
      case Ee:
        return (t = Pr(31, a, o, c)).elementType = Ee, t.lanes = d, t;
      case K:
        return io(a.children, c, d, o);
      case ye:
        g = 8, c |= 24;
        break;
      case G:
        return (t = Pr(12, a, o, 2 | c)).elementType = G, t.lanes = d, t;
      case se:
        return (t = Pr(13, a, o, c)).elementType = se, t.lanes = d, t;
      case ke:
        return (t = Pr(19, a, o, c)).elementType = ke, t.lanes = d, t;
      default:
        if (typeof t == "object" && t !== null) switch (t.$$typeof) {
          case re:
          case ue:
            g = 10;
            break e;
          case oe:
            g = 9;
            break e;
          case pe:
            g = 11;
            break e;
          case Se:
            g = 14;
            break e;
          case Ge:
            g = 16, u = null;
            break e;
        }
        g = 29, a = Error(b(130, t === null ? "null" : typeof t, "")), u = null;
    }
    return (o = Pr(g, a, o, c)).elementType = t, o.type = u, o.lanes = d, o;
  }
  function io(t, o, a, u) {
    return (t = Pr(7, t, u, o)).lanes = a, t;
  }
  function Pu(t, o, a) {
    return (t = Pr(6, t, null, o)).lanes = a, t;
  }
  function tt(t, o, a) {
    return (o = Pr(4, t.children !== null ? t.children : [], t.key, o)).lanes = a, o.stateNode = { containerInfo: t.containerInfo, pendingChildren: null, implementation: t.implementation }, o;
  }
  var Ll = [], zl = 0, Us = null, Ru = 0, uo = [], Rr = 0, Qa = null, so = 1, ut = "";
  function Sn(t, o) {
    Ll[zl++] = Ru, Ll[zl++] = Us, Us = t, Ru = o;
  }
  function Au(t, o, a) {
    uo[Rr++] = so, uo[Rr++] = ut, uo[Rr++] = Qa, Qa = t;
    var u = so;
    t = ut;
    var c = 32 - vt(u) - 1;
    u &= ~(1 << c), a += 1;
    var d = 32 - vt(o) + c;
    if (30 < d) {
      var g = c - c % 5;
      d = (u & (1 << g) - 1).toString(32), u >>= g, c -= g, so = 1 << 32 - vt(o) + c | a << c | u, ut = d + t;
    } else so = 1 << d | a << c | u, ut = t;
  }
  function Jo(t) {
    t.return !== null && (Sn(t, 1), Au(t, 1, 0));
  }
  function Ya(t) {
    for (; t === Us; ) Us = Ll[--zl], Ll[zl] = null, Ru = Ll[--zl], Ll[zl] = null;
    for (; t === Qa; ) Qa = uo[--Rr], uo[Rr] = null, ut = uo[--Rr], uo[Rr] = null, so = uo[--Rr], uo[Rr] = null;
  }
  var Yn = null, Xn = null, bn = !1, Ga = null, Ar = !1, Bs = Error(b(519));
  function ea(t) {
    throw ki(Br(Error(b(418, "")), t)), Bs;
  }
  function um(t) {
    var o = t.stateNode, a = t.type, u = t.memoizedProps;
    switch (o[Ut] = t, o[pr] = u, a) {
      case "dialog":
        an("cancel", o), an("close", o);
        break;
      case "iframe":
      case "object":
      case "embed":
        an("load", o);
        break;
      case "video":
      case "audio":
        for (a = 0; a < Ea.length; a++) an(Ea[a], o);
        break;
      case "source":
        an("error", o);
        break;
      case "img":
      case "image":
      case "link":
        an("error", o), an("load", o);
        break;
      case "details":
        an("toggle", o);
        break;
      case "input":
        an("invalid", o), Vp(o, u.value, u.defaultValue, u.checked, u.defaultChecked, u.type, u.name, !0), mu(o);
        break;
      case "select":
        an("invalid", o);
        break;
      case "textarea":
        an("invalid", o), Es(o, u.value, u.defaultValue, u.children), mu(o);
    }
    typeof (a = u.children) != "string" && typeof a != "number" && typeof a != "bigint" || o.textContent === "" + a || u.suppressHydrationWarning === !0 || It(o.textContent, a) ? (u.popover != null && (an("beforetoggle", o), an("toggle", o)), u.onScroll != null && an("scroll", o), u.onScrollEnd != null && an("scrollend", o), u.onClick != null && (o.onclick = J), o = !0) : o = !1, o || ea(t);
  }
  function sm(t) {
    for (Yn = t.return; Yn; ) switch (Yn.tag) {
      case 5:
      case 13:
        return void (Ar = !1);
      case 27:
      case 3:
        return void (Ar = !0);
      default:
        Yn = Yn.return;
    }
  }
  function Nu(t) {
    if (t !== Yn) return !1;
    if (!bn) return sm(t), bn = !0, !1;
    var o, a = t.tag;
    if ((o = a !== 3 && a !== 27) && ((o = a === 5) && (o = !((o = t.type) !== "form" && o !== "button") || Ju(t.type, t.memoizedProps)), o = !o), o && Xn && ea(t), sm(t), a === 13) {
      if (!(t = (t = t.memoizedState) !== null ? t.dehydrated : null)) throw Error(b(317));
      e: {
        for (t = t.nextSibling, a = 0; t; ) {
          if (t.nodeType === 8) if ((o = t.data) === "/$") {
            if (a === 0) {
              Xn = Do(t.nextSibling);
              break e;
            }
            a--;
          } else o !== "$" && o !== "$!" && o !== "$?" || a++;
          t = t.nextSibling;
        }
        Xn = null;
      }
    } else a === 27 ? (a = Xn, Ql(t.type) ? (t = Nc, Nc = null, Xn = t) : Xn = a) : Xn = Yn ? Do(t.stateNode.nextSibling) : null;
    return !0;
  }
  function _u() {
    Xn = Yn = null, bn = !1;
  }
  function cm() {
    var t = Ga;
    return t !== null && (br === null ? br = t : br.push.apply(br, t), Ga = null), t;
  }
  function ki(t) {
    Ga === null ? Ga = [t] : Ga.push(t);
  }
  var Vs = me(null), Ka = null, na = null;
  function Xa(t, o, a) {
    Te(Vs, o._currentValue), o._currentValue = a;
  }
  function ta(t) {
    t._currentValue = Vs.current, ce(Vs);
  }
  function dm(t, o, a) {
    for (; t !== null; ) {
      var u = t.alternate;
      if ((t.childLanes & o) !== o ? (t.childLanes |= o, u !== null && (u.childLanes |= o)) : u !== null && (u.childLanes & o) !== o && (u.childLanes |= o), t === a) break;
      t = t.return;
    }
  }
  function jd(t, o, a, u) {
    var c = t.child;
    for (c !== null && (c.return = t); c !== null; ) {
      var d = c.dependencies;
      if (d !== null) {
        var g = c.child;
        d = d.firstContext;
        e: for (; d !== null; ) {
          var h = d;
          d = c;
          for (var w = 0; w < o.length; w++) if (h.context === o[w]) {
            d.lanes |= a, (h = d.alternate) !== null && (h.lanes |= a), dm(d.return, a, t), u || (g = null);
            break e;
          }
          d = h.next;
        }
      } else if (c.tag === 18) {
        if ((g = c.return) === null) throw Error(b(341));
        g.lanes |= a, (d = g.alternate) !== null && (d.lanes |= a), dm(g, a, t), g = null;
      } else g = c.child;
      if (g !== null) g.return = c;
      else for (g = c; g !== null; ) {
        if (g === t) {
          g = null;
          break;
        }
        if ((c = g.sibling) !== null) {
          c.return = g.return, g = c;
          break;
        }
        g = g.return;
      }
      c = g;
    }
  }
  function Ou(t, o, a, u) {
    t = null;
    for (var c = o, d = !1; c !== null; ) {
      if (!d) {
        if (524288 & c.flags) d = !0;
        else if (262144 & c.flags) break;
      }
      if (c.tag === 10) {
        var g = c.alternate;
        if (g === null) throw Error(b(387));
        if ((g = g.memoizedProps) !== null) {
          var h = c.type;
          mt(c.pendingProps.value, g.value) || (t !== null ? t.push(h) : t = [h]);
        }
      } else if (c === Be.current) {
        if ((g = c.alternate) === null) throw Error(b(387));
        g.memoizedState.memoizedState !== c.memoizedState.memoizedState && (t !== null ? t.push(Dc) : t = [Dc]);
      }
      c = c.return;
    }
    t !== null && jd(o, t, a, u), o.flags |= 262144;
  }
  function Ws(t) {
    for (t = t.firstContext; t !== null; ) {
      if (!mt(t.context._currentValue, t.memoizedValue)) return !0;
      t = t.next;
    }
    return !1;
  }
  function $a(t) {
    Ka = t, na = null, (t = t.dependencies) !== null && (t.firstContext = null);
  }
  function Bt(t) {
    return wi(Ka, t);
  }
  function qs(t, o) {
    return Ka === null && $a(t), wi(t, o);
  }
  function wi(t, o) {
    var a = o._currentValue;
    if (o = { context: o, memoizedValue: a, next: null }, na === null) {
      if (t === null) throw Error(b(308));
      na = o, t.dependencies = { lanes: 0, firstContext: o }, t.flags |= 524288;
    } else na = na.next = o;
    return a;
  }
  var Hd = typeof AbortController < "u" ? AbortController : function() {
    var t = [], o = this.signal = { aborted: !1, addEventListener: function(a, u) {
      t.push(u);
    } };
    this.abort = function() {
      o.aborted = !0, t.forEach(function(a) {
        return a();
      });
    };
  }, Cg = m.unstable_scheduleCallback, tb = m.unstable_NormalPriority, st = { $$typeof: ue, Consumer: null, Provider: null, _currentValue: null, _currentValue2: null, _threadCount: 0 };
  function Dl() {
    return { controller: new Hd(), data: /* @__PURE__ */ new Map(), refCount: 0 };
  }
  function Si(t) {
    t.refCount--, t.refCount === 0 && Cg(tb, function() {
      t.controller.abort();
    });
  }
  var To = null, er = 0, ra = 0, Za = null;
  function fm() {
    if (--er === 0 && To !== null) {
      Za !== null && (Za.status = "fulfilled");
      var t = To;
      To = null, ra = 0, Za = null;
      for (var o = 0; o < t.length; o++) (0, t[o])();
    }
  }
  var Ud = Ae.S;
  Ae.S = function(t, o) {
    typeof o == "object" && o !== null && typeof o.then == "function" && function(a, u) {
      if (To === null) {
        var c = To = [];
        er = 0, ra = Cc(), Za = { status: "pending", value: void 0, then: function(d) {
          c.push(d);
        } };
      }
      er++, u.then(fm, fm);
    }(0, o), Ud !== null && Ud(t, o);
  };
  var Ja = me(null);
  function Qs() {
    var t = Ja.current;
    return t !== null ? t : Qn.pooledCache;
  }
  function Ei(t, o) {
    Te(Ja, o === null ? Ja.current : o.pool);
  }
  function Bd() {
    var t = Qs();
    return t === null ? null : { parent: st._currentValue, pool: t };
  }
  var Fl = Error(b(460)), Vd = Error(b(474)), Ys = Error(b(542)), Wd = { then: function() {
  } };
  function qd(t) {
    return (t = t.status) === "fulfilled" || t === "rejected";
  }
  function Gs() {
  }
  function pm(t, o, a) {
    switch ((a = t[a]) === void 0 ? t.push(o) : a !== o && (o.then(Gs, Gs), o = a), o.status) {
      case "fulfilled":
        return o.value;
      case "rejected":
        throw hm(t = o.reason), t;
      default:
        if (typeof o.status == "string") o.then(Gs, Gs);
        else {
          if ((t = Qn) !== null && 100 < t.shellSuspendCounter) throw Error(b(482));
          (t = o).status = "pending", t.then(function(u) {
            if (o.status === "pending") {
              var c = o;
              c.status = "fulfilled", c.value = u;
            }
          }, function(u) {
            if (o.status === "pending") {
              var c = o;
              c.status = "rejected", c.reason = u;
            }
          });
        }
        switch (o.status) {
          case "fulfilled":
            return o.value;
          case "rejected":
            throw hm(t = o.reason), t;
        }
        throw xi = o, Fl;
    }
  }
  var xi = null;
  function mm() {
    if (xi === null) throw Error(b(459));
    var t = xi;
    return xi = null, t;
  }
  function hm(t) {
    if (t === Fl || t === Ys) throw Error(b(483));
  }
  var oa = !1;
  function Qd(t) {
    t.updateQueue = { baseState: t.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null, lanes: 0, hiddenCallbacks: null }, callbacks: null };
  }
  function Yd(t, o) {
    t = t.updateQueue, o.updateQueue === t && (o.updateQueue = { baseState: t.baseState, firstBaseUpdate: t.firstBaseUpdate, lastBaseUpdate: t.lastBaseUpdate, shared: t.shared, callbacks: null });
  }
  function Nr(t) {
    return { lane: t, tag: 0, payload: null, callback: null, next: null };
  }
  function aa(t, o, a) {
    var u = t.updateQueue;
    if (u === null) return null;
    if (u = u.shared, 2 & Rn) {
      var c = u.pending;
      return c === null ? o.next = o : (o.next = c.next, c.next = o), u.pending = o, o = js(t), Cu(t, null, a), o;
    }
    return Ol(t, u, o, a), js(t);
  }
  function Ci(t, o, a) {
    if ((o = o.updateQueue) !== null && (o = o.shared, 4194048 & a)) {
      var u = o.lanes;
      a |= u &= t.pendingLanes, o.lanes = a, Ct(t, a);
    }
  }
  function gm(t, o) {
    var a = t.updateQueue, u = t.alternate;
    if (u !== null && a === (u = u.updateQueue)) {
      var c = null, d = null;
      if ((a = a.firstBaseUpdate) !== null) {
        do {
          var g = { lane: a.lane, tag: a.tag, payload: a.payload, callback: null, next: null };
          d === null ? c = d = g : d = d.next = g, a = a.next;
        } while (a !== null);
        d === null ? c = d = o : d = d.next = o;
      } else c = d = o;
      return a = { baseState: u.baseState, firstBaseUpdate: c, lastBaseUpdate: d, shared: u.shared, callbacks: u.callbacks }, void (t.updateQueue = a);
    }
    (t = a.lastBaseUpdate) === null ? a.firstBaseUpdate = o : t.next = o, a.lastBaseUpdate = o;
  }
  var ym = !1;
  function Lu() {
    if (ym && Za !== null)
      throw Za;
  }
  function el(t, o, a, u) {
    ym = !1;
    var c = t.updateQueue;
    oa = !1;
    var d = c.firstBaseUpdate, g = c.lastBaseUpdate, h = c.shared.pending;
    if (h !== null) {
      c.shared.pending = null;
      var w = h, x = w.next;
      w.next = null, g === null ? d = x : g.next = x, g = w;
      var B = t.alternate;
      B !== null && (h = (B = B.updateQueue).lastBaseUpdate) !== g && (h === null ? B.firstBaseUpdate = x : h.next = x, B.lastBaseUpdate = w);
    }
    if (d !== null) {
      var q = c.baseState;
      for (g = 0, B = x = w = null, h = d; ; ) {
        var ee = -536870913 & h.lane, le = ee !== h.lane;
        if (le ? (xn & ee) === ee : (u & ee) === ee) {
          ee !== 0 && ee === ra && (ym = !0), B !== null && (B = B.next = { lane: 0, tag: h.tag, payload: h.payload, callback: null, next: null });
          e: {
            var de = t, I = h;
            ee = o;
            var _ = a;
            switch (I.tag) {
              case 1:
                if (typeof (de = I.payload) == "function") {
                  q = de.call(_, q, ee);
                  break e;
                }
                q = de;
                break e;
              case 3:
                de.flags = -65537 & de.flags | 128;
              case 0:
                if ((ee = typeof (de = I.payload) == "function" ? de.call(_, q, ee) : de) == null) break e;
                q = L({}, q, ee);
                break e;
              case 2:
                oa = !0;
            }
          }
          (ee = h.callback) !== null && (t.flags |= 64, le && (t.flags |= 8192), (le = c.callbacks) === null ? c.callbacks = [ee] : le.push(ee));
        } else le = { lane: ee, tag: h.tag, payload: h.payload, callback: h.callback, next: null }, B === null ? (x = B = le, w = q) : B = B.next = le, g |= ee;
        if ((h = h.next) === null) {
          if ((h = c.shared.pending) === null) break;
          h = (le = h).next, le.next = null, c.lastBaseUpdate = le, c.shared.pending = null;
        }
      }
      B === null && (w = q), c.baseState = w, c.firstBaseUpdate = x, c.lastBaseUpdate = B, d === null && (c.shared.lanes = 0), Hl |= g, t.lanes = g, t.memoizedState = q;
    }
  }
  function Gd(t, o) {
    if (typeof t != "function") throw Error(b(191, t));
    t.call(o);
  }
  function Ks(t, o) {
    var a = t.callbacks;
    if (a !== null) for (t.callbacks = null, t = 0; t < a.length; t++) Gd(a[t], o);
  }
  var Ti = me(null), Xs = me(0);
  function Ot(t, o) {
    Te(Xs, t = ya), Te(Ti, o), ya = t | o.baseLanes;
  }
  function zu() {
    Te(Xs, ya), Te(Ti, Ti.current);
  }
  function Du() {
    ya = Xs.current, ce(Ti), ce(Xs);
  }
  var co = 0, Je = null, In = null, rt = null, $s = !1, Vr = !1, Il = !1, Po = 0, Wr = 0, nl = null, bm = 0;
  function ot() {
    throw Error(b(321));
  }
  function Kd(t, o) {
    if (o === null) return !1;
    for (var a = 0; a < o.length && a < t.length; a++) if (!mt(t[a], o[a])) return !1;
    return !0;
  }
  function Xd(t, o, a, u, c, d) {
    return co = d, Je = o, o.memoizedState = null, o.updateQueue = null, o.lanes = 0, Ae.H = t === null || t.memoizedState === null ? zm : sa, Il = !1, d = a(u, c), Il = !1, Vr && (d = vm(o, a, u, c)), Ml(t), d;
  }
  function Ml(t) {
    Ae.H = ac;
    var o = In !== null && In.next !== null;
    if (co = 0, rt = In = Je = null, $s = !1, Wr = 0, nl = null, o) throw Error(b(300));
    t === null || Lt || (t = t.dependencies) !== null && Ws(t) && (Lt = !0);
  }
  function vm(t, o, a, u) {
    Je = t;
    var c = 0;
    do {
      if (Vr && (nl = null), Wr = 0, Vr = !1, 25 <= c) throw Error(b(301));
      if (c += 1, rt = In = null, t.updateQueue != null) {
        var d = t.updateQueue;
        d.lastEffect = null, d.events = null, d.stores = null, d.memoCache != null && (d.memoCache.index = 0);
      }
      Ae.H = Dg, d = o(a, u);
    } while (Vr);
    return d;
  }
  function Tg() {
    var t = Ae.H, o = t.useState()[0];
    return o = typeof o.then == "function" ? Pi(o) : o, t = t.useState()[0], (In !== null ? In.memoizedState : null) !== t && (Je.flags |= 1024), o;
  }
  function $d() {
    var t = Po !== 0;
    return Po = 0, t;
  }
  function Fu(t, o, a) {
    o.updateQueue = t.updateQueue, o.flags &= -2053, t.lanes &= ~a;
  }
  function Zd(t) {
    if ($s) {
      for (t = t.memoizedState; t !== null; ) {
        var o = t.queue;
        o !== null && (o.pending = null), t = t.next;
      }
      $s = !1;
    }
    co = 0, rt = In = Je = null, Vr = !1, Wr = Po = 0, nl = null;
  }
  function nr() {
    var t = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
    return rt === null ? Je.memoizedState = rt = t : rt = rt.next = t, rt;
  }
  function ct() {
    if (In === null) {
      var t = Je.alternate;
      t = t !== null ? t.memoizedState : null;
    } else t = In.next;
    var o = rt === null ? Je.memoizedState : rt.next;
    if (o !== null) rt = o, In = t;
    else {
      if (t === null)
        throw Je.alternate === null ? Error(b(467)) : Error(b(310));
      t = { memoizedState: (In = t).memoizedState, baseState: In.baseState, baseQueue: In.baseQueue, queue: In.queue, next: null }, rt === null ? Je.memoizedState = rt = t : rt = rt.next = t;
    }
    return rt;
  }
  function Pi(t) {
    var o = Wr;
    return Wr += 1, nl === null && (nl = []), t = pm(nl, t, o), o = Je, (rt === null ? o.memoizedState : rt.next) === null && (o = o.alternate, Ae.H = o === null || o.memoizedState === null ? zm : sa), t;
  }
  function wt(t) {
    if (t !== null && typeof t == "object") {
      if (typeof t.then == "function") return Pi(t);
      if (t.$$typeof === ue) return Bt(t);
    }
    throw Error(b(438, String(t)));
  }
  function Jd(t) {
    var o = null, a = Je.updateQueue;
    if (a !== null && (o = a.memoCache), o == null) {
      var u = Je.alternate;
      u !== null && (u = u.updateQueue) !== null && (u = u.memoCache) != null && (o = { data: u.data.map(function(c) {
        return c.slice();
      }), index: 0 });
    }
    if (o == null && (o = { data: [], index: 0 }), a === null && (a = { lastEffect: null, events: null, stores: null, memoCache: null }, Je.updateQueue = a), a.memoCache = o, (a = o.data[o.index]) === void 0) for (a = o.data[o.index] = Array(t), u = 0; u < t; u++) a[u] = Me;
    return o.index++, a;
  }
  function la(t, o) {
    return typeof o == "function" ? o(t) : o;
  }
  function Zs(t) {
    return ef(ct(), In, t);
  }
  function ef(t, o, a) {
    var u = t.queue;
    if (u === null) throw Error(b(311));
    u.lastRenderedReducer = a;
    var c = t.baseQueue, d = u.pending;
    if (d !== null) {
      if (c !== null) {
        var g = c.next;
        c.next = d.next, d.next = g;
      }
      o.baseQueue = c = d, u.pending = null;
    }
    if (d = t.baseState, c === null) t.memoizedState = d;
    else {
      var h = g = null, w = null, x = o = c.next, B = !1;
      do {
        var q = -536870913 & x.lane;
        if (q !== x.lane ? (xn & q) === q : (co & q) === q) {
          var ee = x.revertLane;
          if (ee === 0) w !== null && (w = w.next = { lane: 0, revertLane: 0, action: x.action, hasEagerState: x.hasEagerState, eagerState: x.eagerState, next: null }), q === ra && (B = !0);
          else {
            if ((co & ee) === ee) {
              x = x.next, ee === ra && (B = !0);
              continue;
            }
            q = { lane: 0, revertLane: x.revertLane, action: x.action, hasEagerState: x.hasEagerState, eagerState: x.eagerState, next: null }, w === null ? (h = w = q, g = d) : w = w.next = q, Je.lanes |= ee, Hl |= ee;
          }
          q = x.action, Il && a(d, q), d = x.hasEagerState ? x.eagerState : a(d, q);
        } else ee = { lane: q, revertLane: x.revertLane, action: x.action, hasEagerState: x.hasEagerState, eagerState: x.eagerState, next: null }, w === null ? (h = w = ee, g = d) : w = w.next = ee, Je.lanes |= q, Hl |= q;
        x = x.next;
      } while (x !== null && x !== o);
      if (w === null ? g = d : w.next = h, !mt(d, t.memoizedState) && (Lt = !0, B && (a = Za) !== null)) throw a;
      t.memoizedState = d, t.baseState = g, t.baseQueue = w, u.lastRenderedState = d;
    }
    return c === null && (u.lanes = 0), [t.memoizedState, u.dispatch];
  }
  function nf(t) {
    var o = ct(), a = o.queue;
    if (a === null) throw Error(b(311));
    a.lastRenderedReducer = t;
    var u = a.dispatch, c = a.pending, d = o.memoizedState;
    if (c !== null) {
      a.pending = null;
      var g = c = c.next;
      do
        d = t(d, g.action), g = g.next;
      while (g !== c);
      mt(d, o.memoizedState) || (Lt = !0), o.memoizedState = d, o.baseQueue === null && (o.baseState = d), a.lastRenderedState = d;
    }
    return [d, u];
  }
  function Js(t, o, a) {
    var u = Je, c = ct(), d = bn;
    if (d) {
      if (a === void 0) throw Error(b(407));
      a = a();
    } else a = o();
    var g = !mt((In || c).memoizedState, a);
    if (g && (c.memoizedState = a, Lt = !0), c = c.queue, Un(2048, 8, wm.bind(null, u, c, t), [t]), c.getSnapshot !== o || g || rt !== null && 1 & rt.memoizedState.tag) {
      if (u.flags |= 2048, Ri(9, { destroy: void 0, resource: void 0 }, km.bind(null, u, c, a, o), null), Qn === null) throw Error(b(349));
      d || 124 & co || tf(u, o, a);
    }
    return a;
  }
  function tf(t, o, a) {
    t.flags |= 16384, t = { getSnapshot: o, value: a }, (o = Je.updateQueue) === null ? (o = { lastEffect: null, events: null, stores: null, memoCache: null }, Je.updateQueue = o, o.stores = [t]) : (a = o.stores) === null ? o.stores = [t] : a.push(t);
  }
  function km(t, o, a, u) {
    o.value = a, o.getSnapshot = u, Sm(o) && rf(t);
  }
  function wm(t, o, a) {
    return a(function() {
      Sm(o) && rf(t);
    });
  }
  function Sm(t) {
    var o = t.getSnapshot;
    t = t.value;
    try {
      var a = o();
      return !mt(t, a);
    } catch {
      return !0;
    }
  }
  function rf(t) {
    var o = Zo(t, 2);
    o !== null && qt(o, t, 2);
  }
  function ec(t) {
    var o = nr();
    if (typeof t == "function") {
      var a = t;
      if (t = a(), Il) {
        Er(!0);
        try {
          a();
        } finally {
          Er(!1);
        }
      }
    }
    return o.memoizedState = o.baseState = t, o.queue = { pending: null, lanes: 0, dispatch: null, lastRenderedReducer: la, lastRenderedState: t }, o;
  }
  function of(t, o, a, u) {
    return t.baseState = a, ef(t, In, typeof u == "function" ? u : la);
  }
  function Pg(t, o, a, u, c) {
    if (Oi(t)) throw Error(b(485));
    if ((t = o.action) !== null) {
      var d = { payload: c, action: t, next: null, isTransition: !0, status: "pending", value: null, reason: null, listeners: [], then: function(g) {
        d.listeners.push(g);
      } };
      Ae.T !== null ? a(!0) : d.isTransition = !1, u(d), (a = o.pending) === null ? (d.next = o.pending = d, af(o, d)) : (d.next = a.next, o.pending = a.next = d);
    }
  }
  function af(t, o) {
    var a = o.action, u = o.payload, c = t.state;
    if (o.isTransition) {
      var d = Ae.T, g = {};
      Ae.T = g;
      try {
        var h = a(c, u), w = Ae.S;
        w !== null && w(g, h), nc(t, o, h);
      } catch (x) {
        uf(t, o, x);
      } finally {
        Ae.T = d;
      }
    } else try {
      nc(t, o, d = a(c, u));
    } catch (x) {
      uf(t, o, x);
    }
  }
  function nc(t, o, a) {
    a !== null && typeof a == "object" && typeof a.then == "function" ? a.then(function(u) {
      lf(t, o, u);
    }, function(u) {
      return uf(t, o, u);
    }) : lf(t, o, a);
  }
  function lf(t, o, a) {
    o.status = "fulfilled", o.value = a, Em(o), t.state = a, (o = t.pending) !== null && ((a = o.next) === o ? t.pending = null : (a = a.next, o.next = a, af(t, a)));
  }
  function uf(t, o, a) {
    var u = t.pending;
    if (t.pending = null, u !== null) {
      u = u.next;
      do
        o.status = "rejected", o.reason = a, Em(o), o = o.next;
      while (o !== u);
    }
    t.action = null;
  }
  function Em(t) {
    t = t.listeners;
    for (var o = 0; o < t.length; o++) (0, t[o])();
  }
  function sf(t, o) {
    return o;
  }
  function xm(t, o) {
    if (bn) {
      var a = Qn.formState;
      if (a !== null) {
        e: {
          var u = Je;
          if (bn) {
            if (Xn) {
              n: {
                for (var c = Xn, d = Ar; c.nodeType !== 8; ) {
                  if (!d) {
                    c = null;
                    break n;
                  }
                  if ((c = Do(c.nextSibling)) === null) {
                    c = null;
                    break n;
                  }
                }
                c = (d = c.data) === "F!" || d === "F" ? c : null;
              }
              if (c) {
                Xn = Do(c.nextSibling), u = c.data === "F!";
                break e;
              }
            }
            ea(u);
          }
          u = !1;
        }
        u && (o = a[0]);
      }
    }
    return (a = nr()).memoizedState = a.baseState = o, u = { pending: null, lanes: 0, dispatch: null, lastRenderedReducer: sf, lastRenderedState: o }, a.queue = u, a = Om.bind(null, Je, u), u.dispatch = a, u = ec(!1), d = oc.bind(null, Je, !1, u.queue), c = { state: o, dispatch: null, action: t, pending: null }, (u = nr()).queue = c, a = Pg.bind(null, Je, c, d, a), c.dispatch = a, u.memoizedState = t, [o, a, !1];
  }
  function ia(t) {
    return cf(ct(), In, t);
  }
  function cf(t, o, a) {
    if (o = ef(t, o, sf)[0], t = Zs(la)[0], typeof o == "object" && o !== null && typeof o.then == "function") try {
      var u = Pi(o);
    } catch (g) {
      throw g === Fl ? Ys : g;
    }
    else u = o;
    var c = (o = ct()).queue, d = c.dispatch;
    return a !== o.memoizedState && (Je.flags |= 2048, Ri(9, { destroy: void 0, resource: void 0 }, Cm.bind(null, c, a), null)), [u, d, t];
  }
  function Cm(t, o) {
    t.action = o;
  }
  function ua(t) {
    var o = ct(), a = In;
    if (a !== null) return cf(o, a, t);
    ct(), o = o.memoizedState;
    var u = (a = ct()).queue.dispatch;
    return a.memoizedState = t, [o, u, !1];
  }
  function Ri(t, o, a, u) {
    return t = { tag: t, create: a, deps: u, inst: o, next: null }, (o = Je.updateQueue) === null && (o = { lastEffect: null, events: null, stores: null, memoCache: null }, Je.updateQueue = o), (a = o.lastEffect) === null ? o.lastEffect = t.next = t : (u = a.next, a.next = t, t.next = u, o.lastEffect = t), t;
  }
  function tc() {
    return ct().memoizedState;
  }
  function jl(t, o, a, u) {
    var c = nr();
    u = u === void 0 ? null : u, Je.flags |= t, c.memoizedState = Ri(1 | o, { destroy: void 0, resource: void 0 }, a, u);
  }
  function Un(t, o, a, u) {
    var c = ct();
    u = u === void 0 ? null : u;
    var d = c.memoizedState.inst;
    In !== null && u !== null && Kd(u, In.memoizedState.deps) ? c.memoizedState = Ri(o, d, a, u) : (Je.flags |= t, c.memoizedState = Ri(1 | o, d, a, u));
  }
  function Rg(t, o) {
    jl(8390656, 8, t, o);
  }
  function Ag(t, o) {
    Un(2048, 8, t, o);
  }
  function Tm(t, o) {
    return Un(4, 2, t, o);
  }
  function Ro(t, o) {
    return Un(4, 4, t, o);
  }
  function Pm(t, o) {
    if (typeof o == "function") {
      t = t();
      var a = o(t);
      return function() {
        typeof a == "function" ? a() : o(null);
      };
    }
    if (o != null) return t = t(), o.current = t, function() {
      o.current = null;
    };
  }
  function df(t, o, a) {
    a = a != null ? a.concat([t]) : null, Un(4, 4, Pm.bind(null, o, t), a);
  }
  function Ai() {
  }
  function Ni(t, o) {
    var a = ct();
    o = o === void 0 ? null : o;
    var u = a.memoizedState;
    return o !== null && Kd(o, u[1]) ? u[0] : (a.memoizedState = [t, o], t);
  }
  function Rm(t, o) {
    var a = ct();
    o = o === void 0 ? null : o;
    var u = a.memoizedState;
    if (o !== null && Kd(o, u[1])) return u[0];
    if (u = t(), Il) {
      Er(!0);
      try {
        t();
      } finally {
        Er(!1);
      }
    }
    return a.memoizedState = [u, o], u;
  }
  function rc(t, o, a) {
    return a === void 0 || 1073741824 & co ? t.memoizedState = o : (t.memoizedState = a, t = Gi(), Je.lanes |= t, Hl |= t, a);
  }
  function Am(t, o, a, u) {
    return mt(a, o) ? a : Ti.current !== null ? (t = rc(t, a, u), mt(t, o) || (Lt = !0), t) : 42 & co ? (t = Gi(), Je.lanes |= t, Hl |= t, o) : (Lt = !0, t.memoizedState = a);
  }
  function Ng(t, o, a, u, c) {
    var d = S.p;
    S.p = d !== 0 && 8 > d ? d : 8;
    var g, h, w, x = Ae.T, B = {};
    Ae.T = B, oc(t, !1, o, a);
    try {
      var q = c(), ee = Ae.S;
      if (ee !== null && ee(B, q), q !== null && typeof q == "object" && typeof q.then == "function") {
        var le = (g = u, h = [], w = { status: "pending", value: null, reason: null, then: function(de) {
          h.push(de);
        } }, q.then(function() {
          w.status = "fulfilled", w.value = g;
          for (var de = 0; de < h.length; de++) (0, h[de])(g);
        }, function(de) {
          for (w.status = "rejected", w.reason = de, de = 0; de < h.length; de++) (0, h[de])(void 0);
        }), w);
        _i(t, o, le, Lr());
      } else _i(t, o, u, Lr());
    } catch (de) {
      _i(t, o, { then: function() {
      }, status: "rejected", reason: de }, Lr());
    } finally {
      S.p = d, Ae.T = x;
    }
  }
  function rb() {
  }
  function ff(t, o, a, u) {
    if (t.tag !== 5) throw Error(b(476));
    var c = _g(t).queue;
    Ng(t, c, o, N, a === null ? rb : function() {
      return Iu(t), a(u);
    });
  }
  function _g(t) {
    var o = t.memoizedState;
    if (o !== null) return o;
    var a = {};
    return (o = { memoizedState: N, baseState: N, baseQueue: null, queue: { pending: null, lanes: 0, dispatch: null, lastRenderedReducer: la, lastRenderedState: N }, next: null }).next = { memoizedState: a, baseState: a, baseQueue: null, queue: { pending: null, lanes: 0, dispatch: null, lastRenderedReducer: la, lastRenderedState: a }, next: null }, t.memoizedState = o, (t = t.alternate) !== null && (t.memoizedState = o), o;
  }
  function Iu(t) {
    _i(t, _g(t).next.queue, {}, Lr());
  }
  function fo() {
    return Bt(Dc);
  }
  function Nm() {
    return ct().memoizedState;
  }
  function Og() {
    return ct().memoizedState;
  }
  function Lg(t) {
    for (var o = t.return; o !== null; ) {
      switch (o.tag) {
        case 24:
        case 3:
          var a = Lr(), u = aa(o, t = Nr(a), a);
          return u !== null && (qt(u, o, a), Ci(u, o, a)), o = { cache: Dl() }, void (t.payload = o);
      }
      o = o.return;
    }
  }
  function _m(t, o, a) {
    var u = Lr();
    a = { lane: u, revertLane: 0, action: a, hasEagerState: !1, eagerState: null, next: null }, Oi(t) ? zg(o, a) : (a = xu(t, o, a, u)) !== null && (qt(a, t, u), Lm(a, o, u));
  }
  function Om(t, o, a) {
    _i(t, o, a, Lr());
  }
  function _i(t, o, a, u) {
    var c = { lane: u, revertLane: 0, action: a, hasEagerState: !1, eagerState: null, next: null };
    if (Oi(t)) zg(o, c);
    else {
      var d = t.alternate;
      if (t.lanes === 0 && (d === null || d.lanes === 0) && (d = o.lastRenderedReducer) !== null) try {
        var g = o.lastRenderedState, h = d(g, a);
        if (c.hasEagerState = !0, c.eagerState = h, mt(h, g)) return Ol(t, o, c, 0), Qn === null && xo(), !1;
      } catch {
      }
      if ((a = xu(t, o, c, u)) !== null) return qt(a, t, u), Lm(a, o, u), !0;
    }
    return !1;
  }
  function oc(t, o, a, u) {
    if (u = { lane: 2, revertLane: Cc(), action: u, hasEagerState: !1, eagerState: null, next: null }, Oi(t)) {
      if (o) throw Error(b(479));
    } else (o = xu(t, a, u, 2)) !== null && qt(o, t, 2);
  }
  function Oi(t) {
    var o = t.alternate;
    return t === Je || o !== null && o === Je;
  }
  function zg(t, o) {
    Vr = $s = !0;
    var a = t.pending;
    a === null ? o.next = o : (o.next = a.next, a.next = o), t.pending = o;
  }
  function Lm(t, o, a) {
    if (4194048 & a) {
      var u = o.lanes;
      a |= u &= t.pendingLanes, o.lanes = a, Ct(t, a);
    }
  }
  var ac = { readContext: Bt, use: wt, useCallback: ot, useContext: ot, useEffect: ot, useImperativeHandle: ot, useLayoutEffect: ot, useInsertionEffect: ot, useMemo: ot, useReducer: ot, useRef: ot, useState: ot, useDebugValue: ot, useDeferredValue: ot, useTransition: ot, useSyncExternalStore: ot, useId: ot, useHostTransitionStatus: ot, useFormState: ot, useActionState: ot, useOptimistic: ot, useMemoCache: ot, useCacheRefresh: ot }, zm = { readContext: Bt, use: wt, useCallback: function(t, o) {
    return nr().memoizedState = [t, o === void 0 ? null : o], t;
  }, useContext: Bt, useEffect: Rg, useImperativeHandle: function(t, o, a) {
    a = a != null ? a.concat([t]) : null, jl(4194308, 4, Pm.bind(null, o, t), a);
  }, useLayoutEffect: function(t, o) {
    return jl(4194308, 4, t, o);
  }, useInsertionEffect: function(t, o) {
    jl(4, 2, t, o);
  }, useMemo: function(t, o) {
    var a = nr();
    o = o === void 0 ? null : o;
    var u = t();
    if (Il) {
      Er(!0);
      try {
        t();
      } finally {
        Er(!1);
      }
    }
    return a.memoizedState = [u, o], u;
  }, useReducer: function(t, o, a) {
    var u = nr();
    if (a !== void 0) {
      var c = a(o);
      if (Il) {
        Er(!0);
        try {
          a(o);
        } finally {
          Er(!1);
        }
      }
    } else c = o;
    return u.memoizedState = u.baseState = c, t = { pending: null, lanes: 0, dispatch: null, lastRenderedReducer: t, lastRenderedState: c }, u.queue = t, t = t.dispatch = _m.bind(null, Je, t), [u.memoizedState, t];
  }, useRef: function(t) {
    return t = { current: t }, nr().memoizedState = t;
  }, useState: function(t) {
    var o = (t = ec(t)).queue, a = Om.bind(null, Je, o);
    return o.dispatch = a, [t.memoizedState, a];
  }, useDebugValue: Ai, useDeferredValue: function(t, o) {
    return rc(nr(), t, o);
  }, useTransition: function() {
    var t = ec(!1);
    return t = Ng.bind(null, Je, t.queue, !0, !1), nr().memoizedState = t, [!1, t];
  }, useSyncExternalStore: function(t, o, a) {
    var u = Je, c = nr();
    if (bn) {
      if (a === void 0) throw Error(b(407));
      a = a();
    } else {
      if (a = o(), Qn === null) throw Error(b(349));
      124 & xn || tf(u, o, a);
    }
    c.memoizedState = a;
    var d = { value: a, getSnapshot: o };
    return c.queue = d, Rg(wm.bind(null, u, d, t), [t]), u.flags |= 2048, Ri(9, { destroy: void 0, resource: void 0 }, km.bind(null, u, d, a, o), null), a;
  }, useId: function() {
    var t = nr(), o = Qn.identifierPrefix;
    if (bn) {
      var a = ut;
      o = "«" + o + "R" + (a = (so & ~(1 << 32 - vt(so) - 1)).toString(32) + a), 0 < (a = Po++) && (o += "H" + a.toString(32)), o += "»";
    } else o = "«" + o + "r" + (a = bm++).toString(32) + "»";
    return t.memoizedState = o;
  }, useHostTransitionStatus: fo, useFormState: xm, useActionState: xm, useOptimistic: function(t) {
    var o = nr();
    o.memoizedState = o.baseState = t;
    var a = { pending: null, lanes: 0, dispatch: null, lastRenderedReducer: null, lastRenderedState: null };
    return o.queue = a, o = oc.bind(null, Je, !0, a), a.dispatch = o, [t, o];
  }, useMemoCache: Jd, useCacheRefresh: function() {
    return nr().memoizedState = Lg.bind(null, Je);
  } }, sa = { readContext: Bt, use: wt, useCallback: Ni, useContext: Bt, useEffect: Ag, useImperativeHandle: df, useInsertionEffect: Tm, useLayoutEffect: Ro, useMemo: Rm, useReducer: Zs, useRef: tc, useState: function() {
    return Zs(la);
  }, useDebugValue: Ai, useDeferredValue: function(t, o) {
    return Am(ct(), In.memoizedState, t, o);
  }, useTransition: function() {
    var t = Zs(la)[0], o = ct().memoizedState;
    return [typeof t == "boolean" ? t : Pi(t), o];
  }, useSyncExternalStore: Js, useId: Nm, useHostTransitionStatus: fo, useFormState: ia, useActionState: ia, useOptimistic: function(t, o) {
    return of(ct(), 0, t, o);
  }, useMemoCache: Jd, useCacheRefresh: Og }, Dg = { readContext: Bt, use: wt, useCallback: Ni, useContext: Bt, useEffect: Ag, useImperativeHandle: df, useInsertionEffect: Tm, useLayoutEffect: Ro, useMemo: Rm, useReducer: nf, useRef: tc, useState: function() {
    return nf(la);
  }, useDebugValue: Ai, useDeferredValue: function(t, o) {
    var a = ct();
    return In === null ? rc(a, t, o) : Am(a, In.memoizedState, t, o);
  }, useTransition: function() {
    var t = nf(la)[0], o = ct().memoizedState;
    return [typeof t == "boolean" ? t : Pi(t), o];
  }, useSyncExternalStore: Js, useId: Nm, useHostTransitionStatus: fo, useFormState: ua, useActionState: ua, useOptimistic: function(t, o) {
    var a = ct();
    return In !== null ? of(a, 0, t, o) : (a.baseState = t, [t, a.queue.dispatch]);
  }, useMemoCache: Jd, useCacheRefresh: Og }, Li = null, zi = 0;
  function tr(t) {
    var o = zi;
    return zi += 1, Li === null && (Li = []), pm(Li, t, o);
  }
  function Mu(t, o) {
    o = o.props.ref, t.ref = o !== void 0 ? o : null;
  }
  function rr(t, o) {
    throw o.$$typeof === U ? Error(b(525)) : (t = Object.prototype.toString.call(o), Error(b(31, t === "[object Object]" ? "object with keys {" + Object.keys(o).join(", ") + "}" : t)));
  }
  function Dm(t) {
    return (0, t._init)(t._payload);
  }
  function ca(t) {
    function o(I, _) {
      if (t) {
        var M = I.deletions;
        M === null ? (I.deletions = [_], I.flags |= 16) : M.push(_);
      }
    }
    function a(I, _) {
      if (!t) return null;
      for (; _ !== null; ) o(I, _), _ = _.sibling;
      return null;
    }
    function u(I) {
      for (var _ = /* @__PURE__ */ new Map(); I !== null; ) I.key !== null ? _.set(I.key, I) : _.set(I.index, I), I = I.sibling;
      return _;
    }
    function c(I, _) {
      return (I = Co(I, _)).index = 0, I.sibling = null, I;
    }
    function d(I, _, M) {
      return I.index = M, t ? (M = I.alternate) !== null ? (M = M.index) < _ ? (I.flags |= 67108866, _) : M : (I.flags |= 67108866, _) : (I.flags |= 1048576, _);
    }
    function g(I) {
      return t && I.alternate === null && (I.flags |= 67108866), I;
    }
    function h(I, _, M, ie) {
      return _ === null || _.tag !== 6 ? ((_ = Pu(M, I.mode, ie)).return = I, _) : ((_ = c(_, M)).return = I, _);
    }
    function w(I, _, M, ie) {
      var xe = M.type;
      return xe === K ? B(I, _, M.props.children, ie, M.key) : _ !== null && (_.elementType === xe || typeof xe == "object" && xe !== null && xe.$$typeof === Ge && Dm(xe) === _.type) ? (Mu(_ = c(_, M.props), M), _.return = I, _) : (Mu(_ = he(M.type, M.key, M.props, null, I.mode, ie), M), _.return = I, _);
    }
    function x(I, _, M, ie) {
      return _ === null || _.tag !== 4 || _.stateNode.containerInfo !== M.containerInfo || _.stateNode.implementation !== M.implementation ? ((_ = tt(M, I.mode, ie)).return = I, _) : ((_ = c(_, M.children || [])).return = I, _);
    }
    function B(I, _, M, ie, xe) {
      return _ === null || _.tag !== 7 ? ((_ = io(M, I.mode, ie, xe)).return = I, _) : ((_ = c(_, M)).return = I, _);
    }
    function q(I, _, M) {
      if (typeof _ == "string" && _ !== "" || typeof _ == "number" || typeof _ == "bigint") return (_ = Pu("" + _, I.mode, M)).return = I, _;
      if (typeof _ == "object" && _ !== null) {
        switch (_.$$typeof) {
          case O:
            return Mu(M = he(_.type, _.key, _.props, null, I.mode, M), _), M.return = I, M;
          case Y:
            return (_ = tt(_, I.mode, M)).return = I, _;
          case Ge:
            return q(I, _ = (0, _._init)(_._payload), M);
        }
        if (jn(_) || Oe(_)) return (_ = io(_, I.mode, M, null)).return = I, _;
        if (typeof _.then == "function") return q(I, tr(_), M);
        if (_.$$typeof === ue) return q(I, qs(I, _), M);
        rr(I, _);
      }
      return null;
    }
    function ee(I, _, M, ie) {
      var xe = _ !== null ? _.key : null;
      if (typeof M == "string" && M !== "" || typeof M == "number" || typeof M == "bigint") return xe !== null ? null : h(I, _, "" + M, ie);
      if (typeof M == "object" && M !== null) {
        switch (M.$$typeof) {
          case O:
            return M.key === xe ? w(I, _, M, ie) : null;
          case Y:
            return M.key === xe ? x(I, _, M, ie) : null;
          case Ge:
            return ee(I, _, M = (xe = M._init)(M._payload), ie);
        }
        if (jn(M) || Oe(M)) return xe !== null ? null : B(I, _, M, ie, null);
        if (typeof M.then == "function") return ee(I, _, tr(M), ie);
        if (M.$$typeof === ue) return ee(I, _, qs(I, M), ie);
        rr(I, M);
      }
      return null;
    }
    function le(I, _, M, ie, xe) {
      if (typeof ie == "string" && ie !== "" || typeof ie == "number" || typeof ie == "bigint") return h(_, I = I.get(M) || null, "" + ie, xe);
      if (typeof ie == "object" && ie !== null) {
        switch (ie.$$typeof) {
          case O:
            return w(_, I = I.get(ie.key === null ? M : ie.key) || null, ie, xe);
          case Y:
            return x(_, I = I.get(ie.key === null ? M : ie.key) || null, ie, xe);
          case Ge:
            return le(I, _, M, ie = (0, ie._init)(ie._payload), xe);
        }
        if (jn(ie) || Oe(ie)) return B(_, I = I.get(M) || null, ie, xe, null);
        if (typeof ie.then == "function") return le(I, _, M, tr(ie), xe);
        if (ie.$$typeof === ue) return le(I, _, M, qs(_, ie), xe);
        rr(_, ie);
      }
      return null;
    }
    function de(I, _, M, ie) {
      if (typeof M == "object" && M !== null && M.type === K && M.key === null && (M = M.props.children), typeof M == "object" && M !== null) {
        switch (M.$$typeof) {
          case O:
            e: {
              for (var xe = M.key; _ !== null; ) {
                if (_.key === xe) {
                  if ((xe = M.type) === K) {
                    if (_.tag === 7) {
                      a(I, _.sibling), (ie = c(_, M.props.children)).return = I, I = ie;
                      break e;
                    }
                  } else if (_.elementType === xe || typeof xe == "object" && xe !== null && xe.$$typeof === Ge && Dm(xe) === _.type) {
                    a(I, _.sibling), Mu(ie = c(_, M.props), M), ie.return = I, I = ie;
                    break e;
                  }
                  a(I, _);
                  break;
                }
                o(I, _), _ = _.sibling;
              }
              M.type === K ? ((ie = io(M.props.children, I.mode, ie, M.key)).return = I, I = ie) : (Mu(ie = he(M.type, M.key, M.props, null, I.mode, ie), M), ie.return = I, I = ie);
            }
            return g(I);
          case Y:
            e: {
              for (xe = M.key; _ !== null; ) {
                if (_.key === xe) {
                  if (_.tag === 4 && _.stateNode.containerInfo === M.containerInfo && _.stateNode.implementation === M.implementation) {
                    a(I, _.sibling), (ie = c(_, M.children || [])).return = I, I = ie;
                    break e;
                  }
                  a(I, _);
                  break;
                }
                o(I, _), _ = _.sibling;
              }
              (ie = tt(M, I.mode, ie)).return = I, I = ie;
            }
            return g(I);
          case Ge:
            return de(I, _, M = (xe = M._init)(M._payload), ie);
        }
        if (jn(M)) return function(Re, Ve, En, yt) {
          for (var ln = null, Cn = null, Ne = Ve, Ke = Ve = 0, Zn = null; Ne !== null && Ke < En.length; Ke++) {
            Ne.index > Ke ? (Zn = Ne, Ne = null) : Zn = Ne.sibling;
            var qe = ee(Re, Ne, En[Ke], yt);
            if (qe === null) {
              Ne === null && (Ne = Zn);
              break;
            }
            t && Ne && qe.alternate === null && o(Re, Ne), Ve = d(qe, Ve, Ke), Cn === null ? ln = qe : Cn.sibling = qe, Cn = qe, Ne = Zn;
          }
          if (Ke === En.length) return a(Re, Ne), bn && Sn(Re, Ke), ln;
          if (Ne === null) {
            for (; Ke < En.length; Ke++) (Ne = q(Re, En[Ke], yt)) !== null && (Ve = d(Ne, Ve, Ke), Cn === null ? ln = Ne : Cn.sibling = Ne, Cn = Ne);
            return bn && Sn(Re, Ke), ln;
          }
          for (Ne = u(Ne); Ke < En.length; Ke++) (Zn = le(Ne, Re, Ke, En[Ke], yt)) !== null && (t && Zn.alternate !== null && Ne.delete(Zn.key === null ? Ke : Zn.key), Ve = d(Zn, Ve, Ke), Cn === null ? ln = Zn : Cn.sibling = Zn, Cn = Zn);
          return t && Ne.forEach(function(zr) {
            return o(Re, zr);
          }), bn && Sn(Re, Ke), ln;
        }(I, _, M, ie);
        if (Oe(M)) {
          if (typeof (xe = Oe(M)) != "function") throw Error(b(150));
          return function(Re, Ve, En, yt) {
            if (En == null) throw Error(b(151));
            for (var ln = null, Cn = null, Ne = Ve, Ke = Ve = 0, Zn = null, qe = En.next(); Ne !== null && !qe.done; Ke++, qe = En.next()) {
              Ne.index > Ke ? (Zn = Ne, Ne = null) : Zn = Ne.sibling;
              var zr = ee(Re, Ne, qe.value, yt);
              if (zr === null) {
                Ne === null && (Ne = Zn);
                break;
              }
              t && Ne && zr.alternate === null && o(Re, Ne), Ve = d(zr, Ve, Ke), Cn === null ? ln = zr : Cn.sibling = zr, Cn = zr, Ne = Zn;
            }
            if (qe.done) return a(Re, Ne), bn && Sn(Re, Ke), ln;
            if (Ne === null) {
              for (; !qe.done; Ke++, qe = En.next()) (qe = q(Re, qe.value, yt)) !== null && (Ve = d(qe, Ve, Ke), Cn === null ? ln = qe : Cn.sibling = qe, Cn = qe);
              return bn && Sn(Re, Ke), ln;
            }
            for (Ne = u(Ne); !qe.done; Ke++, qe = En.next()) (qe = le(Ne, Re, Ke, qe.value, yt)) !== null && (t && qe.alternate !== null && Ne.delete(qe.key === null ? Ke : qe.key), Ve = d(qe, Ve, Ke), Cn === null ? ln = qe : Cn.sibling = qe, Cn = qe);
            return t && Ne.forEach(function($r) {
              return o(Re, $r);
            }), bn && Sn(Re, Ke), ln;
          }(I, _, M = xe.call(M), ie);
        }
        if (typeof M.then == "function") return de(I, _, tr(M), ie);
        if (M.$$typeof === ue) return de(I, _, qs(I, M), ie);
        rr(I, M);
      }
      return typeof M == "string" && M !== "" || typeof M == "number" || typeof M == "bigint" ? (M = "" + M, _ !== null && _.tag === 6 ? (a(I, _.sibling), (ie = c(_, M)).return = I, I = ie) : (a(I, _), (ie = Pu(M, I.mode, ie)).return = I, I = ie), g(I)) : a(I, _);
    }
    return function(I, _, M, ie) {
      try {
        zi = 0;
        var xe = de(I, _, M, ie);
        return Li = null, xe;
      } catch (Ve) {
        if (Ve === Fl || Ve === Ys) throw Ve;
        var Re = Pr(29, Ve, null, I.mode);
        return Re.lanes = ie, Re.return = I, Re;
      }
    };
  }
  var Di = ca(!0), Fi = ca(!1), qr = me(null), Vt = null;
  function da(t) {
    var o = t.alternate;
    Te($n, 1 & $n.current), Te(qr, t), Vt === null && (o === null || Ti.current !== null || o.memoizedState !== null) && (Vt = t);
  }
  function pf(t) {
    if (t.tag === 22) {
      if (Te($n, $n.current), Te(qr, t), Vt === null) {
        var o = t.alternate;
        o !== null && o.memoizedState !== null && (Vt = t);
      }
    } else gr();
  }
  function gr() {
    Te($n, $n.current), Te(qr, qr.current);
  }
  function fa(t) {
    ce(qr), Vt === t && (Vt = null), ce($n);
  }
  var $n = me(0);
  function lc(t) {
    for (var o = t; o !== null; ) {
      if (o.tag === 13) {
        var a = o.memoizedState;
        if (a !== null && ((a = a.dehydrated) === null || a.data === "$?" || Yl(a))) return o;
      } else if (o.tag === 19 && o.memoizedProps.revealOrder !== void 0) {
        if (128 & o.flags) return o;
      } else if (o.child !== null) {
        o.child.return = o, o = o.child;
        continue;
      }
      if (o === t) break;
      for (; o.sibling === null; ) {
        if (o.return === null || o.return === t) return null;
        o = o.return;
      }
      o.sibling.return = o.return, o = o.sibling;
    }
    return null;
  }
  function Ii(t, o, a, u) {
    a = (a = a(u, o = t.memoizedState)) == null ? o : L({}, o, a), t.memoizedState = a, t.lanes === 0 && (t.updateQueue.baseState = a);
  }
  var Mi = { enqueueSetState: function(t, o, a) {
    t = t._reactInternals;
    var u = Lr(), c = Nr(u);
    c.payload = o, a != null && (c.callback = a), (o = aa(t, c, u)) !== null && (qt(o, t, u), Ci(o, t, u));
  }, enqueueReplaceState: function(t, o, a) {
    t = t._reactInternals;
    var u = Lr(), c = Nr(u);
    c.tag = 1, c.payload = o, a != null && (c.callback = a), (o = aa(t, c, u)) !== null && (qt(o, t, u), Ci(o, t, u));
  }, enqueueForceUpdate: function(t, o) {
    t = t._reactInternals;
    var a = Lr(), u = Nr(a);
    u.tag = 2, o != null && (u.callback = o), (o = aa(t, u, a)) !== null && (qt(o, t, a), Ci(o, t, a));
  } };
  function Fm(t, o, a, u, c, d, g) {
    return typeof (t = t.stateNode).shouldComponentUpdate == "function" ? t.shouldComponentUpdate(u, d, g) : !o.prototype || !o.prototype.isPureReactComponent || !yi(a, u) || !yi(c, d);
  }
  function Im(t, o, a, u) {
    t = o.state, typeof o.componentWillReceiveProps == "function" && o.componentWillReceiveProps(a, u), typeof o.UNSAFE_componentWillReceiveProps == "function" && o.UNSAFE_componentWillReceiveProps(a, u), o.state !== t && Mi.enqueueReplaceState(o, o.state, null);
  }
  function Ao(t, o) {
    var a = o;
    if ("ref" in o) for (var u in a = {}, o) u !== "ref" && (a[u] = o[u]);
    if (t = t.defaultProps) for (var c in a === o && (a = L({}, a)), t) a[c] === void 0 && (a[c] = t[c]);
    return a;
  }
  var ic = typeof reportError == "function" ? reportError : function(t) {
    if (typeof window == "object" && typeof window.ErrorEvent == "function") {
      var o = new window.ErrorEvent("error", { bubbles: !0, cancelable: !0, message: typeof t == "object" && t !== null && typeof t.message == "string" ? String(t.message) : String(t), error: t });
      if (!window.dispatchEvent(o)) return;
    } else if (typeof process == "object" && typeof process.emit == "function") return void process.emit("uncaughtException", t);
    console.error(t);
  };
  function uc(t) {
    ic(t);
  }
  function Mm(t) {
    console.error(t);
  }
  function jm(t) {
    ic(t);
  }
  function sc(t, o) {
    try {
      (0, t.onUncaughtError)(o.value, { componentStack: o.stack });
    } catch (a) {
      setTimeout(function() {
        throw a;
      });
    }
  }
  function _r(t, o, a) {
    try {
      (0, t.onCaughtError)(a.value, { componentStack: a.stack, errorBoundary: o.tag === 1 ? o.stateNode : null });
    } catch (u) {
      setTimeout(function() {
        throw u;
      });
    }
  }
  function mf(t, o, a) {
    return (a = Nr(a)).tag = 3, a.payload = { element: null }, a.callback = function() {
      sc(t, o);
    }, a;
  }
  function dt(t) {
    return (t = Nr(t)).tag = 3, t;
  }
  function Hm(t, o, a, u) {
    var c = a.type.getDerivedStateFromError;
    if (typeof c == "function") {
      var d = u.value;
      t.payload = function() {
        return c(d);
      }, t.callback = function() {
        _r(o, a, u);
      };
    }
    var g = a.stateNode;
    g !== null && typeof g.componentDidCatch == "function" && (t.callback = function() {
      _r(o, a, u), typeof c != "function" && (Bl === null ? Bl = /* @__PURE__ */ new Set([this]) : Bl.add(this));
      var h = u.stack;
      this.componentDidCatch(u.value, { componentStack: h !== null ? h : "" });
    });
  }
  var Um = Error(b(461)), Lt = !1;
  function at(t, o, a, u) {
    o.child = t === null ? Fi(o, null, a, u) : Di(o, t.child, a, u);
  }
  function ji(t, o, a, u, c) {
    a = a.render;
    var d = o.ref;
    if ("ref" in u) {
      var g = {};
      for (var h in u) h !== "ref" && (g[h] = u[h]);
    } else g = u;
    return $a(o), u = Xd(t, o, a, g, d, c), h = $d(), t === null || Lt ? (bn && h && Jo(o), o.flags |= 1, at(t, o, u, c), o.child) : (Fu(t, o, c), tl(t, o, c));
  }
  function hf(t, o, a, u, c) {
    if (t === null) {
      var d = a.type;
      return typeof d != "function" || Hs(d) || d.defaultProps !== void 0 || a.compare !== null ? ((t = he(a.type, null, u, o, o.mode, c)).ref = o.ref, t.return = o, o.child = t) : (o.tag = 15, o.type = d, Hi(t, o, d, u, c));
    }
    if (d = t.child, !kf(t, c)) {
      var g = d.memoizedProps;
      if ((a = (a = a.compare) !== null ? a : yi)(g, u) && t.ref === o.ref) return tl(t, o, c);
    }
    return o.flags |= 1, (t = Co(d, u)).ref = o.ref, t.return = o, o.child = t;
  }
  function Hi(t, o, a, u, c) {
    if (t !== null) {
      var d = t.memoizedProps;
      if (yi(d, u) && t.ref === o.ref) {
        if (Lt = !1, o.pendingProps = u = d, !kf(t, c)) return o.lanes = t.lanes, tl(t, o, c);
        131072 & t.flags && (Lt = !0);
      }
    }
    return dc(t, o, a, u, c);
  }
  function Bm(t, o, a) {
    var u = o.pendingProps, c = u.children, d = t !== null ? t.memoizedState : null;
    if (u.mode === "hidden") {
      if (128 & o.flags) {
        if (u = d !== null ? d.baseLanes | a : a, t !== null) {
          for (c = o.child = t.child, d = 0; c !== null; ) d = d | c.lanes | c.childLanes, c = c.sibling;
          o.childLanes = d & ~u;
        } else o.childLanes = 0, o.child = null;
        return Vm(t, o, u, a);
      }
      if (!(536870912 & a)) return o.lanes = o.childLanes = 536870912, Vm(t, o, d !== null ? d.baseLanes | a : a, a);
      o.memoizedState = { baseLanes: 0, cachePool: null }, t !== null && Ei(0, d !== null ? d.cachePool : null), d !== null ? Ot(o, d) : zu(), pf(o);
    } else d !== null ? (Ei(0, d.cachePool), Ot(o, d), gr(), o.memoizedState = null) : (t !== null && Ei(0, null), zu(), gr());
    return at(t, o, c, a), o.child;
  }
  function Vm(t, o, a, u) {
    var c = Qs();
    return c = c === null ? null : { parent: st._currentValue, pool: c }, o.memoizedState = { baseLanes: a, cachePool: c }, t !== null && Ei(0, null), zu(), pf(o), t !== null && Ou(t, o, u, !0), null;
  }
  function cc(t, o) {
    var a = o.ref;
    if (a === null) t !== null && t.ref !== null && (o.flags |= 4194816);
    else {
      if (typeof a != "function" && typeof a != "object") throw Error(b(284));
      t !== null && t.ref === a || (o.flags |= 4194816);
    }
  }
  function dc(t, o, a, u, c) {
    return $a(o), a = Xd(t, o, a, u, void 0, c), u = $d(), t === null || Lt ? (bn && u && Jo(o), o.flags |= 1, at(t, o, a, c), o.child) : (Fu(t, o, c), tl(t, o, c));
  }
  function gf(t, o, a, u, c, d) {
    return $a(o), o.updateQueue = null, a = vm(o, u, a, c), Ml(t), u = $d(), t === null || Lt ? (bn && u && Jo(o), o.flags |= 1, at(t, o, a, d), o.child) : (Fu(t, o, d), tl(t, o, d));
  }
  function Wm(t, o, a, u, c) {
    if ($a(o), o.stateNode === null) {
      var d = Tu, g = a.contextType;
      typeof g == "object" && g !== null && (d = Bt(g)), d = new a(u, d), o.memoizedState = d.state !== null && d.state !== void 0 ? d.state : null, d.updater = Mi, o.stateNode = d, d._reactInternals = o, (d = o.stateNode).props = u, d.state = o.memoizedState, d.refs = {}, Qd(o), g = a.contextType, d.context = typeof g == "object" && g !== null ? Bt(g) : Tu, d.state = o.memoizedState, typeof (g = a.getDerivedStateFromProps) == "function" && (Ii(o, a, g, u), d.state = o.memoizedState), typeof a.getDerivedStateFromProps == "function" || typeof d.getSnapshotBeforeUpdate == "function" || typeof d.UNSAFE_componentWillMount != "function" && typeof d.componentWillMount != "function" || (g = d.state, typeof d.componentWillMount == "function" && d.componentWillMount(), typeof d.UNSAFE_componentWillMount == "function" && d.UNSAFE_componentWillMount(), g !== d.state && Mi.enqueueReplaceState(d, d.state, null), el(o, u, d, c), Lu(), d.state = o.memoizedState), typeof d.componentDidMount == "function" && (o.flags |= 4194308), u = !0;
    } else if (t === null) {
      d = o.stateNode;
      var h = o.memoizedProps, w = Ao(a, h);
      d.props = w;
      var x = d.context, B = a.contextType;
      g = Tu, typeof B == "object" && B !== null && (g = Bt(B));
      var q = a.getDerivedStateFromProps;
      B = typeof q == "function" || typeof d.getSnapshotBeforeUpdate == "function", h = o.pendingProps !== h, B || typeof d.UNSAFE_componentWillReceiveProps != "function" && typeof d.componentWillReceiveProps != "function" || (h || x !== g) && Im(o, d, u, g), oa = !1;
      var ee = o.memoizedState;
      d.state = ee, el(o, u, d, c), Lu(), x = o.memoizedState, h || ee !== x || oa ? (typeof q == "function" && (Ii(o, a, q, u), x = o.memoizedState), (w = oa || Fm(o, a, w, u, ee, x, g)) ? (B || typeof d.UNSAFE_componentWillMount != "function" && typeof d.componentWillMount != "function" || (typeof d.componentWillMount == "function" && d.componentWillMount(), typeof d.UNSAFE_componentWillMount == "function" && d.UNSAFE_componentWillMount()), typeof d.componentDidMount == "function" && (o.flags |= 4194308)) : (typeof d.componentDidMount == "function" && (o.flags |= 4194308), o.memoizedProps = u, o.memoizedState = x), d.props = u, d.state = x, d.context = g, u = w) : (typeof d.componentDidMount == "function" && (o.flags |= 4194308), u = !1);
    } else {
      d = o.stateNode, Yd(t, o), B = Ao(a, g = o.memoizedProps), d.props = B, q = o.pendingProps, ee = d.context, x = a.contextType, w = Tu, typeof x == "object" && x !== null && (w = Bt(x)), (x = typeof (h = a.getDerivedStateFromProps) == "function" || typeof d.getSnapshotBeforeUpdate == "function") || typeof d.UNSAFE_componentWillReceiveProps != "function" && typeof d.componentWillReceiveProps != "function" || (g !== q || ee !== w) && Im(o, d, u, w), oa = !1, ee = o.memoizedState, d.state = ee, el(o, u, d, c), Lu();
      var le = o.memoizedState;
      g !== q || ee !== le || oa || t !== null && t.dependencies !== null && Ws(t.dependencies) ? (typeof h == "function" && (Ii(o, a, h, u), le = o.memoizedState), (B = oa || Fm(o, a, B, u, ee, le, w) || t !== null && t.dependencies !== null && Ws(t.dependencies)) ? (x || typeof d.UNSAFE_componentWillUpdate != "function" && typeof d.componentWillUpdate != "function" || (typeof d.componentWillUpdate == "function" && d.componentWillUpdate(u, le, w), typeof d.UNSAFE_componentWillUpdate == "function" && d.UNSAFE_componentWillUpdate(u, le, w)), typeof d.componentDidUpdate == "function" && (o.flags |= 4), typeof d.getSnapshotBeforeUpdate == "function" && (o.flags |= 1024)) : (typeof d.componentDidUpdate != "function" || g === t.memoizedProps && ee === t.memoizedState || (o.flags |= 4), typeof d.getSnapshotBeforeUpdate != "function" || g === t.memoizedProps && ee === t.memoizedState || (o.flags |= 1024), o.memoizedProps = u, o.memoizedState = le), d.props = u, d.state = le, d.context = w, u = B) : (typeof d.componentDidUpdate != "function" || g === t.memoizedProps && ee === t.memoizedState || (o.flags |= 4), typeof d.getSnapshotBeforeUpdate != "function" || g === t.memoizedProps && ee === t.memoizedState || (o.flags |= 1024), u = !1);
    }
    return d = u, cc(t, o), u = !!(128 & o.flags), d || u ? (d = o.stateNode, a = u && typeof a.getDerivedStateFromError != "function" ? null : d.render(), o.flags |= 1, t !== null && u ? (o.child = Di(o, t.child, null, c), o.child = Di(o, null, a, c)) : at(t, o, a, c), o.memoizedState = d.state, t = o.child) : t = tl(t, o, c), t;
  }
  function Fg(t, o, a, u) {
    return _u(), o.flags |= 256, at(t, o, a, u), o.child;
  }
  var yf = { dehydrated: null, treeContext: null, retryLane: 0, hydrationErrors: null };
  function bf(t) {
    return { baseLanes: t, cachePool: Bd() };
  }
  function qm(t, o, a) {
    return t = t !== null ? t.childLanes & ~a : 0, o && (t |= Or), t;
  }
  function Ui(t, o, a) {
    var u, c = o.pendingProps, d = !1, g = !!(128 & o.flags);
    if ((u = g) || (u = (t === null || t.memoizedState !== null) && !!(2 & $n.current)), u && (d = !0, o.flags &= -129), u = !!(32 & o.flags), o.flags &= -33, t === null) {
      if (bn) {
        if (d ? da(o) : gr(), bn) {
          var h, w = Xn;
          if (h = w) {
            e: {
              for (h = w, w = Ar; h.nodeType !== 8; ) {
                if (!w) {
                  w = null;
                  break e;
                }
                if ((h = Do(h.nextSibling)) === null) {
                  w = null;
                  break e;
                }
              }
              w = h;
            }
            w !== null ? (o.memoizedState = { dehydrated: w, treeContext: Qa !== null ? { id: so, overflow: ut } : null, retryLane: 536870912, hydrationErrors: null }, (h = Pr(18, null, null, 0)).stateNode = w, h.return = o, o.child = h, Yn = o, Xn = null, h = !0) : h = !1;
          }
          h || ea(o);
        }
        if ((w = o.memoizedState) !== null && (w = w.dehydrated) !== null) return Yl(w) ? o.lanes = 32 : o.lanes = 536870912, null;
        fa(o);
      }
      return w = c.children, c = c.fallback, d ? (gr(), w = fc({ mode: "hidden", children: w }, d = o.mode), c = io(c, d, a, null), w.return = o, c.return = o, w.sibling = c, o.child = w, (d = o.child).memoizedState = bf(a), d.childLanes = qm(t, u, a), o.memoizedState = yf, c) : (da(o), ju(o, w));
    }
    if ((h = t.memoizedState) !== null && (w = h.dehydrated) !== null) {
      if (g) 256 & o.flags ? (da(o), o.flags &= -257, o = pc(t, o, a)) : o.memoizedState !== null ? (gr(), o.child = t.child, o.flags |= 128, o = null) : (gr(), d = c.fallback, w = o.mode, c = fc({ mode: "visible", children: c.children }, w), (d = io(d, w, a, null)).flags |= 2, c.return = o, d.return = o, c.sibling = d, o.child = c, Di(o, t.child, null, a), (c = o.child).memoizedState = bf(a), c.childLanes = qm(t, u, a), o.memoizedState = yf, o = d);
      else if (da(o), Yl(w)) {
        if (u = w.nextSibling && w.nextSibling.dataset) var x = u.dgst;
        u = x, (c = Error(b(419))).stack = "", c.digest = u, ki({ value: c, source: null, stack: null }), o = pc(t, o, a);
      } else if (Lt || Ou(t, o, a, !1), u = (a & t.childLanes) !== 0, Lt || u) {
        if ((u = Qn) !== null && (c = ((c = 42 & (c = a & -a) ? 1 : Ln(c)) & (u.suspendedLanes | a)) !== 0 ? 0 : c) !== 0 && c !== h.retryLane) throw h.retryLane = c, Zo(t, c), qt(u, t, c), Um;
        w.data === "$?" || ah(), o = pc(t, o, a);
      } else w.data === "$?" ? (o.flags |= 192, o.child = t.child, o = null) : (t = h.treeContext, Xn = Do(w.nextSibling), Yn = o, bn = !0, Ga = null, Ar = !1, t !== null && (uo[Rr++] = so, uo[Rr++] = ut, uo[Rr++] = Qa, so = t.id, ut = t.overflow, Qa = o), (o = ju(o, c.children)).flags |= 4096);
      return o;
    }
    return d ? (gr(), d = c.fallback, w = o.mode, x = (h = t.child).sibling, (c = Co(h, { mode: "hidden", children: c.children })).subtreeFlags = 65011712 & h.subtreeFlags, x !== null ? d = Co(x, d) : (d = io(d, w, a, null)).flags |= 2, d.return = o, c.return = o, c.sibling = d, o.child = c, c = d, d = o.child, (w = t.child.memoizedState) === null ? w = bf(a) : ((h = w.cachePool) !== null ? (x = st._currentValue, h = h.parent !== x ? { parent: x, pool: x } : h) : h = Bd(), w = { baseLanes: w.baseLanes | a, cachePool: h }), d.memoizedState = w, d.childLanes = qm(t, u, a), o.memoizedState = yf, c) : (da(o), t = (a = t.child).sibling, (a = Co(a, { mode: "visible", children: c.children })).return = o, a.sibling = null, t !== null && ((u = o.deletions) === null ? (o.deletions = [t], o.flags |= 16) : u.push(t)), o.child = a, o.memoizedState = null, a);
  }
  function ju(t, o) {
    return (o = fc({ mode: "visible", children: o }, t.mode)).return = t, t.child = o;
  }
  function fc(t, o) {
    return (t = Pr(22, t, null, o)).lanes = 0, t.stateNode = { _visibility: 1, _pendingMarkers: null, _retryCache: null, _transitions: null }, t;
  }
  function pc(t, o, a) {
    return Di(o, t.child, null, a), (t = ju(o, o.pendingProps.children)).flags |= 2, o.memoizedState = null, t;
  }
  function Qm(t, o, a) {
    t.lanes |= o;
    var u = t.alternate;
    u !== null && (u.lanes |= o), dm(t.return, o, a);
  }
  function vf(t, o, a, u, c) {
    var d = t.memoizedState;
    d === null ? t.memoizedState = { isBackwards: o, rendering: null, renderingStartTime: 0, last: u, tail: a, tailMode: c } : (d.isBackwards = o, d.rendering = null, d.renderingStartTime = 0, d.last = u, d.tail = a, d.tailMode = c);
  }
  function Ym(t, o, a) {
    var u = o.pendingProps, c = u.revealOrder, d = u.tail;
    if (at(t, o, u.children, a), 2 & (u = $n.current)) u = 1 & u | 2, o.flags |= 128;
    else {
      if (t !== null && 128 & t.flags) e: for (t = o.child; t !== null; ) {
        if (t.tag === 13) t.memoizedState !== null && Qm(t, a, o);
        else if (t.tag === 19) Qm(t, a, o);
        else if (t.child !== null) {
          t.child.return = t, t = t.child;
          continue;
        }
        if (t === o) break e;
        for (; t.sibling === null; ) {
          if (t.return === null || t.return === o) break e;
          t = t.return;
        }
        t.sibling.return = t.return, t = t.sibling;
      }
      u &= 1;
    }
    switch (Te($n, u), c) {
      case "forwards":
        for (a = o.child, c = null; a !== null; ) (t = a.alternate) !== null && lc(t) === null && (c = a), a = a.sibling;
        (a = c) === null ? (c = o.child, o.child = null) : (c = a.sibling, a.sibling = null), vf(o, !1, c, a, d);
        break;
      case "backwards":
        for (a = null, c = o.child, o.child = null; c !== null; ) {
          if ((t = c.alternate) !== null && lc(t) === null) {
            o.child = c;
            break;
          }
          t = c.sibling, c.sibling = a, a = c, c = t;
        }
        vf(o, !0, a, null, d);
        break;
      case "together":
        vf(o, !1, null, null, void 0);
        break;
      default:
        o.memoizedState = null;
    }
    return o.child;
  }
  function tl(t, o, a) {
    if (t !== null && (o.dependencies = t.dependencies), Hl |= o.lanes, (a & o.childLanes) === 0 && (t === null || (Ou(t, o, a, !1), (a & o.childLanes) === 0)))
      return null;
    if (t !== null && o.child !== t.child) throw Error(b(153));
    if (o.child !== null) {
      for (a = Co(t = o.child, t.pendingProps), o.child = a, a.return = o; t.sibling !== null; ) t = t.sibling, (a = a.sibling = Co(t, t.pendingProps)).return = o;
      a.sibling = null;
    }
    return o.child;
  }
  function kf(t, o) {
    return (t.lanes & o) !== 0 || !((t = t.dependencies) === null || !Ws(t));
  }
  function Hu(t, o, a) {
    if (t !== null) if (t.memoizedProps !== o.pendingProps) Lt = !0;
    else {
      if (!(kf(t, a) || 128 & o.flags)) return Lt = !1, function(h, w, x) {
        switch (w.tag) {
          case 3:
            Qe(w, w.stateNode.containerInfo), Xa(0, st, h.memoizedState.cache), _u();
            break;
          case 27:
          case 5:
            Vn(w);
            break;
          case 4:
            Qe(w, w.stateNode.containerInfo);
            break;
          case 10:
            Xa(0, w.type, w.memoizedProps.value);
            break;
          case 13:
            var B = w.memoizedState;
            if (B !== null) return B.dehydrated !== null ? (da(w), w.flags |= 128, null) : (x & w.child.childLanes) !== 0 ? Ui(h, w, x) : (da(w), (h = tl(h, w, x)) !== null ? h.sibling : null);
            da(w);
            break;
          case 19:
            var q = !!(128 & h.flags);
            if ((B = (x & w.childLanes) !== 0) || (Ou(h, w, x, !1), B = (x & w.childLanes) !== 0), q) {
              if (B) return Ym(h, w, x);
              w.flags |= 128;
            }
            if ((q = w.memoizedState) !== null && (q.rendering = null, q.tail = null, q.lastEffect = null), Te($n, $n.current), B) break;
            return null;
          case 22:
          case 23:
            return w.lanes = 0, Bm(h, w, x);
          case 24:
            Xa(0, st, h.memoizedState.cache);
        }
        return tl(h, w, x);
      }(t, o, a);
      Lt = !!(131072 & t.flags);
    }
    else Lt = !1, bn && 1048576 & o.flags && Au(o, Ru, o.index);
    switch (o.lanes = 0, o.tag) {
      case 16:
        e: {
          t = o.pendingProps;
          var u = o.elementType, c = u._init;
          if (u = c(u._payload), o.type = u, typeof u != "function") {
            if (u != null) {
              if ((c = u.$$typeof) === pe) {
                o.tag = 11, o = ji(null, o, u, t, a);
                break e;
              }
              if (c === Se) {
                o.tag = 14, o = hf(null, o, u, t, a);
                break e;
              }
            }
            throw o = yn(u) || u, Error(b(306, o, ""));
          }
          Hs(u) ? (t = Ao(u, t), o.tag = 1, o = Wm(null, o, u, t, a)) : (o.tag = 0, o = dc(null, o, u, t, a));
        }
        return o;
      case 0:
        return dc(t, o, o.type, o.pendingProps, a);
      case 1:
        return Wm(t, o, u = o.type, c = Ao(u, o.pendingProps), a);
      case 3:
        e: {
          if (Qe(o, o.stateNode.containerInfo), t === null) throw Error(b(387));
          u = o.pendingProps;
          var d = o.memoizedState;
          c = d.element, Yd(t, o), el(o, u, null, a);
          var g = o.memoizedState;
          if (u = g.cache, Xa(0, st, u), u !== d.cache && jd(o, [st], a, !0), Lu(), u = g.element, d.isDehydrated) {
            if (d = { element: u, isDehydrated: !1, cache: g.cache }, o.updateQueue.baseState = d, o.memoizedState = d, 256 & o.flags) {
              o = Fg(t, o, u, a);
              break e;
            }
            if (u !== c) {
              ki(c = Br(Error(b(424)), o)), o = Fg(t, o, u, a);
              break e;
            }
            for ((t = o.stateNode.containerInfo).nodeType === 9 ? t = t.body : t = t.nodeName === "HTML" ? t.ownerDocument.body : t, Xn = Do(t.firstChild), Yn = o, bn = !0, Ga = null, Ar = !0, a = Fi(o, null, u, a), o.child = a; a; ) a.flags = -3 & a.flags | 4096, a = a.sibling;
          } else {
            if (_u(), u === c) {
              o = tl(t, o, a);
              break e;
            }
            at(t, o, u, a);
          }
          o = o.child;
        }
        return o;
      case 26:
        return cc(t, o), t === null ? (a = ty(o.type, null, o.pendingProps, null)) ? o.memoizedState = a : bn || (a = o.type, t = o.pendingProps, (u = Lo(Ie.current).createElement(a))[Ut] = o, u[pr] = t, Pt(u, a, t), kt(u), o.stateNode = u) : o.memoizedState = ty(o.type, t.memoizedProps, o.pendingProps, t.memoizedState), null;
      case 27:
        return Vn(o), t === null && bn && (u = o.stateNode = ey(o.type, o.pendingProps, Ie.current), Yn = o, Ar = !0, c = Xn, Ql(o.type) ? (Nc = c, Xn = Do(u.firstChild)) : Xn = c), at(t, o, o.pendingProps.children, a), cc(t, o), t === null && (o.flags |= 4194304), o.child;
      case 5:
        return t === null && bn && ((c = u = Xn) && ((u = function(h, w, x, B) {
          for (; h.nodeType === 1; ) {
            var q = x;
            if (h.nodeName.toLowerCase() !== w.toLowerCase()) {
              if (!B && (h.nodeName !== "INPUT" || h.type !== "hidden")) break;
            } else if (B) {
              if (!h[fu]) switch (w) {
                case "meta":
                  if (!h.hasAttribute("itemprop")) break;
                  return h;
                case "link":
                  if ((ee = h.getAttribute("rel")) === "stylesheet" && h.hasAttribute("data-precedence") || ee !== q.rel || h.getAttribute("href") !== (q.href == null || q.href === "" ? null : q.href) || h.getAttribute("crossorigin") !== (q.crossOrigin == null ? null : q.crossOrigin) || h.getAttribute("title") !== (q.title == null ? null : q.title)) break;
                  return h;
                case "style":
                  if (h.hasAttribute("data-precedence")) break;
                  return h;
                case "script":
                  if (((ee = h.getAttribute("src")) !== (q.src == null ? null : q.src) || h.getAttribute("type") !== (q.type == null ? null : q.type) || h.getAttribute("crossorigin") !== (q.crossOrigin == null ? null : q.crossOrigin)) && ee && h.hasAttribute("async") && !h.hasAttribute("itemprop")) break;
                  return h;
                default:
                  return h;
              }
            } else {
              if (w !== "input" || h.type !== "hidden") return h;
              var ee = q.name == null ? null : "" + q.name;
              if (q.type === "hidden" && h.getAttribute("name") === ee) return h;
            }
            if ((h = Do(h.nextSibling)) === null) break;
          }
          return null;
        }(u, o.type, o.pendingProps, Ar)) !== null ? (o.stateNode = u, Yn = o, Xn = Do(u.firstChild), Ar = !1, c = !0) : c = !1), c || ea(o)), Vn(o), c = o.type, d = o.pendingProps, g = t !== null ? t.memoizedProps : null, u = d.children, Ju(c, d) ? u = null : g !== null && Ju(c, g) && (o.flags |= 32), o.memoizedState !== null && (c = Xd(t, o, Tg, null, null, a), Dc._currentValue = c), cc(t, o), at(t, o, u, a), o.child;
      case 6:
        return t === null && bn && ((t = a = Xn) && ((a = function(h, w, x) {
          if (w === "") return null;
          for (; h.nodeType !== 3; )
            if ((h.nodeType !== 1 || h.nodeName !== "INPUT" || h.type !== "hidden") && !x || (h = Do(h.nextSibling)) === null) return null;
          return h;
        }(a, o.pendingProps, Ar)) !== null ? (o.stateNode = a, Yn = o, Xn = null, t = !0) : t = !1), t || ea(o)), null;
      case 13:
        return Ui(t, o, a);
      case 4:
        return Qe(o, o.stateNode.containerInfo), u = o.pendingProps, t === null ? o.child = Di(o, null, u, a) : at(t, o, u, a), o.child;
      case 11:
        return ji(t, o, o.type, o.pendingProps, a);
      case 7:
        return at(t, o, o.pendingProps, a), o.child;
      case 8:
      case 12:
        return at(t, o, o.pendingProps.children, a), o.child;
      case 10:
        return u = o.pendingProps, Xa(0, o.type, u.value), at(t, o, u.children, a), o.child;
      case 9:
        return c = o.type._context, u = o.pendingProps.children, $a(o), u = u(c = Bt(c)), o.flags |= 1, at(t, o, u, a), o.child;
      case 14:
        return hf(t, o, o.type, o.pendingProps, a);
      case 15:
        return Hi(t, o, o.type, o.pendingProps, a);
      case 19:
        return Ym(t, o, a);
      case 31:
        return u = o.pendingProps, a = o.mode, u = { mode: u.mode, children: u.children }, t === null ? ((a = fc(u, a)).ref = o.ref, o.child = a, a.return = o, o = a) : ((a = Co(t.child, u)).ref = o.ref, o.child = a, a.return = o, o = a), o;
      case 22:
        return Bm(t, o, a);
      case 24:
        return $a(o), u = Bt(st), t === null ? ((c = Qs()) === null && (c = Qn, d = Dl(), c.pooledCache = d, d.refCount++, d !== null && (c.pooledCacheLanes |= a), c = d), o.memoizedState = { parent: u, cache: c }, Qd(o), Xa(0, st, c)) : ((t.lanes & a) !== 0 && (Yd(t, o), el(o, null, null, a), Lu()), c = t.memoizedState, d = o.memoizedState, c.parent !== u ? (c = { parent: u, cache: u }, o.memoizedState = c, o.lanes === 0 && (o.memoizedState = o.updateQueue.baseState = c), Xa(0, st, u)) : (u = d.cache, Xa(0, st, u), u !== c.cache && jd(o, [st], a, !0))), at(t, o, o.pendingProps.children, a), o.child;
      case 29:
        throw o.pendingProps;
    }
    throw Error(b(156, o.tag));
  }
  function pa(t) {
    t.flags |= 4;
  }
  function Gm(t, o) {
    if (o.type !== "stylesheet" || 4 & o.state.loading) t.flags &= -16777217;
    else if (t.flags |= 16777216, !oy(o)) {
      if ((o = qr.current) !== null && ((4194048 & xn) === xn ? Vt !== null : (62914560 & xn) !== xn && !(536870912 & xn) || o !== Vt)) throw xi = Wd, Vd;
      t.flags |= 8192;
    }
  }
  function Pn(t, o) {
    o !== null && (t.flags |= 4), 16384 & t.flags && (o = t.tag !== 22 ? Wn() : 536870912, t.lanes |= o, Ul |= o);
  }
  function Bi(t, o) {
    if (!bn) switch (t.tailMode) {
      case "hidden":
        o = t.tail;
        for (var a = null; o !== null; ) o.alternate !== null && (a = o), o = o.sibling;
        a === null ? t.tail = null : a.sibling = null;
        break;
      case "collapsed":
        a = t.tail;
        for (var u = null; a !== null; ) a.alternate !== null && (u = a), a = a.sibling;
        u === null ? o || t.tail === null ? t.tail = null : t.tail.sibling = null : u.sibling = null;
    }
  }
  function ft(t) {
    var o = t.alternate !== null && t.alternate.child === t.child, a = 0, u = 0;
    if (o) for (var c = t.child; c !== null; ) a |= c.lanes | c.childLanes, u |= 65011712 & c.subtreeFlags, u |= 65011712 & c.flags, c.return = t, c = c.sibling;
    else for (c = t.child; c !== null; ) a |= c.lanes | c.childLanes, u |= c.subtreeFlags, u |= c.flags, c.return = t, c = c.sibling;
    return t.subtreeFlags |= u, t.childLanes = a, o;
  }
  function Ig(t, o, a) {
    var u = o.pendingProps;
    switch (Ya(o), o.tag) {
      case 31:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
      case 1:
        return ft(o), null;
      case 3:
        return a = o.stateNode, u = null, t !== null && (u = t.memoizedState.cache), o.memoizedState.cache !== u && (o.flags |= 2048), ta(st), _e(), a.pendingContext && (a.context = a.pendingContext, a.pendingContext = null), t !== null && t.child !== null || (Nu(o) ? pa(o) : t === null || t.memoizedState.isDehydrated && !(256 & o.flags) || (o.flags |= 1024, cm())), ft(o), null;
      case 26:
        return a = o.memoizedState, t === null ? (pa(o), a !== null ? (ft(o), Gm(o, a)) : (ft(o), o.flags &= -16777217)) : a ? a !== t.memoizedState ? (pa(o), ft(o), Gm(o, a)) : (ft(o), o.flags &= -16777217) : (t.memoizedProps !== u && pa(o), ft(o), o.flags &= -16777217), null;
      case 27:
        Fn(o), a = Ie.current;
        var c = o.type;
        if (t !== null && o.stateNode != null) t.memoizedProps !== u && pa(o);
        else {
          if (!u) {
            if (o.stateNode === null) throw Error(b(166));
            return ft(o), null;
          }
          t = He.current, Nu(o) ? um(o) : (t = ey(c, u, a), o.stateNode = t, pa(o));
        }
        return ft(o), null;
      case 5:
        if (Fn(o), a = o.type, t !== null && o.stateNode != null) t.memoizedProps !== u && pa(o);
        else {
          if (!u) {
            if (o.stateNode === null) throw Error(b(166));
            return ft(o), null;
          }
          if (t = He.current, Nu(o)) um(o);
          else {
            switch (c = Lo(Ie.current), t) {
              case 1:
                t = c.createElementNS("http://www.w3.org/2000/svg", a);
                break;
              case 2:
                t = c.createElementNS("http://www.w3.org/1998/Math/MathML", a);
                break;
              default:
                switch (a) {
                  case "svg":
                    t = c.createElementNS("http://www.w3.org/2000/svg", a);
                    break;
                  case "math":
                    t = c.createElementNS("http://www.w3.org/1998/Math/MathML", a);
                    break;
                  case "script":
                    (t = c.createElement("div")).innerHTML = "<script><\/script>", t = t.removeChild(t.firstChild);
                    break;
                  case "select":
                    t = typeof u.is == "string" ? c.createElement("select", { is: u.is }) : c.createElement("select"), u.multiple ? t.multiple = !0 : u.size && (t.size = u.size);
                    break;
                  default:
                    t = typeof u.is == "string" ? c.createElement(a, { is: u.is }) : c.createElement(a);
                }
            }
            t[Ut] = o, t[pr] = u;
            e: for (c = o.child; c !== null; ) {
              if (c.tag === 5 || c.tag === 6) t.appendChild(c.stateNode);
              else if (c.tag !== 4 && c.tag !== 27 && c.child !== null) {
                c.child.return = c, c = c.child;
                continue;
              }
              if (c === o) break e;
              for (; c.sibling === null; ) {
                if (c.return === null || c.return === o) break e;
                c = c.return;
              }
              c.sibling.return = c.return, c = c.sibling;
            }
            o.stateNode = t;
            e: switch (Pt(t, a, u), a) {
              case "button":
              case "input":
              case "select":
              case "textarea":
                t = !!u.autoFocus;
                break e;
              case "img":
                t = !0;
                break e;
              default:
                t = !1;
            }
            t && pa(o);
          }
        }
        return ft(o), o.flags &= -16777217, null;
      case 6:
        if (t && o.stateNode != null) t.memoizedProps !== u && pa(o);
        else {
          if (typeof u != "string" && o.stateNode === null) throw Error(b(166));
          if (t = Ie.current, Nu(o)) {
            if (t = o.stateNode, a = o.memoizedProps, u = null, (c = Yn) !== null) switch (c.tag) {
              case 27:
              case 5:
                u = c.memoizedProps;
            }
            t[Ut] = o, (t = !!(t.nodeValue === a || u !== null && u.suppressHydrationWarning === !0 || It(t.nodeValue, a))) || ea(o);
          } else (t = Lo(t).createTextNode(u))[Ut] = o, o.stateNode = t;
        }
        return ft(o), null;
      case 13:
        if (u = o.memoizedState, t === null || t.memoizedState !== null && t.memoizedState.dehydrated !== null) {
          if (c = Nu(o), u !== null && u.dehydrated !== null) {
            if (t === null) {
              if (!c) throw Error(b(318));
              if (!(c = (c = o.memoizedState) !== null ? c.dehydrated : null)) throw Error(b(317));
              c[Ut] = o;
            } else _u(), !(128 & o.flags) && (o.memoizedState = null), o.flags |= 4;
            ft(o), c = !1;
          } else c = cm(), t !== null && t.memoizedState !== null && (t.memoizedState.hydrationErrors = c), c = !0;
          if (!c) return 256 & o.flags ? (fa(o), o) : (fa(o), null);
        }
        if (fa(o), 128 & o.flags) return o.lanes = a, o;
        if (a = u !== null, t = t !== null && t.memoizedState !== null, a) {
          c = null, (u = o.child).alternate !== null && u.alternate.memoizedState !== null && u.alternate.memoizedState.cachePool !== null && (c = u.alternate.memoizedState.cachePool.pool);
          var d = null;
          u.memoizedState !== null && u.memoizedState.cachePool !== null && (d = u.memoizedState.cachePool.pool), d !== c && (u.flags |= 2048);
        }
        return a !== t && a && (o.child.flags |= 8192), Pn(o, o.updateQueue), ft(o), null;
      case 4:
        return _e(), t === null && mo(o.stateNode.containerInfo), ft(o), null;
      case 10:
        return ta(o.type), ft(o), null;
      case 19:
        if (ce($n), (c = o.memoizedState) === null) return ft(o), null;
        if (u = !!(128 & o.flags), (d = c.rendering) === null) if (u) Bi(c, !1);
        else {
          if (pt !== 0 || t !== null && 128 & t.flags) for (t = o.child; t !== null; ) {
            if ((d = lc(t)) !== null) {
              for (o.flags |= 128, Bi(c, !1), t = d.updateQueue, o.updateQueue = t, Pn(o, t), o.subtreeFlags = 0, t = a, a = o.child; a !== null; ) on(a, t), a = a.sibling;
              return Te($n, 1 & $n.current | 2), o.child;
            }
            t = t.sibling;
          }
          c.tail !== null && oo() > yc && (o.flags |= 128, u = !0, Bi(c, !1), o.lanes = 4194304);
        }
        else {
          if (!u) if ((t = lc(d)) !== null) {
            if (o.flags |= 128, u = !0, t = t.updateQueue, o.updateQueue = t, Pn(o, t), Bi(c, !0), c.tail === null && c.tailMode === "hidden" && !d.alternate && !bn) return ft(o), null;
          } else 2 * oo() - c.renderingStartTime > yc && a !== 536870912 && (o.flags |= 128, u = !0, Bi(c, !1), o.lanes = 4194304);
          c.isBackwards ? (d.sibling = o.child, o.child = d) : ((t = c.last) !== null ? t.sibling = d : o.child = d, c.last = d);
        }
        return c.tail !== null ? (o = c.tail, c.rendering = o, c.tail = o.sibling, c.renderingStartTime = oo(), o.sibling = null, t = $n.current, Te($n, u ? 1 & t | 2 : 1 & t), o) : (ft(o), null);
      case 22:
      case 23:
        return fa(o), Du(), u = o.memoizedState !== null, t !== null ? t.memoizedState !== null !== u && (o.flags |= 8192) : u && (o.flags |= 8192), u ? 536870912 & a && !(128 & o.flags) && (ft(o), 6 & o.subtreeFlags && (o.flags |= 8192)) : ft(o), (a = o.updateQueue) !== null && Pn(o, a.retryQueue), a = null, t !== null && t.memoizedState !== null && t.memoizedState.cachePool !== null && (a = t.memoizedState.cachePool.pool), u = null, o.memoizedState !== null && o.memoizedState.cachePool !== null && (u = o.memoizedState.cachePool.pool), u !== a && (o.flags |= 2048), t !== null && ce(Ja), null;
      case 24:
        return a = null, t !== null && (a = t.memoizedState.cache), o.memoizedState.cache !== a && (o.flags |= 2048), ta(st), ft(o), null;
      case 25:
      case 30:
        return null;
    }
    throw Error(b(156, o.tag));
  }
  function ob(t, o) {
    switch (Ya(o), o.tag) {
      case 1:
        return 65536 & (t = o.flags) ? (o.flags = -65537 & t | 128, o) : null;
      case 3:
        return ta(st), _e(), 65536 & (t = o.flags) && !(128 & t) ? (o.flags = -65537 & t | 128, o) : null;
      case 26:
      case 27:
      case 5:
        return Fn(o), null;
      case 13:
        if (fa(o), (t = o.memoizedState) !== null && t.dehydrated !== null) {
          if (o.alternate === null) throw Error(b(340));
          _u();
        }
        return 65536 & (t = o.flags) ? (o.flags = -65537 & t | 128, o) : null;
      case 19:
        return ce($n), null;
      case 4:
        return _e(), null;
      case 10:
        return ta(o.type), null;
      case 22:
      case 23:
        return fa(o), Du(), t !== null && ce(Ja), 65536 & (t = o.flags) ? (o.flags = -65537 & t | 128, o) : null;
      case 24:
        return ta(st), null;
      default:
        return null;
    }
  }
  function Mg(t, o) {
    switch (Ya(o), o.tag) {
      case 3:
        ta(st), _e();
        break;
      case 26:
      case 27:
      case 5:
        Fn(o);
        break;
      case 4:
        _e();
        break;
      case 13:
        fa(o);
        break;
      case 19:
        ce($n);
        break;
      case 10:
        ta(o.type);
        break;
      case 22:
      case 23:
        fa(o), Du(), t !== null && ce(Ja);
        break;
      case 24:
        ta(st);
    }
  }
  function Vi(t, o) {
    try {
      var a = o.updateQueue, u = a !== null ? a.lastEffect : null;
      if (u !== null) {
        var c = u.next;
        a = c;
        do {
          if ((a.tag & t) === t) {
            u = void 0;
            var d = a.create, g = a.inst;
            u = d(), g.destroy = u;
          }
          a = a.next;
        } while (a !== c);
      }
    } catch (h) {
      An(o, o.return, h);
    }
  }
  function rl(t, o, a) {
    try {
      var u = o.updateQueue, c = u !== null ? u.lastEffect : null;
      if (c !== null) {
        var d = c.next;
        u = d;
        do {
          if ((u.tag & t) === t) {
            var g = u.inst, h = g.destroy;
            if (h !== void 0) {
              g.destroy = void 0, c = o;
              var w = a, x = h;
              try {
                x();
              } catch (B) {
                An(c, w, B);
              }
            }
          }
          u = u.next;
        } while (u !== d);
      }
    } catch (B) {
      An(o, o.return, B);
    }
  }
  function Km(t) {
    var o = t.updateQueue;
    if (o !== null) {
      var a = t.stateNode;
      try {
        Ks(o, a);
      } catch (u) {
        An(t, t.return, u);
      }
    }
  }
  function Xm(t, o, a) {
    a.props = Ao(t.type, t.memoizedProps), a.state = t.memoizedState;
    try {
      a.componentWillUnmount();
    } catch (u) {
      An(t, o, u);
    }
  }
  function ol(t, o) {
    try {
      var a = t.ref;
      if (a !== null) {
        switch (t.tag) {
          case 26:
          case 27:
          case 5:
            var u = t.stateNode;
            break;
          default:
            u = t.stateNode;
        }
        typeof a == "function" ? t.refCleanup = a(u) : a.current = u;
      }
    } catch (c) {
      An(t, o, c);
    }
  }
  function Tt(t, o) {
    var a = t.ref, u = t.refCleanup;
    if (a !== null) if (typeof u == "function") try {
      u();
    } catch (c) {
      An(t, o, c);
    } finally {
      t.refCleanup = null, (t = t.alternate) != null && (t.refCleanup = null);
    }
    else if (typeof a == "function") try {
      a(null);
    } catch (c) {
      An(t, o, c);
    }
    else a.current = null;
  }
  function Uu(t) {
    var o = t.type, a = t.memoizedProps, u = t.stateNode;
    try {
      e: switch (o) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          a.autoFocus && u.focus();
          break e;
        case "img":
          a.src ? u.src = a.src : a.srcSet && (u.srcset = a.srcSet);
      }
    } catch (c) {
      An(t, t.return, c);
    }
  }
  function $m(t, o, a) {
    try {
      var u = t.stateNode;
      (function(c, d, g, h) {
        switch (d) {
          case "div":
          case "span":
          case "svg":
          case "path":
          case "a":
          case "g":
          case "p":
          case "li":
            break;
          case "input":
            var w = null, x = null, B = null, q = null, ee = null, le = null, de = null;
            for (M in g) {
              var I = g[M];
              if (g.hasOwnProperty(M) && I != null) switch (M) {
                case "checked":
                case "value":
                  break;
                case "defaultValue":
                  ee = I;
                default:
                  h.hasOwnProperty(M) || Fe(c, d, M, null, h, I);
              }
            }
            for (var _ in h) {
              var M = h[_];
              if (I = g[_], h.hasOwnProperty(_) && (M != null || I != null)) switch (_) {
                case "type":
                  x = M;
                  break;
                case "name":
                  w = M;
                  break;
                case "checked":
                  le = M;
                  break;
                case "defaultChecked":
                  de = M;
                  break;
                case "value":
                  B = M;
                  break;
                case "defaultValue":
                  q = M;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  if (M != null) throw Error(b(137, d));
                  break;
                default:
                  M !== I && Fe(c, d, _, M, h, I);
              }
            }
            return void bd(c, B, q, ee, le, de, x, w);
          case "select":
            for (x in M = B = q = _ = null, g) if (ee = g[x], g.hasOwnProperty(x) && ee != null) switch (x) {
              case "value":
                break;
              case "multiple":
                M = ee;
              default:
                h.hasOwnProperty(x) || Fe(c, d, x, null, h, ee);
            }
            for (w in h) if (x = h[w], ee = g[w], h.hasOwnProperty(w) && (x != null || ee != null)) switch (w) {
              case "value":
                _ = x;
                break;
              case "defaultValue":
                q = x;
                break;
              case "multiple":
                B = x;
              default:
                x !== ee && Fe(c, d, w, x, h, ee);
            }
            return d = q, g = B, h = M, void (_ != null ? si(c, !!g, _, !1) : !!h != !!g && (d != null ? si(c, !!g, d, !0) : si(c, !!g, g ? [] : "", !1)));
          case "textarea":
            for (q in M = _ = null, g) if (w = g[q], g.hasOwnProperty(q) && w != null && !h.hasOwnProperty(q)) switch (q) {
              case "value":
              case "children":
                break;
              default:
                Fe(c, d, q, null, h, w);
            }
            for (B in h) if (w = h[B], x = g[B], h.hasOwnProperty(B) && (w != null || x != null)) switch (B) {
              case "value":
                _ = w;
                break;
              case "defaultValue":
                M = w;
                break;
              case "children":
                break;
              case "dangerouslySetInnerHTML":
                if (w != null) throw Error(b(91));
                break;
              default:
                w !== x && Fe(c, d, B, w, h, x);
            }
            return void kd(c, _, M);
          case "option":
            for (var ie in g) _ = g[ie], g.hasOwnProperty(ie) && _ != null && !h.hasOwnProperty(ie) && (ie === "selected" ? c.selected = !1 : Fe(c, d, ie, null, h, _));
            for (ee in h) _ = h[ee], M = g[ee], h.hasOwnProperty(ee) && _ !== M && (_ != null || M != null) && (ee === "selected" ? c.selected = _ && typeof _ != "function" && typeof _ != "symbol" : Fe(c, d, ee, _, h, M));
            return;
          case "img":
          case "link":
          case "area":
          case "base":
          case "br":
          case "col":
          case "embed":
          case "hr":
          case "keygen":
          case "meta":
          case "param":
          case "source":
          case "track":
          case "wbr":
          case "menuitem":
            for (var xe in g) _ = g[xe], g.hasOwnProperty(xe) && _ != null && !h.hasOwnProperty(xe) && Fe(c, d, xe, null, h, _);
            for (le in h) if (_ = h[le], M = g[le], h.hasOwnProperty(le) && _ !== M && (_ != null || M != null)) switch (le) {
              case "children":
              case "dangerouslySetInnerHTML":
                if (_ != null) throw Error(b(137, d));
                break;
              default:
                Fe(c, d, le, _, h, M);
            }
            return;
          default:
            if (wd(d)) {
              for (var Re in g) _ = g[Re], g.hasOwnProperty(Re) && _ !== void 0 && !h.hasOwnProperty(Re) && gh(c, d, Re, void 0, h, _);
              for (de in h) _ = h[de], M = g[de], !h.hasOwnProperty(de) || _ === M || _ === void 0 && M === void 0 || gh(c, d, de, _, h, M);
              return;
            }
        }
        for (var Ve in g) _ = g[Ve], g.hasOwnProperty(Ve) && _ != null && !h.hasOwnProperty(Ve) && Fe(c, d, Ve, null, h, _);
        for (I in h) _ = h[I], M = g[I], !h.hasOwnProperty(I) || _ === M || _ == null && M == null || Fe(c, d, I, _, h, M);
      })(u, t.type, a, o), u[pr] = o;
    } catch (c) {
      An(t, t.return, c);
    }
  }
  function wf(t) {
    return t.tag === 5 || t.tag === 3 || t.tag === 26 || t.tag === 27 && Ql(t.type) || t.tag === 4;
  }
  function Sf(t) {
    e: for (; ; ) {
      for (; t.sibling === null; ) {
        if (t.return === null || wf(t.return)) return null;
        t = t.return;
      }
      for (t.sibling.return = t.return, t = t.sibling; t.tag !== 5 && t.tag !== 6 && t.tag !== 18; ) {
        if (t.tag === 27 && Ql(t.type) || 2 & t.flags || t.child === null || t.tag === 4) continue e;
        t.child.return = t, t = t.child;
      }
      if (!(2 & t.flags)) return t.stateNode;
    }
  }
  function Ef(t, o, a) {
    var u = t.tag;
    if (u === 5 || u === 6) t = t.stateNode, o ? (a.nodeType === 9 ? a.body : a.nodeName === "HTML" ? a.ownerDocument.body : a).insertBefore(t, o) : ((o = a.nodeType === 9 ? a.body : a.nodeName === "HTML" ? a.ownerDocument.body : a).appendChild(t), (a = a._reactRootContainer) != null || o.onclick !== null || (o.onclick = J));
    else if (u !== 4 && (u === 27 && Ql(t.type) && (a = t.stateNode, o = null), (t = t.child) !== null)) for (Ef(t, o, a), t = t.sibling; t !== null; ) Ef(t, o, a), t = t.sibling;
  }
  function mc(t, o, a) {
    var u = t.tag;
    if (u === 5 || u === 6) t = t.stateNode, o ? a.insertBefore(t, o) : a.appendChild(t);
    else if (u !== 4 && (u === 27 && Ql(t.type) && (a = t.stateNode), (t = t.child) !== null)) for (mc(t, o, a), t = t.sibling; t !== null; ) mc(t, o, a), t = t.sibling;
  }
  function xf(t) {
    var o = t.stateNode, a = t.memoizedProps;
    try {
      for (var u = t.type, c = o.attributes; c.length; ) o.removeAttributeNode(c[0]);
      Pt(o, u, a), o[Ut] = t, o[pr] = a;
    } catch (d) {
      An(t, t.return, d);
    }
  }
  var ma = !1, lt = !1, Cf = !1, Zm = typeof WeakSet == "function" ? WeakSet : Set, ht = null;
  function Jm(t, o, a) {
    var u = a.flags;
    switch (a.tag) {
      case 0:
      case 11:
      case 15:
        al(t, a), 4 & u && Vi(5, a);
        break;
      case 1:
        if (al(t, a), 4 & u) if (t = a.stateNode, o === null) try {
          t.componentDidMount();
        } catch (g) {
          An(a, a.return, g);
        }
        else {
          var c = Ao(a.type, o.memoizedProps);
          o = o.memoizedState;
          try {
            t.componentDidUpdate(c, o, t.__reactInternalSnapshotBeforeUpdate);
          } catch (g) {
            An(a, a.return, g);
          }
        }
        64 & u && Km(a), 512 & u && ol(a, a.return);
        break;
      case 3:
        if (al(t, a), 64 & u && (t = a.updateQueue) !== null) {
          if (o = null, a.child !== null) switch (a.child.tag) {
            case 27:
            case 5:
            case 1:
              o = a.child.stateNode;
          }
          try {
            Ks(t, o);
          } catch (g) {
            An(a, a.return, g);
          }
        }
        break;
      case 27:
        o === null && 4 & u && xf(a);
      case 26:
      case 5:
        al(t, a), o === null && 4 & u && Uu(a), 512 & u && ol(a, a.return);
        break;
      case 12:
        al(t, a);
        break;
      case 13:
        al(t, a), 4 & u && Bu(t, a), 64 & u && (t = a.memoizedState) !== null && (t = t.dehydrated) !== null && function(g, h) {
          var w = g.ownerDocument;
          if (g.data !== "$?" || w.readyState === "complete") h();
          else {
            var x = function() {
              h(), w.removeEventListener("DOMContentLoaded", x);
            };
            w.addEventListener("DOMContentLoaded", x), g._reactRetry = x;
          }
        }(t, a = ab.bind(null, a));
        break;
      case 22:
        if (!(u = a.memoizedState !== null || ma)) {
          o = o !== null && o.memoizedState !== null || lt, c = ma;
          var d = lt;
          ma = u, (lt = o) && !d ? ll(t, a, !!(8772 & a.subtreeFlags)) : al(t, a), ma = c, lt = d;
        }
        break;
      case 30:
        break;
      default:
        al(t, a);
    }
  }
  function fn(t) {
    var o = t.alternate;
    o !== null && (t.alternate = null, fn(o)), t.child = null, t.deletions = null, t.sibling = null, t.tag === 5 && (o = t.stateNode) !== null && pu(o), t.stateNode = null, t.return = null, t.dependencies = null, t.memoizedProps = null, t.memoizedState = null, t.pendingProps = null, t.stateNode = null, t.updateQueue = null;
  }
  var Gn = null, or = !1;
  function ha(t, o, a) {
    for (a = a.child; a !== null; ) Tf(t, o, a), a = a.sibling;
  }
  function Tf(t, o, a) {
    if (_t && typeof _t.onCommitFiberUnmount == "function") try {
      _t.onCommitFiberUnmount(Ba, a);
    } catch {
    }
    switch (a.tag) {
      case 26:
        lt || Tt(a, o), ha(t, o, a), a.memoizedState ? a.memoizedState.count-- : a.stateNode && (a = a.stateNode).parentNode.removeChild(a);
        break;
      case 27:
        lt || Tt(a, o);
        var u = Gn, c = or;
        Ql(a.type) && (Gn = a.stateNode, or = !1), ha(t, o, a), Ca(a.stateNode), Gn = u, or = c;
        break;
      case 5:
        lt || Tt(a, o);
      case 6:
        if (u = Gn, c = or, Gn = null, ha(t, o, a), or = c, (Gn = u) !== null) if (or) try {
          (Gn.nodeType === 9 ? Gn.body : Gn.nodeName === "HTML" ? Gn.ownerDocument.body : Gn).removeChild(a.stateNode);
        } catch (d) {
          An(a, o, d);
        }
        else try {
          Gn.removeChild(a.stateNode);
        } catch (d) {
          An(a, o, d);
        }
        break;
      case 18:
        Gn !== null && (or ? (Yf((t = Gn).nodeType === 9 ? t.body : t.nodeName === "HTML" ? t.ownerDocument.body : t, a.stateNode), Ra(t)) : Yf(Gn, a.stateNode));
        break;
      case 4:
        u = Gn, c = or, Gn = a.stateNode.containerInfo, or = !0, ha(t, o, a), Gn = u, or = c;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        lt || rl(2, a, o), lt || rl(4, a, o), ha(t, o, a);
        break;
      case 1:
        lt || (Tt(a, o), typeof (u = a.stateNode).componentWillUnmount == "function" && Xm(a, o, u)), ha(t, o, a);
        break;
      case 21:
        ha(t, o, a);
        break;
      case 22:
        lt = (u = lt) || a.memoizedState !== null, ha(t, o, a), lt = u;
        break;
      default:
        ha(t, o, a);
    }
  }
  function Bu(t, o) {
    if (o.memoizedState === null && (t = o.alternate) !== null && (t = t.memoizedState) !== null && (t = t.dehydrated) !== null) try {
      Ra(t);
    } catch (a) {
      An(o, o.return, a);
    }
  }
  function Vu(t, o) {
    var a = function(u) {
      switch (u.tag) {
        case 13:
        case 19:
          var c = u.stateNode;
          return c === null && (c = u.stateNode = new Zm()), c;
        case 22:
          return (c = (u = u.stateNode)._retryCache) === null && (c = u._retryCache = new Zm()), c;
        default:
          throw Error(b(435, u.tag));
      }
    }(t);
    o.forEach(function(u) {
      var c = Vf.bind(null, t, u);
      a.has(u) || (a.add(u), u.then(c, c));
    });
  }
  function Wt(t, o) {
    var a = o.deletions;
    if (a !== null) for (var u = 0; u < a.length; u++) {
      var c = a[u], d = t, g = o, h = g;
      e: for (; h !== null; ) {
        switch (h.tag) {
          case 27:
            if (Ql(h.type)) {
              Gn = h.stateNode, or = !1;
              break e;
            }
            break;
          case 5:
            Gn = h.stateNode, or = !1;
            break e;
          case 3:
          case 4:
            Gn = h.stateNode.containerInfo, or = !0;
            break e;
        }
        h = h.return;
      }
      if (Gn === null) throw Error(b(160));
      Tf(d, g, c), Gn = null, or = !1, (d = c.alternate) !== null && (d.return = null), c.return = null;
    }
    if (13878 & o.subtreeFlags) for (o = o.child; o !== null; ) Pf(o, t), o = o.sibling;
  }
  var po = null;
  function Pf(t, o) {
    var a = t.alternate, u = t.flags;
    switch (t.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        Wt(o, t), zn(t), 4 & u && (rl(3, t, t.return), Vi(3, t), rl(5, t, t.return));
        break;
      case 1:
        Wt(o, t), zn(t), 512 & u && (lt || a === null || Tt(a, a.return)), 64 & u && ma && (t = t.updateQueue) !== null && (u = t.callbacks) !== null && (a = t.shared.hiddenCallbacks, t.shared.hiddenCallbacks = a === null ? u : a.concat(u));
        break;
      case 26:
        var c = po;
        if (Wt(o, t), zn(t), 512 & u && (lt || a === null || Tt(a, a.return)), 4 & u) {
          var d = a !== null ? a.memoizedState : null;
          if (u = t.memoizedState, a === null) if (u === null) if (t.stateNode === null) {
            e: {
              u = t.type, a = t.memoizedProps, c = c.ownerDocument || c;
              n: switch (u) {
                case "title":
                  (!(d = c.getElementsByTagName("title")[0]) || d[fu] || d[Ut] || d.namespaceURI === "http://www.w3.org/2000/svg" || d.hasAttribute("itemprop")) && (d = c.createElement(u), c.head.insertBefore(d, c.querySelector("head > title"))), Pt(d, u, a), d[Ut] = t, kt(d), u = d;
                  break e;
                case "link":
                  var g = Gf("link", "href", c).get(u + (a.href || ""));
                  if (g) {
                    for (var h = 0; h < g.length; h++) if ((d = g[h]).getAttribute("href") === (a.href == null || a.href === "" ? null : a.href) && d.getAttribute("rel") === (a.rel == null ? null : a.rel) && d.getAttribute("title") === (a.title == null ? null : a.title) && d.getAttribute("crossorigin") === (a.crossOrigin == null ? null : a.crossOrigin)) {
                      g.splice(h, 1);
                      break n;
                    }
                  }
                  Pt(d = c.createElement(u), u, a), c.head.appendChild(d);
                  break;
                case "meta":
                  if (g = Gf("meta", "content", c).get(u + (a.content || ""))) {
                    for (h = 0; h < g.length; h++) if ((d = g[h]).getAttribute("content") === (a.content == null ? null : "" + a.content) && d.getAttribute("name") === (a.name == null ? null : a.name) && d.getAttribute("property") === (a.property == null ? null : a.property) && d.getAttribute("http-equiv") === (a.httpEquiv == null ? null : a.httpEquiv) && d.getAttribute("charset") === (a.charSet == null ? null : a.charSet)) {
                      g.splice(h, 1);
                      break n;
                    }
                  }
                  Pt(d = c.createElement(u), u, a), c.head.appendChild(d);
                  break;
                default:
                  throw Error(b(468, u));
              }
              d[Ut] = t, kt(d), u = d;
            }
            t.stateNode = u;
          } else ry(c, t.type, t.stateNode);
          else t.stateNode = _c(c, u, t.memoizedProps);
          else d !== u ? (d === null ? a.stateNode !== null && (a = a.stateNode).parentNode.removeChild(a) : d.count--, u === null ? ry(c, t.type, t.stateNode) : _c(c, u, t.memoizedProps)) : u === null && t.stateNode !== null && $m(t, t.memoizedProps, a.memoizedProps);
        }
        break;
      case 27:
        Wt(o, t), zn(t), 512 & u && (lt || a === null || Tt(a, a.return)), a !== null && 4 & u && $m(t, t.memoizedProps, a.memoizedProps);
        break;
      case 5:
        if (Wt(o, t), zn(t), 512 & u && (lt || a === null || Tt(a, a.return)), 32 & t.flags) {
          c = t.stateNode;
          try {
            Wo(c, "");
          } catch (le) {
            An(t, t.return, le);
          }
        }
        4 & u && t.stateNode != null && $m(t, c = t.memoizedProps, a !== null ? a.memoizedProps : c), 1024 & u && (Cf = !0);
        break;
      case 6:
        if (Wt(o, t), zn(t), 4 & u) {
          if (t.stateNode === null) throw Error(b(162));
          u = t.memoizedProps, a = t.stateNode;
          try {
            a.nodeValue = u;
          } catch (le) {
            An(t, t.return, le);
          }
        }
        break;
      case 3:
        if (Io = null, c = po, po = Gr(o.containerInfo), Wt(o, t), po = c, zn(t), 4 & u && a !== null && a.memoizedState.isDehydrated) try {
          Ra(o.containerInfo);
        } catch (le) {
          An(t, t.return, le);
        }
        Cf && (Cf = !1, No(t));
        break;
      case 4:
        u = po, po = Gr(t.stateNode.containerInfo), Wt(o, t), zn(t), po = u;
        break;
      case 12:
      default:
        Wt(o, t), zn(t);
        break;
      case 13:
        Wt(o, t), zn(t), 8192 & t.child.flags && t.memoizedState !== null != (a !== null && a.memoizedState !== null) && (Of = oo()), 4 & u && (u = t.updateQueue) !== null && (t.updateQueue = null, Vu(t, u));
        break;
      case 22:
        c = t.memoizedState !== null;
        var w = a !== null && a.memoizedState !== null, x = ma, B = lt;
        if (ma = x || c, lt = B || w, Wt(o, t), lt = B, ma = x, zn(t), 8192 & u) e: for (o = t.stateNode, o._visibility = c ? -2 & o._visibility : 1 | o._visibility, c && (a === null || w || ma || lt || Qr(t)), a = null, o = t; ; ) {
          if (o.tag === 5 || o.tag === 26) {
            if (a === null) {
              w = a = o;
              try {
                if (d = w.stateNode, c) typeof (g = d.style).setProperty == "function" ? g.setProperty("display", "none", "important") : g.display = "none";
                else {
                  h = w.stateNode;
                  var q = w.memoizedProps.style, ee = q != null && q.hasOwnProperty("display") ? q.display : null;
                  h.style.display = ee == null || typeof ee == "boolean" ? "" : ("" + ee).trim();
                }
              } catch (le) {
                An(w, w.return, le);
              }
            }
          } else if (o.tag === 6) {
            if (a === null) {
              w = o;
              try {
                w.stateNode.nodeValue = c ? "" : w.memoizedProps;
              } catch (le) {
                An(w, w.return, le);
              }
            }
          } else if ((o.tag !== 22 && o.tag !== 23 || o.memoizedState === null || o === t) && o.child !== null) {
            o.child.return = o, o = o.child;
            continue;
          }
          if (o === t) break e;
          for (; o.sibling === null; ) {
            if (o.return === null || o.return === t) break e;
            a === o && (a = null), o = o.return;
          }
          a === o && (a = null), o.sibling.return = o.return, o = o.sibling;
        }
        4 & u && (u = t.updateQueue) !== null && (a = u.retryQueue) !== null && (u.retryQueue = null, Vu(t, a));
        break;
      case 19:
        Wt(o, t), zn(t), 4 & u && (u = t.updateQueue) !== null && (t.updateQueue = null, Vu(t, u));
      case 30:
      case 21:
    }
  }
  function zn(t) {
    var o = t.flags;
    if (2 & o) {
      try {
        for (var a, u = t.return; u !== null; ) {
          if (wf(u)) {
            a = u;
            break;
          }
          u = u.return;
        }
        if (a == null) throw Error(b(160));
        switch (a.tag) {
          case 27:
            var c = a.stateNode;
            mc(t, Sf(t), c);
            break;
          case 5:
            var d = a.stateNode;
            32 & a.flags && (Wo(d, ""), a.flags &= -33), mc(t, Sf(t), d);
            break;
          case 3:
          case 4:
            var g = a.stateNode.containerInfo;
            Ef(t, Sf(t), g);
            break;
          default:
            throw Error(b(161));
        }
      } catch (h) {
        An(t, t.return, h);
      }
      t.flags &= -3;
    }
    4096 & o && (t.flags &= -4097);
  }
  function No(t) {
    if (1024 & t.subtreeFlags) for (t = t.child; t !== null; ) {
      var o = t;
      No(o), o.tag === 5 && 1024 & o.flags && o.stateNode.reset(), t = t.sibling;
    }
  }
  function al(t, o) {
    if (8772 & o.subtreeFlags) for (o = o.child; o !== null; ) Jm(t, o.alternate, o), o = o.sibling;
  }
  function Qr(t) {
    for (t = t.child; t !== null; ) {
      var o = t;
      switch (o.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          rl(4, o, o.return), Qr(o);
          break;
        case 1:
          Tt(o, o.return);
          var a = o.stateNode;
          typeof a.componentWillUnmount == "function" && Xm(o, o.return, a), Qr(o);
          break;
        case 27:
          Ca(o.stateNode);
        case 26:
        case 5:
          Tt(o, o.return), Qr(o);
          break;
        case 22:
          o.memoizedState === null && Qr(o);
          break;
        default:
          Qr(o);
      }
      t = t.sibling;
    }
  }
  function ll(t, o, a) {
    for (a = a && !!(8772 & o.subtreeFlags), o = o.child; o !== null; ) {
      var u = o.alternate, c = t, d = o, g = d.flags;
      switch (d.tag) {
        case 0:
        case 11:
        case 15:
          ll(c, d, a), Vi(4, d);
          break;
        case 1:
          if (ll(c, d, a), typeof (c = (u = d).stateNode).componentDidMount == "function") try {
            c.componentDidMount();
          } catch (x) {
            An(u, u.return, x);
          }
          if ((c = (u = d).updateQueue) !== null) {
            var h = u.stateNode;
            try {
              var w = c.shared.hiddenCallbacks;
              if (w !== null) for (c.shared.hiddenCallbacks = null, c = 0; c < w.length; c++) Gd(w[c], h);
            } catch (x) {
              An(u, u.return, x);
            }
          }
          a && 64 & g && Km(d), ol(d, d.return);
          break;
        case 27:
          xf(d);
        case 26:
        case 5:
          ll(c, d, a), a && u === null && 4 & g && Uu(d), ol(d, d.return);
          break;
        case 12:
          ll(c, d, a);
          break;
        case 13:
          ll(c, d, a), a && 4 & g && Bu(c, d);
          break;
        case 22:
          d.memoizedState === null && ll(c, d, a), ol(d, d.return);
          break;
        case 30:
          break;
        default:
          ll(c, d, a);
      }
      o = o.sibling;
    }
  }
  function Wu(t, o) {
    var a = null;
    t !== null && t.memoizedState !== null && t.memoizedState.cachePool !== null && (a = t.memoizedState.cachePool.pool), t = null, o.memoizedState !== null && o.memoizedState.cachePool !== null && (t = o.memoizedState.cachePool.pool), t !== a && (t != null && t.refCount++, a != null && Si(a));
  }
  function Nn(t, o) {
    t = null, o.alternate !== null && (t = o.alternate.memoizedState.cache), (o = o.memoizedState.cache) !== t && (o.refCount++, t != null && Si(t));
  }
  function ga(t, o, a, u) {
    if (10256 & o.subtreeFlags) for (o = o.child; o !== null; ) zt(t, o, a, u), o = o.sibling;
  }
  function zt(t, o, a, u) {
    var c = o.flags;
    switch (o.tag) {
      case 0:
      case 11:
      case 15:
        ga(t, o, a, u), 2048 & c && Vi(9, o);
        break;
      case 1:
      case 13:
      default:
        ga(t, o, a, u);
        break;
      case 3:
        ga(t, o, a, u), 2048 & c && (t = null, o.alternate !== null && (t = o.alternate.memoizedState.cache), (o = o.memoizedState.cache) !== t && (o.refCount++, t != null && Si(t)));
        break;
      case 12:
        if (2048 & c) {
          ga(t, o, a, u), t = o.stateNode;
          try {
            var d = o.memoizedProps, g = d.id, h = d.onPostCommit;
            typeof h == "function" && h(g, o.alternate === null ? "mount" : "update", t.passiveEffectDuration, -0);
          } catch (w) {
            An(o, o.return, w);
          }
        } else ga(t, o, a, u);
        break;
      case 23:
        break;
      case 22:
        d = o.stateNode, g = o.alternate, o.memoizedState !== null ? 2 & d._visibility ? ga(t, o, a, u) : qi(t, o) : 2 & d._visibility ? ga(t, o, a, u) : (d._visibility |= 2, Wi(t, o, a, u, !!(10256 & o.subtreeFlags))), 2048 & c && Wu(g, o);
        break;
      case 24:
        ga(t, o, a, u), 2048 & c && Nn(o.alternate, o);
    }
  }
  function Wi(t, o, a, u, c) {
    for (c = c && !!(10256 & o.subtreeFlags), o = o.child; o !== null; ) {
      var d = t, g = o, h = a, w = u, x = g.flags;
      switch (g.tag) {
        case 0:
        case 11:
        case 15:
          Wi(d, g, h, w, c), Vi(8, g);
          break;
        case 23:
          break;
        case 22:
          var B = g.stateNode;
          g.memoizedState !== null ? 2 & B._visibility ? Wi(d, g, h, w, c) : qi(d, g) : (B._visibility |= 2, Wi(d, g, h, w, c)), c && 2048 & x && Wu(g.alternate, g);
          break;
        case 24:
          Wi(d, g, h, w, c), c && 2048 & x && Nn(g.alternate, g);
          break;
        default:
          Wi(d, g, h, w, c);
      }
      o = o.sibling;
    }
  }
  function qi(t, o) {
    if (10256 & o.subtreeFlags) for (o = o.child; o !== null; ) {
      var a = t, u = o, c = u.flags;
      switch (u.tag) {
        case 22:
          qi(a, u), 2048 & c && Wu(u.alternate, u);
          break;
        case 24:
          qi(a, u), 2048 & c && Nn(u.alternate, u);
          break;
        default:
          qi(a, u);
      }
      o = o.sibling;
    }
  }
  var qu = 8192;
  function ar(t) {
    if (t.subtreeFlags & qu) for (t = t.child; t !== null; ) eh(t), t = t.sibling;
  }
  function eh(t) {
    switch (t.tag) {
      case 26:
        ar(t), t.flags & qu && t.memoizedState !== null && function(a, u, c) {
          if (es === null) throw Error(b(475));
          var d = es;
          if (!(u.type !== "stylesheet" || typeof c.media == "string" && matchMedia(c.media).matches === !1 || 4 & u.state.loading)) {
            if (u.instance === null) {
              var g = Gl(c.href), h = a.querySelector(Ji(g));
              if (h) return (a = h._p) !== null && typeof a == "object" && typeof a.then == "function" && (d.count++, d = Lc.bind(d), a.then(d, d)), u.state.loading |= 4, u.instance = h, void kt(h);
              h = a.ownerDocument || a, c = Kr(c), (g = Bn.get(g)) && Mt(c, g), kt(h = h.createElement("link"));
              var w = h;
              w._p = new Promise(function(x, B) {
                w.onload = x, w.onerror = B;
              }), Pt(h, "link", c), u.instance = h;
            }
            d.stylesheets === null && (d.stylesheets = /* @__PURE__ */ new Map()), d.stylesheets.set(u, a), (a = u.state.preload) && !(3 & u.state.loading) && (d.count++, u = Lc.bind(d), a.addEventListener("load", u), a.addEventListener("error", u));
          }
        }(po, t.memoizedState, t.memoizedProps);
        break;
      case 5:
      default:
        ar(t);
        break;
      case 3:
      case 4:
        var o = po;
        po = Gr(t.stateNode.containerInfo), ar(t), po = o;
        break;
      case 22:
        t.memoizedState === null && ((o = t.alternate) !== null && o.memoizedState !== null ? (o = qu, qu = 16777216, ar(t), qu = o) : ar(t));
    }
  }
  function Rf(t) {
    var o = t.alternate;
    if (o !== null && (t = o.child) !== null) {
      o.child = null;
      do
        o = t.sibling, t.sibling = null, t = o;
      while (t !== null);
    }
  }
  function Af(t) {
    var o = t.deletions;
    if (16 & t.flags) {
      if (o !== null) for (var a = 0; a < o.length; a++) {
        var u = o[a];
        ht = u, gc(u, t);
      }
      Rf(t);
    }
    if (10256 & t.subtreeFlags) for (t = t.child; t !== null; ) Nf(t), t = t.sibling;
  }
  function Nf(t) {
    switch (t.tag) {
      case 0:
      case 11:
      case 15:
        Af(t), 2048 & t.flags && rl(9, t, t.return);
        break;
      case 3:
      case 12:
      default:
        Af(t);
        break;
      case 22:
        var o = t.stateNode;
        t.memoizedState !== null && 2 & o._visibility && (t.return === null || t.return.tag !== 13) ? (o._visibility &= -3, hc(t)) : Af(t);
    }
  }
  function hc(t) {
    var o = t.deletions;
    if (16 & t.flags) {
      if (o !== null) for (var a = 0; a < o.length; a++) {
        var u = o[a];
        ht = u, gc(u, t);
      }
      Rf(t);
    }
    for (t = t.child; t !== null; ) {
      switch ((o = t).tag) {
        case 0:
        case 11:
        case 15:
          rl(8, o, o.return), hc(o);
          break;
        case 22:
          2 & (a = o.stateNode)._visibility && (a._visibility &= -3, hc(o));
          break;
        default:
          hc(o);
      }
      t = t.sibling;
    }
  }
  function gc(t, o) {
    for (; ht !== null; ) {
      var a = ht;
      switch (a.tag) {
        case 0:
        case 11:
        case 15:
          rl(8, a, o);
          break;
        case 23:
        case 22:
          if (a.memoizedState !== null && a.memoizedState.cachePool !== null) {
            var u = a.memoizedState.cachePool.pool;
            u != null && u.refCount++;
          }
          break;
        case 24:
          Si(a.memoizedState.cache);
      }
      if ((u = a.child) !== null) u.return = a, ht = u;
      else e: for (a = t; ht !== null; ) {
        var c = (u = ht).sibling, d = u.return;
        if (fn(u), u === a) {
          ht = null;
          break e;
        }
        if (c !== null) {
          c.return = d, ht = c;
          break e;
        }
        ht = d;
      }
    }
  }
  var jg = { getCacheForType: function(t) {
    var o = Bt(st), a = o.data.get(t);
    return a === void 0 && (a = t(), o.data.set(t, a)), a;
  } }, Hg = typeof WeakMap == "function" ? WeakMap : Map, Rn = 0, Qn = null, hn = null, xn = 0, _n = 0, Yr = null, yr = !1, Qu = !1, nh = !1, ya = 0, pt = 0, Hl = 0, Qi = 0, th = 0, Or = 0, Ul = 0, lr = null, br = null, _f = !1, Of = 0, yc = 1 / 0, Lf = null, Bl = null, Dt = 0, Vl = null, ba = null, il = 0, zf = 0, Df = null, bc = null, va = 0, Yi = null;
  function Lr() {
    return 2 & Rn && xn !== 0 ? xn & -xn : Ae.T !== null ? ra !== 0 ? ra : Cc() : ri();
  }
  function Gi() {
    Or === 0 && (Or = 536870912 & xn && !bn ? 536870912 : dn());
    var t = qr.current;
    return t !== null && (t.flags |= 32), Or;
  }
  function qt(t, o, a) {
    (t !== Qn || _n !== 2 && _n !== 9) && t.cancelPendingCommit === null || (Ki(t, 0), ka(t, xn, Or, !1)), Ze(t, a), 2 & Rn && t === Qn || (t === Qn && (!(2 & Rn) && (Qi |= a), pt === 4 && ka(t, xn, Or, !1)), _o(t));
  }
  function rh(t, o, a) {
    if (6 & Rn) throw Error(b(327));
    for (var u = !a && !(124 & o) && (o & t.expiredLanes) === 0 || we(t, o), c = u ? function(x, B) {
      var q = Rn;
      Rn |= 2;
      var ee = wc(), le = If();
      Qn !== x || xn !== B ? (Lf = null, yc = oo() + 500, Ki(x, B)) : Qu = we(x, B);
      e: for (; ; ) try {
        if (_n !== 0 && hn !== null) {
          B = hn;
          var de = Yr;
          n: switch (_n) {
            case 1:
              _n = 0, Yr = null, Wl(x, B, de, 1);
              break;
            case 2:
            case 9:
              if (qd(de)) {
                _n = 0, Yr = null, ih(B);
                break;
              }
              B = function() {
                _n !== 2 && _n !== 9 || Qn !== x || (_n = 7), _o(x);
              }, de.then(B, B);
              break e;
            case 3:
              _n = 7;
              break e;
            case 4:
              _n = 5;
              break e;
            case 7:
              qd(de) ? (_n = 0, Yr = null, ih(B)) : (_n = 0, Yr = null, Wl(x, B, de, 7));
              break;
            case 5:
              var I = null;
              switch (hn.tag) {
                case 26:
                  I = hn.memoizedState;
                case 5:
                case 27:
                  var _ = hn;
                  if (!I || oy(I)) {
                    _n = 0, Yr = null;
                    var M = _.sibling;
                    if (M !== null) hn = M;
                    else {
                      var ie = _.return;
                      ie !== null ? (hn = ie, Sc(ie)) : hn = null;
                    }
                    break n;
                  }
              }
              _n = 0, Yr = null, Wl(x, B, de, 5);
              break;
            case 6:
              _n = 0, Yr = null, Wl(x, B, de, 6);
              break;
            case 8:
              Ff(), pt = 6;
              break e;
            default:
              throw Error(b(462));
          }
        }
        Vg();
        break;
      } catch (xe) {
        Ug(x, xe);
      }
      return na = Ka = null, Ae.H = ee, Ae.A = le, Rn = q, hn !== null ? 0 : (Qn = null, xn = 0, xo(), pt);
    }(t, o) : lh(t, o, !0), d = u; ; ) {
      if (c === 0) {
        Qu && !u && ka(t, o, 0, !1);
        break;
      }
      if (a = t.current.alternate, !d || oh(a)) {
        if (c === 2) {
          if (d = o, t.errorRecoveryDisabledLanes & d) var g = 0;
          else g = (g = -536870913 & t.pendingLanes) !== 0 ? g : 536870912 & g ? 536870912 : 0;
          if (g !== 0) {
            o = g;
            e: {
              var h = t;
              c = lr;
              var w = h.current.memoizedState.isDehydrated;
              if (w && (Ki(h, g).flags |= 256), (g = lh(h, g, !1)) !== 2) {
                if (nh && !w) {
                  h.errorRecoveryDisabledLanes |= d, Qi |= d, c = 4;
                  break e;
                }
                d = br, br = c, d !== null && (br === null ? br = d : br.push.apply(br, d));
              }
              c = g;
            }
            if (d = !1, c !== 2) continue;
          }
        }
        if (c === 1) {
          Ki(t, 0), ka(t, o, 0, !0);
          break;
        }
        e: {
          switch (u = t, d = c) {
            case 0:
            case 1:
              throw Error(b(345));
            case 4:
              if ((4194048 & o) !== o) break;
            case 6:
              ka(u, o, Or, !yr);
              break e;
            case 2:
              br = null;
              break;
            case 3:
            case 5:
              break;
            default:
              throw Error(b(329));
          }
          if ((62914560 & o) === o && 10 < (c = Of + 300 - oo())) {
            if (ka(u, o, Or, !yr), be(u, 0, !0) !== 0) break e;
            u.timeoutHandle = Qf(vc.bind(null, u, a, br, Lf, _f, o, Or, Qi, Ul, yr, d, 2, -0, 0), c);
          } else vc(u, a, br, Lf, _f, o, Or, Qi, Ul, yr, d, 0, -0, 0);
        }
        break;
      }
      c = lh(t, o, !1), d = !1;
    }
    _o(t);
  }
  function vc(t, o, a, u, c, d, g, h, w, x, B, q, ee, le) {
    if (t.timeoutHandle = -1, (8192 & (q = o.subtreeFlags) || !(16785408 & ~q)) && (es = { stylesheets: null, count: 0, unsuspend: Oc }, eh(o), (q = function() {
      if (es === null) throw Error(b(475));
      var de = es;
      return de.stylesheets && de.count === 0 && zc(de, de.stylesheets), 0 < de.count ? function(I) {
        var _ = setTimeout(function() {
          if (de.stylesheets && zc(de, de.stylesheets), de.unsuspend) {
            var M = de.unsuspend;
            de.unsuspend = null, M();
          }
        }, 6e4);
        return de.unsuspend = I, function() {
          de.unsuspend = null, clearTimeout(_);
        };
      } : null;
    }()) !== null)) return t.cancelPendingCommit = q(qg.bind(null, t, o, d, a, u, c, g, h, w, B, 1, ee, le)), void ka(t, d, g, !x);
    qg(t, o, d, a, u, c, g, h, w);
  }
  function oh(t) {
    for (var o = t; ; ) {
      var a = o.tag;
      if ((a === 0 || a === 11 || a === 15) && 16384 & o.flags && (a = o.updateQueue) !== null && (a = a.stores) !== null) for (var u = 0; u < a.length; u++) {
        var c = a[u], d = c.getSnapshot;
        c = c.value;
        try {
          if (!mt(d(), c)) return !1;
        } catch {
          return !1;
        }
      }
      if (a = o.child, 16384 & o.subtreeFlags && a !== null) a.return = o, o = a;
      else {
        if (o === t) break;
        for (; o.sibling === null; ) {
          if (o.return === null || o.return === t) return !0;
          o = o.return;
        }
        o.sibling.return = o.return, o = o.sibling;
      }
    }
    return !0;
  }
  function ka(t, o, a, u) {
    o &= ~th, o &= ~Qi, t.suspendedLanes |= o, t.pingedLanes &= ~o, u && (t.warmLanes |= o), u = t.expirationTimes;
    for (var c = o; 0 < c; ) {
      var d = 31 - vt(c), g = 1 << d;
      u[d] = -1, c &= ~g;
    }
    a !== 0 && tn(t, a, o);
  }
  function kc() {
    return !!(6 & Rn) || (Gu(0), !1);
  }
  function Ff() {
    if (hn !== null) {
      if (_n === 0) var t = hn.return;
      else na = Ka = null, Zd(t = hn), Li = null, zi = 0, t = hn;
      for (; t !== null; ) Mg(t.alternate, t), t = t.return;
      hn = null;
    }
  }
  function Ki(t, o) {
    var a = t.timeoutHandle;
    a !== -1 && (t.timeoutHandle = -1, ib(a)), (a = t.cancelPendingCommit) !== null && (t.cancelPendingCommit = null, a()), Ff(), Qn = t, hn = a = Co(t.current, null), xn = o, _n = 0, Yr = null, yr = !1, Qu = we(t, o), nh = !1, Ul = Or = th = Qi = Hl = pt = 0, br = lr = null, _f = !1, 8 & o && (o |= 32 & o);
    var u = t.entangledLanes;
    if (u !== 0) for (t = t.entanglements, u &= o; 0 < u; ) {
      var c = 31 - vt(u), d = 1 << c;
      o |= t[c], u &= ~d;
    }
    return ya = o, xo(), a;
  }
  function Ug(t, o) {
    Je = null, Ae.H = ac, o === Fl || o === Ys ? (o = mm(), _n = 3) : o === Vd ? (o = mm(), _n = 4) : _n = o === Um ? 8 : o !== null && typeof o == "object" && typeof o.then == "function" ? 6 : 1, Yr = o, hn === null && (pt = 1, sc(t, Br(o, t.current)));
  }
  function wc() {
    var t = Ae.H;
    return Ae.H = ac, t === null ? ac : t;
  }
  function If() {
    var t = Ae.A;
    return Ae.A = jg, t;
  }
  function ah() {
    pt = 4, yr || (4194048 & xn) !== xn && qr.current !== null || (Qu = !0), !(134217727 & Hl) && !(134217727 & Qi) || Qn === null || ka(Qn, xn, Or, !1);
  }
  function lh(t, o, a) {
    var u = Rn;
    Rn |= 2;
    var c = wc(), d = If();
    Qn === t && xn === o || (Lf = null, Ki(t, o)), o = !1;
    var g = pt;
    e: for (; ; ) try {
      if (_n !== 0 && hn !== null) {
        var h = hn, w = Yr;
        switch (_n) {
          case 8:
            Ff(), g = 6;
            break e;
          case 3:
          case 2:
          case 9:
          case 6:
            qr.current === null && (o = !0);
            var x = _n;
            if (_n = 0, Yr = null, Wl(t, h, w, x), a && Qu) {
              g = 0;
              break e;
            }
            break;
          default:
            x = _n, _n = 0, Yr = null, Wl(t, h, w, x);
        }
      }
      Bg(), g = pt;
      break;
    } catch (B) {
      Ug(t, B);
    }
    return o && t.shellSuspendCounter++, na = Ka = null, Rn = u, Ae.H = c, Ae.A = d, hn === null && (Qn = null, xn = 0, xo()), g;
  }
  function Bg() {
    for (; hn !== null; ) Mf(hn);
  }
  function Vg() {
    for (; hn !== null && !Ua(); ) Mf(hn);
  }
  function Mf(t) {
    var o = Hu(t.alternate, t, ya);
    t.memoizedProps = t.pendingProps, o === null ? Sc(t) : hn = o;
  }
  function ih(t) {
    var o = t, a = o.alternate;
    switch (o.tag) {
      case 15:
      case 0:
        o = gf(a, o, o.pendingProps, o.type, void 0, xn);
        break;
      case 11:
        o = gf(a, o, o.pendingProps, o.type.render, o.ref, xn);
        break;
      case 5:
        Zd(o);
      default:
        Mg(a, o), o = Hu(a, o = hn = on(o, ya), ya);
    }
    t.memoizedProps = t.pendingProps, o === null ? Sc(t) : hn = o;
  }
  function Wl(t, o, a, u) {
    na = Ka = null, Zd(o), Li = null, zi = 0;
    var c = o.return;
    try {
      if (function(d, g, h, w, x) {
        if (h.flags |= 32768, w !== null && typeof w == "object" && typeof w.then == "function") {
          if ((g = h.alternate) !== null && Ou(g, h, x, !0), (h = qr.current) !== null) {
            switch (h.tag) {
              case 13:
                return Vt === null ? ah() : h.alternate === null && pt === 0 && (pt = 3), h.flags &= -257, h.flags |= 65536, h.lanes = x, w === Wd ? h.flags |= 16384 : ((g = h.updateQueue) === null ? h.updateQueue = /* @__PURE__ */ new Set([w]) : g.add(w), Uf(d, w, x)), !1;
              case 22:
                return h.flags |= 65536, w === Wd ? h.flags |= 16384 : ((g = h.updateQueue) === null ? (g = { transitions: null, markerInstances: null, retryQueue: /* @__PURE__ */ new Set([w]) }, h.updateQueue = g) : (h = g.retryQueue) === null ? g.retryQueue = /* @__PURE__ */ new Set([w]) : h.add(w), Uf(d, w, x)), !1;
            }
            throw Error(b(435, h.tag));
          }
          return Uf(d, w, x), ah(), !1;
        }
        if (bn) return (g = qr.current) !== null ? (!(65536 & g.flags) && (g.flags |= 256), g.flags |= 65536, g.lanes = x, w !== Bs && ki(Br(d = Error(b(422), { cause: w }), h))) : (w !== Bs && ki(Br(g = Error(b(423), { cause: w }), h)), (d = d.current.alternate).flags |= 65536, x &= -x, d.lanes |= x, w = Br(w, h), gm(d, x = mf(d.stateNode, w, x)), pt !== 4 && (pt = 2)), !1;
        var B = Error(b(520), { cause: w });
        if (B = Br(B, h), lr === null ? lr = [B] : lr.push(B), pt !== 4 && (pt = 2), g === null) return !0;
        w = Br(w, h), h = g;
        do {
          switch (h.tag) {
            case 3:
              return h.flags |= 65536, d = x & -x, h.lanes |= d, gm(h, d = mf(h.stateNode, w, d)), !1;
            case 1:
              if (g = h.type, B = h.stateNode, !(128 & h.flags || typeof g.getDerivedStateFromError != "function" && (B === null || typeof B.componentDidCatch != "function" || Bl !== null && Bl.has(B)))) return h.flags |= 65536, x &= -x, h.lanes |= x, Hm(x = dt(x), d, h, w), gm(h, x), !1;
          }
          h = h.return;
        } while (h !== null);
        return !1;
      }(t, c, o, a, xn)) return pt = 1, sc(t, Br(a, t.current)), void (hn = null);
    } catch (d) {
      if (c !== null) throw hn = c, d;
      return pt = 1, sc(t, Br(a, t.current)), void (hn = null);
    }
    32768 & o.flags ? (bn || u === 1 ? t = !0 : Qu || 536870912 & xn ? t = !1 : (yr = t = !0, (u === 2 || u === 9 || u === 3 || u === 6) && (u = qr.current) !== null && u.tag === 13 && (u.flags |= 16384)), Wg(o, t)) : Sc(o);
  }
  function Sc(t) {
    var o = t;
    do {
      if (32768 & o.flags) return void Wg(o, yr);
      t = o.return;
      var a = Ig(o.alternate, o, ya);
      if (a !== null) return void (hn = a);
      if ((o = o.sibling) !== null) return void (hn = o);
      hn = o = t;
    } while (o !== null);
    pt === 0 && (pt = 5);
  }
  function Wg(t, o) {
    do {
      var a = ob(t.alternate, t);
      if (a !== null) return a.flags &= 32767, void (hn = a);
      if ((a = t.return) !== null && (a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null), !o && (t = t.sibling) !== null) return void (hn = t);
      hn = t = a;
    } while (t !== null);
    pt = 6, hn = null;
  }
  function qg(t, o, a, u, c, d, g, h, w) {
    t.cancelPendingCommit = null;
    do
      Yu();
    while (Dt !== 0);
    if (6 & Rn) throw Error(b(327));
    if (o !== null) {
      if (o === t.current) throw Error(b(177));
      if (d = o.lanes | o.childLanes, function(x, B, q, ee, le, de) {
        var I = x.pendingLanes;
        x.pendingLanes = q, x.suspendedLanes = 0, x.pingedLanes = 0, x.warmLanes = 0, x.expiredLanes &= q, x.entangledLanes &= q, x.errorRecoveryDisabledLanes &= q, x.shellSuspendCounter = 0;
        var _ = x.entanglements, M = x.expirationTimes, ie = x.hiddenUpdates;
        for (q = I & ~q; 0 < q; ) {
          var xe = 31 - vt(q), Re = 1 << xe;
          _[xe] = 0, M[xe] = -1;
          var Ve = ie[xe];
          if (Ve !== null) for (ie[xe] = null, xe = 0; xe < Ve.length; xe++) {
            var En = Ve[xe];
            En !== null && (En.lane &= -536870913);
          }
          q &= ~Re;
        }
        ee !== 0 && tn(x, ee, 0), de !== 0 && le === 0 && x.tag !== 0 && (x.suspendedLanes |= de & ~(I & ~B));
      }(t, a, d |= $o, g, h, w), t === Qn && (hn = Qn = null, xn = 0), ba = o, Vl = t, il = a, zf = d, Df = c, bc = u, 10256 & o.subtreeFlags || 10256 & o.flags ? (t.callbackNode = null, t.callbackPriority = 0, $t(Bo, function() {
        return uh(), null;
      })) : (t.callbackNode = null, t.callbackPriority = 0), u = !!(13878 & o.flags), 13878 & o.subtreeFlags || u) {
        u = Ae.T, Ae.T = null, c = S.p, S.p = 2, g = Rn, Rn |= 4;
        try {
          (function(x, B) {
            if (x = x.containerInfo, Rc = ur, qn(x = Al(x))) {
              if ("selectionStart" in x) var q = { start: x.selectionStart, end: x.selectionEnd };
              else e: {
                var ee = (q = (q = x.ownerDocument) && q.defaultView || window).getSelection && q.getSelection();
                if (ee && ee.rangeCount !== 0) {
                  q = ee.anchorNode;
                  var le = ee.anchorOffset, de = ee.focusNode;
                  ee = ee.focusOffset;
                  try {
                    q.nodeType, de.nodeType;
                  } catch {
                    q = null;
                    break e;
                  }
                  var I = 0, _ = -1, M = -1, ie = 0, xe = 0, Re = x, Ve = null;
                  n: for (; ; ) {
                    for (var En; Re !== q || le !== 0 && Re.nodeType !== 3 || (_ = I + le), Re !== de || ee !== 0 && Re.nodeType !== 3 || (M = I + ee), Re.nodeType === 3 && (I += Re.nodeValue.length), (En = Re.firstChild) !== null; ) Ve = Re, Re = En;
                    for (; ; ) {
                      if (Re === x) break n;
                      if (Ve === q && ++ie === le && (_ = I), Ve === de && ++xe === ee && (M = I), (En = Re.nextSibling) !== null) break;
                      Ve = (Re = Ve).parentNode;
                    }
                    Re = En;
                  }
                  q = _ === -1 || M === -1 ? null : { start: _, end: M };
                } else q = null;
              }
              q = q || { start: 0, end: 0 };
            } else q = null;
            for (Oo = { focusedElem: x, selectionRange: q }, ur = !1, ht = B; ht !== null; ) if (x = (B = ht).child, 1024 & B.subtreeFlags && x !== null) x.return = B, ht = x;
            else for (; ht !== null; ) {
              switch (de = (B = ht).alternate, x = B.flags, B.tag) {
                case 0:
                case 11:
                case 15:
                case 5:
                case 26:
                case 27:
                case 6:
                case 4:
                case 17:
                  break;
                case 1:
                  if (1024 & x && de !== null) {
                    x = void 0, q = B, le = de.memoizedProps, de = de.memoizedState, ee = q.stateNode;
                    try {
                      var yt = Ao(q.type, le, (q.elementType, q.type));
                      x = ee.getSnapshotBeforeUpdate(yt, de), ee.__reactInternalSnapshotBeforeUpdate = x;
                    } catch (ln) {
                      An(q, q.return, ln);
                    }
                  }
                  break;
                case 3:
                  if (1024 & x) {
                    if ((q = (x = B.stateNode.containerInfo).nodeType) === 9) Ac(x);
                    else if (q === 1) switch (x.nodeName) {
                      case "HEAD":
                      case "HTML":
                      case "BODY":
                        Ac(x);
                        break;
                      default:
                        x.textContent = "";
                    }
                  }
                  break;
                default:
                  if (1024 & x) throw Error(b(163));
              }
              if ((x = B.sibling) !== null) {
                x.return = B.return, ht = x;
                break;
              }
              ht = B.return;
            }
          })(t, o);
        } finally {
          Rn = g, S.p = c, Ae.T = u;
        }
      }
      Dt = 1, Qg(), Yg(), jf();
    }
  }
  function Qg() {
    if (Dt === 1) {
      Dt = 0;
      var t = Vl, o = ba, a = !!(13878 & o.flags);
      if (13878 & o.subtreeFlags || a) {
        a = Ae.T, Ae.T = null;
        var u = S.p;
        S.p = 2;
        var c = Rn;
        Rn |= 4;
        try {
          Pf(o, t);
          var d = Oo, g = Al(t.containerInfo), h = d.focusedElem, w = d.selectionRange;
          if (g !== h && h && h.ownerDocument && Ds(h.ownerDocument.documentElement, h)) {
            if (w !== null && qn(h)) {
              var x = w.start, B = w.end;
              if (B === void 0 && (B = x), "selectionStart" in h) h.selectionStart = x, h.selectionEnd = Math.min(B, h.value.length);
              else {
                var q = h.ownerDocument || document, ee = q && q.defaultView || window;
                if (ee.getSelection) {
                  var le = ee.getSelection(), de = h.textContent.length, I = Math.min(w.start, de), _ = w.end === void 0 ? I : Math.min(w.end, de);
                  !le.extend && I > _ && (g = _, _ = I, I = g);
                  var M = Su(h, I), ie = Su(h, _);
                  if (M && ie && (le.rangeCount !== 1 || le.anchorNode !== M.node || le.anchorOffset !== M.offset || le.focusNode !== ie.node || le.focusOffset !== ie.offset)) {
                    var xe = q.createRange();
                    xe.setStart(M.node, M.offset), le.removeAllRanges(), I > _ ? (le.addRange(xe), le.extend(ie.node, ie.offset)) : (xe.setEnd(ie.node, ie.offset), le.addRange(xe));
                  }
                }
              }
            }
            for (q = [], le = h; le = le.parentNode; ) le.nodeType === 1 && q.push({ element: le, left: le.scrollLeft, top: le.scrollTop });
            for (typeof h.focus == "function" && h.focus(), h = 0; h < q.length; h++) {
              var Re = q[h];
              Re.element.scrollLeft = Re.left, Re.element.scrollTop = Re.top;
            }
          }
          ur = !!Rc, Oo = Rc = null;
        } finally {
          Rn = c, S.p = u, Ae.T = a;
        }
      }
      t.current = o, Dt = 2;
    }
  }
  function Yg() {
    if (Dt === 2) {
      Dt = 0;
      var t = Vl, o = ba, a = !!(8772 & o.flags);
      if (8772 & o.subtreeFlags || a) {
        a = Ae.T, Ae.T = null;
        var u = S.p;
        S.p = 2;
        var c = Rn;
        Rn |= 4;
        try {
          Jm(t, o.alternate, o);
        } finally {
          Rn = c, S.p = u, Ae.T = a;
        }
      }
      Dt = 3;
    }
  }
  function jf() {
    if (Dt === 4 || Dt === 3) {
      Dt = 0, Uo();
      var t = Vl, o = ba, a = il, u = bc;
      10256 & o.subtreeFlags || 10256 & o.flags ? Dt = 5 : (Dt = 0, ba = Vl = null, Hf(t, t.pendingLanes));
      var c = t.pendingLanes;
      if (c === 0 && (Bl = null), Hn(a), o = o.stateNode, _t && typeof _t.onCommitFiberRoot == "function") try {
        _t.onCommitFiberRoot(Ba, o, void 0, !(128 & ~o.current.flags));
      } catch {
      }
      if (u !== null) {
        o = Ae.T, c = S.p, S.p = 2, Ae.T = null;
        try {
          for (var d = t.onRecoverableError, g = 0; g < u.length; g++) {
            var h = u[g];
            d(h.value, { componentStack: h.stack });
          }
        } finally {
          Ae.T = o, S.p = c;
        }
      }
      3 & il && Yu(), _o(t), c = t.pendingLanes, 4194090 & a && 42 & c ? t === Yi ? va++ : (va = 0, Yi = t) : va = 0, Gu(0);
    }
  }
  function Hf(t, o) {
    (t.pooledCacheLanes &= o) === 0 && (o = t.pooledCache) != null && (t.pooledCache = null, Si(o));
  }
  function Yu(t) {
    return Qg(), Yg(), jf(), uh();
  }
  function uh() {
    if (Dt !== 5) return !1;
    var t = Vl, o = zf;
    zf = 0;
    var a = Hn(il), u = Ae.T, c = S.p;
    try {
      S.p = 32 > a ? 32 : a, Ae.T = null, a = Df, Df = null;
      var d = Vl, g = il;
      if (Dt = 0, ba = Vl = null, il = 0, 6 & Rn) throw Error(b(331));
      var h = Rn;
      if (Rn |= 4, Nf(d.current), zt(d, d.current, g, a), Rn = h, Gu(0, !1), _t && typeof _t.onPostCommitFiberRoot == "function") try {
        _t.onPostCommitFiberRoot(Ba, d);
      } catch {
      }
      return !0;
    } finally {
      S.p = c, Ae.T = u, Hf(t, o);
    }
  }
  function sh(t, o, a) {
    o = Br(a, o), (t = aa(t, o = mf(t.stateNode, o, 2), 2)) !== null && (Ze(t, 2), _o(t));
  }
  function An(t, o, a) {
    if (t.tag === 3) sh(t, t, a);
    else for (; o !== null; ) {
      if (o.tag === 3) {
        sh(o, t, a);
        break;
      }
      if (o.tag === 1) {
        var u = o.stateNode;
        if (typeof o.type.getDerivedStateFromError == "function" || typeof u.componentDidCatch == "function" && (Bl === null || !Bl.has(u))) {
          t = Br(a, t), (u = aa(o, a = dt(2), 2)) !== null && (Hm(a, u, o, t), Ze(u, 2), _o(u));
          break;
        }
      }
      o = o.return;
    }
  }
  function Uf(t, o, a) {
    var u = t.pingCache;
    if (u === null) {
      u = t.pingCache = new Hg();
      var c = /* @__PURE__ */ new Set();
      u.set(o, c);
    } else (c = u.get(o)) === void 0 && (c = /* @__PURE__ */ new Set(), u.set(o, c));
    c.has(a) || (nh = !0, c.add(a), t = Bf.bind(null, t, o, a), o.then(t, t));
  }
  function Bf(t, o, a) {
    var u = t.pingCache;
    u !== null && u.delete(o), t.pingedLanes |= t.suspendedLanes & a, t.warmLanes &= ~a, Qn === t && (xn & a) === a && (pt === 4 || pt === 3 && (62914560 & xn) === xn && 300 > oo() - Of ? !(2 & Rn) && Ki(t, 0) : th |= a, Ul === xn && (Ul = 0)), _o(t);
  }
  function ch(t, o) {
    o === 0 && (o = Wn()), (t = Zo(t, o)) !== null && (Ze(t, o), _o(t));
  }
  function ab(t) {
    var o = t.memoizedState, a = 0;
    o !== null && (a = o.retryLane), ch(t, a);
  }
  function Vf(t, o) {
    var a = 0;
    switch (t.tag) {
      case 13:
        var u = t.stateNode, c = t.memoizedState;
        c !== null && (a = c.retryLane);
        break;
      case 19:
        u = t.stateNode;
        break;
      case 22:
        u = t.stateNode._retryCache;
        break;
      default:
        throw Error(b(314));
    }
    u !== null && u.delete(o), ch(t, a);
  }
  var Ec = null, wa = null, xc = !1, Xi = !1, Wf = !1, ql = 0;
  function _o(t) {
    t !== wa && t.next === null && (wa === null ? Ec = wa = t : wa = wa.next = t), Xi = !0, xc || (xc = !0, ub(function() {
      6 & Rn ? $t(yl, Gg) : dh();
    }));
  }
  function Gu(t, o) {
    if (!Wf && Xi) {
      Wf = !0;
      do
        for (var a = !1, u = Ec; u !== null; ) {
          if (t !== 0) {
            var c = u.pendingLanes;
            if (c === 0) var d = 0;
            else {
              var g = u.suspendedLanes, h = u.pingedLanes;
              d = (1 << 31 - vt(42 | t) + 1) - 1, d = 201326741 & (d &= c & ~(g & ~h)) ? 201326741 & d | 1 : d ? 2 | d : 0;
            }
            d !== 0 && (a = !0, gt(u, d));
          } else d = xn, !(3 & (d = be(u, u === Qn ? d : 0, u.cancelPendingCommit !== null || u.timeoutHandle !== -1))) || we(u, d) || (a = !0, gt(u, d));
          u = u.next;
        }
      while (a);
      Wf = !1;
    }
  }
  function Gg() {
    dh();
  }
  function dh() {
    Xi = xc = !1;
    var t = 0;
    ql !== 0 && (function() {
      var g = window.event;
      return g && g.type === "popstate" ? g !== zo && (zo = g, !0) : (zo = null, !1);
    }() && (t = ql), ql = 0);
    for (var o = oo(), a = null, u = Ec; u !== null; ) {
      var c = u.next, d = fh(u, o);
      d === 0 ? (u.next = null, a === null ? Ec = c : a.next = c, c === null && (wa = a)) : (a = u, (t !== 0 || 3 & d) && (Xi = !0)), u = c;
    }
    Gu(t);
  }
  function fh(t, o) {
    for (var a = t.suspendedLanes, u = t.pingedLanes, c = t.expirationTimes, d = -62914561 & t.pendingLanes; 0 < d; ) {
      var g = 31 - vt(d), h = 1 << g, w = c[g];
      w === -1 ? (h & a) !== 0 && (h & u) === 0 || (c[g] = Le(h, o)) : w <= o && (t.expiredLanes |= h), d &= ~h;
    }
    if (a = xn, a = be(t, t === (o = Qn) ? a : 0, t.cancelPendingCommit !== null || t.timeoutHandle !== -1), u = t.callbackNode, a === 0 || t === o && (_n === 2 || _n === 9) || t.cancelPendingCommit !== null) return u !== null && u !== null && fr(u), t.callbackNode = null, t.callbackPriority = 0;
    if (!(3 & a) || we(t, a)) {
      if ((o = a & -a) === t.callbackPriority) return o;
      switch (u !== null && fr(u), Hn(a)) {
        case 2:
        case 8:
          a = ti;
          break;
        case 32:
        default:
          a = Bo;
          break;
        case 268435456:
          a = vs;
      }
      return u = ph.bind(null, t), a = $t(a, u), t.callbackPriority = o, t.callbackNode = a, o;
    }
    return u !== null && u !== null && fr(u), t.callbackPriority = 2, t.callbackNode = null, 2;
  }
  function ph(t, o) {
    if (Dt !== 0 && Dt !== 5) return t.callbackNode = null, t.callbackPriority = 0, null;
    var a = t.callbackNode;
    if (Yu() && t.callbackNode !== a) return null;
    var u = xn;
    return (u = be(t, t === Qn ? u : 0, t.cancelPendingCommit !== null || t.timeoutHandle !== -1)) === 0 ? null : (rh(t, u, o), fh(t, oo()), t.callbackNode != null && t.callbackNode === a ? ph.bind(null, t) : null);
  }
  function gt(t, o) {
    if (Yu()) return null;
    rh(t, o, !0);
  }
  function Cc() {
    return ql === 0 && (ql = dn()), ql;
  }
  function Kg(t) {
    return t == null || typeof t == "symbol" || typeof t == "boolean" ? null : typeof t == "function" ? t : wl("" + t);
  }
  function en(t, o) {
    var a = o.ownerDocument.createElement("input");
    return a.name = o.name, a.value = o.value, t.id && a.setAttribute("form", t.id), o.parentNode.insertBefore(a, o), t = new FormData(t), a.parentNode.removeChild(a), t;
  }
  for (var mh = 0; mh < Eu.length; mh++) {
    var Sa = Eu[mh];
    lo(Sa.toLowerCase(), "on" + (Sa[0].toUpperCase() + Sa.slice(1)));
  }
  lo(So, "onAnimationEnd"), lo(Eo, "onAnimationIteration"), lo(Ms, "onAnimationStart"), lo("dblclick", "onDoubleClick"), lo("focusin", "onFocus"), lo("focusout", "onBlur"), lo(Eg, "onTransitionRun"), lo(om, "onTransitionStart"), lo(Md, "onTransitionCancel"), lo(am, "onTransitionEnd"), li("onMouseEnter", ["mouseout", "mouseover"]), li("onMouseLeave", ["mouseout", "mouseover"]), li("onPointerEnter", ["pointerout", "pointerover"]), li("onPointerLeave", ["pointerout", "pointerover"]), vl("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), vl("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), vl("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), vl("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), vl("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), vl("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
  var Ea = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Ku = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(Ea));
  function Tc(t, o) {
    o = !!(4 & o);
    for (var a = 0; a < t.length; a++) {
      var u = t[a], c = u.event;
      u = u.listeners;
      e: {
        var d = void 0;
        if (o) for (var g = u.length - 1; 0 <= g; g--) {
          var h = u[g], w = h.instance, x = h.currentTarget;
          if (h = h.listener, w !== d && c.isPropagationStopped()) break e;
          d = h, c.currentTarget = x;
          try {
            d(c);
          } catch (B) {
            ic(B);
          }
          c.currentTarget = null, d = w;
        }
        else for (g = 0; g < u.length; g++) {
          if (w = (h = u[g]).instance, x = h.currentTarget, h = h.listener, w !== d && c.isPropagationStopped()) break e;
          d = h, c.currentTarget = x;
          try {
            d(c);
          } catch (B) {
            ic(B);
          }
          c.currentTarget = null, d = w;
        }
      }
    }
  }
  function an(t, o) {
    var a = o[Fp];
    a === void 0 && (a = o[Fp] = /* @__PURE__ */ new Set());
    var u = t + "__bubble";
    a.has(u) || ($u(o, t, 2, !1), a.add(u));
  }
  function hh(t, o, a) {
    var u = 0;
    o && (u |= 4), $u(a, t, u, o);
  }
  var Xu = "_reactListening" + Math.random().toString(36).slice(2);
  function mo(t) {
    if (!t[Xu]) {
      t[Xu] = !0, Mp.forEach(function(a) {
        a !== "selectionchange" && (Ku.has(a) || hh(a, !1, t), hh(a, !0, t));
      });
      var o = t.nodeType === 9 ? t : t.ownerDocument;
      o === null || o[Xu] || (o[Xu] = !0, hh("selectionchange", !1, o));
    }
  }
  function $u(t, o, a, u) {
    switch (vh(o)) {
      case 2:
        var c = Pa;
        break;
      case 8:
        c = cb;
        break;
      default:
        c = $f;
    }
    a = c.bind(null, o, a, t), c = void 0, !Qp || o !== "touchstart" && o !== "touchmove" && o !== "wheel" || (c = !0), u ? c !== void 0 ? t.addEventListener(o, a, { capture: !0, passive: c }) : t.addEventListener(o, a, !0) : c !== void 0 ? t.addEventListener(o, a, { passive: c }) : t.addEventListener(o, a, !1);
  }
  function Pc(t, o, a, u, c) {
    var d = u;
    if (!(1 & o || 2 & o || u === null)) e: for (; ; ) {
      if (u === null) return;
      var g = u.tag;
      if (g === 3 || g === 4) {
        var h = u.stateNode.containerInfo;
        if (h === c) break;
        if (g === 4) for (g = u.return; g !== null; ) {
          var w = g.tag;
          if ((w === 3 || w === 4) && g.stateNode.containerInfo === c) return;
          g = g.return;
        }
        for (; h !== null; ) {
          if ((g = oi(h)) === null) return;
          if ((w = g.tag) === 5 || w === 6 || w === 26 || w === 27) {
            u = d = g;
            continue e;
          }
          h = h.parentNode;
        }
      }
      u = u.return;
    }
    Cs(function() {
      var x = d, B = Sd(a), q = [];
      e: {
        var ee = lm.get(t);
        if (ee !== void 0) {
          var le = Td, de = t;
          switch (t) {
            case "keypress":
              if (xd(a) === 0) break e;
            case "keydown":
            case "keyup":
              le = Cr;
              break;
            case "focusin":
              de = "focus", le = As;
              break;
            case "focusout":
              de = "blur", le = As;
              break;
            case "beforeblur":
            case "afterblur":
              le = As;
              break;
            case "click":
              if (a.button === 2) break e;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              le = Xp;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              le = bg;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              le = Ad;
              break;
            case So:
            case Eo:
            case Ms:
              le = vg;
              break;
            case am:
              le = bu;
              break;
            case "scroll":
            case "scrollend":
              le = yg;
              break;
            case "wheel":
              le = Zp;
              break;
            case "copy":
            case "cut":
            case "paste":
              le = mi;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              le = $p;
              break;
            case "toggle":
            case "beforetoggle":
              le = kg;
          }
          var I = !!(4 & o), _ = !I && (t === "scroll" || t === "scrollend"), M = I ? ee !== null ? ee + "Capture" : null : ee;
          I = [];
          for (var ie, xe = x; xe !== null; ) {
            var Re = xe;
            if (ie = Re.stateNode, (Re = Re.tag) !== 5 && Re !== 26 && Re !== 27 || ie === null || M === null || (Re = yu(xe, M)) != null && I.push($i(xe, Re, ie)), _) break;
            xe = xe.return;
          }
          0 < I.length && (ee = new le(ee, de, null, a, B), q.push({ event: ee, listeners: I }));
        }
      }
      if (!(7 & o)) {
        if (le = t === "mouseout" || t === "pointerout", (!(ee = t === "mouseover" || t === "pointerover") || a === xs || !(de = a.relatedTarget || a.fromElement) || !oi(de) && !de[Va]) && (le || ee) && (ee = B.window === B ? B : (ee = B.ownerDocument) ? ee.defaultView || ee.parentWindow : window, le ? (le = x, (de = (de = a.relatedTarget || a.toElement) ? oi(de) : null) !== null && (_ = W(de), I = de.tag, de !== _ || I !== 5 && I !== 27 && I !== 6) && (de = null)) : (le = null, de = x), le !== de)) {
          if (I = Xp, Re = "onMouseLeave", M = "onMouseEnter", xe = "mouse", t !== "pointerout" && t !== "pointerover" || (I = $p, Re = "onPointerLeave", M = "onPointerEnter", xe = "pointer"), _ = le == null ? ee : mr(le), ie = de == null ? ee : mr(de), (ee = new I(Re, xe + "leave", le, a, B)).target = _, ee.relatedTarget = ie, Re = null, oi(B) === x && ((I = new I(M, xe + "enter", de, a, B)).target = ie, I.relatedTarget = _, Re = I), _ = Re, le && de) e: {
            for (M = de, xe = 0, ie = I = le; ie; ie = Ft(ie)) xe++;
            for (ie = 0, Re = M; Re; Re = Ft(Re)) ie++;
            for (; 0 < xe - ie; ) I = Ft(I), xe--;
            for (; 0 < ie - xe; ) M = Ft(M), ie--;
            for (; xe--; ) {
              if (I === M || M !== null && I === M.alternate) break e;
              I = Ft(I), M = Ft(M);
            }
            I = null;
          }
          else I = null;
          le !== null && qf(q, ee, le, I, !1), de !== null && _ !== null && qf(q, _, de, I, !0);
        }
        if ((le = (ee = x ? mr(x) : window).nodeName && ee.nodeName.toLowerCase()) === "select" || le === "input" && ee.type === "file") var Ve = _d;
        else if (Tl(ee)) if (Pl) Ve = Rl;
        else {
          Ve = Sg;
          var En = zs;
        }
        else !(le = ee.nodeName) || le.toLowerCase() !== "input" || ee.type !== "checkbox" && ee.type !== "radio" ? x && wd(x.elementType) && (Ve = _d) : Ve = zd;
        switch (Ve && (Ve = Ve(t, x)) ? tm(q, Ve, a, B) : (En && En(t, ee, x), t === "focusout" && x && ee.type === "number" && x.memoizedProps.value != null && vd(ee, "number", ee.value)), En = x ? mr(x) : window, t) {
          case "focusin":
            (Tl(En) || En.contentEditable === "true") && (bi = En, Fs = x, wo = null);
            break;
          case "focusout":
            wo = Fs = bi = null;
            break;
          case "mousedown":
            vi = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            vi = !1, Go(q, a, B);
            break;
          case "selectionchange":
            if (Fd) break;
          case "keydown":
          case "keyup":
            Go(q, a, B);
        }
        var yt;
        if (_s) e: {
          switch (t) {
            case "compositionstart":
              var ln = "onCompositionStart";
              break e;
            case "compositionend":
              ln = "onCompositionEnd";
              break e;
            case "compositionupdate":
              ln = "onCompositionUpdate";
              break e;
          }
          ln = void 0;
        }
        else Cl ? Ls(t, a) && (ln = "onCompositionEnd") : t === "keydown" && a.keyCode === 229 && (ln = "onCompositionStart");
        ln && (Qo && a.locale !== "ko" && (Cl || ln !== "onCompositionStart" ? ln === "onCompositionEnd" && Cl && (yt = Yp()) : (Ed = "value" in (Sl = B) ? Sl.value : Sl.textContent, Cl = !0)), 0 < (En = Zi(x, ln)).length && (ln = new El(ln, t, null, a, B), q.push({ event: ln, listeners: En }), (yt || (yt = xl(a)) !== null) && (ln.data = yt))), (yt = Jp ? function(Cn, Ne) {
          switch (Cn) {
            case "compositionend":
              return xl(Ne);
            case "keypress":
              return Ne.which !== 32 ? null : (Nd = !0, em);
            case "textInput":
              return (Cn = Ne.data) === em && Nd ? null : Cn;
            default:
              return null;
          }
        }(t, a) : function(Cn, Ne) {
          if (Cl) return Cn === "compositionend" || !_s && Ls(Cn, Ne) ? (Cn = Yp(), Ts = Ed = Sl = null, Cl = !1, Cn) : null;
          switch (Cn) {
            case "paste":
            default:
              return null;
            case "keypress":
              if (!(Ne.ctrlKey || Ne.altKey || Ne.metaKey) || Ne.ctrlKey && Ne.altKey) {
                if (Ne.char && 1 < Ne.char.length) return Ne.char;
                if (Ne.which) return String.fromCharCode(Ne.which);
              }
              return null;
            case "compositionend":
              return Qo && Ne.locale !== "ko" ? null : Ne.data;
          }
        }(t, a)) && 0 < (ln = Zi(x, "onBeforeInput")).length && (En = new El("onBeforeInput", "beforeinput", null, a, B), q.push({ event: En, listeners: ln }), En.data = yt), function(Cn, Ne, Ke, Zn, qe) {
          if (Ne === "submit" && Ke && Ke.stateNode === qe) {
            var zr = Kg((qe[pr] || null).action), $r = Zn.submitter;
            $r && (Ne = (Ne = $r[pr] || null) ? Kg(Ne.formAction) : $r.getAttribute("formAction")) !== null && (zr = Ne, $r = null);
            var xh = new Td("action", "action", null, Zn, qe);
            Cn.push({ event: xh, listeners: [{ instance: null, listener: function() {
              if (Zn.defaultPrevented) {
                if (ql !== 0) {
                  var Vc = $r ? en(qe, $r) : new FormData(qe);
                  ff(Ke, { pending: !0, data: Vc, method: qe.method, action: zr }, null, Vc);
                }
              } else typeof zr == "function" && (xh.preventDefault(), Vc = $r ? en(qe, $r) : new FormData(qe), ff(Ke, { pending: !0, data: Vc, method: qe.method, action: zr }, zr, Vc));
            }, currentTarget: qe }] });
          }
        }(q, t, x, a, B);
      }
      Tc(q, o);
    });
  }
  function $i(t, o, a) {
    return { instance: t, listener: o, currentTarget: a };
  }
  function Zi(t, o) {
    for (var a = o + "Capture", u = []; t !== null; ) {
      var c = t, d = c.stateNode;
      if ((c = c.tag) !== 5 && c !== 26 && c !== 27 || d === null || ((c = yu(t, a)) != null && u.unshift($i(t, c, d)), (c = yu(t, o)) != null && u.push($i(t, c, d))), t.tag === 3) return u;
      t = t.return;
    }
    return [];
  }
  function Ft(t) {
    if (t === null) return null;
    do
      t = t.return;
    while (t && t.tag !== 5 && t.tag !== 27);
    return t || null;
  }
  function qf(t, o, a, u, c) {
    for (var d = o._reactName, g = []; a !== null && a !== u; ) {
      var h = a, w = h.alternate, x = h.stateNode;
      if (h = h.tag, w !== null && w === u) break;
      h !== 5 && h !== 26 && h !== 27 || x === null || (w = x, c ? (x = yu(a, d)) != null && g.unshift($i(a, x, w)) : c || (x = yu(a, d)) != null && g.push($i(a, x, w))), a = a.return;
    }
    g.length !== 0 && t.push({ event: o, listeners: g });
  }
  var lb = /\r\n?/g, Xg = /\u0000|\uFFFD/g;
  function $g(t) {
    return (typeof t == "string" ? t : "" + t).replace(lb, `
`).replace(Xg, "");
  }
  function It(t, o) {
    return o = $g(o), $g(t) === o;
  }
  function J() {
  }
  function Fe(t, o, a, u, c, d) {
    switch (a) {
      case "children":
        typeof u == "string" ? o === "body" || o === "textarea" && u === "" || Wo(t, u) : (typeof u == "number" || typeof u == "bigint") && o !== "body" && Wo(t, "" + u);
        break;
      case "className":
        Zt(t, "class", u);
        break;
      case "tabIndex":
        Zt(t, "tabindex", u);
        break;
      case "dir":
      case "role":
      case "viewBox":
      case "width":
      case "height":
        Zt(t, a, u);
        break;
      case "style":
        hu(t, u, d);
        break;
      case "data":
        if (o !== "object") {
          Zt(t, "data", u);
          break;
        }
      case "src":
      case "href":
        if (u === "" && (o !== "a" || a !== "href")) {
          t.removeAttribute(a);
          break;
        }
        if (u == null || typeof u == "function" || typeof u == "symbol" || typeof u == "boolean") {
          t.removeAttribute(a);
          break;
        }
        u = wl("" + u), t.setAttribute(a, u);
        break;
      case "action":
      case "formAction":
        if (typeof u == "function") {
          t.setAttribute(a, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
          break;
        }
        if (typeof d == "function" && (a === "formAction" ? (o !== "input" && Fe(t, o, "name", c.name, c, null), Fe(t, o, "formEncType", c.formEncType, c, null), Fe(t, o, "formMethod", c.formMethod, c, null), Fe(t, o, "formTarget", c.formTarget, c, null)) : (Fe(t, o, "encType", c.encType, c, null), Fe(t, o, "method", c.method, c, null), Fe(t, o, "target", c.target, c, null))), u == null || typeof u == "symbol" || typeof u == "boolean") {
          t.removeAttribute(a);
          break;
        }
        u = wl("" + u), t.setAttribute(a, u);
        break;
      case "onClick":
        u != null && (t.onclick = J);
        break;
      case "onScroll":
        u != null && an("scroll", t);
        break;
      case "onScrollEnd":
        u != null && an("scrollend", t);
        break;
      case "dangerouslySetInnerHTML":
        if (u != null) {
          if (typeof u != "object" || !("__html" in u)) throw Error(b(61));
          if ((a = u.__html) != null) {
            if (c.children != null) throw Error(b(60));
            t.innerHTML = a;
          }
        }
        break;
      case "multiple":
        t.multiple = u && typeof u != "function" && typeof u != "symbol";
        break;
      case "muted":
        t.muted = u && typeof u != "function" && typeof u != "symbol";
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "ref":
      case "autoFocus":
        break;
      case "xlinkHref":
        if (u == null || typeof u == "function" || typeof u == "boolean" || typeof u == "symbol") {
          t.removeAttribute("xlink:href");
          break;
        }
        a = wl("" + u), t.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", a);
        break;
      case "contentEditable":
      case "spellCheck":
      case "draggable":
      case "value":
      case "autoReverse":
      case "externalResourcesRequired":
      case "focusable":
      case "preserveAlpha":
        u != null && typeof u != "function" && typeof u != "symbol" ? t.setAttribute(a, "" + u) : t.removeAttribute(a);
        break;
      case "inert":
      case "allowFullScreen":
      case "async":
      case "autoPlay":
      case "controls":
      case "default":
      case "defer":
      case "disabled":
      case "disablePictureInPicture":
      case "disableRemotePlayback":
      case "formNoValidate":
      case "hidden":
      case "loop":
      case "noModule":
      case "noValidate":
      case "open":
      case "playsInline":
      case "readOnly":
      case "required":
      case "reversed":
      case "scoped":
      case "seamless":
      case "itemScope":
        u && typeof u != "function" && typeof u != "symbol" ? t.setAttribute(a, "") : t.removeAttribute(a);
        break;
      case "capture":
      case "download":
        u === !0 ? t.setAttribute(a, "") : u !== !1 && u != null && typeof u != "function" && typeof u != "symbol" ? t.setAttribute(a, u) : t.removeAttribute(a);
        break;
      case "cols":
      case "rows":
      case "size":
      case "span":
        u != null && typeof u != "function" && typeof u != "symbol" && !isNaN(u) && 1 <= u ? t.setAttribute(a, u) : t.removeAttribute(a);
        break;
      case "rowSpan":
      case "start":
        u == null || typeof u == "function" || typeof u == "symbol" || isNaN(u) ? t.removeAttribute(a) : t.setAttribute(a, u);
        break;
      case "popover":
        an("beforetoggle", t), an("toggle", t), ws(t, "popover", u);
        break;
      case "xlinkActuate":
        xr(t, "http://www.w3.org/1999/xlink", "xlink:actuate", u);
        break;
      case "xlinkArcrole":
        xr(t, "http://www.w3.org/1999/xlink", "xlink:arcrole", u);
        break;
      case "xlinkRole":
        xr(t, "http://www.w3.org/1999/xlink", "xlink:role", u);
        break;
      case "xlinkShow":
        xr(t, "http://www.w3.org/1999/xlink", "xlink:show", u);
        break;
      case "xlinkTitle":
        xr(t, "http://www.w3.org/1999/xlink", "xlink:title", u);
        break;
      case "xlinkType":
        xr(t, "http://www.w3.org/1999/xlink", "xlink:type", u);
        break;
      case "xmlBase":
        xr(t, "http://www.w3.org/XML/1998/namespace", "xml:base", u);
        break;
      case "xmlLang":
        xr(t, "http://www.w3.org/XML/1998/namespace", "xml:lang", u);
        break;
      case "xmlSpace":
        xr(t, "http://www.w3.org/XML/1998/namespace", "xml:space", u);
        break;
      case "is":
        ws(t, "is", u);
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        (!(2 < a.length) || a[0] !== "o" && a[0] !== "O" || a[1] !== "n" && a[1] !== "N") && ws(t, a = eb.get(a) || a, u);
    }
  }
  function gh(t, o, a, u, c, d) {
    switch (a) {
      case "style":
        hu(t, u, d);
        break;
      case "dangerouslySetInnerHTML":
        if (u != null) {
          if (typeof u != "object" || !("__html" in u)) throw Error(b(61));
          if ((a = u.__html) != null) {
            if (c.children != null) throw Error(b(60));
            t.innerHTML = a;
          }
        }
        break;
      case "children":
        typeof u == "string" ? Wo(t, u) : (typeof u == "number" || typeof u == "bigint") && Wo(t, "" + u);
        break;
      case "onScroll":
        u != null && an("scroll", t);
        break;
      case "onScrollEnd":
        u != null && an("scrollend", t);
        break;
      case "onClick":
        u != null && (t.onclick = J);
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "innerHTML":
      case "ref":
      case "innerText":
      case "textContent":
        break;
      default:
        md.hasOwnProperty(a) || (a[0] !== "o" || a[1] !== "n" || (c = a.endsWith("Capture"), o = a.slice(2, c ? a.length - 7 : void 0), typeof (d = (d = t[pr] || null) != null ? d[a] : null) == "function" && t.removeEventListener(o, d, c), typeof u != "function") ? a in t ? t[a] = u : u === !0 ? t.setAttribute(a, "") : ws(t, a, u) : (typeof d != "function" && d !== null && (a in t ? t[a] = null : t.hasAttribute(a) && t.removeAttribute(a)), t.addEventListener(o, u, c)));
    }
  }
  function Pt(t, o, a) {
    switch (o) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "img":
        an("error", t), an("load", t);
        var u, c = !1, d = !1;
        for (u in a) if (a.hasOwnProperty(u)) {
          var g = a[u];
          if (g != null) switch (u) {
            case "src":
              c = !0;
              break;
            case "srcSet":
              d = !0;
              break;
            case "children":
            case "dangerouslySetInnerHTML":
              throw Error(b(137, o));
            default:
              Fe(t, o, u, g, a, null);
          }
        }
        return d && Fe(t, o, "srcSet", a.srcSet, a, null), void (c && Fe(t, o, "src", a.src, a, null));
      case "input":
        an("invalid", t);
        var h = u = g = d = null, w = null, x = null;
        for (c in a) if (a.hasOwnProperty(c)) {
          var B = a[c];
          if (B != null) switch (c) {
            case "name":
              d = B;
              break;
            case "type":
              g = B;
              break;
            case "checked":
              w = B;
              break;
            case "defaultChecked":
              x = B;
              break;
            case "value":
              u = B;
              break;
            case "defaultValue":
              h = B;
              break;
            case "children":
            case "dangerouslySetInnerHTML":
              if (B != null) throw Error(b(137, o));
              break;
            default:
              Fe(t, o, c, B, a, null);
          }
        }
        return Vp(t, u, h, w, x, g, d, !1), void mu(t);
      case "select":
        for (d in an("invalid", t), c = g = u = null, a) if (a.hasOwnProperty(d) && (h = a[d]) != null) switch (d) {
          case "value":
            u = h;
            break;
          case "defaultValue":
            g = h;
            break;
          case "multiple":
            c = h;
          default:
            Fe(t, o, d, h, a, null);
        }
        return o = u, a = g, t.multiple = !!c, void (o != null ? si(t, !!c, o, !1) : a != null && si(t, !!c, a, !0));
      case "textarea":
        for (g in an("invalid", t), u = d = c = null, a) if (a.hasOwnProperty(g) && (h = a[g]) != null) switch (g) {
          case "value":
            c = h;
            break;
          case "defaultValue":
            d = h;
            break;
          case "children":
            u = h;
            break;
          case "dangerouslySetInnerHTML":
            if (h != null) throw Error(b(91));
            break;
          default:
            Fe(t, o, g, h, a, null);
        }
        return Es(t, c, d, u), void mu(t);
      case "option":
        for (w in a) a.hasOwnProperty(w) && (c = a[w]) != null && (w === "selected" ? t.selected = c && typeof c != "function" && typeof c != "symbol" : Fe(t, o, w, c, a, null));
        return;
      case "dialog":
        an("beforetoggle", t), an("toggle", t), an("cancel", t), an("close", t);
        break;
      case "iframe":
      case "object":
        an("load", t);
        break;
      case "video":
      case "audio":
        for (c = 0; c < Ea.length; c++) an(Ea[c], t);
        break;
      case "image":
        an("error", t), an("load", t);
        break;
      case "details":
        an("toggle", t);
        break;
      case "embed":
      case "source":
      case "link":
        an("error", t), an("load", t);
      case "area":
      case "base":
      case "br":
      case "col":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "track":
      case "wbr":
      case "menuitem":
        for (x in a) if (a.hasOwnProperty(x) && (c = a[x]) != null) switch (x) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(b(137, o));
          default:
            Fe(t, o, x, c, a, null);
        }
        return;
      default:
        if (wd(o)) {
          for (B in a) a.hasOwnProperty(B) && (c = a[B]) !== void 0 && gh(t, o, B, c, a, void 0);
          return;
        }
    }
    for (h in a) a.hasOwnProperty(h) && (c = a[h]) != null && Fe(t, o, h, c, a, null);
  }
  var Rc = null, Oo = null;
  function Lo(t) {
    return t.nodeType === 9 ? t : t.ownerDocument;
  }
  function Zu(t) {
    switch (t) {
      case "http://www.w3.org/2000/svg":
        return 1;
      case "http://www.w3.org/1998/Math/MathML":
        return 2;
      default:
        return 0;
    }
  }
  function ul(t, o) {
    if (t === 0) switch (o) {
      case "svg":
        return 1;
      case "math":
        return 2;
      default:
        return 0;
    }
    return t === 1 && o === "foreignObject" ? 0 : t;
  }
  function Ju(t, o) {
    return t === "textarea" || t === "noscript" || typeof o.children == "string" || typeof o.children == "number" || typeof o.children == "bigint" || typeof o.dangerouslySetInnerHTML == "object" && o.dangerouslySetInnerHTML !== null && o.dangerouslySetInnerHTML.__html != null;
  }
  var zo = null, Qf = typeof setTimeout == "function" ? setTimeout : void 0, ib = typeof clearTimeout == "function" ? clearTimeout : void 0, Zg = typeof Promise == "function" ? Promise : void 0, ub = typeof queueMicrotask == "function" ? queueMicrotask : Zg !== void 0 ? function(t) {
    return Zg.resolve(null).then(t).catch(xa);
  } : Qf;
  function xa(t) {
    setTimeout(function() {
      throw t;
    });
  }
  function Ql(t) {
    return t === "head";
  }
  function Yf(t, o) {
    var a = o, u = 0, c = 0;
    do {
      var d = a.nextSibling;
      if (t.removeChild(a), d && d.nodeType === 8) if ((a = d.data) === "/$") {
        if (0 < u && 8 > u) {
          a = u;
          var g = t.ownerDocument;
          if (1 & a && Ca(g.documentElement), 2 & a && Ca(g.body), 4 & a) for (Ca(a = g.head), g = a.firstChild; g; ) {
            var h = g.nextSibling, w = g.nodeName;
            g[fu] || w === "SCRIPT" || w === "STYLE" || w === "LINK" && g.rel.toLowerCase() === "stylesheet" || a.removeChild(g), g = h;
          }
        }
        if (c === 0) return t.removeChild(d), void Ra(o);
        c--;
      } else a === "$" || a === "$?" || a === "$!" ? c++ : u = a.charCodeAt(0) - 48;
      else u = 0;
      a = d;
    } while (a);
    Ra(o);
  }
  function Ac(t) {
    var o = t.firstChild;
    for (o && o.nodeType === 10 && (o = o.nextSibling); o; ) {
      var a = o;
      switch (o = o.nextSibling, a.nodeName) {
        case "HTML":
        case "HEAD":
        case "BODY":
          Ac(a), pu(a);
          continue;
        case "SCRIPT":
        case "STYLE":
          continue;
        case "LINK":
          if (a.rel.toLowerCase() === "stylesheet") continue;
      }
      t.removeChild(a);
    }
  }
  function Yl(t) {
    return t.data === "$!" || t.data === "$?" && t.ownerDocument.readyState === "complete";
  }
  function Do(t) {
    for (; t != null; t = t.nextSibling) {
      var o = t.nodeType;
      if (o === 1 || o === 3) break;
      if (o === 8) {
        if ((o = t.data) === "$" || o === "$!" || o === "$?" || o === "F!" || o === "F") break;
        if (o === "/$") return null;
      }
    }
    return t;
  }
  var Nc = null;
  function Jg(t) {
    t = t.previousSibling;
    for (var o = 0; t; ) {
      if (t.nodeType === 8) {
        var a = t.data;
        if (a === "$" || a === "$!" || a === "$?") {
          if (o === 0) return t;
          o--;
        } else a === "/$" && o++;
      }
      t = t.previousSibling;
    }
    return null;
  }
  function ey(t, o, a) {
    switch (o = Lo(a), t) {
      case "html":
        if (!(t = o.documentElement)) throw Error(b(452));
        return t;
      case "head":
        if (!(t = o.head)) throw Error(b(453));
        return t;
      case "body":
        if (!(t = o.body)) throw Error(b(454));
        return t;
      default:
        throw Error(b(451));
    }
  }
  function Ca(t) {
    for (var o = t.attributes; o.length; ) t.removeAttributeNode(o[0]);
    pu(t);
  }
  var Bn = /* @__PURE__ */ new Map(), Pe = /* @__PURE__ */ new Set();
  function Gr(t) {
    return typeof t.getRootNode == "function" ? t.getRootNode() : t.nodeType === 9 ? t : t.ownerDocument;
  }
  var Rt = S.d;
  S.d = { f: function() {
    var t = Rt.f(), o = kc();
    return t || o;
  }, r: function(t) {
    var o = Wa(t);
    o !== null && o.tag === 5 && o.type === "form" ? Iu(o) : Rt.r(t);
  }, D: function(t) {
    Rt.D(t), ny("dns-prefetch", t, null);
  }, C: function(t, o) {
    Rt.C(t, o), ny("preconnect", t, o);
  }, L: function(t, o, a) {
    Rt.L(t, o, a);
    var u = St;
    if (u && t && o) {
      var c = 'link[rel="preload"][as="' + Hr(o) + '"]';
      o === "image" && a && a.imageSrcSet ? (c += '[imagesrcset="' + Hr(a.imageSrcSet) + '"]', typeof a.imageSizes == "string" && (c += '[imagesizes="' + Hr(a.imageSizes) + '"]')) : c += '[href="' + Hr(t) + '"]';
      var d = c;
      switch (o) {
        case "style":
          d = Gl(t);
          break;
        case "script":
          d = vr(t);
      }
      Bn.has(d) || (t = L({ rel: "preload", href: o === "image" && a && a.imageSrcSet ? void 0 : t, as: o }, a), Bn.set(d, t), u.querySelector(c) !== null || o === "style" && u.querySelector(Ji(d)) || o === "script" && u.querySelector(Xr(d)) || (Pt(o = u.createElement("link"), "link", t), kt(o), u.head.appendChild(o)));
    }
  }, m: function(t, o) {
    Rt.m(t, o);
    var a = St;
    if (a && t) {
      var u = o && typeof o.as == "string" ? o.as : "script", c = 'link[rel="modulepreload"][as="' + Hr(u) + '"][href="' + Hr(t) + '"]', d = c;
      switch (u) {
        case "audioworklet":
        case "paintworklet":
        case "serviceworker":
        case "sharedworker":
        case "worker":
        case "script":
          d = vr(t);
      }
      if (!Bn.has(d) && (t = L({ rel: "modulepreload", href: t }, o), Bn.set(d, t), a.querySelector(c) === null)) {
        switch (u) {
          case "audioworklet":
          case "paintworklet":
          case "serviceworker":
          case "sharedworker":
          case "worker":
          case "script":
            if (a.querySelector(Xr(d))) return;
        }
        Pt(u = a.createElement("link"), "link", t), kt(u), a.head.appendChild(u);
      }
    }
  }, X: function(t, o) {
    Rt.X(t, o);
    var a = St;
    if (a && t) {
      var u = ai(a).hoistableScripts, c = vr(t), d = u.get(c);
      d || ((d = a.querySelector(Xr(c))) || (t = L({ src: t, async: !0 }, o), (o = Bn.get(c)) && ir(t, o), kt(d = a.createElement("script")), Pt(d, "link", t), a.head.appendChild(d)), d = { type: "script", instance: d, count: 1, state: null }, u.set(c, d));
    }
  }, S: function(t, o, a) {
    Rt.S(t, o, a);
    var u = St;
    if (u && t) {
      var c = ai(u).hoistableStyles, d = Gl(t);
      o = o || "default";
      var g = c.get(d);
      if (!g) {
        var h = { loading: 0, preload: null };
        if (g = u.querySelector(Ji(d))) h.loading = 5;
        else {
          t = L({ rel: "stylesheet", href: t, "data-precedence": o }, a), (a = Bn.get(d)) && Mt(t, a);
          var w = g = u.createElement("link");
          kt(w), Pt(w, "link", t), w._p = new Promise(function(x, B) {
            w.onload = x, w.onerror = B;
          }), w.addEventListener("load", function() {
            h.loading |= 1;
          }), w.addEventListener("error", function() {
            h.loading |= 2;
          }), h.loading |= 4, Fo(g, o, u);
        }
        g = { type: "stylesheet", instance: g, count: 1, state: h }, c.set(d, g);
      }
    }
  }, M: function(t, o) {
    Rt.M(t, o);
    var a = St;
    if (a && t) {
      var u = ai(a).hoistableScripts, c = vr(t), d = u.get(c);
      d || ((d = a.querySelector(Xr(c))) || (t = L({ src: t, async: !0, type: "module" }, o), (o = Bn.get(c)) && ir(t, o), kt(d = a.createElement("script")), Pt(d, "link", t), a.head.appendChild(d)), d = { type: "script", instance: d, count: 1, state: null }, u.set(c, d));
    }
  } };
  var St = typeof document > "u" ? null : document;
  function ny(t, o, a) {
    var u = St;
    if (u && typeof o == "string" && o) {
      var c = Hr(o);
      c = 'link[rel="' + t + '"][href="' + c + '"]', typeof a == "string" && (c += '[crossorigin="' + a + '"]'), Pe.has(c) || (Pe.add(c), t = { rel: t, crossOrigin: a, href: o }, u.querySelector(c) === null && (Pt(o = u.createElement("link"), "link", t), kt(o), u.head.appendChild(o)));
    }
  }
  function ty(t, o, a, u) {
    var c, d, g, h, w = (w = Ie.current) ? Gr(w) : null;
    if (!w) throw Error(b(446));
    switch (t) {
      case "meta":
      case "title":
        return null;
      case "style":
        return typeof a.precedence == "string" && typeof a.href == "string" ? (o = Gl(a.href), (u = (a = ai(w).hoistableStyles).get(o)) || (u = { type: "style", instance: null, count: 0, state: null }, a.set(o, u)), u) : { type: "void", instance: null, count: 0, state: null };
      case "link":
        if (a.rel === "stylesheet" && typeof a.href == "string" && typeof a.precedence == "string") {
          t = Gl(a.href);
          var x = ai(w).hoistableStyles, B = x.get(t);
          if (B || (w = w.ownerDocument || w, B = { type: "stylesheet", instance: null, count: 0, state: { loading: 0, preload: null } }, x.set(t, B), (x = w.querySelector(Ji(t))) && !x._p && (B.instance = x, B.state.loading = 5), Bn.has(t) || (a = { rel: "preload", as: "style", href: a.href, crossOrigin: a.crossOrigin, integrity: a.integrity, media: a.media, hrefLang: a.hrefLang, referrerPolicy: a.referrerPolicy }, Bn.set(t, a), x || (c = w, d = t, g = a, h = B.state, c.querySelector('link[rel="preload"][as="style"][' + d + "]") ? h.loading = 1 : (d = c.createElement("link"), h.preload = d, d.addEventListener("load", function() {
            return h.loading |= 1;
          }), d.addEventListener("error", function() {
            return h.loading |= 2;
          }), Pt(d, "link", g), kt(d), c.head.appendChild(d))))), o && u === null) throw Error(b(528, ""));
          return B;
        }
        if (o && u !== null) throw Error(b(529, ""));
        return null;
      case "script":
        return o = a.async, typeof (a = a.src) == "string" && o && typeof o != "function" && typeof o != "symbol" ? (o = vr(a), (u = (a = ai(w).hoistableScripts).get(o)) || (u = { type: "script", instance: null, count: 0, state: null }, a.set(o, u)), u) : { type: "void", instance: null, count: 0, state: null };
      default:
        throw Error(b(444, t));
    }
  }
  function Gl(t) {
    return 'href="' + Hr(t) + '"';
  }
  function Ji(t) {
    return 'link[rel="stylesheet"][' + t + "]";
  }
  function Kr(t) {
    return L({}, t, { "data-precedence": t.precedence, precedence: null });
  }
  function vr(t) {
    return '[src="' + Hr(t) + '"]';
  }
  function Xr(t) {
    return "script[async]" + t;
  }
  function _c(t, o, a) {
    if (o.count++, o.instance === null) switch (o.type) {
      case "style":
        var u = t.querySelector('style[data-href~="' + Hr(a.href) + '"]');
        if (u) return o.instance = u, kt(u), u;
        var c = L({}, a, { "data-href": a.href, "data-precedence": a.precedence, href: null, precedence: null });
        return kt(u = (t.ownerDocument || t).createElement("style")), Pt(u, "style", c), Fo(u, a.precedence, t), o.instance = u;
      case "stylesheet":
        c = Gl(a.href);
        var d = t.querySelector(Ji(c));
        if (d) return o.state.loading |= 4, o.instance = d, kt(d), d;
        u = Kr(a), (c = Bn.get(c)) && Mt(u, c), kt(d = (t.ownerDocument || t).createElement("link"));
        var g = d;
        return g._p = new Promise(function(h, w) {
          g.onload = h, g.onerror = w;
        }), Pt(d, "link", u), o.state.loading |= 4, Fo(d, a.precedence, t), o.instance = d;
      case "script":
        return d = vr(a.src), (c = t.querySelector(Xr(d))) ? (o.instance = c, kt(c), c) : (u = a, (c = Bn.get(d)) && ir(u = L({}, a), c), kt(c = (t = t.ownerDocument || t).createElement("script")), Pt(c, "link", u), t.head.appendChild(c), o.instance = c);
      case "void":
        return null;
      default:
        throw Error(b(443, o.type));
    }
    else o.type === "stylesheet" && !(4 & o.state.loading) && (u = o.instance, o.state.loading |= 4, Fo(u, a.precedence, t));
    return o.instance;
  }
  function Fo(t, o, a) {
    for (var u = a.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), c = u.length ? u[u.length - 1] : null, d = c, g = 0; g < u.length; g++) {
      var h = u[g];
      if (h.dataset.precedence === o) d = h;
      else if (d !== c) break;
    }
    d ? d.parentNode.insertBefore(t, d.nextSibling) : (o = a.nodeType === 9 ? a.head : a).insertBefore(t, o.firstChild);
  }
  function Mt(t, o) {
    t.crossOrigin == null && (t.crossOrigin = o.crossOrigin), t.referrerPolicy == null && (t.referrerPolicy = o.referrerPolicy), t.title == null && (t.title = o.title);
  }
  function ir(t, o) {
    t.crossOrigin == null && (t.crossOrigin = o.crossOrigin), t.referrerPolicy == null && (t.referrerPolicy = o.referrerPolicy), t.integrity == null && (t.integrity = o.integrity);
  }
  var Io = null;
  function Gf(t, o, a) {
    if (Io === null) {
      var u = /* @__PURE__ */ new Map(), c = Io = /* @__PURE__ */ new Map();
      c.set(a, u);
    } else (u = (c = Io).get(a)) || (u = /* @__PURE__ */ new Map(), c.set(a, u));
    if (u.has(t)) return u;
    for (u.set(t, null), a = a.getElementsByTagName(t), c = 0; c < a.length; c++) {
      var d = a[c];
      if (!(d[fu] || d[Ut] || t === "link" && d.getAttribute("rel") === "stylesheet") && d.namespaceURI !== "http://www.w3.org/2000/svg") {
        var g = d.getAttribute(o) || "";
        g = t + g;
        var h = u.get(g);
        h ? h.push(d) : u.set(g, [d]);
      }
    }
    return u;
  }
  function ry(t, o, a) {
    (t = t.ownerDocument || t).head.insertBefore(a, o === "title" ? t.querySelector("head > title") : null);
  }
  function oy(t) {
    return !!(t.type !== "stylesheet" || 3 & t.state.loading);
  }
  var es = null;
  function Oc() {
  }
  function Lc() {
    if (this.count--, this.count === 0) {
      if (this.stylesheets) zc(this, this.stylesheets);
      else if (this.unsuspend) {
        var t = this.unsuspend;
        this.unsuspend = null, t();
      }
    }
  }
  var Ta = null;
  function zc(t, o) {
    t.stylesheets = null, t.unsuspend !== null && (t.count++, Ta = /* @__PURE__ */ new Map(), o.forEach(sb, t), Ta = null, Lc.call(t));
  }
  function sb(t, o) {
    if (!(4 & o.state.loading)) {
      var a = Ta.get(t);
      if (a) var u = a.get(null);
      else {
        a = /* @__PURE__ */ new Map(), Ta.set(t, a);
        for (var c = t.querySelectorAll("link[data-precedence],style[data-precedence]"), d = 0; d < c.length; d++) {
          var g = c[d];
          g.nodeName !== "LINK" && g.getAttribute("media") === "not all" || (a.set(g.dataset.precedence, g), u = g);
        }
        u && a.set(null, u);
      }
      g = (c = o.instance).getAttribute("data-precedence"), (d = a.get(g) || u) === u && a.set(null, c), a.set(g, c), this.count++, u = Lc.bind(this), c.addEventListener("load", u), c.addEventListener("error", u), d ? d.parentNode.insertBefore(c, d.nextSibling) : (t = t.nodeType === 9 ? t.head : t).insertBefore(c, t.firstChild), o.state.loading |= 4;
    }
  }
  var Dc = { $$typeof: ue, Provider: null, Consumer: null, _currentValue: N, _currentValue2: N, _threadCount: 0 };
  function ay(t, o, a, u, c, d, g, h) {
    this.tag = 1, this.containerInfo = t, this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null, this.callbackPriority = 0, this.expirationTimes = wn(-1), this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = wn(0), this.hiddenUpdates = wn(null), this.identifierPrefix = u, this.onUncaughtError = c, this.onCaughtError = d, this.onRecoverableError = g, this.pooledCache = null, this.pooledCacheLanes = 0, this.formState = h, this.incompleteTransitions = /* @__PURE__ */ new Map();
  }
  function yh(t, o, a, u, c, d, g, h, w, x, B, q) {
    return t = new ay(t, o, a, g, h, w, x, q), o = 1, d === !0 && (o |= 24), d = Pr(3, null, null, o), t.current = d, d.stateNode = t, (o = Dl()).refCount++, t.pooledCache = o, o.refCount++, d.memoizedState = { element: u, isDehydrated: a, cache: o }, Qd(d), t;
  }
  function Fc(t) {
    return t ? t = Tu : Tu;
  }
  function Kf(t, o, a, u, c, d) {
    c = Fc(c), u.context === null ? u.context = c : u.pendingContext = c, (u = Nr(o)).payload = { element: a }, (d = d === void 0 ? null : d) !== null && (u.callback = d), (a = aa(t, u, o)) !== null && (qt(a, 0, o), Ci(a, t, o));
  }
  function bh(t, o) {
    if ((t = t.memoizedState) !== null && t.dehydrated !== null) {
      var a = t.retryLane;
      t.retryLane = a !== 0 && a < o ? a : o;
    }
  }
  function Ic(t, o) {
    bh(t, o), (t = t.alternate) && bh(t, o);
  }
  function Xf(t) {
    if (t.tag === 13) {
      var o = Zo(t, 67108864);
      o !== null && qt(o, 0, 67108864), Ic(t, 67108864);
    }
  }
  var ur = !0;
  function Pa(t, o, a, u) {
    var c = Ae.T;
    Ae.T = null;
    var d = S.p;
    try {
      S.p = 2, $f(t, o, a, u);
    } finally {
      S.p = d, Ae.T = c;
    }
  }
  function cb(t, o, a, u) {
    var c = Ae.T;
    Ae.T = null;
    var d = S.p;
    try {
      S.p = 8, $f(t, o, a, u);
    } finally {
      S.p = d, Ae.T = c;
    }
  }
  function $f(t, o, a, u) {
    if (ur) {
      var c = Zf(u);
      if (c === null) Pc(t, o, u, Mc, a), kh(t, u);
      else if (function(x, B, q, ee, le) {
        switch (B) {
          case "focusin":
            return sl = Xl(sl, x, B, q, ee, le), !0;
          case "dragenter":
            return cl = Xl(cl, x, B, q, ee, le), !0;
          case "mouseover":
            return dl = Xl(dl, x, B, q, ee, le), !0;
          case "pointerover":
            var de = le.pointerId;
            return jc.set(de, Xl(jc.get(de) || null, x, B, q, ee, le)), !0;
          case "gotpointercapture":
            return de = le.pointerId, ns.set(de, Xl(ns.get(de) || null, x, B, q, ee, le)), !0;
        }
        return !1;
      }(c, t, o, a, u)) u.stopPropagation();
      else if (kh(t, u), 4 & o && -1 < db.indexOf(t)) {
        for (; c !== null; ) {
          var d = Wa(c);
          if (d !== null) switch (d.tag) {
            case 3:
              if ((d = d.stateNode).current.memoizedState.isDehydrated) {
                var g = V(d.pendingLanes);
                if (g !== 0) {
                  var h = d;
                  for (h.pendingLanes |= 2, h.entangledLanes |= 2; g; ) {
                    var w = 1 << 31 - vt(g);
                    h.entanglements[1] |= w, g &= ~w;
                  }
                  _o(d), !(6 & Rn) && (yc = oo() + 500, Gu(0));
                }
              }
              break;
            case 13:
              (h = Zo(d, 2)) !== null && qt(h, 0, 2), kc(), Ic(d, 2);
          }
          if ((d = Zf(u)) === null && Pc(t, o, u, Mc, a), d === c) break;
          c = d;
        }
        c !== null && u.stopPropagation();
      } else Pc(t, o, u, null, a);
    }
  }
  function Zf(t) {
    return Jf(t = Sd(t));
  }
  var Mc = null;
  function Jf(t) {
    if (Mc = null, (t = oi(t)) !== null) {
      var o = W(t);
      if (o === null) t = null;
      else {
        var a = o.tag;
        if (a === 13) {
          if ((t = Z(o)) !== null) return t;
          t = null;
        } else if (a === 3) {
          if (o.stateNode.current.memoizedState.isDehydrated) return o.tag === 3 ? o.stateNode.containerInfo : null;
          t = null;
        } else o !== t && (t = null);
      }
    }
    return Mc = t, null;
  }
  function vh(t) {
    switch (t) {
      case "beforetoggle":
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "toggle":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 2;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 8;
      case "message":
        switch (rn()) {
          case yl:
            return 2;
          case ti:
            return 8;
          case Bo:
          case pd:
            return 32;
          case vs:
            return 268435456;
          default:
            return 32;
        }
      default:
        return 32;
    }
  }
  var ep = !1, sl = null, cl = null, dl = null, jc = /* @__PURE__ */ new Map(), ns = /* @__PURE__ */ new Map(), Kl = [], db = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
  function kh(t, o) {
    switch (t) {
      case "focusin":
      case "focusout":
        sl = null;
        break;
      case "dragenter":
      case "dragleave":
        cl = null;
        break;
      case "mouseover":
      case "mouseout":
        dl = null;
        break;
      case "pointerover":
      case "pointerout":
        jc.delete(o.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        ns.delete(o.pointerId);
    }
  }
  function Xl(t, o, a, u, c, d) {
    return t === null || t.nativeEvent !== d ? (t = { blockedOn: o, domEventName: a, eventSystemFlags: u, nativeEvent: d, targetContainers: [c] }, o !== null && (o = Wa(o)) !== null && Xf(o), t) : (t.eventSystemFlags |= u, o = t.targetContainers, c !== null && o.indexOf(c) === -1 && o.push(c), t);
  }
  function np(t) {
    var o = oi(t.target);
    if (o !== null) {
      var a = W(o);
      if (a !== null) {
        if ((o = a.tag) === 13) {
          if ((o = Z(a)) !== null) return t.blockedOn = o, void function(u, c) {
            var d = S.p;
            try {
              return S.p = u, c();
            } finally {
              S.p = d;
            }
          }(t.priority, function() {
            if (a.tag === 13) {
              var u = Lr();
              u = Ln(u);
              var c = Zo(a, u);
              c !== null && qt(c, 0, u), Ic(a, u);
            }
          });
        } else if (o === 3 && a.stateNode.current.memoizedState.isDehydrated) return void (t.blockedOn = a.tag === 3 ? a.stateNode.containerInfo : null);
      }
    }
    t.blockedOn = null;
  }
  function Hc(t) {
    if (t.blockedOn !== null) return !1;
    for (var o = t.targetContainers; 0 < o.length; ) {
      var a = Zf(t.nativeEvent);
      if (a !== null) return (o = Wa(a)) !== null && Xf(o), t.blockedOn = a, !1;
      var u = new (a = t.nativeEvent).constructor(a.type, a);
      xs = u, a.target.dispatchEvent(u), xs = null, o.shift();
    }
    return !0;
  }
  function wh(t, o, a) {
    Hc(t) && a.delete(o);
  }
  function fb() {
    ep = !1, sl !== null && Hc(sl) && (sl = null), cl !== null && Hc(cl) && (cl = null), dl !== null && Hc(dl) && (dl = null), jc.forEach(wh), ns.forEach(wh);
  }
  function tp(t, o) {
    t.blockedOn === o && (t.blockedOn = null, ep || (ep = !0, m.unstable_scheduleCallback(m.unstable_NormalPriority, fb)));
  }
  var rp = null;
  function Sh(t) {
    rp !== t && (rp = t, m.unstable_scheduleCallback(m.unstable_NormalPriority, function() {
      rp === t && (rp = null);
      for (var o = 0; o < t.length; o += 3) {
        var a = t[o], u = t[o + 1], c = t[o + 2];
        if (typeof u != "function") {
          if (Jf(u || a) === null) continue;
          break;
        }
        var d = Wa(a);
        d !== null && (t.splice(o, 3), o -= 3, ff(d, { pending: !0, data: c, method: a.method, action: u }, u, c));
      }
    }));
  }
  function Ra(t) {
    function o(w) {
      return tp(w, t);
    }
    sl !== null && tp(sl, t), cl !== null && tp(cl, t), dl !== null && tp(dl, t), jc.forEach(o), ns.forEach(o);
    for (var a = 0; a < Kl.length; a++) {
      var u = Kl[a];
      u.blockedOn === t && (u.blockedOn = null);
    }
    for (; 0 < Kl.length && (a = Kl[0]).blockedOn === null; ) np(a), a.blockedOn === null && Kl.shift();
    if ((a = (t.ownerDocument || t).$$reactFormReplay) != null) for (u = 0; u < a.length; u += 3) {
      var c = a[u], d = a[u + 1], g = c[pr] || null;
      if (typeof d == "function") g || Sh(a);
      else if (g) {
        var h = null;
        if (d && d.hasAttribute("formAction")) {
          if (c = d, g = d[pr] || null) h = g.formAction;
          else if (Jf(c) !== null) continue;
        } else h = g.action;
        typeof h == "function" ? a[u + 1] = h : (a.splice(u, 3), u -= 3), Sh(a);
      }
    }
  }
  function Uc(t) {
    this._internalRoot = t;
  }
  function Bc(t) {
    this._internalRoot = t;
  }
  Bc.prototype.render = Uc.prototype.render = function(t) {
    var o = this._internalRoot;
    if (o === null) throw Error(b(409));
    Kf(o.current, Lr(), t, o, null, null);
  }, Bc.prototype.unmount = Uc.prototype.unmount = function() {
    var t = this._internalRoot;
    if (t !== null) {
      this._internalRoot = null;
      var o = t.containerInfo;
      Kf(t.current, 2, null, t, null, null), kc(), o[Va] = null;
    }
  }, Bc.prototype.unstable_scheduleHydration = function(t) {
    if (t) {
      var o = ri();
      t = { blockedOn: null, target: t, priority: o };
      for (var a = 0; a < Kl.length && o !== 0 && o < Kl[a].priority; a++) ;
      Kl.splice(a, 0, t), a === 0 && np(t);
    }
  };
  var Eh = k.version;
  if (Eh !== "19.1.0") throw Error(b(527, Eh, "19.1.0"));
  S.findDOMNode = function(t) {
    var o = t._reactInternals;
    if (o === void 0)
      throw typeof t.render == "function" ? Error(b(188)) : (t = Object.keys(t).join(","), Error(b(268, t)));
    return t = function(a) {
      var u = a.alternate;
      if (!u) {
        if ((u = W(a)) === null) throw Error(b(188));
        return u !== a ? null : a;
      }
      for (var c = a, d = u; ; ) {
        var g = c.return;
        if (g === null) break;
        var h = g.alternate;
        if (h === null) {
          if ((d = g.return) !== null) {
            c = d;
            continue;
          }
          break;
        }
        if (g.child === h.child) {
          for (h = g.child; h; ) {
            if (h === c) return H(g), a;
            if (h === d) return H(g), u;
            h = h.sibling;
          }
          throw Error(b(188));
        }
        if (c.return !== d.return) c = g, d = h;
        else {
          for (var w = !1, x = g.child; x; ) {
            if (x === c) {
              w = !0, c = g, d = h;
              break;
            }
            if (x === d) {
              w = !0, d = g, c = h;
              break;
            }
            x = x.sibling;
          }
          if (!w) {
            for (x = h.child; x; ) {
              if (x === c) {
                w = !0, c = h, d = g;
                break;
              }
              if (x === d) {
                w = !0, d = h, c = g;
                break;
              }
              x = x.sibling;
            }
            if (!w) throw Error(b(189));
          }
        }
        if (c.alternate !== d) throw Error(b(190));
      }
      if (c.tag !== 3) throw Error(b(188));
      return c.stateNode.current === c ? a : u;
    }(o), t = (t = t !== null ? R(t) : null) === null ? null : t.stateNode;
  };
  var ly = { bundleType: 0, version: "19.1.0", rendererPackageName: "react-dom", currentDispatcherRef: Ae, reconcilerVersion: "19.1.0" };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var eu = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!eu.isDisabled && eu.supportsFiber) try {
      Ba = eu.inject(ly), _t = eu;
    } catch {
    }
  }
  return lg.createRoot = function(t, o) {
    if (!A(t)) throw Error(b(299));
    var a = !1, u = "", c = uc, d = Mm, g = jm;
    return o != null && (o.unstable_strictMode === !0 && (a = !0), o.identifierPrefix !== void 0 && (u = o.identifierPrefix), o.onUncaughtError !== void 0 && (c = o.onUncaughtError), o.onCaughtError !== void 0 && (d = o.onCaughtError), o.onRecoverableError !== void 0 && (g = o.onRecoverableError), o.unstable_transitionCallbacks !== void 0 && o.unstable_transitionCallbacks), o = yh(t, 1, !1, null, 0, a, u, c, d, g, 0, null), t[Va] = o.current, mo(t), new Uc(o);
  }, lg.hydrateRoot = function(t, o, a) {
    if (!A(t)) throw Error(b(299));
    var u = !1, c = "", d = uc, g = Mm, h = jm, w = null;
    return a != null && (a.unstable_strictMode === !0 && (u = !0), a.identifierPrefix !== void 0 && (c = a.identifierPrefix), a.onUncaughtError !== void 0 && (d = a.onUncaughtError), a.onCaughtError !== void 0 && (g = a.onCaughtError), a.onRecoverableError !== void 0 && (h = a.onRecoverableError), a.unstable_transitionCallbacks !== void 0 && a.unstable_transitionCallbacks, a.formState !== void 0 && (w = a.formState)), (o = yh(t, 1, !0, o, 0, u, c, d, g, h, 0, w)).context = Fc(null), a = o.current, (c = Nr(u = Ln(u = Lr()))).callback = null, aa(a, c, u), a = u, o.current.lanes = a, Ze(o, a), _o(o), t[Va] = o.current, mo(t), new Bc(o);
  }, lg.version = "19.1.0", lg;
}
var Yk, Gk, ig = {};
function V1() {
  if (Yk) return ig;
  Yk = 1;
  /**
  	 * @license React
  	 * react-dom-client.development.js
  	 *
  	 * Copyright (c) Meta Platforms, Inc. and affiliates.
  	 *
  	 * This source code is licensed under the MIT license found in the
  	 * LICENSE file in the root directory of this source tree.
  	 */
  return {}.NODE_ENV !== "production" && function() {
    function m(e, n) {
      for (e = e.memoizedState; e !== null && 0 < n; ) e = e.next, n--;
      return e;
    }
    function k(e, n, r, l) {
      if (r >= n.length) return l;
      var i = n[r], s = It(e) ? e.slice() : en({}, e);
      return s[i] = k(e[i], n, r + 1, l), s;
    }
    function C(e, n, r) {
      if (n.length === r.length) {
        for (var l = 0; l < r.length - 1; l++) if (n[l] !== r[l]) return void console.warn("copyWithRename() expects paths to be the same except for the deepest key");
        return b(e, n, r, 0);
      }
      console.warn("copyWithRename() expects paths of the same length");
    }
    function b(e, n, r, l) {
      var i = n[l], s = It(e) ? e.slice() : en({}, e);
      return l + 1 === n.length ? (s[r[l]] = s[i], It(s) ? s.splice(i, 1) : delete s[i]) : s[i] = b(e[i], n, r, l + 1), s;
    }
    function A(e, n, r) {
      var l = n[r], i = It(e) ? e.slice() : en({}, e);
      return r + 1 === n.length ? (It(i) ? i.splice(l, 1) : delete i[l], i) : (i[l] = A(e[l], n, r + 1), i);
    }
    function W() {
      return !1;
    }
    function Z() {
      return null;
    }
    function H() {
    }
    function R() {
      console.error("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://react.dev/link/rules-of-hooks");
    }
    function L() {
      console.error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
    }
    function U() {
    }
    function O(e) {
      var n = [];
      return e.forEach(function(r) {
        n.push(r);
      }), n.sort().join(", ");
    }
    function Y(e, n, r, l) {
      return new Os(e, n, r, l);
    }
    function K(e, n) {
      e.context === ts && (Mf(e.current, 2, n, e, null, null), ji());
    }
    function ye(e, n) {
      if (Na !== null) {
        var r = n.staleFamilies;
        n = n.updatedFamilies, Hu(), _s(e.current, n, r), ji();
      }
    }
    function G(e) {
      Na = e;
    }
    function re(e) {
      return !(!e || e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11);
    }
    function oe(e) {
      var n = e, r = e;
      if (e.alternate) for (; n.return; ) n = n.return;
      else {
        e = n;
        do
          4098 & (n = e).flags && (r = n.return), e = n.return;
        while (e);
      }
      return n.tag === 3 ? r : null;
    }
    function ue(e) {
      if (e.tag === 13) {
        var n = e.memoizedState;
        if (n === null && (e = e.alternate) !== null && (n = e.memoizedState), n !== null) return n.dehydrated;
      }
      return null;
    }
    function pe(e) {
      if (oe(e) !== e) throw Error("Unable to find node on an unmounted component.");
    }
    function se(e) {
      var n = e.tag;
      if (n === 5 || n === 26 || n === 27 || n === 6) return e;
      for (e = e.child; e !== null; ) {
        if ((n = se(e)) !== null) return n;
        e = e.sibling;
      }
      return null;
    }
    function ke(e) {
      return e === null || typeof e != "object" ? null : typeof (e = Xg && e[Xg] || e["@@iterator"]) == "function" ? e : null;
    }
    function Se(e) {
      if (e == null) return null;
      if (typeof e == "function") return e.$$typeof === $g ? null : e.displayName || e.name || null;
      if (typeof e == "string") return e;
      switch (e) {
        case Ku:
          return "Fragment";
        case an:
          return "Profiler";
        case Tc:
          return "StrictMode";
        case Pc:
          return "Suspense";
        case $i:
          return "SuspenseList";
        case qf:
          return "Activity";
      }
      if (typeof e == "object") switch (typeof e.tag == "number" && console.error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), e.$$typeof) {
        case Ea:
          return "Portal";
        case mo:
          return (e.displayName || "Context") + ".Provider";
        case Xu:
          return (e._context.displayName || "Context") + ".Consumer";
        case $u:
          var n = e.render;
          return (e = e.displayName) || (e = (e = n.displayName || n.name || "") !== "" ? "ForwardRef(" + e + ")" : "ForwardRef"), e;
        case Zi:
          return (n = e.displayName || null) !== null ? n : Se(e.type) || "Memo";
        case Ft:
          n = e._payload, e = e._init;
          try {
            return Se(e(n));
          } catch {
          }
      }
      return null;
    }
    function Ge(e) {
      return typeof e.tag == "number" ? Ee(e) : typeof e.name == "string" ? e.name : null;
    }
    function Ee(e) {
      var n = e.type;
      switch (e.tag) {
        case 31:
          return "Activity";
        case 24:
          return "Cache";
        case 9:
          return (n._context.displayName || "Context") + ".Consumer";
        case 10:
          return (n.displayName || "Context") + ".Provider";
        case 18:
          return "DehydratedFragment";
        case 11:
          return e = (e = n.render).displayName || e.name || "", n.displayName || (e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef");
        case 7:
          return "Fragment";
        case 26:
        case 27:
        case 5:
          return n;
        case 4:
          return "Portal";
        case 3:
          return "Root";
        case 6:
          return "Text";
        case 16:
          return Se(n);
        case 8:
          return n === Tc ? "StrictMode" : "Mode";
        case 22:
          return "Offscreen";
        case 12:
          return "Profiler";
        case 21:
          return "Scope";
        case 13:
          return "Suspense";
        case 19:
          return "SuspenseList";
        case 25:
          return "TracingMarker";
        case 1:
        case 0:
        case 14:
        case 15:
          if (typeof n == "function") return n.displayName || n.name || null;
          if (typeof n == "string") return n;
          break;
        case 29:
          if ((n = e._debugInfo) != null) {
            for (var r = n.length - 1; 0 <= r; r--) if (typeof n[r].name == "string") return n[r].name;
          }
          if (e.return !== null) return Ee(e.return);
      }
      return null;
    }
    function Me(e) {
      return { current: e };
    }
    function Ue(e, n) {
      0 > Oo ? console.error("Unexpected pop.") : (n !== Rc[Oo] && console.error("Unexpected Fiber popped."), e.current = Pt[Oo], Pt[Oo] = null, Rc[Oo] = null, Oo--);
    }
    function Oe(e, n, r) {
      Oo++, Pt[Oo] = e.current, Rc[Oo] = r, e.current = n;
    }
    function mn(e) {
      return e === null && console.error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue."), e;
    }
    function yn(e, n) {
      Oe(ul, n, e), Oe(Zu, e, e), Oe(Lo, null, e);
      var r = n.nodeType;
      switch (r) {
        case 9:
        case 11:
          r = r === 9 ? "#document" : "#fragment", n = (n = n.documentElement) && (n = n.namespaceURI) ? jg(n) : fs;
          break;
        default:
          if (r = n.tagName, n = n.namespaceURI) n = Hg(n = jg(n), r);
          else switch (r) {
            case "svg":
              n = _p;
              break;
            case "math":
              n = Iy;
              break;
            default:
              n = fs;
          }
      }
      r = { context: n, ancestorInfo: r = Vp(null, r = r.toLowerCase()) }, Ue(Lo, e), Oe(Lo, r, e);
    }
    function jn(e) {
      Ue(Lo, e), Ue(Zu, e), Ue(ul, e);
    }
    function Ae() {
      return mn(Lo.current);
    }
    function S(e) {
      e.memoizedState !== null && Oe(Ju, e, e);
      var n = mn(Lo.current), r = e.type, l = Hg(n.context, r);
      n !== (l = { context: l, ancestorInfo: r = Vp(n.ancestorInfo, r) }) && (Oe(Zu, e, e), Oe(Lo, l, e));
    }
    function N(e) {
      Zu.current === e && (Ue(Lo, e), Ue(Zu, e)), Ju.current === e && (Ue(Ju, e), ng._currentValue = id);
    }
    function $(e) {
      return typeof Symbol == "function" && Symbol.toStringTag && e[Symbol.toStringTag] || e.constructor.name || "Object";
    }
    function ae(e) {
      try {
        return me(e), !1;
      } catch {
        return !0;
      }
    }
    function me(e) {
      return "" + e;
    }
    function ce(e, n) {
      if (ae(e)) return console.error("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before using it here.", n, $(e)), me(e);
    }
    function Te(e, n) {
      if (ae(e)) return console.error("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before using it here.", n, $(e)), me(e);
    }
    function He(e) {
      if (ae(e)) return console.error("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before using it here.", $(e)), me(e);
    }
    function Ce(e) {
      if (typeof Jg == "function" && ey(e), Bn && typeof Bn.setStrictMode == "function") try {
        Bn.setStrictMode(Ca, e);
      } catch (n) {
        Gr || (Gr = !0, console.error("React instrumentation encountered an error: %s", n));
      }
    }
    function Ie(e) {
      Pe = e;
    }
    function Be() {
      Pe !== null && typeof Pe.markCommitStopped == "function" && Pe.markCommitStopped();
    }
    function Qe(e) {
      Pe !== null && typeof Pe.markComponentRenderStarted == "function" && Pe.markComponentRenderStarted(e);
    }
    function _e() {
      Pe !== null && typeof Pe.markComponentRenderStopped == "function" && Pe.markComponentRenderStopped();
    }
    function Vn(e) {
      Pe !== null && typeof Pe.markRenderStarted == "function" && Pe.markRenderStarted(e);
    }
    function Fn() {
      Pe !== null && typeof Pe.markRenderStopped == "function" && Pe.markRenderStopped();
    }
    function Xt(e, n) {
      Pe !== null && typeof Pe.markStateUpdateScheduled == "function" && Pe.markStateUpdateScheduled(e, n);
    }
    function $t(e) {
      return 1 & e ? "SyncHydrationLane" : 2 & e ? "Sync" : 4 & e ? "InputContinuousHydration" : 8 & e ? "InputContinuous" : 16 & e ? "DefaultHydration" : 32 & e ? "Default" : 128 & e ? "TransitionHydration" : 4194048 & e ? "Transition" : 62914560 & e ? "Retry" : 67108864 & e ? "SelectiveHydration" : 134217728 & e ? "IdleHydration" : 268435456 & e ? "Idle" : 536870912 & e ? "Offscreen" : 1073741824 & e ? "Deferred" : void 0;
    }
    function fr(e) {
      var n = 42 & e;
      if (n !== 0) return n;
      switch (e & -e) {
        case 1:
          return 1;
        case 2:
          return 2;
        case 4:
          return 4;
        case 8:
          return 8;
        case 16:
          return 16;
        case 32:
          return 32;
        case 64:
          return 64;
        case 128:
          return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
          return 4194048 & e;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
          return 62914560 & e;
        case 67108864:
          return 67108864;
        case 134217728:
          return 134217728;
        case 268435456:
          return 268435456;
        case 536870912:
          return 536870912;
        case 1073741824:
          return 0;
        default:
          return console.error("Should have found matching lanes. This is a bug in React."), e;
      }
    }
    function Ua(e, n, r) {
      var l = e.pendingLanes;
      if (l === 0) return 0;
      var i = 0, s = e.suspendedLanes, f = e.pingedLanes;
      e = e.warmLanes;
      var p = 134217727 & l;
      return p !== 0 ? (l = p & ~s) !== 0 ? i = fr(l) : (f &= p) !== 0 ? i = fr(f) : r || (r = p & ~e) !== 0 && (i = fr(r)) : (p = l & ~s) !== 0 ? i = fr(p) : f !== 0 ? i = fr(f) : r || (r = l & ~e) !== 0 && (i = fr(r)), i === 0 ? 0 : n !== 0 && n !== i && (n & s) === 0 && ((s = i & -i) >= (r = n & -n) || s === 32 && 4194048 & r) ? n : i;
    }
    function Uo(e, n) {
      return (e.pendingLanes & ~(e.suspendedLanes & ~e.pingedLanes) & n) === 0;
    }
    function oo(e, n) {
      switch (e) {
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
          return n + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
          return n + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
          return -1;
        default:
          return console.error("Should have found matching lanes. This is a bug in React."), -1;
      }
    }
    function rn() {
      var e = Gl;
      return !(4194048 & (Gl <<= 1)) && (Gl = 256), e;
    }
    function yl() {
      var e = Ji;
      return !(62914560 & (Ji <<= 1)) && (Ji = 4194304), e;
    }
    function ti(e) {
      for (var n = [], r = 0; 31 > r; r++) n.push(e);
      return n;
    }
    function Bo(e, n) {
      e.pendingLanes |= n, n !== 268435456 && (e.suspendedLanes = 0, e.pingedLanes = 0, e.warmLanes = 0);
    }
    function pd(e, n, r) {
      e.pendingLanes |= n, e.suspendedLanes &= ~n;
      var l = 31 - St(n);
      e.entangledLanes |= n, e.entanglements[l] = 1073741824 | e.entanglements[l] | 4194090 & r;
    }
    function vs(e, n) {
      var r = e.entangledLanes |= n;
      for (e = e.entanglements; r; ) {
        var l = 31 - St(r), i = 1 << l;
        i & n | e[l] & n && (e[l] |= n), r &= ~i;
      }
    }
    function du(e) {
      switch (e) {
        case 2:
          e = 1;
          break;
        case 8:
          e = 4;
          break;
        case 32:
          e = 16;
          break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
          e = 128;
          break;
        case 268435456:
          e = 134217728;
          break;
        default:
          e = 0;
      }
      return e;
    }
    function ks(e, n, r) {
      if (Rt) for (e = e.pendingUpdatersLaneMap; 0 < r; ) {
        var l = 31 - St(r), i = 1 << l;
        e[l].add(n), r &= ~i;
      }
    }
    function Ba(e, n) {
      if (Rt) for (var r = e.pendingUpdatersLaneMap, l = e.memoizedUpdaters; 0 < n; ) {
        var i = 31 - St(n);
        e = 1 << i, 0 < (i = r[i]).size && (i.forEach(function(s) {
          var f = s.alternate;
          f !== null && l.has(f) || l.add(s);
        }), i.clear()), n &= ~e;
      }
    }
    function _t(e) {
      return Kr < (e &= -e) ? vr < e ? 134217727 & e ? Xr : _c : vr : Kr;
    }
    function Er() {
      var e = Fe.p;
      return e !== 0 ? e : (e = window.event) === void 0 ? Xr : uh(e.type);
    }
    function vt(e) {
      delete e[Mt], delete e[ir], delete e[Gf], delete e[ry], delete e[oy];
    }
    function bo(e) {
      var n = e[Mt];
      if (n) return n;
      for (var r = e.parentNode; r; ) {
        if (n = r[Io] || r[Mt]) {
          if (r = n.alternate, n.child !== null || r !== null && r.child !== null) for (e = yc(e); e !== null; ) {
            if (r = e[Mt]) return r;
            e = yc(e);
          }
          return n;
        }
        r = (e = r).parentNode;
      }
      return null;
    }
    function vo(e) {
      if (e = e[Mt] || e[Io]) {
        var n = e.tag;
        if (n === 5 || n === 6 || n === 13 || n === 26 || n === 27 || n === 3) return e;
      }
      return null;
    }
    function Vo(e) {
      var n = e.tag;
      if (n === 5 || n === 26 || n === 27 || n === 6) return e.stateNode;
      throw Error("getNodeFromInstance: Invalid argument.");
    }
    function E(e) {
      var n = e[es];
      return n || (n = e[es] = { hoistableStyles: /* @__PURE__ */ new Map(), hoistableScripts: /* @__PURE__ */ new Map() }), n;
    }
    function V(e) {
      e[Oc] = !0;
    }
    function be(e, n) {
      we(e, n), we(e + "Capture", n);
    }
    function we(e, n) {
      Ta[e] && console.error("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", e), Ta[e] = n;
      var r = e.toLowerCase();
      for (zc[r] = e, e === "onDoubleClick" && (zc.ondblclick = e), e = 0; e < n.length; e++) Lc.add(n[e]);
    }
    function Le(e, n) {
      sb[n.type] || n.onChange || n.onInput || n.readOnly || n.disabled || n.value == null || console.error(e === "select" ? "You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set `onChange`." : "You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), n.onChange || n.readOnly || n.disabled || n.checked == null || console.error("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function dn(e) {
      return !!zo.call(yh, e) || !zo.call(ay, e) && (Dc.test(e) ? yh[e] = !0 : (ay[e] = !0, console.error("Invalid attribute name: `%s`", e), !1));
    }
    function Wn(e, n, r) {
      if (dn(n)) {
        if (!e.hasAttribute(n)) {
          switch (typeof r) {
            case "symbol":
            case "object":
            case "function":
              return r;
            case "boolean":
              if (r === !1) return r;
          }
          return r === void 0 ? void 0 : null;
        }
        return (e = e.getAttribute(n)) === "" && r === !0 || (ce(r, n), e === "" + r ? r : e);
      }
    }
    function wn(e, n, r) {
      if (dn(n)) if (r === null) e.removeAttribute(n);
      else {
        switch (typeof r) {
          case "undefined":
          case "function":
          case "symbol":
            return void e.removeAttribute(n);
          case "boolean":
            var l = n.toLowerCase().slice(0, 5);
            if (l !== "data-" && l !== "aria-") return void e.removeAttribute(n);
        }
        ce(r, n), e.setAttribute(n, "" + r);
      }
    }
    function Ze(e, n, r) {
      if (r === null) e.removeAttribute(n);
      else {
        switch (typeof r) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            return void e.removeAttribute(n);
        }
        ce(r, n), e.setAttribute(n, "" + r);
      }
    }
    function tn(e, n, r, l) {
      if (l === null) e.removeAttribute(r);
      else {
        switch (typeof l) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            return void e.removeAttribute(r);
        }
        ce(l, r), e.setAttributeNS(n, r, "" + l);
      }
    }
    function Ct() {
    }
    function Ln(e) {
      if (Kf === void 0) try {
        throw Error();
      } catch (r) {
        var n = r.stack.trim().match(/\n( *(at )?)/);
        Kf = n && n[1] || "", bh = -1 < r.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < r.stack.indexOf("@") ? "@unknown:0:0" : "";
      }
      return `
` + Kf + e + bh;
    }
    function Hn(e, n) {
      if (!e || Ic) return "";
      var r = Xf.get(e);
      if (r !== void 0) return r;
      Ic = !0, r = Error.prepareStackTrace, Error.prepareStackTrace = void 0;
      var l;
      l = J.H, J.H = null, function() {
        if (Fc === 0) {
          ql = console.log, _o = console.info, Gu = console.warn, Gg = console.error, dh = console.group, fh = console.groupCollapsed, ph = console.groupEnd;
          var F = { configurable: !0, enumerable: !0, value: Ct, writable: !0 };
          Object.defineProperties(console, { info: F, log: F, warn: F, error: F, group: F, groupCollapsed: F, groupEnd: F });
        }
        Fc++;
      }();
      try {
        var i = { DetermineComponentFrameRoot: function() {
          try {
            if (n) {
              var F = function() {
                throw Error();
              };
              if (Object.defineProperty(F.prototype, "props", { set: function() {
                throw Error();
              } }), typeof Reflect == "object" && Reflect.construct) {
                try {
                  Reflect.construct(F, []);
                } catch (Q) {
                  var te = Q;
                }
                Reflect.construct(e, [], F);
              } else {
                try {
                  F.call();
                } catch (Q) {
                  te = Q;
                }
                e.call(F.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (Q) {
                te = Q;
              }
              (F = e()) && typeof F.catch == "function" && F.catch(function() {
              });
            }
          } catch (Q) {
            if (Q && te && typeof Q.stack == "string") return [Q.stack, te.stack];
          }
          return [null, null];
        } };
        i.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var s = Object.getOwnPropertyDescriptor(i.DetermineComponentFrameRoot, "name");
        s && s.configurable && Object.defineProperty(i.DetermineComponentFrameRoot, "name", { value: "DetermineComponentFrameRoot" });
        var f = i.DetermineComponentFrameRoot(), p = f[0], y = f[1];
        if (p && y) {
          var v = p.split(`
`), z = y.split(`
`);
          for (f = s = 0; s < v.length && !v[s].includes("DetermineComponentFrameRoot"); ) s++;
          for (; f < z.length && !z[f].includes("DetermineComponentFrameRoot"); ) f++;
          if (s === v.length || f === z.length) for (s = v.length - 1, f = z.length - 1; 1 <= s && 0 <= f && v[s] !== z[f]; ) f--;
          for (; 1 <= s && 0 <= f; s--, f--) if (v[s] !== z[f]) {
            if (s !== 1 || f !== 1) do
              if (s--, 0 > --f || v[s] !== z[f]) {
                var j = `
` + v[s].replace(" at new ", " at ");
                return e.displayName && j.includes("<anonymous>") && (j = j.replace("<anonymous>", e.displayName)), typeof e == "function" && Xf.set(e, j), j;
              }
            while (1 <= s && 0 <= f);
            break;
          }
        }
      } finally {
        Ic = !1, J.H = l, function() {
          if (--Fc === 0) {
            var F = { configurable: !0, enumerable: !0, writable: !0 };
            Object.defineProperties(console, { log: en({}, F, { value: ql }), info: en({}, F, { value: _o }), warn: en({}, F, { value: Gu }), error: en({}, F, { value: Gg }), group: en({}, F, { value: dh }), groupCollapsed: en({}, F, { value: fh }), groupEnd: en({}, F, { value: ph }) });
          }
          0 > Fc && console.error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }(), Error.prepareStackTrace = r;
      }
      return v = (v = e ? e.displayName || e.name : "") ? Ln(v) : "", typeof e == "function" && Xf.set(e, v), v;
    }
    function ri(e) {
      var n = Error.prepareStackTrace;
      return Error.prepareStackTrace = void 0, e = e.stack, Error.prepareStackTrace = n, e.startsWith(`Error: react-stack-top-frame
`) && (e = e.slice(29)), (n = e.indexOf(`
`)) !== -1 && (e = e.slice(n + 1)), (n = e.indexOf("react-stack-bottom-frame")) !== -1 && (n = e.lastIndexOf(`
`, n)), n === -1 ? "" : e = e.slice(0, n);
    }
    function bl(e) {
      switch (e.tag) {
        case 26:
        case 27:
        case 5:
          return Ln(e.type);
        case 16:
          return Ln("Lazy");
        case 13:
          return Ln("Suspense");
        case 19:
          return Ln("SuspenseList");
        case 0:
        case 15:
          return Hn(e.type, !1);
        case 11:
          return Hn(e.type.render, !1);
        case 1:
          return Hn(e.type, !0);
        case 31:
          return Ln("Activity");
        default:
          return "";
      }
    }
    function Ut(e) {
      try {
        var n = "";
        do {
          n += bl(e);
          var r = e._debugInfo;
          if (r) for (var l = r.length - 1; 0 <= l; l--) {
            var i = r[l];
            if (typeof i.name == "string") {
              var s = n, f = i.env;
              n = s + Ln(i.name + (f ? " [" + f + "]" : ""));
            }
          }
          e = e.return;
        } while (e);
        return n;
      } catch (p) {
        return `
Error generating stack: ` + p.message + `
` + p.stack;
      }
    }
    function pr(e) {
      return (e = e ? e.displayName || e.name : "") ? Ln(e) : "";
    }
    function Va() {
      if (ur === null) return null;
      var e = ur._debugOwner;
      return e != null ? Ge(e) : null;
    }
    function Fp() {
      if (ur === null) return "";
      var e = ur;
      try {
        var n = "";
        switch (e.tag === 6 && (e = e.return), e.tag) {
          case 26:
          case 27:
          case 5:
            n += Ln(e.type);
            break;
          case 13:
            n += Ln("Suspense");
            break;
          case 19:
            n += Ln("SuspenseList");
            break;
          case 31:
            n += Ln("Activity");
            break;
          case 30:
          case 0:
          case 15:
          case 1:
            e._debugOwner || n !== "" || (n += pr(e.type));
            break;
          case 11:
            e._debugOwner || n !== "" || (n += pr(e.type.render));
        }
        for (; e; ) if (typeof e.tag == "number") {
          var r = e;
          e = r._debugOwner;
          var l = r._debugStack;
          e && l && (typeof l != "string" && (r._debugStack = l = ri(l)), l !== "" && (n += `
` + l));
        } else {
          if (e.debugStack == null) break;
          var i = e.debugStack;
          (e = e.owner) && i && (n += `
` + ri(i));
        }
        var s = n;
      } catch (f) {
        s = `
Error generating stack: ` + f.message + `
` + f.stack;
      }
      return s;
    }
    function De(e, n, r, l, i, s, f) {
      var p = ur;
      Ip(e);
      try {
        return e !== null && e._debugTask ? e._debugTask.run(n.bind(null, r, l, i, s, f)) : n(r, l, i, s, f);
      } finally {
        Ip(p);
      }
      throw Error("runWithFiberInDEV should never be called in production. This is a bug in React.");
    }
    function Ip(e) {
      J.getCurrentStack = e === null ? null : Fp, Pa = !1, ur = e;
    }
    function jr(e) {
      switch (typeof e) {
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
          return e;
        case "object":
          return He(e), e;
        default:
          return "";
      }
    }
    function fu(e) {
      var n = e.type;
      return (e = e.nodeName) && e.toLowerCase() === "input" && (n === "checkbox" || n === "radio");
    }
    function pu(e) {
      e._valueTracker || (e._valueTracker = function(n) {
        var r = fu(n) ? "checked" : "value", l = Object.getOwnPropertyDescriptor(n.constructor.prototype, r);
        He(n[r]);
        var i = "" + n[r];
        if (!n.hasOwnProperty(r) && l !== void 0 && typeof l.get == "function" && typeof l.set == "function") {
          var s = l.get, f = l.set;
          return Object.defineProperty(n, r, { configurable: !0, get: function() {
            return s.call(this);
          }, set: function(p) {
            He(p), i = "" + p, f.call(this, p);
          } }), Object.defineProperty(n, r, { enumerable: l.enumerable }), { getValue: function() {
            return i;
          }, setValue: function(p) {
            He(p), i = "" + p;
          }, stopTracking: function() {
            n._valueTracker = null, delete n[r];
          } };
        }
      }(e));
    }
    function oi(e) {
      if (!e) return !1;
      var n = e._valueTracker;
      if (!n) return !0;
      var r = n.getValue(), l = "";
      return e && (l = fu(e) ? e.checked ? "true" : "false" : e.value), (e = l) !== r && (n.setValue(e), !0);
    }
    function Wa(e) {
      if ((e = e || (typeof document < "u" ? document : void 0)) === void 0) return null;
      try {
        return e.activeElement || e.body;
      } catch {
        return e.body;
      }
    }
    function mr(e) {
      return e.replace(cb, function(n) {
        return "\\" + n.charCodeAt(0).toString(16) + " ";
      });
    }
    function ai(e, n) {
      n.checked === void 0 || n.defaultChecked === void 0 || Zf || (console.error("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://react.dev/link/controlled-components", Va() || "A component", n.type), Zf = !0), n.value === void 0 || n.defaultValue === void 0 || $f || (console.error("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://react.dev/link/controlled-components", Va() || "A component", n.type), $f = !0);
    }
    function kt(e, n, r, l, i, s, f, p) {
      e.name = "", f != null && typeof f != "function" && typeof f != "symbol" && typeof f != "boolean" ? (ce(f, "type"), e.type = f) : e.removeAttribute("type"), n != null ? f === "number" ? (n === 0 && e.value === "" || e.value != n) && (e.value = "" + jr(n)) : e.value !== "" + jr(n) && (e.value = "" + jr(n)) : f !== "submit" && f !== "reset" || e.removeAttribute("value"), n != null ? md(e, f, jr(n)) : r != null ? md(e, f, jr(r)) : l != null && e.removeAttribute("value"), i == null && s != null && (e.defaultChecked = !!s), i != null && (e.checked = i && typeof i != "function" && typeof i != "symbol"), p != null && typeof p != "function" && typeof p != "symbol" && typeof p != "boolean" ? (ce(p, "name"), e.name = "" + jr(p)) : e.removeAttribute("name");
    }
    function Mp(e, n, r, l, i, s, f, p) {
      if (s != null && typeof s != "function" && typeof s != "symbol" && typeof s != "boolean" && (ce(s, "type"), e.type = s), n != null || r != null) {
        if ((s === "submit" || s === "reset") && n == null) return;
        r = r != null ? "" + jr(r) : "", n = n != null ? "" + jr(n) : r, p || n === e.value || (e.value = n), e.defaultValue = n;
      }
      l = typeof (l = l ?? i) != "function" && typeof l != "symbol" && !!l, e.checked = p ? e.checked : !!l, e.defaultChecked = !!l, f != null && typeof f != "function" && typeof f != "symbol" && typeof f != "boolean" && (ce(f, "name"), e.name = f);
    }
    function md(e, n, r) {
      n === "number" && Wa(e.ownerDocument) === e || e.defaultValue === "" + r || (e.defaultValue = "" + r);
    }
    function vl(e, n) {
      n.value == null && (typeof n.children == "object" && n.children !== null ? Cc.Children.forEach(n.children, function(r) {
        r == null || typeof r == "string" || typeof r == "number" || typeof r == "bigint" || Jf || (Jf = !0, console.error("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>."));
      }) : n.dangerouslySetInnerHTML == null || vh || (vh = !0, console.error("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected."))), n.selected == null || Mc || (console.error("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), Mc = !0);
    }
    function li() {
      var e = Va();
      return e ? `

Check the render method of \`` + e + "`." : "";
    }
    function kl(e, n, r, l) {
      if (e = e.options, n) {
        n = {};
        for (var i = 0; i < r.length; i++) n["$" + r[i]] = !0;
        for (r = 0; r < e.length; r++) i = n.hasOwnProperty("$" + e[r].value), e[r].selected !== i && (e[r].selected = i), i && l && (e[r].defaultSelected = !0);
      } else {
        for (r = "" + jr(r), n = null, i = 0; i < e.length; i++) {
          if (e[i].value === r) return e[i].selected = !0, void (l && (e[i].defaultSelected = !0));
          n !== null || e[i].disabled || (n = e[i]);
        }
        n !== null && (n.selected = !0);
      }
    }
    function jp(e, n) {
      for (e = 0; e < sl.length; e++) {
        var r = sl[e];
        if (n[r] != null) {
          var l = It(n[r]);
          n.multiple && !l ? console.error("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", r, li()) : !n.multiple && l && console.error("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", r, li());
        }
      }
      n.value === void 0 || n.defaultValue === void 0 || ep || (console.error("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://react.dev/link/controlled-components"), ep = !0);
    }
    function mg(e, n) {
      n.value === void 0 || n.defaultValue === void 0 || cl || (console.error("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://react.dev/link/controlled-components", Va() || "A component"), cl = !0), n.children != null && n.value == null && console.error("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
    }
    function Hp(e, n, r) {
      n == null || ((n = "" + jr(n)) !== e.value && (e.value = n), r != null) ? e.defaultValue = r != null ? "" + jr(r) : "" : e.defaultValue !== n && (e.defaultValue = n);
    }
    function Up(e, n, r, l) {
      if (n == null) {
        if (l != null) {
          if (r != null) throw Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
          if (It(l)) {
            if (1 < l.length) throw Error("<textarea> can only have at most one child.");
            l = l[0];
          }
          r = l;
        }
        r == null && (r = ""), n = r;
      }
      r = jr(n), e.defaultValue = r, (l = e.textContent) === r && l !== "" && l !== null && (e.value = l);
    }
    function ws(e, n) {
      return e.serverProps === void 0 && e.serverTail.length === 0 && e.children.length === 1 && 3 < e.distanceFromLeaf && e.distanceFromLeaf > 15 - n ? ws(e.children[0], n) : e;
    }
    function Zt(e) {
      return "  " + "  ".repeat(e);
    }
    function xr(e) {
      return "+ " + "  ".repeat(e);
    }
    function ao(e) {
      return "- " + "  ".repeat(e);
    }
    function hd(e) {
      switch (e.tag) {
        case 26:
        case 27:
        case 5:
          return e.type;
        case 16:
          return "Lazy";
        case 13:
          return "Suspense";
        case 19:
          return "SuspenseList";
        case 0:
        case 15:
        case 1:
          return (e = e.type).displayName || e.name || null;
        case 11:
          return (e = e.type.render).displayName || e.name || null;
        default:
          return null;
      }
    }
    function ii(e, n) {
      return dl.test(e) ? (e = JSON.stringify(e)).length > n - 2 ? 8 > n ? '{"..."}' : "{" + e.slice(0, n - 7) + '..."}' : "{" + e + "}" : e.length > n ? 5 > n ? '{"..."}' : e.slice(0, n - 3) + "..." : e;
    }
    function gd(e, n, r) {
      var l = 120 - 2 * r;
      if (n === null) return xr(r) + ii(e, l) + `
`;
      if (typeof n == "string") {
        for (var i = 0; i < n.length && i < e.length && n.charCodeAt(i) === e.charCodeAt(i); i++) ;
        return i > l - 8 && 10 < i && (e = "..." + e.slice(i - 8), n = "..." + n.slice(i - 8)), xr(r) + ii(e, l) + `
` + ao(r) + ii(n, l) + `
`;
      }
      return Zt(r) + ii(e, l) + `
`;
    }
    function yd(e) {
      return Object.prototype.toString.call(e).replace(/^\[object (.*)\]$/, function(n, r) {
        return r;
      });
    }
    function Jt(e, n) {
      switch (typeof e) {
        case "string":
          return (e = JSON.stringify(e)).length > n ? 5 > n ? '"..."' : e.slice(0, n - 4) + '..."' : e;
        case "object":
          if (e === null) return "null";
          if (It(e)) return "[...]";
          if (e.$$typeof === Sa) return (n = Se(e.type)) ? "<" + n + ">" : "<...>";
          var r = yd(e);
          if (r === "Object") {
            for (var l in r = "", n -= 2, e) if (e.hasOwnProperty(l)) {
              var i = JSON.stringify(l);
              if (i !== '"' + l + '"' && (l = i), n -= l.length - 2, 0 > (n -= (i = Jt(e[l], 15 > n ? n : 15)).length)) {
                r += r === "" ? "..." : ", ...";
                break;
              }
              r += (r === "" ? "" : ",") + l + ":" + i;
            }
            return "{" + r + "}";
          }
          return r;
        case "function":
          return (n = e.displayName || e.name) ? "function " + n : "function";
        default:
          return String(e);
      }
    }
    function ui(e, n) {
      return typeof e != "string" || dl.test(e) ? "{" + Jt(e, n - 2) + "}" : e.length > n - 2 ? 5 > n ? '"..."' : '"' + e.slice(0, n - 5) + '..."' : '"' + e + '"';
    }
    function mu(e, n, r) {
      var l, i = 120 - r.length - e.length, s = [];
      for (l in n) if (n.hasOwnProperty(l) && l !== "children") {
        var f = ui(n[l], 120 - r.length - l.length - 1);
        i -= l.length + f.length + 2, s.push(l + "=" + f);
      }
      return s.length === 0 ? r + "<" + e + `>
` : 0 < i ? r + "<" + e + " " + s.join(" ") + `>
` : r + "<" + e + `
` + r + "  " + s.join(`
` + r + "  ") + `
` + r + `>
`;
    }
    function hg(e, n, r) {
      var l, i = "", s = en({}, n);
      for (l in e) if (e.hasOwnProperty(l)) {
        delete s[l];
        var f = 120 - 2 * r - l.length - 2, p = Jt(e[l], f);
        n.hasOwnProperty(l) ? (f = Jt(n[l], f), i += xr(r) + l + ": " + p + `
`, i += ao(r) + l + ": " + f + `
`) : i += xr(r) + l + ": " + p + `
`;
      }
      for (var y in s) s.hasOwnProperty(y) && (e = Jt(s[y], 120 - 2 * r - y.length - 2), i += ao(r) + y + ": " + e + `
`);
      return i;
    }
    function Ss(e, n) {
      var r = hd(e);
      if (r === null) {
        for (r = "", e = e.child; e; ) r += Ss(e, n), e = e.sibling;
        return r;
      }
      return Zt(n) + "<" + r + `>
`;
    }
    function Bp(e, n) {
      var r = ws(e, n);
      if (r !== e && (e.children.length !== 1 || e.children[0] !== r)) return Zt(n) + `...
` + Bp(r, n + 1);
      r = "";
      var l = e.fiber._debugInfo;
      if (l) for (var i = 0; i < l.length; i++) {
        var s = l[i].name;
        typeof s == "string" && (r += Zt(n) + "<" + s + `>
`, n++);
      }
      if (l = "", i = e.fiber.pendingProps, e.fiber.tag === 6) l = gd(i, e.serverProps, n), n++;
      else if ((s = hd(e.fiber)) !== null) if (e.serverProps === void 0) {
        var f = 120 - 2 * (l = n) - s.length - 2, p = "";
        for (v in i) if (i.hasOwnProperty(v) && v !== "children") {
          var y = ui(i[v], 15);
          if (0 > (f -= v.length + y.length + 2)) {
            p += " ...";
            break;
          }
          p += " " + v + "=" + y;
        }
        l = Zt(l) + "<" + s + p + `>
`, n++;
      } else e.serverProps === null ? (l = mu(s, i, xr(n)), n++) : typeof e.serverProps == "string" ? console.error("Should not have matched a non HostText fiber to a Text node. This is a bug in React.") : (l = function(z, j, F, te) {
        var Q = "", ge = /* @__PURE__ */ new Map();
        for (X in F) F.hasOwnProperty(X) && ge.set(X.toLowerCase(), X);
        if (ge.size === 1 && ge.has("children")) Q += mu(z, j, Zt(te));
        else {
          for (var T in j) if (j.hasOwnProperty(T) && T !== "children") {
            var P = 120 - 2 * (te + 1) - T.length - 1, D = ge.get(T.toLowerCase());
            if (D !== void 0) {
              ge.delete(T.toLowerCase());
              var X = j[T];
              D = F[D];
              var ve = ui(X, P);
              P = ui(D, P), typeof X == "object" && X !== null && typeof D == "object" && D !== null && yd(X) === "Object" && yd(D) === "Object" && (2 < Object.keys(X).length || 2 < Object.keys(D).length || -1 < ve.indexOf("...") || -1 < P.indexOf("...")) ? Q += Zt(te + 1) + T + `={{
` + hg(X, D, te + 2) + Zt(te + 1) + `}}
` : (Q += xr(te + 1) + T + "=" + ve + `
`, Q += ao(te + 1) + T + "=" + P + `
`);
            } else Q += Zt(te + 1) + T + "=" + ui(j[T], P) + `
`;
          }
          ge.forEach(function(pn) {
            if (pn !== "children") {
              var kn = 120 - 2 * (te + 1) - pn.length - 1;
              Q += ao(te + 1) + pn + "=" + ui(F[pn], kn) + `
`;
            }
          }), Q = Q === "" ? Zt(te) + "<" + z + `>
` : Zt(te) + "<" + z + `
` + Q + Zt(te) + `>
`;
        }
        return z = F.children, j = j.children, typeof z == "string" || typeof z == "number" || typeof z == "bigint" ? (ge = "", typeof j != "string" && typeof j != "number" && typeof j != "bigint" || (ge = "" + j), Q += gd(ge, "" + z, te + 1)) : typeof j != "string" && typeof j != "number" && typeof j != "bigint" || (Q = z == null ? Q + gd("" + j, null, te + 1) : Q + gd("" + j, void 0, te + 1)), Q;
      }(s, i, e.serverProps, n), n++);
      var v = "";
      for (i = e.fiber.child, s = 0; i && s < e.children.length; ) (f = e.children[s]).fiber === i ? (v += Bp(f, n), s++) : v += Ss(i, n), i = i.sibling;
      for (i && 0 < e.children.length && (v += Zt(n) + `...
`), i = e.serverTail, e.serverProps === null && n--, e = 0; e < i.length; e++) v = typeof (s = i[e]) == "string" ? v + (ao(n) + ii(s, 120 - 2 * n) + `
`) : v + mu(s.type, s.props, ao(n));
      return r + l + v;
    }
    function Hr(e) {
      try {
        return `

` + Bp(e, 0);
      } catch {
        return "";
      }
    }
    function bd(e, n, r) {
      for (var l = n, i = null, s = 0; l; ) l === e && (s = 0), i = { fiber: l, children: i !== null ? [i] : [], serverProps: l === n ? r : l === e ? null : void 0, serverTail: [], distanceFromLeaf: s }, s++, l = l.return;
      return i !== null ? Hr(i).replaceAll(/^[+-]/gm, ">") : "";
    }
    function Vp(e, n) {
      var r = en({}, e || kh), l = { tag: n };
      return ns.indexOf(n) !== -1 && (r.aTagInScope = null, r.buttonTagInScope = null, r.nobrTagInScope = null), Kl.indexOf(n) !== -1 && (r.pTagInButtonScope = null), jc.indexOf(n) !== -1 && n !== "address" && n !== "div" && n !== "p" && (r.listItemTagAutoclosing = null, r.dlItemTagAutoclosing = null), r.current = l, n === "form" && (r.formTag = l), n === "a" && (r.aTagInScope = l), n === "button" && (r.buttonTagInScope = l), n === "nobr" && (r.nobrTagInScope = l), n === "p" && (r.pTagInButtonScope = l), n === "li" && (r.listItemTagAutoclosing = l), n !== "dd" && n !== "dt" || (r.dlItemTagAutoclosing = l), n === "#document" || n === "html" ? r.containerTagInScope = null : r.containerTagInScope || (r.containerTagInScope = l), e !== null || n !== "#document" && n !== "html" && n !== "body" ? r.implicitRootScope === !0 && (r.implicitRootScope = !1) : r.implicitRootScope = !0, r;
    }
    function vd(e, n, r) {
      switch (n) {
        case "select":
          return e === "hr" || e === "option" || e === "optgroup" || e === "script" || e === "template" || e === "#text";
        case "optgroup":
          return e === "option" || e === "#text";
        case "option":
          return e === "#text";
        case "tr":
          return e === "th" || e === "td" || e === "style" || e === "script" || e === "template";
        case "tbody":
        case "thead":
        case "tfoot":
          return e === "tr" || e === "style" || e === "script" || e === "template";
        case "colgroup":
          return e === "col" || e === "template";
        case "table":
          return e === "caption" || e === "colgroup" || e === "tbody" || e === "tfoot" || e === "thead" || e === "style" || e === "script" || e === "template";
        case "head":
          return e === "base" || e === "basefont" || e === "bgsound" || e === "link" || e === "meta" || e === "title" || e === "noscript" || e === "noframes" || e === "style" || e === "script" || e === "template";
        case "html":
          if (r) break;
          return e === "head" || e === "body" || e === "frameset";
        case "frameset":
          return e === "frame";
        case "#document":
          if (!r) return e === "html";
      }
      switch (e) {
        case "h1":
        case "h2":
        case "h3":
        case "h4":
        case "h5":
        case "h6":
          return n !== "h1" && n !== "h2" && n !== "h3" && n !== "h4" && n !== "h5" && n !== "h6";
        case "rp":
        case "rt":
          return db.indexOf(n) === -1;
        case "caption":
        case "col":
        case "colgroup":
        case "frameset":
        case "frame":
        case "tbody":
        case "td":
        case "tfoot":
        case "th":
        case "thead":
        case "tr":
          return n == null;
        case "head":
          return r || n === null;
        case "html":
          return r && n === "#document" || n === null;
        case "body":
          return r && (n === "#document" || n === "html") || n === null;
      }
      return !0;
    }
    function si(e, n) {
      for (; e; ) {
        switch (e.tag) {
          case 5:
          case 26:
          case 27:
            if (e.type === n) return e;
        }
        e = e.return;
      }
      return null;
    }
    function kd(e, n) {
      var r = (n = n || kh).current;
      if (n = (r = vd(e, r && r.tag, n.implicitRootScope) ? null : r) ? null : function(p, y) {
        switch (p) {
          case "address":
          case "article":
          case "aside":
          case "blockquote":
          case "center":
          case "details":
          case "dialog":
          case "dir":
          case "div":
          case "dl":
          case "fieldset":
          case "figcaption":
          case "figure":
          case "footer":
          case "header":
          case "hgroup":
          case "main":
          case "menu":
          case "nav":
          case "ol":
          case "p":
          case "section":
          case "summary":
          case "ul":
          case "pre":
          case "listing":
          case "table":
          case "hr":
          case "xmp":
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return y.pTagInButtonScope;
          case "form":
            return y.formTag || y.pTagInButtonScope;
          case "li":
            return y.listItemTagAutoclosing;
          case "dd":
          case "dt":
            return y.dlItemTagAutoclosing;
          case "button":
            return y.buttonTagInScope;
          case "a":
            return y.aTagInScope;
          case "nobr":
            return y.nobrTagInScope;
        }
        return null;
      }(e, n), !(n = r || n)) return !0;
      var l = n.tag;
      if (n = String(!!r) + "|" + e + "|" + l, Xl[n]) return !1;
      Xl[n] = !0;
      var i = (n = ur) ? si(n.return, l) : null, s = n !== null && i !== null ? bd(i, n, null) : "", f = "<" + e + ">";
      return r ? (r = "", l === "table" && e === "tr" && (r += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."), console.error(`In HTML, %s cannot be a child of <%s>.%s
This will cause a hydration error.%s`, f, l, r, s)) : console.error(`In HTML, %s cannot be a descendant of <%s>.
This will cause a hydration error.%s`, f, l, s), n && (e = n.return, i === null || e === null || i === e && e._debugOwner === n._debugOwner || De(i, function() {
        console.error(`<%s> cannot contain a nested %s.
See this log for the ancestor stack trace.`, l, f);
      })), !1;
    }
    function Es(e, n, r) {
      if (r || vd("#text", n, !1)) return !0;
      if (Xl[r = "#text|" + n]) return !1;
      Xl[r] = !0;
      var l = (r = ur) ? si(r, n) : null;
      return r = r !== null && l !== null ? bd(l, r, r.tag !== 6 ? { children: null } : null) : "", /\S/.test(e) ? console.error(`In HTML, text nodes cannot be a child of <%s>.
This will cause a hydration error.%s`, n, r) : console.error(`In HTML, whitespace text nodes cannot be a child of <%s>. Make sure you don't have any extra whitespace between tags on each line of your source code.
This will cause a hydration error.%s`, n, r), !1;
    }
    function Wo(e, n) {
      if (n) {
        var r = e.firstChild;
        if (r && r === e.lastChild && r.nodeType === 3) return void (r.nodeValue = n);
      }
      e.textContent = n;
    }
    function gg(e, n, r) {
      var l = n.indexOf("--") === 0;
      l || (-1 < n.indexOf("-") ? Ra.hasOwnProperty(n) && Ra[n] || (Ra[n] = !0, console.error("Unsupported style property %s. Did you mean %s?", n, n.replace(tp, "ms-").replace(rp, function(i, s) {
        return s.toUpperCase();
      }))) : fb.test(n) ? Ra.hasOwnProperty(n) && Ra[n] || (Ra[n] = !0, console.error("Unsupported vendor-prefixed style property %s. Did you mean %s?", n, n.charAt(0).toUpperCase() + n.slice(1))) : !Sh.test(r) || Uc.hasOwnProperty(r) && Uc[r] || (Uc[r] = !0, console.error(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, n, r.replace(Sh, ""))), typeof r == "number" && (isNaN(r) ? Bc || (Bc = !0, console.error("`NaN` is an invalid value for the `%s` css style property.", n)) : isFinite(r) || Eh || (Eh = !0, console.error("`Infinity` is an invalid value for the `%s` css style property.", n)))), r == null || typeof r == "boolean" || r === "" ? l ? e.setProperty(n, "") : n === "float" ? e.cssFloat = "" : e[n] = "" : l ? e.setProperty(n, r) : typeof r != "number" || r === 0 || ly.has(n) ? n === "float" ? e.cssFloat = r : (Te(r, n), e[n] = ("" + r).trim()) : e[n] = r + "px";
    }
    function Wp(e, n, r) {
      if (n != null && typeof n != "object") throw Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
      if (n && Object.freeze(n), e = e.style, r != null) {
        if (n) {
          var l = {};
          if (r) {
            for (var i in r) if (r.hasOwnProperty(i) && !n.hasOwnProperty(i)) for (var s = np[i] || [i], f = 0; f < s.length; f++) l[s[f]] = i;
          }
          for (var p in n) if (n.hasOwnProperty(p) && (!r || r[p] !== n[p])) for (i = np[p] || [p], s = 0; s < i.length; s++) l[i[s]] = p;
          for (var y in p = {}, n) for (i = np[y] || [y], s = 0; s < i.length; s++) p[i[s]] = y;
          for (var v in y = {}, l) if (i = l[v], (s = p[v]) && i !== s && !y[f = i + "," + s]) {
            y[f] = !0, f = console;
            var z = n[i];
            f.error.call(f, "%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", z == null || typeof z == "boolean" || z === "" ? "Removing" : "Updating", i, s);
          }
        }
        for (var j in r) !r.hasOwnProperty(j) || n != null && n.hasOwnProperty(j) || (j.indexOf("--") === 0 ? e.setProperty(j, "") : j === "float" ? e.cssFloat = "" : e[j] = "");
        for (var F in n) v = n[F], n.hasOwnProperty(F) && r[F] !== v && gg(e, F, v);
      } else for (l in n) n.hasOwnProperty(l) && gg(e, l, n[l]);
    }
    function hu(e) {
      if (e.indexOf("-") === -1) return !1;
      switch (e) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    function wd(e) {
      return o.get(e) || e;
    }
    function eb(e, n) {
      if (zo.call(c, n) && c[n]) return !0;
      if (g.test(n)) {
        if (e = "aria-" + n.slice(4).toLowerCase(), (e = u.hasOwnProperty(e) ? e : null) == null) return console.error("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", n), c[n] = !0;
        if (n !== e) return console.error("Invalid ARIA attribute `%s`. Did you mean `%s`?", n, e), c[n] = !0;
      }
      if (d.test(n)) {
        if (e = n.toLowerCase(), (e = u.hasOwnProperty(e) ? e : null) == null) return c[n] = !0, !1;
        n !== e && (console.error("Unknown ARIA attribute `%s`. Did you mean `%s`?", n, e), c[n] = !0);
      }
      return !0;
    }
    function nb(e, n, r, l) {
      if (zo.call(w, n) && w[n]) return !0;
      var i = n.toLowerCase();
      if (i === "onfocusin" || i === "onfocusout") return console.error("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), w[n] = !0;
      if (typeof r == "function" && (e === "form" && n === "action" || e === "input" && n === "formAction" || e === "button" && n === "formAction")) return !0;
      if (l != null) {
        if (e = l.possibleRegistrationNames, l.registrationNameDependencies.hasOwnProperty(n)) return !0;
        if ((l = e.hasOwnProperty(i) ? e[i] : null) != null) return console.error("Invalid event handler property `%s`. Did you mean `%s`?", n, l), w[n] = !0;
        if (x.test(n)) return console.error("Unknown event handler property `%s`. It will be ignored.", n), w[n] = !0;
      } else if (x.test(n)) return B.test(n) && console.error("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", n), w[n] = !0;
      if (q.test(n) || ee.test(n)) return !0;
      if (i === "innerhtml") return console.error("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), w[n] = !0;
      if (i === "aria") return console.error("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), w[n] = !0;
      if (i === "is" && r != null && typeof r != "string") return console.error("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof r), w[n] = !0;
      if (typeof r == "number" && isNaN(r)) return console.error("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", n), w[n] = !0;
      if (a.hasOwnProperty(i)) {
        if ((i = a[i]) !== n) return console.error("Invalid DOM property `%s`. Did you mean `%s`?", n, i), w[n] = !0;
      } else if (n !== i) return console.error("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", n, i), w[n] = !0;
      switch (n) {
        case "dangerouslySetInnerHTML":
        case "children":
        case "style":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
        case "innerText":
        case "textContent":
          return !0;
      }
      switch (typeof r) {
        case "boolean":
          switch (n) {
            case "autoFocus":
            case "checked":
            case "multiple":
            case "muted":
            case "selected":
            case "contentEditable":
            case "spellCheck":
            case "draggable":
            case "value":
            case "autoReverse":
            case "externalResourcesRequired":
            case "focusable":
            case "preserveAlpha":
            case "allowFullScreen":
            case "async":
            case "autoPlay":
            case "controls":
            case "default":
            case "defer":
            case "disabled":
            case "disablePictureInPicture":
            case "disableRemotePlayback":
            case "formNoValidate":
            case "hidden":
            case "loop":
            case "noModule":
            case "noValidate":
            case "open":
            case "playsInline":
            case "readOnly":
            case "required":
            case "reversed":
            case "scoped":
            case "seamless":
            case "itemScope":
            case "capture":
            case "download":
            case "inert":
              return !0;
            default:
              return (i = n.toLowerCase().slice(0, 5)) === "data-" || i === "aria-" || (r ? console.error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', r, n, n, r, n) : console.error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', r, n, n, r, n, n, n), w[n] = !0);
          }
        case "function":
        case "symbol":
          return w[n] = !0, !1;
        case "string":
          if (r === "false" || r === "true") {
            switch (n) {
              case "checked":
              case "selected":
              case "multiple":
              case "muted":
              case "allowFullScreen":
              case "async":
              case "autoPlay":
              case "controls":
              case "default":
              case "defer":
              case "disabled":
              case "disablePictureInPicture":
              case "disableRemotePlayback":
              case "formNoValidate":
              case "hidden":
              case "loop":
              case "noModule":
              case "noValidate":
              case "open":
              case "playsInline":
              case "readOnly":
              case "required":
              case "reversed":
              case "scoped":
              case "seamless":
              case "itemScope":
              case "inert":
                break;
              default:
                return !0;
            }
            console.error("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", r, n, r === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', n, r), w[n] = !0;
          }
      }
      return !0;
    }
    function wl(e) {
      return le.test("" + e) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : e;
    }
    function xs(e) {
      return (e = e.target || e.srcElement || window).correspondingUseElement && (e = e.correspondingUseElement), e.nodeType === 3 ? e.parentNode : e;
    }
    function Sd(e) {
      var n = vo(e);
      if (n && (e = n.stateNode)) {
        var r = e[ir] || null;
        e: switch (e = n.stateNode, n.type) {
          case "input":
            if (kt(e, r.value, r.defaultValue, r.defaultValue, r.checked, r.defaultChecked, r.type, r.name), n = r.name, r.type === "radio" && n != null) {
              for (r = e; r.parentNode; ) r = r.parentNode;
              for (ce(n, "name"), r = r.querySelectorAll('input[name="' + mr("" + n) + '"][type="radio"]'), n = 0; n < r.length; n++) {
                var l = r[n];
                if (l !== e && l.form === e.form) {
                  var i = l[ir] || null;
                  if (!i) throw Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
                  kt(l, i.value, i.defaultValue, i.defaultValue, i.checked, i.defaultChecked, i.type, i.name);
                }
              }
              for (n = 0; n < r.length; n++) (l = r[n]).form === e.form && oi(l);
            }
            break e;
          case "textarea":
            Hp(e, r.value, r.defaultValue);
            break e;
          case "select":
            (n = r.value) != null && kl(e, !!r.multiple, n, !1);
        }
      }
    }
    function ci(e, n, r) {
      if (M) return e(n, r);
      M = !0;
      try {
        return e(n);
      } finally {
        if (M = !1, (I !== null || _ !== null) && (ji(), I && (n = I, e = _, _ = I = null, Sd(n), e))) for (n = 0; n < e.length; n++) Sd(e[n]);
      }
    }
    function qo(e, n) {
      var r = e.stateNode;
      if (r === null) return null;
      var l = r[ir] || null;
      if (l === null) return null;
      r = l[n];
      e: switch (n) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          (l = !l.disabled) || (l = !((e = e.type) === "button" || e === "input" || e === "select" || e === "textarea")), e = !l;
          break e;
        default:
          e = !1;
      }
      if (e) return null;
      if (r && typeof r != "function") throw Error("Expected `" + n + "` listener to be a function, instead got a value of `" + typeof r + "` type.");
      return r;
    }
    function qp() {
      if (Ne) return Ne;
      var e, n, r = Cn, l = r.length, i = "value" in ln ? ln.value : ln.textContent, s = i.length;
      for (e = 0; e < l && r[e] === i[e]; e++) ;
      var f = l - e;
      for (n = 1; n <= f && r[l - n] === i[s - n]; n++) ;
      return Ne = i.slice(e, 1 < n ? 1 - n : void 0);
    }
    function gu(e) {
      var n = e.keyCode;
      return "charCode" in e ? (e = e.charCode) === 0 && n === 13 && (e = 13) : e = n, e === 10 && (e = 13), 32 <= e || e === 13 ? e : 0;
    }
    function Cs() {
      return !0;
    }
    function yu() {
      return !1;
    }
    function it(e) {
      function n(r, l, i, s, f) {
        for (var p in this._reactName = r, this._targetInst = i, this.type = l, this.nativeEvent = s, this.target = f, this.currentTarget = null, e) e.hasOwnProperty(p) && (r = e[p], this[p] = r ? r(s) : s[p]);
        return this.isDefaultPrevented = (s.defaultPrevented != null ? s.defaultPrevented : s.returnValue === !1) ? Cs : yu, this.isPropagationStopped = yu, this;
      }
      return en(n.prototype, { preventDefault: function() {
        this.defaultPrevented = !0;
        var r = this.nativeEvent;
        r && (r.preventDefault ? r.preventDefault() : typeof r.returnValue != "unknown" && (r.returnValue = !1), this.isDefaultPrevented = Cs);
      }, stopPropagation: function() {
        var r = this.nativeEvent;
        r && (r.stopPropagation ? r.stopPropagation() : typeof r.cancelBubble != "unknown" && (r.cancelBubble = !0), this.isPropagationStopped = Cs);
      }, persist: function() {
      }, isPersistent: Cs }), n;
    }
    function Qp(e) {
      var n = this.nativeEvent;
      return n.getModifierState ? n.getModifierState(e) : !!(e = qw[e]) && !!n[e];
    }
    function di() {
      return Qp;
    }
    function Sl(e, n) {
      switch (e) {
        case "keyup":
          return $w.indexOf(n.keyCode) !== -1;
        case "keydown":
          return n.keyCode !== Fv;
        case "keypress":
        case "mousedown":
        case "focusout":
          return !0;
        default:
          return !1;
      }
    }
    function Ed(e) {
      return typeof (e = e.detail) == "object" && "data" in e ? e.data : null;
    }
    function Ts(e) {
      var n = e && e.nodeName && e.nodeName.toLowerCase();
      return n === "input" ? !!Jw[e.type] : n === "textarea";
    }
    function Yp(e, n, r, l) {
      I ? _ ? _.push(l) : _ = [l] : I = l, 0 < (n = Vu(n, "onChange")).length && (r = new Zn("onChange", "change", null, r, l), e.push({ event: r, listeners: n }));
    }
    function xd(e) {
      Jm(e, 0);
    }
    function fi(e) {
      if (oi(Vo(e))) return e;
    }
    function Gp(e, n) {
      if (e === "change") return n;
    }
    function hr() {
      iy && (iy.detachEvent("onpropertychange", Cd), Th = iy = null);
    }
    function Cd(e) {
      if (e.propertyName === "value" && fi(Th)) {
        var n = [];
        Yp(n, Th, e, xs(e)), ci(xd, n);
      }
    }
    function Kp(e, n, r) {
      e === "focusin" ? (hr(), Th = r, (iy = n).attachEvent("onpropertychange", Cd)) : e === "focusout" && hr();
    }
    function Ps(e) {
      if (e === "selectionchange" || e === "keyup" || e === "keydown") return fi(Th);
    }
    function pi(e, n) {
      if (e === "click") return fi(n);
    }
    function Td(e, n) {
      if (e === "input" || e === "change") return fi(n);
    }
    function qa(e, n) {
      if (Zr(e, n)) return !0;
      if (typeof e != "object" || e === null || typeof n != "object" || n === null) return !1;
      var r = Object.keys(e), l = Object.keys(n);
      if (r.length !== l.length) return !1;
      for (l = 0; l < r.length; l++) {
        var i = r[l];
        if (!zo.call(n, i) || !Zr(e[i], n[i])) return !1;
      }
      return !0;
    }
    function yg(e) {
      for (; e && e.firstChild; ) e = e.firstChild;
      return e;
    }
    function Rs(e, n) {
      var r, l = yg(e);
      for (e = 0; l; ) {
        if (l.nodeType === 3) {
          if (r = e + l.textContent.length, e <= n && r >= n) return { node: l, offset: n - e };
          e = r;
        }
        e: {
          for (; l; ) {
            if (l.nextSibling) {
              l = l.nextSibling;
              break e;
            }
            l = l.parentNode;
          }
          l = void 0;
        }
        l = yg(l);
      }
    }
    function Xp(e, n) {
      return !(!e || !n) && (e === n || (!e || e.nodeType !== 3) && (n && n.nodeType === 3 ? Xp(e, n.parentNode) : "contains" in e ? e.contains(n) : !!e.compareDocumentPosition && !!(16 & e.compareDocumentPosition(n))));
    }
    function bg(e) {
      for (var n = Wa((e = e != null && e.ownerDocument != null && e.ownerDocument.defaultView != null ? e.ownerDocument.defaultView : window).document); n instanceof e.HTMLIFrameElement; ) {
        try {
          var r = typeof n.contentWindow.location.href == "string";
        } catch {
          r = !1;
        }
        if (!r) break;
        n = Wa((e = n.contentWindow).document);
      }
      return n;
    }
    function As(e) {
      var n = e && e.nodeName && e.nodeName.toLowerCase();
      return n && (n === "input" && (e.type === "text" || e.type === "search" || e.type === "tel" || e.type === "url" || e.type === "password") || n === "textarea" || e.contentEditable === "true");
    }
    function vg(e, n, r) {
      var l = r.window === r ? r.document : r.nodeType === 9 ? r : r.ownerDocument;
      gb || ap == null || ap !== Wa(l) || ("selectionStart" in (l = ap) && As(l) ? l = { start: l.selectionStart, end: l.selectionEnd } : l = { anchorNode: (l = (l.ownerDocument && l.ownerDocument.defaultView || window).getSelection()).anchorNode, anchorOffset: l.anchorOffset, focusNode: l.focusNode, focusOffset: l.focusOffset }, Ph && qa(Ph, l) || (Ph = l, 0 < (l = Vu(hb, "onSelect")).length && (n = new Zn("onSelect", "select", null, n, r), e.push({ event: n, listeners: l }), n.target = ap)));
    }
    function mi(e, n) {
      var r = {};
      return r[e.toLowerCase()] = n.toLowerCase(), r["Webkit" + e] = "webkit" + n, r["Moz" + e] = "moz" + n, r;
    }
    function El(e) {
      if (yb[e]) return yb[e];
      if (!lp[e]) return e;
      var n, r = lp[e];
      for (n in r) if (r.hasOwnProperty(n) && n in Bv) return yb[e] = r[n];
      return e;
    }
    function ko(e, n) {
      Yv.set(e, n), be(n, [e]);
    }
    function Ur(e, n) {
      if (typeof e == "object" && e !== null) {
        var r = vb.get(e);
        return r !== void 0 ? r : (n = { value: e, source: n, stack: Ut(n) }, vb.set(e, n), n);
      }
      return { value: e, source: n, stack: Ut(n) };
    }
    function Pd() {
      for (var e = ip, n = kb = ip = 0; n < e; ) {
        var r = Aa[n];
        Aa[n++] = null;
        var l = Aa[n];
        Aa[n++] = null;
        var i = Aa[n];
        Aa[n++] = null;
        var s = Aa[n];
        if (Aa[n++] = null, l !== null && i !== null) {
          var f = l.pending;
          f === null ? i.next = i : (i.next = f.next, f.next = i), l.pending = i;
        }
        s !== 0 && $p(r, i, s);
      }
    }
    function Rd(e, n, r, l) {
      Aa[ip++] = e, Aa[ip++] = n, Aa[ip++] = r, Aa[ip++] = l, kb |= l, e.lanes |= l, (e = e.alternate) !== null && (e.lanes |= l);
    }
    function Ns(e, n, r, l) {
      return Rd(e, n, r, l), Ad(e);
    }
    function Cr(e, n) {
      return Rd(e, null, null, n), Ad(e);
    }
    function $p(e, n, r) {
      e.lanes |= r;
      var l = e.alternate;
      l !== null && (l.lanes |= r);
      for (var i = !1, s = e.return; s !== null; ) s.childLanes |= r, (l = s.alternate) !== null && (l.childLanes |= r), s.tag === 22 && ((e = s.stateNode) === null || e._visibility & uy || (i = !0)), e = s, s = s.return;
      return e.tag === 3 ? (s = e.stateNode, i && n !== null && (i = 31 - St(r), (l = (e = s.hiddenUpdates)[i]) === null ? e[i] = [n] : l.push(n), n.lane = 536870912 | r), s) : null;
    }
    function Ad(e) {
      if (Kh > S1) throw td = Kh = 0, Xh = Xb = null, Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
      td > E1 && (td = 0, Xh = null, console.error("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render.")), e.alternate === null && 4098 & e.flags && Xm(e);
      for (var n = e, r = n.return; r !== null; ) n.alternate === null && 4098 & n.flags && Xm(e), r = (n = r).return;
      return n.tag === 3 ? n.stateNode : null;
    }
    function bu(e) {
      if (Na === null) return e;
      var n = Na(e);
      return n === void 0 ? e : n.current;
    }
    function Zp(e) {
      if (Na === null) return e;
      var n = Na(e);
      return n === void 0 ? e != null && typeof e.render == "function" && (n = bu(e.render), e.render !== n) ? (n = { $$typeof: $u, render: n }, e.displayName !== void 0 && (n.displayName = e.displayName), n) : e : n.current;
    }
    function kg(e, n) {
      if (Na === null) return !1;
      var r = e.elementType, l = !1, i = typeof (n = n.type) == "object" && n !== null ? n.$$typeof : null;
      switch (e.tag) {
        case 1:
          typeof n == "function" && (l = !0);
          break;
        case 0:
          (typeof n == "function" || i === Ft) && (l = !0);
          break;
        case 11:
          (i === $u || i === Ft) && (l = !0);
          break;
        case 14:
        case 15:
          (i === Zi || i === Ft) && (l = !0);
          break;
        default:
          return !1;
      }
      return !(!l || (e = Na(r), e === void 0 || e !== Na(n)));
    }
    function wg(e) {
      Na !== null && typeof WeakSet == "function" && (up === null && (up = /* @__PURE__ */ new WeakSet()), up.add(e));
    }
    function _s(e, n, r) {
      var l = e.alternate, i = e.child, s = e.sibling, f = e.tag, p = e.type, y = null;
      switch (f) {
        case 0:
        case 15:
        case 1:
          y = p;
          break;
        case 11:
          y = p.render;
      }
      if (Na === null) throw Error("Expected resolveFamily to be set during hot reload.");
      var v = !1;
      p = !1, y !== null && (y = Na(y)) !== void 0 && (r.has(y) ? p = !0 : n.has(y) && (f === 1 ? p = !0 : v = !0)), up !== null && (up.has(e) || l !== null && up.has(l)) && (p = !0), p && (e._debugNeedsRemount = !0), (p || v) && (l = Cr(e, 2)) !== null && dt(l, e, 2), i === null || p || _s(i, n, r), s !== null && _s(s, n, r);
    }
    function Os(e, n, r, l) {
      this.tag = e, this.key = r, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.refCleanup = this.ref = null, this.pendingProps = n, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = l, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null, this.actualDuration = -0, this.actualStartTime = -1.1, this.treeBaseDuration = this.selfBaseDuration = -0, this._debugTask = this._debugStack = this._debugOwner = this._debugInfo = null, this._debugNeedsRemount = !1, this._debugHookTypes = null, Kv || typeof Object.preventExtensions != "function" || Object.preventExtensions(this);
    }
    function Jp(e) {
      return !(!(e = e.prototype) || !e.isReactComponent);
    }
    function Qo(e, n) {
      var r = e.alternate;
      switch (r === null ? ((r = Y(e.tag, n, e.key, e.mode)).elementType = e.elementType, r.type = e.type, r.stateNode = e.stateNode, r._debugOwner = e._debugOwner, r._debugStack = e._debugStack, r._debugTask = e._debugTask, r._debugHookTypes = e._debugHookTypes, r.alternate = e, e.alternate = r) : (r.pendingProps = n, r.type = e.type, r.flags = 0, r.subtreeFlags = 0, r.deletions = null, r.actualDuration = -0, r.actualStartTime = -1.1), r.flags = 65011712 & e.flags, r.childLanes = e.childLanes, r.lanes = e.lanes, r.child = e.child, r.memoizedProps = e.memoizedProps, r.memoizedState = e.memoizedState, r.updateQueue = e.updateQueue, n = e.dependencies, r.dependencies = n === null ? null : { lanes: n.lanes, firstContext: n.firstContext, _debugThenableState: n._debugThenableState }, r.sibling = e.sibling, r.index = e.index, r.ref = e.ref, r.refCleanup = e.refCleanup, r.selfBaseDuration = e.selfBaseDuration, r.treeBaseDuration = e.treeBaseDuration, r._debugInfo = e._debugInfo, r._debugNeedsRemount = e._debugNeedsRemount, r.tag) {
        case 0:
        case 15:
        case 1:
          r.type = bu(e.type);
          break;
        case 11:
          r.type = Zp(e.type);
      }
      return r;
    }
    function em(e, n) {
      e.flags &= 65011714;
      var r = e.alternate;
      return r === null ? (e.childLanes = 0, e.lanes = n, e.child = null, e.subtreeFlags = 0, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null, e.stateNode = null, e.selfBaseDuration = 0, e.treeBaseDuration = 0) : (e.childLanes = r.childLanes, e.lanes = r.lanes, e.child = r.child, e.subtreeFlags = 0, e.deletions = null, e.memoizedProps = r.memoizedProps, e.memoizedState = r.memoizedState, e.updateQueue = r.updateQueue, e.type = r.type, n = r.dependencies, e.dependencies = n === null ? null : { lanes: n.lanes, firstContext: n.firstContext, _debugThenableState: n._debugThenableState }, e.selfBaseDuration = r.selfBaseDuration, e.treeBaseDuration = r.treeBaseDuration), e;
    }
    function Nd(e, n, r, l, i, s) {
      var f = 0, p = e;
      if (typeof e == "function") Jp(e) && (f = 1), p = bu(p);
      else if (typeof e == "string") f = function(y, v, z) {
        var j = !z.ancestorInfo.containerTagInScope;
        if (z.context === _p || v.itemProp != null) return !j || v.itemProp == null || y !== "meta" && y !== "title" && y !== "style" && y !== "link" && y !== "script" || console.error("Cannot render a <%s> outside the main document if it has an `itemProp` prop. `itemProp` suggests the tag belongs to an `itemScope` which can appear anywhere in the DOM. If you were intending for React to hoist this <%s> remove the `itemProp` prop. Otherwise, try moving this tag into the <head> or <body> of the Document.", y, y), !1;
        switch (y) {
          case "meta":
          case "title":
            return !0;
          case "style":
            if (typeof v.precedence != "string" || typeof v.href != "string" || v.href === "") {
              j && console.error('Cannot render a <style> outside the main document without knowing its precedence and a unique href key. React can hoist and deduplicate <style> tags if you provide a `precedence` prop along with an `href` prop that does not conflict with the `href` values used in any other hoisted <style> or <link rel="stylesheet" ...> tags.  Note that hoisting <style> tags is considered an advanced feature that most will not use directly. Consider moving the <style> tag to the <head> or consider adding a `precedence="default"` and `href="some unique resource identifier"`.');
              break;
            }
            return !0;
          case "link":
            if (typeof v.rel != "string" || typeof v.href != "string" || v.href === "" || v.onLoad || v.onError) {
              if (v.rel === "stylesheet" && typeof v.precedence == "string") {
                y = v.href;
                var F = v.onError, te = v.disabled;
                z = [], v.onLoad && z.push("`onLoad`"), F && z.push("`onError`"), te != null && z.push("`disabled`"), F = function(Q, ge) {
                  switch (Q.length) {
                    case 0:
                      return "";
                    case 1:
                      return Q[0];
                    case 2:
                      return Q[0] + " " + ge + " " + Q[1];
                    default:
                      return Q.slice(0, -1).join(", ") + ", " + ge + " " + Q[Q.length - 1];
                  }
                }(z, "and"), F += z.length === 1 ? " prop" : " props", te = z.length === 1 ? "an " + F : "the " + F, z.length && console.error('React encountered a <link rel="stylesheet" href="%s" ... /> with a `precedence` prop that also included %s. The presence of loading and error handlers indicates an intent to manage the stylesheet loading state from your from your Component code and React will not hoist or deduplicate this stylesheet. If your intent was to have React hoist and deduplciate this stylesheet using the `precedence` prop remove the %s, otherwise remove the `precedence` prop.', y, te, F);
              }
              j && (typeof v.rel != "string" || typeof v.href != "string" || v.href === "" ? console.error("Cannot render a <link> outside the main document without a `rel` and `href` prop. Try adding a `rel` and/or `href` prop to this <link> or moving the link into the <head> tag") : (v.onError || v.onLoad) && console.error("Cannot render a <link> with onLoad or onError listeners outside the main document. Try removing onLoad={...} and onError={...} or moving it into the root <head> tag or somewhere in the <body>."));
              break;
            }
            return v.rel !== "stylesheet" || (y = v.precedence, v = v.disabled, typeof y != "string" && j && console.error('Cannot render a <link rel="stylesheet" /> outside the main document without knowing its precedence. Consider adding precedence="default" or moving it into the root <head> tag.'), typeof y == "string" && v == null);
          case "script":
            if (!(y = v.async && typeof v.async != "function" && typeof v.async != "symbol") || v.onLoad || v.onError || !v.src || typeof v.src != "string") {
              j && (y ? v.onLoad || v.onError ? console.error("Cannot render a <script> with onLoad or onError listeners outside the main document. Try removing onLoad={...} and onError={...} or moving it into the root <head> tag or somewhere in the <body>.") : console.error("Cannot render a <script> outside the main document without `async={true}` and a non-empty `src` prop. Ensure there is a valid `src` and either make the script async or move it into the root <head> tag or somewhere in the <body>.") : console.error('Cannot render a sync or defer <script> outside the main document without knowing its order. Try adding async="" or moving it into the root <head> tag.'));
              break;
            }
            return !0;
          case "noscript":
          case "template":
            j && console.error("Cannot render <%s> outside the main document. Try moving it into the root <head> tag.", y);
        }
        return !1;
      }(e, r, f = Ae()) ? 26 : e === "html" || e === "head" || e === "body" ? 27 : 5;
      else e: switch (e) {
        case qf:
          return (n = Y(31, r, n, i)).elementType = qf, n.lanes = s, n;
        case Ku:
          return xl(r.children, i, s, n);
        case Tc:
          f = 8, i |= Dr, i |= fl;
          break;
        case an:
          return l = i, typeof (e = r).id != "string" && console.error('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof e.id), (n = Y(12, e, n, l | kr)).elementType = an, n.lanes = s, n.stateNode = { effectDuration: 0, passiveEffectDuration: 0 }, n;
        case Pc:
          return (n = Y(13, r, n, i)).elementType = Pc, n.lanes = s, n;
        case $i:
          return (n = Y(19, r, n, i)).elementType = $i, n.lanes = s, n;
        default:
          if (typeof e == "object" && e !== null) switch (e.$$typeof) {
            case hh:
            case mo:
              f = 10;
              break e;
            case Xu:
              f = 9;
              break e;
            case $u:
              f = 11, p = Zp(p);
              break e;
            case Zi:
              f = 14;
              break e;
            case Ft:
              f = 16, p = null;
              break e;
          }
          p = "", (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (p += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports."), e === null ? r = "null" : It(e) ? r = "array" : e !== void 0 && e.$$typeof === Sa ? (r = "<" + (Se(e.type) || "Unknown") + " />", p = " Did you accidentally export a JSX literal instead of a component?") : r = typeof e, (f = l ? Ge(l) : null) && (p += `

Check the render method of \`` + f + "`."), f = 29, r = Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: " + r + "." + p), p = null;
      }
      return (n = Y(f, r, n, i)).elementType = e, n.type = p, n.lanes = s, n._debugOwner = l, n;
    }
    function Ls(e, n, r) {
      return (n = Nd(e.type, e.key, e.props, e._owner, n, r))._debugOwner = e._owner, n._debugStack = e._debugStack, n._debugTask = e._debugTask, n;
    }
    function xl(e, n, r, l) {
      return (e = Y(7, e, l, n)).lanes = r, e;
    }
    function Cl(e, n, r) {
      return (e = Y(6, e, null, n)).lanes = r, e;
    }
    function nm(e, n, r) {
      return (n = Y(4, e.children !== null ? e.children : [], e.key, n)).lanes = r, n.stateNode = { containerInfo: e.containerInfo, pendingChildren: null, implementation: e.implementation }, n;
    }
    function Tl(e, n) {
      gi(), sp[cp++] = cy, sp[cp++] = sy, sy = e, cy = n;
    }
    function tm(e, n, r) {
      gi(), _a[Oa++] = $l, _a[Oa++] = tu, _a[Oa++] = Wc, Wc = e;
      var l = $l;
      e = tu;
      var i = 32 - St(l) - 1;
      l &= ~(1 << i), r += 1;
      var s = 32 - St(n) + i;
      if (30 < s) {
        var f = i - i % 5;
        s = (l & (1 << f) - 1).toString(32), l >>= f, i -= f, $l = 1 << 32 - St(n) + i | r << i | l, tu = s + e;
      } else $l = 1 << s | r << i | l, tu = e;
    }
    function vu(e) {
      gi(), e.return !== null && (Tl(e, 1), tm(e, 1, 0));
    }
    function hi(e) {
      for (; e === sy; ) sy = sp[--cp], sp[cp] = null, cy = sp[--cp], sp[cp] = null;
      for (; e === Wc; ) Wc = _a[--Oa], _a[Oa] = null, tu = _a[--Oa], _a[Oa] = null, $l = _a[--Oa], _a[Oa] = null;
    }
    function gi() {
      Tn || console.error("Expected to be hydrating. This is a bug in React. Please file an issue.");
    }
    function Yo(e, n) {
      if (e.return === null) {
        if (La === null) La = { fiber: e, children: [], serverProps: void 0, serverTail: [], distanceFromLeaf: n };
        else {
          if (La.fiber !== e) throw Error("Saw multiple hydration diff roots in a pass. This is a bug in React.");
          La.distanceFromLeaf > n && (La.distanceFromLeaf = n);
        }
        return La;
      }
      var r = Yo(e.return, n + 1).children;
      return 0 < r.length && r[r.length - 1].fiber === e ? ((r = r[r.length - 1]).distanceFromLeaf > n && (r.distanceFromLeaf = n), r) : (n = { fiber: e, children: [], serverProps: void 0, serverTail: [], distanceFromLeaf: n }, r.push(n), n);
    }
    function _d(e, n) {
      ru || ((e = Yo(e, 0)).serverProps = null, n !== null && (n = br(n), e.serverTail.push(n)));
    }
    function Pl(e) {
      var n = "", r = La;
      throw r !== null && (La = null, n = Hr(r)), zs(Ur(Error(`Hydration failed because the server rendered HTML didn't match the client. As a result this tree will be regenerated on the client. This can happen if a SSR-ed Client Component used:

- A server/client branch \`if (typeof window !== 'undefined')\`.
- Variable input such as \`Date.now()\` or \`Math.random()\` which changes each time it's called.
- Date formatting in a user's locale which doesn't match the server.
- External changing data without sending a snapshot of it along with the HTML.
- Invalid HTML tag nesting.

It can also happen if the client has a browser extension installed which messes with the HTML before React loaded.

https://react.dev/link/hydration-mismatch` + n), e)), wb;
    }
    function Od(e) {
      var n = e.stateNode, r = e.type, l = e.memoizedProps;
      switch (n[Mt] = e, n[ir] = l, Pf(r, l), r) {
        case "dialog":
          fn("cancel", n), fn("close", n);
          break;
        case "iframe":
        case "object":
        case "embed":
          fn("load", n);
          break;
        case "video":
        case "audio":
          for (r = 0; r < $h.length; r++) fn($h[r], n);
          break;
        case "source":
          fn("error", n);
          break;
        case "img":
        case "image":
        case "link":
          fn("error", n), fn("load", n);
          break;
        case "details":
          fn("toggle", n);
          break;
        case "input":
          Le("input", l), fn("invalid", n), ai(0, l), Mp(n, l.value, l.defaultValue, l.checked, l.defaultChecked, l.type, l.name, !0), pu(n);
          break;
        case "option":
          vl(0, l);
          break;
        case "select":
          Le("select", l), fn("invalid", n), jp(n, l);
          break;
        case "textarea":
          Le("textarea", l), fn("invalid", n), mg(0, l), Up(n, l.value, l.defaultValue, l.children), pu(n);
      }
      typeof (r = l.children) != "string" && typeof r != "number" && typeof r != "bigint" || n.textContent === "" + r || l.suppressHydrationWarning === !0 || ll(n.textContent, r) ? (l.popover != null && (fn("beforetoggle", n), fn("toggle", n)), l.onScroll != null && fn("scroll", n), l.onScrollEnd != null && fn("scrollend", n), l.onClick != null && (n.onclick = Wu), n = !0) : n = !1, n || Pl(e);
    }
    function Ld(e) {
      for (Jr = e.return; Jr; ) switch (Jr.tag) {
        case 5:
        case 13:
          return void (Zl = !1);
        case 27:
        case 3:
          return void (Zl = !0);
        default:
          Jr = Jr.return;
      }
    }
    function ku(e) {
      if (e !== Jr) return !1;
      if (!Tn) return Ld(e), Tn = !0, !1;
      var n, r = e.tag;
      if ((n = r !== 3 && r !== 27) && ((n = r === 5) && (n = !((n = e.type) !== "form" && n !== "button") || Rn(e.type, e.memoizedProps)), n = !n), n && Et) {
        for (n = Et; n; ) {
          var l = Yo(e, 0), i = br(n);
          l.serverTail.push(i), n = i.type === "Suspense" ? Of(n) : lr(n.nextSibling);
        }
        Pl(e);
      }
      if (Ld(e), r === 13) {
        if (!(e = (e = e.memoizedState) !== null ? e.dehydrated : null)) throw Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
        Et = Of(e);
      } else r === 27 ? (r = Et, yr(e.type) ? (e = uv, uv = null, Et = e) : Et = r) : Et = Jr ? lr(e.stateNode.nextSibling) : null;
      return !0;
    }
    function wu() {
      Et = Jr = null, ru = Tn = !1;
    }
    function rm() {
      var e = qc;
      return e !== null && (to === null ? to = e : to.push.apply(to, e), qc = null), e;
    }
    function zs(e) {
      qc === null ? qc = [e] : qc.push(e);
    }
    function Sg() {
      var e = La;
      if (e !== null) {
        La = null;
        for (var n = Hr(e); 0 < e.children.length; ) e = e.children[0];
        De(e.fiber, function() {
          console.error(`A tree hydrated but some attributes of the server rendered HTML didn't match the client properties. This won't be patched up. This can happen if a SSR-ed Client Component used:

- A server/client branch \`if (typeof window !== 'undefined')\`.
- Variable input such as \`Date.now()\` or \`Math.random()\` which changes each time it's called.
- Date formatting in a user's locale which doesn't match the server.
- External changing data without sending a snapshot of it along with the HTML.
- Invalid HTML tag nesting.

It can also happen if the client has a browser extension installed which messes with the HTML before React loaded.

%s%s`, "https://react.dev/link/hydration-mismatch", n);
        });
      }
    }
    function zd() {
      dp = dy = null, fp = !1;
    }
    function Rl(e, n, r) {
      Oe(Sb, n._currentValue, e), n._currentValue = r, Oe(Eb, n._currentRenderer, e), n._currentRenderer !== void 0 && n._currentRenderer !== null && n._currentRenderer !== Zv && console.error("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), n._currentRenderer = Zv;
    }
    function mt(e, n) {
      e._currentValue = Sb.current;
      var r = Eb.current;
      Ue(Eb, n), e._currentRenderer = r, Ue(Sb, n);
    }
    function yi(e, n, r) {
      for (; e !== null; ) {
        var l = e.alternate;
        if ((e.childLanes & n) !== n ? (e.childLanes |= n, l !== null && (l.childLanes |= n)) : l !== null && (l.childLanes & n) !== n && (l.childLanes |= n), e === r) break;
        e = e.return;
      }
      e !== r && console.error("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
    }
    function Dd(e, n, r, l) {
      var i = e.child;
      for (i !== null && (i.return = e); i !== null; ) {
        var s = i.dependencies;
        if (s !== null) {
          var f = i.child;
          s = s.firstContext;
          e: for (; s !== null; ) {
            var p = s;
            s = i;
            for (var y = 0; y < n.length; y++) if (p.context === n[y]) {
              s.lanes |= r, (p = s.alternate) !== null && (p.lanes |= r), yi(s.return, r, e), l || (f = null);
              break e;
            }
            s = p.next;
          }
        } else if (i.tag === 18) {
          if ((f = i.return) === null) throw Error("We just came from a parent so we must have had a parent. This is a bug in React.");
          f.lanes |= r, (s = f.alternate) !== null && (s.lanes |= r), yi(f, r, e), f = null;
        } else f = i.child;
        if (f !== null) f.return = i;
        else for (f = i; f !== null; ) {
          if (f === e) {
            f = null;
            break;
          }
          if ((i = f.sibling) !== null) {
            i.return = f.return, f = i;
            break;
          }
          f = f.return;
        }
        i = f;
      }
    }
    function Su(e, n, r, l) {
      e = null;
      for (var i = n, s = !1; i !== null; ) {
        if (!s) {
          if (524288 & i.flags) s = !0;
          else if (262144 & i.flags) break;
        }
        if (i.tag === 10) {
          var f = i.alternate;
          if (f === null) throw Error("Should have a current fiber. This is a bug in React.");
          if ((f = f.memoizedProps) !== null) {
            var p = i.type;
            Zr(i.pendingProps.value, f.value) || (e !== null ? e.push(p) : e = [p]);
          }
        } else if (i === Ju.current) {
          if ((f = i.alternate) === null) throw Error("Should have a current fiber. This is a bug in React.");
          f.memoizedState.memoizedState !== i.memoizedState.memoizedState && (e !== null ? e.push(ng) : e = [ng]);
        }
        i = i.return;
      }
      e !== null && Dd(n, e, r, l), n.flags |= 262144;
    }
    function Ds(e) {
      for (e = e.firstContext; e !== null; ) {
        if (!Zr(e.context._currentValue, e.memoizedValue)) return !0;
        e = e.next;
      }
      return !1;
    }
    function Al(e) {
      dy = e, dp = null, (e = e.dependencies) !== null && (e.firstContext = null);
    }
    function qn(e) {
      return fp && console.error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."), bi(dy, e);
    }
    function Fd(e, n) {
      return dy === null && Al(e), bi(e, n);
    }
    function bi(e, n) {
      var r = n._currentValue;
      if (n = { context: n, memoizedValue: r, next: null }, dp === null) {
        if (e === null) throw Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
        dp = n, e.dependencies = { lanes: 0, firstContext: n, _debugThenableState: null }, e.flags |= 524288;
      } else dp = dp.next = n;
      return r;
    }
    function Fs() {
      return { controller: new i1(), data: /* @__PURE__ */ new Map(), refCount: 0 };
    }
    function wo(e) {
      e.controller.signal.aborted && console.warn("A cache instance was retained after it was already freed. This likely indicates a bug in React."), e.refCount++;
    }
    function vi(e) {
      e.refCount--, 0 > e.refCount && console.warn("A cache instance was released after it was already freed. This likely indicates a bug in React."), e.refCount === 0 && u1(s1, function() {
        e.controller.abort();
      });
    }
    function Go() {
      var e = Qc;
      return Qc = 0, e;
    }
    function Ko(e) {
      var n = Qc;
      return Qc = e, n;
    }
    function Xo(e) {
      var n = Qc;
      return Qc += e, n;
    }
    function Is(e) {
      ho = pp(), 0 > e.actualStartTime && (e.actualStartTime = ho);
    }
    function Id(e) {
      if (0 <= ho) {
        var n = pp() - ho;
        e.actualDuration += n, e.selfBaseDuration = n, ho = -1;
      }
    }
    function Nl(e) {
      if (0 <= ho) {
        var n = pp() - ho;
        e.actualDuration += n, ho = -1;
      }
    }
    function So() {
      if (0 <= ho) {
        var e = pp() - ho;
        ho = -1, Qc += e;
      }
    }
    function Eo() {
      ho = pp();
    }
    function Ms(e) {
      for (var n = e.child; n; ) e.actualDuration += n.actualDuration, n = n.sibling;
    }
    function Eg() {
      if (--xb === 0 && Rh !== null) {
        Gc !== null && (Gc.status = "fulfilled");
        var e = Rh;
        Rh = null, Yc = 0, Gc = null;
        for (var n = 0; n < e.length; n++) (0, e[n])();
      }
    }
    function om() {
      var e = mp.current;
      return e !== null ? e : Kn.pooledCache;
    }
    function Md(e, n) {
      Oe(mp, n === null ? mp.current : n.pool, e);
    }
    function am() {
      var e = om();
      return e === null ? null : { parent: Qt._currentValue, pool: e };
    }
    function lm(e) {
      return (e = e.status) === "fulfilled" || e === "rejected";
    }
    function Eu() {
    }
    function lo(e, n, r) {
      J.actQueue !== null && (J.didUsePromise = !0);
      var l = e.thenables;
      switch ((r = l[r]) === void 0 ? l.push(n) : r !== n && (e.didWarnAboutUncachedPromise || (e.didWarnAboutUncachedPromise = !0, console.error("A component was suspended by an uncached promise. Creating promises inside a Client Component or hook is not yet supported, except via a Suspense-compatible library or framework.")), n.then(Eu, Eu), n = r), n.status) {
        case "fulfilled":
          return n.value;
        case "rejected":
          throw Br(e = n.reason), e;
        default:
          if (typeof n.status == "string") n.then(Eu, Eu);
          else {
            if ((e = Kn) !== null && 100 < e.shellSuspendCounter) throw Error("An unknown Component is an async Client Component. Only Server Components can be async at the moment. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server.");
            (e = n).status = "pending", e.then(function(i) {
              if (n.status === "pending") {
                var s = n;
                s.status = "fulfilled", s.value = i;
              }
            }, function(i) {
              if (n.status === "pending") {
                var s = n;
                s.status = "rejected", s.reason = i;
              }
            });
          }
          switch (n.status) {
            case "fulfilled":
              return n.value;
            case "rejected":
              throw Br(e = n.reason), e;
          }
          throw Fh = n, yy = !0, Dh;
      }
    }
    function im() {
      if (Fh === null) throw Error("Expected a suspended thenable. This is a bug in React. Please file an issue.");
      var e = Fh;
      return Fh = null, yy = !1, e;
    }
    function Br(e) {
      if (e === Dh || e === gy) throw Error("Hooks are not supported inside an async component. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server.");
    }
    function Tr(e) {
      e.updateQueue = { baseState: e.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null, lanes: 0, hiddenCallbacks: null }, callbacks: null };
    }
    function _l(e, n) {
      e = e.updateQueue, n.updateQueue === e && (n.updateQueue = { baseState: e.baseState, firstBaseUpdate: e.firstBaseUpdate, lastBaseUpdate: e.lastBaseUpdate, shared: e.shared, callbacks: null });
    }
    function $o(e) {
      return { lane: e, tag: r0, payload: null, callback: null, next: null };
    }
    function xo(e, n, r) {
      var l = e.updateQueue;
      if (l === null) return null;
      if (l = l.shared, Pb === l && !l0) {
        var i = Ee(e);
        console.error(`An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback.

Please update the following component: %s`, i), l0 = !0;
      }
      return (Dn & no) !== Mo ? ((i = l.pending) === null ? n.next = n : (n.next = i.next, i.next = n), l.pending = n, n = Ad(e), $p(e, null, r), n) : (Rd(e, l, n, r), Ad(e));
    }
    function Ol(e, n, r) {
      if ((n = n.updateQueue) !== null && (n = n.shared, 4194048 & r)) {
        var l = n.lanes;
        r |= l &= e.pendingLanes, n.lanes = r, vs(e, r);
      }
    }
    function xu(e, n) {
      var r = e.updateQueue, l = e.alternate;
      if (l !== null && r === (l = l.updateQueue)) {
        var i = null, s = null;
        if ((r = r.firstBaseUpdate) !== null) {
          do {
            var f = { lane: r.lane, tag: r.tag, payload: r.payload, callback: null, next: null };
            s === null ? i = s = f : s = s.next = f, r = r.next;
          } while (r !== null);
          s === null ? i = s = n : s = s.next = n;
        } else i = s = n;
        return r = { baseState: l.baseState, firstBaseUpdate: i, lastBaseUpdate: s, shared: l.shared, callbacks: l.callbacks }, void (e.updateQueue = r);
      }
      (e = r.lastBaseUpdate) === null ? r.firstBaseUpdate = n : e.next = n, r.lastBaseUpdate = n;
    }
    function Zo() {
      if (Rb && Gc !== null)
        throw Gc;
    }
    function Cu(e, n, r, l) {
      Rb = !1;
      var i = e.updateQueue;
      rs = !1, Pb = i.shared;
      var s = i.firstBaseUpdate, f = i.lastBaseUpdate, p = i.shared.pending;
      if (p !== null) {
        i.shared.pending = null;
        var y = p, v = y.next;
        y.next = null, f === null ? s = v : f.next = v, f = y;
        var z = e.alternate;
        z !== null && (p = (z = z.updateQueue).lastBaseUpdate) !== f && (p === null ? z.firstBaseUpdate = v : p.next = v, z.lastBaseUpdate = y);
      }
      if (s !== null) {
        var j = i.baseState;
        for (f = 0, z = v = y = null, p = s; ; ) {
          var F = -536870913 & p.lane, te = F !== p.lane;
          if (te ? (vn & F) === F : (l & F) === F) {
            F !== 0 && F === Yc && (Rb = !0), z !== null && (z = z.next = { lane: 0, tag: p.tag, payload: p.payload, callback: null, next: null });
            e: {
              F = e;
              var Q = p, ge = n, T = r;
              switch (Q.tag) {
                case o0:
                  if (typeof (Q = Q.payload) == "function") {
                    fp = !0;
                    var P = Q.call(T, j, ge);
                    if (F.mode & Dr) {
                      Ce(!0);
                      try {
                        Q.call(T, j, ge);
                      } finally {
                        Ce(!1);
                      }
                    }
                    fp = !1, j = P;
                    break e;
                  }
                  j = Q;
                  break e;
                case Tb:
                  F.flags = -65537 & F.flags | 128;
                case r0:
                  if (typeof (P = Q.payload) == "function") {
                    if (fp = !0, Q = P.call(T, j, ge), F.mode & Dr) {
                      Ce(!0);
                      try {
                        P.call(T, j, ge);
                      } finally {
                        Ce(!1);
                      }
                    }
                    fp = !1;
                  } else Q = P;
                  if (Q == null) break e;
                  j = en({}, j, Q);
                  break e;
                case a0:
                  rs = !0;
              }
            }
            (F = p.callback) !== null && (e.flags |= 64, te && (e.flags |= 8192), (te = i.callbacks) === null ? i.callbacks = [F] : te.push(F));
          } else te = { lane: F, tag: p.tag, payload: p.payload, callback: p.callback, next: null }, z === null ? (v = z = te, y = j) : z = z.next = te, f |= F;
          if ((p = p.next) === null) {
            if ((p = i.shared.pending) === null) break;
            p = (te = p).next, te.next = null, i.lastBaseUpdate = te, i.shared.pending = null;
          }
        }
        z === null && (y = j), i.baseState = y, i.firstBaseUpdate = v, i.lastBaseUpdate = z, s === null && (i.shared.lanes = 0), is |= f, e.lanes = f, e.memoizedState = j;
      }
      Pb = null;
    }
    function js(e, n) {
      if (typeof e != "function") throw Error("Invalid argument passed as callback. Expected a function. Instead received: " + e);
      e.call(n);
    }
    function Tu(e, n) {
      var r = e.shared.hiddenCallbacks;
      if (r !== null) for (e.shared.hiddenCallbacks = null, e = 0; e < r.length; e++) js(r[e], n);
    }
    function xg(e, n) {
      var r = e.callbacks;
      if (r !== null) for (e.callbacks = null, e = 0; e < r.length; e++) js(r[e], n);
    }
    function Pr(e, n) {
      var r = ei;
      Oe(by, r, e), Oe(gp, n, e), ei = r | n.baseLanes;
    }
    function Hs(e) {
      Oe(by, ei, e), Oe(gp, gp.current, e);
    }
    function Co(e) {
      ei = by.current, Ue(gp, e), Ue(by, e);
    }
    function on() {
      var e = ne;
      Fa === null ? Fa = [e] : Fa.push(e);
    }
    function he() {
      var e = ne;
      if (Fa !== null && (au++, Fa[au] !== e)) {
        var n = Ee(Ye);
        if (!i0.has(n) && (i0.add(n), Fa !== null)) {
          for (var r = "", l = 0; l <= au; l++) {
            var i = Fa[l], s = l === au ? e : i;
            for (i = l + 1 + ". " + i; 30 > i.length; ) i += " ";
            r += i += s + `
`;
          }
          console.error(`React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://react.dev/link/rules-of-hooks

   Previous render            Next render
   ------------------------------------------------------
%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
`, n, r);
        }
      }
    }
    function io(e) {
      e == null || It(e) || console.error("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", ne, typeof e);
    }
    function Pu() {
      var e = Ee(Ye);
      s0.has(e) || (s0.add(e), console.error("ReactDOM.useFormState has been renamed to React.useActionState. Please update %s to use React.useActionState.", e));
    }
    function tt() {
      throw Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.`);
    }
    function Ll(e, n) {
      if (Mh) return !1;
      if (n === null) return console.error("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", ne), !1;
      e.length !== n.length && console.error(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, ne, "[" + n.join(", ") + "]", "[" + e.join(", ") + "]");
      for (var r = 0; r < n.length && r < e.length; r++) if (!Zr(e[r], n[r])) return !1;
      return !0;
    }
    function zl(e, n, r, l, i, s) {
      os = s, Ye = n, Fa = e !== null ? e._debugHookTypes : null, au = -1, Mh = e !== null && e.type !== n.type, Object.prototype.toString.call(r) !== "[object AsyncFunction]" && Object.prototype.toString.call(r) !== "[object AsyncGeneratorFunction]" || (s = Ee(Ye), Ab.has(s) || (Ab.add(s), console.error("%s is an async Client Component. Only Server Components can be async at the moment. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server.", s === null ? "An unknown Component" : "<" + s + ">"))), n.memoizedState = null, n.updateQueue = null, n.lanes = 0, J.H = e !== null && e.memoizedState !== null ? _b : Fa !== null ? c0 : Nb, Xc = s = (n.mode & Dr) !== Jn;
      var f = Lb(r, l, i);
      if (Xc = !1, yp && (f = Ru(n, r, l, i)), s) {
        Ce(!0);
        try {
          f = Ru(n, r, l, i);
        } finally {
          Ce(!1);
        }
      }
      return Us(e, n), f;
    }
    function Us(e, n) {
      n._debugHookTypes = Fa, n.dependencies === null ? ou !== null && (n.dependencies = { lanes: 0, firstContext: null, _debugThenableState: ou }) : n.dependencies._debugThenableState = ou, J.H = wy;
      var r = et !== null && et.next !== null;
      if (os = 0, Fa = ne = jt = et = Ye = null, au = -1, e !== null && (65011712 & e.flags) != (65011712 & n.flags) && console.error("Internal React error: Expected static flag was missing. Please notify the React team."), vy = !1, Ih = 0, ou = null, r) throw Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
      e === null || sr || (e = e.dependencies) !== null && Ds(e) && (sr = !0), yy ? (yy = !1, e = !0) : e = !1, e && (n = Ee(n) || "Unknown", u0.has(n) || Ab.has(n) || (u0.add(n), console.error("`use` was called from inside a try/catch block. This is not allowed and can lead to unexpected behavior. To handle errors triggered by `use`, wrap your component in a error boundary.")));
    }
    function Ru(e, n, r, l) {
      Ye = e;
      var i = 0;
      do {
        if (yp && (ou = null), Ih = 0, yp = !1, i >= d1) throw Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
        if (i += 1, Mh = !1, jt = et = null, e.updateQueue != null) {
          var s = e.updateQueue;
          s.lastEffect = null, s.events = null, s.stores = null, s.memoCache != null && (s.memoCache.index = 0);
        }
        au = -1, J.H = d0, s = Lb(n, r, l);
      } while (yp);
      return s;
    }
    function uo() {
      var e = J.H, n = e.useState()[0];
      return n = typeof n.then == "function" ? Au(n) : n, e = e.useState()[0], (et !== null ? et.memoizedState : null) !== e && (Ye.flags |= 1024), n;
    }
    function Rr() {
      var e = ky !== 0;
      return ky = 0, e;
    }
    function Qa(e, n, r) {
      n.updateQueue = e.updateQueue, n.flags = (n.mode & fl) !== Jn ? -402655237 & n.flags : -2053 & n.flags, e.lanes &= ~r;
    }
    function so(e) {
      if (vy) {
        for (e = e.memoizedState; e !== null; ) {
          var n = e.queue;
          n !== null && (n.pending = null), e = e.next;
        }
        vy = !1;
      }
      os = 0, Fa = jt = et = Ye = null, au = -1, ne = null, yp = !1, Ih = ky = 0, ou = null;
    }
    function ut() {
      var e = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
      return jt === null ? Ye.memoizedState = jt = e : jt = jt.next = e, jt;
    }
    function Sn() {
      if (et === null) {
        var e = Ye.alternate;
        e = e !== null ? e.memoizedState : null;
      } else e = et.next;
      var n = jt === null ? Ye.memoizedState : jt.next;
      if (n !== null) jt = n, et = e;
      else {
        if (e === null)
          throw Ye.alternate === null ? Error("Update hook called on initial render. This is likely a bug in React. Please file an issue.") : Error("Rendered more hooks than during the previous render.");
        e = { memoizedState: (et = e).memoizedState, baseState: et.baseState, baseQueue: et.baseQueue, queue: et.queue, next: null }, jt === null ? Ye.memoizedState = jt = e : jt = jt.next = e;
      }
      return jt;
    }
    function Au(e) {
      var n = Ih;
      return Ih += 1, ou === null && (ou = { didWarnAboutUncachedPromise: !1, thenables: [] }), e = lo(ou, e, n), n = Ye, (jt === null ? n.memoizedState : jt.next) === null && (n = n.alternate, J.H = n !== null && n.memoizedState !== null ? _b : Nb), e;
    }
    function Jo(e) {
      if (e !== null && typeof e == "object") {
        if (typeof e.then == "function") return Au(e);
        if (e.$$typeof === mo) return qn(e);
      }
      throw Error("An unsupported type was passed to use(): " + String(e));
    }
    function Ya(e) {
      var n = null, r = Ye.updateQueue;
      if (r !== null && (n = r.memoCache), n == null) {
        var l = Ye.alternate;
        l !== null && (l = l.updateQueue) !== null && (l = l.memoCache) != null && (n = { data: l.data.map(function(i) {
          return i.slice();
        }), index: 0 });
      }
      if (n == null && (n = { data: [], index: 0 }), r === null && (r = { lastEffect: null, events: null, stores: null, memoCache: null }, Ye.updateQueue = r), r.memoCache = n, (r = n.data[n.index]) === void 0 || Mh) for (r = n.data[n.index] = Array(e), l = 0; l < e; l++) r[l] = lb;
      else r.length !== e && console.error("Expected a constant size argument for each invocation of useMemoCache. The previous cache was allocated with size %s but size %s was requested.", r.length, e);
      return n.index++, r;
    }
    function Yn(e, n) {
      return typeof n == "function" ? n(e) : n;
    }
    function Xn(e, n, r) {
      var l = ut();
      if (r !== void 0) {
        var i = r(n);
        if (Xc) {
          Ce(!0);
          try {
            r(n);
          } finally {
            Ce(!1);
          }
        }
      } else i = n;
      return l.memoizedState = l.baseState = i, e = { pending: null, lanes: 0, dispatch: null, lastRenderedReducer: e, lastRenderedState: i }, l.queue = e, e = e.dispatch = ym.bind(null, Ye, e), [l.memoizedState, e];
    }
    function bn(e) {
      return Ga(Sn(), et, e);
    }
    function Ga(e, n, r) {
      var l = e.queue;
      if (l === null) throw Error("Should have a queue. You are likely calling Hooks conditionally, which is not allowed. (https://react.dev/link/invalid-hook-call)");
      l.lastRenderedReducer = r;
      var i = e.baseQueue, s = l.pending;
      if (s !== null) {
        if (i !== null) {
          var f = i.next;
          i.next = s.next, s.next = f;
        }
        n.baseQueue !== i && console.error("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React."), n.baseQueue = i = s, l.pending = null;
      }
      if (s = e.baseState, i === null) e.memoizedState = s;
      else {
        var p = f = null, y = null, v = n = i.next, z = !1;
        do {
          var j = -536870913 & v.lane;
          if (j !== v.lane ? (vn & j) === j : (os & j) === j) {
            var F = v.revertLane;
            if (F === 0) y !== null && (y = y.next = { lane: 0, revertLane: 0, action: v.action, hasEagerState: v.hasEagerState, eagerState: v.eagerState, next: null }), j === Yc && (z = !0);
            else {
              if ((os & F) === F) {
                v = v.next, F === Yc && (z = !0);
                continue;
              }
              j = { lane: 0, revertLane: v.revertLane, action: v.action, hasEagerState: v.hasEagerState, eagerState: v.eagerState, next: null }, y === null ? (p = y = j, f = s) : y = y.next = j, Ye.lanes |= F, is |= F;
            }
            j = v.action, Xc && r(s, j), s = v.hasEagerState ? v.eagerState : r(s, j);
          } else F = { lane: j, revertLane: v.revertLane, action: v.action, hasEagerState: v.hasEagerState, eagerState: v.eagerState, next: null }, y === null ? (p = y = F, f = s) : y = y.next = F, Ye.lanes |= j, is |= j;
          v = v.next;
        } while (v !== null && v !== n);
        if (y === null ? f = s : y.next = p, !Zr(s, e.memoizedState) && (sr = !0, z && (r = Gc) !== null)) throw r;
        e.memoizedState = s, e.baseState = f, e.baseQueue = y, l.lastRenderedState = s;
      }
      return i === null && (l.lanes = 0), [e.memoizedState, l.dispatch];
    }
    function Ar(e) {
      var n = Sn(), r = n.queue;
      if (r === null) throw Error("Should have a queue. You are likely calling Hooks conditionally, which is not allowed. (https://react.dev/link/invalid-hook-call)");
      r.lastRenderedReducer = e;
      var l = r.dispatch, i = r.pending, s = n.memoizedState;
      if (i !== null) {
        r.pending = null;
        var f = i = i.next;
        do
          s = e(s, f.action), f = f.next;
        while (f !== i);
        Zr(s, n.memoizedState) || (sr = !0), n.memoizedState = s, n.baseQueue === null && (n.baseState = s), r.lastRenderedState = s;
      }
      return [s, l];
    }
    function Bs(e, n, r) {
      var l = Ye, i = ut();
      if (Tn) {
        if (r === void 0) throw Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
        var s = r();
        hp || s === r() || (console.error("The result of getServerSnapshot should be cached to avoid an infinite loop"), hp = !0);
      } else {
        if (s = n(), hp || (r = n(), Zr(s, r) || (console.error("The result of getSnapshot should be cached to avoid an infinite loop"), hp = !0)), Kn === null) throw Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        124 & vn || um(l, n, s);
      }
      return i.memoizedState = s, r = { value: s, getSnapshot: n }, i.queue = r, ra(Nu.bind(null, l, r, e), [e]), l.flags |= 2048, Dl(Da | Yt, { destroy: void 0, resource: void 0 }, sm.bind(null, l, r, s, n), null), s;
    }
    function ea(e, n, r) {
      var l = Ye, i = Sn(), s = Tn;
      if (s) {
        if (r === void 0) throw Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
        r = r();
      } else if (r = n(), !hp) {
        var f = n();
        Zr(r, f) || (console.error("The result of getSnapshot should be cached to avoid an infinite loop"), hp = !0);
      }
      (f = !Zr((et || i).memoizedState, r)) && (i.memoizedState = r, sr = !0), i = i.queue;
      var p = Nu.bind(null, l, i, e);
      if (er(2048, Yt, p, [e]), i.getSnapshot !== n || f || jt !== null && jt.memoizedState.tag & Da) {
        if (l.flags |= 2048, Dl(Da | Yt, { destroy: void 0, resource: void 0 }, sm.bind(null, l, i, r, n), null), Kn === null) throw Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        s || 124 & os || um(l, n, r);
      }
      return r;
    }
    function um(e, n, r) {
      e.flags |= 16384, e = { getSnapshot: n, value: r }, (n = Ye.updateQueue) === null ? (n = { lastEffect: null, events: null, stores: null, memoCache: null }, Ye.updateQueue = n, n.stores = [e]) : (r = n.stores) === null ? n.stores = [e] : r.push(e);
    }
    function sm(e, n, r, l) {
      n.value = r, n.getSnapshot = l, _u(n) && cm(e);
    }
    function Nu(e, n, r) {
      return r(function() {
        _u(n) && cm(e);
      });
    }
    function _u(e) {
      var n = e.getSnapshot;
      e = e.value;
      try {
        var r = n();
        return !Zr(e, r);
      } catch {
        return !0;
      }
    }
    function cm(e) {
      var n = Cr(e, 2);
      n !== null && dt(n, e, 2);
    }
    function ki(e) {
      var n = ut();
      if (typeof e == "function") {
        var r = e;
        if (e = r(), Xc) {
          Ce(!0);
          try {
            r();
          } finally {
            Ce(!1);
          }
        }
      }
      return n.memoizedState = n.baseState = e, n.queue = { pending: null, lanes: 0, dispatch: null, lastRenderedReducer: Yn, lastRenderedState: e }, n;
    }
    function Vs(e) {
      var n = (e = ki(e)).queue, r = Lu.bind(null, Ye, n);
      return n.dispatch = r, [e.memoizedState, r];
    }
    function Ka(e) {
      var n = ut();
      n.memoizedState = n.baseState = e;
      var r = { pending: null, lanes: 0, dispatch: null, lastRenderedReducer: null, lastRenderedState: null };
      return n.queue = r, n = Gd.bind(null, Ye, !0, r), r.dispatch = n, [e, n];
    }
    function na(e, n) {
      return Xa(Sn(), et, e, n);
    }
    function Xa(e, n, r, l) {
      return e.baseState = r, Ga(e, et, typeof l == "function" ? l : Yn);
    }
    function ta(e, n) {
      var r = Sn();
      return et !== null ? Xa(r, 0, e, n) : (r.baseState = e, [e, r.queue.dispatch]);
    }
    function dm(e, n, r, l, i) {
      if (Ks(e)) throw Error("Cannot update form state while rendering.");
      if ((e = n.action) !== null) {
        var s = { payload: i, action: e, next: null, isTransition: !0, status: "pending", value: null, reason: null, listeners: [], then: function(f) {
          s.listeners.push(f);
        } };
        J.T !== null ? r(!0) : s.isTransition = !1, l(s), (r = n.pending) === null ? (s.next = n.pending = s, jd(n, s)) : (s.next = r.next, n.pending = r.next = s);
      }
    }
    function jd(e, n) {
      var r = n.action, l = n.payload, i = e.state;
      if (n.isTransition) {
        var s = J.T, f = {};
        J.T = f, J.T._updatedFibers = /* @__PURE__ */ new Set();
        try {
          var p = r(i, l), y = J.S;
          y !== null && y(f, p), Ou(e, n, p);
        } catch (v) {
          $a(e, n, v);
        } finally {
          J.T = s, s === null && f._updatedFibers && (e = f._updatedFibers.size, f._updatedFibers.clear(), 10 < e && console.warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."));
        }
      } else try {
        Ou(e, n, f = r(i, l));
      } catch (v) {
        $a(e, n, v);
      }
    }
    function Ou(e, n, r) {
      r !== null && typeof r == "object" && typeof r.then == "function" ? (r.then(function(l) {
        Ws(e, n, l);
      }, function(l) {
        return $a(e, n, l);
      }), n.isTransition || console.error("An async function with useActionState was called outside of a transition. This is likely not what you intended (for example, isPending will not update correctly). Either call the returned function inside startTransition, or pass it to an `action` or `formAction` prop.")) : Ws(e, n, r);
    }
    function Ws(e, n, r) {
      n.status = "fulfilled", n.value = r, Bt(n), e.state = r, (n = e.pending) !== null && ((r = n.next) === n ? e.pending = null : (r = r.next, n.next = r, jd(e, r)));
    }
    function $a(e, n, r) {
      var l = e.pending;
      if (e.pending = null, l !== null) {
        l = l.next;
        do
          n.status = "rejected", n.reason = r, Bt(n), n = n.next;
        while (n !== l);
      }
      e.action = null;
    }
    function Bt(e) {
      e = e.listeners;
      for (var n = 0; n < e.length; n++) (0, e[n])();
    }
    function qs(e, n) {
      return n;
    }
    function wi(e, n) {
      if (Tn) {
        var r = Kn.formState;
        if (r !== null) {
          e: {
            var l = Ye;
            if (Tn) {
              if (Et) {
                n: {
                  for (var i = Et, s = Zl; i.nodeType !== 8; ) {
                    if (!s) {
                      i = null;
                      break n;
                    }
                    if ((i = lr(i.nextSibling)) === null) {
                      i = null;
                      break n;
                    }
                  }
                  i = (s = i.data) === ov || s === sk ? i : null;
                }
                if (i) {
                  Et = lr(i.nextSibling), l = i.data === ov;
                  break e;
                }
              }
              Pl(l);
            }
            l = !1;
          }
          l && (n = r[0]);
        }
      }
      return (r = ut()).memoizedState = r.baseState = n, l = { pending: null, lanes: 0, dispatch: null, lastRenderedReducer: qs, lastRenderedState: n }, r.queue = l, r = Lu.bind(null, Ye, l), l.dispatch = r, l = ki(!1), s = Gd.bind(null, Ye, !1, l.queue), i = { state: n, dispatch: null, action: e, pending: null }, (l = ut()).queue = i, r = dm.bind(null, Ye, i, s, r), i.dispatch = r, l.memoizedState = e, [n, r, !1];
    }
    function Hd(e) {
      return Cg(Sn(), et, e);
    }
    function Cg(e, n, r) {
      if (n = Ga(e, n, qs)[0], e = bn(Yn)[0], typeof n == "object" && n !== null && typeof n.then == "function") try {
        var l = Au(n);
      } catch (f) {
        throw f === Dh ? gy : f;
      }
      else l = n;
      var i = (n = Sn()).queue, s = i.dispatch;
      return r !== n.memoizedState && (Ye.flags |= 2048, Dl(Da | Yt, { destroy: void 0, resource: void 0 }, tb.bind(null, i, r), null)), [l, s, e];
    }
    function tb(e, n) {
      e.action = n;
    }
    function st(e) {
      var n = Sn(), r = et;
      if (r !== null) return Cg(n, r, e);
      Sn(), n = n.memoizedState;
      var l = (r = Sn()).queue.dispatch;
      return r.memoizedState = e, [n, l, !1];
    }
    function Dl(e, n, r, l) {
      return e = { tag: e, create: r, deps: l, inst: n, next: null }, (n = Ye.updateQueue) === null && (n = { lastEffect: null, events: null, stores: null, memoCache: null }, Ye.updateQueue = n), (r = n.lastEffect) === null ? n.lastEffect = e.next = e : (l = r.next, r.next = e, e.next = l, n.lastEffect = e), e;
    }
    function Si(e) {
      return e = { current: e }, ut().memoizedState = e;
    }
    function To(e, n, r, l) {
      var i = ut();
      l = l === void 0 ? null : l, Ye.flags |= e, i.memoizedState = Dl(Da | n, { destroy: void 0, resource: void 0 }, r, l);
    }
    function er(e, n, r, l) {
      var i = Sn();
      l = l === void 0 ? null : l;
      var s = i.memoizedState.inst;
      et !== null && l !== null && Ll(l, et.memoizedState.deps) ? i.memoizedState = Dl(n, s, r, l) : (Ye.flags |= e, i.memoizedState = Dl(Da | n, s, r, l));
    }
    function ra(e, n) {
      (Ye.mode & fl) !== Jn && (Ye.mode & Gv) === Jn ? To(276826112, Yt, e, n) : To(8390656, Yt, e, n);
    }
    function Za(e, n) {
      var r = 4194308;
      return (Ye.mode & fl) !== Jn && (r |= 134217728), To(r, wr, e, n);
    }
    function fm(e, n) {
      if (typeof n == "function") {
        e = e();
        var r = n(e);
        return function() {
          typeof r == "function" ? r() : n(null);
        };
      }
      if (n != null) return n.hasOwnProperty("current") || console.error("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(n).join(", ") + "}"), e = e(), n.current = e, function() {
        n.current = null;
      };
    }
    function Ud(e, n, r) {
      typeof n != "function" && console.error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", n !== null ? typeof n : "null"), r = r != null ? r.concat([e]) : null;
      var l = 4194308;
      (Ye.mode & fl) !== Jn && (l |= 134217728), To(l, wr, fm.bind(null, n, e), r);
    }
    function Ja(e, n, r) {
      typeof n != "function" && console.error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", n !== null ? typeof n : "null"), r = r != null ? r.concat([e]) : null, er(4, wr, fm.bind(null, n, e), r);
    }
    function Qs(e, n) {
      return ut().memoizedState = [e, n === void 0 ? null : n], e;
    }
    function Ei(e, n) {
      var r = Sn();
      n = n === void 0 ? null : n;
      var l = r.memoizedState;
      return n !== null && Ll(n, l[1]) ? l[0] : (r.memoizedState = [e, n], e);
    }
    function Bd(e, n) {
      var r = ut();
      n = n === void 0 ? null : n;
      var l = e();
      if (Xc) {
        Ce(!0);
        try {
          e();
        } finally {
          Ce(!1);
        }
      }
      return r.memoizedState = [l, n], l;
    }
    function Fl(e, n) {
      var r = Sn();
      n = n === void 0 ? null : n;
      var l = r.memoizedState;
      if (n !== null && Ll(n, l[1])) return l[0];
      if (l = e(), Xc) {
        Ce(!0);
        try {
          e();
        } finally {
          Ce(!1);
        }
      }
      return r.memoizedState = [l, n], l;
    }
    function Vd(e, n) {
      return qd(ut(), e, n);
    }
    function Ys(e, n) {
      return Gs(Sn(), et.memoizedState, e, n);
    }
    function Wd(e, n) {
      var r = Sn();
      return et === null ? qd(r, e, n) : Gs(r, et.memoizedState, e, n);
    }
    function qd(e, n, r) {
      return r === void 0 || 1073741824 & os ? e.memoizedState = n : (e.memoizedState = r, e = mf(), Ye.lanes |= e, is |= e, r);
    }
    function Gs(e, n, r, l) {
      return Zr(r, n) ? r : gp.current !== null ? (e = qd(e, r, l), Zr(e, n) || (sr = !0), e) : 42 & os ? (e = mf(), Ye.lanes |= e, is |= e, n) : (sr = !0, e.memoizedState = r);
    }
    function pm(e, n, r, l, i) {
      var s = Fe.p;
      Fe.p = s !== 0 && s < vr ? s : vr;
      var f, p, y, v = J.T, z = {};
      J.T = z, Gd(e, !1, n, r), z._updatedFibers = /* @__PURE__ */ new Set();
      try {
        var j = i(), F = J.S;
        if (F !== null && F(z, j), j !== null && typeof j == "object" && typeof j.then == "function") {
          var te = (f = l, p = [], y = { status: "pending", value: null, reason: null, then: function(Q) {
            p.push(Q);
          } }, j.then(function() {
            y.status = "fulfilled", y.value = f;
            for (var Q = 0; Q < p.length; Q++) (0, p[Q])(f);
          }, function(Q) {
            for (y.status = "rejected", y.reason = Q, Q = 0; Q < p.length; Q++) (0, p[Q])(void 0);
          }), y);
          el(e, n, te, _r(e));
        } else el(e, n, l, _r(e));
      } catch (Q) {
        el(e, n, { then: function() {
        }, status: "rejected", reason: Q }, _r(e));
      } finally {
        Fe.p = s, J.T = v, v === null && z._updatedFibers && (e = z._updatedFibers.size, z._updatedFibers.clear(), 10 < e && console.warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."));
      }
    }
    function xi(e, n, r, l) {
      if (e.tag !== 5) throw Error("Expected the form instance to be a HostComponent. This is a bug in React.");
      var i = mm(e).queue;
      pm(e, i, n, id, r === null ? U : function() {
        return hm(e), r(l);
      });
    }
    function mm(e) {
      var n = e.memoizedState;
      if (n !== null) return n;
      var r = {};
      return (n = { memoizedState: id, baseState: id, baseQueue: null, queue: { pending: null, lanes: 0, dispatch: null, lastRenderedReducer: Yn, lastRenderedState: id }, next: null }).next = { memoizedState: r, baseState: r, baseQueue: null, queue: { pending: null, lanes: 0, dispatch: null, lastRenderedReducer: Yn, lastRenderedState: r }, next: null }, e.memoizedState = n, (e = e.alternate) !== null && (e.memoizedState = n), n;
    }
    function hm(e) {
      J.T === null && console.error("requestFormReset was called outside a transition or action. To fix, move to an action, or wrap with startTransition."), el(e, mm(e).next.queue, {}, _r(e));
    }
    function oa() {
      var e = ki(!1);
      return e = pm.bind(null, Ye, e.queue, !0, !1), ut().memoizedState = e, [!1, e];
    }
    function Qd() {
      var e = bn(Yn)[0], n = Sn().memoizedState;
      return [typeof e == "boolean" ? e : Au(e), n];
    }
    function Yd() {
      var e = Ar(Yn)[0], n = Sn().memoizedState;
      return [typeof e == "boolean" ? e : Au(e), n];
    }
    function Nr() {
      return qn(ng);
    }
    function aa() {
      var e = ut(), n = Kn.identifierPrefix;
      if (Tn) {
        var r = tu;
        n = "«" + n + "R" + (r = ($l & ~(1 << 32 - St($l) - 1)).toString(32) + r), 0 < (r = ky++) && (n += "H" + r.toString(32)), n += "»";
      } else n = "«" + n + "r" + (r = c1++).toString(32) + "»";
      return e.memoizedState = n;
    }
    function Ci() {
      return ut().memoizedState = gm.bind(null, Ye);
    }
    function gm(e, n) {
      for (var r = e.return; r !== null; ) {
        switch (r.tag) {
          case 24:
          case 3:
            var l = _r(r), i = xo(r, e = $o(l), l);
            return i !== null && (dt(i, r, l), Ol(i, r, l)), r = Fs(), n != null && i !== null && console.error("The seed argument is not enabled outside experimental channels."), void (e.payload = { cache: r });
        }
        r = r.return;
      }
    }
    function ym(e, n, r) {
      var l = arguments;
      typeof l[3] == "function" && console.error("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var i = { lane: l = _r(e), revertLane: 0, action: r, hasEagerState: !1, eagerState: null, next: null };
      Ks(e) ? Ti(n, i) : (i = Ns(e, n, i, l)) !== null && (dt(i, e, l), Xs(i, n, l)), Xt(e, l);
    }
    function Lu(e, n, r) {
      var l = arguments;
      typeof l[3] == "function" && console.error("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect()."), el(e, n, r, l = _r(e)), Xt(e, l);
    }
    function el(e, n, r, l) {
      var i = { lane: l, revertLane: 0, action: r, hasEagerState: !1, eagerState: null, next: null };
      if (Ks(e)) Ti(n, i);
      else {
        var s = e.alternate;
        if (e.lanes === 0 && (s === null || s.lanes === 0) && (s = n.lastRenderedReducer) !== null) {
          var f = J.H;
          J.H = ml;
          try {
            var p = n.lastRenderedState, y = s(p, r);
            if (i.hasEagerState = !0, i.eagerState = y, Zr(y, p)) return Rd(e, n, i, 0), Kn === null && Pd(), !1;
          } catch {
          } finally {
            J.H = f;
          }
        }
        if ((r = Ns(e, n, i, l)) !== null) return dt(r, e, l), Xs(r, n, l), !0;
      }
      return !1;
    }
    function Gd(e, n, r, l) {
      if (J.T === null && Yc === 0 && console.error("An optimistic state update occurred outside a transition or action. To fix, move the update to an action, or wrap with startTransition."), l = { lane: 2, revertLane: lt(), action: l, hasEagerState: !1, eagerState: null, next: null }, Ks(e)) {
        if (n) throw Error("Cannot update optimistic state while rendering.");
        console.error("Cannot call startTransition while rendering.");
      } else (n = Ns(e, r, l, 2)) !== null && dt(n, e, 2);
      Xt(e, 2);
    }
    function Ks(e) {
      var n = e.alternate;
      return e === Ye || n !== null && n === Ye;
    }
    function Ti(e, n) {
      yp = vy = !0;
      var r = e.pending;
      r === null ? n.next = n : (n.next = r.next, r.next = n), e.pending = n;
    }
    function Xs(e, n, r) {
      if (4194048 & r) {
        var l = n.lanes;
        r |= l &= e.pendingLanes, n.lanes = r, vs(e, r);
      }
    }
    function Ot(e) {
      var n = un;
      return e != null && (un = n === null ? e : n.concat(e)), n;
    }
    function zu(e, n, r) {
      for (var l = Object.keys(e.props), i = 0; i < l.length; i++) {
        var s = l[i];
        if (s !== "children" && s !== "key") {
          n === null && ((n = Ls(e, r.mode, 0))._debugInfo = un, n.return = r), De(n, function(f) {
            console.error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", f);
          }, s);
          break;
        }
      }
    }
    function Du(e) {
      var n = jh;
      return jh += 1, bp === null && (bp = { didWarnAboutUncachedPromise: !1, thenables: [] }), lo(bp, e, n);
    }
    function co(e, n) {
      n = n.props.ref, e.ref = n !== void 0 ? n : null;
    }
    function Je(e, n) {
      throw n.$$typeof === mh ? Error(`A React Element from an older version of React was rendered. This is not supported. It can happen if:
- Multiple copies of the "react" package is used.
- A library pre-bundled an old copy of "react" or "react/jsx-runtime".
- A compiler tries to "inline" JSX instead of using the runtime.`) : (e = Object.prototype.toString.call(n), Error("Objects are not valid as a React child (found: " + (e === "[object Object]" ? "object with keys {" + Object.keys(n).join(", ") + "}" : e) + "). If you meant to render a collection of children, use an array instead."));
    }
    function In(e, n) {
      var r = Ee(e) || "Component";
      T0[r] || (T0[r] = !0, n = n.displayName || n.name || "Component", e.tag === 3 ? console.error(`Functions are not valid as a React child. This may happen if you return %s instead of <%s /> from render. Or maybe you meant to call this function rather than return it.
  root.render(%s)`, n, n, n) : console.error(`Functions are not valid as a React child. This may happen if you return %s instead of <%s /> from render. Or maybe you meant to call this function rather than return it.
  <%s>{%s}</%s>`, n, n, r, n, r));
    }
    function rt(e, n) {
      var r = Ee(e) || "Component";
      P0[r] || (P0[r] = !0, n = String(n), e.tag === 3 ? console.error(`Symbols are not valid as a React child.
  root.render(%s)`, n) : console.error(`Symbols are not valid as a React child.
  <%s>%s</%s>`, r, n, r));
    }
    function $s(e) {
      function n(T, P) {
        if (e) {
          var D = T.deletions;
          D === null ? (T.deletions = [P], T.flags |= 16) : D.push(P);
        }
      }
      function r(T, P) {
        if (!e) return null;
        for (; P !== null; ) n(T, P), P = P.sibling;
        return null;
      }
      function l(T) {
        for (var P = /* @__PURE__ */ new Map(); T !== null; ) T.key !== null ? P.set(T.key, T) : P.set(T.index, T), T = T.sibling;
        return P;
      }
      function i(T, P) {
        return (T = Qo(T, P)).index = 0, T.sibling = null, T;
      }
      function s(T, P, D) {
        return T.index = D, e ? (D = T.alternate) !== null ? (D = D.index) < P ? (T.flags |= 67108866, P) : D : (T.flags |= 67108866, P) : (T.flags |= 1048576, P);
      }
      function f(T) {
        return e && T.alternate === null && (T.flags |= 67108866), T;
      }
      function p(T, P, D, X) {
        return P === null || P.tag !== 6 ? ((P = Cl(D, T.mode, X)).return = T, P._debugOwner = T, P._debugTask = T._debugTask, P._debugInfo = un, P) : ((P = i(P, D)).return = T, P._debugInfo = un, P);
      }
      function y(T, P, D, X) {
        var ve = D.type;
        return ve === Ku ? (zu(D, P = z(T, P, D.props.children, X, D.key), T), P) : P !== null && (P.elementType === ve || kg(P, D) || typeof ve == "object" && ve !== null && ve.$$typeof === Ft && as(ve) === P.type) ? (co(P = i(P, D.props), D), P.return = T, P._debugOwner = D._owner, P._debugInfo = un, P) : (co(P = Ls(D, T.mode, X), D), P.return = T, P._debugInfo = un, P);
      }
      function v(T, P, D, X) {
        return P === null || P.tag !== 4 || P.stateNode.containerInfo !== D.containerInfo || P.stateNode.implementation !== D.implementation ? ((P = nm(D, T.mode, X)).return = T, P._debugInfo = un, P) : ((P = i(P, D.children || [])).return = T, P._debugInfo = un, P);
      }
      function z(T, P, D, X, ve) {
        return P === null || P.tag !== 7 ? ((P = xl(D, T.mode, X, ve)).return = T, P._debugOwner = T, P._debugTask = T._debugTask, P._debugInfo = un, P) : ((P = i(P, D)).return = T, P._debugInfo = un, P);
      }
      function j(T, P, D) {
        if (typeof P == "string" && P !== "" || typeof P == "number" || typeof P == "bigint") return (P = Cl("" + P, T.mode, D)).return = T, P._debugOwner = T, P._debugTask = T._debugTask, P._debugInfo = un, P;
        if (typeof P == "object" && P !== null) {
          switch (P.$$typeof) {
            case Sa:
              return co(D = Ls(P, T.mode, D), P), D.return = T, T = Ot(P._debugInfo), D._debugInfo = un, un = T, D;
            case Ea:
              return (P = nm(P, T.mode, D)).return = T, P._debugInfo = un, P;
            case Ft:
              var X = Ot(P._debugInfo);
              return T = j(T, P = as(P), D), un = X, T;
          }
          if (It(P) || ke(P)) return (D = xl(P, T.mode, D, null)).return = T, D._debugOwner = T, D._debugTask = T._debugTask, T = Ot(P._debugInfo), D._debugInfo = un, un = T, D;
          if (typeof P.then == "function") return X = Ot(P._debugInfo), T = j(T, Du(P), D), un = X, T;
          if (P.$$typeof === mo) return j(T, Fd(T, P), D);
          Je(T, P);
        }
        return typeof P == "function" && In(T, P), typeof P == "symbol" && rt(T, P), null;
      }
      function F(T, P, D, X) {
        var ve = P !== null ? P.key : null;
        if (typeof D == "string" && D !== "" || typeof D == "number" || typeof D == "bigint") return ve !== null ? null : p(T, P, "" + D, X);
        if (typeof D == "object" && D !== null) {
          switch (D.$$typeof) {
            case Sa:
              return D.key === ve ? (ve = Ot(D._debugInfo), T = y(T, P, D, X), un = ve, T) : null;
            case Ea:
              return D.key === ve ? v(T, P, D, X) : null;
            case Ft:
              return ve = Ot(D._debugInfo), T = F(T, P, D = as(D), X), un = ve, T;
          }
          if (It(D) || ke(D)) return ve !== null ? null : (ve = Ot(D._debugInfo), T = z(T, P, D, X, null), un = ve, T);
          if (typeof D.then == "function") return ve = Ot(D._debugInfo), T = F(T, P, Du(D), X), un = ve, T;
          if (D.$$typeof === mo) return F(T, P, Fd(T, D), X);
          Je(T, D);
        }
        return typeof D == "function" && In(T, D), typeof D == "symbol" && rt(T, D), null;
      }
      function te(T, P, D, X, ve) {
        if (typeof X == "string" && X !== "" || typeof X == "number" || typeof X == "bigint") return p(P, T = T.get(D) || null, "" + X, ve);
        if (typeof X == "object" && X !== null) {
          switch (X.$$typeof) {
            case Sa:
              return D = T.get(X.key === null ? D : X.key) || null, T = Ot(X._debugInfo), P = y(P, D, X, ve), un = T, P;
            case Ea:
              return v(P, T = T.get(X.key === null ? D : X.key) || null, X, ve);
            case Ft:
              var pn = Ot(X._debugInfo);
              return P = te(T, P, D, X = as(X), ve), un = pn, P;
          }
          if (It(X) || ke(X)) return D = T.get(D) || null, T = Ot(X._debugInfo), P = z(P, D, X, ve, null), un = T, P;
          if (typeof X.then == "function") return pn = Ot(X._debugInfo), P = te(T, P, D, Du(X), ve), un = pn, P;
          if (X.$$typeof === mo) return te(T, P, D, Fd(P, X), ve);
          Je(P, X);
        }
        return typeof X == "function" && In(P, X), typeof X == "symbol" && rt(P, X), null;
      }
      function Q(T, P, D, X) {
        if (typeof D != "object" || D === null) return X;
        switch (D.$$typeof) {
          case Sa:
          case Ea:
            H(T, P, D);
            var ve = D.key;
            if (typeof ve != "string") break;
            if (X === null) {
              (X = /* @__PURE__ */ new Set()).add(ve);
              break;
            }
            if (!X.has(ve)) {
              X.add(ve);
              break;
            }
            De(P, function() {
              console.error("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.", ve);
            });
            break;
          case Ft:
            Q(T, P, D = as(D), X);
        }
        return X;
      }
      function ge(T, P, D, X) {
        if (typeof D == "object" && D !== null && D.type === Ku && D.key === null && (zu(D, null, T), D = D.props.children), typeof D == "object" && D !== null) {
          switch (D.$$typeof) {
            case Sa:
              var ve = Ot(D._debugInfo);
              e: {
                for (var pn = D.key; P !== null; ) {
                  if (P.key === pn) {
                    if ((pn = D.type) === Ku) {
                      if (P.tag === 7) {
                        r(T, P.sibling), (X = i(P, D.props.children)).return = T, X._debugOwner = D._owner, X._debugInfo = un, zu(D, X, T), T = X;
                        break e;
                      }
                    } else if (P.elementType === pn || kg(P, D) || typeof pn == "object" && pn !== null && pn.$$typeof === Ft && as(pn) === P.type) {
                      r(T, P.sibling), co(X = i(P, D.props), D), X.return = T, X._debugOwner = D._owner, X._debugInfo = un, T = X;
                      break e;
                    }
                    r(T, P);
                    break;
                  }
                  n(T, P), P = P.sibling;
                }
                D.type === Ku ? ((X = xl(D.props.children, T.mode, X, D.key)).return = T, X._debugOwner = T, X._debugTask = T._debugTask, X._debugInfo = un, zu(D, X, T), T = X) : (co(X = Ls(D, T.mode, X), D), X.return = T, X._debugInfo = un, T = X);
              }
              return T = f(T), un = ve, T;
            case Ea:
              e: {
                for (D = (ve = D).key; P !== null; ) {
                  if (P.key === D) {
                    if (P.tag === 4 && P.stateNode.containerInfo === ve.containerInfo && P.stateNode.implementation === ve.implementation) {
                      r(T, P.sibling), (X = i(P, ve.children || [])).return = T, T = X;
                      break e;
                    }
                    r(T, P);
                    break;
                  }
                  n(T, P), P = P.sibling;
                }
                (X = nm(ve, T.mode, X)).return = T, T = X;
              }
              return f(T);
            case Ft:
              return ve = Ot(D._debugInfo), T = ge(T, P, D = as(D), X), un = ve, T;
          }
          if (It(D)) return ve = Ot(D._debugInfo), T = function(je, We, sn, On) {
            for (var dr = null, Ht = null, Xe = null, nn = We, $e = We = 0, bt = null; nn !== null && $e < sn.length; $e++) {
              nn.index > $e ? (bt = nn, nn = null) : bt = nn.sibling;
              var nt = F(je, nn, sn[$e], On);
              if (nt === null) {
                nn === null && (nn = bt);
                break;
              }
              dr = Q(je, nt, sn[$e], dr), e && nn && nt.alternate === null && n(je, nn), We = s(nt, We, $e), Xe === null ? Ht = nt : Xe.sibling = nt, Xe = nt, nn = bt;
            }
            if ($e === sn.length) return r(je, nn), Tn && Tl(je, $e), Ht;
            if (nn === null) {
              for (; $e < sn.length; $e++) (nn = j(je, sn[$e], On)) !== null && (dr = Q(je, nn, sn[$e], dr), We = s(nn, We, $e), Xe === null ? Ht = nn : Xe.sibling = nn, Xe = nn);
              return Tn && Tl(je, $e), Ht;
            }
            for (nn = l(nn); $e < sn.length; $e++) (bt = te(nn, je, $e, sn[$e], On)) !== null && (dr = Q(je, bt, sn[$e], dr), e && bt.alternate !== null && nn.delete(bt.key === null ? $e : bt.key), We = s(bt, We, $e), Xe === null ? Ht = bt : Xe.sibling = bt, Xe = bt);
            return e && nn.forEach(function(ro) {
              return n(je, ro);
            }), Tn && Tl(je, $e), Ht;
          }(T, P, D, X), un = ve, T;
          if (ke(D)) {
            if (ve = Ot(D._debugInfo), typeof (pn = ke(D)) != "function") throw Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
            var kn = pn.call(D);
            return kn === D ? T.tag === 0 && Object.prototype.toString.call(T.type) === "[object GeneratorFunction]" && Object.prototype.toString.call(kn) === "[object Generator]" || (x0 || console.error("Using Iterators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. You can also use an Iterable that can iterate multiple times over the same items."), x0 = !0) : D.entries !== pn || Ob || (console.error("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), Ob = !0), T = function(je, We, sn, On) {
              if (sn == null) throw Error("An iterable object provided no iterator.");
              for (var dr = null, Ht = null, Xe = We, nn = We = 0, $e = null, bt = null, nt = sn.next(); Xe !== null && !nt.done; nn++, nt = sn.next()) {
                Xe.index > nn ? ($e = Xe, Xe = null) : $e = Xe.sibling;
                var ro = F(je, Xe, nt.value, On);
                if (ro === null) {
                  Xe === null && (Xe = $e);
                  break;
                }
                bt = Q(je, ro, nt.value, bt), e && Xe && ro.alternate === null && n(je, Xe), We = s(ro, We, nn), Ht === null ? dr = ro : Ht.sibling = ro, Ht = ro, Xe = $e;
              }
              if (nt.done) return r(je, Xe), Tn && Tl(je, nn), dr;
              if (Xe === null) {
                for (; !nt.done; nn++, nt = sn.next()) (Xe = j(je, nt.value, On)) !== null && (bt = Q(je, Xe, nt.value, bt), We = s(Xe, We, nn), Ht === null ? dr = Xe : Ht.sibling = Xe, Ht = Xe);
                return Tn && Tl(je, nn), dr;
              }
              for (Xe = l(Xe); !nt.done; nn++, nt = sn.next()) ($e = te(Xe, je, nn, nt.value, On)) !== null && (bt = Q(je, $e, nt.value, bt), e && $e.alternate !== null && Xe.delete($e.key === null ? nn : $e.key), We = s($e, We, nn), Ht === null ? dr = $e : Ht.sibling = $e, Ht = $e);
              return e && Xe.forEach(function(F1) {
                return n(je, F1);
              }), Tn && Tl(je, nn), dr;
            }(T, P, kn, X), un = ve, T;
          }
          if (typeof D.then == "function") return ve = Ot(D._debugInfo), T = ge(T, P, Du(D), X), un = ve, T;
          if (D.$$typeof === mo) return ge(T, P, Fd(T, D), X);
          Je(T, D);
        }
        return typeof D == "string" && D !== "" || typeof D == "number" || typeof D == "bigint" ? (ve = "" + D, P !== null && P.tag === 6 ? (r(T, P.sibling), (X = i(P, ve)).return = T, T = X) : (r(T, P), (X = Cl(ve, T.mode, X)).return = T, X._debugOwner = T, X._debugTask = T._debugTask, X._debugInfo = un, T = X), f(T)) : (typeof D == "function" && In(T, D), typeof D == "symbol" && rt(T, D), r(T, P));
      }
      return function(T, P, D, X) {
        var ve = un;
        un = null;
        try {
          jh = 0;
          var pn = ge(T, P, D, X);
          return bp = null, pn;
        } catch (sn) {
          if (sn === Dh || sn === gy) throw sn;
          var kn = Y(29, sn, null, T.mode);
          kn.lanes = X, kn.return = T;
          var je = kn._debugInfo = un;
          if (kn._debugOwner = T._debugOwner, kn._debugTask = T._debugTask, je != null) {
            for (var We = je.length - 1; 0 <= We; We--) if (typeof je[We].stack == "string") {
              kn._debugOwner = je[We], kn._debugTask = je[We].debugTask;
              break;
            }
          }
          return kn;
        } finally {
          un = ve;
        }
      };
    }
    function Vr(e) {
      var n = e.alternate;
      Oe(Gt, Gt.current & kp, e), Oe(Ia, e, e), lu === null && (n === null || gp.current !== null || n.memoizedState !== null) && (lu = e);
    }
    function Il(e) {
      if (e.tag === 22) {
        if (Oe(Gt, Gt.current, e), Oe(Ia, e, e), lu === null) {
          var n = e.alternate;
          n !== null && n.memoizedState !== null && (lu = e);
        }
      } else Po(e);
    }
    function Po(e) {
      Oe(Gt, Gt.current, e), Oe(Ia, Ia.current, e);
    }
    function Wr(e) {
      Ue(Ia, e), lu === e && (lu = null), Ue(Gt, e);
    }
    function nl(e) {
      for (var n = e; n !== null; ) {
        if (n.tag === 13) {
          var r = n.memoizedState;
          if (r !== null && ((r = r.dehydrated) === null || r.data === su || Ul(r))) return n;
        } else if (n.tag === 19 && n.memoizedProps.revealOrder !== void 0) {
          if (128 & n.flags) return n;
        } else if (n.child !== null) {
          n.child.return = n, n = n.child;
          continue;
        }
        if (n === e) break;
        for (; n.sibling === null; ) {
          if (n.return === null || n.return === e) return null;
          n = n.return;
        }
        n.sibling.return = n.return, n = n.sibling;
      }
      return null;
    }
    function bm(e) {
      if (e !== null && typeof e != "function") {
        var n = String(e);
        j0.has(n) || (j0.add(n), console.error("Expected the last optional `callback` argument to be a function. Instead received: %s.", e));
      }
    }
    function ot(e, n, r, l) {
      var i = e.memoizedState, s = r(l, i);
      if (e.mode & Dr) {
        Ce(!0);
        try {
          s = r(l, i);
        } finally {
          Ce(!1);
        }
      }
      s === void 0 && (n = Se(n) || "Component", D0.has(n) || (D0.add(n), console.error("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", n))), i = s == null ? i : en({}, i, s), e.memoizedState = i, e.lanes === 0 && (e.updateQueue.baseState = i);
    }
    function Kd(e, n, r, l, i, s, f) {
      var p = e.stateNode;
      if (typeof p.shouldComponentUpdate == "function") {
        if (r = p.shouldComponentUpdate(l, s, f), e.mode & Dr) {
          Ce(!0);
          try {
            r = p.shouldComponentUpdate(l, s, f);
          } finally {
            Ce(!1);
          }
        }
        return r === void 0 && console.error("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", Se(n) || "Component"), r;
      }
      return !n.prototype || !n.prototype.isPureReactComponent || !qa(r, l) || !qa(i, s);
    }
    function Xd(e, n, r, l) {
      var i = n.state;
      typeof n.componentWillReceiveProps == "function" && n.componentWillReceiveProps(r, l), typeof n.UNSAFE_componentWillReceiveProps == "function" && n.UNSAFE_componentWillReceiveProps(r, l), n.state !== i && (e = Ee(e) || "Component", N0.has(e) || (N0.add(e), console.error("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", e)), Db.enqueueReplaceState(n, n.state, null));
    }
    function Ml(e, n) {
      var r = n;
      if ("ref" in n) for (var l in r = {}, n) l !== "ref" && (r[l] = n[l]);
      if (e = e.defaultProps) for (var i in r === n && (r = en({}, r)), e) r[i] === void 0 && (r[i] = e[i]);
      return r;
    }
    function vm(e) {
      Fb(e), console.warn(`%s

%s
`, wp ? "An error occurred in the <" + wp + "> component." : "An error occurred in one of your React components.", `Consider adding an error boundary to your tree to customize error handling behavior.
Visit https://react.dev/link/error-boundaries to learn more about error boundaries.`);
    }
    function Tg(e) {
      var n = wp ? "The above error occurred in the <" + wp + "> component." : "The above error occurred in one of your React components.", r = "React will try to recreate this component tree from scratch using the error boundary you provided, " + (Ib || "Anonymous") + ".";
      if (typeof e == "object" && e !== null && typeof e.environmentName == "string") {
        var l = e.environmentName;
        typeof (e = [`%o

%s

%s
`, e, n, r].slice(0))[0] == "string" ? e.splice(0, 1, Tk + e[0], Pk, Hy + l + Hy, Rk) : e.splice(0, 0, Tk, Pk, Hy + l + Hy, Rk), e.unshift(console), (l = z1.apply(console.error, e))();
      } else console.error(`%o

%s

%s
`, e, n, r);
    }
    function $d(e) {
      Fb(e);
    }
    function Fu(e, n) {
      try {
        wp = n.source ? Ee(n.source) : null, Ib = null;
        var r = n.value;
        J.actQueue !== null ? J.thrownErrors.push(r) : (0, e.onUncaughtError)(r, { componentStack: n.stack });
      } catch (l) {
        setTimeout(function() {
          throw l;
        });
      }
    }
    function Zd(e, n, r) {
      try {
        wp = r.source ? Ee(r.source) : null, Ib = Ee(n), (0, e.onCaughtError)(r.value, { componentStack: r.stack, errorBoundary: n.tag === 1 ? n.stateNode : null });
      } catch (l) {
        setTimeout(function() {
          throw l;
        });
      }
    }
    function nr(e, n, r) {
      return (r = $o(r)).tag = Tb, r.payload = { element: null }, r.callback = function() {
        De(n.source, Fu, e, n);
      }, r;
    }
    function ct(e) {
      return (e = $o(e)).tag = Tb, e;
    }
    function Pi(e, n, r, l) {
      var i = r.type.getDerivedStateFromError;
      if (typeof i == "function") {
        var s = l.value;
        e.payload = function() {
          return i(s);
        }, e.callback = function() {
          wg(r), De(l.source, Zd, n, r, l);
        };
      }
      var f = r.stateNode;
      f !== null && typeof f.componentDidCatch == "function" && (e.callback = function() {
        wg(r), De(l.source, Zd, n, r, l), typeof i != "function" && (ss === null ? ss = /* @__PURE__ */ new Set([this]) : ss.add(this)), f1(this, l), typeof i == "function" || !(2 & r.lanes) && console.error("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", Ee(r) || "Unknown");
      });
    }
    function wt(e, n, r, l) {
      n.child = e === null ? R0(n, null, r, l) : vp(n, e.child, r, l);
    }
    function Jd(e, n, r, l, i) {
      r = r.render;
      var s = n.ref;
      if ("ref" in l) {
        var f = {};
        for (var p in l) p !== "ref" && (f[p] = l[p]);
      } else f = l;
      return Al(n), Qe(n), l = zl(e, n, r, f, s, i), p = Rr(), _e(), e === null || sr ? (Tn && p && vu(n), n.flags |= 1, wt(e, n, l, i), n.child) : (Qa(e, n, i), ia(e, n, i));
    }
    function la(e, n, r, l, i) {
      if (e === null) {
        var s = r.type;
        return typeof s != "function" || Jp(s) || s.defaultProps !== void 0 || r.compare !== null ? ((e = Nd(r.type, null, l, n, n.mode, i)).ref = n.ref, e.return = n, n.child = e) : (r = bu(s), n.tag = 15, n.type = r, rf(n, s), Zs(e, n, r, l, i));
      }
      if (s = e.child, !cf(e, i)) {
        var f = s.memoizedProps;
        if ((r = (r = r.compare) !== null ? r : qa)(f, l) && e.ref === n.ref) return ia(e, n, i);
      }
      return n.flags |= 1, (e = Qo(s, l)).ref = n.ref, e.return = n, n.child = e;
    }
    function Zs(e, n, r, l, i) {
      if (e !== null) {
        var s = e.memoizedProps;
        if (qa(s, l) && e.ref === n.ref && n.type === e.type) {
          if (sr = !1, n.pendingProps = l = s, !cf(e, i)) return n.lanes = e.lanes, ia(e, n, i);
          131072 & e.flags && (sr = !0);
        }
      }
      return tf(e, n, r, l, i);
    }
    function ef(e, n, r) {
      var l = n.pendingProps, i = l.children, s = e !== null ? e.memoizedState : null;
      if (l.mode === "hidden") {
        if (128 & n.flags) {
          if (l = s !== null ? s.baseLanes | r : r, e !== null) {
            for (i = n.child = e.child, s = 0; i !== null; ) s = s | i.lanes | i.childLanes, i = i.sibling;
            n.childLanes = s & ~l;
          } else n.childLanes = 0, n.child = null;
          return nf(e, n, l, r);
        }
        if (!(536870912 & r)) return n.lanes = n.childLanes = 536870912, nf(e, n, s !== null ? s.baseLanes | r : r, r);
        n.memoizedState = { baseLanes: 0, cachePool: null }, e !== null && Md(n, s !== null ? s.cachePool : null), s !== null ? Pr(n, s) : Hs(n), Il(n);
      } else s !== null ? (Md(n, s.cachePool), Pr(n, s), Po(n), n.memoizedState = null) : (e !== null && Md(n, null), Hs(n), Po(n));
      return wt(e, n, i, r), n.child;
    }
    function nf(e, n, r, l) {
      var i = om();
      return i = i === null ? null : { parent: Qt._currentValue, pool: i }, n.memoizedState = { baseLanes: r, cachePool: i }, e !== null && Md(n, null), Hs(n), Il(n), e !== null && Su(e, n, l, !0), null;
    }
    function Js(e, n) {
      var r = n.ref;
      if (r === null) e !== null && e.ref !== null && (n.flags |= 4194816);
      else {
        if (typeof r != "function" && typeof r != "object") throw Error("Expected ref to be a function, an object returned by React.createRef(), or undefined/null.");
        e !== null && e.ref === r || (n.flags |= 4194816);
      }
    }
    function tf(e, n, r, l, i) {
      if (r.prototype && typeof r.prototype.render == "function") {
        var s = Se(r) || "Unknown";
        U0[s] || (console.error("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", s, s), U0[s] = !0);
      }
      return n.mode & Dr && pl.recordLegacyContextWarning(n, null), e === null && (rf(n, n.type), r.contextTypes && (s = Se(r) || "Unknown", V0[s] || (V0[s] = !0, console.error("%s uses the legacy contextTypes API which was removed in React 19. Use React.createContext() with React.useContext() instead. (https://react.dev/link/legacy-context)", s)))), Al(n), Qe(n), r = zl(e, n, r, l, void 0, i), l = Rr(), _e(), e === null || sr ? (Tn && l && vu(n), n.flags |= 1, wt(e, n, r, i), n.child) : (Qa(e, n, i), ia(e, n, i));
    }
    function km(e, n, r, l, i, s) {
      return Al(n), Qe(n), au = -1, Mh = e !== null && e.type !== n.type, n.updateQueue = null, r = Ru(n, l, r, i), Us(e, n), l = Rr(), _e(), e === null || sr ? (Tn && l && vu(n), n.flags |= 1, wt(e, n, r, s), n.child) : (Qa(e, n, s), ia(e, n, s));
    }
    function wm(e, n, r, l, i) {
      switch (Z(n)) {
        case !1:
          var s = n.stateNode, f = new n.type(n.memoizedProps, s.context).state;
          s.updater.enqueueSetState(s, f, null);
          break;
        case !0:
          n.flags |= 128, n.flags |= 65536, s = Error("Simulated error coming from DevTools");
          var p = i & -i;
          if (n.lanes |= p, (f = Kn) === null) throw Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
          Pi(p = ct(p), f, n, Ur(s, n)), xu(n, p);
      }
      if (Al(n), n.stateNode === null) {
        if (f = ts, s = r.contextType, "contextType" in r && s !== null && (s === void 0 || s.$$typeof !== mo) && !M0.has(r) && (M0.add(r), p = s === void 0 ? " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof s != "object" ? " However, it is set to a " + typeof s + "." : s.$$typeof === Xu ? " Did you accidentally pass the Context.Consumer instead?" : " However, it is set to an object with keys {" + Object.keys(s).join(", ") + "}.", console.error("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", Se(r) || "Component", p)), typeof s == "object" && s !== null && (f = qn(s)), s = new r(l, f), n.mode & Dr) {
          Ce(!0);
          try {
            s = new r(l, f);
          } finally {
            Ce(!1);
          }
        }
        if (f = n.memoizedState = s.state !== null && s.state !== void 0 ? s.state : null, s.updater = Db, n.stateNode = s, s._reactInternals = n, s._reactInternalInstance = A0, typeof r.getDerivedStateFromProps == "function" && f === null && (f = Se(r) || "Component", _0.has(f) || (_0.add(f), console.error("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", f, s.state === null ? "null" : "undefined", f))), typeof r.getDerivedStateFromProps == "function" || typeof s.getSnapshotBeforeUpdate == "function") {
          var y = p = f = null;
          if (typeof s.componentWillMount == "function" && s.componentWillMount.__suppressDeprecationWarning !== !0 ? f = "componentWillMount" : typeof s.UNSAFE_componentWillMount == "function" && (f = "UNSAFE_componentWillMount"), typeof s.componentWillReceiveProps == "function" && s.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? p = "componentWillReceiveProps" : typeof s.UNSAFE_componentWillReceiveProps == "function" && (p = "UNSAFE_componentWillReceiveProps"), typeof s.componentWillUpdate == "function" && s.componentWillUpdate.__suppressDeprecationWarning !== !0 ? y = "componentWillUpdate" : typeof s.UNSAFE_componentWillUpdate == "function" && (y = "UNSAFE_componentWillUpdate"), f !== null || p !== null || y !== null) {
            s = Se(r) || "Component";
            var v = typeof r.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            L0.has(s) || (L0.add(s), console.error(`Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://react.dev/link/unsafe-component-lifecycles`, s, v, f !== null ? `
  ` + f : "", p !== null ? `
  ` + p : "", y !== null ? `
  ` + y : ""));
          }
        }
        s = n.stateNode, f = Se(r) || "Component", s.render || (r.prototype && typeof r.prototype.render == "function" ? console.error("No `render` method found on the %s instance: did you accidentally return an object from the constructor?", f) : console.error("No `render` method found on the %s instance: you may have forgotten to define `render`.", f)), !s.getInitialState || s.getInitialState.isReactClassApproved || s.state || console.error("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", f), s.getDefaultProps && !s.getDefaultProps.isReactClassApproved && console.error("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", f), s.contextType && console.error("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", f), r.childContextTypes && !I0.has(r) && (I0.add(r), console.error("%s uses the legacy childContextTypes API which was removed in React 19. Use React.createContext() instead. (https://react.dev/link/legacy-context)", f)), r.contextTypes && !F0.has(r) && (F0.add(r), console.error("%s uses the legacy contextTypes API which was removed in React 19. Use React.createContext() with static contextType instead. (https://react.dev/link/legacy-context)", f)), typeof s.componentShouldUpdate == "function" && console.error("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", f), r.prototype && r.prototype.isPureReactComponent && s.shouldComponentUpdate !== void 0 && console.error("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", Se(r) || "A pure component"), typeof s.componentDidUnmount == "function" && console.error("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", f), typeof s.componentDidReceiveProps == "function" && console.error("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", f), typeof s.componentWillRecieveProps == "function" && console.error("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", f), typeof s.UNSAFE_componentWillRecieveProps == "function" && console.error("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", f), p = s.props !== l, s.props !== void 0 && p && console.error("When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", f), s.defaultProps && console.error("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", f, f), typeof s.getSnapshotBeforeUpdate != "function" || typeof s.componentDidUpdate == "function" || O0.has(r) || (O0.add(r), console.error("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", Se(r))), typeof s.getDerivedStateFromProps == "function" && console.error("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", f), typeof s.getDerivedStateFromError == "function" && console.error("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", f), typeof r.getSnapshotBeforeUpdate == "function" && console.error("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", f), (p = s.state) && (typeof p != "object" || It(p)) && console.error("%s.state: must be set to an object or null", f), typeof s.getChildContext == "function" && typeof r.childContextTypes != "object" && console.error("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", f), (s = n.stateNode).props = l, s.state = n.memoizedState, s.refs = {}, Tr(n), f = r.contextType, s.context = typeof f == "object" && f !== null ? qn(f) : ts, s.state === l && (f = Se(r) || "Component", z0.has(f) || (z0.add(f), console.error("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", f))), n.mode & Dr && pl.recordLegacyContextWarning(n, s), pl.recordUnsafeLifecycleWarnings(n, s), s.state = n.memoizedState, typeof (f = r.getDerivedStateFromProps) == "function" && (ot(n, r, f, l), s.state = n.memoizedState), typeof r.getDerivedStateFromProps == "function" || typeof s.getSnapshotBeforeUpdate == "function" || typeof s.UNSAFE_componentWillMount != "function" && typeof s.componentWillMount != "function" || (f = s.state, typeof s.componentWillMount == "function" && s.componentWillMount(), typeof s.UNSAFE_componentWillMount == "function" && s.UNSAFE_componentWillMount(), f !== s.state && (console.error("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", Ee(n) || "Component"), Db.enqueueReplaceState(s, s.state, null)), Cu(n, l, s, i), Zo(), s.state = n.memoizedState), typeof s.componentDidMount == "function" && (n.flags |= 4194308), (n.mode & fl) !== Jn && (n.flags |= 134217728), s = !0;
      } else if (e === null) {
        s = n.stateNode;
        var z = n.memoizedProps;
        p = Ml(r, z), s.props = p;
        var j = s.context;
        y = r.contextType, f = ts, typeof y == "object" && y !== null && (f = qn(y)), y = typeof (v = r.getDerivedStateFromProps) == "function" || typeof s.getSnapshotBeforeUpdate == "function", z = n.pendingProps !== z, y || typeof s.UNSAFE_componentWillReceiveProps != "function" && typeof s.componentWillReceiveProps != "function" || (z || j !== f) && Xd(n, s, l, f), rs = !1;
        var F = n.memoizedState;
        s.state = F, Cu(n, l, s, i), Zo(), j = n.memoizedState, z || F !== j || rs ? (typeof v == "function" && (ot(n, r, v, l), j = n.memoizedState), (p = rs || Kd(n, r, p, l, F, j, f)) ? (y || typeof s.UNSAFE_componentWillMount != "function" && typeof s.componentWillMount != "function" || (typeof s.componentWillMount == "function" && s.componentWillMount(), typeof s.UNSAFE_componentWillMount == "function" && s.UNSAFE_componentWillMount()), typeof s.componentDidMount == "function" && (n.flags |= 4194308), (n.mode & fl) !== Jn && (n.flags |= 134217728)) : (typeof s.componentDidMount == "function" && (n.flags |= 4194308), (n.mode & fl) !== Jn && (n.flags |= 134217728), n.memoizedProps = l, n.memoizedState = j), s.props = l, s.state = j, s.context = f, s = p) : (typeof s.componentDidMount == "function" && (n.flags |= 4194308), (n.mode & fl) !== Jn && (n.flags |= 134217728), s = !1);
      } else {
        s = n.stateNode, _l(e, n), y = Ml(r, f = n.memoizedProps), s.props = y, v = n.pendingProps, F = s.context, j = r.contextType, p = ts, typeof j == "object" && j !== null && (p = qn(j)), (j = typeof (z = r.getDerivedStateFromProps) == "function" || typeof s.getSnapshotBeforeUpdate == "function") || typeof s.UNSAFE_componentWillReceiveProps != "function" && typeof s.componentWillReceiveProps != "function" || (f !== v || F !== p) && Xd(n, s, l, p), rs = !1, F = n.memoizedState, s.state = F, Cu(n, l, s, i), Zo();
        var te = n.memoizedState;
        f !== v || F !== te || rs || e !== null && e.dependencies !== null && Ds(e.dependencies) ? (typeof z == "function" && (ot(n, r, z, l), te = n.memoizedState), (y = rs || Kd(n, r, y, l, F, te, p) || e !== null && e.dependencies !== null && Ds(e.dependencies)) ? (j || typeof s.UNSAFE_componentWillUpdate != "function" && typeof s.componentWillUpdate != "function" || (typeof s.componentWillUpdate == "function" && s.componentWillUpdate(l, te, p), typeof s.UNSAFE_componentWillUpdate == "function" && s.UNSAFE_componentWillUpdate(l, te, p)), typeof s.componentDidUpdate == "function" && (n.flags |= 4), typeof s.getSnapshotBeforeUpdate == "function" && (n.flags |= 1024)) : (typeof s.componentDidUpdate != "function" || f === e.memoizedProps && F === e.memoizedState || (n.flags |= 4), typeof s.getSnapshotBeforeUpdate != "function" || f === e.memoizedProps && F === e.memoizedState || (n.flags |= 1024), n.memoizedProps = l, n.memoizedState = te), s.props = l, s.state = te, s.context = p, s = y) : (typeof s.componentDidUpdate != "function" || f === e.memoizedProps && F === e.memoizedState || (n.flags |= 4), typeof s.getSnapshotBeforeUpdate != "function" || f === e.memoizedProps && F === e.memoizedState || (n.flags |= 1024), s = !1);
      }
      if (p = s, Js(e, n), f = !!(128 & n.flags), p || f) {
        if (p = n.stateNode, Ip(n), f && typeof r.getDerivedStateFromError != "function") r = null, ho = -1;
        else {
          if (Qe(n), r = m0(p), n.mode & Dr) {
            Ce(!0);
            try {
              m0(p);
            } finally {
              Ce(!1);
            }
          }
          _e();
        }
        n.flags |= 1, e !== null && f ? (n.child = vp(n, e.child, null, i), n.child = vp(n, null, r, i)) : wt(e, n, r, i), n.memoizedState = p.state, e = n.child;
      } else e = ia(e, n, i);
      return i = n.stateNode, s && i.props !== l && (Sp || console.error("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", Ee(n) || "a component"), Sp = !0), e;
    }
    function Sm(e, n, r, l) {
      return wu(), n.flags |= 256, wt(e, n, r, l), n.child;
    }
    function rf(e, n) {
      n && n.childContextTypes && console.error(`childContextTypes cannot be defined on a function component.
  %s.childContextTypes = ...`, n.displayName || n.name || "Component"), typeof n.getDerivedStateFromProps == "function" && (e = Se(n) || "Unknown", W0[e] || (console.error("%s: Function components do not support getDerivedStateFromProps.", e), W0[e] = !0)), typeof n.contextType == "object" && n.contextType !== null && (n = Se(n) || "Unknown", B0[n] || (console.error("%s: Function components do not support contextType.", n), B0[n] = !0));
    }
    function ec(e) {
      return { baseLanes: e, cachePool: am() };
    }
    function of(e, n, r) {
      return e = e !== null ? e.childLanes & ~r : 0, n && (e |= Ho), e;
    }
    function Pg(e, n, r) {
      var l, i = n.pendingProps;
      W(n) && (n.flags |= 128);
      var s = !1, f = !!(128 & n.flags);
      if ((l = f) || (l = (e === null || e.memoizedState !== null) && (Gt.current & Hh) !== 0), l && (s = !0, n.flags &= -129), l = !!(32 & n.flags), n.flags &= -33, e === null) {
        if (Tn) {
          if (s ? Vr(n) : Po(n), Tn) {
            var p, y = Et;
            if (!(p = !y)) {
              e: {
                var v = y;
                for (p = Zl; v.nodeType !== 8; ) {
                  if (!p) {
                    p = null;
                    break e;
                  }
                  if ((v = lr(v.nextSibling)) === null) {
                    p = null;
                    break e;
                  }
                }
                p = v;
              }
              p !== null ? (gi(), n.memoizedState = { dehydrated: p, treeContext: Wc !== null ? { id: $l, overflow: tu } : null, retryLane: 536870912, hydrationErrors: null }, (v = Y(18, null, null, Jn)).stateNode = p, v.return = n, n.child = v, Jr = n, Et = null, p = !0) : p = !1, p = !p;
            }
            p && (_d(n, y), Pl(n));
          }
          if ((y = n.memoizedState) !== null && (y = y.dehydrated) !== null) return Ul(y) ? n.lanes = 32 : n.lanes = 536870912, null;
          Wr(n);
        }
        return y = i.children, i = i.fallback, s ? (Po(n), y = nc({ mode: "hidden", children: y }, s = n.mode), i = xl(i, s, r, null), y.return = n, i.return = n, y.sibling = i, n.child = y, (s = n.child).memoizedState = ec(r), s.childLanes = of(e, l, r), n.memoizedState = jb, i) : (Vr(n), af(n, y));
      }
      var z = e.memoizedState;
      if (z !== null && (y = z.dehydrated) !== null) {
        if (f) 256 & n.flags ? (Vr(n), n.flags &= -257, n = lf(e, n, r)) : n.memoizedState !== null ? (Po(n), n.child = e.child, n.flags |= 128, n = null) : (Po(n), s = i.fallback, y = n.mode, i = nc({ mode: "visible", children: i.children }, y), (s = xl(s, y, r, null)).flags |= 2, i.return = n, s.return = n, i.sibling = s, n.child = i, vp(n, e.child, null, r), (i = n.child).memoizedState = ec(r), i.childLanes = of(e, l, r), n.memoizedState = jb, n = s);
        else if (Vr(n), Tn && console.error("We should not be hydrating here. This is a bug in React. Please file a bug."), Ul(y)) {
          if (l = y.nextSibling && y.nextSibling.dataset) {
            p = l.dgst;
            var j = l.msg;
            v = l.stck;
            var F = l.cstck;
          }
          l = p, i = v, p = s = F, (s = (y = j) ? Error(y) : Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.")).stack = i || "", s.digest = l, i = { value: s, source: null, stack: l = p === void 0 ? null : p }, typeof l == "string" && vb.set(s, i), zs(i), n = lf(e, n, r);
        } else if (sr || Su(e, n, r, !1), l = (r & e.childLanes) !== 0, sr || l) {
          if ((l = Kn) !== null && (i = ((i = 42 & (i = r & -r) ? 1 : du(i)) & (l.suspendedLanes | r)) !== 0 ? 0 : i) !== 0 && i !== z.retryLane) throw z.retryLane = i, Cr(e, i), dt(l, e, i), H0;
          y.data === su || dc(), n = lf(e, n, r);
        } else y.data === su ? (n.flags |= 192, n.child = e.child, n = null) : (e = z.treeContext, Et = lr(y.nextSibling), Jr = n, Tn = !0, qc = null, ru = !1, La = null, Zl = !1, e !== null && (gi(), _a[Oa++] = $l, _a[Oa++] = tu, _a[Oa++] = Wc, $l = e.id, tu = e.overflow, Wc = n), (n = af(n, i.children)).flags |= 4096);
        return n;
      }
      return s ? (Po(n), s = i.fallback, y = n.mode, v = (p = e.child).sibling, (i = Qo(p, { mode: "hidden", children: i.children })).subtreeFlags = 65011712 & p.subtreeFlags, v !== null ? s = Qo(v, s) : (s = xl(s, y, r, null)).flags |= 2, s.return = n, i.return = n, i.sibling = s, n.child = i, i = s, s = n.child, (y = e.child.memoizedState) === null ? y = ec(r) : ((p = y.cachePool) !== null ? (v = Qt._currentValue, p = p.parent !== v ? { parent: v, pool: v } : p) : p = am(), y = { baseLanes: y.baseLanes | r, cachePool: p }), s.memoizedState = y, s.childLanes = of(e, l, r), n.memoizedState = jb, i) : (Vr(n), e = (r = e.child).sibling, (r = Qo(r, { mode: "visible", children: i.children })).return = n, r.sibling = null, e !== null && ((l = n.deletions) === null ? (n.deletions = [e], n.flags |= 16) : l.push(e)), n.child = r, n.memoizedState = null, r);
    }
    function af(e, n) {
      return (n = nc({ mode: "visible", children: n }, e.mode)).return = e, e.child = n;
    }
    function nc(e, n) {
      return (e = Y(22, e, null, n)).lanes = 0, e.stateNode = { _visibility: uy, _pendingMarkers: null, _retryCache: null, _transitions: null }, e;
    }
    function lf(e, n, r) {
      return vp(n, e.child, null, r), (e = af(n, n.pendingProps.children)).flags |= 2, n.memoizedState = null, e;
    }
    function uf(e, n, r) {
      e.lanes |= n;
      var l = e.alternate;
      l !== null && (l.lanes |= n), yi(e.return, n, r);
    }
    function Em(e, n) {
      var r = It(e);
      return e = !r && typeof ke(e) == "function", !r && !e || (r = r ? "array" : "iterable", console.error("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", r, n, r), !1);
    }
    function sf(e, n, r, l, i) {
      var s = e.memoizedState;
      s === null ? e.memoizedState = { isBackwards: n, rendering: null, renderingStartTime: 0, last: l, tail: r, tailMode: i } : (s.isBackwards = n, s.rendering = null, s.renderingStartTime = 0, s.last = l, s.tail = r, s.tailMode = i);
    }
    function xm(e, n, r) {
      var l = n.pendingProps, i = l.revealOrder, s = l.tail;
      if (l = l.children, i !== void 0 && i !== "forwards" && i !== "backwards" && i !== "together" && !q0[i]) if (q0[i] = !0, typeof i == "string") switch (i.toLowerCase()) {
        case "together":
        case "forwards":
        case "backwards":
          console.error('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', i, i.toLowerCase());
          break;
        case "forward":
        case "backward":
          console.error('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', i, i.toLowerCase());
          break;
        default:
          console.error('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', i);
      }
      else console.error('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', i);
      s === void 0 || Mb[s] || (s !== "collapsed" && s !== "hidden" ? (Mb[s] = !0, console.error('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', s)) : i !== "forwards" && i !== "backwards" && (Mb[s] = !0, console.error('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', s)));
      e: if ((i === "forwards" || i === "backwards") && l != null && l !== !1) if (It(l)) {
        for (var f = 0; f < l.length; f++) if (!Em(l[f], f)) break e;
      } else if (f = ke(l), typeof f == "function") {
        if (f = f.call(l)) for (var p = f.next(), y = 0; !p.done; p = f.next()) {
          if (!Em(p.value, y)) break e;
          y++;
        }
      } else console.error('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', i);
      if (wt(e, n, l, r), ((l = Gt.current) & Hh) !== 0) l = l & kp | Hh, n.flags |= 128;
      else {
        if (e !== null && 128 & e.flags) e: for (e = n.child; e !== null; ) {
          if (e.tag === 13) e.memoizedState !== null && uf(e, r, n);
          else if (e.tag === 19) uf(e, r, n);
          else if (e.child !== null) {
            e.child.return = e, e = e.child;
            continue;
          }
          if (e === n) break e;
          for (; e.sibling === null; ) {
            if (e.return === null || e.return === n) break e;
            e = e.return;
          }
          e.sibling.return = e.return, e = e.sibling;
        }
        l &= kp;
      }
      switch (Oe(Gt, l, n), i) {
        case "forwards":
          for (r = n.child, i = null; r !== null; ) (e = r.alternate) !== null && nl(e) === null && (i = r), r = r.sibling;
          (r = i) === null ? (i = n.child, n.child = null) : (i = r.sibling, r.sibling = null), sf(n, !1, i, r, s);
          break;
        case "backwards":
          for (r = null, i = n.child, n.child = null; i !== null; ) {
            if ((e = i.alternate) !== null && nl(e) === null) {
              n.child = i;
              break;
            }
            e = i.sibling, i.sibling = r, r = i, i = e;
          }
          sf(n, !0, r, null, s);
          break;
        case "together":
          sf(n, !1, null, null, void 0);
          break;
        default:
          n.memoizedState = null;
      }
      return n.child;
    }
    function ia(e, n, r) {
      if (e !== null && (n.dependencies = e.dependencies), ho = -1, is |= n.lanes, (r & n.childLanes) === 0 && (e === null || (Su(e, n, r, !1), (r & n.childLanes) === 0)))
        return null;
      if (e !== null && n.child !== e.child) throw Error("Resuming work not yet implemented.");
      if (n.child !== null) {
        for (r = Qo(e = n.child, e.pendingProps), n.child = r, r.return = n; e.sibling !== null; ) e = e.sibling, (r = r.sibling = Qo(e, e.pendingProps)).return = n;
        r.sibling = null;
      }
      return n.child;
    }
    function cf(e, n) {
      return (e.lanes & n) !== 0 || !((e = e.dependencies) === null || !Ds(e));
    }
    function Cm(e, n, r) {
      if (n._debugNeedsRemount && e !== null) {
        (r = Nd(n.type, n.key, n.pendingProps, n._debugOwner || null, n.mode, n.lanes))._debugStack = n._debugStack, r._debugTask = n._debugTask;
        var l = n.return;
        if (l === null) throw Error("Cannot swap the root fiber.");
        if (e.alternate = null, n.alternate = null, r.index = n.index, r.sibling = n.sibling, r.return = n.return, r.ref = n.ref, r._debugInfo = n._debugInfo, n === l.child) l.child = r;
        else {
          var i = l.child;
          if (i === null) throw Error("Expected parent to have a child.");
          for (; i.sibling !== n; ) if ((i = i.sibling) === null) throw Error("Expected to find the previous sibling.");
          i.sibling = r;
        }
        return (n = l.deletions) === null ? (l.deletions = [e], l.flags |= 16) : n.push(e), r.flags |= 2, r;
      }
      if (e !== null) if (e.memoizedProps !== n.pendingProps || n.type !== e.type) sr = !0;
      else {
        if (!(cf(e, r) || 128 & n.flags)) return sr = !1, function(p, y, v) {
          switch (y.tag) {
            case 3:
              yn(y, y.stateNode.containerInfo), Rl(y, Qt, p.memoizedState.cache), wu();
              break;
            case 27:
            case 5:
              S(y);
              break;
            case 4:
              yn(y, y.stateNode.containerInfo);
              break;
            case 10:
              Rl(y, y.type, y.memoizedProps.value);
              break;
            case 12:
              (v & y.childLanes) !== 0 && (y.flags |= 4), y.flags |= 2048;
              var z = y.stateNode;
              z.effectDuration = -0, z.passiveEffectDuration = -0;
              break;
            case 13:
              if ((z = y.memoizedState) !== null) return z.dehydrated !== null ? (Vr(y), y.flags |= 128, null) : (v & y.child.childLanes) !== 0 ? Pg(p, y, v) : (Vr(y), (p = ia(p, y, v)) !== null ? p.sibling : null);
              Vr(y);
              break;
            case 19:
              var j = !!(128 & p.flags);
              if ((z = (v & y.childLanes) !== 0) || (Su(p, y, v, !1), z = (v & y.childLanes) !== 0), j) {
                if (z) return xm(p, y, v);
                y.flags |= 128;
              }
              if ((j = y.memoizedState) !== null && (j.rendering = null, j.tail = null, j.lastEffect = null), Oe(Gt, Gt.current, y), z) break;
              return null;
            case 22:
            case 23:
              return y.lanes = 0, ef(p, y, v);
            case 24:
              Rl(y, Qt, p.memoizedState.cache);
          }
          return ia(p, y, v);
        }(e, n, r);
        sr = !!(131072 & e.flags);
      }
      else sr = !1, (l = Tn) && (gi(), l = !!(1048576 & n.flags)), l && (l = n.index, gi(), tm(n, cy, l));
      switch (n.lanes = 0, n.tag) {
        case 16:
          e: {
            if (l = n.pendingProps, e = as(n.elementType), n.type = e, typeof e != "function") {
              if (e != null) {
                if ((i = e.$$typeof) === $u) {
                  n.tag = 11, n.type = e = Zp(e), n = Jd(null, n, e, l, r);
                  break e;
                }
                if (i === Zi) {
                  n.tag = 14, n = la(null, n, e, l, r);
                  break e;
                }
              }
              throw n = "", e !== null && typeof e == "object" && e.$$typeof === Ft && (n = " Did you wrap a component in React.lazy() more than once?"), e = Se(e) || e, Error("Element type is invalid. Received a promise that resolves to: " + e + ". Lazy element type must resolve to a class or function." + n);
            }
            Jp(e) ? (l = Ml(e, l), n.tag = 1, n.type = e = bu(e), n = wm(null, n, e, l, r)) : (n.tag = 0, rf(n, e), n.type = e = bu(e), n = tf(null, n, e, l, r));
          }
          return n;
        case 0:
          return tf(e, n, n.type, n.pendingProps, r);
        case 1:
          return wm(e, n, l = n.type, i = Ml(l, n.pendingProps), r);
        case 3:
          e: {
            if (yn(n, n.stateNode.containerInfo), e === null) throw Error("Should have a current fiber. This is a bug in React.");
            l = n.pendingProps;
            var s = n.memoizedState;
            i = s.element, _l(e, n), Cu(n, l, null, r);
            var f = n.memoizedState;
            if (l = f.cache, Rl(n, Qt, l), l !== s.cache && Dd(n, [Qt], r, !0), Zo(), l = f.element, s.isDehydrated) {
              if (s = { element: l, isDehydrated: !1, cache: f.cache }, n.updateQueue.baseState = s, n.memoizedState = s, 256 & n.flags) {
                n = Sm(e, n, l, r);
                break e;
              }
              if (l !== i) {
                zs(i = Ur(Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), n)), n = Sm(e, n, l, r);
                break e;
              }
              for ((e = n.stateNode.containerInfo).nodeType === 9 ? e = e.body : e = e.nodeName === "HTML" ? e.ownerDocument.body : e, Et = lr(e.firstChild), Jr = n, Tn = !0, qc = null, ru = !1, La = null, Zl = !0, e = R0(n, null, l, r), n.child = e; e; ) e.flags = -3 & e.flags | 4096, e = e.sibling;
            } else {
              if (wu(), l === i) {
                n = ia(e, n, r);
                break e;
              }
              wt(e, n, l, r);
            }
            n = n.child;
          }
          return n;
        case 26:
          return Js(e, n), e === null ? (e = Df(n.type, null, n.pendingProps, null)) ? n.memoizedState = e : Tn || (e = n.type, r = n.pendingProps, (l = gc(l = mn(ul.current)).createElement(e))[Mt] = n, l[ir] = r, zt(l, e, r), V(l), n.stateNode = l) : n.memoizedState = Df(n.type, e.memoizedProps, n.pendingProps, e.memoizedState), null;
        case 27:
          return S(n), e === null && Tn && (l = mn(ul.current), i = Ae(), l = n.stateNode = Dt(n.type, n.pendingProps, l, i, !1), ru || (i = hc(l, n.type, n.pendingProps, i)) !== null && (Yo(n, 0).serverProps = i), Jr = n, Zl = !0, i = Et, yr(n.type) ? (uv = i, Et = lr(l.firstChild)) : Et = i), wt(e, n, n.pendingProps.children, r), Js(e, n), e === null && (n.flags |= 4194304), n.child;
        case 5:
          return e === null && Tn && (s = Ae(), l = kd(n.type, s.ancestorInfo), (f = !(i = Et)) || ((f = function(p, y, v, z) {
            for (; p.nodeType === 1; ) {
              var j = v;
              if (p.nodeName.toLowerCase() !== y.toLowerCase()) {
                if (!z && (p.nodeName !== "INPUT" || p.type !== "hidden")) break;
              } else if (z) {
                if (!p[Oc]) switch (y) {
                  case "meta":
                    if (!p.hasAttribute("itemprop")) break;
                    return p;
                  case "link":
                    if ((F = p.getAttribute("rel")) === "stylesheet" && p.hasAttribute("data-precedence") || F !== j.rel || p.getAttribute("href") !== (j.href == null || j.href === "" ? null : j.href) || p.getAttribute("crossorigin") !== (j.crossOrigin == null ? null : j.crossOrigin) || p.getAttribute("title") !== (j.title == null ? null : j.title)) break;
                    return p;
                  case "style":
                    if (p.hasAttribute("data-precedence")) break;
                    return p;
                  case "script":
                    if (((F = p.getAttribute("src")) !== (j.src == null ? null : j.src) || p.getAttribute("type") !== (j.type == null ? null : j.type) || p.getAttribute("crossorigin") !== (j.crossOrigin == null ? null : j.crossOrigin)) && F && p.hasAttribute("async") && !p.hasAttribute("itemprop")) break;
                    return p;
                  default:
                    return p;
                }
              } else {
                if (y !== "input" || p.type !== "hidden") return p;
                ce(j.name, "name");
                var F = j.name == null ? null : "" + j.name;
                if (j.type === "hidden" && p.getAttribute("name") === F) return p;
              }
              if ((p = lr(p.nextSibling)) === null) break;
            }
            return null;
          }(i, n.type, n.pendingProps, Zl)) !== null ? (n.stateNode = f, ru || (s = hc(f, n.type, n.pendingProps, s)) !== null && (Yo(n, 0).serverProps = s), Jr = n, Et = lr(f.firstChild), Zl = !1, s = !0) : s = !1, f = !s), f && (l && _d(n, i), Pl(n))), S(n), i = n.type, s = n.pendingProps, f = e !== null ? e.memoizedProps : null, l = s.children, Rn(i, s) ? l = null : f !== null && Rn(i, f) && (n.flags |= 32), n.memoizedState !== null && (i = zl(e, n, uo, null, null, r), ng._currentValue = i), Js(e, n), wt(e, n, l, r), n.child;
        case 6:
          return e === null && Tn && (e = n.pendingProps, e = (l = (r = Ae()).ancestorInfo.current) == null || Es(e, l.tag, r.ancestorInfo.implicitRootScope), (l = !(r = Et)) || ((l = function(p, y, v) {
            if (y === "") return null;
            for (; p.nodeType !== 3; )
              if ((p.nodeType !== 1 || p.nodeName !== "INPUT" || p.type !== "hidden") && !v || (p = lr(p.nextSibling)) === null) return null;
            return p;
          }(r, n.pendingProps, Zl)) !== null ? (n.stateNode = l, Jr = n, Et = null, l = !0) : l = !1, l = !l), l && (e && _d(n, r), Pl(n))), null;
        case 13:
          return Pg(e, n, r);
        case 4:
          return yn(n, n.stateNode.containerInfo), l = n.pendingProps, e === null ? n.child = vp(n, null, l, r) : wt(e, n, l, r), n.child;
        case 11:
          return Jd(e, n, n.type, n.pendingProps, r);
        case 7:
          return wt(e, n, n.pendingProps, r), n.child;
        case 8:
          return wt(e, n, n.pendingProps.children, r), n.child;
        case 12:
          return n.flags |= 4, n.flags |= 2048, (l = n.stateNode).effectDuration = -0, l.passiveEffectDuration = -0, wt(e, n, n.pendingProps.children, r), n.child;
        case 10:
          return l = n.type, s = (i = n.pendingProps).value, "value" in i || Q0 || (Q0 = !0, console.error("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?")), Rl(n, l, s), wt(e, n, i.children, r), n.child;
        case 9:
          return i = n.type._context, typeof (l = n.pendingProps.children) != "function" && console.error("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."), Al(n), i = qn(i), Qe(n), l = Lb(l, i, void 0), _e(), n.flags |= 1, wt(e, n, l, r), n.child;
        case 14:
          return la(e, n, n.type, n.pendingProps, r);
        case 15:
          return Zs(e, n, n.type, n.pendingProps, r);
        case 19:
          return xm(e, n, r);
        case 31:
          return l = n.pendingProps, r = n.mode, l = { mode: l.mode, children: l.children }, e === null ? ((e = nc(l, r)).ref = n.ref, n.child = e, e.return = n, n = e) : ((e = Qo(e.child, l)).ref = n.ref, n.child = e, e.return = n, n = e), n;
        case 22:
          return ef(e, n, r);
        case 24:
          return Al(n), l = qn(Qt), e === null ? ((i = om()) === null && (i = Kn, s = Fs(), i.pooledCache = s, wo(s), s !== null && (i.pooledCacheLanes |= r), i = s), n.memoizedState = { parent: l, cache: i }, Tr(n), Rl(n, Qt, i)) : ((e.lanes & r) !== 0 && (_l(e, n), Cu(n, null, null, r), Zo()), i = e.memoizedState, s = n.memoizedState, i.parent !== l ? (i = { parent: l, cache: l }, n.memoizedState = i, n.lanes === 0 && (n.memoizedState = n.updateQueue.baseState = i), Rl(n, Qt, l)) : (l = s.cache, Rl(n, Qt, l), l !== i.cache && Dd(n, [Qt], r, !0))), wt(e, n, n.pendingProps.children, r), n.child;
        case 29:
          throw n.pendingProps;
      }
      throw Error("Unknown unit of work tag (" + n.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function ua(e) {
      e.flags |= 4;
    }
    function Ri(e, n) {
      if (n.type !== "stylesheet" || (n.state.loading & Ma) !== ld) e.flags &= -16777217;
      else if (e.flags |= 16777216, !Ki(n)) {
        if ((n = Ia.current) !== null && ((4194048 & vn) === vn ? lu !== null : (62914560 & vn) !== vn && !(536870912 & vn) || n !== lu)) throw Fh = Cb, t0;
        e.flags |= 8192;
      }
    }
    function tc(e, n) {
      n !== null && (e.flags |= 4), 16384 & e.flags && (n = e.tag !== 22 ? yl() : 536870912, e.lanes |= n, ed |= n);
    }
    function jl(e, n) {
      if (!Tn) switch (e.tailMode) {
        case "hidden":
          n = e.tail;
          for (var r = null; n !== null; ) n.alternate !== null && (r = n), n = n.sibling;
          r === null ? e.tail = null : r.sibling = null;
          break;
        case "collapsed":
          r = e.tail;
          for (var l = null; r !== null; ) r.alternate !== null && (l = r), r = r.sibling;
          l === null ? n || e.tail === null ? e.tail = null : e.tail.sibling = null : l.sibling = null;
      }
    }
    function Un(e) {
      var n = e.alternate !== null && e.alternate.child === e.child, r = 0, l = 0;
      if (n) if ((e.mode & kr) !== Jn) {
        for (var i = e.selfBaseDuration, s = e.child; s !== null; ) r |= s.lanes | s.childLanes, l |= 65011712 & s.subtreeFlags, l |= 65011712 & s.flags, i += s.treeBaseDuration, s = s.sibling;
        e.treeBaseDuration = i;
      } else for (i = e.child; i !== null; ) r |= i.lanes | i.childLanes, l |= 65011712 & i.subtreeFlags, l |= 65011712 & i.flags, i.return = e, i = i.sibling;
      else if ((e.mode & kr) !== Jn) {
        i = e.actualDuration, s = e.selfBaseDuration;
        for (var f = e.child; f !== null; ) r |= f.lanes | f.childLanes, l |= f.subtreeFlags, l |= f.flags, i += f.actualDuration, s += f.treeBaseDuration, f = f.sibling;
        e.actualDuration = i, e.treeBaseDuration = s;
      } else for (i = e.child; i !== null; ) r |= i.lanes | i.childLanes, l |= i.subtreeFlags, l |= i.flags, i.return = e, i = i.sibling;
      return e.subtreeFlags |= l, e.childLanes = r, n;
    }
    function Rg(e, n, r) {
      var l = n.pendingProps;
      switch (hi(n), n.tag) {
        case 31:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
        case 1:
          return Un(n), null;
        case 3:
          return r = n.stateNode, l = null, e !== null && (l = e.memoizedState.cache), n.memoizedState.cache !== l && (n.flags |= 2048), mt(Qt, n), jn(n), r.pendingContext && (r.context = r.pendingContext, r.pendingContext = null), e !== null && e.child !== null || (ku(n) ? (Sg(), ua(n)) : e === null || e.memoizedState.isDehydrated && !(256 & n.flags) || (n.flags |= 1024, rm())), Un(n), null;
        case 26:
          return r = n.memoizedState, e === null ? (ua(n), r !== null ? (Un(n), Ri(n, r)) : (Un(n), n.flags &= -16777217)) : r ? r !== e.memoizedState ? (ua(n), Un(n), Ri(n, r)) : (Un(n), n.flags &= -16777217) : (e.memoizedProps !== l && ua(n), Un(n), n.flags &= -16777217), null;
        case 27:
          N(n), r = mn(ul.current);
          var i = n.type;
          if (e !== null && n.stateNode != null) e.memoizedProps !== l && ua(n);
          else {
            if (!l) {
              if (n.stateNode === null) throw Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
              return Un(n), null;
            }
            e = Ae(), ku(n) ? Od(n) : (e = Dt(i, l, r, e, !0), n.stateNode = e, ua(n));
          }
          return Un(n), null;
        case 5:
          if (N(n), r = n.type, e !== null && n.stateNode != null) e.memoizedProps !== l && ua(n);
          else {
            if (!l) {
              if (n.stateNode === null) throw Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
              return Un(n), null;
            }
            if (i = Ae(), ku(n)) Od(n);
            else {
              switch (e = mn(ul.current), kd(r, i.ancestorInfo), i = i.context, e = gc(e), i) {
                case _p:
                  e = e.createElementNS(t, r);
                  break;
                case Iy:
                  e = e.createElementNS(eu, r);
                  break;
                default:
                  switch (r) {
                    case "svg":
                      e = e.createElementNS(t, r);
                      break;
                    case "math":
                      e = e.createElementNS(eu, r);
                      break;
                    case "script":
                      (e = e.createElement("div")).innerHTML = "<script><\/script>", e = e.removeChild(e.firstChild);
                      break;
                    case "select":
                      e = typeof l.is == "string" ? e.createElement("select", { is: l.is }) : e.createElement("select"), l.multiple ? e.multiple = !0 : l.size && (e.size = l.size);
                      break;
                    default:
                      e = typeof l.is == "string" ? e.createElement(r, { is: l.is }) : e.createElement(r), r.indexOf("-") === -1 && (r !== r.toLowerCase() && console.error("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", r), Object.prototype.toString.call(e) !== "[object HTMLUnknownElement]" || zo.call(dk, r) || (dk[r] = !0, console.error("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", r)));
                  }
              }
              e[Mt] = n, e[ir] = l;
              e: for (i = n.child; i !== null; ) {
                if (i.tag === 5 || i.tag === 6) e.appendChild(i.stateNode);
                else if (i.tag !== 4 && i.tag !== 27 && i.child !== null) {
                  i.child.return = i, i = i.child;
                  continue;
                }
                if (i === n) break e;
                for (; i.sibling === null; ) {
                  if (i.return === null || i.return === n) break e;
                  i = i.return;
                }
                i.sibling.return = i.return, i = i.sibling;
              }
              n.stateNode = e;
              e: switch (zt(e, r, l), r) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  e = !!l.autoFocus;
                  break e;
                case "img":
                  e = !0;
                  break e;
                default:
                  e = !1;
              }
              e && ua(n);
            }
          }
          return Un(n), n.flags &= -16777217, null;
        case 6:
          if (e && n.stateNode != null) e.memoizedProps !== l && ua(n);
          else {
            if (typeof l != "string" && n.stateNode === null) throw Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
            if (e = mn(ul.current), r = Ae(), ku(n)) {
              e = n.stateNode, r = n.memoizedProps, i = !ru, l = null;
              var s = Jr;
              if (s !== null) switch (s.tag) {
                case 3:
                  i && (i = _f(e, r, l)) !== null && (Yo(n, 0).serverProps = i);
                  break;
                case 27:
                case 5:
                  l = s.memoizedProps, i && (i = _f(e, r, l)) !== null && (Yo(n, 0).serverProps = i);
              }
              e[Mt] = n, (e = !!(e.nodeValue === r || l !== null && l.suppressHydrationWarning === !0 || ll(e.nodeValue, r))) || Pl(n);
            } else (i = r.ancestorInfo.current) != null && Es(l, i.tag, r.ancestorInfo.implicitRootScope), (e = gc(e).createTextNode(l))[Mt] = n, n.stateNode = e;
          }
          return Un(n), null;
        case 13:
          if (l = n.memoizedState, e === null || e.memoizedState !== null && e.memoizedState.dehydrated !== null) {
            if (i = ku(n), l !== null && l.dehydrated !== null) {
              if (e === null) {
                if (!i) throw Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
                if (!(i = (i = n.memoizedState) !== null ? i.dehydrated : null)) throw Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
                i[Mt] = n, Un(n), (n.mode & kr) !== Jn && l !== null && (i = n.child) !== null && (n.treeBaseDuration -= i.treeBaseDuration);
              } else Sg(), wu(), !(128 & n.flags) && (n.memoizedState = null), n.flags |= 4, Un(n), (n.mode & kr) !== Jn && l !== null && (i = n.child) !== null && (n.treeBaseDuration -= i.treeBaseDuration);
              i = !1;
            } else i = rm(), e !== null && e.memoizedState !== null && (e.memoizedState.hydrationErrors = i), i = !0;
            if (!i) return 256 & n.flags ? (Wr(n), n) : (Wr(n), null);
          }
          return Wr(n), 128 & n.flags ? (n.lanes = r, (n.mode & kr) !== Jn && Ms(n), n) : (r = l !== null, e = e !== null && e.memoizedState !== null, r && (i = null, (l = n.child).alternate !== null && l.alternate.memoizedState !== null && l.alternate.memoizedState.cachePool !== null && (i = l.alternate.memoizedState.cachePool.pool), s = null, l.memoizedState !== null && l.memoizedState.cachePool !== null && (s = l.memoizedState.cachePool.pool), s !== i && (l.flags |= 2048)), r !== e && r && (n.child.flags |= 8192), tc(n, n.updateQueue), Un(n), (n.mode & kr) !== Jn && r && (e = n.child) !== null && (n.treeBaseDuration -= e.treeBaseDuration), null);
        case 4:
          return jn(n), e === null && or(n.stateNode.containerInfo), Un(n), null;
        case 10:
          return mt(n.type, n), Un(n), null;
        case 19:
          if (Ue(Gt, n), (i = n.memoizedState) === null) return Un(n), null;
          if (l = !!(128 & n.flags), (s = i.rendering) === null) if (l) jl(i, !1);
          else {
            if (xt !== uu || e !== null && 128 & e.flags) for (e = n.child; e !== null; ) {
              if ((s = nl(e)) !== null) {
                for (n.flags |= 128, jl(i, !1), e = s.updateQueue, n.updateQueue = e, tc(n, e), n.subtreeFlags = 0, e = r, r = n.child; r !== null; ) em(r, e), r = r.sibling;
                return Oe(Gt, Gt.current & kp | Hh, n), n.child;
              }
              e = e.sibling;
            }
            i.tail !== null && xa() > Cy && (n.flags |= 128, l = !0, jl(i, !1), n.lanes = 4194304);
          }
          else {
            if (!l) if ((e = nl(s)) !== null) {
              if (n.flags |= 128, l = !0, e = e.updateQueue, n.updateQueue = e, tc(n, e), jl(i, !0), i.tail === null && i.tailMode === "hidden" && !s.alternate && !Tn) return Un(n), null;
            } else 2 * xa() - i.renderingStartTime > Cy && r !== 536870912 && (n.flags |= 128, l = !0, jl(i, !1), n.lanes = 4194304);
            i.isBackwards ? (s.sibling = n.child, n.child = s) : ((e = i.last) !== null ? e.sibling = s : n.child = s, i.last = s);
          }
          return i.tail !== null ? (e = i.tail, i.rendering = e, i.tail = e.sibling, i.renderingStartTime = xa(), e.sibling = null, r = Gt.current, Oe(Gt, r = l ? r & kp | Hh : r & kp, n), e) : (Un(n), null);
        case 22:
        case 23:
          return Wr(n), Co(n), l = n.memoizedState !== null, e !== null ? e.memoizedState !== null !== l && (n.flags |= 8192) : l && (n.flags |= 8192), l ? 536870912 & r && !(128 & n.flags) && (Un(n), 6 & n.subtreeFlags && (n.flags |= 8192)) : Un(n), (r = n.updateQueue) !== null && tc(n, r.retryQueue), r = null, e !== null && e.memoizedState !== null && e.memoizedState.cachePool !== null && (r = e.memoizedState.cachePool.pool), l = null, n.memoizedState !== null && n.memoizedState.cachePool !== null && (l = n.memoizedState.cachePool.pool), l !== r && (n.flags |= 2048), e !== null && Ue(mp, n), null;
        case 24:
          return r = null, e !== null && (r = e.memoizedState.cache), n.memoizedState.cache !== r && (n.flags |= 2048), mt(Qt, n), Un(n), null;
        case 25:
        case 30:
          return null;
      }
      throw Error("Unknown unit of work tag (" + n.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function Ag(e, n) {
      switch (hi(n), n.tag) {
        case 1:
          return 65536 & (e = n.flags) ? (n.flags = -65537 & e | 128, (n.mode & kr) !== Jn && Ms(n), n) : null;
        case 3:
          return mt(Qt, n), jn(n), 65536 & (e = n.flags) && !(128 & e) ? (n.flags = -65537 & e | 128, n) : null;
        case 26:
        case 27:
        case 5:
          return N(n), null;
        case 13:
          if (Wr(n), (e = n.memoizedState) !== null && e.dehydrated !== null) {
            if (n.alternate === null) throw Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
            wu();
          }
          return 65536 & (e = n.flags) ? (n.flags = -65537 & e | 128, (n.mode & kr) !== Jn && Ms(n), n) : null;
        case 19:
          return Ue(Gt, n), null;
        case 4:
          return jn(n), null;
        case 10:
          return mt(n.type, n), null;
        case 22:
        case 23:
          return Wr(n), Co(n), e !== null && Ue(mp, n), 65536 & (e = n.flags) ? (n.flags = -65537 & e | 128, (n.mode & kr) !== Jn && Ms(n), n) : null;
        case 24:
          return mt(Qt, n), null;
        default:
          return null;
      }
    }
    function Tm(e, n) {
      switch (hi(n), n.tag) {
        case 3:
          mt(Qt, n), jn(n);
          break;
        case 26:
        case 27:
        case 5:
          N(n);
          break;
        case 4:
          jn(n);
          break;
        case 13:
          Wr(n);
          break;
        case 19:
          Ue(Gt, n);
          break;
        case 10:
          mt(n.type, n);
          break;
        case 22:
        case 23:
          Wr(n), Co(n), e !== null && Ue(mp, n);
          break;
        case 24:
          mt(Qt, n);
      }
    }
    function Ro(e) {
      return (e.mode & kr) !== Jn;
    }
    function Pm(e, n) {
      Ro(e) ? (Eo(), Ai(n, e), So()) : Ai(n, e);
    }
    function df(e, n, r) {
      Ro(e) ? (Eo(), Ni(r, e, n), So()) : Ni(r, e, n);
    }
    function Ai(e, n) {
      try {
        var r = n.updateQueue, l = r !== null ? r.lastEffect : null;
        if (l !== null) {
          var i = l.next;
          r = i;
          do {
            if ((r.tag & e) === e && ((e & Yt) !== za ? Pe !== null && typeof Pe.markComponentPassiveEffectMountStarted == "function" && Pe.markComponentPassiveEffectMountStarted(n) : (e & wr) !== za && Pe !== null && typeof Pe.markComponentLayoutEffectMountStarted == "function" && Pe.markComponentLayoutEffectMountStarted(n), l = void 0, (e & eo) !== za && (Ap = !0), l = De(n, p1, r), (e & eo) !== za && (Ap = !1), (e & Yt) !== za ? Pe !== null && typeof Pe.markComponentPassiveEffectMountStopped == "function" && Pe.markComponentPassiveEffectMountStopped() : (e & wr) !== za && Pe !== null && typeof Pe.markComponentLayoutEffectMountStopped == "function" && Pe.markComponentLayoutEffectMountStopped(), l !== void 0 && typeof l != "function")) {
              var s;
              s = (r.tag & wr) !== 0 ? "useLayoutEffect" : (r.tag & eo) !== 0 ? "useInsertionEffect" : "useEffect", De(n, function(f, p) {
                console.error("%s must not return anything besides a function, which is used for clean-up.%s", f, p);
              }, s, l === null ? " You returned null. If your effect does not require clean up, return undefined (or nothing)." : typeof l.then == "function" ? `

It looks like you wrote ` + s + `(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:

` + s + `(() => {
  async function fetchData() {
    // You can await here
    const response = await MyAPI.getData(someId);
    // ...
  }
  fetchData();
}, [someId]); // Or [] if effect doesn't need props or state

Learn more about data fetching with Hooks: https://react.dev/link/hooks-data-fetching` : " You returned: " + l);
            }
            r = r.next;
          } while (r !== i);
        }
      } catch (f) {
        Pn(n, n.return, f);
      }
    }
    function Ni(e, n, r) {
      try {
        var l = n.updateQueue, i = l !== null ? l.lastEffect : null;
        if (i !== null) {
          var s = i.next;
          l = s;
          do {
            if ((l.tag & e) === e) {
              var f = l.inst, p = f.destroy;
              p !== void 0 && (f.destroy = void 0, (e & Yt) !== za ? Pe !== null && typeof Pe.markComponentPassiveEffectUnmountStarted == "function" && Pe.markComponentPassiveEffectUnmountStarted(n) : (e & wr) !== za && Pe !== null && typeof Pe.markComponentLayoutEffectUnmountStarted == "function" && Pe.markComponentLayoutEffectUnmountStarted(n), (e & eo) !== za && (Ap = !0), De(i = n, m1, i, r, p), (e & eo) !== za && (Ap = !1), (e & Yt) !== za ? Pe !== null && typeof Pe.markComponentPassiveEffectUnmountStopped == "function" && Pe.markComponentPassiveEffectUnmountStopped() : (e & wr) !== za && Pe !== null && typeof Pe.markComponentLayoutEffectUnmountStopped == "function" && Pe.markComponentLayoutEffectUnmountStopped());
            }
            l = l.next;
          } while (l !== s);
        }
      } catch (y) {
        Pn(n, n.return, y);
      }
    }
    function Rm(e, n) {
      Ro(e) ? (Eo(), Ai(n, e), So()) : Ai(n, e);
    }
    function rc(e, n, r) {
      Ro(e) ? (Eo(), Ni(r, e, n), So()) : Ni(r, e, n);
    }
    function Am(e) {
      var n = e.updateQueue;
      if (n !== null) {
        var r = e.stateNode;
        e.type.defaultProps || "ref" in e.memoizedProps || Sp || (r.props !== e.memoizedProps && console.error("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", Ee(e) || "instance"), r.state !== e.memoizedState && console.error("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", Ee(e) || "instance"));
        try {
          De(e, xg, n, r);
        } catch (l) {
          Pn(e, e.return, l);
        }
      }
    }
    function Ng(e, n, r) {
      return e.getSnapshotBeforeUpdate(n, r);
    }
    function rb(e, n) {
      var r = n.memoizedProps, l = n.memoizedState;
      n = e.stateNode, e.type.defaultProps || "ref" in e.memoizedProps || Sp || (n.props !== e.memoizedProps && console.error("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", Ee(e) || "instance"), n.state !== e.memoizedState && console.error("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", Ee(e) || "instance"));
      try {
        var i = Ml(e.type, r, (e.elementType, e.type)), s = De(e, Ng, n, i, l);
        r = Y0, s !== void 0 || r.has(e.type) || (r.add(e.type), De(e, function() {
          console.error("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", Ee(e));
        })), n.__reactInternalSnapshotBeforeUpdate = s;
      } catch (f) {
        Pn(e, e.return, f);
      }
    }
    function ff(e, n, r) {
      r.props = Ml(e.type, e.memoizedProps), r.state = e.memoizedState, Ro(e) ? (Eo(), De(e, k0, e, n, r), So()) : De(e, k0, e, n, r);
    }
    function _g(e) {
      var n = e.ref;
      if (n !== null) {
        switch (e.tag) {
          case 26:
          case 27:
          case 5:
            var r = e.stateNode;
            break;
          default:
            r = e.stateNode;
        }
        if (typeof n == "function") if (Ro(e)) try {
          Eo(), e.refCleanup = n(r);
        } finally {
          So();
        }
        else e.refCleanup = n(r);
        else typeof n == "string" ? console.error("String refs are no longer supported.") : n.hasOwnProperty("current") || console.error("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", Ee(e)), n.current = r;
      }
    }
    function Iu(e, n) {
      try {
        De(e, _g, e);
      } catch (r) {
        Pn(e, n, r);
      }
    }
    function fo(e, n) {
      var r = e.ref, l = e.refCleanup;
      if (r !== null) if (typeof l == "function") try {
        if (Ro(e)) try {
          Eo(), De(e, l);
        } finally {
          So();
        }
        else De(e, l);
      } catch (i) {
        Pn(e, n, i);
      } finally {
        e.refCleanup = null, (e = e.alternate) != null && (e.refCleanup = null);
      }
      else if (typeof r == "function") try {
        if (Ro(e)) try {
          Eo(), De(e, r, null);
        } finally {
          So();
        }
        else De(e, r, null);
      } catch (i) {
        Pn(e, n, i);
      }
      else r.current = null;
    }
    function Nm(e, n, r, l) {
      var i = e.memoizedProps, s = i.id, f = i.onCommit;
      i = i.onRender, n = n === null ? "mount" : "update", py && (n = "nested-update"), typeof i == "function" && i(s, n, e.actualDuration, e.treeBaseDuration, e.actualStartTime, r), typeof f == "function" && f(e.memoizedProps.id, n, l, r);
    }
    function Og(e, n, r, l) {
      var i = e.memoizedProps;
      e = i.id, i = i.onPostCommit, n = n === null ? "mount" : "update", py && (n = "nested-update"), typeof i == "function" && i(e, n, l, r);
    }
    function Lg(e) {
      var n = e.type, r = e.memoizedProps, l = e.stateNode;
      try {
        De(e, hn, l, n, r, e);
      } catch (i) {
        Pn(e, e.return, i);
      }
    }
    function _m(e, n, r) {
      try {
        De(e, xn, e.stateNode, e.type, r, n, e);
      } catch (l) {
        Pn(e, e.return, l);
      }
    }
    function Om(e) {
      return e.tag === 5 || e.tag === 3 || e.tag === 26 || e.tag === 27 && yr(e.type) || e.tag === 4;
    }
    function _i(e) {
      e: for (; ; ) {
        for (; e.sibling === null; ) {
          if (e.return === null || Om(e.return)) return null;
          e = e.return;
        }
        for (e.sibling.return = e.return, e = e.sibling; e.tag !== 5 && e.tag !== 6 && e.tag !== 18; ) {
          if (e.tag === 27 && yr(e.type) || 2 & e.flags || e.child === null || e.tag === 4) continue e;
          e.child.return = e, e = e.child;
        }
        if (!(2 & e.flags)) return e.stateNode;
      }
    }
    function oc(e, n, r) {
      var l = e.tag;
      if (l === 5 || l === 6) e = e.stateNode, n ? (r.nodeType === 9 ? r.body : r.nodeName === "HTML" ? r.ownerDocument.body : r).insertBefore(e, n) : ((n = r.nodeType === 9 ? r.body : r.nodeName === "HTML" ? r.ownerDocument.body : r).appendChild(e), (r = r._reactRootContainer) != null || n.onclick !== null || (n.onclick = Wu));
      else if (l !== 4 && (l === 27 && yr(e.type) && (r = e.stateNode, n = null), (e = e.child) !== null)) for (oc(e, n, r), e = e.sibling; e !== null; ) oc(e, n, r), e = e.sibling;
    }
    function Oi(e, n, r) {
      var l = e.tag;
      if (l === 5 || l === 6) e = e.stateNode, n ? r.insertBefore(e, n) : r.appendChild(e);
      else if (l !== 4 && (l === 27 && yr(e.type) && (r = e.stateNode), (e = e.child) !== null)) for (Oi(e, n, r), e = e.sibling; e !== null; ) Oi(e, n, r), e = e.sibling;
    }
    function zg(e) {
      for (var n, r = e.return; r !== null; ) {
        if (Om(r)) {
          n = r;
          break;
        }
        r = r.return;
      }
      if (n == null) throw Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
      switch (n.tag) {
        case 27:
          n = n.stateNode, Oi(e, r = _i(e), n);
          break;
        case 5:
          r = n.stateNode, 32 & n.flags && (_n(r), n.flags &= -33), Oi(e, n = _i(e), r);
          break;
        case 3:
        case 4:
          n = n.stateNode.containerInfo, oc(e, r = _i(e), n);
          break;
        default:
          throw Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    function Lm(e) {
      var n = e.stateNode, r = e.memoizedProps;
      try {
        De(e, Vl, e.type, r, n, e);
      } catch (l) {
        Pn(e, e.return, l);
      }
    }
    function ac(e, n, r) {
      var l = r.flags;
      switch (r.tag) {
        case 0:
        case 11:
        case 15:
          ca(e, r), 4 & l && Pm(r, wr | Da);
          break;
        case 1:
          if (ca(e, r), 4 & l) if (e = r.stateNode, n === null) r.type.defaultProps || "ref" in r.memoizedProps || Sp || (e.props !== r.memoizedProps && console.error("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", Ee(r) || "instance"), e.state !== r.memoizedState && console.error("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", Ee(r) || "instance")), Ro(r) ? (Eo(), De(r, zb, r, e), So()) : De(r, zb, r, e);
          else {
            var i = Ml(r.type, n.memoizedProps);
            n = n.memoizedState, r.type.defaultProps || "ref" in r.memoizedProps || Sp || (e.props !== r.memoizedProps && console.error("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", Ee(r) || "instance"), e.state !== r.memoizedState && console.error("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", Ee(r) || "instance")), Ro(r) ? (Eo(), De(r, y0, r, e, i, n, e.__reactInternalSnapshotBeforeUpdate), So()) : De(r, y0, r, e, i, n, e.__reactInternalSnapshotBeforeUpdate);
          }
          64 & l && Am(r), 512 & l && Iu(r, r.return);
          break;
        case 3:
          if (n = Go(), ca(e, r), 64 & l && (l = r.updateQueue) !== null) {
            if (i = null, r.child !== null) switch (r.child.tag) {
              case 27:
              case 5:
              case 1:
                i = r.child.stateNode;
            }
            try {
              De(r, xg, l, i);
            } catch (f) {
              Pn(r, r.return, f);
            }
          }
          e.effectDuration += Ko(n);
          break;
        case 27:
          n === null && 4 & l && Lm(r);
        case 26:
        case 5:
          ca(e, r), n === null && 4 & l && Lg(r), 512 & l && Iu(r, r.return);
          break;
        case 12:
          if (4 & l) {
            l = Go(), ca(e, r), (e = r.stateNode).effectDuration += Xo(l);
            try {
              De(r, Nm, r, n, fy, e.effectDuration);
            } catch (f) {
              Pn(r, r.return, f);
            }
          } else ca(e, r);
          break;
        case 13:
          ca(e, r), 4 & l && Li(e, r), 64 & l && (e = r.memoizedState) !== null && (e = e.dehydrated) !== null && function(f, p) {
            var y = f.ownerDocument;
            if (f.data !== su || y.readyState === ck) p();
            else {
              var v = function() {
                p(), y.removeEventListener("DOMContentLoaded", v);
              };
              y.addEventListener("DOMContentLoaded", v), f._reactRetry = v;
            }
          }(e, r = ob.bind(null, r));
          break;
        case 22:
          if (!(l = r.memoizedState !== null || iu)) {
            n = n !== null && n.memoizedState !== null || At, i = iu;
            var s = At;
            iu = l, (At = n) && !s ? Vt(e, r, !!(8772 & r.subtreeFlags)) : ca(e, r), iu = i, At = s;
          }
          break;
        case 30:
          break;
        default:
          ca(e, r);
      }
    }
    function zm(e) {
      var n = e.alternate;
      n !== null && (e.alternate = null, zm(n)), e.child = null, e.deletions = null, e.sibling = null, e.tag === 5 && (n = e.stateNode) !== null && vt(n), e.stateNode = null, e._debugOwner = null, e.return = null, e.dependencies = null, e.memoizedProps = null, e.memoizedState = null, e.pendingProps = null, e.stateNode = null, e.updateQueue = null;
    }
    function sa(e, n, r) {
      for (r = r.child; r !== null; ) Dg(e, n, r), r = r.sibling;
    }
    function Dg(e, n, r) {
      if (Bn && typeof Bn.onCommitFiberUnmount == "function") try {
        Bn.onCommitFiberUnmount(Ca, r);
      } catch (s) {
        Gr || (Gr = !0, console.error("React instrumentation encountered an error: %s", s));
      }
      switch (r.tag) {
        case 26:
          At || fo(r, n), sa(e, n, r), r.memoizedState ? r.memoizedState.count-- : r.stateNode && (r = r.stateNode).parentNode.removeChild(r);
          break;
        case 27:
          At || fo(r, n);
          var l = Kt, i = go;
          yr(r.type) && (Kt = r.stateNode, go = !1), sa(e, n, r), De(r, ba, r.stateNode), Kt = l, go = i;
          break;
        case 5:
          At || fo(r, n);
        case 6:
          if (l = Kt, i = go, Kt = null, sa(e, n, r), go = i, (Kt = l) !== null) if (go) try {
            De(r, nh, Kt, r.stateNode);
          } catch (s) {
            Pn(r, n, s);
          }
          else try {
            De(r, Qu, Kt, r.stateNode);
          } catch (s) {
            Pn(r, n, s);
          }
          break;
        case 18:
          Kt !== null && (go ? (ya((e = Kt).nodeType === 9 ? e.body : e.nodeName === "HTML" ? e.ownerDocument.body : e, r.stateNode), wa(e)) : ya(Kt, r.stateNode));
          break;
        case 4:
          l = Kt, i = go, Kt = r.stateNode.containerInfo, go = !0, sa(e, n, r), Kt = l, go = i;
          break;
        case 0:
        case 11:
        case 14:
        case 15:
          At || Ni(eo, r, n), At || df(r, n, wr), sa(e, n, r);
          break;
        case 1:
          At || (fo(r, n), typeof (l = r.stateNode).componentWillUnmount == "function" && ff(r, n, l)), sa(e, n, r);
          break;
        case 21:
          sa(e, n, r);
          break;
        case 22:
          At = (l = At) || r.memoizedState !== null, sa(e, n, r), At = l;
          break;
        default:
          sa(e, n, r);
      }
    }
    function Li(e, n) {
      if (n.memoizedState === null && (e = n.alternate) !== null && (e = e.memoizedState) !== null && (e = e.dehydrated) !== null) try {
        De(n, Bl, e);
      } catch (r) {
        Pn(n, n.return, r);
      }
    }
    function zi(e, n) {
      var r = function(l) {
        switch (l.tag) {
          case 13:
          case 19:
            var i = l.stateNode;
            return i === null && (i = l.stateNode = new G0()), i;
          case 22:
            return (i = (l = l.stateNode)._retryCache) === null && (i = l._retryCache = new G0()), i;
          default:
            throw Error("Unexpected Suspense handler tag (" + l.tag + "). This is a bug in React.");
        }
      }(e);
      n.forEach(function(l) {
        var i = Mg.bind(null, e, l);
        if (!r.has(l)) {
          if (r.add(l), Rt) {
            if (Ep === null || xp === null) throw Error("Expected finished root and lanes to be set. This is a bug in React.");
            ol(xp, Ep);
          }
          l.then(i, i);
        }
      });
    }
    function tr(e, n) {
      var r = n.deletions;
      if (r !== null) for (var l = 0; l < r.length; l++) {
        var i = e, s = n, f = r[l], p = s;
        e: for (; p !== null; ) {
          switch (p.tag) {
            case 27:
              if (yr(p.type)) {
                Kt = p.stateNode, go = !1;
                break e;
              }
              break;
            case 5:
              Kt = p.stateNode, go = !1;
              break e;
            case 3:
            case 4:
              Kt = p.stateNode.containerInfo, go = !0;
              break e;
          }
          p = p.return;
        }
        if (Kt === null) throw Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
        Dg(i, s, f), Kt = null, go = !1, (s = (i = f).alternate) !== null && (s.return = null), i.return = null;
      }
      if (13878 & n.subtreeFlags) for (n = n.child; n !== null; ) Mu(n, e), n = n.sibling;
    }
    function Mu(e, n) {
      var r = e.alternate, l = e.flags;
      switch (e.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          tr(n, e), rr(e), 4 & l && (Ni(eo | Da, e, e.return), Ai(eo | Da, e), df(e, e.return, wr | Da));
          break;
        case 1:
          tr(n, e), rr(e), 512 & l && (At || r === null || fo(r, r.return)), 64 & l && iu && (e = e.updateQueue) !== null && (l = e.callbacks) !== null && (r = e.shared.hiddenCallbacks, e.shared.hiddenCallbacks = r === null ? l : r.concat(l));
          break;
        case 26:
          var i = hl;
          if (tr(n, e), rr(e), 512 & l && (At || r === null || fo(r, r.return)), 4 & l) if (n = r !== null ? r.memoizedState : null, l = e.memoizedState, r === null) if (l === null) if (e.stateNode === null) {
            e: {
              l = e.type, r = e.memoizedProps, n = i.ownerDocument || i;
              n: switch (l) {
                case "title":
                  (!(i = n.getElementsByTagName("title")[0]) || i[Oc] || i[Mt] || i.namespaceURI === t || i.hasAttribute("itemprop")) && (i = n.createElement(l), n.head.insertBefore(i, n.querySelector("head > title"))), zt(i, l, r), i[Mt] = e, V(i), l = i;
                  break e;
                case "link":
                  var s = kc("link", "href", n).get(l + (r.href || ""));
                  if (s) {
                    for (var f = 0; f < s.length; f++) if ((i = s[f]).getAttribute("href") === (r.href == null || r.href === "" ? null : r.href) && i.getAttribute("rel") === (r.rel == null ? null : r.rel) && i.getAttribute("title") === (r.title == null ? null : r.title) && i.getAttribute("crossorigin") === (r.crossOrigin == null ? null : r.crossOrigin)) {
                      s.splice(f, 1);
                      break n;
                    }
                  }
                  zt(i = n.createElement(l), l, r), n.head.appendChild(i);
                  break;
                case "meta":
                  if (s = kc("meta", "content", n).get(l + (r.content || ""))) {
                    for (f = 0; f < s.length; f++) if (i = s[f], ce(r.content, "content"), i.getAttribute("content") === (r.content == null ? null : "" + r.content) && i.getAttribute("name") === (r.name == null ? null : r.name) && i.getAttribute("property") === (r.property == null ? null : r.property) && i.getAttribute("http-equiv") === (r.httpEquiv == null ? null : r.httpEquiv) && i.getAttribute("charset") === (r.charSet == null ? null : r.charSet)) {
                      s.splice(f, 1);
                      break n;
                    }
                  }
                  zt(i = n.createElement(l), l, r), n.head.appendChild(i);
                  break;
                default:
                  throw Error('getNodesForType encountered a type it did not expect: "' + l + '". This is a bug in React.');
              }
              i[Mt] = e, V(i), l = i;
            }
            e.stateNode = l;
          } else Ff(i, e.type, e.stateNode);
          else e.stateNode = rh(i, l, e.memoizedProps);
          else n !== l ? (n === null ? r.stateNode !== null && (r = r.stateNode).parentNode.removeChild(r) : n.count--, l === null ? Ff(i, e.type, e.stateNode) : rh(i, l, e.memoizedProps)) : l === null && e.stateNode !== null && _m(e, e.memoizedProps, r.memoizedProps);
          break;
        case 27:
          tr(n, e), rr(e), 512 & l && (At || r === null || fo(r, r.return)), r !== null && 4 & l && _m(e, e.memoizedProps, r.memoizedProps);
          break;
        case 5:
          if (tr(n, e), rr(e), 512 & l && (At || r === null || fo(r, r.return)), 32 & e.flags) {
            n = e.stateNode;
            try {
              De(e, _n, n);
            } catch (z) {
              Pn(e, e.return, z);
            }
          }
          4 & l && e.stateNode != null && _m(e, n = e.memoizedProps, r !== null ? r.memoizedProps : n), 1024 & l && (Hb = !0, e.type !== "form" && console.error("Unexpected host component type. Expected a form. This is a bug in React."));
          break;
        case 6:
          if (tr(n, e), rr(e), 4 & l) {
            if (e.stateNode === null) throw Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
            l = e.memoizedProps, r = r !== null ? r.memoizedProps : l, n = e.stateNode;
            try {
              De(e, Yr, n, r, l);
            } catch (z) {
              Pn(e, e.return, z);
            }
          }
          break;
        case 3:
          if (i = Go(), My = null, s = hl, hl = il(n.containerInfo), tr(n, e), hl = s, rr(e), 4 & l && r !== null && r.memoizedState.isDehydrated) try {
            De(e, Lf, n.containerInfo);
          } catch (z) {
            Pn(e, e.return, z);
          }
          Hb && (Hb = !1, Dm(e)), n.effectDuration += Ko(i);
          break;
        case 4:
          l = hl, hl = il(e.stateNode.containerInfo), tr(n, e), rr(e), hl = l;
          break;
        case 12:
          l = Go(), tr(n, e), rr(e), e.stateNode.effectDuration += Xo(l);
          break;
        case 13:
          tr(n, e), rr(e), 8192 & e.child.flags && e.memoizedState !== null != (r !== null && r.memoizedState !== null) && (Qb = xa()), 4 & l && (l = e.updateQueue) !== null && (e.updateQueue = null, zi(e, l));
          break;
        case 22:
          i = e.memoizedState !== null;
          var p = r !== null && r.memoizedState !== null, y = iu, v = At;
          if (iu = y || i, At = v || p, tr(n, e), At = v, iu = y, rr(e), 8192 & l) e: for (n = e.stateNode, n._visibility = i ? n._visibility & ~uy : n._visibility | uy, i && (r === null || p || iu || At || Fi(e)), r = null, n = e; ; ) {
            if (n.tag === 5 || n.tag === 26) {
              if (r === null) {
                p = r = n;
                try {
                  s = p.stateNode, i ? De(p, pt, s) : De(p, Qi, p.stateNode, p.memoizedProps);
                } catch (z) {
                  Pn(p, p.return, z);
                }
              }
            } else if (n.tag === 6) {
              if (r === null) {
                p = n;
                try {
                  f = p.stateNode, i ? De(p, Hl, f) : De(p, th, f, p.memoizedProps);
                } catch (z) {
                  Pn(p, p.return, z);
                }
              }
            } else if ((n.tag !== 22 && n.tag !== 23 || n.memoizedState === null || n === e) && n.child !== null) {
              n.child.return = n, n = n.child;
              continue;
            }
            if (n === e) break e;
            for (; n.sibling === null; ) {
              if (n.return === null || n.return === e) break e;
              r === n && (r = null), n = n.return;
            }
            r === n && (r = null), n.sibling.return = n.return, n = n.sibling;
          }
          4 & l && (l = e.updateQueue) !== null && (r = l.retryQueue) !== null && (l.retryQueue = null, zi(e, r));
          break;
        case 19:
          tr(n, e), rr(e), 4 & l && (l = e.updateQueue) !== null && (e.updateQueue = null, zi(e, l));
          break;
        case 30:
        case 21:
          break;
        default:
          tr(n, e), rr(e);
      }
    }
    function rr(e) {
      var n = e.flags;
      if (2 & n) {
        try {
          De(e, zg, e);
        } catch (r) {
          Pn(e, e.return, r);
        }
        e.flags &= -3;
      }
      4096 & n && (e.flags &= -4097);
    }
    function Dm(e) {
      if (1024 & e.subtreeFlags) for (e = e.child; e !== null; ) {
        var n = e;
        Dm(n), n.tag === 5 && 1024 & n.flags && n.stateNode.reset(), e = e.sibling;
      }
    }
    function ca(e, n) {
      if (8772 & n.subtreeFlags) for (n = n.child; n !== null; ) ac(e, n.alternate, n), n = n.sibling;
    }
    function Di(e) {
      switch (e.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          df(e, e.return, wr), Fi(e);
          break;
        case 1:
          fo(e, e.return);
          var n = e.stateNode;
          typeof n.componentWillUnmount == "function" && ff(e, e.return, n), Fi(e);
          break;
        case 27:
          De(e, ba, e.stateNode);
        case 26:
        case 5:
          fo(e, e.return), Fi(e);
          break;
        case 22:
          e.memoizedState === null && Fi(e);
          break;
        default:
          Fi(e);
      }
    }
    function Fi(e) {
      for (e = e.child; e !== null; ) Di(e), e = e.sibling;
    }
    function qr(e, n, r, l) {
      var i = r.flags;
      switch (r.tag) {
        case 0:
        case 11:
        case 15:
          Vt(e, r, l), Pm(r, wr);
          break;
        case 1:
          if (Vt(e, r, l), typeof (n = r.stateNode).componentDidMount == "function" && De(r, zb, r, n), (n = r.updateQueue) !== null) {
            e = r.stateNode;
            try {
              De(r, Tu, n, e);
            } catch (s) {
              Pn(r, r.return, s);
            }
          }
          l && 64 & i && Am(r), Iu(r, r.return);
          break;
        case 27:
          Lm(r);
        case 26:
        case 5:
          Vt(e, r, l), l && n === null && 4 & i && Lg(r), Iu(r, r.return);
          break;
        case 12:
          if (l && 4 & i) {
            i = Go(), Vt(e, r, l), (l = r.stateNode).effectDuration += Xo(i);
            try {
              De(r, Nm, r, n, fy, l.effectDuration);
            } catch (s) {
              Pn(r, r.return, s);
            }
          } else Vt(e, r, l);
          break;
        case 13:
          Vt(e, r, l), l && 4 & i && Li(e, r);
          break;
        case 22:
          r.memoizedState === null && Vt(e, r, l), Iu(r, r.return);
          break;
        case 30:
          break;
        default:
          Vt(e, r, l);
      }
    }
    function Vt(e, n, r) {
      for (r = r && !!(8772 & n.subtreeFlags), n = n.child; n !== null; ) qr(e, n.alternate, n, r), n = n.sibling;
    }
    function da(e, n) {
      var r = null;
      e !== null && e.memoizedState !== null && e.memoizedState.cachePool !== null && (r = e.memoizedState.cachePool.pool), e = null, n.memoizedState !== null && n.memoizedState.cachePool !== null && (e = n.memoizedState.cachePool.pool), e !== r && (e != null && wo(e), r != null && vi(r));
    }
    function pf(e, n) {
      e = null, n.alternate !== null && (e = n.alternate.memoizedState.cache), (n = n.memoizedState.cache) !== e && (wo(n), e != null && vi(e));
    }
    function gr(e, n, r, l) {
      if (10256 & n.subtreeFlags) for (n = n.child; n !== null; ) fa(e, n, r, l), n = n.sibling;
    }
    function fa(e, n, r, l) {
      var i = n.flags;
      switch (n.tag) {
        case 0:
        case 11:
        case 15:
          gr(e, n, r, l), 2048 & i && Rm(n, Yt | Da);
          break;
        case 1:
        case 13:
        default:
          gr(e, n, r, l);
          break;
        case 3:
          var s = Go();
          gr(e, n, r, l), 2048 & i && (r = null, n.alternate !== null && (r = n.alternate.memoizedState.cache), (n = n.memoizedState.cache) !== r && (wo(n), r != null && vi(r))), e.passiveEffectDuration += Ko(s);
          break;
        case 12:
          if (2048 & i) {
            i = Go(), gr(e, n, r, l), (e = n.stateNode).passiveEffectDuration += Xo(i);
            try {
              De(n, Og, n, n.alternate, fy, e.passiveEffectDuration);
            } catch (p) {
              Pn(n, n.return, p);
            }
          } else gr(e, n, r, l);
          break;
        case 23:
          break;
        case 22:
          s = n.stateNode;
          var f = n.alternate;
          n.memoizedState !== null ? s._visibility & nu ? gr(e, n, r, l) : Ii(e, n) : s._visibility & nu ? gr(e, n, r, l) : (s._visibility |= nu, $n(e, n, r, l, !!(10256 & n.subtreeFlags))), 2048 & i && da(f, n);
          break;
        case 24:
          gr(e, n, r, l), 2048 & i && pf(n.alternate, n);
      }
    }
    function $n(e, n, r, l, i) {
      for (i = i && !!(10256 & n.subtreeFlags), n = n.child; n !== null; ) lc(e, n, r, l, i), n = n.sibling;
    }
    function lc(e, n, r, l, i) {
      var s = n.flags;
      switch (n.tag) {
        case 0:
        case 11:
        case 15:
          $n(e, n, r, l, i), Rm(n, Yt);
          break;
        case 23:
          break;
        case 22:
          var f = n.stateNode;
          n.memoizedState !== null ? f._visibility & nu ? $n(e, n, r, l, i) : Ii(e, n) : (f._visibility |= nu, $n(e, n, r, l, i)), i && 2048 & s && da(n.alternate, n);
          break;
        case 24:
          $n(e, n, r, l, i), i && 2048 & s && pf(n.alternate, n);
          break;
        default:
          $n(e, n, r, l, i);
      }
    }
    function Ii(e, n) {
      if (10256 & n.subtreeFlags) for (n = n.child; n !== null; ) {
        var r = e, l = n, i = l.flags;
        switch (l.tag) {
          case 22:
            Ii(r, l), 2048 & i && da(l.alternate, l);
            break;
          case 24:
            Ii(r, l), 2048 & i && pf(l.alternate, l);
            break;
          default:
            Ii(r, l);
        }
        n = n.sibling;
      }
    }
    function Mi(e) {
      if (e.subtreeFlags & Uh) for (e = e.child; e !== null; ) Fm(e), e = e.sibling;
    }
    function Fm(e) {
      switch (e.tag) {
        case 26:
          Mi(e), e.flags & Uh && e.memoizedState !== null && function(r, l, i) {
            if (eg === null) throw Error("Internal React Error: suspendedState null when it was expected to exists. Please report this as a React bug.");
            var s = eg;
            if (l.type === "stylesheet" && (typeof i.media != "string" || matchMedia(i.media).matches !== !1) && (l.state.loading & Ma) === ld) {
              if (l.instance === null) {
                var f = va(i.href), p = r.querySelector(Yi(f));
                if (p) return (r = p._p) !== null && typeof r == "object" && typeof r.then == "function" && (s.count++, s = wc.bind(s), r.then(s, s)), l.state.loading |= Ma, l.instance = p, void V(p);
                p = r.ownerDocument || r, i = Lr(i), (f = ja.get(f)) && oh(i, f), V(p = p.createElement("link"));
                var y = p;
                y._p = new Promise(function(v, z) {
                  y.onload = v, y.onerror = z;
                }), zt(p, "link", i), l.instance = p;
              }
              s.stylesheets === null && (s.stylesheets = /* @__PURE__ */ new Map()), s.stylesheets.set(l, r), (r = l.state.preload) && (l.state.loading & hk) === ld && (s.count++, l = wc.bind(s), r.addEventListener("load", l), r.addEventListener("error", l));
            }
          }(hl, e.memoizedState, e.memoizedProps);
          break;
        case 5:
        default:
          Mi(e);
          break;
        case 3:
        case 4:
          var n = hl;
          hl = il(e.stateNode.containerInfo), Mi(e), hl = n;
          break;
        case 22:
          e.memoizedState === null && ((n = e.alternate) !== null && n.memoizedState !== null ? (n = Uh, Uh = 16777216, Mi(e), Uh = n) : Mi(e));
      }
    }
    function Im(e) {
      var n = e.alternate;
      if (n !== null && (e = n.child) !== null) {
        n.child = null;
        do
          n = e.sibling, e.sibling = null, e = n;
        while (e !== null);
      }
    }
    function Ao(e) {
      var n = e.deletions;
      if (16 & e.flags) {
        if (n !== null) for (var r = 0; r < n.length; r++) {
          var l = n[r];
          cr = l, jm(l, e);
        }
        Im(e);
      }
      if (10256 & e.subtreeFlags) for (e = e.child; e !== null; ) ic(e), e = e.sibling;
    }
    function ic(e) {
      switch (e.tag) {
        case 0:
        case 11:
        case 15:
          Ao(e), 2048 & e.flags && rc(e, e.return, Yt | Da);
          break;
        case 3:
          var n = Go();
          Ao(e), e.stateNode.passiveEffectDuration += Ko(n);
          break;
        case 12:
          n = Go(), Ao(e), e.stateNode.passiveEffectDuration += Xo(n);
          break;
        case 22:
          n = e.stateNode, e.memoizedState !== null && n._visibility & nu && (e.return === null || e.return.tag !== 13) ? (n._visibility &= ~nu, uc(e)) : Ao(e);
          break;
        default:
          Ao(e);
      }
    }
    function uc(e) {
      var n = e.deletions;
      if (16 & e.flags) {
        if (n !== null) for (var r = 0; r < n.length; r++) {
          var l = n[r];
          cr = l, jm(l, e);
        }
        Im(e);
      }
      for (e = e.child; e !== null; ) Mm(e), e = e.sibling;
    }
    function Mm(e) {
      switch (e.tag) {
        case 0:
        case 11:
        case 15:
          rc(e, e.return, Yt), uc(e);
          break;
        case 22:
          var n = e.stateNode;
          n._visibility & nu && (n._visibility &= ~nu, uc(e));
          break;
        default:
          uc(e);
      }
    }
    function jm(e, n) {
      for (; cr !== null; ) {
        var r = cr, l = r;
        switch (l.tag) {
          case 0:
          case 11:
          case 15:
            rc(l, n, Yt);
            break;
          case 23:
          case 22:
            l.memoizedState !== null && l.memoizedState.cachePool !== null && (l = l.memoizedState.cachePool.pool) != null && wo(l);
            break;
          case 24:
            vi(l.memoizedState.cache);
        }
        if ((l = r.child) !== null) l.return = r, cr = l;
        else e: for (r = e; cr !== null; ) {
          var i = (l = cr).sibling, s = l.return;
          if (zm(l), l === r) {
            cr = null;
            break e;
          }
          if (i !== null) {
            i.return = s, cr = i;
            break e;
          }
          cr = s;
        }
      }
    }
    function sc() {
      var e = typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0;
      return e || J.actQueue === null || console.error("The current testing environment is not configured to support act(...)"), e;
    }
    function _r(e) {
      if ((Dn & no) !== Mo && vn !== 0) return vn & -vn;
      var n = J.T;
      return n !== null ? (n._updatedFibers || (n._updatedFibers = /* @__PURE__ */ new Set()), n._updatedFibers.add(e), (e = Yc) !== 0 ? e : lt()) : Er();
    }
    function mf() {
      Ho === 0 && (Ho = 536870912 & vn && !Tn ? 536870912 : rn());
      var e = Ia.current;
      return e !== null && (e.flags |= 32), Ho;
    }
    function dt(e, n, r) {
      if (Ap && console.error("useInsertionEffect must not schedule updates."), $b && (Ty = !0), (e !== Kn || Mn !== Zc && Mn !== Jc) && e.cancelPendingCommit === null || (Hi(e, 0), at(e, vn, Ho, !1)), Bo(e, r), (Dn & no) !== 0 && e === Kn) {
        if (Pa) switch (n.tag) {
          case 0:
          case 11:
          case 15:
            e = gn && Ee(gn) || "Unknown", ok.has(e) || (ok.add(e), n = Ee(n) || "Unknown", console.error("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://react.dev/link/setstate-in-render", n, e, e));
            break;
          case 1:
            rk || (console.error("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."), rk = !0);
        }
      } else Rt && ks(e, n, r), function(l) {
        sc() && J.actQueue === null && De(l, function() {
          console.error(`An update to %s inside a test was not wrapped in act(...).

When testing, code that causes React state updates should be wrapped into act(...):

act(() => {
  /* fire events that update state */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://react.dev/link/wrap-tests-with-act`, Ee(l));
        });
      }(n), e === Kn && ((Dn & no) === Mo && (us |= r), xt === $c && at(e, vn, Ho, !1)), Tt(e);
    }
    function Hm(e, n, r) {
      if ((Dn & (no | gl)) !== Mo) throw Error("Should not already be working.");
      for (var l = !r && !(124 & n) && (n & e.expiredLanes) === 0 || Uo(e, n), i = l ? function(v, z) {
        var j = Dn;
        Dn |= no;
        var F = Vm(), te = cc();
        if (Kn !== v || vn !== z) {
          if (Rt) {
            var Q = v.memoizedUpdaters;
            0 < Q.size && (ol(v, vn), Q.clear()), Ba(v, z);
          }
          Gh = null, Cy = xa() + Z0, Hi(v, z);
        } else Pp = Uo(v, z);
        Vn(z);
        e: for (; ; ) try {
          if (Mn !== yo && gn !== null) n: switch (z = gn, Q = jo, Mn) {
            case Wh:
              Mn = yo, jo = null, Ui(v, z, Q, Wh);
              break;
            case Zc:
            case Jc:
              if (lm(Q)) {
                Mn = yo, jo = null, bf(z);
                break;
              }
              z = function() {
                Mn !== Zc && Mn !== Jc || Kn !== v || (Mn = Qh), Tt(v);
              }, Q.then(z, z);
              break e;
            case qh:
              Mn = Qh;
              break e;
            case X0:
              Mn = Bb;
              break e;
            case Qh:
              lm(Q) ? (Mn = yo, jo = null, bf(z)) : (Mn = yo, jo = null, Ui(v, z, Q, Qh));
              break;
            case Bb:
              var ge = null;
              switch (gn.tag) {
                case 26:
                  ge = gn.memoizedState;
                case 5:
                case 27:
                  var T = gn;
                  if (!ge || Ki(ge)) {
                    Mn = yo, jo = null;
                    var P = T.sibling;
                    if (P !== null) gn = P;
                    else {
                      var D = T.return;
                      D !== null ? (gn = D, ju(D)) : gn = null;
                    }
                    break n;
                  }
                  break;
                default:
                  console.error("Unexpected type of fiber triggered a suspensey commit. This is a bug in React.");
              }
              Mn = yo, jo = null, Ui(v, z, Q, Bb);
              break;
            case Tp:
              Mn = yo, jo = null, Ui(v, z, Q, Tp);
              break;
            case Vb:
              hf(), xt = Ey;
              break e;
            default:
              throw Error("Unexpected SuspendedReason. This is a bug in React.");
          }
          J.actQueue !== null ? Wm() : Fg();
          break;
        } catch (X) {
          Bm(v, X);
        }
        return zd(), J.H = F, J.A = te, Dn = j, gn !== null ? (Pe !== null && typeof Pe.markRenderYielded == "function" && Pe.markRenderYielded(), uu) : (Fn(), Kn = null, vn = 0, Pd(), xt);
      }(e, n) : gf(e, n, !0), s = l; ; ) {
        if (i === uu) {
          Pp && !l && at(e, n, 0, !1);
          break;
        }
        if (r = e.current.alternate, !s || Lt(r)) {
          if (i === Cp) {
            if (s = n, e.errorRecoveryDisabledLanes & s) var f = 0;
            else f = (f = -536870913 & e.pendingLanes) !== 0 ? f : 536870912 & f ? 536870912 : 0;
            if (f !== 0) {
              n = f;
              e: {
                var p = f;
                f = Yh;
                var y = (i = e).current.memoizedState.isDehydrated;
                if (y && (Hi(i, p).flags |= 256), (p = gf(i, p, !1)) !== Cp) {
                  if (Wb && !y) {
                    i.errorRecoveryDisabledLanes |= s, us |= s, i = $c;
                    break e;
                  }
                  i = to, to = f, i !== null && (to === null ? to = i : to.push.apply(to, i));
                }
                i = p;
              }
              if (s = !1, i !== Cp) continue;
            }
          }
          if (i === Vh) {
            Hi(e, 0), at(e, n, 0, !0);
            break;
          }
          e: {
            switch (l = e, i) {
              case uu:
              case Vh:
                throw Error("Root did not complete. This is a bug in React.");
              case $c:
                if ((4194048 & n) !== n) break;
              case Ey:
                at(l, n, Ho, !ls);
                break e;
              case Cp:
                to = null;
                break;
              case Ub:
              case K0:
                break;
              default:
                throw Error("Unknown root exit status.");
            }
            if (J.actQueue !== null) pc(l, r, n, to, Gh, xy, Ho, us, ed);
            else {
              if ((62914560 & n) === n && 10 < (s = Qb + $0 - xa())) {
                if (at(l, n, Ho, !ls), Ua(l, 0, !0) !== 0) break e;
                l.timeoutHandle = fk(Um.bind(null, l, r, to, Gh, xy, n, Ho, us, ed, ls, i, k1, Jv, 0), s);
                break e;
              }
              Um(l, r, to, Gh, xy, n, Ho, us, ed, ls, i, b1, Jv, 0);
            }
          }
          break;
        }
        i = gf(e, n, !1), s = !1;
      }
      Tt(e);
    }
    function Um(e, n, r, l, i, s, f, p, y, v, z, j, F, te) {
      if (e.timeoutHandle = ad, (8192 & (j = n.subtreeFlags) || !(16785408 & ~j)) && (eg = { stylesheets: null, count: 0, unsuspend: Ug }, Fm(n), (j = function() {
        if (eg === null) throw Error("Internal React Error: suspendedState null when it was expected to exists. Please report this as a React bug.");
        var Q = eg;
        return Q.stylesheets && Q.count === 0 && If(Q, Q.stylesheets), 0 < Q.count ? function(ge) {
          var T = setTimeout(function() {
            if (Q.stylesheets && If(Q, Q.stylesheets), Q.unsuspend) {
              var P = Q.unsuspend;
              Q.unsuspend = null, P();
            }
          }, 6e4);
          return Q.unsuspend = ge, function() {
            Q.unsuspend = null, clearTimeout(T);
          };
        } : null;
      }()) !== null)) return e.cancelPendingCommit = j(pc.bind(null, e, n, s, r, l, i, f, p, y, z, v1, F, te)), void at(e, s, f, !v);
      pc(e, n, s, r, l, i, f, p, y);
    }
    function Lt(e) {
      for (var n = e; ; ) {
        var r = n.tag;
        if ((r === 0 || r === 11 || r === 15) && 16384 & n.flags && (r = n.updateQueue) !== null && (r = r.stores) !== null) for (var l = 0; l < r.length; l++) {
          var i = r[l], s = i.getSnapshot;
          i = i.value;
          try {
            if (!Zr(s(), i)) return !1;
          } catch {
            return !1;
          }
        }
        if (r = n.child, 16384 & n.subtreeFlags && r !== null) r.return = n, n = r;
        else {
          if (n === e) break;
          for (; n.sibling === null; ) {
            if (n.return === null || n.return === e) return !0;
            n = n.return;
          }
          n.sibling.return = n.return, n = n.sibling;
        }
      }
      return !0;
    }
    function at(e, n, r, l) {
      n &= ~qb, n &= ~us, e.suspendedLanes |= n, e.pingedLanes &= ~n, l && (e.warmLanes |= n), l = e.expirationTimes;
      for (var i = n; 0 < i; ) {
        var s = 31 - St(i), f = 1 << s;
        l[s] = -1, i &= ~f;
      }
      r !== 0 && pd(e, r, n);
    }
    function ji() {
      return (Dn & (no | gl)) !== Mo || (Uu(0), !1);
    }
    function hf() {
      if (gn !== null) {
        if (Mn === yo) var e = gn.return;
        else e = gn, zd(), so(e), bp = null, jh = 0, e = gn;
        for (; e !== null; ) Tm(e.alternate, e), e = e.return;
        gn = null;
      }
    }
    function Hi(e, n) {
      var r = e.timeoutHandle;
      r !== ad && (e.timeoutHandle = ad, O1(r)), (r = e.cancelPendingCommit) !== null && (e.cancelPendingCommit = null, r()), hf(), Kn = e, gn = r = Qo(e.current, null), vn = n, Mn = yo, jo = null, ls = !1, Pp = Uo(e, n), Wb = !1, xt = uu, ed = Ho = qb = us = is = 0, to = Yh = null, xy = !1, 8 & n && (n |= 32 & n);
      var l = e.entangledLanes;
      if (l !== 0) for (e = e.entanglements, l &= n; 0 < l; ) {
        var i = 31 - St(l), s = 1 << i;
        n |= e[i], l &= ~s;
      }
      return ei = n, Pd(), 1e3 < (n = $v()) - Xv && (J.recentlyCreatedOwnerStacks = 0, Xv = n), pl.discardPendingWarnings(), r;
    }
    function Bm(e, n) {
      Ye = null, J.H = wy, J.getCurrentStack = null, Pa = !1, ur = null, n === Dh || n === gy ? (n = im(), Mn = qh) : n === t0 ? (n = im(), Mn = X0) : Mn = n === H0 ? Vb : n !== null && typeof n == "object" && typeof n.then == "function" ? Tp : Wh, jo = n;
      var r = gn;
      if (r === null) xt = Vh, Fu(e, Ur(n, e.current));
      else switch (r.mode & kr && Id(r), _e(), Mn) {
        case Wh:
          Pe !== null && typeof Pe.markComponentErrored == "function" && Pe.markComponentErrored(r, n, vn);
          break;
        case Zc:
        case Jc:
        case qh:
        case Tp:
        case Qh:
          Pe !== null && typeof Pe.markComponentSuspended == "function" && Pe.markComponentSuspended(r, n, vn);
      }
    }
    function Vm() {
      var e = J.H;
      return J.H = wy, e === null ? wy : e;
    }
    function cc() {
      var e = J.A;
      return J.A = h1, e;
    }
    function dc() {
      xt = $c, ls || (4194048 & vn) !== vn && Ia.current !== null || (Pp = !0), !(134217727 & is) && !(134217727 & us) || Kn === null || at(Kn, vn, Ho, !1);
    }
    function gf(e, n, r) {
      var l = Dn;
      Dn |= no;
      var i = Vm(), s = cc();
      if (Kn !== e || vn !== n) {
        if (Rt) {
          var f = e.memoizedUpdaters;
          0 < f.size && (ol(e, vn), f.clear()), Ba(e, n);
        }
        Gh = null, Hi(e, n);
      }
      Vn(n), n = !1, f = xt;
      e: for (; ; ) try {
        if (Mn !== yo && gn !== null) {
          var p = gn, y = jo;
          switch (Mn) {
            case Vb:
              hf(), f = Ey;
              break e;
            case qh:
            case Zc:
            case Jc:
            case Tp:
              Ia.current === null && (n = !0);
              var v = Mn;
              if (Mn = yo, jo = null, Ui(e, p, y, v), r && Pp) {
                f = uu;
                break e;
              }
              break;
            default:
              v = Mn, Mn = yo, jo = null, Ui(e, p, y, v);
          }
        }
        Wm(), f = xt;
        break;
      } catch (z) {
        Bm(e, z);
      }
      return n && e.shellSuspendCounter++, zd(), Dn = l, J.H = i, J.A = s, Fn(), gn === null && (Kn = null, vn = 0, Pd()), f;
    }
    function Wm() {
      for (; gn !== null; ) yf(gn);
    }
    function Fg() {
      for (; gn !== null && !Zg(); ) yf(gn);
    }
    function yf(e) {
      var n = e.alternate;
      (e.mode & kr) !== Jn ? (Is(e), n = De(e, Cm, n, e, ei), Id(e)) : n = De(e, Cm, n, e, ei), e.memoizedProps = e.pendingProps, n === null ? ju(e) : gn = n;
    }
    function bf(e) {
      var n = De(e, qm, e);
      e.memoizedProps = e.pendingProps, n === null ? ju(e) : gn = n;
    }
    function qm(e) {
      var n = e.alternate, r = (e.mode & kr) !== Jn;
      switch (r && Is(e), e.tag) {
        case 15:
        case 0:
          n = km(n, e, e.pendingProps, e.type, void 0, vn);
          break;
        case 11:
          n = km(n, e, e.pendingProps, e.type.render, e.ref, vn);
          break;
        case 5:
          so(e);
        default:
          Tm(n, e), n = Cm(n, e = gn = em(e, ei), ei);
      }
      return r && Id(e), n;
    }
    function Ui(e, n, r, l) {
      zd(), so(n), bp = null, jh = 0;
      var i = n.return;
      try {
        if (function(s, f, p, y, v) {
          if (p.flags |= 32768, Rt && ol(s, v), y !== null && typeof y == "object" && typeof y.then == "function") {
            if ((f = p.alternate) !== null && Su(f, p, v, !0), Tn && (ru = !0), (p = Ia.current) !== null) {
              switch (p.tag) {
                case 13:
                  return lu === null ? dc() : p.alternate === null && xt === uu && (xt = Ub), p.flags &= -257, p.flags |= 65536, p.lanes = v, y === Cb ? p.flags |= 16384 : ((f = p.updateQueue) === null ? p.updateQueue = /* @__PURE__ */ new Set([y]) : f.add(y), Bi(s, y, v)), !1;
                case 22:
                  return p.flags |= 65536, y === Cb ? p.flags |= 16384 : ((f = p.updateQueue) === null ? (f = { transitions: null, markerInstances: null, retryQueue: /* @__PURE__ */ new Set([y]) }, p.updateQueue = f) : (p = f.retryQueue) === null ? f.retryQueue = /* @__PURE__ */ new Set([y]) : p.add(y), Bi(s, y, v)), !1;
              }
              throw Error("Unexpected Suspense handler tag (" + p.tag + "). This is a bug in React.");
            }
            return Bi(s, y, v), dc(), !1;
          }
          if (Tn) return ru = !0, (f = Ia.current) !== null ? (!(65536 & f.flags) && (f.flags |= 256), f.flags |= 65536, f.lanes = v, y !== wb && zs(Ur(Error("There was an error while hydrating but React was able to recover by instead client rendering from the nearest Suspense boundary.", { cause: y }), p))) : (y !== wb && zs(Ur(Error("There was an error while hydrating but React was able to recover by instead client rendering the entire root.", { cause: y }), p)), (s = s.current.alternate).flags |= 65536, v &= -v, s.lanes |= v, y = Ur(y, p), xu(s, v = nr(s.stateNode, y, v)), xt !== $c && (xt = Cp)), !1;
          var z = Ur(Error("There was an error during concurrent rendering but React was able to recover by instead synchronously rendering the entire root.", { cause: y }), p);
          if (Yh === null ? Yh = [z] : Yh.push(z), xt !== $c && (xt = Cp), f === null) return !0;
          y = Ur(y, p), p = f;
          do {
            switch (p.tag) {
              case 3:
                return p.flags |= 65536, s = v & -v, p.lanes |= s, xu(p, s = nr(p.stateNode, y, s)), !1;
              case 1:
                if (f = p.type, z = p.stateNode, !(128 & p.flags || typeof f.getDerivedStateFromError != "function" && (z === null || typeof z.componentDidCatch != "function" || ss !== null && ss.has(z)))) return p.flags |= 65536, v &= -v, p.lanes |= v, Pi(v = ct(v), s, p, y), xu(p, v), !1;
            }
            p = p.return;
          } while (p !== null);
          return !1;
        }(e, i, n, r, vn)) return xt = Vh, Fu(e, Ur(r, e.current)), void (gn = null);
      } catch (s) {
        if (i !== null) throw gn = i, s;
        return xt = Vh, Fu(e, Ur(r, e.current)), void (gn = null);
      }
      32768 & n.flags ? (Tn || l === Wh ? e = !0 : Pp || 536870912 & vn ? e = !1 : (ls = e = !0, (l === Zc || l === Jc || l === qh || l === Tp) && (l = Ia.current) !== null && l.tag === 13 && (l.flags |= 16384)), fc(n, e)) : ju(n);
    }
    function ju(e) {
      var n = e;
      do {
        if (32768 & n.flags) return void fc(n, ls);
        var r = n.alternate;
        if (e = n.return, Is(n), r = De(n, Rg, r, n, ei), (n.mode & kr) !== Jn && Nl(n), r !== null) return void (gn = r);
        if ((n = n.sibling) !== null) return void (gn = n);
        gn = n = e;
      } while (n !== null);
      xt === uu && (xt = K0);
    }
    function fc(e, n) {
      do {
        var r = Ag(e.alternate, e);
        if (r !== null) return r.flags &= 32767, void (gn = r);
        if ((e.mode & kr) !== Jn) {
          Nl(e), r = e.actualDuration;
          for (var l = e.child; l !== null; ) r += l.actualDuration, l = l.sibling;
          e.actualDuration = r;
        }
        if ((r = e.return) !== null && (r.flags |= 32768, r.subtreeFlags = 0, r.deletions = null), !n && (e = e.sibling) !== null) return void (gn = e);
        gn = e = r;
      } while (e !== null);
      xt = Ey, gn = null;
    }
    function pc(e, n, r, l, i, s, f, p, y) {
      e.cancelPendingCommit = null;
      do
        Hu();
      while (Sr !== nd);
      if (pl.flushLegacyContextWarning(), pl.flushPendingUnsafeLifecycleWarnings(), (Dn & (no | gl)) !== Mo) throw Error("Should not already be working.");
      if (Pe !== null && typeof Pe.markCommitStarted == "function" && Pe.markCommitStarted(r), n === null) Be();
      else {
        if (r === 0 && console.error("finishedLanes should not be empty during a commit. This is a bug in React."), n === e.current) throw Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
        if (s = n.lanes | n.childLanes, function(F, te, Q, ge, T, P) {
          var D = F.pendingLanes;
          F.pendingLanes = Q, F.suspendedLanes = 0, F.pingedLanes = 0, F.warmLanes = 0, F.expiredLanes &= Q, F.entangledLanes &= Q, F.errorRecoveryDisabledLanes &= Q, F.shellSuspendCounter = 0;
          var X = F.entanglements, ve = F.expirationTimes, pn = F.hiddenUpdates;
          for (Q = D & ~Q; 0 < Q; ) {
            var kn = 31 - St(Q), je = 1 << kn;
            X[kn] = 0, ve[kn] = -1;
            var We = pn[kn];
            if (We !== null) for (pn[kn] = null, kn = 0; kn < We.length; kn++) {
              var sn = We[kn];
              sn !== null && (sn.lane &= -536870913);
            }
            Q &= ~je;
          }
          ge !== 0 && pd(F, ge, 0), P !== 0 && T === 0 && F.tag !== 0 && (F.suspendedLanes |= P & ~(D & ~te));
        }(e, r, s |= kb, f, p, y), e === Kn && (gn = Kn = null, vn = 0), Rp = n, cs = e, ds = r, Gb = s, Kb = i, tk = l, 10256 & n.subtreeFlags || 10256 & n.flags ? (e.callbackNode = null, e.callbackPriority = 0, v = Yl, z = function() {
          return pa(), null;
        }, (j = J.actQueue) !== null ? j.push(z) : Qf(v, z)) : (e.callbackNode = null, e.callbackPriority = 0), fy = pp(), l = !!(13878 & n.flags), 13878 & n.subtreeFlags || l) {
          l = J.T, J.T = null, i = Fe.p, Fe.p = Kr, f = Dn, Dn |= gl;
          try {
            (function(F, te) {
              if (F = F.containerInfo, av = Uy, As(F = bg(F))) {
                if ("selectionStart" in F) var Q = { start: F.selectionStart, end: F.selectionEnd };
                else e: {
                  var ge = (Q = (Q = F.ownerDocument) && Q.defaultView || window).getSelection && Q.getSelection();
                  if (ge && ge.rangeCount !== 0) {
                    Q = ge.anchorNode;
                    var T = ge.anchorOffset, P = ge.focusNode;
                    ge = ge.focusOffset;
                    try {
                      Q.nodeType, P.nodeType;
                    } catch {
                      Q = null;
                      break e;
                    }
                    var D = 0, X = -1, ve = -1, pn = 0, kn = 0, je = F, We = null;
                    n: for (; ; ) {
                      for (var sn; je !== Q || T !== 0 && je.nodeType !== 3 || (X = D + T), je !== P || ge !== 0 && je.nodeType !== 3 || (ve = D + ge), je.nodeType === 3 && (D += je.nodeValue.length), (sn = je.firstChild) !== null; ) We = je, je = sn;
                      for (; ; ) {
                        if (je === F) break n;
                        if (We === Q && ++pn === T && (X = D), We === P && ++kn === ge && (ve = D), (sn = je.nextSibling) !== null) break;
                        We = (je = We).parentNode;
                      }
                      je = sn;
                    }
                    Q = X === -1 || ve === -1 ? null : { start: X, end: ve };
                  } else Q = null;
                }
                Q = Q || { start: 0, end: 0 };
              } else Q = null;
              for (lv = { focusedElem: F, selectionRange: Q }, Uy = !1, cr = te; cr !== null; ) if (F = (te = cr).child, 1024 & te.subtreeFlags && F !== null) F.return = te, cr = F;
              else for (; cr !== null; ) {
                switch (Q = (F = te = cr).alternate, T = F.flags, F.tag) {
                  case 0:
                  case 11:
                  case 15:
                  case 5:
                  case 26:
                  case 27:
                  case 6:
                  case 4:
                  case 17:
                    break;
                  case 1:
                    1024 & T && Q !== null && rb(F, Q);
                    break;
                  case 3:
                    if (1024 & T) {
                      if ((Q = (F = F.stateNode.containerInfo).nodeType) === 9) Or(F);
                      else if (Q === 1) switch (F.nodeName) {
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                          Or(F);
                          break;
                        default:
                          F.textContent = "";
                      }
                    }
                    break;
                  default:
                    if (1024 & T) throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
                }
                if ((F = te.sibling) !== null) {
                  F.return = te.return, cr = F;
                  break;
                }
                cr = te.return;
              }
            })(e, n);
          } finally {
            Dn = f, Fe.p = i, J.T = l;
          }
        }
        Sr = J0, Qm(), vf(), Ym();
      }
      var v, z, j;
    }
    function Qm() {
      if (Sr === J0) {
        Sr = nd;
        var e = cs, n = Rp, r = ds, l = !!(13878 & n.flags);
        if (13878 & n.subtreeFlags || l) {
          l = J.T, J.T = null;
          var i = Fe.p;
          Fe.p = Kr;
          var s = Dn;
          Dn |= gl;
          try {
            Ep = r, xp = e, Mu(n, e), xp = Ep = null, r = lv;
            var f = bg(e.containerInfo), p = r.focusedElem, y = r.selectionRange;
            if (f !== p && p && p.ownerDocument && Xp(p.ownerDocument.documentElement, p)) {
              if (y !== null && As(p)) {
                var v = y.start, z = y.end;
                if (z === void 0 && (z = v), "selectionStart" in p) p.selectionStart = v, p.selectionEnd = Math.min(z, p.value.length);
                else {
                  var j = p.ownerDocument || document, F = j && j.defaultView || window;
                  if (F.getSelection) {
                    var te = F.getSelection(), Q = p.textContent.length, ge = Math.min(y.start, Q), T = y.end === void 0 ? ge : Math.min(y.end, Q);
                    !te.extend && ge > T && (f = T, T = ge, ge = f);
                    var P = Rs(p, ge), D = Rs(p, T);
                    if (P && D && (te.rangeCount !== 1 || te.anchorNode !== P.node || te.anchorOffset !== P.offset || te.focusNode !== D.node || te.focusOffset !== D.offset)) {
                      var X = j.createRange();
                      X.setStart(P.node, P.offset), te.removeAllRanges(), ge > T ? (te.addRange(X), te.extend(D.node, D.offset)) : (X.setEnd(D.node, D.offset), te.addRange(X));
                    }
                  }
                }
              }
              for (j = [], te = p; te = te.parentNode; ) te.nodeType === 1 && j.push({ element: te, left: te.scrollLeft, top: te.scrollTop });
              for (typeof p.focus == "function" && p.focus(), p = 0; p < j.length; p++) {
                var ve = j[p];
                ve.element.scrollLeft = ve.left, ve.element.scrollTop = ve.top;
              }
            }
            Uy = !!av, lv = av = null;
          } finally {
            Dn = s, Fe.p = i, J.T = l;
          }
        }
        e.current = n, Sr = ek;
      }
    }
    function vf() {
      if (Sr === ek) {
        Sr = nd;
        var e = cs, n = Rp, r = ds, l = !!(8772 & n.flags);
        if (8772 & n.subtreeFlags || l) {
          l = J.T, J.T = null;
          var i = Fe.p;
          Fe.p = Kr;
          var s = Dn;
          Dn |= gl;
          try {
            Pe !== null && typeof Pe.markLayoutEffectsStarted == "function" && Pe.markLayoutEffectsStarted(r), Ep = r, xp = e, ac(e, n.alternate, n), xp = Ep = null, Pe !== null && typeof Pe.markLayoutEffectsStopped == "function" && Pe.markLayoutEffectsStopped();
          } finally {
            Dn = s, Fe.p = i, J.T = l;
          }
        }
        Sr = nk;
      }
    }
    function Ym() {
      if (Sr === w1 || Sr === nk) {
        Sr = nd, ub();
        var e = cs, n = Rp, r = ds, l = tk, i = !!(10256 & n.subtreeFlags) || !!(10256 & n.flags);
        i ? Sr = Yb : (Sr = nd, Rp = cs = null, kf(e, e.pendingLanes), td = 0, Xh = null);
        var s = e.pendingLanes;
        if (s === 0 && (ss = null), i || Km(e), i = _t(r), n = n.stateNode, Bn && typeof Bn.onCommitFiberRoot == "function") try {
          var f = !(128 & ~n.current.flags);
          switch (i) {
            case Kr:
              var p = Yf;
              break;
            case vr:
              p = Ac;
              break;
            case Xr:
              p = Yl;
              break;
            case _c:
              p = Nc;
              break;
            default:
              p = Yl;
          }
          Bn.onCommitFiberRoot(Ca, n, p, f);
        } catch (j) {
          Gr || (Gr = !0, console.error("React instrumentation encountered an error: %s", j));
        }
        if (Rt && e.memoizedUpdaters.clear(), g1.forEach(function(j) {
          return j();
        }), l !== null) {
          f = J.T, p = Fe.p, Fe.p = Kr, J.T = null;
          try {
            var y = e.onRecoverableError;
            for (n = 0; n < l.length; n++) {
              var v = l[n], z = tl(v.stack);
              De(v.source, y, v.value, z);
            }
          } finally {
            J.T = f, Fe.p = p;
          }
        }
        3 & ds && Hu(), Tt(e), s = e.pendingLanes, 4194090 & r && 42 & s ? (my = !0, e === Xb ? Kh++ : (Kh = 0, Xb = e)) : Kh = 0, Uu(0), Be();
      }
    }
    function tl(e) {
      return e = { componentStack: e }, Object.defineProperty(e, "digest", { get: function() {
        console.error('You are accessing "digest" from the errorInfo object passed to onRecoverableError. This property is no longer provided as part of errorInfo but can be accessed as a property of the Error instance itself.');
      } }), e;
    }
    function kf(e, n) {
      (e.pooledCacheLanes &= n) === 0 && (n = e.pooledCache) != null && (e.pooledCache = null, vi(n));
    }
    function Hu(e) {
      return Qm(), vf(), Ym(), pa();
    }
    function pa() {
      if (Sr !== Yb) return !1;
      var e = cs, n = Gb;
      Gb = 0;
      var r = _t(ds), l = Xr > r ? Xr : r;
      r = J.T;
      var i = Fe.p;
      try {
        Fe.p = l, J.T = null, l = Kb, Kb = null;
        var s = cs, f = ds;
        if (Sr = nd, Rp = cs = null, ds = 0, (Dn & (no | gl)) !== Mo) throw Error("Cannot flush passive effects while already rendering.");
        $b = !0, Ty = !1, Pe !== null && typeof Pe.markPassiveEffectsStarted == "function" && Pe.markPassiveEffectsStarted(f);
        var p = Dn;
        if (Dn |= gl, ic(s.current), fa(s, s.current, f, l), Pe !== null && typeof Pe.markPassiveEffectsStopped == "function" && Pe.markPassiveEffectsStopped(), Km(s), Dn = p, Uu(0, !1), Ty ? s === Xh ? td++ : (td = 0, Xh = s) : td = 0, Ty = $b = !1, Bn && typeof Bn.onPostCommitFiberRoot == "function") try {
          Bn.onPostCommitFiberRoot(Ca, s);
        } catch (v) {
          Gr || (Gr = !0, console.error("React instrumentation encountered an error: %s", v));
        }
        var y = s.current.stateNode;
        return y.effectDuration = 0, y.passiveEffectDuration = 0, !0;
      } finally {
        Fe.p = i, J.T = r, kf(e, n);
      }
    }
    function Gm(e, n, r) {
      n = Ur(r, n), (e = xo(e, n = nr(e.stateNode, n, 2), 2)) !== null && (Bo(e, 2), Tt(e));
    }
    function Pn(e, n, r) {
      if (Ap = !1, e.tag === 3) Gm(e, e, r);
      else {
        for (; n !== null; ) {
          if (n.tag === 3) return void Gm(n, e, r);
          if (n.tag === 1) {
            var l = n.stateNode;
            if (typeof n.type.getDerivedStateFromError == "function" || typeof l.componentDidCatch == "function" && (ss === null || !ss.has(l))) return e = Ur(r, e), void ((l = xo(n, r = ct(2), 2)) !== null && (Pi(r, l, n, e), Bo(l, 2), Tt(l)));
          }
          n = n.return;
        }
        console.error(`Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Potential causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.

Error message:

%s`, r);
      }
    }
    function Bi(e, n, r) {
      var l = e.pingCache;
      if (l === null) {
        l = e.pingCache = new y1();
        var i = /* @__PURE__ */ new Set();
        l.set(n, i);
      } else (i = l.get(n)) === void 0 && (i = /* @__PURE__ */ new Set(), l.set(n, i));
      i.has(r) || (Wb = !0, i.add(r), l = ft.bind(null, e, n, r), Rt && ol(e, r), n.then(l, l));
    }
    function ft(e, n, r) {
      var l = e.pingCache;
      l !== null && l.delete(n), e.pingedLanes |= e.suspendedLanes & r, e.warmLanes &= ~r, sc() && J.actQueue === null && console.error(`A suspended resource finished loading inside a test, but the event was not wrapped in act(...).

When testing, code that resolves suspended data should be wrapped into act(...):

act(() => {
  /* finish loading suspended data */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://react.dev/link/wrap-tests-with-act`), Kn === e && (vn & r) === r && (xt === $c || xt === Ub && (62914560 & vn) === vn && xa() - Qb < $0 ? (Dn & no) === Mo && Hi(e, 0) : qb |= r, ed === vn && (ed = 0)), Tt(e);
    }
    function Ig(e, n) {
      n === 0 && (n = yl()), (e = Cr(e, n)) !== null && (Bo(e, n), Tt(e));
    }
    function ob(e) {
      var n = e.memoizedState, r = 0;
      n !== null && (r = n.retryLane), Ig(e, r);
    }
    function Mg(e, n) {
      var r = 0;
      switch (e.tag) {
        case 13:
          var l = e.stateNode, i = e.memoizedState;
          i !== null && (r = i.retryLane);
          break;
        case 19:
          l = e.stateNode;
          break;
        case 22:
          l = e.stateNode._retryCache;
          break;
        default:
          throw Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
      }
      l !== null && l.delete(n), Ig(e, r);
    }
    function Vi(e, n, r) {
      if (67117056 & n.subtreeFlags) for (n = n.child; n !== null; ) {
        var l = e, i = n, s = i.type === Tc;
        s = r || s, i.tag !== 22 ? 67108864 & i.flags ? s && De(i, rl, l, i, (i.mode & Gv) === Jn) : Vi(l, i, s) : i.memoizedState === null && (s && 8192 & i.flags ? De(i, rl, l, i) : 67108864 & i.subtreeFlags && De(i, Vi, l, i, s)), n = n.sibling;
      }
    }
    function rl(e, n) {
      var r = !(2 < arguments.length && arguments[2] !== void 0) || arguments[2];
      Ce(!0);
      try {
        Di(n), r && Mm(n), qr(e, n.alternate, n, !1), r && lc(e, n, 0, null, !1);
      } finally {
        Ce(!1);
      }
    }
    function Km(e) {
      var n = !0;
      e.current.mode & (Dr | fl) || (n = !1), Vi(e, e.current, n);
    }
    function Xm(e) {
      if ((Dn & no) === Mo) {
        var n = e.tag;
        if (n === 3 || n === 1 || n === 0 || n === 11 || n === 14 || n === 15) {
          if (n = Ee(e) || "ReactComponent", Py !== null) {
            if (Py.has(n)) return;
            Py.add(n);
          } else Py = /* @__PURE__ */ new Set([n]);
          De(e, function() {
            console.error("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
          });
        }
      }
    }
    function ol(e, n) {
      Rt && e.memoizedUpdaters.forEach(function(r) {
        ks(e, r, n);
      });
    }
    function Tt(e) {
      e !== Np && e.next === null && (Np === null ? Ry = Np = e : Np = Np.next = e), Ay = !0, J.actQueue !== null ? Jb || (Jb = !0, ma()) : Zb || (Zb = !0, ma());
    }
    function Uu(e, n) {
      if (!ev && Ay) {
        ev = !0;
        do
          for (var r = !1, l = Ry; l !== null; ) {
            if (e !== 0) {
              var i = l.pendingLanes;
              if (i === 0) var s = 0;
              else {
                var f = l.suspendedLanes, p = l.pingedLanes;
                s = (1 << 31 - St(42 | e) + 1) - 1, s = 201326741 & (s &= i & ~(f & ~p)) ? 201326741 & s | 1 : s ? 2 | s : 0;
              }
              s !== 0 && (r = !0, mc(l, s));
            } else s = vn, !(3 & (s = Ua(l, l === Kn ? s : 0, l.cancelPendingCommit !== null || l.timeoutHandle !== ad))) || Uo(l, s) || (r = !0, mc(l, s));
            l = l.next;
          }
        while (r);
        ev = !1;
      }
    }
    function $m() {
      wf();
    }
    function wf() {
      Ay = Jb = Zb = !1;
      var e = 0;
      rd !== 0 && (function() {
        var f = window.event;
        return f && f.type === "popstate" ? f !== iv && (iv = f, !0) : (iv = null, !1);
      }() && (e = rd), rd = 0);
      for (var n = xa(), r = null, l = Ry; l !== null; ) {
        var i = l.next, s = Sf(l, n);
        s === 0 ? (l.next = null, r === null ? Ry = i : r.next = i, i === null && (Np = r)) : (r = l, (e !== 0 || 3 & s) && (Ay = !0)), l = i;
      }
      Uu(e);
    }
    function Sf(e, n) {
      for (var r = e.suspendedLanes, l = e.pingedLanes, i = e.expirationTimes, s = -62914561 & e.pendingLanes; 0 < s; ) {
        var f = 31 - St(s), p = 1 << f, y = i[f];
        y === -1 ? (p & r) !== 0 && (p & l) === 0 || (i[f] = oo(p, n)) : y <= n && (e.expiredLanes |= p), s &= ~p;
      }
      if (r = vn, r = Ua(e, e === (n = Kn) ? r : 0, e.cancelPendingCommit !== null || e.timeoutHandle !== ad), l = e.callbackNode, r === 0 || e === n && (Mn === Zc || Mn === Jc) || e.cancelPendingCommit !== null) return l !== null && xf(l), e.callbackNode = null, e.callbackPriority = 0;
      if (!(3 & r) || Uo(e, r)) {
        if ((n = r & -r) === e.callbackPriority && (J.actQueue === null || l === nv)) return n;
        switch (xf(l), _t(r)) {
          case Kr:
          case vr:
            r = Ac;
            break;
          case Xr:
            r = Yl;
            break;
          case _c:
            r = Nc;
            break;
          default:
            r = Yl;
        }
        return l = Ef.bind(null, e), J.actQueue !== null ? (J.actQueue.push(l), r = nv) : r = Qf(r, l), e.callbackPriority = n, e.callbackNode = r, n;
      }
      return l !== null && xf(l), e.callbackPriority = 2, e.callbackNode = null, 2;
    }
    function Ef(e, n) {
      if (my = py = !1, Sr !== nd && Sr !== Yb) return e.callbackNode = null, e.callbackPriority = 0, null;
      var r = e.callbackNode;
      if (Hu() && e.callbackNode !== r) return null;
      var l = vn;
      return (l = Ua(e, e === Kn ? l : 0, e.cancelPendingCommit !== null || e.timeoutHandle !== ad)) === 0 ? null : (Hm(e, l, n), Sf(e, xa()), e.callbackNode != null && e.callbackNode === r ? Ef.bind(null, e) : null);
    }
    function mc(e, n) {
      if (Hu()) return null;
      py = my, my = !1, Hm(e, n, !0);
    }
    function xf(e) {
      e !== nv && e !== null && ib(e);
    }
    function ma() {
      J.actQueue !== null && J.actQueue.push(function() {
        return wf(), null;
      }), L1(function() {
        (Dn & (no | gl)) !== Mo ? Qf(Yf, $m) : wf();
      });
    }
    function lt() {
      return rd === 0 && (rd = rn()), rd;
    }
    function Cf(e) {
      return e == null || typeof e == "symbol" || typeof e == "boolean" ? null : typeof e == "function" ? e : (ce(e, "action"), wl("" + e));
    }
    function Zm(e, n) {
      var r = n.ownerDocument.createElement("input");
      return r.name = n.name, r.value = n.value, e.id && r.setAttribute("form", e.id), n.parentNode.insertBefore(r, n), e = new FormData(e), r.parentNode.removeChild(r), e;
    }
    function ht(e, n, r) {
      e.currentTarget = r;
      try {
        n(e);
      } catch (l) {
        Fb(l);
      }
      e.currentTarget = null;
    }
    function Jm(e, n) {
      n = !!(4 & n);
      for (var r = 0; r < e.length; r++) {
        var l = e[r];
        e: {
          var i = void 0, s = l.event;
          if (l = l.listeners, n) for (var f = l.length - 1; 0 <= f; f--) {
            var p = l[f], y = p.instance, v = p.currentTarget;
            if (p = p.listener, y !== i && s.isPropagationStopped()) break e;
            y !== null ? De(y, ht, s, p, v) : ht(s, p, v), i = y;
          }
          else for (f = 0; f < l.length; f++) {
            if (y = (p = l[f]).instance, v = p.currentTarget, p = p.listener, y !== i && s.isPropagationStopped()) break e;
            y !== null ? De(y, ht, s, p, v) : ht(s, p, v), i = y;
          }
        }
      }
    }
    function fn(e, n) {
      tv.has(e) || console.error('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.', e);
      var r = n[Gf];
      r === void 0 && (r = n[Gf] = /* @__PURE__ */ new Set());
      var l = e + "__bubble";
      r.has(l) || (ha(n, e, 2, !1), r.add(l));
    }
    function Gn(e, n, r) {
      tv.has(e) && !n && console.error('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.', e);
      var l = 0;
      n && (l |= 4), ha(r, e, l, n);
    }
    function or(e) {
      if (!e[Ny]) {
        e[Ny] = !0, Lc.forEach(function(r) {
          r !== "selectionchange" && (tv.has(r) || Gn(r, !1, e), Gn(r, !0, e));
        });
        var n = e.nodeType === 9 ? e : e.ownerDocument;
        n === null || n[Ny] || (n[Ny] = !0, Gn("selectionchange", !1, n));
      }
    }
    function ha(e, n, r, l) {
      switch (uh(n)) {
        case Kr:
          var i = Qg;
          break;
        case vr:
          i = Yg;
          break;
        default:
          i = jf;
      }
      r = i.bind(null, n, r, e), i = void 0, !xe || n !== "touchstart" && n !== "touchmove" && n !== "wheel" || (i = !0), l ? i !== void 0 ? e.addEventListener(n, r, { capture: !0, passive: i }) : e.addEventListener(n, r, !0) : i !== void 0 ? e.addEventListener(n, r, { passive: i }) : e.addEventListener(n, r, !1);
    }
    function Tf(e, n, r, l, i) {
      var s = l;
      if (!(1 & n || 2 & n || l === null)) e: for (; ; ) {
        if (l === null) return;
        var f = l.tag;
        if (f === 3 || f === 4) {
          var p = l.stateNode.containerInfo;
          if (p === i) break;
          if (f === 4) for (f = l.return; f !== null; ) {
            var y = f.tag;
            if ((y === 3 || y === 4) && f.stateNode.containerInfo === i) return;
            f = f.return;
          }
          for (; p !== null; ) {
            if ((f = bo(p)) === null) return;
            if ((y = f.tag) === 5 || y === 6 || y === 26 || y === 27) {
              l = s = f;
              continue e;
            }
            p = p.parentNode;
          }
        }
        l = l.return;
      }
      ci(function() {
        var v = s, z = xs(r), j = [];
        e: {
          var F = Yv.get(e);
          if (F !== void 0) {
            var te = Zn, Q = e;
            switch (e) {
              case "keypress":
                if (gu(r) === 0) break e;
              case "keydown":
              case "keyup":
                te = Qw;
                break;
              case "focusin":
                Q = "focus", te = pb;
                break;
              case "focusout":
                Q = "blur", te = pb;
                break;
              case "beforeblur":
              case "afterblur":
                te = pb;
                break;
              case "click":
                if (r.button === 2) break e;
              case "auxclick":
              case "dblclick":
              case "mousedown":
              case "mousemove":
              case "mouseup":
              case "mouseout":
              case "mouseover":
              case "contextmenu":
                te = xh;
                break;
              case "drag":
              case "dragend":
              case "dragenter":
              case "dragexit":
              case "dragleave":
              case "dragover":
              case "dragstart":
              case "drop":
                te = Vc;
                break;
              case "touchcancel":
              case "touchend":
              case "touchmove":
              case "touchstart":
                te = Yw;
                break;
              case Vv:
              case Wv:
              case qv:
                te = Hw;
                break;
              case Qv:
                te = Gw;
                break;
              case "scroll":
              case "scrollend":
                te = zr;
                break;
              case "wheel":
                te = Kw;
                break;
              case "copy":
              case "cut":
              case "paste":
                te = Uw;
                break;
              case "gotpointercapture":
              case "lostpointercapture":
              case "pointercancel":
              case "pointerdown":
              case "pointermove":
              case "pointerout":
              case "pointerover":
              case "pointerup":
                te = Dv;
                break;
              case "toggle":
              case "beforetoggle":
                te = Xw;
            }
            var ge = !!(4 & n), T = !ge && (e === "scroll" || e === "scrollend"), P = ge ? F !== null ? F + "Capture" : null : F;
            ge = [];
            for (var D, X = v; X !== null; ) {
              var ve = X;
              if (D = ve.stateNode, (ve = ve.tag) !== 5 && ve !== 26 && ve !== 27 || D === null || P === null || (ve = qo(X, P)) != null && ge.push(Bu(X, ve, D)), T) break;
              X = X.return;
            }
            0 < ge.length && (F = new te(F, Q, null, r, z), j.push({ event: F, listeners: ge }));
          }
        }
        if (!(7 & n)) {
          if (te = e === "mouseout" || e === "pointerout", (!(F = e === "mouseover" || e === "pointerover") || r === de || !(Q = r.relatedTarget || r.fromElement) || !bo(Q) && !Q[Io]) && (te || F) && (F = z.window === z ? z : (F = z.ownerDocument) ? F.defaultView || F.parentWindow : window, te ? (te = v, (Q = (Q = r.relatedTarget || r.toElement) ? bo(Q) : null) !== null && (T = oe(Q), ge = Q.tag, Q !== T || ge !== 5 && ge !== 27 && ge !== 6) && (Q = null)) : (te = null, Q = v), te !== Q)) {
            if (ge = xh, ve = "onMouseLeave", P = "onMouseEnter", X = "mouse", e !== "pointerout" && e !== "pointerover" || (ge = Dv, ve = "onPointerLeave", P = "onPointerEnter", X = "pointer"), T = te == null ? F : Vo(te), D = Q == null ? F : Vo(Q), (F = new ge(ve, X + "leave", te, r, z)).target = T, F.relatedTarget = D, ve = null, bo(z) === v && ((ge = new ge(P, X + "enter", Q, r, z)).target = D, ge.relatedTarget = T, ve = ge), T = ve, te && Q) e: {
              for (P = Q, X = 0, D = ge = te; D; D = Wt(D)) X++;
              for (D = 0, ve = P; ve; ve = Wt(ve)) D++;
              for (; 0 < X - D; ) ge = Wt(ge), X--;
              for (; 0 < D - X; ) P = Wt(P), D--;
              for (; X--; ) {
                if (ge === P || P !== null && ge === P.alternate) break e;
                ge = Wt(ge), P = Wt(P);
              }
              ge = null;
            }
            else ge = null;
            te !== null && po(j, F, te, ge, !1), Q !== null && T !== null && po(j, T, Q, ge, !0);
          }
          if ((te = (F = v ? Vo(v) : window).nodeName && F.nodeName.toLowerCase()) === "select" || te === "input" && F.type === "file") var pn = Gp;
          else if (Ts(F)) if (Uv) pn = Td;
          else {
            pn = Ps;
            var kn = Kp;
          }
          else !(te = F.nodeName) || te.toLowerCase() !== "input" || F.type !== "checkbox" && F.type !== "radio" ? v && hu(v.elementType) && (pn = Gp) : pn = pi;
          switch (pn && (pn = pn(e, v)) ? Yp(j, pn, r, z) : (kn && kn(e, F, v), e === "focusout" && v && F.type === "number" && v.memoizedProps.value != null && md(F, "number", F.value)), kn = v ? Vo(v) : window, e) {
            case "focusin":
              (Ts(kn) || kn.contentEditable === "true") && (ap = kn, hb = v, Ph = null);
              break;
            case "focusout":
              Ph = hb = ap = null;
              break;
            case "mousedown":
              gb = !0;
              break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
              gb = !1, vg(j, r, z);
              break;
            case "selectionchange":
              if (e1) break;
            case "keydown":
            case "keyup":
              vg(j, r, z);
          }
          var je;
          if (mb) e: {
            switch (e) {
              case "compositionstart":
                var We = "onCompositionStart";
                break e;
              case "compositionend":
                We = "onCompositionEnd";
                break e;
              case "compositionupdate":
                We = "onCompositionUpdate";
                break e;
            }
            We = void 0;
          }
          else op ? Sl(e, r) && (We = "onCompositionEnd") : e === "keydown" && r.keyCode === Fv && (We = "onCompositionStart");
          We && (Iv && r.locale !== "ko" && (op || We !== "onCompositionStart" ? We === "onCompositionEnd" && op && (je = qp()) : (Cn = "value" in (ln = z) ? ln.value : ln.textContent, op = !0)), 0 < (kn = Vu(v, We)).length && (We = new zv(We, e, null, r, z), j.push({ event: We, listeners: kn }), (je || (je = Ed(r)) !== null) && (We.data = je))), (je = Zw ? function(sn, On) {
            switch (sn) {
              case "compositionend":
                return Ed(On);
              case "keypress":
                return On.which !== Mv ? null : (Hv = !0, jv);
              case "textInput":
                return (sn = On.data) === jv && Hv ? null : sn;
              default:
                return null;
            }
          }(e, r) : function(sn, On) {
            if (op) return sn === "compositionend" || !mb && Sl(sn, On) ? (sn = qp(), Ne = Cn = ln = null, op = !1, sn) : null;
            switch (sn) {
              case "paste":
              default:
                return null;
              case "keypress":
                if (!(On.ctrlKey || On.altKey || On.metaKey) || On.ctrlKey && On.altKey) {
                  if (On.char && 1 < On.char.length) return On.char;
                  if (On.which) return String.fromCharCode(On.which);
                }
                return null;
              case "compositionend":
                return Iv && On.locale !== "ko" ? null : On.data;
            }
          }(e, r)) && 0 < (We = Vu(v, "onBeforeInput")).length && (kn = new Bw("onBeforeInput", "beforeinput", null, r, z), j.push({ event: kn, listeners: We }), kn.data = je), function(sn, On, dr, Ht, Xe) {
            if (On === "submit" && dr && dr.stateNode === Xe) {
              var nn = Cf((Xe[ir] || null).action), $e = Ht.submitter;
              $e && (On = (On = $e[ir] || null) ? Cf(On.formAction) : $e.getAttribute("formAction")) !== null && (nn = On, $e = null);
              var bt = new Zn("action", "action", null, Ht, Xe);
              sn.push({ event: bt, listeners: [{ instance: null, listener: function() {
                if (Ht.defaultPrevented) {
                  if (rd !== 0) {
                    var nt = $e ? Zm(Xe, $e) : new FormData(Xe), ro = { pending: !0, data: nt, method: Xe.method, action: nn };
                    Object.freeze(ro), xi(dr, ro, null, nt);
                  }
                } else typeof nn == "function" && (bt.preventDefault(), ro = { pending: !0, data: nt = $e ? Zm(Xe, $e) : new FormData(Xe), method: Xe.method, action: nn }, Object.freeze(ro), xi(dr, ro, nn, nt));
              }, currentTarget: Xe }] });
            }
          }(j, e, v, r, z);
        }
        Jm(j, n);
      });
    }
    function Bu(e, n, r) {
      return { instance: e, listener: n, currentTarget: r };
    }
    function Vu(e, n) {
      for (var r = n + "Capture", l = []; e !== null; ) {
        var i = e, s = i.stateNode;
        if ((i = i.tag) !== 5 && i !== 26 && i !== 27 || s === null || ((i = qo(e, r)) != null && l.unshift(Bu(e, i, s)), (i = qo(e, n)) != null && l.push(Bu(e, i, s))), e.tag === 3) return l;
        e = e.return;
      }
      return [];
    }
    function Wt(e) {
      if (e === null) return null;
      do
        e = e.return;
      while (e && e.tag !== 5 && e.tag !== 27);
      return e || null;
    }
    function po(e, n, r, l, i) {
      for (var s = n._reactName, f = []; r !== null && r !== l; ) {
        var p = r, y = p.alternate, v = p.stateNode;
        if (p = p.tag, y !== null && y === l) break;
        p !== 5 && p !== 26 && p !== 27 || v === null || (y = v, i ? (v = qo(r, s)) != null && f.unshift(Bu(r, v, y)) : i || (v = qo(r, s)) != null && f.push(Bu(r, v, y))), r = r.return;
      }
      f.length !== 0 && e.push({ event: n, listeners: f });
    }
    function Pf(e, n) {
      (function(l, i) {
        var s, f = [];
        for (s in i) eb(l, s) || f.push(s);
        i = f.map(function(p) {
          return "`" + p + "`";
        }).join(", "), f.length === 1 ? console.error("Invalid aria prop %s on <%s> tag. For details, see https://react.dev/link/invalid-aria-props", i, l) : 1 < f.length && console.error("Invalid aria props %s on <%s> tag. For details, see https://react.dev/link/invalid-aria-props", i, l);
      })(e, n), e !== "input" && e !== "textarea" && e !== "select" || n == null || n.value !== null || h || (h = !0, e === "select" && n.multiple ? console.error("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", e) : console.error("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", e));
      var r = { registrationNameDependencies: Ta, possibleRegistrationNames: zc };
      hu(e) || typeof n.is == "string" || function(l, i, s) {
        var f, p = [];
        for (f in i) nb(l, f, i[f], s) || p.push(f);
        i = p.map(function(y) {
          return "`" + y + "`";
        }).join(", "), p.length === 1 ? console.error("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://react.dev/link/attribute-behavior ", i, l) : 1 < p.length && console.error("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://react.dev/link/attribute-behavior ", i, l);
      }(e, n, r), n.contentEditable && !n.suppressContentEditableWarning && n.children != null && console.error("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional.");
    }
    function zn(e, n, r, l) {
      n !== r && (r = Qr(r), Qr(n) !== r && (l[e] = n));
    }
    function No(e, n) {
      n === !1 ? console.error("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", e, e, e) : console.error("Expected `%s` listener to be a function, instead got a value of `%s` type.", e, typeof n);
    }
    function al(e, n) {
      return (e = e.namespaceURI === eu || e.namespaceURI === t ? e.ownerDocument.createElementNS(e.namespaceURI, e.tagName) : e.ownerDocument.createElement(e.tagName)).innerHTML = n, e.innerHTML;
    }
    function Qr(e) {
      return ae(e) && (console.error("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before using it here.", $(e)), me(e)), (typeof e == "string" ? e : "" + e).replace(x1, `
`).replace(C1, "");
    }
    function ll(e, n) {
      return n = Qr(n), Qr(e) === n;
    }
    function Wu() {
    }
    function Nn(e, n, r, l, i, s) {
      switch (r) {
        case "children":
          typeof l == "string" ? (Es(l, n, !1), n === "body" || n === "textarea" && l === "" || Wo(e, l)) : typeof l != "number" && typeof l != "bigint" || (Es("" + l, n, !1), n !== "body" && Wo(e, "" + l));
          break;
        case "className":
          Ze(e, "class", l);
          break;
        case "tabIndex":
          Ze(e, "tabindex", l);
          break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
          Ze(e, r, l);
          break;
        case "style":
          Wp(e, l, s);
          break;
        case "data":
          if (n !== "object") {
            Ze(e, "data", l);
            break;
          }
        case "src":
        case "href":
          if (l === "" && (n !== "a" || r !== "href")) {
            console.error(r === "src" ? 'An empty string ("") was passed to the %s attribute. This may cause the browser to download the whole page again over the network. To fix this, either do not render the element at all or pass null to %s instead of an empty string.' : 'An empty string ("") was passed to the %s attribute. To fix this, either do not render the element at all or pass null to %s instead of an empty string.', r, r), e.removeAttribute(r);
            break;
          }
          if (l == null || typeof l == "function" || typeof l == "symbol" || typeof l == "boolean") {
            e.removeAttribute(r);
            break;
          }
          ce(l, r), l = wl("" + l), e.setAttribute(r, l);
          break;
        case "action":
        case "formAction":
          if (l != null && (n === "form" ? r === "formAction" ? console.error("You can only pass the formAction prop to <input> or <button>. Use the action prop on <form>.") : typeof l == "function" && (i.encType == null && i.method == null || Ly || (Ly = !0, console.error("Cannot specify a encType or method for a form that specifies a function as the action. React provides those automatically. They will get overridden.")), i.target == null || Oy || (Oy = !0, console.error("Cannot specify a target for a form that specifies a function as the action. The function will always be executed in the same window."))) : n === "input" || n === "button" ? r === "action" ? console.error("You can only pass the action prop to <form>. Use the formAction prop on <input> or <button>.") : n !== "input" || i.type === "submit" || i.type === "image" || _y ? n !== "button" || i.type == null || i.type === "submit" || _y ? typeof l == "function" && (i.name == null || ik || (ik = !0, console.error('Cannot specify a "name" prop for a button that specifies a function as a formAction. React needs it to encode which action should be invoked. It will get overridden.')), i.formEncType == null && i.formMethod == null || Ly || (Ly = !0, console.error("Cannot specify a formEncType or formMethod for a button that specifies a function as a formAction. React provides those automatically. They will get overridden.")), i.formTarget == null || Oy || (Oy = !0, console.error("Cannot specify a formTarget for a button that specifies a function as a formAction. The function will always be executed in the same window."))) : (_y = !0, console.error('A button can only specify a formAction along with type="submit" or no type.')) : (_y = !0, console.error('An input can only specify a formAction along with type="submit" or type="image".')) : console.error(r === "action" ? "You can only pass the action prop to <form>." : "You can only pass the formAction prop to <input> or <button>.")), typeof l == "function") {
            e.setAttribute(r, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
            break;
          }
          if (typeof s == "function" && (r === "formAction" ? (n !== "input" && Nn(e, n, "name", i.name, i, null), Nn(e, n, "formEncType", i.formEncType, i, null), Nn(e, n, "formMethod", i.formMethod, i, null), Nn(e, n, "formTarget", i.formTarget, i, null)) : (Nn(e, n, "encType", i.encType, i, null), Nn(e, n, "method", i.method, i, null), Nn(e, n, "target", i.target, i, null))), l == null || typeof l == "symbol" || typeof l == "boolean") {
            e.removeAttribute(r);
            break;
          }
          ce(l, r), l = wl("" + l), e.setAttribute(r, l);
          break;
        case "onClick":
          l != null && (typeof l != "function" && No(r, l), e.onclick = Wu);
          break;
        case "onScroll":
          l != null && (typeof l != "function" && No(r, l), fn("scroll", e));
          break;
        case "onScrollEnd":
          l != null && (typeof l != "function" && No(r, l), fn("scrollend", e));
          break;
        case "dangerouslySetInnerHTML":
          if (l != null) {
            if (typeof l != "object" || !("__html" in l)) throw Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://react.dev/link/dangerously-set-inner-html for more information.");
            if ((r = l.__html) != null) {
              if (i.children != null) throw Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
              e.innerHTML = r;
            }
          }
          break;
        case "multiple":
          e.multiple = l && typeof l != "function" && typeof l != "symbol";
          break;
        case "muted":
          e.muted = l && typeof l != "function" && typeof l != "symbol";
          break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
        case "autoFocus":
          break;
        case "xlinkHref":
          if (l == null || typeof l == "function" || typeof l == "boolean" || typeof l == "symbol") {
            e.removeAttribute("xlink:href");
            break;
          }
          ce(l, r), r = wl("" + l), e.setAttributeNS(od, "xlink:href", r);
          break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
          l != null && typeof l != "function" && typeof l != "symbol" ? (ce(l, r), e.setAttribute(r, "" + l)) : e.removeAttribute(r);
          break;
        case "inert":
          l !== "" || zy[r] || (zy[r] = !0, console.error("Received an empty string for a boolean attribute `%s`. This will treat the attribute as if it were false. Either pass `false` to silence this warning, or pass `true` if you used an empty string in earlier versions of React to indicate this attribute is true.", r));
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
          l && typeof l != "function" && typeof l != "symbol" ? e.setAttribute(r, "") : e.removeAttribute(r);
          break;
        case "capture":
        case "download":
          l === !0 ? e.setAttribute(r, "") : l !== !1 && l != null && typeof l != "function" && typeof l != "symbol" ? (ce(l, r), e.setAttribute(r, l)) : e.removeAttribute(r);
          break;
        case "cols":
        case "rows":
        case "size":
        case "span":
          l != null && typeof l != "function" && typeof l != "symbol" && !isNaN(l) && 1 <= l ? (ce(l, r), e.setAttribute(r, l)) : e.removeAttribute(r);
          break;
        case "rowSpan":
        case "start":
          l == null || typeof l == "function" || typeof l == "symbol" || isNaN(l) ? e.removeAttribute(r) : (ce(l, r), e.setAttribute(r, l));
          break;
        case "popover":
          fn("beforetoggle", e), fn("toggle", e), wn(e, "popover", l);
          break;
        case "xlinkActuate":
          tn(e, od, "xlink:actuate", l);
          break;
        case "xlinkArcrole":
          tn(e, od, "xlink:arcrole", l);
          break;
        case "xlinkRole":
          tn(e, od, "xlink:role", l);
          break;
        case "xlinkShow":
          tn(e, od, "xlink:show", l);
          break;
        case "xlinkTitle":
          tn(e, od, "xlink:title", l);
          break;
        case "xlinkType":
          tn(e, od, "xlink:type", l);
          break;
        case "xmlBase":
          tn(e, rv, "xml:base", l);
          break;
        case "xmlLang":
          tn(e, rv, "xml:lang", l);
          break;
        case "xmlSpace":
          tn(e, rv, "xml:space", l);
          break;
        case "is":
          s != null && console.error('Cannot update the "is" prop after it has been initialized.'), wn(e, "is", l);
          break;
        case "innerText":
        case "textContent":
          break;
        case "popoverTarget":
          uk || l == null || typeof l != "object" || (uk = !0, console.error("The `popoverTarget` prop expects the ID of an Element as a string. Received %s instead.", l));
        default:
          !(2 < r.length) || r[0] !== "o" && r[0] !== "O" || r[1] !== "n" && r[1] !== "N" ? wn(e, r = wd(r), l) : Ta.hasOwnProperty(r) && l != null && typeof l != "function" && No(r, l);
      }
    }
    function ga(e, n, r, l, i, s) {
      switch (r) {
        case "style":
          Wp(e, l, s);
          break;
        case "dangerouslySetInnerHTML":
          if (l != null) {
            if (typeof l != "object" || !("__html" in l)) throw Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://react.dev/link/dangerously-set-inner-html for more information.");
            if ((r = l.__html) != null) {
              if (i.children != null) throw Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
              e.innerHTML = r;
            }
          }
          break;
        case "children":
          typeof l == "string" ? Wo(e, l) : (typeof l == "number" || typeof l == "bigint") && Wo(e, "" + l);
          break;
        case "onScroll":
          l != null && (typeof l != "function" && No(r, l), fn("scroll", e));
          break;
        case "onScrollEnd":
          l != null && (typeof l != "function" && No(r, l), fn("scrollend", e));
          break;
        case "onClick":
          l != null && (typeof l != "function" && No(r, l), e.onclick = Wu);
          break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
        case "innerText":
        case "textContent":
          break;
        default:
          Ta.hasOwnProperty(r) ? l != null && typeof l != "function" && No(r, l) : r[0] !== "o" || r[1] !== "n" || (i = r.endsWith("Capture"), n = r.slice(2, i ? r.length - 7 : void 0), typeof (s = (s = e[ir] || null) != null ? s[r] : null) == "function" && e.removeEventListener(n, s, i), typeof l != "function") ? r in e ? e[r] = l : l === !0 ? e.setAttribute(r, "") : wn(e, r, l) : (typeof s != "function" && s !== null && (r in e ? e[r] = null : e.hasAttribute(r) && e.removeAttribute(r)), e.addEventListener(n, l, i));
      }
    }
    function zt(e, n, r) {
      switch (Pf(n, r), n) {
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
          break;
        case "img":
          fn("error", e), fn("load", e);
          var l, i = !1, s = !1;
          for (l in r) if (r.hasOwnProperty(l)) {
            var f = r[l];
            if (f != null) switch (l) {
              case "src":
                i = !0;
                break;
              case "srcSet":
                s = !0;
                break;
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(n + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
              default:
                Nn(e, n, l, f, r, null);
            }
          }
          return s && Nn(e, n, "srcSet", r.srcSet, r, null), void (i && Nn(e, n, "src", r.src, r, null));
        case "input":
          Le("input", r), fn("invalid", e);
          var p = l = f = s = null, y = null, v = null;
          for (i in r) if (r.hasOwnProperty(i)) {
            var z = r[i];
            if (z != null) switch (i) {
              case "name":
                s = z;
                break;
              case "type":
                f = z;
                break;
              case "checked":
                y = z;
                break;
              case "defaultChecked":
                v = z;
                break;
              case "value":
                l = z;
                break;
              case "defaultValue":
                p = z;
                break;
              case "children":
              case "dangerouslySetInnerHTML":
                if (z != null) throw Error(n + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
                break;
              default:
                Nn(e, n, i, z, r, null);
            }
          }
          return ai(0, r), Mp(e, l, p, y, v, f, s, !1), void pu(e);
        case "select":
          for (s in Le("select", r), fn("invalid", e), i = f = l = null, r) if (r.hasOwnProperty(s) && (p = r[s]) != null) switch (s) {
            case "value":
              l = p;
              break;
            case "defaultValue":
              f = p;
              break;
            case "multiple":
              i = p;
            default:
              Nn(e, n, s, p, r, null);
          }
          return jp(e, r), n = l, r = f, e.multiple = !!i, void (n != null ? kl(e, !!i, n, !1) : r != null && kl(e, !!i, r, !0));
        case "textarea":
          for (f in Le("textarea", r), fn("invalid", e), l = s = i = null, r) if (r.hasOwnProperty(f) && (p = r[f]) != null) switch (f) {
            case "value":
              i = p;
              break;
            case "defaultValue":
              s = p;
              break;
            case "children":
              l = p;
              break;
            case "dangerouslySetInnerHTML":
              if (p != null) throw Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
              break;
            default:
              Nn(e, n, f, p, r, null);
          }
          return mg(0, r), Up(e, i, s, l), void pu(e);
        case "option":
          for (y in vl(0, r), r) r.hasOwnProperty(y) && (i = r[y]) != null && (y === "selected" ? e.selected = i && typeof i != "function" && typeof i != "symbol" : Nn(e, n, y, i, r, null));
          return;
        case "dialog":
          fn("beforetoggle", e), fn("toggle", e), fn("cancel", e), fn("close", e);
          break;
        case "iframe":
        case "object":
          fn("load", e);
          break;
        case "video":
        case "audio":
          for (i = 0; i < $h.length; i++) fn($h[i], e);
          break;
        case "image":
          fn("error", e), fn("load", e);
          break;
        case "details":
          fn("toggle", e);
          break;
        case "embed":
        case "source":
        case "link":
          fn("error", e), fn("load", e);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
          for (v in r) if (r.hasOwnProperty(v) && (i = r[v]) != null) switch (v) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw Error(n + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
            default:
              Nn(e, n, v, i, r, null);
          }
          return;
        default:
          if (hu(n)) {
            for (z in r) r.hasOwnProperty(z) && (i = r[z]) !== void 0 && ga(e, n, z, i, r, void 0);
            return;
          }
      }
      for (p in r) r.hasOwnProperty(p) && (i = r[p]) != null && Nn(e, n, p, i, r, null);
    }
    function Wi(e) {
      switch (e) {
        case "class":
          return "className";
        case "for":
          return "htmlFor";
        default:
          return e;
      }
    }
    function qi(e) {
      var n = {};
      e = e.style;
      for (var r = 0; r < e.length; r++) {
        var l = e[r];
        n[l] = e.getPropertyValue(l);
      }
      return n;
    }
    function qu(e, n, r) {
      if (n != null && typeof n != "object") console.error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
      else {
        var l, i, s = l = "";
        for (i in n) if (n.hasOwnProperty(i)) {
          var f = n[i];
          f != null && typeof f != "boolean" && f !== "" && (i.indexOf("--") === 0 ? (Te(f, i), l += s + i + ":" + ("" + f).trim()) : typeof f != "number" || f === 0 || ly.has(i) ? (Te(f, i), l += s + i.replace(Hc, "-$1").toLowerCase().replace(wh, "-ms-") + ":" + ("" + f).trim()) : l += s + i.replace(Hc, "-$1").toLowerCase().replace(wh, "-ms-") + ":" + f + "px", s = ";");
        }
        l = l || null, (n = e.getAttribute("style")) !== l && (l = Qr(l), Qr(n) !== l && (r.style = qi(e)));
      }
    }
    function ar(e, n, r, l, i, s) {
      if (i.delete(r), (e = e.getAttribute(r)) === null) switch (typeof l) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          return;
      }
      else if (l != null) switch (typeof l) {
        case "function":
        case "symbol":
        case "boolean":
          break;
        default:
          if (ce(l, n), e === "" + l) return;
      }
      zn(n, e, l, s);
    }
    function eh(e, n, r, l, i, s) {
      if (i.delete(r), (e = e.getAttribute(r)) === null) {
        switch (typeof l) {
          case "function":
          case "symbol":
            return;
        }
        if (!l) return;
      } else switch (typeof l) {
        case "function":
        case "symbol":
          break;
        default:
          if (l) return;
      }
      zn(n, e, l, s);
    }
    function Rf(e, n, r, l, i, s) {
      if (i.delete(r), (e = e.getAttribute(r)) === null) switch (typeof l) {
        case "undefined":
        case "function":
        case "symbol":
          return;
      }
      else if (l != null) switch (typeof l) {
        case "function":
        case "symbol":
          break;
        default:
          if (ce(l, r), e === "" + l) return;
      }
      zn(n, e, l, s);
    }
    function Af(e, n, r, l, i, s) {
      if (i.delete(r), (e = e.getAttribute(r)) === null) switch (typeof l) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          return;
        default:
          if (isNaN(l)) return;
      }
      else if (l != null) switch (typeof l) {
        case "function":
        case "symbol":
        case "boolean":
          break;
        default:
          if (!isNaN(l) && (ce(l, n), e === "" + l)) return;
      }
      zn(n, e, l, s);
    }
    function Nf(e, n, r, l, i, s) {
      if (i.delete(r), (e = e.getAttribute(r)) === null) switch (typeof l) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          return;
      }
      else if (l != null) switch (typeof l) {
        case "function":
        case "symbol":
        case "boolean":
          break;
        default:
          if (ce(l, n), e === (r = wl("" + l))) return;
      }
      zn(n, e, l, s);
    }
    function hc(e, n, r, l) {
      for (var i = {}, s = /* @__PURE__ */ new Set(), f = e.attributes, p = 0; p < f.length; p++) switch (f[p].name.toLowerCase()) {
        case "value":
        case "checked":
        case "selected":
          break;
        default:
          s.add(f[p].name);
      }
      if (hu(n)) {
        for (var y in r) if (r.hasOwnProperty(y)) {
          var v = r[y];
          if (v != null) {
            if (Ta.hasOwnProperty(y)) typeof v != "function" && No(y, v);
            else if (r.suppressHydrationWarning !== !0) switch (y) {
              case "children":
                typeof v != "string" && typeof v != "number" || zn("children", e.textContent, v, i);
                continue;
              case "suppressContentEditableWarning":
              case "suppressHydrationWarning":
              case "defaultValue":
              case "defaultChecked":
              case "innerHTML":
              case "ref":
                continue;
              case "dangerouslySetInnerHTML":
                f = e.innerHTML, (v = v ? v.__html : void 0) != null && zn(y, f, v = al(e, v), i);
                continue;
              case "style":
                s.delete(y), qu(e, v, i);
                continue;
              case "offsetParent":
              case "offsetTop":
              case "offsetLeft":
              case "offsetWidth":
              case "offsetHeight":
              case "isContentEditable":
              case "outerText":
              case "outerHTML":
                s.delete(y.toLowerCase()), console.error("Assignment to read-only property will result in a no-op: `%s`", y);
                continue;
              case "className":
                s.delete("class"), zn("className", f = Wn(e, "class", v), v, i);
                continue;
              default:
                l.context === fs && n !== "svg" && n !== "math" ? s.delete(y.toLowerCase()) : s.delete(y), zn(y, f = Wn(e, y, v), v, i);
            }
          }
        }
      } else for (v in r) if (r.hasOwnProperty(v) && (y = r[v]) != null) {
        if (Ta.hasOwnProperty(v)) typeof y != "function" && No(v, y);
        else if (r.suppressHydrationWarning !== !0) switch (v) {
          case "children":
            typeof y != "string" && typeof y != "number" || zn("children", e.textContent, y, i);
            continue;
          case "suppressContentEditableWarning":
          case "suppressHydrationWarning":
          case "value":
          case "checked":
          case "selected":
          case "defaultValue":
          case "defaultChecked":
          case "innerHTML":
          case "ref":
            continue;
          case "dangerouslySetInnerHTML":
            f = e.innerHTML, (y = y ? y.__html : void 0) != null && f !== (y = al(e, y)) && (i[v] = { __html: f });
            continue;
          case "className":
            ar(e, v, "class", y, s, i);
            continue;
          case "tabIndex":
            ar(e, v, "tabindex", y, s, i);
            continue;
          case "style":
            s.delete(v), qu(e, y, i);
            continue;
          case "multiple":
            s.delete(v), zn(v, e.multiple, y, i);
            continue;
          case "muted":
            s.delete(v), zn(v, e.muted, y, i);
            continue;
          case "autoFocus":
            s.delete("autofocus"), zn(v, e.autofocus, y, i);
            continue;
          case "data":
            if (n !== "object") {
              s.delete(v), zn(v, f = e.getAttribute("data"), y, i);
              continue;
            }
          case "src":
          case "href":
            if (!(y !== "" || n === "a" && v === "href" || n === "object" && v === "data")) {
              console.error(v === "src" ? 'An empty string ("") was passed to the %s attribute. This may cause the browser to download the whole page again over the network. To fix this, either do not render the element at all or pass null to %s instead of an empty string.' : 'An empty string ("") was passed to the %s attribute. To fix this, either do not render the element at all or pass null to %s instead of an empty string.', v, v);
              continue;
            }
            Nf(e, v, v, y, s, i);
            continue;
          case "action":
          case "formAction":
            if (f = e.getAttribute(v), typeof y == "function") {
              s.delete(v.toLowerCase()), v === "formAction" ? (s.delete("name"), s.delete("formenctype"), s.delete("formmethod"), s.delete("formtarget")) : (s.delete("enctype"), s.delete("method"), s.delete("target"));
              continue;
            }
            if (f === T1) {
              s.delete(v.toLowerCase()), zn(v, "function", y, i);
              continue;
            }
            Nf(e, v, v.toLowerCase(), y, s, i);
            continue;
          case "xlinkHref":
            Nf(e, v, "xlink:href", y, s, i);
            continue;
          case "contentEditable":
            Rf(e, v, "contenteditable", y, s, i);
            continue;
          case "spellCheck":
            Rf(e, v, "spellcheck", y, s, i);
            continue;
          case "draggable":
          case "autoReverse":
          case "externalResourcesRequired":
          case "focusable":
          case "preserveAlpha":
            Rf(e, v, v, y, s, i);
            continue;
          case "allowFullScreen":
          case "async":
          case "autoPlay":
          case "controls":
          case "default":
          case "defer":
          case "disabled":
          case "disablePictureInPicture":
          case "disableRemotePlayback":
          case "formNoValidate":
          case "hidden":
          case "loop":
          case "noModule":
          case "noValidate":
          case "open":
          case "playsInline":
          case "readOnly":
          case "required":
          case "reversed":
          case "scoped":
          case "seamless":
          case "itemScope":
            eh(e, v, v.toLowerCase(), y, s, i);
            continue;
          case "capture":
          case "download":
            e: {
              p = e;
              var z = f = v, j = i;
              if (s.delete(z), (p = p.getAttribute(z)) === null) switch (typeof y) {
                case "undefined":
                case "function":
                case "symbol":
                  break e;
                default:
                  if (y === !1) break e;
              }
              else if (y != null) switch (typeof y) {
                case "function":
                case "symbol":
                  break;
                case "boolean":
                  if (y === !0 && p === "") break e;
                  break;
                default:
                  if (ce(y, f), p === "" + y) break e;
              }
              zn(f, p, y, j);
            }
            continue;
          case "cols":
          case "rows":
          case "size":
          case "span":
            e: {
              if (p = e, z = f = v, j = i, s.delete(z), (p = p.getAttribute(z)) === null) switch (typeof y) {
                case "undefined":
                case "function":
                case "symbol":
                case "boolean":
                  break e;
                default:
                  if (isNaN(y) || 1 > y) break e;
              }
              else if (y != null) switch (typeof y) {
                case "function":
                case "symbol":
                case "boolean":
                  break;
                default:
                  if (!(isNaN(y) || 1 > y) && (ce(y, f), p === "" + y)) break e;
              }
              zn(f, p, y, j);
            }
            continue;
          case "rowSpan":
            Af(e, v, "rowspan", y, s, i);
            continue;
          case "start":
            Af(e, v, v, y, s, i);
            continue;
          case "xHeight":
            ar(e, v, "x-height", y, s, i);
            continue;
          case "xlinkActuate":
            ar(e, v, "xlink:actuate", y, s, i);
            continue;
          case "xlinkArcrole":
            ar(e, v, "xlink:arcrole", y, s, i);
            continue;
          case "xlinkRole":
            ar(e, v, "xlink:role", y, s, i);
            continue;
          case "xlinkShow":
            ar(e, v, "xlink:show", y, s, i);
            continue;
          case "xlinkTitle":
            ar(e, v, "xlink:title", y, s, i);
            continue;
          case "xlinkType":
            ar(e, v, "xlink:type", y, s, i);
            continue;
          case "xmlBase":
            ar(e, v, "xml:base", y, s, i);
            continue;
          case "xmlLang":
            ar(e, v, "xml:lang", y, s, i);
            continue;
          case "xmlSpace":
            ar(e, v, "xml:space", y, s, i);
            continue;
          case "inert":
            y !== "" || zy[v] || (zy[v] = !0, console.error("Received an empty string for a boolean attribute `%s`. This will treat the attribute as if it were false. Either pass `false` to silence this warning, or pass `true` if you used an empty string in earlier versions of React to indicate this attribute is true.", v)), eh(e, v, v, y, s, i);
            continue;
          default:
            if (!(2 < v.length) || v[0] !== "o" && v[0] !== "O" || v[1] !== "n" && v[1] !== "N") {
              p = wd(v), f = !1, l.context === fs && n !== "svg" && n !== "math" ? s.delete(p.toLowerCase()) : (z = v.toLowerCase(), (z = a.hasOwnProperty(z) && a[z] || null) !== null && z !== v && (f = !0, s.delete(z)), s.delete(p));
              e: if (z = e, j = p, p = y, dn(j)) if (z.hasAttribute(j)) z = z.getAttribute(j), ce(p, j), p = z === "" + p ? p : z;
              else {
                switch (typeof p) {
                  case "function":
                  case "symbol":
                    break e;
                  case "boolean":
                    if ((z = j.toLowerCase().slice(0, 5)) !== "data-" && z !== "aria-") break e;
                }
                p = p === void 0 ? void 0 : null;
              }
              else p = void 0;
              f || zn(v, p, y, i);
            }
        }
      }
      return 0 < s.size && r.suppressHydrationWarning !== !0 && function(F, te, Q) {
        te.forEach(function(ge) {
          Q[Wi(ge)] = ge === "style" ? qi(F) : F.getAttribute(ge);
        });
      }(e, s, i), Object.keys(i).length === 0 ? null : i;
    }
    function gc(e) {
      return e.nodeType === 9 ? e : e.ownerDocument;
    }
    function jg(e) {
      switch (e) {
        case t:
          return _p;
        case eu:
          return Iy;
        default:
          return fs;
      }
    }
    function Hg(e, n) {
      if (e === fs) switch (n) {
        case "svg":
          return _p;
        case "math":
          return Iy;
        default:
          return fs;
      }
      return e === _p && n === "foreignObject" ? fs : e;
    }
    function Rn(e, n) {
      return e === "textarea" || e === "noscript" || typeof n.children == "string" || typeof n.children == "number" || typeof n.children == "bigint" || typeof n.dangerouslySetInnerHTML == "object" && n.dangerouslySetInnerHTML !== null && n.dangerouslySetInnerHTML.__html != null;
    }
    function Qn(e) {
      setTimeout(function() {
        throw e;
      });
    }
    function hn(e, n, r) {
      switch (n) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          r.autoFocus && e.focus();
          break;
        case "img":
          r.src ? e.src = r.src : r.srcSet && (e.srcset = r.srcSet);
      }
    }
    function xn(e, n, r, l) {
      (function(i, s, f, p) {
        switch (Pf(s, p), s) {
          case "div":
          case "span":
          case "svg":
          case "path":
          case "a":
          case "g":
          case "p":
          case "li":
            break;
          case "input":
            var y = null, v = null, z = null, j = null, F = null, te = null, Q = null;
            for (P in f) {
              var ge = f[P];
              if (f.hasOwnProperty(P) && ge != null) switch (P) {
                case "checked":
                case "value":
                  break;
                case "defaultValue":
                  F = ge;
                default:
                  p.hasOwnProperty(P) || Nn(i, s, P, null, p, ge);
              }
            }
            for (var T in p) {
              var P = p[T];
              if (ge = f[T], p.hasOwnProperty(T) && (P != null || ge != null)) switch (T) {
                case "type":
                  v = P;
                  break;
                case "name":
                  y = P;
                  break;
                case "checked":
                  te = P;
                  break;
                case "defaultChecked":
                  Q = P;
                  break;
                case "value":
                  z = P;
                  break;
                case "defaultValue":
                  j = P;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  if (P != null) throw Error(s + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
                  break;
                default:
                  P !== ge && Nn(i, s, T, P, p, ge);
              }
            }
            return s = f.type === "checkbox" || f.type === "radio" ? f.checked != null : f.value != null, p = p.type === "checkbox" || p.type === "radio" ? p.checked != null : p.value != null, s || !p || lk || (console.error("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://react.dev/link/controlled-components"), lk = !0), !s || p || ak || (console.error("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://react.dev/link/controlled-components"), ak = !0), void kt(i, z, j, F, te, Q, v, y);
          case "select":
            for (v in P = z = j = T = null, f) if (F = f[v], f.hasOwnProperty(v) && F != null) switch (v) {
              case "value":
                break;
              case "multiple":
                P = F;
              default:
                p.hasOwnProperty(v) || Nn(i, s, v, null, p, F);
            }
            for (y in p) if (v = p[y], F = f[y], p.hasOwnProperty(y) && (v != null || F != null)) switch (y) {
              case "value":
                T = v;
                break;
              case "defaultValue":
                j = v;
                break;
              case "multiple":
                z = v;
              default:
                v !== F && Nn(i, s, y, v, p, F);
            }
            return p = j, s = z, f = P, void (T != null ? kl(i, !!s, T, !1) : !!f != !!s && (p != null ? kl(i, !!s, p, !0) : kl(i, !!s, s ? [] : "", !1)));
          case "textarea":
            for (j in P = T = null, f) if (y = f[j], f.hasOwnProperty(j) && y != null && !p.hasOwnProperty(j)) switch (j) {
              case "value":
              case "children":
                break;
              default:
                Nn(i, s, j, null, p, y);
            }
            for (z in p) if (y = p[z], v = f[z], p.hasOwnProperty(z) && (y != null || v != null)) switch (z) {
              case "value":
                T = y;
                break;
              case "defaultValue":
                P = y;
                break;
              case "children":
                break;
              case "dangerouslySetInnerHTML":
                if (y != null) throw Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
                break;
              default:
                y !== v && Nn(i, s, z, y, p, v);
            }
            return void Hp(i, T, P);
          case "option":
            for (var D in f) T = f[D], f.hasOwnProperty(D) && T != null && !p.hasOwnProperty(D) && (D === "selected" ? i.selected = !1 : Nn(i, s, D, null, p, T));
            for (F in p) T = p[F], P = f[F], !p.hasOwnProperty(F) || T === P || T == null && P == null || (F === "selected" ? i.selected = T && typeof T != "function" && typeof T != "symbol" : Nn(i, s, F, T, p, P));
            return;
          case "img":
          case "link":
          case "area":
          case "base":
          case "br":
          case "col":
          case "embed":
          case "hr":
          case "keygen":
          case "meta":
          case "param":
          case "source":
          case "track":
          case "wbr":
          case "menuitem":
            for (var X in f) T = f[X], f.hasOwnProperty(X) && T != null && !p.hasOwnProperty(X) && Nn(i, s, X, null, p, T);
            for (te in p) if (T = p[te], P = f[te], p.hasOwnProperty(te) && T !== P && (T != null || P != null)) switch (te) {
              case "children":
              case "dangerouslySetInnerHTML":
                if (T != null) throw Error(s + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
                break;
              default:
                Nn(i, s, te, T, p, P);
            }
            return;
          default:
            if (hu(s)) {
              for (var ve in f) T = f[ve], f.hasOwnProperty(ve) && T !== void 0 && !p.hasOwnProperty(ve) && ga(i, s, ve, void 0, p, T);
              for (Q in p) T = p[Q], P = f[Q], !p.hasOwnProperty(Q) || T === P || T === void 0 && P === void 0 || ga(i, s, Q, T, p, P);
              return;
            }
        }
        for (var pn in f) T = f[pn], f.hasOwnProperty(pn) && T != null && !p.hasOwnProperty(pn) && Nn(i, s, pn, null, p, T);
        for (ge in p) T = p[ge], P = f[ge], !p.hasOwnProperty(ge) || T === P || T == null && P == null || Nn(i, s, ge, T, p, P);
      })(e, n, r, l), e[ir] = l;
    }
    function _n(e) {
      Wo(e, "");
    }
    function Yr(e, n, r) {
      e.nodeValue = r;
    }
    function yr(e) {
      return e === "head";
    }
    function Qu(e, n) {
      e.removeChild(n);
    }
    function nh(e, n) {
      (e.nodeType === 9 ? e.body : e.nodeName === "HTML" ? e.ownerDocument.body : e).removeChild(n);
    }
    function ya(e, n) {
      var r = n, l = 0, i = 0;
      do {
        var s = r.nextSibling;
        if (e.removeChild(r), s && s.nodeType === 8) if ((r = s.data) === Fy) {
          if (0 < l && 8 > l) {
            r = l;
            var f = e.ownerDocument;
            if (r & R1 && ba(f.documentElement), r & A1 && ba(f.body), r & N1) for (ba(r = f.head), f = r.firstChild; f; ) {
              var p = f.nextSibling, y = f.nodeName;
              f[Oc] || y === "SCRIPT" || y === "STYLE" || y === "LINK" && f.rel.toLowerCase() === "stylesheet" || r.removeChild(f), f = p;
            }
          }
          if (i === 0) return e.removeChild(s), void wa(n);
          i--;
        } else r === Dy || r === su || r === Zh ? i++ : l = r.charCodeAt(0) - 48;
        else l = 0;
        r = s;
      } while (r);
      wa(n);
    }
    function pt(e) {
      typeof (e = e.style).setProperty == "function" ? e.setProperty("display", "none", "important") : e.display = "none";
    }
    function Hl(e) {
      e.nodeValue = "";
    }
    function Qi(e, n) {
      n = (n = n[_1]) != null && n.hasOwnProperty("display") ? n.display : null, e.style.display = n == null || typeof n == "boolean" ? "" : ("" + n).trim();
    }
    function th(e, n) {
      e.nodeValue = n;
    }
    function Or(e) {
      var n = e.firstChild;
      for (n && n.nodeType === 10 && (n = n.nextSibling); n; ) {
        var r = n;
        switch (n = n.nextSibling, r.nodeName) {
          case "HTML":
          case "HEAD":
          case "BODY":
            Or(r), vt(r);
            continue;
          case "SCRIPT":
          case "STYLE":
            continue;
          case "LINK":
            if (r.rel.toLowerCase() === "stylesheet") continue;
        }
        e.removeChild(r);
      }
    }
    function Ul(e) {
      return e.data === Zh || e.data === su && e.ownerDocument.readyState === ck;
    }
    function lr(e) {
      for (; e != null; e = e.nextSibling) {
        var n = e.nodeType;
        if (n === 1 || n === 3) break;
        if (n === 8) {
          if ((n = e.data) === Dy || n === Zh || n === su || n === ov || n === sk) break;
          if (n === Fy) return null;
        }
      }
      return e;
    }
    function br(e) {
      if (e.nodeType === 1) {
        for (var n = e.nodeName.toLowerCase(), r = {}, l = e.attributes, i = 0; i < l.length; i++) {
          var s = l[i];
          r[Wi(s.name)] = s.name.toLowerCase() === "style" ? qi(e) : s.value;
        }
        return { type: n, props: r };
      }
      return e.nodeType === 8 ? { type: "Suspense", props: {} } : e.nodeValue;
    }
    function _f(e, n, r) {
      return r === null || r[P1] !== !0 ? (e.nodeValue === n ? e = null : (n = Qr(n), e = Qr(e.nodeValue) === n ? null : e.nodeValue), e) : null;
    }
    function Of(e) {
      e = e.nextSibling;
      for (var n = 0; e; ) {
        if (e.nodeType === 8) {
          var r = e.data;
          if (r === Fy) {
            if (n === 0) return lr(e.nextSibling);
            n--;
          } else r !== Dy && r !== Zh && r !== su || n++;
        }
        e = e.nextSibling;
      }
      return null;
    }
    function yc(e) {
      e = e.previousSibling;
      for (var n = 0; e; ) {
        if (e.nodeType === 8) {
          var r = e.data;
          if (r === Dy || r === Zh || r === su) {
            if (n === 0) return e;
            n--;
          } else r === Fy && n++;
        }
        e = e.previousSibling;
      }
      return null;
    }
    function Lf(e) {
      wa(e);
    }
    function Bl(e) {
      wa(e);
    }
    function Dt(e, n, r, l, i) {
      switch (i && kd(e, l.ancestorInfo), n = gc(r), e) {
        case "html":
          if (!(e = n.documentElement)) throw Error("React expected an <html> element (document.documentElement) to exist in the Document but one was not found. React never removes the documentElement for any Document it renders into so the cause is likely in some other script running on this page.");
          return e;
        case "head":
          if (!(e = n.head)) throw Error("React expected a <head> element (document.head) to exist in the Document but one was not found. React never removes the head for any Document it renders into so the cause is likely in some other script running on this page.");
          return e;
        case "body":
          if (!(e = n.body)) throw Error("React expected a <body> element (document.body) to exist in the Document but one was not found. React never removes the body for any Document it renders into so the cause is likely in some other script running on this page.");
          return e;
        default:
          throw Error("resolveSingletonInstance was called with an element type that is not supported. This is a bug in React.");
      }
    }
    function Vl(e, n, r, l) {
      if (!r[Io] && vo(r)) {
        var i = r.tagName.toLowerCase();
        console.error("You are mounting a new %s component when a previous one has not first unmounted. It is an error to render more than one %s component at a time and attributes and children of these components will likely fail in unpredictable ways. Please only render a single instance of <%s> and if you need to mount a new one, ensure any previous ones have unmounted first.", i, i, i);
      }
      switch (e) {
        case "html":
        case "head":
        case "body":
          break;
        default:
          console.error("acquireSingletonInstance was called with an element type that is not supported. This is a bug in React.");
      }
      for (i = r.attributes; i.length; ) r.removeAttributeNode(i[0]);
      zt(r, e, n), r[Mt] = l, r[ir] = n;
    }
    function ba(e) {
      for (var n = e.attributes; n.length; ) e.removeAttributeNode(n[0]);
      vt(e);
    }
    function il(e) {
      return typeof e.getRootNode == "function" ? e.getRootNode() : e.nodeType === 9 ? e : e.ownerDocument;
    }
    function zf(e, n, r) {
      var l = Op;
      if (l && typeof n == "string" && n) {
        var i = mr(n);
        i = 'link[rel="' + e + '"][href="' + i + '"]', typeof r == "string" && (i += '[crossorigin="' + r + '"]'), gk.has(i) || (gk.add(i), e = { rel: e, crossOrigin: r, href: n }, l.querySelector(i) === null && (zt(n = l.createElement("link"), "link", e), V(n), l.head.appendChild(n)));
      }
    }
    function Df(e, n, r, l) {
      var i = (i = ul.current) ? il(i) : null;
      if (!i) throw Error('"resourceRoot" was expected to exist. This is a bug in React.');
      switch (e) {
        case "meta":
        case "title":
          return null;
        case "style":
          return typeof r.precedence == "string" && typeof r.href == "string" ? (r = va(r.href), (l = (n = E(i).hoistableStyles).get(r)) || (l = { type: "style", instance: null, count: 0, state: null }, n.set(r, l)), l) : { type: "void", instance: null, count: 0, state: null };
        case "link":
          if (r.rel === "stylesheet" && typeof r.href == "string" && typeof r.precedence == "string") {
            e = va(r.href);
            var s = E(i).hoistableStyles, f = s.get(e);
            if (!f && (i = i.ownerDocument || i, f = { type: "stylesheet", instance: null, count: 0, state: { loading: ld, preload: null } }, s.set(e, f), (s = i.querySelector(Yi(e))) && !s._p && (f.instance = s, f.state.loading = Jh | Ma), !ja.has(e))) {
              var p = { rel: "preload", as: "style", href: r.href, crossOrigin: r.crossOrigin, integrity: r.integrity, media: r.media, hrefLang: r.hrefLang, referrerPolicy: r.referrerPolicy };
              ja.set(e, p), s || function(y, v, z, j) {
                y.querySelector('link[rel="preload"][as="style"][' + v + "]") ? j.loading = Jh : (v = y.createElement("link"), j.preload = v, v.addEventListener("load", function() {
                  return j.loading |= Jh;
                }), v.addEventListener("error", function() {
                  return j.loading |= mk;
                }), zt(v, "link", z), V(v), y.head.appendChild(v));
              }(i, e, p, f.state);
            }
            if (n && l === null) throw r = `

  - ` + bc(n) + `
  + ` + bc(r), Error("Expected <link> not to update to be updated to a stylesheet with precedence. Check the `rel`, `href`, and `precedence` props of this component. Alternatively, check whether two different <link> components render in the same slot or share the same key." + r);
            return f;
          }
          if (n && l !== null) throw r = `

  - ` + bc(n) + `
  + ` + bc(r), Error("Expected stylesheet with precedence to not be updated to a different kind of <link>. Check the `rel`, `href`, and `precedence` props of this component. Alternatively, check whether two different <link> components render in the same slot or share the same key." + r);
          return null;
        case "script":
          return n = r.async, typeof (r = r.src) == "string" && n && typeof n != "function" && typeof n != "symbol" ? (r = Gi(r), (l = (n = E(i).hoistableScripts).get(r)) || (l = { type: "script", instance: null, count: 0, state: null }, n.set(r, l)), l) : { type: "void", instance: null, count: 0, state: null };
        default:
          throw Error('getResource encountered a type it did not expect: "' + e + '". this is a bug in React.');
      }
    }
    function bc(e) {
      var n = 0, r = "<link";
      return typeof e.rel == "string" ? (n++, r += ' rel="' + e.rel + '"') : zo.call(e, "rel") && (n++, r += ' rel="' + (e.rel === null ? "null" : "invalid type " + typeof e.rel) + '"'), typeof e.href == "string" ? (n++, r += ' href="' + e.href + '"') : zo.call(e, "href") && (n++, r += ' href="' + (e.href === null ? "null" : "invalid type " + typeof e.href) + '"'), typeof e.precedence == "string" ? (n++, r += ' precedence="' + e.precedence + '"') : zo.call(e, "precedence") && (n++, r += " precedence={" + (e.precedence === null ? "null" : "invalid type " + typeof e.precedence) + "}"), Object.getOwnPropertyNames(e).length > n && (r += " ..."), r + " />";
    }
    function va(e) {
      return 'href="' + mr(e) + '"';
    }
    function Yi(e) {
      return 'link[rel="stylesheet"][' + e + "]";
    }
    function Lr(e) {
      return en({}, e, { "data-precedence": e.precedence, precedence: null });
    }
    function Gi(e) {
      return '[src="' + mr(e) + '"]';
    }
    function qt(e) {
      return "script[async]" + e;
    }
    function rh(e, n, r) {
      if (n.count++, n.instance === null) switch (n.type) {
        case "style":
          var l = e.querySelector('style[data-href~="' + mr(r.href) + '"]');
          if (l) return n.instance = l, V(l), l;
          var i = en({}, r, { "data-href": r.href, "data-precedence": r.precedence, href: null, precedence: null });
          return V(l = (e.ownerDocument || e).createElement("style")), zt(l, "style", i), vc(l, r.precedence, e), n.instance = l;
        case "stylesheet":
          i = va(r.href);
          var s = e.querySelector(Yi(i));
          if (s) return n.state.loading |= Ma, n.instance = s, V(s), s;
          l = Lr(r), (i = ja.get(i)) && oh(l, i), V(s = (e.ownerDocument || e).createElement("link"));
          var f = s;
          return f._p = new Promise(function(p, y) {
            f.onload = p, f.onerror = y;
          }), zt(s, "link", l), n.state.loading |= Ma, vc(s, r.precedence, e), n.instance = s;
        case "script":
          return s = Gi(r.src), (i = e.querySelector(qt(s))) ? (n.instance = i, V(i), i) : (l = r, (i = ja.get(s)) && ka(l = en({}, r), i), V(i = (e = e.ownerDocument || e).createElement("script")), zt(i, "link", l), e.head.appendChild(i), n.instance = i);
        case "void":
          return null;
        default:
          throw Error('acquireResource encountered a resource type it did not expect: "' + n.type + '". this is a bug in React.');
      }
      else n.type === "stylesheet" && (n.state.loading & Ma) === ld && (l = n.instance, n.state.loading |= Ma, vc(l, r.precedence, e));
      return n.instance;
    }
    function vc(e, n, r) {
      for (var l = r.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), i = l.length ? l[l.length - 1] : null, s = i, f = 0; f < l.length; f++) {
        var p = l[f];
        if (p.dataset.precedence === n) s = p;
        else if (s !== i) break;
      }
      s ? s.parentNode.insertBefore(e, s.nextSibling) : (n = r.nodeType === 9 ? r.head : r).insertBefore(e, n.firstChild);
    }
    function oh(e, n) {
      e.crossOrigin == null && (e.crossOrigin = n.crossOrigin), e.referrerPolicy == null && (e.referrerPolicy = n.referrerPolicy), e.title == null && (e.title = n.title);
    }
    function ka(e, n) {
      e.crossOrigin == null && (e.crossOrigin = n.crossOrigin), e.referrerPolicy == null && (e.referrerPolicy = n.referrerPolicy), e.integrity == null && (e.integrity = n.integrity);
    }
    function kc(e, n, r) {
      if (My === null) {
        var l = /* @__PURE__ */ new Map(), i = My = /* @__PURE__ */ new Map();
        i.set(r, l);
      } else (l = (i = My).get(r)) || (l = /* @__PURE__ */ new Map(), i.set(r, l));
      if (l.has(e)) return l;
      for (l.set(e, null), r = r.getElementsByTagName(e), i = 0; i < r.length; i++) {
        var s = r[i];
        if (!(s[Oc] || s[Mt] || e === "link" && s.getAttribute("rel") === "stylesheet") && s.namespaceURI !== t) {
          var f = s.getAttribute(n) || "";
          f = e + f;
          var p = l.get(f);
          p ? p.push(s) : l.set(f, [s]);
        }
      }
      return l;
    }
    function Ff(e, n, r) {
      (e = e.ownerDocument || e).head.insertBefore(r, n === "title" ? e.querySelector("head > title") : null);
    }
    function Ki(e) {
      return e.type !== "stylesheet" || (e.state.loading & hk) !== ld;
    }
    function Ug() {
    }
    function wc() {
      if (this.count--, this.count === 0) {
        if (this.stylesheets) If(this, this.stylesheets);
        else if (this.unsuspend) {
          var e = this.unsuspend;
          this.unsuspend = null, e();
        }
      }
    }
    function If(e, n) {
      e.stylesheets = null, e.unsuspend !== null && (e.count++, jy = /* @__PURE__ */ new Map(), n.forEach(ah, e), jy = null, wc.call(e));
    }
    function ah(e, n) {
      if (!(n.state.loading & Ma)) {
        var r = jy.get(e);
        if (r) var l = r.get(sv);
        else {
          r = /* @__PURE__ */ new Map(), jy.set(e, r);
          for (var i = e.querySelectorAll("link[data-precedence],style[data-precedence]"), s = 0; s < i.length; s++) {
            var f = i[s];
            f.nodeName !== "LINK" && f.getAttribute("media") === "not all" || (r.set(f.dataset.precedence, f), l = f);
          }
          l && r.set(sv, l);
        }
        f = (i = n.instance).getAttribute("data-precedence"), (s = r.get(f) || l) === l && r.set(sv, i), r.set(f, i), this.count++, l = wc.bind(this), i.addEventListener("load", l), i.addEventListener("error", l), s ? s.parentNode.insertBefore(i, s.nextSibling) : (e = e.nodeType === 9 ? e.head : e).insertBefore(i, e.firstChild), n.state.loading |= Ma;
      }
    }
    function lh(e, n, r, l, i, s, f, p) {
      for (this.tag = 1, this.containerInfo = e, this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = ad, this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null, this.callbackPriority = 0, this.expirationTimes = ti(-1), this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = ti(0), this.hiddenUpdates = ti(null), this.identifierPrefix = l, this.onUncaughtError = i, this.onCaughtError = s, this.onRecoverableError = f, this.pooledCache = null, this.pooledCacheLanes = 0, this.formState = p, this.incompleteTransitions = /* @__PURE__ */ new Map(), this.passiveEffectDuration = this.effectDuration = -0, this.memoizedUpdaters = /* @__PURE__ */ new Set(), e = this.pendingUpdatersLaneMap = [], n = 0; 31 > n; n++) e.push(/* @__PURE__ */ new Set());
      this._debugRootType = r ? "hydrateRoot()" : "createRoot()";
    }
    function Bg(e, n, r, l, i, s, f, p, y, v, z, j) {
      return e = new lh(e, n, r, f, p, y, v, j), n = o1, s === !0 && (n |= Dr | fl), Rt && (n |= kr), s = Y(3, null, null, n), e.current = s, s.stateNode = e, wo(n = Fs()), e.pooledCache = n, wo(n), s.memoizedState = { element: l, isDehydrated: r, cache: n }, Tr(s), e;
    }
    function Vg(e) {
      return e ? e = ts : ts;
    }
    function Mf(e, n, r, l, i, s) {
      if (Bn && typeof Bn.onScheduleFiberRoot == "function") try {
        Bn.onScheduleFiberRoot(Ca, l, r);
      } catch (f) {
        Gr || (Gr = !0, console.error("React instrumentation encountered an error: %s", f));
      }
      Pe !== null && typeof Pe.markRenderScheduled == "function" && Pe.markRenderScheduled(n), i = Vg(i), l.context === null ? l.context = i : l.pendingContext = i, Pa && ur !== null && !Ak && (Ak = !0, console.error(`Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.

Check the render method of %s.`, Ee(ur) || "Unknown")), (l = $o(n)).payload = { element: r }, (s = s === void 0 ? null : s) !== null && (typeof s != "function" && console.error("Expected the last optional `callback` argument to be a function. Instead received: %s.", s), l.callback = s), (r = xo(e, l, n)) !== null && (dt(r, e, n), Ol(r, e, n));
    }
    function ih(e, n) {
      if ((e = e.memoizedState) !== null && e.dehydrated !== null) {
        var r = e.retryLane;
        e.retryLane = r !== 0 && r < n ? r : n;
      }
    }
    function Wl(e, n) {
      ih(e, n), (e = e.alternate) && ih(e, n);
    }
    function Sc(e) {
      if (e.tag === 13) {
        var n = Cr(e, 67108864);
        n !== null && dt(n, e, 67108864), Wl(e, 67108864);
      }
    }
    function Wg() {
      return ur;
    }
    function qg() {
      for (var e = /* @__PURE__ */ new Map(), n = 1, r = 0; 31 > r; r++) {
        var l = $t(n);
        e.set(n, l), n *= 2;
      }
      return e;
    }
    function Qg(e, n, r, l) {
      var i = J.T;
      J.T = null;
      var s = Fe.p;
      try {
        Fe.p = Kr, jf(e, n, r, l);
      } finally {
        Fe.p = s, J.T = i;
      }
    }
    function Yg(e, n, r, l) {
      var i = J.T;
      J.T = null;
      var s = Fe.p;
      try {
        Fe.p = vr, jf(e, n, r, l);
      } finally {
        Fe.p = s, J.T = i;
      }
    }
    function jf(e, n, r, l) {
      if (Uy) {
        var i = Hf(l);
        if (i === null) Tf(e, n, l, By, r), sh(e, l);
        else if (function(v, z, j, F, te) {
          switch (z) {
            case "focusin":
              return ps = An(ps, v, z, j, F, te), !0;
            case "dragenter":
              return ms = An(ms, v, z, j, F, te), !0;
            case "mouseover":
              return hs = An(hs, v, z, j, F, te), !0;
            case "pointerover":
              var Q = te.pointerId;
              return tg.set(Q, An(tg.get(Q) || null, v, z, j, F, te)), !0;
            case "gotpointercapture":
              return Q = te.pointerId, rg.set(Q, An(rg.get(Q) || null, v, z, j, F, te)), !0;
          }
          return !1;
        }(i, e, n, r, l)) l.stopPropagation();
        else if (sh(e, l), 4 & n && -1 < D1.indexOf(e)) {
          for (; i !== null; ) {
            var s = vo(i);
            if (s !== null) switch (s.tag) {
              case 3:
                if ((s = s.stateNode).current.memoizedState.isDehydrated) {
                  var f = fr(s.pendingLanes);
                  if (f !== 0) {
                    var p = s;
                    for (p.pendingLanes |= 2, p.entangledLanes |= 2; f; ) {
                      var y = 1 << 31 - St(f);
                      p.entanglements[1] |= y, f &= ~y;
                    }
                    Tt(s), (Dn & (no | gl)) === Mo && (Cy = xa() + Z0, Uu(0));
                  }
                }
                break;
              case 13:
                (p = Cr(s, 2)) !== null && dt(p, s, 2), ji(), Wl(s, 2);
            }
            if ((s = Hf(l)) === null && Tf(e, n, l, By, r), s === i) break;
            i = s;
          }
          i !== null && l.stopPropagation();
        } else Tf(e, n, l, null, r);
      }
    }
    function Hf(e) {
      return Yu(e = xs(e));
    }
    function Yu(e) {
      if (By = null, (e = bo(e)) !== null) {
        var n = oe(e);
        if (n === null) e = null;
        else {
          var r = n.tag;
          if (r === 13) {
            if ((e = ue(n)) !== null) return e;
            e = null;
          } else if (r === 3) {
            if (n.stateNode.current.memoizedState.isDehydrated) return n.tag === 3 ? n.stateNode.containerInfo : null;
            e = null;
          } else n !== e && (e = null);
        }
      }
      return By = e, null;
    }
    function uh(e) {
      switch (e) {
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
          return Kr;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
          return vr;
        case "message":
          switch (Ql()) {
            case Yf:
              return Kr;
            case Ac:
              return vr;
            case Yl:
            case Do:
              return Xr;
            case Nc:
              return _c;
            default:
              return Xr;
          }
        default:
          return Xr;
      }
    }
    function sh(e, n) {
      switch (e) {
        case "focusin":
        case "focusout":
          ps = null;
          break;
        case "dragenter":
        case "dragleave":
          ms = null;
          break;
        case "mouseover":
        case "mouseout":
          hs = null;
          break;
        case "pointerover":
        case "pointerout":
          tg.delete(n.pointerId);
          break;
        case "gotpointercapture":
        case "lostpointercapture":
          rg.delete(n.pointerId);
      }
    }
    function An(e, n, r, l, i, s) {
      return e === null || e.nativeEvent !== s ? (e = { blockedOn: n, domEventName: r, eventSystemFlags: l, nativeEvent: s, targetContainers: [i] }, n !== null && (n = vo(n)) !== null && Sc(n), e) : (e.eventSystemFlags |= l, n = e.targetContainers, i !== null && n.indexOf(i) === -1 && n.push(i), e);
    }
    function Uf(e) {
      var n = bo(e.target);
      if (n !== null) {
        var r = oe(n);
        if (r !== null) {
          if ((n = r.tag) === 13) {
            if ((n = ue(r)) !== null) return e.blockedOn = n, void function(l, i) {
              var s = Fe.p;
              try {
                return Fe.p = l, i();
              } finally {
                Fe.p = s;
              }
            }(e.priority, function() {
              if (r.tag === 13) {
                var l = _r(r);
                l = du(l);
                var i = Cr(r, l);
                i !== null && dt(i, r, l), Wl(r, l);
              }
            });
          } else if (n === 3 && r.stateNode.current.memoizedState.isDehydrated) return void (e.blockedOn = r.tag === 3 ? r.stateNode.containerInfo : null);
        }
      }
      e.blockedOn = null;
    }
    function Bf(e) {
      if (e.blockedOn !== null) return !1;
      for (var n = e.targetContainers; 0 < n.length; ) {
        var r = Hf(e.nativeEvent);
        if (r !== null) return (n = vo(r)) !== null && Sc(n), e.blockedOn = r, !1;
        var l = new (r = e.nativeEvent).constructor(r.type, r), i = l;
        de !== null && console.error("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue."), de = i, r.target.dispatchEvent(l), de === null && console.error("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue."), de = null, n.shift();
      }
      return !0;
    }
    function ch(e, n, r) {
      Bf(e) && r.delete(n);
    }
    function ab() {
      cv = !1, ps !== null && Bf(ps) && (ps = null), ms !== null && Bf(ms) && (ms = null), hs !== null && Bf(hs) && (hs = null), tg.forEach(ch), rg.forEach(ch);
    }
    function Vf(e, n) {
      e.blockedOn === n && (e.blockedOn = null, cv || (cv = !0, gt.unstable_scheduleCallback(gt.unstable_NormalPriority, ab)));
    }
    function Ec(e) {
      Vy !== e && (Vy = e, gt.unstable_scheduleCallback(gt.unstable_NormalPriority, function() {
        Vy === e && (Vy = null);
        for (var n = 0; n < e.length; n += 3) {
          var r = e[n], l = e[n + 1], i = e[n + 2];
          if (typeof l != "function") {
            if (Yu(l || r) === null) continue;
            break;
          }
          var s = vo(r);
          s !== null && (e.splice(n, 3), n -= 3, r = { pending: !0, data: i, method: r.method, action: l }, Object.freeze(r), xi(s, r, l, i));
        }
      }));
    }
    function wa(e) {
      function n(y) {
        return Vf(y, e);
      }
      ps !== null && Vf(ps, e), ms !== null && Vf(ms, e), hs !== null && Vf(hs, e), tg.forEach(n), rg.forEach(n);
      for (var r = 0; r < gs.length; r++) {
        var l = gs[r];
        l.blockedOn === e && (l.blockedOn = null);
      }
      for (; 0 < gs.length && (r = gs[0]).blockedOn === null; ) Uf(r), r.blockedOn === null && gs.shift();
      if ((r = (e.ownerDocument || e).$$reactFormReplay) != null) for (l = 0; l < r.length; l += 3) {
        var i = r[l], s = r[l + 1], f = i[ir] || null;
        if (typeof s == "function") f || Ec(r);
        else if (f) {
          var p = null;
          if (s && s.hasAttribute("formAction")) {
            if (i = s, f = s[ir] || null) p = f.formAction;
            else if (Yu(i) !== null) continue;
          } else p = f.action;
          typeof p == "function" ? r[l + 1] = p : (r.splice(l, 3), l -= 3), Ec(r);
        }
      }
    }
    function xc(e) {
      this._internalRoot = e;
    }
    function Xi(e) {
      this._internalRoot = e;
    }
    function Wf(e) {
      e[Io] && (e._reactRootContainer ? console.error("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.") : console.error("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it."));
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var ql, _o, Gu, Gg, dh, fh, ph, gt = aw(), Cc = Lp(), Kg = Cv(), en = Object.assign, mh = Symbol.for("react.element"), Sa = Symbol.for("react.transitional.element"), Ea = Symbol.for("react.portal"), Ku = Symbol.for("react.fragment"), Tc = Symbol.for("react.strict_mode"), an = Symbol.for("react.profiler"), hh = Symbol.for("react.provider"), Xu = Symbol.for("react.consumer"), mo = Symbol.for("react.context"), $u = Symbol.for("react.forward_ref"), Pc = Symbol.for("react.suspense"), $i = Symbol.for("react.suspense_list"), Zi = Symbol.for("react.memo"), Ft = Symbol.for("react.lazy"), qf = Symbol.for("react.activity"), lb = Symbol.for("react.memo_cache_sentinel"), Xg = Symbol.iterator, $g = Symbol.for("react.client.reference"), It = Array.isArray, J = Cc.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, Fe = Kg.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, gh = Object.freeze({ pending: !1, data: null, method: null, action: null }), Pt = [], Rc = [], Oo = -1, Lo = Me(null), Zu = Me(null), ul = Me(null), Ju = Me(null), zo = Object.prototype.hasOwnProperty, Qf = gt.unstable_scheduleCallback, ib = gt.unstable_cancelCallback, Zg = gt.unstable_shouldYield, ub = gt.unstable_requestPaint, xa = gt.unstable_now, Ql = gt.unstable_getCurrentPriorityLevel, Yf = gt.unstable_ImmediatePriority, Ac = gt.unstable_UserBlockingPriority, Yl = gt.unstable_NormalPriority, Do = gt.unstable_LowPriority, Nc = gt.unstable_IdlePriority, Jg = gt.log, ey = gt.unstable_setDisableYieldValue, Ca = null, Bn = null, Pe = null, Gr = !1, Rt = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u", St = Math.clz32 ? Math.clz32 : function(e) {
      return (e >>>= 0) === 0 ? 32 : 31 - (ny(e) / ty | 0) | 0;
    }, ny = Math.log, ty = Math.LN2, Gl = 256, Ji = 4194304, Kr = 2, vr = 8, Xr = 32, _c = 268435456, Fo = Math.random().toString(36).slice(2), Mt = "__reactFiber$" + Fo, ir = "__reactProps$" + Fo, Io = "__reactContainer$" + Fo, Gf = "__reactEvents$" + Fo, ry = "__reactListeners$" + Fo, oy = "__reactHandles$" + Fo, es = "__reactResources$" + Fo, Oc = "__reactMarker$" + Fo, Lc = /* @__PURE__ */ new Set(), Ta = {}, zc = {}, sb = { button: !0, checkbox: !0, image: !0, hidden: !0, radio: !0, reset: !0, submit: !0 }, Dc = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), ay = {}, yh = {}, Fc = 0;
    Ct.__reactDisabledLog = !0;
    var Kf, bh, Ic = !1, Xf = new (typeof WeakMap == "function" ? WeakMap : Map)(), ur = null, Pa = !1, cb = /[\n"\\]/g, $f = !1, Zf = !1, Mc = !1, Jf = !1, vh = !1, ep = !1, sl = ["value", "defaultValue"], cl = !1, dl = /["'&<>\n\t]|^\s|\s$/, jc = "address applet area article aside base basefont bgsound blockquote body br button caption center col colgroup dd details dir div dl dt embed fieldset figcaption figure footer form frame frameset h1 h2 h3 h4 h5 h6 head header hgroup hr html iframe img input isindex li link listing main marquee menu menuitem meta nav noembed noframes noscript object ol p param plaintext pre script section select source style summary table tbody td template textarea tfoot th thead title tr track ul wbr xmp".split(" "), ns = "applet caption html table td th marquee object template foreignObject desc title".split(" "), Kl = ns.concat(["button"]), db = "dd dt li option optgroup p rp rt".split(" "), kh = { current: null, formTag: null, aTagInScope: null, buttonTagInScope: null, nobrTagInScope: null, pTagInButtonScope: null, listItemTagAutoclosing: null, dlItemTagAutoclosing: null, containerTagInScope: null, implicitRootScope: !1 }, Xl = {}, np = { animation: "animationDelay animationDirection animationDuration animationFillMode animationIterationCount animationName animationPlayState animationTimingFunction".split(" "), background: "backgroundAttachment backgroundClip backgroundColor backgroundImage backgroundOrigin backgroundPositionX backgroundPositionY backgroundRepeat backgroundSize".split(" "), backgroundPosition: ["backgroundPositionX", "backgroundPositionY"], border: "borderBottomColor borderBottomStyle borderBottomWidth borderImageOutset borderImageRepeat borderImageSlice borderImageSource borderImageWidth borderLeftColor borderLeftStyle borderLeftWidth borderRightColor borderRightStyle borderRightWidth borderTopColor borderTopStyle borderTopWidth".split(" "), borderBlockEnd: ["borderBlockEndColor", "borderBlockEndStyle", "borderBlockEndWidth"], borderBlockStart: ["borderBlockStartColor", "borderBlockStartStyle", "borderBlockStartWidth"], borderBottom: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth"], borderColor: ["borderBottomColor", "borderLeftColor", "borderRightColor", "borderTopColor"], borderImage: ["borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth"], borderInlineEnd: ["borderInlineEndColor", "borderInlineEndStyle", "borderInlineEndWidth"], borderInlineStart: ["borderInlineStartColor", "borderInlineStartStyle", "borderInlineStartWidth"], borderLeft: ["borderLeftColor", "borderLeftStyle", "borderLeftWidth"], borderRadius: ["borderBottomLeftRadius", "borderBottomRightRadius", "borderTopLeftRadius", "borderTopRightRadius"], borderRight: ["borderRightColor", "borderRightStyle", "borderRightWidth"], borderStyle: ["borderBottomStyle", "borderLeftStyle", "borderRightStyle", "borderTopStyle"], borderTop: ["borderTopColor", "borderTopStyle", "borderTopWidth"], borderWidth: ["borderBottomWidth", "borderLeftWidth", "borderRightWidth", "borderTopWidth"], columnRule: ["columnRuleColor", "columnRuleStyle", "columnRuleWidth"], columns: ["columnCount", "columnWidth"], flex: ["flexBasis", "flexGrow", "flexShrink"], flexFlow: ["flexDirection", "flexWrap"], font: "fontFamily fontFeatureSettings fontKerning fontLanguageOverride fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontVariantAlternates fontVariantCaps fontVariantEastAsian fontVariantLigatures fontVariantNumeric fontVariantPosition fontWeight lineHeight".split(" "), fontVariant: "fontVariantAlternates fontVariantCaps fontVariantEastAsian fontVariantLigatures fontVariantNumeric fontVariantPosition".split(" "), gap: ["columnGap", "rowGap"], grid: "gridAutoColumns gridAutoFlow gridAutoRows gridTemplateAreas gridTemplateColumns gridTemplateRows".split(" "), gridArea: ["gridColumnEnd", "gridColumnStart", "gridRowEnd", "gridRowStart"], gridColumn: ["gridColumnEnd", "gridColumnStart"], gridColumnGap: ["columnGap"], gridGap: ["columnGap", "rowGap"], gridRow: ["gridRowEnd", "gridRowStart"], gridRowGap: ["rowGap"], gridTemplate: ["gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"], listStyle: ["listStyleImage", "listStylePosition", "listStyleType"], margin: ["marginBottom", "marginLeft", "marginRight", "marginTop"], marker: ["markerEnd", "markerMid", "markerStart"], mask: "maskClip maskComposite maskImage maskMode maskOrigin maskPositionX maskPositionY maskRepeat maskSize".split(" "), maskPosition: ["maskPositionX", "maskPositionY"], outline: ["outlineColor", "outlineStyle", "outlineWidth"], overflow: ["overflowX", "overflowY"], padding: ["paddingBottom", "paddingLeft", "paddingRight", "paddingTop"], placeContent: ["alignContent", "justifyContent"], placeItems: ["alignItems", "justifyItems"], placeSelf: ["alignSelf", "justifySelf"], textDecoration: ["textDecorationColor", "textDecorationLine", "textDecorationStyle"], textEmphasis: ["textEmphasisColor", "textEmphasisStyle"], transition: ["transitionDelay", "transitionDuration", "transitionProperty", "transitionTimingFunction"], wordWrap: ["overflowWrap"] }, Hc = /([A-Z])/g, wh = /^ms-/, fb = /^(?:webkit|moz|o)[A-Z]/, tp = /^-ms-/, rp = /-(.)/g, Sh = /;\s*$/, Ra = {}, Uc = {}, Bc = !1, Eh = !1, ly = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" ")), eu = "http://www.w3.org/1998/Math/MathML", t = "http://www.w3.org/2000/svg", o = /* @__PURE__ */ new Map([["acceptCharset", "accept-charset"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"], ["crossOrigin", "crossorigin"], ["accentHeight", "accent-height"], ["alignmentBaseline", "alignment-baseline"], ["arabicForm", "arabic-form"], ["baselineShift", "baseline-shift"], ["capHeight", "cap-height"], ["clipPath", "clip-path"], ["clipRule", "clip-rule"], ["colorInterpolation", "color-interpolation"], ["colorInterpolationFilters", "color-interpolation-filters"], ["colorProfile", "color-profile"], ["colorRendering", "color-rendering"], ["dominantBaseline", "dominant-baseline"], ["enableBackground", "enable-background"], ["fillOpacity", "fill-opacity"], ["fillRule", "fill-rule"], ["floodColor", "flood-color"], ["floodOpacity", "flood-opacity"], ["fontFamily", "font-family"], ["fontSize", "font-size"], ["fontSizeAdjust", "font-size-adjust"], ["fontStretch", "font-stretch"], ["fontStyle", "font-style"], ["fontVariant", "font-variant"], ["fontWeight", "font-weight"], ["glyphName", "glyph-name"], ["glyphOrientationHorizontal", "glyph-orientation-horizontal"], ["glyphOrientationVertical", "glyph-orientation-vertical"], ["horizAdvX", "horiz-adv-x"], ["horizOriginX", "horiz-origin-x"], ["imageRendering", "image-rendering"], ["letterSpacing", "letter-spacing"], ["lightingColor", "lighting-color"], ["markerEnd", "marker-end"], ["markerMid", "marker-mid"], ["markerStart", "marker-start"], ["overlinePosition", "overline-position"], ["overlineThickness", "overline-thickness"], ["paintOrder", "paint-order"], ["panose-1", "panose-1"], ["pointerEvents", "pointer-events"], ["renderingIntent", "rendering-intent"], ["shapeRendering", "shape-rendering"], ["stopColor", "stop-color"], ["stopOpacity", "stop-opacity"], ["strikethroughPosition", "strikethrough-position"], ["strikethroughThickness", "strikethrough-thickness"], ["strokeDasharray", "stroke-dasharray"], ["strokeDashoffset", "stroke-dashoffset"], ["strokeLinecap", "stroke-linecap"], ["strokeLinejoin", "stroke-linejoin"], ["strokeMiterlimit", "stroke-miterlimit"], ["strokeOpacity", "stroke-opacity"], ["strokeWidth", "stroke-width"], ["textAnchor", "text-anchor"], ["textDecoration", "text-decoration"], ["textRendering", "text-rendering"], ["transformOrigin", "transform-origin"], ["underlinePosition", "underline-position"], ["underlineThickness", "underline-thickness"], ["unicodeBidi", "unicode-bidi"], ["unicodeRange", "unicode-range"], ["unitsPerEm", "units-per-em"], ["vAlphabetic", "v-alphabetic"], ["vHanging", "v-hanging"], ["vIdeographic", "v-ideographic"], ["vMathematical", "v-mathematical"], ["vectorEffect", "vector-effect"], ["vertAdvY", "vert-adv-y"], ["vertOriginX", "vert-origin-x"], ["vertOriginY", "vert-origin-y"], ["wordSpacing", "word-spacing"], ["writingMode", "writing-mode"], ["xmlnsXlink", "xmlns:xlink"], ["xHeight", "x-height"]]), a = { accept: "accept", acceptcharset: "acceptCharset", "accept-charset": "acceptCharset", accesskey: "accessKey", action: "action", allowfullscreen: "allowFullScreen", alt: "alt", as: "as", async: "async", autocapitalize: "autoCapitalize", autocomplete: "autoComplete", autocorrect: "autoCorrect", autofocus: "autoFocus", autoplay: "autoPlay", autosave: "autoSave", capture: "capture", cellpadding: "cellPadding", cellspacing: "cellSpacing", challenge: "challenge", charset: "charSet", checked: "checked", children: "children", cite: "cite", class: "className", classid: "classID", classname: "className", cols: "cols", colspan: "colSpan", content: "content", contenteditable: "contentEditable", contextmenu: "contextMenu", controls: "controls", controlslist: "controlsList", coords: "coords", crossorigin: "crossOrigin", dangerouslysetinnerhtml: "dangerouslySetInnerHTML", data: "data", datetime: "dateTime", default: "default", defaultchecked: "defaultChecked", defaultvalue: "defaultValue", defer: "defer", dir: "dir", disabled: "disabled", disablepictureinpicture: "disablePictureInPicture", disableremoteplayback: "disableRemotePlayback", download: "download", draggable: "draggable", enctype: "encType", enterkeyhint: "enterKeyHint", fetchpriority: "fetchPriority", for: "htmlFor", form: "form", formmethod: "formMethod", formaction: "formAction", formenctype: "formEncType", formnovalidate: "formNoValidate", formtarget: "formTarget", frameborder: "frameBorder", headers: "headers", height: "height", hidden: "hidden", high: "high", href: "href", hreflang: "hrefLang", htmlfor: "htmlFor", httpequiv: "httpEquiv", "http-equiv": "httpEquiv", icon: "icon", id: "id", imagesizes: "imageSizes", imagesrcset: "imageSrcSet", inert: "inert", innerhtml: "innerHTML", inputmode: "inputMode", integrity: "integrity", is: "is", itemid: "itemID", itemprop: "itemProp", itemref: "itemRef", itemscope: "itemScope", itemtype: "itemType", keyparams: "keyParams", keytype: "keyType", kind: "kind", label: "label", lang: "lang", list: "list", loop: "loop", low: "low", manifest: "manifest", marginwidth: "marginWidth", marginheight: "marginHeight", max: "max", maxlength: "maxLength", media: "media", mediagroup: "mediaGroup", method: "method", min: "min", minlength: "minLength", multiple: "multiple", muted: "muted", name: "name", nomodule: "noModule", nonce: "nonce", novalidate: "noValidate", open: "open", optimum: "optimum", pattern: "pattern", placeholder: "placeholder", playsinline: "playsInline", poster: "poster", preload: "preload", profile: "profile", radiogroup: "radioGroup", readonly: "readOnly", referrerpolicy: "referrerPolicy", rel: "rel", required: "required", reversed: "reversed", role: "role", rows: "rows", rowspan: "rowSpan", sandbox: "sandbox", scope: "scope", scoped: "scoped", scrolling: "scrolling", seamless: "seamless", selected: "selected", shape: "shape", size: "size", sizes: "sizes", span: "span", spellcheck: "spellCheck", src: "src", srcdoc: "srcDoc", srclang: "srcLang", srcset: "srcSet", start: "start", step: "step", style: "style", summary: "summary", tabindex: "tabIndex", target: "target", title: "title", type: "type", usemap: "useMap", value: "value", width: "width", wmode: "wmode", wrap: "wrap", about: "about", accentheight: "accentHeight", "accent-height": "accentHeight", accumulate: "accumulate", additive: "additive", alignmentbaseline: "alignmentBaseline", "alignment-baseline": "alignmentBaseline", allowreorder: "allowReorder", alphabetic: "alphabetic", amplitude: "amplitude", arabicform: "arabicForm", "arabic-form": "arabicForm", ascent: "ascent", attributename: "attributeName", attributetype: "attributeType", autoreverse: "autoReverse", azimuth: "azimuth", basefrequency: "baseFrequency", baselineshift: "baselineShift", "baseline-shift": "baselineShift", baseprofile: "baseProfile", bbox: "bbox", begin: "begin", bias: "bias", by: "by", calcmode: "calcMode", capheight: "capHeight", "cap-height": "capHeight", clip: "clip", clippath: "clipPath", "clip-path": "clipPath", clippathunits: "clipPathUnits", cliprule: "clipRule", "clip-rule": "clipRule", color: "color", colorinterpolation: "colorInterpolation", "color-interpolation": "colorInterpolation", colorinterpolationfilters: "colorInterpolationFilters", "color-interpolation-filters": "colorInterpolationFilters", colorprofile: "colorProfile", "color-profile": "colorProfile", colorrendering: "colorRendering", "color-rendering": "colorRendering", contentscripttype: "contentScriptType", contentstyletype: "contentStyleType", cursor: "cursor", cx: "cx", cy: "cy", d: "d", datatype: "datatype", decelerate: "decelerate", descent: "descent", diffuseconstant: "diffuseConstant", direction: "direction", display: "display", divisor: "divisor", dominantbaseline: "dominantBaseline", "dominant-baseline": "dominantBaseline", dur: "dur", dx: "dx", dy: "dy", edgemode: "edgeMode", elevation: "elevation", enablebackground: "enableBackground", "enable-background": "enableBackground", end: "end", exponent: "exponent", externalresourcesrequired: "externalResourcesRequired", fill: "fill", fillopacity: "fillOpacity", "fill-opacity": "fillOpacity", fillrule: "fillRule", "fill-rule": "fillRule", filter: "filter", filterres: "filterRes", filterunits: "filterUnits", floodopacity: "floodOpacity", "flood-opacity": "floodOpacity", floodcolor: "floodColor", "flood-color": "floodColor", focusable: "focusable", fontfamily: "fontFamily", "font-family": "fontFamily", fontsize: "fontSize", "font-size": "fontSize", fontsizeadjust: "fontSizeAdjust", "font-size-adjust": "fontSizeAdjust", fontstretch: "fontStretch", "font-stretch": "fontStretch", fontstyle: "fontStyle", "font-style": "fontStyle", fontvariant: "fontVariant", "font-variant": "fontVariant", fontweight: "fontWeight", "font-weight": "fontWeight", format: "format", from: "from", fx: "fx", fy: "fy", g1: "g1", g2: "g2", glyphname: "glyphName", "glyph-name": "glyphName", glyphorientationhorizontal: "glyphOrientationHorizontal", "glyph-orientation-horizontal": "glyphOrientationHorizontal", glyphorientationvertical: "glyphOrientationVertical", "glyph-orientation-vertical": "glyphOrientationVertical", glyphref: "glyphRef", gradienttransform: "gradientTransform", gradientunits: "gradientUnits", hanging: "hanging", horizadvx: "horizAdvX", "horiz-adv-x": "horizAdvX", horizoriginx: "horizOriginX", "horiz-origin-x": "horizOriginX", ideographic: "ideographic", imagerendering: "imageRendering", "image-rendering": "imageRendering", in2: "in2", in: "in", inlist: "inlist", intercept: "intercept", k1: "k1", k2: "k2", k3: "k3", k4: "k4", k: "k", kernelmatrix: "kernelMatrix", kernelunitlength: "kernelUnitLength", kerning: "kerning", keypoints: "keyPoints", keysplines: "keySplines", keytimes: "keyTimes", lengthadjust: "lengthAdjust", letterspacing: "letterSpacing", "letter-spacing": "letterSpacing", lightingcolor: "lightingColor", "lighting-color": "lightingColor", limitingconeangle: "limitingConeAngle", local: "local", markerend: "markerEnd", "marker-end": "markerEnd", markerheight: "markerHeight", markermid: "markerMid", "marker-mid": "markerMid", markerstart: "markerStart", "marker-start": "markerStart", markerunits: "markerUnits", markerwidth: "markerWidth", mask: "mask", maskcontentunits: "maskContentUnits", maskunits: "maskUnits", mathematical: "mathematical", mode: "mode", numoctaves: "numOctaves", offset: "offset", opacity: "opacity", operator: "operator", order: "order", orient: "orient", orientation: "orientation", origin: "origin", overflow: "overflow", overlineposition: "overlinePosition", "overline-position": "overlinePosition", overlinethickness: "overlineThickness", "overline-thickness": "overlineThickness", paintorder: "paintOrder", "paint-order": "paintOrder", panose1: "panose1", "panose-1": "panose1", pathlength: "pathLength", patterncontentunits: "patternContentUnits", patterntransform: "patternTransform", patternunits: "patternUnits", pointerevents: "pointerEvents", "pointer-events": "pointerEvents", points: "points", pointsatx: "pointsAtX", pointsaty: "pointsAtY", pointsatz: "pointsAtZ", popover: "popover", popovertarget: "popoverTarget", popovertargetaction: "popoverTargetAction", prefix: "prefix", preservealpha: "preserveAlpha", preserveaspectratio: "preserveAspectRatio", primitiveunits: "primitiveUnits", property: "property", r: "r", radius: "radius", refx: "refX", refy: "refY", renderingintent: "renderingIntent", "rendering-intent": "renderingIntent", repeatcount: "repeatCount", repeatdur: "repeatDur", requiredextensions: "requiredExtensions", requiredfeatures: "requiredFeatures", resource: "resource", restart: "restart", result: "result", results: "results", rotate: "rotate", rx: "rx", ry: "ry", scale: "scale", security: "security", seed: "seed", shaperendering: "shapeRendering", "shape-rendering": "shapeRendering", slope: "slope", spacing: "spacing", specularconstant: "specularConstant", specularexponent: "specularExponent", speed: "speed", spreadmethod: "spreadMethod", startoffset: "startOffset", stddeviation: "stdDeviation", stemh: "stemh", stemv: "stemv", stitchtiles: "stitchTiles", stopcolor: "stopColor", "stop-color": "stopColor", stopopacity: "stopOpacity", "stop-opacity": "stopOpacity", strikethroughposition: "strikethroughPosition", "strikethrough-position": "strikethroughPosition", strikethroughthickness: "strikethroughThickness", "strikethrough-thickness": "strikethroughThickness", string: "string", stroke: "stroke", strokedasharray: "strokeDasharray", "stroke-dasharray": "strokeDasharray", strokedashoffset: "strokeDashoffset", "stroke-dashoffset": "strokeDashoffset", strokelinecap: "strokeLinecap", "stroke-linecap": "strokeLinecap", strokelinejoin: "strokeLinejoin", "stroke-linejoin": "strokeLinejoin", strokemiterlimit: "strokeMiterlimit", "stroke-miterlimit": "strokeMiterlimit", strokewidth: "strokeWidth", "stroke-width": "strokeWidth", strokeopacity: "strokeOpacity", "stroke-opacity": "strokeOpacity", suppresscontenteditablewarning: "suppressContentEditableWarning", suppresshydrationwarning: "suppressHydrationWarning", surfacescale: "surfaceScale", systemlanguage: "systemLanguage", tablevalues: "tableValues", targetx: "targetX", targety: "targetY", textanchor: "textAnchor", "text-anchor": "textAnchor", textdecoration: "textDecoration", "text-decoration": "textDecoration", textlength: "textLength", textrendering: "textRendering", "text-rendering": "textRendering", to: "to", transform: "transform", transformorigin: "transformOrigin", "transform-origin": "transformOrigin", typeof: "typeof", u1: "u1", u2: "u2", underlineposition: "underlinePosition", "underline-position": "underlinePosition", underlinethickness: "underlineThickness", "underline-thickness": "underlineThickness", unicode: "unicode", unicodebidi: "unicodeBidi", "unicode-bidi": "unicodeBidi", unicoderange: "unicodeRange", "unicode-range": "unicodeRange", unitsperem: "unitsPerEm", "units-per-em": "unitsPerEm", unselectable: "unselectable", valphabetic: "vAlphabetic", "v-alphabetic": "vAlphabetic", values: "values", vectoreffect: "vectorEffect", "vector-effect": "vectorEffect", version: "version", vertadvy: "vertAdvY", "vert-adv-y": "vertAdvY", vertoriginx: "vertOriginX", "vert-origin-x": "vertOriginX", vertoriginy: "vertOriginY", "vert-origin-y": "vertOriginY", vhanging: "vHanging", "v-hanging": "vHanging", videographic: "vIdeographic", "v-ideographic": "vIdeographic", viewbox: "viewBox", viewtarget: "viewTarget", visibility: "visibility", vmathematical: "vMathematical", "v-mathematical": "vMathematical", vocab: "vocab", widths: "widths", wordspacing: "wordSpacing", "word-spacing": "wordSpacing", writingmode: "writingMode", "writing-mode": "writingMode", x1: "x1", x2: "x2", x: "x", xchannelselector: "xChannelSelector", xheight: "xHeight", "x-height": "xHeight", xlinkactuate: "xlinkActuate", "xlink:actuate": "xlinkActuate", xlinkarcrole: "xlinkArcrole", "xlink:arcrole": "xlinkArcrole", xlinkhref: "xlinkHref", "xlink:href": "xlinkHref", xlinkrole: "xlinkRole", "xlink:role": "xlinkRole", xlinkshow: "xlinkShow", "xlink:show": "xlinkShow", xlinktitle: "xlinkTitle", "xlink:title": "xlinkTitle", xlinktype: "xlinkType", "xlink:type": "xlinkType", xmlbase: "xmlBase", "xml:base": "xmlBase", xmllang: "xmlLang", "xml:lang": "xmlLang", xmlns: "xmlns", "xml:space": "xmlSpace", xmlnsxlink: "xmlnsXlink", "xmlns:xlink": "xmlnsXlink", xmlspace: "xmlSpace", y1: "y1", y2: "y2", y: "y", ychannelselector: "yChannelSelector", z: "z", zoomandpan: "zoomAndPan" }, u = { "aria-current": 0, "aria-description": 0, "aria-details": 0, "aria-disabled": 0, "aria-hidden": 0, "aria-invalid": 0, "aria-keyshortcuts": 0, "aria-label": 0, "aria-roledescription": 0, "aria-autocomplete": 0, "aria-checked": 0, "aria-expanded": 0, "aria-haspopup": 0, "aria-level": 0, "aria-modal": 0, "aria-multiline": 0, "aria-multiselectable": 0, "aria-orientation": 0, "aria-placeholder": 0, "aria-pressed": 0, "aria-readonly": 0, "aria-required": 0, "aria-selected": 0, "aria-sort": 0, "aria-valuemax": 0, "aria-valuemin": 0, "aria-valuenow": 0, "aria-valuetext": 0, "aria-atomic": 0, "aria-busy": 0, "aria-live": 0, "aria-relevant": 0, "aria-dropeffect": 0, "aria-grabbed": 0, "aria-activedescendant": 0, "aria-colcount": 0, "aria-colindex": 0, "aria-colspan": 0, "aria-controls": 0, "aria-describedby": 0, "aria-errormessage": 0, "aria-flowto": 0, "aria-labelledby": 0, "aria-owns": 0, "aria-posinset": 0, "aria-rowcount": 0, "aria-rowindex": 0, "aria-rowspan": 0, "aria-setsize": 0 }, c = {}, d = RegExp("^(aria)-[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), g = RegExp("^(aria)[A-Z][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), h = !1, w = {}, x = /^on./, B = /^on[^A-Z]/, q = RegExp("^(aria)-[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), ee = RegExp("^(aria)[A-Z][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), le = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i, de = null, I = null, _ = null, M = !1, ie = !(typeof window > "u" || window.document === void 0 || window.document.createElement === void 0), xe = !1;
    if (ie) try {
      var Re = {};
      Object.defineProperty(Re, "passive", { get: function() {
        xe = !0;
      } }), window.addEventListener("test", Re, Re), window.removeEventListener("test", Re, Re);
    } catch {
      xe = !1;
    }
    var Ve, En, yt, ln = null, Cn = null, Ne = null, Ke = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(e) {
      return e.timeStamp || Date.now();
    }, defaultPrevented: 0, isTrusted: 0 }, Zn = it(Ke), qe = en({}, Ke, { view: 0, detail: 0 }), zr = it(qe), $r = en({}, qe, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: di, button: 0, buttons: 0, relatedTarget: function(e) {
      return e.relatedTarget === void 0 ? e.fromElement === e.srcElement ? e.toElement : e.fromElement : e.relatedTarget;
    }, movementX: function(e) {
      return "movementX" in e ? e.movementX : (e !== yt && (yt && e.type === "mousemove" ? (Ve = e.screenX - yt.screenX, En = e.screenY - yt.screenY) : En = Ve = 0, yt = e), Ve);
    }, movementY: function(e) {
      return "movementY" in e ? e.movementY : En;
    } }), xh = it($r), Vc = it(en({}, $r, { dataTransfer: 0 })), pb = it(en({}, qe, { relatedTarget: 0 })), Hw = it(en({}, Ke, { animationName: 0, elapsedTime: 0, pseudoElement: 0 })), Uw = it(en({}, Ke, { clipboardData: function(e) {
      return "clipboardData" in e ? e.clipboardData : window.clipboardData;
    } })), zv = it(en({}, Ke, { data: 0 })), Bw = zv, Vw = { Esc: "Escape", Spacebar: " ", Left: "ArrowLeft", Up: "ArrowUp", Right: "ArrowRight", Down: "ArrowDown", Del: "Delete", Win: "OS", Menu: "ContextMenu", Apps: "ContextMenu", Scroll: "ScrollLock", MozPrintableKey: "Unidentified" }, Ww = { 8: "Backspace", 9: "Tab", 12: "Clear", 13: "Enter", 16: "Shift", 17: "Control", 18: "Alt", 19: "Pause", 20: "CapsLock", 27: "Escape", 32: " ", 33: "PageUp", 34: "PageDown", 35: "End", 36: "Home", 37: "ArrowLeft", 38: "ArrowUp", 39: "ArrowRight", 40: "ArrowDown", 45: "Insert", 46: "Delete", 112: "F1", 113: "F2", 114: "F3", 115: "F4", 116: "F5", 117: "F6", 118: "F7", 119: "F8", 120: "F9", 121: "F10", 122: "F11", 123: "F12", 144: "NumLock", 145: "ScrollLock", 224: "Meta" }, qw = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" }, Qw = it(en({}, qe, { key: function(e) {
      if (e.key) {
        var n = Vw[e.key] || e.key;
        if (n !== "Unidentified") return n;
      }
      return e.type === "keypress" ? (e = gu(e)) === 13 ? "Enter" : String.fromCharCode(e) : e.type === "keydown" || e.type === "keyup" ? Ww[e.keyCode] || "Unidentified" : "";
    }, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: di, charCode: function(e) {
      return e.type === "keypress" ? gu(e) : 0;
    }, keyCode: function(e) {
      return e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
    }, which: function(e) {
      return e.type === "keypress" ? gu(e) : e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
    } })), Dv = it(en({}, $r, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 })), Yw = it(en({}, qe, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: di })), Gw = it(en({}, Ke, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 })), Kw = it(en({}, $r, { deltaX: function(e) {
      return "deltaX" in e ? e.deltaX : "wheelDeltaX" in e ? -e.wheelDeltaX : 0;
    }, deltaY: function(e) {
      return "deltaY" in e ? e.deltaY : "wheelDeltaY" in e ? -e.wheelDeltaY : "wheelDelta" in e ? -e.wheelDelta : 0;
    }, deltaZ: 0, deltaMode: 0 })), Xw = it(en({}, Ke, { newState: 0, oldState: 0 })), $w = [9, 13, 27, 32], Fv = 229, mb = ie && "CompositionEvent" in window, Ch = null;
    ie && "documentMode" in document && (Ch = document.documentMode);
    var Zw = ie && "TextEvent" in window && !Ch, Iv = ie && (!mb || Ch && 8 < Ch && 11 >= Ch), Mv = 32, jv = String.fromCharCode(Mv), Hv = !1, op = !1, Jw = { color: !0, date: !0, datetime: !0, "datetime-local": !0, email: !0, month: !0, number: !0, password: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0 }, iy = null, Th = null, Uv = !1;
    ie && (Uv = function(e) {
      if (!ie) return !1;
      var n = (e = "on" + e) in document;
      return n || ((n = document.createElement("div")).setAttribute(e, "return;"), n = typeof n[e] == "function"), n;
    }("input") && (!document.documentMode || 9 < document.documentMode));
    var Zr = typeof Object.is == "function" ? Object.is : function(e, n) {
      return e === n && (e !== 0 || 1 / e == 1 / n) || e != e && n != n;
    }, e1 = ie && "documentMode" in document && 11 >= document.documentMode, ap = null, hb = null, Ph = null, gb = !1, lp = { animationend: mi("Animation", "AnimationEnd"), animationiteration: mi("Animation", "AnimationIteration"), animationstart: mi("Animation", "AnimationStart"), transitionrun: mi("Transition", "TransitionRun"), transitionstart: mi("Transition", "TransitionStart"), transitioncancel: mi("Transition", "TransitionCancel"), transitionend: mi("Transition", "TransitionEnd") }, yb = {}, Bv = {};
    ie && (Bv = document.createElement("div").style, "AnimationEvent" in window || (delete lp.animationend.animation, delete lp.animationiteration.animation, delete lp.animationstart.animation), "TransitionEvent" in window || delete lp.transitionend.transition);
    var Vv = El("animationend"), Wv = El("animationiteration"), qv = El("animationstart"), n1 = El("transitionrun"), t1 = El("transitionstart"), r1 = El("transitioncancel"), Qv = El("transitionend"), Yv = /* @__PURE__ */ new Map(), bb = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
    bb.push("scrollEnd");
    var vb = /* @__PURE__ */ new WeakMap(), uy = 1, nu = 2, Aa = [], ip = 0, kb = 0, ts = {};
    Object.freeze(ts);
    var Na = null, up = null, Jn = 0, o1 = 1, kr = 2, Dr = 8, fl = 16, Gv = 64, Kv = !1;
    try {
      Object.preventExtensions({});
    } catch {
      Kv = !0;
    }
    var sp = [], cp = 0, sy = null, cy = 0, _a = [], Oa = 0, Wc = null, $l = 1, tu = "", Jr = null, Et = null, Tn = !1, ru = !1, La = null, qc = null, Zl = !1, wb = Error("Hydration Mismatch Exception: This is not a real error, and should not leak into userspace. If you're seeing this, it's likely a bug in React."), Xv = 0;
    if (typeof performance == "object" && typeof performance.now == "function") var a1 = performance, $v = function() {
      return a1.now();
    };
    else {
      var l1 = Date;
      $v = function() {
        return l1.now();
      };
    }
    var Sb = Me(null), Eb = Me(null), Zv = {}, dy = null, dp = null, fp = !1, i1 = typeof AbortController < "u" ? AbortController : function() {
      var e = [], n = this.signal = { aborted: !1, addEventListener: function(r, l) {
        e.push(l);
      } };
      this.abort = function() {
        n.aborted = !0, e.forEach(function(r) {
          return r();
        });
      };
    }, u1 = gt.unstable_scheduleCallback, s1 = gt.unstable_NormalPriority, Qt = { $$typeof: mo, Consumer: null, Provider: null, _currentValue: null, _currentValue2: null, _threadCount: 0, _currentRenderer: null, _currentRenderer2: null }, pp = gt.unstable_now, Jv = -0, fy = -0, ho = -1.1, Qc = -0, py = !1, my = !1, Rh = null, xb = 0, Yc = 0, Gc = null, e0 = J.S;
    J.S = function(e, n) {
      typeof n == "object" && n !== null && typeof n.then == "function" && function(r, l) {
        if (Rh === null) {
          var i = Rh = [];
          xb = 0, Yc = lt(), Gc = { status: "pending", value: void 0, then: function(s) {
            i.push(s);
          } };
        }
        xb++, l.then(Eg, Eg);
      }(0, n), e0 !== null && e0(e, n);
    };
    var mp = Me(null), pl = { recordUnsafeLifecycleWarnings: function() {
    }, flushPendingUnsafeLifecycleWarnings: function() {
    }, recordLegacyContextWarning: function() {
    }, flushLegacyContextWarning: function() {
    }, discardPendingWarnings: function() {
    } }, Ah = [], Nh = [], _h = [], Oh = [], Lh = [], zh = [], Kc = /* @__PURE__ */ new Set();
    pl.recordUnsafeLifecycleWarnings = function(e, n) {
      Kc.has(e.type) || (typeof n.componentWillMount == "function" && n.componentWillMount.__suppressDeprecationWarning !== !0 && Ah.push(e), e.mode & Dr && typeof n.UNSAFE_componentWillMount == "function" && Nh.push(e), typeof n.componentWillReceiveProps == "function" && n.componentWillReceiveProps.__suppressDeprecationWarning !== !0 && _h.push(e), e.mode & Dr && typeof n.UNSAFE_componentWillReceiveProps == "function" && Oh.push(e), typeof n.componentWillUpdate == "function" && n.componentWillUpdate.__suppressDeprecationWarning !== !0 && Lh.push(e), e.mode & Dr && typeof n.UNSAFE_componentWillUpdate == "function" && zh.push(e));
    }, pl.flushPendingUnsafeLifecycleWarnings = function() {
      var e = /* @__PURE__ */ new Set();
      0 < Ah.length && (Ah.forEach(function(p) {
        e.add(Ee(p) || "Component"), Kc.add(p.type);
      }), Ah = []);
      var n = /* @__PURE__ */ new Set();
      0 < Nh.length && (Nh.forEach(function(p) {
        n.add(Ee(p) || "Component"), Kc.add(p.type);
      }), Nh = []);
      var r = /* @__PURE__ */ new Set();
      0 < _h.length && (_h.forEach(function(p) {
        r.add(Ee(p) || "Component"), Kc.add(p.type);
      }), _h = []);
      var l = /* @__PURE__ */ new Set();
      0 < Oh.length && (Oh.forEach(function(p) {
        l.add(Ee(p) || "Component"), Kc.add(p.type);
      }), Oh = []);
      var i = /* @__PURE__ */ new Set();
      0 < Lh.length && (Lh.forEach(function(p) {
        i.add(Ee(p) || "Component"), Kc.add(p.type);
      }), Lh = []);
      var s = /* @__PURE__ */ new Set();
      if (0 < zh.length && (zh.forEach(function(p) {
        s.add(Ee(p) || "Component"), Kc.add(p.type);
      }), zh = []), 0 < n.size) {
        var f = O(n);
        console.error(`Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.

Please update the following components: %s`, f);
      }
      0 < l.size && (f = O(l), console.error(`Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://react.dev/link/derived-state

Please update the following components: %s`, f)), 0 < s.size && (f = O(s), console.error(`Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.

Please update the following components: %s`, f)), 0 < e.size && (f = O(e), console.warn(`componentWillMount has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.
* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, f)), 0 < r.size && (f = O(r), console.warn(`componentWillReceiveProps has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://react.dev/link/derived-state
* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, f)), 0 < i.size && (f = O(i), console.warn(`componentWillUpdate has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, f));
    };
    var hy = /* @__PURE__ */ new Map(), n0 = /* @__PURE__ */ new Set();
    pl.recordLegacyContextWarning = function(e, n) {
      for (var r = null, l = e; l !== null; ) l.mode & Dr && (r = l), l = l.return;
      r === null ? console.error("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.") : !n0.has(e.type) && (l = hy.get(r), e.type.contextTypes != null || e.type.childContextTypes != null || n !== null && typeof n.getChildContext == "function") && (l === void 0 && (l = [], hy.set(r, l)), l.push(e));
    }, pl.flushLegacyContextWarning = function() {
      hy.forEach(function(e) {
        if (e.length !== 0) {
          var n = e[0], r = /* @__PURE__ */ new Set();
          e.forEach(function(i) {
            r.add(Ee(i) || "Component"), n0.add(i.type);
          });
          var l = O(r);
          De(n, function() {
            console.error(`Legacy context API has been detected within a strict-mode tree.

The old API will be supported in all 16.x releases, but applications using it should migrate to the new version.

Please update the following components: %s

Learn more about this warning here: https://react.dev/link/legacy-context`, l);
          });
        }
      });
    }, pl.discardPendingWarnings = function() {
      Ah = [], Nh = [], _h = [], Oh = [], Lh = [], zh = [], hy = /* @__PURE__ */ new Map();
    };
    var hp, Dh = Error("Suspense Exception: This is not a real error! It's an implementation detail of `use` to interrupt the current render. You must either rethrow it immediately, or move the `use` call outside of the `try/catch` block. Capturing without rethrowing will lead to unexpected behavior.\n\nTo handle async errors, wrap your component in an error boundary, or call the promise's `.catch` method and pass the result to `use`."), t0 = Error("Suspense Exception: This is not a real error, and should not leak into userspace. If you're seeing this, it's likely a bug in React."), gy = Error("Suspense Exception: This is not a real error! It's an implementation detail of `useActionState` to interrupt the current render. You must either rethrow it immediately, or move the `useActionState` call outside of the `try/catch` block. Capturing without rethrowing will lead to unexpected behavior.\n\nTo handle async errors, wrap your component in an error boundary."), Cb = { then: function() {
      console.error('Internal React error: A listener was unexpectedly attached to a "noop" thenable. This is a bug in React. Please file an issue.');
    } }, Fh = null, yy = !1, za = 0, Da = 1, eo = 2, wr = 4, Yt = 8, r0 = 0, o0 = 1, a0 = 2, Tb = 3, rs = !1, l0 = !1, Pb = null, Rb = !1, gp = Me(null), by = Me(0), i0 = /* @__PURE__ */ new Set(), u0 = /* @__PURE__ */ new Set(), Ab = /* @__PURE__ */ new Set(), s0 = /* @__PURE__ */ new Set(), os = 0, Ye = null, et = null, jt = null, vy = !1, yp = !1, Xc = !1, ky = 0, Ih = 0, ou = null, c1 = 0, d1 = 25, ne = null, Fa = null, au = -1, Mh = !1, wy = { readContext: qn, use: Jo, useCallback: tt, useContext: tt, useEffect: tt, useImperativeHandle: tt, useLayoutEffect: tt, useInsertionEffect: tt, useMemo: tt, useReducer: tt, useRef: tt, useState: tt, useDebugValue: tt, useDeferredValue: tt, useTransition: tt, useSyncExternalStore: tt, useId: tt, useHostTransitionStatus: tt, useFormState: tt, useActionState: tt, useOptimistic: tt, useMemoCache: tt, useCacheRefresh: tt }, Nb = null, c0 = null, _b = null, d0 = null, Jl = null, ml = null, Sy = null;
    Nb = { readContext: function(e) {
      return qn(e);
    }, use: Jo, useCallback: function(e, n) {
      return ne = "useCallback", on(), io(n), Qs(e, n);
    }, useContext: function(e) {
      return ne = "useContext", on(), qn(e);
    }, useEffect: function(e, n) {
      return ne = "useEffect", on(), io(n), ra(e, n);
    }, useImperativeHandle: function(e, n, r) {
      return ne = "useImperativeHandle", on(), io(r), Ud(e, n, r);
    }, useInsertionEffect: function(e, n) {
      ne = "useInsertionEffect", on(), io(n), To(4, eo, e, n);
    }, useLayoutEffect: function(e, n) {
      return ne = "useLayoutEffect", on(), io(n), Za(e, n);
    }, useMemo: function(e, n) {
      ne = "useMemo", on(), io(n);
      var r = J.H;
      J.H = Jl;
      try {
        return Bd(e, n);
      } finally {
        J.H = r;
      }
    }, useReducer: function(e, n, r) {
      ne = "useReducer", on();
      var l = J.H;
      J.H = Jl;
      try {
        return Xn(e, n, r);
      } finally {
        J.H = l;
      }
    }, useRef: function(e) {
      return ne = "useRef", on(), Si(e);
    }, useState: function(e) {
      ne = "useState", on();
      var n = J.H;
      J.H = Jl;
      try {
        return Vs(e);
      } finally {
        J.H = n;
      }
    }, useDebugValue: function() {
      ne = "useDebugValue", on();
    }, useDeferredValue: function(e, n) {
      return ne = "useDeferredValue", on(), Vd(e, n);
    }, useTransition: function() {
      return ne = "useTransition", on(), oa();
    }, useSyncExternalStore: function(e, n, r) {
      return ne = "useSyncExternalStore", on(), Bs(e, n, r);
    }, useId: function() {
      return ne = "useId", on(), aa();
    }, useFormState: function(e, n) {
      return ne = "useFormState", on(), Pu(), wi(e, n);
    }, useActionState: function(e, n) {
      return ne = "useActionState", on(), wi(e, n);
    }, useOptimistic: function(e) {
      return ne = "useOptimistic", on(), Ka(e);
    }, useHostTransitionStatus: Nr, useMemoCache: Ya, useCacheRefresh: function() {
      return ne = "useCacheRefresh", on(), Ci();
    } }, c0 = { readContext: function(e) {
      return qn(e);
    }, use: Jo, useCallback: function(e, n) {
      return ne = "useCallback", he(), Qs(e, n);
    }, useContext: function(e) {
      return ne = "useContext", he(), qn(e);
    }, useEffect: function(e, n) {
      return ne = "useEffect", he(), ra(e, n);
    }, useImperativeHandle: function(e, n, r) {
      return ne = "useImperativeHandle", he(), Ud(e, n, r);
    }, useInsertionEffect: function(e, n) {
      ne = "useInsertionEffect", he(), To(4, eo, e, n);
    }, useLayoutEffect: function(e, n) {
      return ne = "useLayoutEffect", he(), Za(e, n);
    }, useMemo: function(e, n) {
      ne = "useMemo", he();
      var r = J.H;
      J.H = Jl;
      try {
        return Bd(e, n);
      } finally {
        J.H = r;
      }
    }, useReducer: function(e, n, r) {
      ne = "useReducer", he();
      var l = J.H;
      J.H = Jl;
      try {
        return Xn(e, n, r);
      } finally {
        J.H = l;
      }
    }, useRef: function(e) {
      return ne = "useRef", he(), Si(e);
    }, useState: function(e) {
      ne = "useState", he();
      var n = J.H;
      J.H = Jl;
      try {
        return Vs(e);
      } finally {
        J.H = n;
      }
    }, useDebugValue: function() {
      ne = "useDebugValue", he();
    }, useDeferredValue: function(e, n) {
      return ne = "useDeferredValue", he(), Vd(e, n);
    }, useTransition: function() {
      return ne = "useTransition", he(), oa();
    }, useSyncExternalStore: function(e, n, r) {
      return ne = "useSyncExternalStore", he(), Bs(e, n, r);
    }, useId: function() {
      return ne = "useId", he(), aa();
    }, useActionState: function(e, n) {
      return ne = "useActionState", he(), wi(e, n);
    }, useFormState: function(e, n) {
      return ne = "useFormState", he(), Pu(), wi(e, n);
    }, useOptimistic: function(e) {
      return ne = "useOptimistic", he(), Ka(e);
    }, useHostTransitionStatus: Nr, useMemoCache: Ya, useCacheRefresh: function() {
      return ne = "useCacheRefresh", he(), Ci();
    } }, _b = { readContext: function(e) {
      return qn(e);
    }, use: Jo, useCallback: function(e, n) {
      return ne = "useCallback", he(), Ei(e, n);
    }, useContext: function(e) {
      return ne = "useContext", he(), qn(e);
    }, useEffect: function(e, n) {
      ne = "useEffect", he(), er(2048, Yt, e, n);
    }, useImperativeHandle: function(e, n, r) {
      return ne = "useImperativeHandle", he(), Ja(e, n, r);
    }, useInsertionEffect: function(e, n) {
      return ne = "useInsertionEffect", he(), er(4, eo, e, n);
    }, useLayoutEffect: function(e, n) {
      return ne = "useLayoutEffect", he(), er(4, wr, e, n);
    }, useMemo: function(e, n) {
      ne = "useMemo", he();
      var r = J.H;
      J.H = ml;
      try {
        return Fl(e, n);
      } finally {
        J.H = r;
      }
    }, useReducer: function(e, n, r) {
      ne = "useReducer", he();
      var l = J.H;
      J.H = ml;
      try {
        return bn(e);
      } finally {
        J.H = l;
      }
    }, useRef: function() {
      return ne = "useRef", he(), Sn().memoizedState;
    }, useState: function() {
      ne = "useState", he();
      var e = J.H;
      J.H = ml;
      try {
        return bn(Yn);
      } finally {
        J.H = e;
      }
    }, useDebugValue: function() {
      ne = "useDebugValue", he();
    }, useDeferredValue: function(e, n) {
      return ne = "useDeferredValue", he(), Ys(e, n);
    }, useTransition: function() {
      return ne = "useTransition", he(), Qd();
    }, useSyncExternalStore: function(e, n, r) {
      return ne = "useSyncExternalStore", he(), ea(e, n, r);
    }, useId: function() {
      return ne = "useId", he(), Sn().memoizedState;
    }, useFormState: function(e) {
      return ne = "useFormState", he(), Pu(), Hd(e);
    }, useActionState: function(e) {
      return ne = "useActionState", he(), Hd(e);
    }, useOptimistic: function(e, n) {
      return ne = "useOptimistic", he(), na(e, n);
    }, useHostTransitionStatus: Nr, useMemoCache: Ya, useCacheRefresh: function() {
      return ne = "useCacheRefresh", he(), Sn().memoizedState;
    } }, d0 = { readContext: function(e) {
      return qn(e);
    }, use: Jo, useCallback: function(e, n) {
      return ne = "useCallback", he(), Ei(e, n);
    }, useContext: function(e) {
      return ne = "useContext", he(), qn(e);
    }, useEffect: function(e, n) {
      ne = "useEffect", he(), er(2048, Yt, e, n);
    }, useImperativeHandle: function(e, n, r) {
      return ne = "useImperativeHandle", he(), Ja(e, n, r);
    }, useInsertionEffect: function(e, n) {
      return ne = "useInsertionEffect", he(), er(4, eo, e, n);
    }, useLayoutEffect: function(e, n) {
      return ne = "useLayoutEffect", he(), er(4, wr, e, n);
    }, useMemo: function(e, n) {
      ne = "useMemo", he();
      var r = J.H;
      J.H = Sy;
      try {
        return Fl(e, n);
      } finally {
        J.H = r;
      }
    }, useReducer: function(e, n, r) {
      ne = "useReducer", he();
      var l = J.H;
      J.H = Sy;
      try {
        return Ar(e);
      } finally {
        J.H = l;
      }
    }, useRef: function() {
      return ne = "useRef", he(), Sn().memoizedState;
    }, useState: function() {
      ne = "useState", he();
      var e = J.H;
      J.H = Sy;
      try {
        return Ar(Yn);
      } finally {
        J.H = e;
      }
    }, useDebugValue: function() {
      ne = "useDebugValue", he();
    }, useDeferredValue: function(e, n) {
      return ne = "useDeferredValue", he(), Wd(e, n);
    }, useTransition: function() {
      return ne = "useTransition", he(), Yd();
    }, useSyncExternalStore: function(e, n, r) {
      return ne = "useSyncExternalStore", he(), ea(e, n, r);
    }, useId: function() {
      return ne = "useId", he(), Sn().memoizedState;
    }, useFormState: function(e) {
      return ne = "useFormState", he(), Pu(), st(e);
    }, useActionState: function(e) {
      return ne = "useActionState", he(), st(e);
    }, useOptimistic: function(e, n) {
      return ne = "useOptimistic", he(), ta(e, n);
    }, useHostTransitionStatus: Nr, useMemoCache: Ya, useCacheRefresh: function() {
      return ne = "useCacheRefresh", he(), Sn().memoizedState;
    } }, Jl = { readContext: function(e) {
      return L(), qn(e);
    }, use: function(e) {
      return R(), Jo(e);
    }, useCallback: function(e, n) {
      return ne = "useCallback", R(), on(), Qs(e, n);
    }, useContext: function(e) {
      return ne = "useContext", R(), on(), qn(e);
    }, useEffect: function(e, n) {
      return ne = "useEffect", R(), on(), ra(e, n);
    }, useImperativeHandle: function(e, n, r) {
      return ne = "useImperativeHandle", R(), on(), Ud(e, n, r);
    }, useInsertionEffect: function(e, n) {
      ne = "useInsertionEffect", R(), on(), To(4, eo, e, n);
    }, useLayoutEffect: function(e, n) {
      return ne = "useLayoutEffect", R(), on(), Za(e, n);
    }, useMemo: function(e, n) {
      ne = "useMemo", R(), on();
      var r = J.H;
      J.H = Jl;
      try {
        return Bd(e, n);
      } finally {
        J.H = r;
      }
    }, useReducer: function(e, n, r) {
      ne = "useReducer", R(), on();
      var l = J.H;
      J.H = Jl;
      try {
        return Xn(e, n, r);
      } finally {
        J.H = l;
      }
    }, useRef: function(e) {
      return ne = "useRef", R(), on(), Si(e);
    }, useState: function(e) {
      ne = "useState", R(), on();
      var n = J.H;
      J.H = Jl;
      try {
        return Vs(e);
      } finally {
        J.H = n;
      }
    }, useDebugValue: function() {
      ne = "useDebugValue", R(), on();
    }, useDeferredValue: function(e, n) {
      return ne = "useDeferredValue", R(), on(), Vd(e, n);
    }, useTransition: function() {
      return ne = "useTransition", R(), on(), oa();
    }, useSyncExternalStore: function(e, n, r) {
      return ne = "useSyncExternalStore", R(), on(), Bs(e, n, r);
    }, useId: function() {
      return ne = "useId", R(), on(), aa();
    }, useFormState: function(e, n) {
      return ne = "useFormState", R(), on(), wi(e, n);
    }, useActionState: function(e, n) {
      return ne = "useActionState", R(), on(), wi(e, n);
    }, useOptimistic: function(e) {
      return ne = "useOptimistic", R(), on(), Ka(e);
    }, useMemoCache: function(e) {
      return R(), Ya(e);
    }, useHostTransitionStatus: Nr, useCacheRefresh: function() {
      return ne = "useCacheRefresh", on(), Ci();
    } }, ml = { readContext: function(e) {
      return L(), qn(e);
    }, use: function(e) {
      return R(), Jo(e);
    }, useCallback: function(e, n) {
      return ne = "useCallback", R(), he(), Ei(e, n);
    }, useContext: function(e) {
      return ne = "useContext", R(), he(), qn(e);
    }, useEffect: function(e, n) {
      ne = "useEffect", R(), he(), er(2048, Yt, e, n);
    }, useImperativeHandle: function(e, n, r) {
      return ne = "useImperativeHandle", R(), he(), Ja(e, n, r);
    }, useInsertionEffect: function(e, n) {
      return ne = "useInsertionEffect", R(), he(), er(4, eo, e, n);
    }, useLayoutEffect: function(e, n) {
      return ne = "useLayoutEffect", R(), he(), er(4, wr, e, n);
    }, useMemo: function(e, n) {
      ne = "useMemo", R(), he();
      var r = J.H;
      J.H = ml;
      try {
        return Fl(e, n);
      } finally {
        J.H = r;
      }
    }, useReducer: function(e, n, r) {
      ne = "useReducer", R(), he();
      var l = J.H;
      J.H = ml;
      try {
        return bn(e);
      } finally {
        J.H = l;
      }
    }, useRef: function() {
      return ne = "useRef", R(), he(), Sn().memoizedState;
    }, useState: function() {
      ne = "useState", R(), he();
      var e = J.H;
      J.H = ml;
      try {
        return bn(Yn);
      } finally {
        J.H = e;
      }
    }, useDebugValue: function() {
      ne = "useDebugValue", R(), he();
    }, useDeferredValue: function(e, n) {
      return ne = "useDeferredValue", R(), he(), Ys(e, n);
    }, useTransition: function() {
      return ne = "useTransition", R(), he(), Qd();
    }, useSyncExternalStore: function(e, n, r) {
      return ne = "useSyncExternalStore", R(), he(), ea(e, n, r);
    }, useId: function() {
      return ne = "useId", R(), he(), Sn().memoizedState;
    }, useFormState: function(e) {
      return ne = "useFormState", R(), he(), Hd(e);
    }, useActionState: function(e) {
      return ne = "useActionState", R(), he(), Hd(e);
    }, useOptimistic: function(e, n) {
      return ne = "useOptimistic", R(), he(), na(e, n);
    }, useMemoCache: function(e) {
      return R(), Ya(e);
    }, useHostTransitionStatus: Nr, useCacheRefresh: function() {
      return ne = "useCacheRefresh", he(), Sn().memoizedState;
    } }, Sy = { readContext: function(e) {
      return L(), qn(e);
    }, use: function(e) {
      return R(), Jo(e);
    }, useCallback: function(e, n) {
      return ne = "useCallback", R(), he(), Ei(e, n);
    }, useContext: function(e) {
      return ne = "useContext", R(), he(), qn(e);
    }, useEffect: function(e, n) {
      ne = "useEffect", R(), he(), er(2048, Yt, e, n);
    }, useImperativeHandle: function(e, n, r) {
      return ne = "useImperativeHandle", R(), he(), Ja(e, n, r);
    }, useInsertionEffect: function(e, n) {
      return ne = "useInsertionEffect", R(), he(), er(4, eo, e, n);
    }, useLayoutEffect: function(e, n) {
      return ne = "useLayoutEffect", R(), he(), er(4, wr, e, n);
    }, useMemo: function(e, n) {
      ne = "useMemo", R(), he();
      var r = J.H;
      J.H = ml;
      try {
        return Fl(e, n);
      } finally {
        J.H = r;
      }
    }, useReducer: function(e, n, r) {
      ne = "useReducer", R(), he();
      var l = J.H;
      J.H = ml;
      try {
        return Ar(e);
      } finally {
        J.H = l;
      }
    }, useRef: function() {
      return ne = "useRef", R(), he(), Sn().memoizedState;
    }, useState: function() {
      ne = "useState", R(), he();
      var e = J.H;
      J.H = ml;
      try {
        return Ar(Yn);
      } finally {
        J.H = e;
      }
    }, useDebugValue: function() {
      ne = "useDebugValue", R(), he();
    }, useDeferredValue: function(e, n) {
      return ne = "useDeferredValue", R(), he(), Wd(e, n);
    }, useTransition: function() {
      return ne = "useTransition", R(), he(), Yd();
    }, useSyncExternalStore: function(e, n, r) {
      return ne = "useSyncExternalStore", R(), he(), ea(e, n, r);
    }, useId: function() {
      return ne = "useId", R(), he(), Sn().memoizedState;
    }, useFormState: function(e) {
      return ne = "useFormState", R(), he(), st(e);
    }, useActionState: function(e) {
      return ne = "useActionState", R(), he(), st(e);
    }, useOptimistic: function(e, n) {
      return ne = "useOptimistic", R(), he(), ta(e, n);
    }, useMemoCache: function(e) {
      return R(), Ya(e);
    }, useHostTransitionStatus: Nr, useCacheRefresh: function() {
      return ne = "useCacheRefresh", he(), Sn().memoizedState;
    } };
    var Ob, f0 = { "react-stack-bottom-frame": function(e, n, r) {
      var l = Pa;
      Pa = !0;
      try {
        return e(n, r);
      } finally {
        Pa = l;
      }
    } }, Lb = f0["react-stack-bottom-frame"].bind(f0), p0 = { "react-stack-bottom-frame": function(e) {
      var n = Pa;
      Pa = !0;
      try {
        return e.render();
      } finally {
        Pa = n;
      }
    } }, m0 = p0["react-stack-bottom-frame"].bind(p0), h0 = { "react-stack-bottom-frame": function(e, n) {
      try {
        n.componentDidMount();
      } catch (r) {
        Pn(e, e.return, r);
      }
    } }, zb = h0["react-stack-bottom-frame"].bind(h0), g0 = { "react-stack-bottom-frame": function(e, n, r, l, i) {
      try {
        n.componentDidUpdate(r, l, i);
      } catch (s) {
        Pn(e, e.return, s);
      }
    } }, y0 = g0["react-stack-bottom-frame"].bind(g0), b0 = { "react-stack-bottom-frame": function(e, n) {
      var r = n.stack;
      e.componentDidCatch(n.value, { componentStack: r !== null ? r : "" });
    } }, f1 = b0["react-stack-bottom-frame"].bind(b0), v0 = { "react-stack-bottom-frame": function(e, n, r) {
      try {
        r.componentWillUnmount();
      } catch (l) {
        Pn(e, n, l);
      }
    } }, k0 = v0["react-stack-bottom-frame"].bind(v0), w0 = { "react-stack-bottom-frame": function(e) {
      e.resourceKind != null && console.error("Expected only SimpleEffects when enableUseEffectCRUDOverload is disabled, got %s", e.resourceKind);
      var n = e.create;
      return e = e.inst, n = n(), e.destroy = n;
    } }, p1 = w0["react-stack-bottom-frame"].bind(w0), S0 = { "react-stack-bottom-frame": function(e, n, r) {
      try {
        r();
      } catch (l) {
        Pn(e, n, l);
      }
    } }, m1 = S0["react-stack-bottom-frame"].bind(S0), E0 = { "react-stack-bottom-frame": function(e) {
      return (0, e._init)(e._payload);
    } }, as = E0["react-stack-bottom-frame"].bind(E0), bp = null, jh = 0, un = null, x0 = Ob = !1, C0 = {}, T0 = {}, P0 = {};
    H = function(e, n, r) {
      if (r !== null && typeof r == "object" && r._store && (!r._store.validated && r.key == null || r._store.validated === 2)) {
        if (typeof r._store != "object") throw Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        r._store.validated = 1;
        var l = Ee(e), i = l || "null";
        if (!C0[i]) {
          C0[i] = !0, r = r._owner, e = e._debugOwner;
          var s = "";
          e && typeof e.tag == "number" && (i = Ee(e)) && (s = `

Check the render method of \`` + i + "`."), s || l && (s = `

Check the top-level render call using <` + l + ">.");
          var f = "";
          r != null && e !== r && (l = null, typeof r.tag == "number" ? l = Ee(r) : typeof r.name == "string" && (l = r.name), l && (f = " It was passed a child from " + l + ".")), De(n, function() {
            console.error('Each child in a list should have a unique "key" prop.%s%s See https://react.dev/link/warning-keys for more information.', s, f);
          });
        }
      }
    };
    var vp = $s(!0), R0 = $s(!1), Ia = Me(null), lu = null, kp = 1, Hh = 2, Gt = Me(0), A0 = {}, N0 = /* @__PURE__ */ new Set(), _0 = /* @__PURE__ */ new Set(), O0 = /* @__PURE__ */ new Set(), L0 = /* @__PURE__ */ new Set(), z0 = /* @__PURE__ */ new Set(), D0 = /* @__PURE__ */ new Set(), F0 = /* @__PURE__ */ new Set(), I0 = /* @__PURE__ */ new Set(), M0 = /* @__PURE__ */ new Set(), j0 = /* @__PURE__ */ new Set();
    Object.freeze(A0);
    var Db = { enqueueSetState: function(e, n, r) {
      var l = _r(e = e._reactInternals), i = $o(l);
      i.payload = n, r != null && (bm(r), i.callback = r), (n = xo(e, i, l)) !== null && (dt(n, e, l), Ol(n, e, l)), Xt(e, l);
    }, enqueueReplaceState: function(e, n, r) {
      var l = _r(e = e._reactInternals), i = $o(l);
      i.tag = o0, i.payload = n, r != null && (bm(r), i.callback = r), (n = xo(e, i, l)) !== null && (dt(n, e, l), Ol(n, e, l)), Xt(e, l);
    }, enqueueForceUpdate: function(e, n) {
      var r = _r(e = e._reactInternals), l = $o(r);
      l.tag = a0, n != null && (bm(n), l.callback = n), (n = xo(e, l, r)) !== null && (dt(n, e, r), Ol(n, e, r)), Pe !== null && typeof Pe.markForceUpdateScheduled == "function" && Pe.markForceUpdateScheduled(e, r);
    } }, Fb = typeof reportError == "function" ? reportError : function(e) {
      if (typeof window == "object" && typeof window.ErrorEvent == "function") {
        var n = new window.ErrorEvent("error", { bubbles: !0, cancelable: !0, message: typeof e == "object" && e !== null && typeof e.message == "string" ? String(e.message) : String(e), error: e });
        if (!window.dispatchEvent(n)) return;
      } else if (typeof process == "object" && typeof process.emit == "function") return void process.emit("uncaughtException", e);
      console.error(e);
    }, wp = null, Ib = null, H0 = Error("This is not a real error. It's an implementation detail of React's selective hydration feature. If this leaks into userspace, it's a bug in React. Please file an issue."), sr = !1, U0 = {}, B0 = {}, V0 = {}, W0 = {}, Sp = !1, q0 = {}, Mb = {}, jb = { dehydrated: null, treeContext: null, retryLane: 0, hydrationErrors: null }, Q0 = !1, Y0 = null;
    Y0 = /* @__PURE__ */ new Set();
    var iu = !1, At = !1, Hb = !1, G0 = typeof WeakSet == "function" ? WeakSet : Set, cr = null, Ep = null, xp = null, Kt = null, go = !1, hl = null, Uh = 8192, h1 = { getCacheForType: function(e) {
      var n = qn(Qt), r = n.data.get(e);
      return r === void 0 && (r = e(), n.data.set(e, r)), r;
    }, getOwner: function() {
      return ur;
    } };
    if (typeof Symbol == "function" && Symbol.for) {
      var Bh = Symbol.for;
      Bh("selector.component"), Bh("selector.has_pseudo_class"), Bh("selector.role"), Bh("selector.test_id"), Bh("selector.text");
    }
    var g1 = [], y1 = typeof WeakMap == "function" ? WeakMap : Map, Mo = 0, no = 2, gl = 4, uu = 0, Vh = 1, Cp = 2, Ub = 3, $c = 4, Ey = 6, K0 = 5, Dn = Mo, Kn = null, gn = null, vn = 0, yo = 0, Wh = 1, Zc = 2, qh = 3, X0 = 4, Bb = 5, Tp = 6, Qh = 7, Vb = 8, Jc = 9, Mn = yo, jo = null, ls = !1, Pp = !1, Wb = !1, ei = 0, xt = uu, is = 0, us = 0, qb = 0, Ho = 0, ed = 0, Yh = null, to = null, xy = !1, Qb = 0, $0 = 300, Cy = 1 / 0, Z0 = 500, Gh = null, ss = null, b1 = 0, v1 = 1, k1 = 2, nd = 0, J0 = 1, ek = 2, nk = 3, w1 = 4, Yb = 5, Sr = 0, cs = null, Rp = null, ds = 0, Gb = 0, Kb = null, tk = null, S1 = 50, Kh = 0, Xb = null, $b = !1, Ty = !1, E1 = 50, td = 0, Xh = null, Ap = !1, Py = null, rk = !1, ok = /* @__PURE__ */ new Set(), Ry = null, Np = null, Zb = !1, Jb = !1, Ay = !1, ev = !1, rd = 0, nv = {};
    (function() {
      for (var e = 0; e < bb.length; e++) {
        var n = bb[e];
        ko(n.toLowerCase(), "on" + (n = n[0].toUpperCase() + n.slice(1)));
      }
      ko(Vv, "onAnimationEnd"), ko(Wv, "onAnimationIteration"), ko(qv, "onAnimationStart"), ko("dblclick", "onDoubleClick"), ko("focusin", "onFocus"), ko("focusout", "onBlur"), ko(n1, "onTransitionRun"), ko(t1, "onTransitionStart"), ko(r1, "onTransitionCancel"), ko(Qv, "onTransitionEnd");
    })(), we("onMouseEnter", ["mouseout", "mouseover"]), we("onMouseLeave", ["mouseout", "mouseover"]), we("onPointerEnter", ["pointerout", "pointerover"]), we("onPointerLeave", ["pointerout", "pointerover"]), be("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), be("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), be("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), be("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), be("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), be("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
    var $h = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), tv = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($h)), Ny = "_reactListening" + Math.random().toString(36).slice(2), ak = !1, lk = !1, _y = !1, ik = !1, Oy = !1, Ly = !1, uk = !1, zy = {}, x1 = /\r\n?/g, C1 = /\u0000|\uFFFD/g, od = "http://www.w3.org/1999/xlink", rv = "http://www.w3.org/XML/1998/namespace", T1 = "javascript:throw new Error('React form unexpectedly submitted.')", P1 = "suppressHydrationWarning", Dy = "$", Fy = "/$", su = "$?", Zh = "$!", R1 = 1, A1 = 2, N1 = 4, ov = "F!", sk = "F", ck = "complete", _1 = "style", fs = 0, _p = 1, Iy = 2, av = null, lv = null, dk = { dialog: !0, webview: !0 }, iv = null, fk = typeof setTimeout == "function" ? setTimeout : void 0, O1 = typeof clearTimeout == "function" ? clearTimeout : void 0, ad = -1, pk = typeof Promise == "function" ? Promise : void 0, L1 = typeof queueMicrotask == "function" ? queueMicrotask : pk !== void 0 ? function(e) {
      return pk.resolve(null).then(e).catch(Qn);
    } : fk, uv = null, ld = 0, Jh = 1, mk = 2, hk = 3, Ma = 4, ja = /* @__PURE__ */ new Map(), gk = /* @__PURE__ */ new Set(), cu = Fe.d;
    Fe.d = { f: function() {
      var e = cu.f(), n = ji();
      return e || n;
    }, r: function(e) {
      var n = vo(e);
      n !== null && n.tag === 5 && n.type === "form" ? hm(n) : cu.r(e);
    }, D: function(e) {
      cu.D(e), zf("dns-prefetch", e, null);
    }, C: function(e, n) {
      cu.C(e, n), zf("preconnect", e, n);
    }, L: function(e, n, r) {
      cu.L(e, n, r);
      var l = Op;
      if (l && e && n) {
        var i = 'link[rel="preload"][as="' + mr(n) + '"]';
        n === "image" && r && r.imageSrcSet ? (i += '[imagesrcset="' + mr(r.imageSrcSet) + '"]', typeof r.imageSizes == "string" && (i += '[imagesizes="' + mr(r.imageSizes) + '"]')) : i += '[href="' + mr(e) + '"]';
        var s = i;
        switch (n) {
          case "style":
            s = va(e);
            break;
          case "script":
            s = Gi(e);
        }
        ja.has(s) || (e = en({ rel: "preload", href: n === "image" && r && r.imageSrcSet ? void 0 : e, as: n }, r), ja.set(s, e), l.querySelector(i) !== null || n === "style" && l.querySelector(Yi(s)) || n === "script" && l.querySelector(qt(s)) || (zt(n = l.createElement("link"), "link", e), V(n), l.head.appendChild(n)));
      }
    }, m: function(e, n) {
      cu.m(e, n);
      var r = Op;
      if (r && e) {
        var l = n && typeof n.as == "string" ? n.as : "script", i = 'link[rel="modulepreload"][as="' + mr(l) + '"][href="' + mr(e) + '"]', s = i;
        switch (l) {
          case "audioworklet":
          case "paintworklet":
          case "serviceworker":
          case "sharedworker":
          case "worker":
          case "script":
            s = Gi(e);
        }
        if (!ja.has(s) && (e = en({ rel: "modulepreload", href: e }, n), ja.set(s, e), r.querySelector(i) === null)) {
          switch (l) {
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
              if (r.querySelector(qt(s))) return;
          }
          zt(l = r.createElement("link"), "link", e), V(l), r.head.appendChild(l);
        }
      }
    }, X: function(e, n) {
      cu.X(e, n);
      var r = Op;
      if (r && e) {
        var l = E(r).hoistableScripts, i = Gi(e), s = l.get(i);
        s || ((s = r.querySelector(qt(i))) || (e = en({ src: e, async: !0 }, n), (n = ja.get(i)) && ka(e, n), V(s = r.createElement("script")), zt(s, "link", e), r.head.appendChild(s)), s = { type: "script", instance: s, count: 1, state: null }, l.set(i, s));
      }
    }, S: function(e, n, r) {
      cu.S(e, n, r);
      var l = Op;
      if (l && e) {
        var i = E(l).hoistableStyles, s = va(e);
        n = n || "default";
        var f = i.get(s);
        if (!f) {
          var p = { loading: ld, preload: null };
          if (f = l.querySelector(Yi(s))) p.loading = Jh | Ma;
          else {
            e = en({ rel: "stylesheet", href: e, "data-precedence": n }, r), (r = ja.get(s)) && oh(e, r);
            var y = f = l.createElement("link");
            V(y), zt(y, "link", e), y._p = new Promise(function(v, z) {
              y.onload = v, y.onerror = z;
            }), y.addEventListener("load", function() {
              p.loading |= Jh;
            }), y.addEventListener("error", function() {
              p.loading |= mk;
            }), p.loading |= Ma, vc(f, n, l);
          }
          f = { type: "stylesheet", instance: f, count: 1, state: p }, i.set(s, f);
        }
      }
    }, M: function(e, n) {
      cu.M(e, n);
      var r = Op;
      if (r && e) {
        var l = E(r).hoistableScripts, i = Gi(e), s = l.get(i);
        s || ((s = r.querySelector(qt(i))) || (e = en({ src: e, async: !0, type: "module" }, n), (n = ja.get(i)) && ka(e, n), V(s = r.createElement("script")), zt(s, "link", e), r.head.appendChild(s)), s = { type: "script", instance: s, count: 1, state: null }, l.set(i, s));
      }
    } };
    var yk, bk, vk, kk, wk, Sk, Ek, xk, Ck, Op = typeof document > "u" ? null : document, My = null, eg = null, sv = null, jy = null, id = gh, ng = { $$typeof: mo, Provider: null, Consumer: null, _currentValue: id, _currentValue2: id, _threadCount: 0 }, Tk = "%c%s%c ", Pk = "background: #e6e6e6;background: light-dark(rgba(0,0,0,0.1), rgba(255,255,255,0.25));color: #000000;color: light-dark(#000000, #ffffff);border-radius: 2px", Rk = "", Hy = " ", z1 = Function.prototype.bind, Ak = !1;
    yk = function(e, n, r, l) {
      (n = m(e, n)) !== null && (r = k(n.memoizedState, r, 0, l), n.memoizedState = r, n.baseState = r, e.memoizedProps = en({}, e.memoizedProps), (r = Cr(e, 2)) !== null && dt(r, e, 2));
    }, bk = function(e, n, r) {
      (n = m(e, n)) !== null && (r = A(n.memoizedState, r, 0), n.memoizedState = r, n.baseState = r, e.memoizedProps = en({}, e.memoizedProps), (r = Cr(e, 2)) !== null && dt(r, e, 2));
    }, vk = function(e, n, r, l) {
      (n = m(e, n)) !== null && (r = C(n.memoizedState, r, l), n.memoizedState = r, n.baseState = r, e.memoizedProps = en({}, e.memoizedProps), (r = Cr(e, 2)) !== null && dt(r, e, 2));
    }, kk = function(e, n, r) {
      e.pendingProps = k(e.memoizedProps, n, 0, r), e.alternate && (e.alternate.pendingProps = e.pendingProps), (n = Cr(e, 2)) !== null && dt(n, e, 2);
    }, wk = function(e, n) {
      e.pendingProps = A(e.memoizedProps, n, 0), e.alternate && (e.alternate.pendingProps = e.pendingProps), (n = Cr(e, 2)) !== null && dt(n, e, 2);
    }, Sk = function(e, n, r) {
      e.pendingProps = C(e.memoizedProps, n, r), e.alternate && (e.alternate.pendingProps = e.pendingProps), (n = Cr(e, 2)) !== null && dt(n, e, 2);
    }, Ek = function(e) {
      var n = Cr(e, 2);
      n !== null && dt(n, e, 2);
    }, xk = function(e) {
      Z = e;
    }, Ck = function(e) {
      W = e;
    };
    var Fr, Uy = !0, By = null, cv = !1, ps = null, ms = null, hs = null, tg = /* @__PURE__ */ new Map(), rg = /* @__PURE__ */ new Map(), gs = [], D1 = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" "), Vy = null;
    if (Xi.prototype.render = xc.prototype.render = function(e) {
      var n = this._internalRoot;
      if (n === null) throw Error("Cannot update an unmounted root.");
      var r = arguments;
      typeof r[1] == "function" ? console.error("does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().") : re(r[1]) ? console.error("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.") : r[1] !== void 0 && console.error("You passed a second argument to root.render(...) but it only accepts one argument."), r = e;
      var l = n.current;
      Mf(l, _r(l), r, n, null, null);
    }, Xi.prototype.unmount = xc.prototype.unmount = function() {
      var e = arguments;
      if (typeof e[0] == "function" && console.error("does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect()."), (e = this._internalRoot) !== null) {
        this._internalRoot = null;
        var n = e.containerInfo;
        (Dn & (no | gl)) !== Mo && console.error("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition."), Mf(e.current, 2, null, e, null, null), ji(), n[Io] = null;
      }
    }, Xi.prototype.unstable_scheduleHydration = function(e) {
      if (e) {
        var n = Er();
        e = { blockedOn: null, target: e, priority: n };
        for (var r = 0; r < gs.length && n !== 0 && n < gs[r].priority; r++) ;
        gs.splice(r, 0, e), r === 0 && Uf(e);
      }
    }, function() {
      var e = Cc.version;
      if (e !== "19.1.0") throw Error(`Incompatible React versions: The "react" and "react-dom" packages must have the exact same version. Instead got:
  - react:      ` + e + `
  - react-dom:  19.1.0
Learn more: https://react.dev/warnings/version-mismatch`);
    }(), typeof Map == "function" && Map.prototype != null && typeof Map.prototype.forEach == "function" && typeof Set == "function" && Set.prototype != null && typeof Set.prototype.clear == "function" && typeof Set.prototype.forEach == "function" || console.error("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://react.dev/link/react-polyfills"), Fe.findDOMNode = function(e) {
      var n = e._reactInternals;
      if (n === void 0)
        throw typeof e.render == "function" ? Error("Unable to find node on an unmounted component.") : (e = Object.keys(e).join(","), Error("Argument appears to not be a ReactComponent. Keys: " + e));
      return e = function(r) {
        var l = r.alternate;
        if (!l) {
          if ((l = oe(r)) === null) throw Error("Unable to find node on an unmounted component.");
          return l !== r ? null : r;
        }
        for (var i = r, s = l; ; ) {
          var f = i.return;
          if (f === null) break;
          var p = f.alternate;
          if (p === null) {
            if ((s = f.return) !== null) {
              i = s;
              continue;
            }
            break;
          }
          if (f.child === p.child) {
            for (p = f.child; p; ) {
              if (p === i) return pe(f), r;
              if (p === s) return pe(f), l;
              p = p.sibling;
            }
            throw Error("Unable to find node on an unmounted component.");
          }
          if (i.return !== s.return) i = f, s = p;
          else {
            for (var y = !1, v = f.child; v; ) {
              if (v === i) {
                y = !0, i = f, s = p;
                break;
              }
              if (v === s) {
                y = !0, s = f, i = p;
                break;
              }
              v = v.sibling;
            }
            if (!y) {
              for (v = p.child; v; ) {
                if (v === i) {
                  y = !0, i = p, s = f;
                  break;
                }
                if (v === s) {
                  y = !0, s = p, i = f;
                  break;
                }
                v = v.sibling;
              }
              if (!y) throw Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
            }
          }
          if (i.alternate !== s) throw Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
        }
        if (i.tag !== 3) throw Error("Unable to find node on an unmounted component.");
        return i.stateNode.current === i ? r : l;
      }(n), e = (e = e !== null ? se(e) : null) === null ? null : e.stateNode;
    }, (Fr = { bundleType: 1, version: "19.1.0", rendererPackageName: "react-dom", currentDispatcherRef: J, reconcilerVersion: "19.1.0" }).overrideHookState = yk, Fr.overrideHookStateDeletePath = bk, Fr.overrideHookStateRenamePath = vk, Fr.overrideProps = kk, Fr.overridePropsDeletePath = wk, Fr.overridePropsRenamePath = Sk, Fr.scheduleUpdate = Ek, Fr.setErrorHandler = xk, Fr.setSuspenseHandler = Ck, Fr.scheduleRefresh = ye, Fr.scheduleRoot = K, Fr.setRefreshHandler = G, Fr.getCurrentFiber = Wg, Fr.getLaneLabelMap = qg, Fr.injectProfilingHooks = Ie, !function(e) {
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u") return !1;
      var n = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (n.isDisabled) return !0;
      if (!n.supportsFiber) return console.error("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://react.dev/link/react-devtools"), !0;
      try {
        Ca = n.inject(e), Bn = n;
      } catch (r) {
        console.error("React instrumentation encountered an error: %s.", r);
      }
      return !!n.checkDCE;
    }(Fr) && ie && window.top === window.self && (-1 < navigator.userAgent.indexOf("Chrome") && navigator.userAgent.indexOf("Edge") === -1 || -1 < navigator.userAgent.indexOf("Firefox"))) {
      var Nk = window.location.protocol;
      /^(https?|file):$/.test(Nk) && console.info("%cDownload the React DevTools for a better development experience: https://react.dev/link/react-devtools" + (Nk === "file:" ? `
You might need to use a local HTTP server (instead of file://): https://react.dev/link/react-devtools-faq` : ""), "font-weight:bold");
    }
    ig.createRoot = function(e, n) {
      if (!re(e)) throw Error("Target container is not a DOM element.");
      Wf(e);
      var r = !1, l = "", i = vm, s = Tg, f = $d;
      return n != null && (n.hydrate ? console.warn("hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.") : typeof n == "object" && n !== null && n.$$typeof === Sa && console.error(`You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:

  let root = createRoot(domContainer);
  root.render(<App />);`), n.unstable_strictMode === !0 && (r = !0), n.identifierPrefix !== void 0 && (l = n.identifierPrefix), n.onUncaughtError !== void 0 && (i = n.onUncaughtError), n.onCaughtError !== void 0 && (s = n.onCaughtError), n.onRecoverableError !== void 0 && (f = n.onRecoverableError), n.unstable_transitionCallbacks !== void 0 && n.unstable_transitionCallbacks), n = Bg(e, 1, !1, null, 0, r, l, i, s, f, 0, null), e[Io] = n.current, or(e), new xc(n);
    }, ig.hydrateRoot = function(e, n, r) {
      if (!re(e)) throw Error("Target container is not a DOM element.");
      Wf(e), n === void 0 && console.error("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
      var l = !1, i = "", s = vm, f = Tg, p = $d, y = null;
      return r != null && (r.unstable_strictMode === !0 && (l = !0), r.identifierPrefix !== void 0 && (i = r.identifierPrefix), r.onUncaughtError !== void 0 && (s = r.onUncaughtError), r.onCaughtError !== void 0 && (f = r.onCaughtError), r.onRecoverableError !== void 0 && (p = r.onRecoverableError), r.unstable_transitionCallbacks !== void 0 && r.unstable_transitionCallbacks, r.formState !== void 0 && (y = r.formState)), (n = Bg(e, 1, !0, n, 0, l, i, s, f, p, 0, y)).context = Vg(null), (i = $o(l = du(l = _r(r = n.current)))).callback = null, xo(r, i, l), r = l, n.current.lanes = r, Bo(n, r), Tt(n), e[Io] = n.current, or(e), new Xi(n);
    }, ig.version = "19.1.0", typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }(), ig;
}
var W1 = function() {
  if (Gk) return Wy.exports;
  Gk = 1;
  var m = {};
  return m.NODE_ENV === "production" ? (function k() {
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE == "function") {
      if (m.NODE_ENV !== "production") throw new Error("^_^");
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(k);
      } catch (C) {
        console.error(C);
      }
    }
  }(), Wy.exports = B1()) : Wy.exports = V1(), Wy.exports;
}();
const q1 = ow(W1);
var fe = Lp();
const Nt = ow(fe), Kk = typeof document < "u" ? Nt.useLayoutEffect : () => {
}, bs = (m) => {
  var k;
  return (k = m?.ownerDocument) !== null && k !== void 0 ? k : document;
}, dd = (m) => m && "window" in m && m.window === m ? m : bs(m).defaultView || window;
function lw(m, k) {
  return !(!k || !m) && m.contains(k);
}
const bv = (m = document) => m.activeElement;
function iw(m) {
  return m.target;
}
function uw(m) {
  var k, C, b = "";
  if (typeof m == "string" || typeof m == "number") b += m;
  else if (typeof m == "object") if (Array.isArray(m)) {
    var A = m.length;
    for (k = 0; k < A; k++) m[k] && (C = uw(m[k])) && (b && (b += " "), b += C);
  } else for (C in m) m[C] && (b && (b += " "), b += C);
  return b;
}
function ud() {
  for (var m, k, C = 0, b = "", A = arguments.length; C < A; C++) (m = arguments[C]) && (k = uw(m)) && (b && (b += " "), b += k);
  return b;
}
var Q1 = {};
function sw(m) {
  if (Q1.NODE_ENV === "test") return m;
  let k = null;
  return () => (k == null && (k = m()), k);
}
const Y1 = sw(function() {
  return m = /^Mac/i, typeof window < "u" && window.navigator != null && m.test(((k = window.navigator.userAgentData) === null || k === void 0 ? void 0 : k.platform) || window.navigator.platform);
  var m, k;
}), G1 = sw(function() {
  return m = /Android/i, typeof window < "u" && window.navigator != null && (((k = window.navigator.userAgentData) === null || k === void 0 ? void 0 : k.brands.some((C) => m.test(C.brand))) || m.test(window.navigator.userAgent));
  var m, k;
});
function cw() {
  let m = fe.useRef(/* @__PURE__ */ new Map()), k = fe.useCallback((A, W, Z, H) => {
    let R = H?.once ? (...L) => {
      m.current.delete(Z), Z(...L);
    } : Z;
    m.current.set(Z, { type: W, eventTarget: A, fn: R, options: H }), A.addEventListener(W, R, H);
  }, []), C = fe.useCallback((A, W, Z, H) => {
    var R;
    let L = ((R = m.current.get(Z)) === null || R === void 0 ? void 0 : R.fn) || Z;
    A.removeEventListener(W, L, H), m.current.delete(Z);
  }, []), b = fe.useCallback(() => {
    m.current.forEach((A, W) => {
      C(A.eventTarget, A.type, W, A.options);
    });
  }, [C]);
  return fe.useEffect(() => b, [b]), { addGlobalListener: k, removeGlobalListener: C, removeAllGlobalListeners: b };
}
var K1 = Cv();
function dw(m) {
  let k = m;
  return k.nativeEvent = m, k.isDefaultPrevented = () => k.defaultPrevented, k.isPropagationStopped = () => k.cancelBubble, k.persist = () => {
  }, k;
}
function fw(m) {
  let k = fe.useRef({ isFocused: !1, observer: null });
  Kk(() => {
    const b = k.current;
    return () => {
      b.observer && (b.observer.disconnect(), b.observer = null);
    };
  }, []);
  let C = function(b) {
    const A = fe.useRef(null);
    return Kk(() => {
      A.current = b;
    }, [b]), fe.useCallback((...W) => {
      const Z = A.current;
      return Z?.(...W);
    }, []);
  }((b) => {
    m?.(b);
  });
  return fe.useCallback((b) => {
    if (b.target instanceof HTMLButtonElement || b.target instanceof HTMLInputElement || b.target instanceof HTMLTextAreaElement || b.target instanceof HTMLSelectElement) {
      k.current.isFocused = !0;
      let A = b.target, W = (Z) => {
        if (k.current.isFocused = !1, A.disabled) {
          let H = dw(Z);
          C(H);
        }
        k.current.observer && (k.current.observer.disconnect(), k.current.observer = null);
      };
      A.addEventListener("focusout", W, { once: !0 }), k.current.observer = new MutationObserver(() => {
        if (k.current.isFocused && A.disabled) {
          var Z;
          (Z = k.current.observer) === null || Z === void 0 || Z.disconnect();
          let H = A === document.activeElement ? null : document.activeElement;
          A.dispatchEvent(new FocusEvent("blur", { relatedTarget: H })), A.dispatchEvent(new FocusEvent("focusout", { bubbles: !0, relatedTarget: H }));
        }
      }), k.current.observer.observe(A, { attributes: !0, attributeFilter: ["disabled"] });
    }
  }, [C]);
}
var pw = {};
let dg = null, vv = /* @__PURE__ */ new Set(), cg = /* @__PURE__ */ new Map(), fd = !1, kv = !1;
const X1 = { Tab: !0, Escape: !0 };
function Tv(m, k) {
  for (let C of vv) C(m, k);
}
function Gy(m) {
  fd = !0, function(k) {
    return !(k.metaKey || !Y1() && k.altKey || k.ctrlKey || k.key === "Control" || k.key === "Shift" || k.key === "Meta");
  }(m) && (dg = "keyboard", Tv("keyboard", m));
}
function Ha(m) {
  dg = "pointer", m.type !== "mousedown" && m.type !== "pointerdown" || (fd = !0, Tv("pointer", m));
}
function mw(m) {
  var k;
  ((k = m).mozInputSource === 0 && k.isTrusted || (G1() && k.pointerType ? k.type === "click" && k.buttons === 1 : k.detail === 0 && !k.pointerType)) && (fd = !0, dg = "virtual");
}
function hw(m) {
  m.target !== window && m.target !== document && m.isTrusted && (fd || kv || (dg = "virtual", Tv("virtual", m)), fd = !1, kv = !1);
}
function gw() {
  fd = !1, kv = !0;
}
function wv(m) {
  if (typeof window > "u" || typeof document > "u" || cg.get(dd(m))) return;
  const k = dd(m), C = bs(m);
  let b = k.HTMLElement.prototype.focus;
  k.HTMLElement.prototype.focus = function() {
    fd = !0, b.apply(this, arguments);
  }, C.addEventListener("keydown", Gy, !0), C.addEventListener("keyup", Gy, !0), C.addEventListener("click", mw, !0), k.addEventListener("focus", hw, !0), k.addEventListener("blur", gw, !1), typeof PointerEvent < "u" ? (C.addEventListener("pointerdown", Ha, !0), C.addEventListener("pointermove", Ha, !0), C.addEventListener("pointerup", Ha, !0)) : pw.NODE_ENV === "test" && (C.addEventListener("mousedown", Ha, !0), C.addEventListener("mousemove", Ha, !0), C.addEventListener("mouseup", Ha, !0)), k.addEventListener("beforeunload", () => {
    $1(m);
  }, { once: !0 }), cg.set(k, { focus: b });
}
const $1 = (m, k) => {
  const C = dd(m), b = bs(m);
  k && b.removeEventListener("DOMContentLoaded", k), cg.has(C) && (C.HTMLElement.prototype.focus = cg.get(C).focus, b.removeEventListener("keydown", Gy, !0), b.removeEventListener("keyup", Gy, !0), b.removeEventListener("click", mw, !0), C.removeEventListener("focus", hw, !0), C.removeEventListener("blur", gw, !1), typeof PointerEvent < "u" ? (b.removeEventListener("pointerdown", Ha, !0), b.removeEventListener("pointermove", Ha, !0), b.removeEventListener("pointerup", Ha, !0)) : pw.NODE_ENV === "test" && (b.removeEventListener("mousedown", Ha, !0), b.removeEventListener("mousemove", Ha, !0), b.removeEventListener("mouseup", Ha, !0)), cg.delete(C));
};
function yw() {
  return dg !== "pointer";
}
typeof document < "u" && function(m) {
  const k = bs(m);
  let C;
  k.readyState !== "loading" ? wv(m) : (C = () => {
    wv(m);
  }, k.addEventListener("DOMContentLoaded", C));
}();
const Z1 = /* @__PURE__ */ new Set(["checkbox", "radio", "range", "color", "file", "image", "button", "submit", "reset"]);
function J1(m, k, C) {
  wv(), fe.useEffect(() => {
    let b = (A, W) => {
      (function(Z, H, R) {
        let L = bs(R?.target);
        const U = typeof window < "u" ? dd(R?.target).HTMLInputElement : HTMLInputElement, O = typeof window < "u" ? dd(R?.target).HTMLTextAreaElement : HTMLTextAreaElement, Y = typeof window < "u" ? dd(R?.target).HTMLElement : HTMLElement, K = typeof window < "u" ? dd(R?.target).KeyboardEvent : KeyboardEvent;
        return !((Z = Z || L.activeElement instanceof U && !Z1.has(L.activeElement.type) || L.activeElement instanceof O || L.activeElement instanceof Y && L.activeElement.isContentEditable) && H === "keyboard" && R instanceof K && !X1[R.key]);
      })(!!C?.isTextInput, A, W) && m(yw());
    };
    return vv.add(b), () => {
      vv.delete(b);
    };
  }, k);
}
function eS(m) {
  let { isDisabled: k, onBlurWithin: C, onFocusWithin: b, onFocusWithinChange: A } = m, W = fe.useRef({ isFocusWithin: !1 }), { addGlobalListener: Z, removeAllGlobalListeners: H } = cw(), R = fe.useCallback((O) => {
    O.currentTarget.contains(O.target) && W.current.isFocusWithin && !O.currentTarget.contains(O.relatedTarget) && (W.current.isFocusWithin = !1, H(), C && C(O), A && A(!1));
  }, [C, A, W, H]), L = fw(R), U = fe.useCallback((O) => {
    if (!O.currentTarget.contains(O.target)) return;
    const Y = bs(O.target), K = bv(Y);
    if (!W.current.isFocusWithin && K === iw(O.nativeEvent)) {
      b && b(O), A && A(!0), W.current.isFocusWithin = !0, L(O);
      let ye = O.currentTarget;
      Z(Y, "focus", (G) => {
        if (W.current.isFocusWithin && !lw(ye, G.target)) {
          let re = new Y.defaultView.FocusEvent("blur", { relatedTarget: G.target });
          (function(ue, pe) {
            Object.defineProperty(ue, "target", { value: pe }), Object.defineProperty(ue, "currentTarget", { value: pe });
          })(re, ye);
          let oe = dw(re);
          R(oe);
        }
      }, { capture: !0 });
    }
  }, [b, A, L, Z, R]);
  return k ? { focusWithinProps: { onFocus: void 0, onBlur: void 0 } } : { focusWithinProps: { onFocus: U, onBlur: R } };
}
var Sv = {};
let Ky = !1, mv = 0;
function Ev() {
  Ky = !0, setTimeout(() => {
    Ky = !1;
  }, 50);
}
function Xk(m) {
  m.pointerType === "touch" && Ev();
}
function nS() {
  if (typeof document < "u") return typeof PointerEvent < "u" ? document.addEventListener("pointerup", Xk) : Sv.NODE_ENV === "test" && document.addEventListener("touchend", Ev), mv++, () => {
    mv--, mv > 0 || (typeof PointerEvent < "u" ? document.removeEventListener("pointerup", Xk) : Sv.NODE_ENV === "test" && document.removeEventListener("touchend", Ev));
  };
}
function bw(m) {
  let { onHoverStart: k, onHoverChange: C, onHoverEnd: b, isDisabled: A } = m, [W, Z] = fe.useState(!1), H = fe.useRef({ isHovered: !1, ignoreEmulatedMouseEvents: !1, pointerType: "", target: null }).current;
  fe.useEffect(nS, []);
  let { addGlobalListener: R, removeAllGlobalListeners: L } = cw(), { hoverProps: U, triggerHoverEnd: O } = fe.useMemo(() => {
    let Y = (G, re) => {
      if (H.pointerType = re, A || re === "touch" || H.isHovered || !G.currentTarget.contains(G.target)) return;
      H.isHovered = !0;
      let oe = G.currentTarget;
      H.target = oe, R(bs(G.target), "pointerover", (ue) => {
        H.isHovered && H.target && !lw(H.target, ue.target) && K(ue, ue.pointerType);
      }, { capture: !0 }), k && k({ type: "hoverstart", target: oe, pointerType: re }), C && C(!0), Z(!0);
    }, K = (G, re) => {
      let oe = H.target;
      H.pointerType = "", H.target = null, re !== "touch" && H.isHovered && oe && (H.isHovered = !1, L(), b && b({ type: "hoverend", target: oe, pointerType: re }), C && C(!1), Z(!1));
    }, ye = {};
    return typeof PointerEvent < "u" ? (ye.onPointerEnter = (G) => {
      Ky && G.pointerType === "mouse" || Y(G, G.pointerType);
    }, ye.onPointerLeave = (G) => {
      !A && G.currentTarget.contains(G.target) && K(G, G.pointerType);
    }) : Sv.NODE_ENV === "test" && (ye.onTouchStart = () => {
      H.ignoreEmulatedMouseEvents = !0;
    }, ye.onMouseEnter = (G) => {
      H.ignoreEmulatedMouseEvents || Ky || Y(G, "mouse"), H.ignoreEmulatedMouseEvents = !1;
    }, ye.onMouseLeave = (G) => {
      !A && G.currentTarget.contains(G.target) && K(G, "mouse");
    }), { hoverProps: ye, triggerHoverEnd: K };
  }, [k, C, b, A, H, R, L]);
  return fe.useEffect(() => {
    A && O({ currentTarget: H.target }, H.pointerType);
  }, [A]), { hoverProps: U, isHovered: W };
}
function vw(m = {}) {
  let { autoFocus: k = !1, isTextInput: C, within: b } = m, A = fe.useRef({ isFocused: !1, isFocusVisible: k || yw() }), [W, Z] = fe.useState(!1), [H, R] = fe.useState(() => A.current.isFocused && A.current.isFocusVisible), L = fe.useCallback(() => R(A.current.isFocused && A.current.isFocusVisible), []), U = fe.useCallback((K) => {
    A.current.isFocused = K, Z(K), L();
  }, [L]);
  J1((K) => {
    A.current.isFocusVisible = K, L();
  }, [], { isTextInput: C });
  let { focusProps: O } = function(K) {
    let { isDisabled: ye, onFocus: G, onBlur: re, onFocusChange: oe } = K;
    const ue = fe.useCallback((ke) => {
      if (ke.target === ke.currentTarget) return re && re(ke), oe && oe(!1), !0;
    }, [re, oe]), pe = fw(ue), se = fe.useCallback((ke) => {
      const Se = bs(ke.target), Ge = Se ? bv(Se) : bv();
      ke.target === ke.currentTarget && Ge === iw(ke.nativeEvent) && (G && G(ke), oe && oe(!0), pe(ke));
    }, [oe, G, pe]);
    return { focusProps: { onFocus: !ye && (G || oe || re) ? se : void 0, onBlur: ye || !re && !oe ? void 0 : ue } };
  }({ isDisabled: b, onFocusChange: U }), { focusWithinProps: Y } = eS({ isDisabled: !b, onFocusWithinChange: U });
  return { isFocused: W, isFocusVisible: H, focusProps: b ? Y : O };
}
var tS = Object.defineProperty, hv = (m, k, C) => (((b, A, W) => {
  A in b ? tS(b, A, { enumerable: !0, configurable: !0, writable: !0, value: W }) : b[A] = W;
})(m, typeof k != "symbol" ? k + "" : k, C), C);
let kw = new class {
  constructor() {
    hv(this, "current", this.detect()), hv(this, "handoffState", "pending"), hv(this, "currentId", 0);
  }
  set(m) {
    this.current !== m && (this.handoffState = "pending", this.currentId = 0, this.current = m);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window > "u" || typeof document > "u" ? "server" : "client";
  }
  handoff() {
    this.handoffState === "pending" && (this.handoffState = "complete");
  }
  get isHandoffComplete() {
    return this.handoffState === "complete";
  }
}();
function ww() {
  let m = [], k = { addEventListener: (C, b, A, W) => (C.addEventListener(b, A, W), k.add(() => C.removeEventListener(b, A, W))), requestAnimationFrame(...C) {
    let b = requestAnimationFrame(...C);
    return k.add(() => cancelAnimationFrame(b));
  }, nextFrame: (...C) => k.requestAnimationFrame(() => k.requestAnimationFrame(...C)), setTimeout(...C) {
    let b = setTimeout(...C);
    return k.add(() => clearTimeout(b));
  }, microTask(...C) {
    let b = { current: !0 };
    return function(A) {
      typeof queueMicrotask == "function" ? queueMicrotask(A) : Promise.resolve().then(A).catch((W) => setTimeout(() => {
        throw W;
      }));
    }(() => {
      b.current && C[0]();
    }), k.add(() => {
      b.current = !1;
    });
  }, style(C, b, A) {
    let W = C.style.getPropertyValue(b);
    return Object.assign(C.style, { [b]: A }), this.add(() => {
      Object.assign(C.style, { [b]: W });
    });
  }, group(C) {
    let b = ww();
    return C(b), this.add(() => b.dispose());
  }, add: (C) => (m.includes(C) || m.push(C), () => {
    let b = m.indexOf(C);
    if (b >= 0) for (let A of m.splice(b, 1)) A();
  }), dispose() {
    for (let C of m.splice(0)) C();
  } };
  return k;
}
let fg = (m, k) => {
  kw.isServer ? fe.useEffect(m, k) : fe.useLayoutEffect(m, k);
};
function Pv(m) {
  let k = fe.useRef(m);
  return fg(() => {
    k.current = m;
  }, [m]), k;
}
let ni = function(m) {
  let k = Pv(m);
  return Nt.useCallback((...C) => k.current(...C), [k]);
}, rS = fe.createContext(void 0);
function Xy() {
  return fe.useContext(rS);
}
function $k(...m) {
  return Array.from(new Set(m.flatMap((k) => typeof k == "string" ? k.split(" ") : []))).filter(Boolean).join(" ");
}
function Rv(m, k, ...C) {
  if (m in k) {
    let A = k[m];
    return typeof A == "function" ? A(...C) : A;
  }
  let b = new Error(`Tried to handle "${m}" but there is no handler defined. Only defined handlers are: ${Object.keys(k).map((A) => `"${A}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(b, Rv), b;
}
var oS = ((m) => (m[m.None = 0] = "None", m[m.RenderStrategy = 1] = "RenderStrategy", m[m.Static = 2] = "Static", m))(oS || {}), aS = ((m) => (m[m.Unmount = 0] = "Unmount", m[m.Hidden = 1] = "Hidden", m))(aS || {});
function zp() {
  let m = function() {
    let k = fe.useRef([]), C = fe.useCallback((b) => {
      for (let A of k.current) A != null && (typeof A == "function" ? A(b) : A.current = b);
    }, []);
    return (...b) => {
      if (!b.every((A) => A == null)) return k.current = b, C;
    };
  }();
  return fe.useCallback((k) => function({ ourProps: C, theirProps: b, slot: A, defaultTag: W, features: Z, visible: H = !0, name: R, mergeRefs: L }) {
    L = L ?? lS;
    let U = Sw(b, C);
    if (H) return Qy(U, A, W, R, L);
    let O = Z ?? 0;
    if (2 & O) {
      let { static: Y = !1, ...K } = U;
      if (Y) return Qy(K, A, W, R, L);
    }
    if (1 & O) {
      let { unmount: Y = !0, ...K } = U;
      return Rv(Y ? 0 : 1, { 0: () => null, 1: () => Qy({ ...K, hidden: !0, style: { display: "none" } }, A, W, R, L) });
    }
    return Qy(U, A, W, R, L);
  }({ mergeRefs: m, ...k }), [m]);
}
function Qy(m, k = {}, C, b, A) {
  let { as: W = C, children: Z, refName: H = "ref", ...R } = gv(m, ["unmount", "static"]), L = m.ref !== void 0 ? { [H]: m.ref } : {}, U = typeof Z == "function" ? Z(k) : Z;
  "className" in R && R.className && typeof R.className == "function" && (R.className = R.className(k)), R["aria-labelledby"] && R["aria-labelledby"] === R.id && (R["aria-labelledby"] = void 0);
  let O = {};
  if (k) {
    let Y = !1, K = [];
    for (let [ye, G] of Object.entries(k)) typeof G == "boolean" && (Y = !0), G === !0 && K.push(ye.replace(/([A-Z])/g, (re) => `-${re.toLowerCase()}`));
    if (Y) {
      O["data-headlessui-state"] = K.join(" ");
      for (let ye of K) O[`data-${ye}`] = "";
    }
  }
  if (W === fe.Fragment && (Object.keys(sd(R)).length > 0 || Object.keys(sd(O)).length > 0)) {
    if (fe.isValidElement(U) && !(Array.isArray(U) && U.length > 1)) {
      let Y = U.props, K = Y?.className, ye = typeof K == "function" ? (...oe) => $k(K(...oe), R.className) : $k(K, R.className), G = ye ? { className: ye } : {}, re = Sw(U.props, sd(gv(R, ["ref"])));
      for (let oe in O) oe in re && delete O[oe];
      return fe.cloneElement(U, Object.assign({}, re, O, L, { ref: A(iS(U), L.ref) }, G));
    }
    if (Object.keys(sd(R)).length > 0) throw new Error(['Passing props on "Fragment"!', "", `The current component <${b} /> is rendering a "Fragment".`, "However we need to passthrough the following props:", Object.keys(sd(R)).concat(Object.keys(sd(O))).map((Y) => `  - ${Y}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".', "Render a single element as the child so that we can forward the props onto that element."].map((Y) => `  - ${Y}`).join(`
`)].join(`
`));
  }
  return fe.createElement(W, Object.assign({}, gv(R, ["ref"]), W !== fe.Fragment && L, W !== fe.Fragment && O), U);
}
function lS(...m) {
  return m.every((k) => k == null) ? void 0 : (k) => {
    for (let C of m) C != null && (typeof C == "function" ? C(k) : C.current = k);
  };
}
function Sw(...m) {
  if (m.length === 0) return {};
  if (m.length === 1) return m[0];
  let k = {}, C = {};
  for (let b of m) for (let A in b) A.startsWith("on") && typeof b[A] == "function" ? (C[A] != null || (C[A] = []), C[A].push(b[A])) : k[A] = b[A];
  if (k.disabled || k["aria-disabled"]) for (let b in C) /^(on(?:Click|Pointer|Mouse|Key)(?:Down|Up|Press)?)$/.test(b) && (C[b] = [(A) => {
    var W;
    return (W = A?.preventDefault) == null ? void 0 : W.call(A);
  }]);
  for (let b in C) Object.assign(k, { [b](A, ...W) {
    let Z = C[b];
    for (let H of Z) {
      if ((A instanceof Event || A?.nativeEvent instanceof Event) && A.defaultPrevented) return;
      H(A, ...W);
    }
  } });
  return k;
}
function Ew(...m) {
  if (m.length === 0) return {};
  if (m.length === 1) return m[0];
  let k = {}, C = {};
  for (let b of m) for (let A in b) A.startsWith("on") && typeof b[A] == "function" ? (C[A] != null || (C[A] = []), C[A].push(b[A])) : k[A] = b[A];
  for (let b in C) Object.assign(k, { [b](...A) {
    let W = C[b];
    for (let Z of W) Z?.(...A);
  } });
  return k;
}
function Dp(m) {
  var k;
  return Object.assign(fe.forwardRef(m), { displayName: (k = m.displayName) != null ? k : m.name });
}
function sd(m) {
  let k = Object.assign({}, m);
  for (let C in k) k[C] === void 0 && delete k[C];
  return k;
}
function gv(m, k = []) {
  let C = Object.assign({}, m);
  for (let b of k) b in C && delete C[b];
  return C;
}
function iS(m) {
  return Nt.version.split(".")[0] >= "19" ? m.props.ref : m.ref;
}
function xw(m = {}, k = null, C = []) {
  for (let [b, A] of Object.entries(m)) Tw(C, Cw(k, b), A);
  return C;
}
function Cw(m, k) {
  return m ? m + "[" + k + "]" : k;
}
function Tw(m, k, C) {
  if (Array.isArray(C)) for (let [b, A] of C.entries()) Tw(m, Cw(k, b.toString()), A);
  else C instanceof Date ? m.push([k, C.toISOString()]) : typeof C == "boolean" ? m.push([k, C ? "1" : "0"]) : typeof C == "string" ? m.push([k, C]) : typeof C == "number" ? m.push([k, `${C}`]) : C == null ? m.push([k, ""]) : xw(C, k, m);
}
var Av = ((m) => (m[m.None = 1] = "None", m[m.Focusable = 2] = "Focusable", m[m.Hidden = 4] = "Hidden", m))(Av || {});
let Pw = Dp(function(m, k) {
  var C;
  let { features: b = 1, ...A } = m, W = { ref: k, "aria-hidden": !(2 & ~b) || ((C = A["aria-hidden"]) != null ? C : void 0), hidden: !(4 & ~b) || void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...!(4 & ~b) && !!(2 & ~b) && { display: "none" } } };
  return zp()({ ourProps: W, theirProps: A, slot: {}, defaultTag: "span", name: "Hidden" });
}), uS = fe.createContext(null);
function sS({ children: m }) {
  let k = fe.useContext(uS);
  if (!k) return Nt.createElement(Nt.Fragment, null, m);
  let { target: C } = k;
  return C ? K1.createPortal(Nt.createElement(Nt.Fragment, null, m), C) : null;
}
function cS({ data: m, form: k, disabled: C, onReset: b, overrides: A }) {
  let [W, Z] = fe.useState(null), H = function() {
    let [R] = fe.useState(ww);
    return fe.useEffect(() => () => R.dispose(), [R]), R;
  }();
  return fe.useEffect(() => {
    if (b && W) return H.addEventListener(W, "reset", b);
  }, [W, k, b]), Nt.createElement(sS, null, Nt.createElement(dS, { setForm: Z, formId: k }), xw(m).map(([R, L]) => Nt.createElement(Pw, { features: Av.Hidden, ...sd({ key: R, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: k, disabled: C, name: R, value: L, ...A }) })));
}
function dS({ setForm: m, formId: k }) {
  return fe.useEffect(() => {
    if (k) {
      let C = document.getElementById(k);
      C && m(C);
    }
  }, [m, k]), k ? null : Nt.createElement(Pw, { features: Av.Hidden, as: "input", type: "hidden", hidden: !0, readOnly: !0, ref: (C) => {
    if (!C) return;
    let b = C.closest("form");
    b && m(b);
  } });
}
let fS = fe.createContext(void 0);
function Rw() {
  return fe.useContext(fS);
}
function Aw(m) {
  return function(k) {
    return typeof k == "object" && k !== null && "nodeType" in k;
  }(m) && "tagName" in m;
}
function $y(m) {
  return Aw(m) && "accessKey" in m;
}
function pS(m) {
  return $y(m) && m.nodeName === "INPUT";
}
function Zk(m) {
  return $y(m) && m.nodeName === "LABEL";
}
function mS(m) {
  return $y(m) && m.nodeName === "FIELDSET";
}
function Jk(m) {
  return $y(m) && m.nodeName === "LEGEND";
}
function hS(m) {
  return !!Aw(m) && m.matches('a[href],audio[controls],button,details,embed,iframe,img[usemap],input:not([type="hidden"]),label,select,textarea,video[controls]');
}
function Nw(m) {
  let k = m.parentElement, C = null;
  for (; k && !mS(k); ) Jk(k) && (C = k), k = k.parentElement;
  let b = k?.getAttribute("disabled") === "";
  return (!b || !function(A) {
    if (!A) return !1;
    let W = A.previousElementSibling;
    for (; W !== null; ) {
      if (Jk(W)) return !1;
      W = W.previousElementSibling;
    }
    return !0;
  }(C)) && b;
}
let gS = Symbol();
function pg(...m) {
  let k = fe.useRef(m);
  fe.useEffect(() => {
    k.current = m;
  }, [m]);
  let C = ni((b) => {
    for (let A of k.current) A != null && (typeof A == "function" ? A(b) : A.current = b);
  });
  return m.every((b) => b == null || b?.[gS]) ? void 0 : C;
}
let Zy = fe.createContext(null);
function _w() {
  let m = fe.useContext(Zy);
  if (m === null) {
    let k = new Error("You used a <Description /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(k, _w), k;
  }
  return m;
}
function yS() {
  var m, k;
  return (k = (m = fe.useContext(Zy)) == null ? void 0 : m.value) != null ? k : void 0;
}
function Ow() {
  let [m, k] = fe.useState([]);
  return [m.length > 0 ? m.join(" ") : void 0, fe.useMemo(() => function(C) {
    let b = ni((W) => (k((Z) => [...Z, W]), () => k((Z) => {
      let H = Z.slice(), R = H.indexOf(W);
      return R !== -1 && H.splice(R, 1), H;
    }))), A = fe.useMemo(() => ({ register: b, slot: C.slot, name: C.name, props: C.props, value: C.value }), [b, C.slot, C.name, C.props, C.value]);
    return Nt.createElement(Zy.Provider, { value: A }, C.children);
  }, [k])];
}
Zy.displayName = "DescriptionContext";
let bS = Dp(function(m, k) {
  let C = fe.useId(), b = Xy(), { id: A = `headlessui-description-${C}`, ...W } = m, Z = _w(), H = pg(k);
  fg(() => Z.register(A), [A, Z.register]);
  let R = b || !1, L = fe.useMemo(() => ({ ...Z.slot, disabled: R }), [Z.slot, R]), U = { ref: H, ...Z.props, id: A };
  return zp()({ ourProps: U, theirProps: W, slot: L, defaultTag: "p", name: Z.name || "Description" });
}), vS = Object.assign(bS, {});
var cd = ((m) => (m.Space = " ", m.Enter = "Enter", m.Escape = "Escape", m.Backspace = "Backspace", m.Delete = "Delete", m.ArrowLeft = "ArrowLeft", m.ArrowUp = "ArrowUp", m.ArrowRight = "ArrowRight", m.ArrowDown = "ArrowDown", m.Home = "Home", m.End = "End", m.PageUp = "PageUp", m.PageDown = "PageDown", m.Tab = "Tab", m))(cd || {});
let Jy = fe.createContext(null);
function Lw() {
  let m = fe.useContext(Jy);
  if (m === null) {
    let k = new Error("You used a <Label /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(k, Lw), k;
  }
  return m;
}
function zw(m) {
  var k, C;
  return (C = (k = fe.useContext(Jy)) == null ? void 0 : k.value) != null ? C : void 0;
}
function Dw({ inherit: m = !1 } = {}) {
  let k = zw(), [C, b] = fe.useState([]), A = m ? [k, ...C].filter(Boolean) : C;
  return [A.length > 0 ? A.join(" ") : void 0, fe.useMemo(() => function(W) {
    let Z = ni((R) => (b((L) => [...L, R]), () => b((L) => {
      let U = L.slice(), O = U.indexOf(R);
      return O !== -1 && U.splice(O, 1), U;
    }))), H = fe.useMemo(() => ({ register: Z, slot: W.slot, name: W.name, props: W.props, value: W.value }), [Z, W.slot, W.name, W.props, W.value]);
    return Nt.createElement(Jy.Provider, { value: H }, W.children);
  }, [b])];
}
Jy.displayName = "LabelContext";
let kS = Dp(function(m, k) {
  var C;
  let b = fe.useId(), A = Lw(), W = Rw(), Z = Xy(), { id: H = `headlessui-label-${b}`, htmlFor: R = W ?? ((C = A.props) == null ? void 0 : C.htmlFor), passive: L = !1, ...U } = m, O = pg(k);
  fg(() => A.register(H), [H, A.register]);
  let Y = ni((re) => {
    let oe = re.currentTarget;
    if ((re.target === re.currentTarget || !hS(re.target)) && (Zk(oe) && re.preventDefault(), A.props && "onClick" in A.props && typeof A.props.onClick == "function" && A.props.onClick(re), Zk(oe))) {
      let ue = document.getElementById(oe.htmlFor);
      if (ue) {
        let pe = ue.getAttribute("disabled");
        if (pe === "true" || pe === "") return;
        let se = ue.getAttribute("aria-disabled");
        if (se === "true" || se === "") return;
        (pS(ue) && (ue.type === "file" || ue.type === "radio" || ue.type === "checkbox") || ue.role === "radio" || ue.role === "checkbox" || ue.role === "switch") && ue.click(), ue.focus({ preventScroll: !0 });
      }
    }
  }), K = Z || !1, ye = fe.useMemo(() => ({ ...A.slot, disabled: K }), [A.slot, K]), G = { ref: O, ...A.props, id: H, htmlFor: R, onClick: Y };
  return L && ("onClick" in G && (delete G.htmlFor, delete G.onClick), "onClick" in U && delete U.onClick), zp()({ ourProps: G, theirProps: U, slot: ye, defaultTag: R ? "label" : "div", name: A.name || "Label" });
}), wS = Object.assign(kS, {});
function SS(m, k) {
  return m !== null && k !== null && typeof m == "object" && typeof k == "object" && "id" in m && "id" in k ? m.id === k.id : m === k;
}
function ES(m = SS) {
  return fe.useCallback((k, C) => {
    if (typeof m == "string") {
      let b = m;
      return k?.[b] === C?.[b];
    }
    return m(k, C);
  }, [m]);
}
let xS = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((m) => `${m}:not([tabindex='-1'])`).join(","), CS = ["[data-autofocus]"].map((m) => `${m}:not([tabindex='-1'])`).join(",");
var sg = ((m) => (m[m.First = 1] = "First", m[m.Previous = 2] = "Previous", m[m.Next = 4] = "Next", m[m.Last = 8] = "Last", m[m.WrapAround = 16] = "WrapAround", m[m.NoScroll = 32] = "NoScroll", m[m.AutoFocus = 64] = "AutoFocus", m))(sg || {}), xv = ((m) => (m[m.Error = 0] = "Error", m[m.Overflow = 1] = "Overflow", m[m.Success = 2] = "Success", m[m.Underflow = 3] = "Underflow", m))(xv || {}), TS = ((m) => (m[m.Previous = -1] = "Previous", m[m.Next = 1] = "Next", m))(TS || {}), PS = ((m) => (m[m.Strict = 0] = "Strict", m[m.Loose = 1] = "Loose", m))(PS || {}), RS = ((m) => (m[m.Keyboard = 0] = "Keyboard", m[m.Mouse = 1] = "Mouse", m))(RS || {});
typeof window < "u" && typeof document < "u" && (document.addEventListener("keydown", (m) => {
  m.metaKey || m.altKey || m.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (m) => {
  m.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : m.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
let AS = ["textarea", "input"].join(",");
function Fw(m, k = (C) => C) {
  return m.slice().sort((C, b) => {
    let A = k(C), W = k(b);
    if (A === null || W === null) return 0;
    let Z = A.compareDocumentPosition(W);
    return Z & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : Z & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function ew(m, k, { sorted: C = !0, relativeTo: b = null, skipElements: A = [] } = {}) {
  let W = Array.isArray(m) ? m.length > 0 ? m[0].ownerDocument : document : m.ownerDocument, Z = Array.isArray(m) ? C ? Fw(m) : m : 64 & k ? function(K = document.body) {
    return K == null ? [] : Array.from(K.querySelectorAll(CS)).sort((ye, G) => Math.sign((ye.tabIndex || Number.MAX_SAFE_INTEGER) - (G.tabIndex || Number.MAX_SAFE_INTEGER)));
  }(m) : function(K = document.body) {
    return K == null ? [] : Array.from(K.querySelectorAll(xS)).sort((ye, G) => Math.sign((ye.tabIndex || Number.MAX_SAFE_INTEGER) - (G.tabIndex || Number.MAX_SAFE_INTEGER)));
  }(m);
  A.length > 0 && Z.length > 1 && (Z = Z.filter((K) => !A.some((ye) => ye != null && "current" in ye ? ye?.current === K : ye === K))), b = b ?? W.activeElement;
  let H, R = (() => {
    if (5 & k) return 1;
    if (10 & k) return -1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), L = (() => {
    if (1 & k) return 0;
    if (2 & k) return Math.max(0, Z.indexOf(b)) - 1;
    if (4 & k) return Math.max(0, Z.indexOf(b)) + 1;
    if (8 & k) return Z.length - 1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), U = 32 & k ? { preventScroll: !0 } : {}, O = 0, Y = Z.length;
  do {
    if (O >= Y || O + Y <= 0) return 0;
    let K = L + O;
    if (16 & k) K = (K + Y) % Y;
    else {
      if (K < 0) return 3;
      if (K >= Y) return 1;
    }
    H = Z[K], H?.focus(U), O += R;
  } while (H !== W.activeElement);
  return 6 & k && function(K) {
    var ye, G;
    return (G = (ye = K?.matches) == null ? void 0 : ye.call(K, AS)) != null && G;
  }(H) && H.select(), 2;
}
var NS = ((m) => (m[m.RegisterOption = 0] = "RegisterOption", m[m.UnregisterOption = 1] = "UnregisterOption", m))(NS || {});
let _S = { 0(m, k) {
  let C = [...m.options, { id: k.id, element: k.element, propsRef: k.propsRef }];
  return { ...m, options: Fw(C, (b) => b.element.current) };
}, 1(m, k) {
  let C = m.options.slice(), b = m.options.findIndex((A) => A.id === k.id);
  return b === -1 ? m : (C.splice(b, 1), { ...m, options: C });
} }, Nv = fe.createContext(null);
function _v(m) {
  let k = fe.useContext(Nv);
  if (k === null) {
    let C = new Error(`<${m} /> is missing a parent <RadioGroup /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(C, _v), C;
  }
  return k;
}
Nv.displayName = "RadioGroupDataContext";
let Ov = fe.createContext(null);
function Lv(m) {
  let k = fe.useContext(Ov);
  if (k === null) {
    let C = new Error(`<${m} /> is missing a parent <RadioGroup /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(C, Lv), C;
  }
  return k;
}
function OS(m, k) {
  return Rv(k.type, _S, m, k);
}
Ov.displayName = "RadioGroupActionsContext";
let LS = Dp(function(m, k) {
  let C = fe.useId(), b = Xy(), { id: A = `headlessui-radiogroup-${C}`, value: W, form: Z, name: H, onChange: R, by: L, disabled: U = b || !1, defaultValue: O, tabIndex: Y = 0, ...K } = m, ye = ES(L), [G, re] = fe.useReducer(OS, { options: [] }), oe = G.options, [ue, pe] = Dw(), [se, ke] = Ow(), Se = fe.useRef(null), Ge = pg(Se, k), Ee = function(Te) {
    let [He] = fe.useState(Te);
    return He;
  }(O), [Me, Ue] = function(Te, He, Ce) {
    let [Ie, Be] = fe.useState(Ce), Qe = Te !== void 0, _e = fe.useRef(Qe), Vn = fe.useRef(!1), Fn = fe.useRef(!1);
    return !Qe || _e.current || Vn.current ? !Qe && _e.current && !Fn.current && (Fn.current = !0, _e.current = Qe, console.error("A component is changing from controlled to uncontrolled. This may be caused by the value changing from a defined value to undefined, which should not happen.")) : (Vn.current = !0, _e.current = Qe, console.error("A component is changing from uncontrolled to controlled. This may be caused by the value changing from undefined to a defined value, which should not happen.")), [Qe ? Te : Ie, ni((Xt) => (Qe || Be(Xt), He?.(Xt)))];
  }(W, R, Ee), Oe = fe.useMemo(() => oe.find((Te) => !Te.propsRef.current.disabled), [oe]), mn = fe.useMemo(() => oe.some((Te) => ye(Te.propsRef.current.value, Me)), [oe, Me]), yn = ni((Te) => {
    var He;
    if (U || ye(Te, Me)) return !1;
    let Ce = (He = oe.find((Ie) => ye(Ie.propsRef.current.value, Te))) == null ? void 0 : He.propsRef.current;
    return (Ce == null || !Ce.disabled) && (Ue?.(Te), !0);
  }), jn = ni((Te) => {
    let He = Se.current;
    if (!He) return;
    let Ce = function(Be) {
      var Qe, _e;
      return kw.isServer ? null : Be ? "ownerDocument" in Be ? Be.ownerDocument : "current" in Be ? (_e = (Qe = Be.current) == null ? void 0 : Qe.ownerDocument) != null ? _e : document : null : document;
    }(He), Ie = oe.filter((Be) => Be.propsRef.current.disabled === !1).map((Be) => Be.element.current);
    switch (Te.key) {
      case cd.Enter:
        (function(Be) {
          var Qe, _e;
          let Vn = (Qe = Be?.form) != null ? Qe : Be.closest("form");
          if (Vn) {
            for (let Fn of Vn.elements) if (Fn !== Be && (Fn.tagName === "INPUT" && Fn.type === "submit" || Fn.tagName === "BUTTON" && Fn.type === "submit" || Fn.nodeName === "INPUT" && Fn.type === "image")) return void Fn.click();
            (_e = Vn.requestSubmit) == null || _e.call(Vn);
          }
        })(Te.currentTarget);
        break;
      case cd.ArrowLeft:
      case cd.ArrowUp:
        if (Te.preventDefault(), Te.stopPropagation(), ew(Ie, sg.Previous | sg.WrapAround) === xv.Success) {
          let Be = oe.find((Qe) => Qe.element.current === Ce?.activeElement);
          Be && yn(Be.propsRef.current.value);
        }
        break;
      case cd.ArrowRight:
      case cd.ArrowDown:
        if (Te.preventDefault(), Te.stopPropagation(), ew(Ie, sg.Next | sg.WrapAround) === xv.Success) {
          let Be = oe.find((Qe) => Qe.element.current === Ce?.activeElement);
          Be && yn(Be.propsRef.current.value);
        }
        break;
      case cd.Space: {
        Te.preventDefault(), Te.stopPropagation();
        let Be = oe.find((Qe) => Qe.element.current === Ce?.activeElement);
        Be && yn(Be.propsRef.current.value);
      }
    }
  }), Ae = ni((Te) => (re({ type: 0, ...Te }), () => re({ type: 1, id: Te.id }))), S = fe.useMemo(() => ({ value: Me, firstOption: Oe, containsCheckedOption: mn, disabled: U, compare: ye, tabIndex: Y, ...G }), [Me, Oe, mn, U, ye, Y, G]), N = fe.useMemo(() => ({ registerOption: Ae, change: yn }), [Ae, yn]), $ = { ref: Ge, id: A, role: "radiogroup", "aria-labelledby": ue, "aria-describedby": se, onKeyDown: jn }, ae = fe.useMemo(() => ({ value: Me }), [Me]), me = fe.useCallback(() => {
    if (Ee !== void 0) return yn(Ee);
  }, [yn, Ee]), ce = zp();
  return Nt.createElement(ke, { name: "RadioGroup.Description" }, Nt.createElement(pe, { name: "RadioGroup.Label" }, Nt.createElement(Ov.Provider, { value: N }, Nt.createElement(Nv.Provider, { value: S }, H != null && Nt.createElement(cS, { disabled: U, data: { [H]: Me || "on" }, overrides: { type: "radio", checked: Me != null }, form: Z, onReset: me }), ce({ ourProps: $, theirProps: K, slot: ae, defaultTag: "div", name: "RadioGroup" })))));
}), zS = Dp(function(m, k) {
  var C;
  let b = _v("RadioGroup.Option"), A = Lv("RadioGroup.Option"), W = fe.useId(), { id: Z = `headlessui-radiogroup-option-${W}`, value: H, disabled: R = b.disabled || !1, autoFocus: L = !1, ...U } = m, O = fe.useRef(null), Y = pg(O, k), [K, ye] = Dw(), [G, re] = Ow(), oe = Pv({ value: H, disabled: R });
  fg(() => A.registerOption({ id: Z, element: O, propsRef: oe }), [Z, A, O, oe]);
  let ue = ni((mn) => {
    var yn;
    if (Nw(mn.currentTarget)) return mn.preventDefault();
    A.change(H) && ((yn = O.current) == null || yn.focus());
  }), pe = ((C = b.firstOption) == null ? void 0 : C.id) === Z, { isFocusVisible: se, focusProps: ke } = vw({ autoFocus: L }), { isHovered: Se, hoverProps: Ge } = bw({ isDisabled: R }), Ee = b.compare(b.value, H), Me = Ew({ ref: Y, id: Z, role: "radio", "aria-checked": Ee ? "true" : "false", "aria-labelledby": K, "aria-describedby": G, "aria-disabled": !!R || void 0, tabIndex: R ? -1 : Ee || !b.containsCheckedOption && pe ? b.tabIndex : -1, onClick: R ? void 0 : ue, autoFocus: L }, ke, Ge), Ue = fe.useMemo(() => ({ checked: Ee, disabled: R, active: se, hover: Se, focus: se, autofocus: L }), [Ee, R, Se, se, L]), Oe = zp();
  return Nt.createElement(re, { name: "RadioGroup.Description" }, Nt.createElement(ye, { name: "RadioGroup.Label" }, Oe({ ourProps: Me, theirProps: U, slot: Ue, defaultTag: "div", name: "RadioGroup.Option" })));
}), DS = Dp(function(m, k) {
  var C;
  let b = _v("Radio"), A = Lv("Radio"), W = fe.useId(), Z = Rw(), H = Xy(), { id: R = Z || `headlessui-radio-${W}`, value: L, disabled: U = b.disabled || H || !1, autoFocus: O = !1, ...Y } = m, K = fe.useRef(null), ye = pg(K, k), G = zw(), re = yS(), oe = Pv({ value: L, disabled: U });
  fg(() => A.registerOption({ id: R, element: K, propsRef: oe }), [R, A, K, oe]);
  let ue = ni((Oe) => {
    var mn;
    if (Nw(Oe.currentTarget)) return Oe.preventDefault();
    A.change(L) && ((mn = K.current) == null || mn.focus());
  }), { isFocusVisible: pe, focusProps: se } = vw({ autoFocus: O }), { isHovered: ke, hoverProps: Se } = bw({ isDisabled: U }), Ge = ((C = b.firstOption) == null ? void 0 : C.id) === R, Ee = b.compare(b.value, L), Me = Ew({ ref: ye, id: R, role: "radio", "aria-checked": Ee ? "true" : "false", "aria-labelledby": G, "aria-describedby": re, "aria-disabled": !!U || void 0, tabIndex: U ? -1 : Ee || !b.containsCheckedOption && Ge ? b.tabIndex : -1, autoFocus: O, onClick: U ? void 0 : ue }, se, Se), Ue = fe.useMemo(() => ({ checked: Ee, disabled: U, hover: ke, focus: pe, autofocus: O }), [Ee, U, ke, pe, O]);
  return zp()({ ourProps: Me, theirProps: Y, slot: Ue, defaultTag: "span", name: "Radio" });
}), FS = wS, IS = vS, ys = Object.assign(LS, { Option: zS, Radio: DS, Label: FS, Description: IS });
function MS({ id: m, buttonText: k }) {
  const C = fe.useRef(null);
  return ze.jsx("modal-opener", { ref: C, className: "no-js-hidden", "data-modal": `modal-${m}`, children: ze.jsx("a", { href: "#", className: "text-xs link flex items-center", "aria-haspopup": "dialog", onClick: (b) => {
    b.preventDefault();
    const A = C.current, W = document.querySelector("modal-opener button"), Z = document.getElementById(A?.dataset?.modal);
    Z && Z.open(W);
  }, children: k ? ze.jsx("span", { className: "uppercase underline font-medium underline-offset-2 decoration-1 tracking-[.08em]", children: k }) : ze.jsxs("svg", { className: "svg-icon", style: { width: "14px", height: "14px", fill: "currentColor", overflow: "hidden", position: "relative" }, viewBox: "0 0 1024 1024", version: "1.1", xmlns: "http://www.w3.org/2000/svg", children: [ze.jsx("path", { d: "M512 320c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zM512 768c-17.6 0-32-14.4-32-32V416c0-17.6 14.4-32 32-32s32 14.4 32 32v320c0 17.6-14.4 32-32 32z", fill: "" }), ze.jsx("path", { d: "M512 128c51.9 0 102.2 10.1 149.5 30.2 45.7 19.3 86.8 47 122.1 82.3s63 76.4 82.3 122.1c20 47.3 30.2 97.6 30.2 149.5S886 614.3 865.9 661.6c-19.3 45.7-47 86.8-82.3 122.1s-76.4 63-122.1 82.3c-47.3 20-97.6 30.2-149.5 30.2S409.8 886.1 362.5 866c-45.7-19.3-86.8-47-122.1-82.3s-63-76.4-82.3-122.1c-20-47.3-30.2-97.6-30.2-149.5s10.1-102.2 30.2-149.5c19.3-45.7 47-86.8 82.3-122.1s76.4-63 122.1-82.3c47.4-20 97.6-30.2 149.5-30.2m0-64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z", fill: "" })] }) }) });
}
const jS = ({ style: m = "Diamond", value: k = "", onChange: C, color: b = { color: "#000" } }) => {
  const A = fe.useRef(null), [W, Z] = fe.useState(k);
  fe.useEffect(() => {
    Z(k || "");
  }, [k]), fe.useEffect(() => {
    (async function() {
      const L = [new FontFace("DiamondLeft", "url(data:font/woff2;base64,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)"), new FontFace("DiamondCenter", "url(data:font/woff2;base64,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)"), new FontFace("DiamondRight", "url(data:font/woff2;base64,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)")];
      try {
        await Promise.all(L.map((U) => U.load()));
      } catch (U) {
        console.error("Error loading fonts:", U);
      }
      L.forEach((U) => document.fonts.add(U)), document.body.classList.add("fonts-loaded");
    })();
  }, []), fe.useEffect(() => {
    if (m !== "Diamond") return;
    const L = A.current;
    if (!L) return;
    const U = L.getContext("2d"), O = () => {
      (() => {
        const { width: Y, height: K } = L.getBoundingClientRect();
        L.width = Y, L.height = K;
      })(), document.fonts.ready.then(() => ((Y) => {
        U.clearRect(0, 0, L.width, L.height);
        let K = [];
        Y.length > 0 && (K = ["<", ...Y.slice(0, 3).split("")], Y.length > 2 && K.push(">"));
        const ye = K.length, G = L.width / 2 - 20 * (ye - 1) / 2, re = L.height / 2;
        K.forEach((oe, ue) => {
          let pe;
          ue === 0 || ue === 1 ? pe = "DiamondLeft" : ue === 2 ? pe = "DiamondCenter" : ue >= 3 && (pe = "DiamondRight"), U.font = `80px '${pe}', sans-serif`, U.textBaseline = "middle", U.textAlign = "center", U.fillStyle = b.color, U.fillText(oe, G + 20 * ue, re);
        });
      })(W));
    };
    return O(), window.addEventListener("resize", O), () => window.removeEventListener("resize", O);
  }, [m, W, b]);
  const H = m === "Diamond" ? 3 : 6, R = m === "Diamond" ? "Enter up to 3 letters..." : "Enter up to 6 characters...";
  return ze.jsxs("div", { className: "diamond-monogram-container border border-ledbury-gray flex flex-col items-center justify-center", children: [ze.jsx("input", { type: "text", maxLength: H, placeholder: R, value: W, onChange: (L) => {
    let U = L.target.value;
    if (m === "Diamond" && (U = U.replace(/[^a-zA-Z]/g, "")), m === "Block") {
      const Y = U.replace(/\s/g, "");
      Y.length > 6 && (U = Y.slice(0, 6));
    }
    Z(U), C && C(U);
  }, className: "w-full border-b px-3 py-2 border-ledbury-gray" }), m === "Diamond" ? ze.jsx("canvas", { ref: A, className: "w-full h-40" }) : ze.jsx("div", { className: "block-monogram-preview select-none text-center text-5xl font-black h-[120px] flex items-center", style: { fontFamily: "Arial, Helvetica, Verdana, sans-serif", color: b?.color }, children: W })] });
};
function ug({ field: m, errors: k }) {
  return m.ui?.label || m.name ? ze.jsxs("div", { className: "flex flex-col mb-2 text-ledbury-gray", children: [ze.jsxs("div", { className: "flex items-center gap-2", children: [ze.jsx("label", { className: "text-md font-medium", children: m.ui?.label || m.name }), m.ui?.info && ze.jsx("span", { className: "text-gray-400 cursor-pointer", title: m.ui.info, children: "ⓘ" }), m.ui?.modal && ze.jsx(MS, { id: m.ui.modal.id, buttonText: m.ui.modal.title }), m.ui?.description && ze.jsx("p", { className: "text-xs text-ledbury-orange mb-0", children: m.ui.description })] }), k?.[m.key] && ze.jsx("p", { className: "text-xs text-error mt-0.5", children: k[m.key] })] }) : null;
}
function Yy({ field: m, selection: k }) {
  return ze.jsx(ze.Fragment, { children: m.ui?.finePrint && (typeof m.ui.finePrint == "string" ? ze.jsx("p", { className: "text-xs text-gray-500 mt-4 flex gap-2", dangerouslySetInnerHTML: { __html: m.ui.finePrint } }) : k && k in m.ui.finePrint && ze.jsx("p", { className: "text-xs text-gray-500 mt-4 flex gap-2", children: m.ui.finePrint[k] })) });
}
function Iw(m) {
  const { field: k, formData: C, onChange: b, errors: A, isVisible: W } = m, { conditional: Z, ...H } = k.ui || {}, R = Z?.reduce((Y, K) => C[K.when.field] === K.when.equals ? { ...Y, ...K.ui } : Y, H) || H, L = { ...k, ui: R };
  let U = k.disabled ?? !1;
  const O = /* @__PURE__ */ new Set();
  if (L.validationRules) for (const Y of L.validationRules) Y.type === "disabled" && Y.when && C[Y.when.field] === Y.when.equals && (Y.values && Array.isArray(Y.values) ? Y.values.forEach((K) => O.add(K)) : U = !0);
  if (L.inputType === "group") {
    const Y = L.ui?.containerClass || "", [K, ye] = fe.useState(() => C[L.key] != null ? C[L.key] : L.default != null ? L.default : "");
    Nt.useEffect(() => {
      C[L.key] != null && ye(C[L.key]);
    }, [C[L.key], L.key]);
    const G = (re) => {
      ye(re), b(L.key, re), L.visibleIf && L.visibleIf.key !== L.key && b(L.visibleIf.key, re);
    };
    return ze.jsxs("div", { className: "space-y-2", children: [ze.jsx(ug, { field: L, errors: A }), L.options && ze.jsxs(ys, { value: K, onChange: G, children: [ze.jsx(ys.Label, { className: "sr-only", children: L.ui?.label || L.name }), ze.jsx("div", { className: `flex gap-2.5 ${Y}`.trim(), children: L.options.map((re) => {
      const oe = re.value ?? re, ue = re.title ?? re.label ?? re, pe = U || O.has(oe);
      return ze.jsx(ys.Option, { value: oe, disabled: pe, children: ({ checked: se }) => ze.jsxs("div", { className: ud("flex items-center justify-center p-3 border transition min-w-[72px] min-h-12 bg-white", pe ? "opacity-50 cursor-not-allowed" : se ? "border-ledbury-gray cursor-pointer" : "border-ledbury-option hover:border-ledbury-gray cursor-pointer", re.represented ? "ledbury-represented" : ""), children: [re.image && ze.jsx("img", { src: re.image, alt: ue, className: "mx-auto mb-2 h-20 object-contain" }), ze.jsx("span", { className: ud("font-medium block text-ledbury-gray", re.image ? "text-xs" : "text-md capitalize"), children: ue })] }) }, oe.toString());
    }) })] }), (!L.options || K) && L.fields.filter((re) => !W || W(re, C)).map((re) => ze.jsx("div", { className: ud("p-4 rounded-md transition-colors", C[re.key] ? "bg-gray-100" : null), children: ze.jsx(Iw, { field: re, formData: C, onChange: b, errors: A, isVisible: W }) }, re.key)), ze.jsx(Yy, { field: L, selection: K })] });
  }
  if (L.inputType === "swatch") {
    const Y = C[L.key] ?? "", K = L.options?.find((G) => G.value === Y.value), ye = L.ui?.containerClass || "";
    return ze.jsxs("div", { className: ye, children: [ze.jsxs("div", { className: "flex items-center mb-1", children: [ze.jsx(ug, { field: L, errors: A }), K && ze.jsx("span", { className: "text-xs ml-2 mb-2", children: K.value })] }), ze.jsxs(ys, { value: Y, onChange: (G) => b(L.key, G), children: [ze.jsx(ys.Label, { className: "sr-only", children: L.ui?.label || L.name }), ze.jsx("div", { className: "flex gap-4 flex-wrap", children: L.options.map((G) => {
      const re = G.value ?? G, oe = G.title ?? G.label ?? G, ue = G.color ?? re, pe = U || O.has(re);
      return ze.jsx(ys.Option, { value: G, disabled: pe, children: ({ checked: se }) => ze.jsx("div", { className: ud("h-8 w-8 rounded-full border transition", pe ? "opacity-50 cursor-not-allowed" : se ? "ring-2 ring-offset-1 ring-black cursor-pointer" : "border-gray-300 cursor-pointer"), style: { backgroundColor: ue }, title: oe }) }, re.toString());
    }) })] }), ze.jsx(Yy, { field: L })] });
  }
  if (L.inputType === "radio") {
    const Y = L.ui?.containerClass || "";
    return ze.jsxs("div", { className: Y, children: [ze.jsx(ug, { field: L, errors: A }), ze.jsx(ys, { value: C[L.key] ?? "", onChange: (K) => b(L.key, K), children: ze.jsx("div", { className: "flex gap-2.5 flex-wrap", children: L.options.map((K) => {
      const ye = K.value ?? K, G = K.title ?? K.label ?? K, re = U || O.has(ye), oe = L.validationRules?.find((pe) => pe.type === "disabled"), ue = oe?.message || "This option is not available.";
      return ze.jsx(ys.Option, { value: ye, disabled: re, children: ({ checked: pe }) => ze.jsxs("div", { className: ud("relative items-center justify-center p-3 border transition min-w-[72px] min-h-12 text-center group", re ? "border-gray-100 cursor-not-allowed" : pe ? "border-ledbury-gray cursor-pointer" : "border-ledbury-option hover:border-ledbury-gray cursor-pointer", K.image ? "grid aspect-square items-stretch gap-1 size-[118px]" : "flex flex-row", K.image && pe ? "bg-ledbury-gray" : "bg-white", K.represented ? "ledbury-represented" : ""), children: [K.image && ze.jsx("img", { src: K.image, alt: G, className: ud("mx-auto max-w-12 object-contain", pe ? "invert" : "") }), ze.jsx("span", { className: ud("block", K.image ? "text-[10px] uppercase font-extralight tracking-[0.5px]" : "text-md capitalize", K.image && pe ? "text-white" : "", re ? "text-gray-400" : "text-ledbury-gray"), children: G }), re && ze.jsx("div", { className: "absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 p-2 text-white bg-black shadow-lg tooltip group-hover:opacity-100 opacity-0 transition-opacity w-full pointer-events-none text-xs", children: ue })] }) }, ye.toString());
    }) }) }), ze.jsx(Yy, { field: L })] });
  }
  if (L.inputType === "text") {
    const Y = L.ui?.containerClass || "";
    if (L.key === "monogram_text") {
      const K = C.monogram_style, ye = C.monogram_color || "#000";
      return ze.jsxs("div", { className: Y, children: [ze.jsx(ug, { field: L, errors: A }), ze.jsx(jS, { style: K, value: C[L.key] ?? "", color: ye, onChange: (G) => b(L.key, G) }), ze.jsx(Yy, { field: L })] });
    }
    return ze.jsxs("div", { className: Y, children: [ze.jsx(ug, { field: L, errors: A }), (() => {
      let K, ye;
      if (L.validationRules) {
        const G = L.validationRules.find((oe) => oe.type === "length");
        G && (K = G.min, ye = G.max);
        const re = L.validationRules.find((oe) => oe.type === "conditional" && oe.when.field in C && C[oe.when.field] === oe.when.equals);
        if (re) {
          const oe = re.rules.find((ue) => ue.type === "length");
          oe && (K = oe.min, ye = oe.max);
        }
      }
      return ze.jsx("input", { type: "text", disabled: U, value: C[L.key] ?? "", onChange: (G) => b(L.key, G.target.value), placeholder: L.ui?.placeholder, minLength: K, maxLength: ye, className: "w-full border px-3 py-2 border-ledbury-gray disabled:opacity-50 disabled:cursor-not-allowed" });
    })()] });
  }
  return null;
}
function Mw(m, k, C) {
  const b = {};
  return m.forEach((A) => {
    if (!C(A, k)) return;
    const W = k[A.key];
    if (A.validationRules) {
      for (const Z of A.validationRules) if (Z.type === "disabled" && Z.when && k[Z.when.field] === Z.when.equals && !Z.values) return;
    }
    !A.required || W !== void 0 && W !== "" && W !== null || (b[A.key] = A.name ? `${A.name} is required` : "Required"), A.validationRules && A.validationRules.forEach((Z) => {
      Z.type === "presence" && (W || (b[A.key] = Z.message)), Z.type === "length" && W != null && (Z.min != null && String(W).length < Z.min && (b[A.key] = Z.message || `Minimum length is ${Z.min}`), Z.max != null && String(W).length > Z.max && (b[A.key] = Z.message || `Maximum length is ${Z.max}`)), Z.type === "regex" && W != null && (new RegExp(Z.pattern).test(String(W)) || (b[A.key] = Z.message)), Z.type === "conditional" && Z.when && k[Z.when.field] === Z.when.equals && Array.isArray(Z.rules) && Z.rules.forEach((H) => {
        H.type === "length" && W != null && (H.min != null && String(W).length < H.min && (b[A.key] = H.message || `Minimum length is ${H.min}`), H.max != null && String(W).length > H.max && (b[A.key] = H.message || `Maximum length is ${H.max}`)), H.type === "regex" && W != null && (new RegExp(H.pattern).test(String(W)) || (b[A.key] = H.message));
      });
    }), A.inputType === "group" && Array.isArray(A.fields) && W && Object.assign(b, Mw(A.fields, k, C));
  }), b;
}
const nw = (m, k) => {
  if (typeof m != "string") return m;
  if ((m = m.trim()) === "true") return !0;
  if (m === "false") return !1;
  if (m === "null") return null;
  if (m !== "undefined") {
    if (k && Array.isArray(k)) for (const C of k) {
      const b = typeof C == "object" ? C.value : C;
      if (typeof b == "number" && String(b) === m) return b;
    }
    return /^\d+$/.test(m) ? parseInt(m, 10) : /^\d*\.\d+$/.test(m) ? parseFloat(m) : m;
  }
};
function HS({ config: m, defaultValues: k = {}, productType: C, formSelector: b, preSubmit: A }) {
  const W = (() => {
    const G = new URLSearchParams(window.location.search), re = {}, oe = { fit_type: "fit_type" };
    for (const [ue, pe] of G.entries()) if (ue === "props") try {
      const se = JSON.parse(decodeURIComponent(pe));
      Array.isArray(se) && se.forEach(([ke, Se]) => {
        if (typeof ke == "string" && !ke.startsWith("_")) {
          const Ge = oe[ke] || ke;
          re[Ge] = Se;
        }
      });
    } catch (se) {
      console.warn("Failed to parse props parameter:", se);
    }
    else if (ue.match(/^properties\[(.+)\]$/)) {
      const se = ue.match(/^properties\[(.+)\]$/);
      if (se) {
        const ke = se[1];
        re[oe[ke] || ke] = pe;
      }
    } else ["edit", "line", "key"].includes(ue) || (re[oe[ue] || ue] = pe);
    return re;
  })(), Z = Math.random().toString(36).slice(2), [H, R] = fe.useState(() => {
    const G = { ...k }, re = (pe) => {
      const se = [];
      return pe.forEach((ke) => {
        se.push(ke), ke.inputType === "group" && Array.isArray(ke.fields) && se.push(...re(ke.fields));
      }), se;
    }, oe = re(m.options);
    Object.entries(W).forEach(([pe, se]) => {
      const ke = oe.find((Se) => Se.key === pe);
      if (ke && ke.options) if (ke.inputType === "swatch" && typeof se == "object" && se !== null) {
        const Se = ke.options.find((Ge) => Ge.value === se.value || Ge.title === se.title);
        G[pe] = Se || ke.default || ke.options[0] || se;
      } else {
        const Se = nw(se, ke.options);
        G[pe] = Se;
      }
      else G[pe] = nw(se);
    }), Object.entries(W).forEach(([pe, se]) => {
      oe.forEach((ke) => {
        ke.inputType === "group" && ke.visibleIf?.key === pe && se === ke.visibleIf.equals && ke.default != null && G[ke.key] == null && (G[ke.key] = ke.default);
      });
    });
    const ue = (pe) => {
      pe.forEach((se) => {
        se.default != null && G[se.key] == null && (G[se.key] = se.default), se.inputType === "group" && se.visibleIf?.key && G[se.visibleIf.key] == null && (G[se.visibleIf.key] = se.default), se.inputType === "group" && Array.isArray(se.fields) && ue(se.fields);
      });
    };
    return ue(m.options), G;
  }), L = (G, re) => {
    if (G.visibleOn && !G.visibleOn.includes(C) || G.visibleWhen !== void 0 && !G.visibleWhen) return !1;
    if (G.visibleIf) {
      const { key: oe, equals: ue } = G.visibleIf, pe = re[oe];
      return pe === ue || typeof pe == "string" && String(ue) === pe || typeof ue == "string" && String(pe) === ue || typeof pe == "number" && Number(ue) === pe && !isNaN(Number(ue)) || typeof ue == "number" && Number(pe) === ue && !isNaN(Number(pe)) || typeof pe == "boolean" && !!ue === pe || typeof ue == "boolean" && !!pe === ue;
    }
    return !0;
  }, [U, O] = fe.useState({}), Y = fe.useRef(null);
  fe.useEffect(() => {
    const G = b ? document.querySelector(b) : Y.current?.closest("form");
    if (!G) return;
    const re = Array.from(G.querySelectorAll("button[type=submit], input[type=submit]")), oe = (ue) => {
      const pe = Mw(m.options, H, L);
      if (Object.keys(pe).length > 0) {
        ue.preventDefault(), O(pe);
        const se = Object.keys(pe)[0], ke = (Me, Ue) => {
          for (const Oe of Me) {
            if (Oe.key === Ue) return { field: Oe };
            if (Oe.inputType === "group" && Oe.fields) {
              const mn = ke(Oe.fields, Ue);
              if (mn) return { field: mn.field, parentGroup: Oe };
            }
          }
          return null;
        }, Se = ke(m.options, se);
        let Ge = `[data-key="${se}"]`;
        Se?.parentGroup && (Ge = `[data-key="${Se.parentGroup.key}"]`);
        const Ee = Y.current?.querySelector(Ge);
        return void (Ee?.scrollIntoView && Ee.scrollIntoView({ behavior: "smooth", block: "center" }));
      }
      G.querySelectorAll("input[data-mto-sidebar]").forEach((se) => se.remove()), ye(H).forEach(({ name: se, value: ke }) => {
        const Se = document.createElement("input");
        Se.type = "hidden", Se.name = se, Se.value = String(ke), Se.dataset.mtoSidebar = "1", G.appendChild(Se);
      });
    };
    return re.forEach((ue) => ue.addEventListener("click", oe, !0)), () => re.forEach((ue) => ue.removeEventListener("click", oe, !0));
  }, [b, H, m.options, L]), fe.useEffect(() => {
    const G = b ? document.querySelector(b) : Y.current?.closest("form");
    if (!G) return;
    const re = G.querySelector('input[name="properties[_bundle_id]"]');
    if (re && re.remove(), (() => {
      const oe = m.options.flatMap((ue) => ue.inputType === "group" && ue.fields || []).find((ue) => ue.key === "monogram");
      return !!oe && !!L(oe, H) && H.monogram === !0;
    })()) {
      const oe = document.createElement("input");
      oe.type = "hidden", oe.name = "properties[_bundle_id]", oe.value = Z, G.append(oe);
    }
  }, [H, b, Z, m.options, L]), fe.useEffect(() => {
    const G = b ? document.querySelector(b) : Y.current?.closest("form");
    if (!G) return;
    const re = (oe) => {
      oe.preventDefault(), A && (async () => (await A(G, H), G.submit()))();
    };
    return G.addEventListener("submit", re), () => {
      G.removeEventListener("submit", re);
    };
  }, [b, A, H]);
  const K = (G, re) => {
    R((oe) => ({ ...oe, [G]: re })), O((oe) => {
      const ue = { ...oe };
      return delete ue[G], ue;
    });
  }, ye = (G, re = "") => {
    const oe = (ue, pe) => {
      for (const se of ue) {
        if (se.key === pe) return se;
        if (se.inputType === "group" && se.fields) {
          const ke = oe(se.fields, pe);
          if (ke) return ke;
        }
      }
      return null;
    };
    return Object.entries(G).flatMap(([ue, pe]) => {
      if (pe == null || pe === "") return [];
      const se = oe(m.options, ue);
      if (se && se.inputType === "group") return [];
      const ke = re ? `${re}[${ue}]` : ue;
      return typeof pe == "object" && pe !== null ? ye(pe, ke) : [{ name: `properties[${ke}]`, value: pe }];
    });
  };
  return ze.jsx("div", { ref: Y, className: "grid grid-cols-1 gap-5", children: m.options.filter((G) => L(G, H)).map((G) => ze.jsx("div", { "data-key": G.key, children: ze.jsx(Iw, { field: G, formData: H, onChange: K, errors: U, isVisible: L }) }, G.key)) });
}
const jw = { productId: 123456789, options: [{ name: "Fit", key: "fit_guide", inputType: "radio", required: !0, options: [{ title: "Extra Slim", value: "extra-slim" }, { title: "Tailored", value: "tailored" }, { title: "Contemporary", value: "contemporary" }, { title: "Classic", value: "classic" }], ui: { modal: { id: "fit-guide", title: "Fit Guide" } } }, { name: "Collar Style", key: "collar_style", inputType: "radio", required: !0, options: ["Spread", "Button Down", "Cutaway"], ui: { label: "Choose Collar Style" } }, { name: "Sleeve Length", key: "sleeve_length", inputType: "radio", required: !0, options: ["32", "33", "34", "35"], ui: { label: "Sleeve Length (inches)" } }, { name: "Collar Size", key: "collar_size", inputType: "radio", required: !0, options: ["14", "14.5", "15", "15.5", "16", "16.5", "17"], ui: { label: "Collar Size (inches)" } }, { name: "Further Customize", key: "customization", visibleOn: ["dress-shirt"], inputType: "group", visibleIf: { key: "customization_enabled", equals: !0 }, options: [{ title: "Yes", value: !0 }, { title: "No", value: !1 }], default: !1, fields: [{ name: "Pocket", key: "pocket_position", inputType: "radio", required: !0, options: ["Yes", "No"], default: "No", ui: { label: "Pocket", modal: { id: "pocket-modal" } } }, { name: "Body Length", key: "body_length", inputType: "radio", required: !0, options: ["Tucked", "Untucked"], ui: { label: "Body Length", modal: { id: "body-length" } } }, { name: "Cuff Type", key: "cuff_type", inputType: "radio", required: !0, options: ["Spread", "Button Down", "Cutaway"], ui: { label: "Cuff Type" } }, { name: "Monogram", key: "monogram", inputType: "group", visibleIf: { key: "monogram_enabled", equals: !0 }, ui: { description: "$14.95 (+ Additional 3 Days Processing)", containerClass: "" }, options: [{ title: "Yes", value: !0 }, { title: "No", value: !1 }], fields: [{ name: "Style", key: "monogram_style", inputType: "radio", required: !0, options: ["Diamond", "Block"], default: "Diamond", ui: { label: "Monogram Style" } }, { name: "Text", key: "monogram_text", inputType: "text", required: !0, ui: { label: "Monogram Text", placeholder: "ABC", conditional: [{ when: { field: "monogram_style", equals: "Diamond" }, ui: { label: "3 Initials (Diamond)", description: "Exact 3 initials required" } }, { when: { field: "monogram_style", equals: "Block" }, ui: { label: "Monogram Text", description: "Up to 6 characters" } }] }, validationRules: [{ type: "presence", message: "Please add characters" }, { type: "conditional", when: { field: "monogram_style", equals: "Diamond" }, rules: [{ type: "length", min: 3, max: 3, message: "3 initials required for diamond style" }, { type: "regex", pattern: "^[A-Z]{3}$", message: "Letters A-Z valid only" }] }, { type: "conditional", when: { field: "monogram_style", equals: "Block" }, rules: [{ type: "length", max: 6, message: "6 characters max for block style" }, { type: "regex", pattern: "^[A-Za-z0-9 !@#$%^&*()_+=-]*$", message: "Invalid character for block style" }] }] }, { name: "Color", key: "monogram_color", inputType: "swatch", required: !0, options: [{ title: "White", color: "White", value: "White" }, { title: "Navy", color: "Navy", value: "Navy" }, { title: "Red", color: "Red", value: "Red" }, { title: "Black", color: "Black", value: "Black" }], ui: { label: "Monogram Color" } }, { name: "Location", key: "monogram_location", inputType: "radio", required: !0, options: ["Top of Pocket Centered", "Cuff", "Hem"], ui: { label: "Monogram Location" }, validationRules: [{ type: "disabled", when: { field: "pocket_position", equals: "No" }, values: ["Top of Pocket Centered"] }] }] }] }] }, tw = document.getElementById("mto-config"), rw = tw ? JSON.parse(tw?.textContent || jw) : {}, yv = document.getElementById("mto-sidebar-root");
if (yv) {
  const m = yv.dataset.productType || rw.productType || jw.productType;
  q1.createRoot(yv).render(ze.jsx(HS, { config: rw, productType: m, metafields: window?.mtoMetafields || { mto: { monogram_optional: !0 } }, formSelector: "form.js-product-form", preSubmit: window?.mtoPreSubmit || null }));
}
